import { isEmpty, flatten, isNil, compact, first, isArray, mapValues, noop, omit, camelCase as camelCase$1 } from 'lodash';
import * as React from 'react';
import React__default, { createElement, memo, useState, useCallback, forwardRef, useRef, useLayoutEffect, useEffect, useMemo, useId as useId$1, Children, createContext, useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import * as ReactDOM from 'react-dom';
import ReactDOM__default from 'react-dom';
import camelize$1 from 'camelize';
import { isSameDay, getHours, format, parse, parseISO, formatISO, startOfYear, startOfMonth, subMonths, endOfMonth, compareAsc, getYear, differenceInYears, isValid } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { decamelizeKeys, camelizeKeys } from 'humps';
import { stringify, parse as parse$1 } from 'query-string';
import HyperDX from '@hyperdx/browser';
import Honeybadger from '@honeybadger-io/js';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch, connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { Button as Button$2, MaskedInput, Input } from '@launchpadlab/lp-components';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import { Tooltip } from '@material-ui/core';
import { useHistory, Link, useLocation, Switch, Route, useRouteMatch, useParams } from 'react-router-dom';
import { Field } from 'redux-form';
import { Field as Field$1 } from 'react-final-form';
import { IMaskInput } from 'react-imask';
import InputMask$1 from 'react-input-mask';
import { NumericFormat, PatternFormat } from 'react-number-format';
import ReactSelect, { createFilter, components } from 'react-select';
import ReactModal from 'react-modal';
import { FixedSizeList } from 'react-window';
import { useReactTable, getFilteredRowModel, getSortedRowModel, getPaginationRowModel, getCoreRowModel, flexRender } from '@tanstack/react-table';
import { Analytics } from 'analytics';
import googleAnalyticsPlugin from '@analytics/google-analytics';
import googleTagManager from '@analytics/google-tag-manager';
import { middleware as middleware$1 } from '@launchpadlab/lp-redux-api';
import { http, configureApi } from '@launchpadlab/lp-requests';
import { createBrowserHistory } from 'history';
import { compose } from 'redux';
import { useForm, Controller } from 'react-hook-form';

const addHyphen = str => {
  if (str) {
    const result = str.split('');
    result.splice(2, 0, '-');
    return result.join('');
  } else {
    return str;
  }
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (Object.prototype.hasOwnProperty.call(n, '__esModule')) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			var isInstance = false;
      try {
        isInstance = this instanceof a;
      } catch {}
			if (isInstance) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var AppsOutlined$1 = {};

var interopRequireDefault = {exports: {}};

var hasRequiredInteropRequireDefault;
function requireInteropRequireDefault() {
  if (hasRequiredInteropRequireDefault) return interopRequireDefault.exports;
  hasRequiredInteropRequireDefault = 1;
  (function (module) {
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(interopRequireDefault);
  return interopRequireDefault.exports;
}

var interopRequireWildcard = {exports: {}};

var _typeof$4 = {exports: {}};

var hasRequired_typeof;
function require_typeof() {
  if (hasRequired_typeof) return _typeof$4.exports;
  hasRequired_typeof = 1;
  (function (module) {
    function _typeof(o) {
      "@babel/helpers - typeof";

      return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
        return typeof o;
      } : function (o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
    }
    module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(_typeof$4);
  return _typeof$4.exports;
}

var hasRequiredInteropRequireWildcard;
function requireInteropRequireWildcard() {
  if (hasRequiredInteropRequireWildcard) return interopRequireWildcard.exports;
  hasRequiredInteropRequireWildcard = 1;
  (function (module) {
    var _typeof = require_typeof()["default"];
    function _getRequireWildcardCache(e) {
      if ("function" != typeof WeakMap) return null;
      var r = new WeakMap(),
        t = new WeakMap();
      return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
      })(e);
    }
    function _interopRequireWildcard(e, r) {
      if (!r && e && e.__esModule) return e;
      if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
        "default": e
      };
      var t = _getRequireWildcardCache(r);
      if (t && t.has(e)) return t.get(e);
      var n = {
          __proto__: null
        },
        a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
      }
      return n["default"] = e, t && t.set(e, n), n;
    }
    module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(interopRequireWildcard);
  return interopRequireWildcard.exports;
}

var createSvgIcon$1 = {};

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }
  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function _typeof$3(o) {
  "@babel/helpers - typeof";

  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$3(o);
}

function isPlainObject(item) {
  return item && _typeof$3(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? _extends({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }
      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

function toPrimitive(t, r) {
  if ("object" != _typeof$3(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof$3(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof$3(i) ? i : i + "";
}

function _defineProperty$2(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (process.env.NODE_ENV === 'production') {
    return propTypes;
  }
  return _extends({}, propTypes, _defineProperty$2({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });
    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }
    return null;
  }));
}

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://mui.com/production-error/?code=' + code;
  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }
  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

var reactIs$2 = {exports: {}};

var reactIs_production_min$2 = {};

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$2;
function requireReactIs_production_min$2() {
  if (hasRequiredReactIs_production_min$2) return reactIs_production_min$2;
  hasRequiredReactIs_production_min$2 = 1;
  var b = 60103,
    c = 60106,
    d = 60107,
    e = 60108,
    f = 60114,
    g = 60109,
    h = 60110,
    k = 60112,
    l = 60113,
    m = 60120,
    n = 60115,
    p = 60116,
    q = 60121,
    r = 60122,
    u = 60117,
    v = 60129,
    w = 60131;
  if ("function" === typeof Symbol && Symbol.for) {
    var x = Symbol.for;
    b = x("react.element");
    c = x("react.portal");
    d = x("react.fragment");
    e = x("react.strict_mode");
    f = x("react.profiler");
    g = x("react.provider");
    h = x("react.context");
    k = x("react.forward_ref");
    l = x("react.suspense");
    m = x("react.suspense_list");
    n = x("react.memo");
    p = x("react.lazy");
    q = x("react.block");
    r = x("react.server.block");
    u = x("react.fundamental");
    v = x("react.debug_trace_mode");
    w = x("react.legacy_hidden");
  }
  function y(a) {
    if ("object" === typeof a && null !== a) {
      var t = a.$$typeof;
      switch (t) {
        case b:
          switch (a = a.type, a) {
            case d:
            case f:
            case e:
            case l:
            case m:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case h:
                case k:
                case p:
                case n:
                case g:
                  return a;
                default:
                  return t;
              }
          }
        case c:
          return t;
      }
    }
  }
  var z = g,
    A = b,
    B = k,
    C = d,
    D = p,
    E = n,
    F = c,
    G = f,
    H = e,
    I = l;
  reactIs_production_min$2.ContextConsumer = h;
  reactIs_production_min$2.ContextProvider = z;
  reactIs_production_min$2.Element = A;
  reactIs_production_min$2.ForwardRef = B;
  reactIs_production_min$2.Fragment = C;
  reactIs_production_min$2.Lazy = D;
  reactIs_production_min$2.Memo = E;
  reactIs_production_min$2.Portal = F;
  reactIs_production_min$2.Profiler = G;
  reactIs_production_min$2.StrictMode = H;
  reactIs_production_min$2.Suspense = I;
  reactIs_production_min$2.isAsyncMode = function () {
    return false;
  };
  reactIs_production_min$2.isConcurrentMode = function () {
    return false;
  };
  reactIs_production_min$2.isContextConsumer = function (a) {
    return y(a) === h;
  };
  reactIs_production_min$2.isContextProvider = function (a) {
    return y(a) === g;
  };
  reactIs_production_min$2.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
  };
  reactIs_production_min$2.isForwardRef = function (a) {
    return y(a) === k;
  };
  reactIs_production_min$2.isFragment = function (a) {
    return y(a) === d;
  };
  reactIs_production_min$2.isLazy = function (a) {
    return y(a) === p;
  };
  reactIs_production_min$2.isMemo = function (a) {
    return y(a) === n;
  };
  reactIs_production_min$2.isPortal = function (a) {
    return y(a) === c;
  };
  reactIs_production_min$2.isProfiler = function (a) {
    return y(a) === f;
  };
  reactIs_production_min$2.isStrictMode = function (a) {
    return y(a) === e;
  };
  reactIs_production_min$2.isSuspense = function (a) {
    return y(a) === l;
  };
  reactIs_production_min$2.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === v || a === e || a === l || a === m || a === w || "object" === typeof a && null !== a && (a.$$typeof === p || a.$$typeof === n || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r) ? true : false;
  };
  reactIs_production_min$2.typeOf = y;
  return reactIs_production_min$2;
}

var reactIs_development$2 = {};

/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$2;
function requireReactIs_development$2() {
  if (hasRequiredReactIs_development$2) return reactIs_development$2;
  hasRequiredReactIs_development$2 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function () {

      // ATTENTION
      // When adding new symbols to this file,
      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var REACT_ELEMENT_TYPE = 0xeac7;
      var REACT_PORTAL_TYPE = 0xeaca;
      var REACT_FRAGMENT_TYPE = 0xeacb;
      var REACT_STRICT_MODE_TYPE = 0xeacc;
      var REACT_PROFILER_TYPE = 0xead2;
      var REACT_PROVIDER_TYPE = 0xeacd;
      var REACT_CONTEXT_TYPE = 0xeace;
      var REACT_FORWARD_REF_TYPE = 0xead0;
      var REACT_SUSPENSE_TYPE = 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = 0xead8;
      var REACT_MEMO_TYPE = 0xead3;
      var REACT_LAZY_TYPE = 0xead4;
      var REACT_BLOCK_TYPE = 0xead9;
      var REACT_SERVER_BLOCK_TYPE = 0xeada;
      var REACT_FUNDAMENTAL_TYPE = 0xead5;
      var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
      var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
      if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
        REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
        REACT_PROFILER_TYPE = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        symbolFor('react.scope');
        symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
      }

      // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

      var enableScopeAPI = false; // Experimental Create Event Handle API.

      function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') {
          return true;
        } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).

        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
          return true;
        }
        if (typeof type === 'object' && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
            return true;
          }
        }
        return false;
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      }
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
          }
        }
        return false;
      }
      function isConcurrentMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
          }
        }
        return false;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$2.ContextConsumer = ContextConsumer;
      reactIs_development$2.ContextProvider = ContextProvider;
      reactIs_development$2.Element = Element;
      reactIs_development$2.ForwardRef = ForwardRef;
      reactIs_development$2.Fragment = Fragment;
      reactIs_development$2.Lazy = Lazy;
      reactIs_development$2.Memo = Memo;
      reactIs_development$2.Portal = Portal;
      reactIs_development$2.Profiler = Profiler;
      reactIs_development$2.StrictMode = StrictMode;
      reactIs_development$2.Suspense = Suspense;
      reactIs_development$2.isAsyncMode = isAsyncMode;
      reactIs_development$2.isConcurrentMode = isConcurrentMode;
      reactIs_development$2.isContextConsumer = isContextConsumer;
      reactIs_development$2.isContextProvider = isContextProvider;
      reactIs_development$2.isElement = isElement;
      reactIs_development$2.isForwardRef = isForwardRef;
      reactIs_development$2.isFragment = isFragment;
      reactIs_development$2.isLazy = isLazy;
      reactIs_development$2.isMemo = isMemo;
      reactIs_development$2.isPortal = isPortal;
      reactIs_development$2.isProfiler = isProfiler;
      reactIs_development$2.isStrictMode = isStrictMode;
      reactIs_development$2.isSuspense = isSuspense;
      reactIs_development$2.isValidElementType = isValidElementType;
      reactIs_development$2.typeOf = typeOf;
    })();
  }
  return reactIs_development$2;
}

var hasRequiredReactIs$2;
function requireReactIs$2() {
  if (hasRequiredReactIs$2) return reactIs$2.exports;
  hasRequiredReactIs$2 = 1;
  if (process.env.NODE_ENV === 'production') {
    reactIs$2.exports = requireReactIs_production_min$2();
  } else {
    reactIs$2.exports = requireReactIs_development$2();
  }
  return reactIs$2.exports;
}

var reactIsExports = requireReactIs$2();

// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */

function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }
  if (typeof Component === 'string') {
    return Component;
  }
  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }
  if (_typeof$3(Component) === 'object') {
    switch (Component.$$typeof) {
      case reactIsExports.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');
      case reactIsExports.Memo:
        return getWrappedName(Component, Component.type, 'memo');
      default:
        return undefined;
    }
  }
  return undefined;
}

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: capitalize(string) expects a string argument." : formatMuiErrorMessage(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }
  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }
    if (process.env.NODE_ENV !== 'production') {
      if (typeof func !== 'function') {
        console.error('Material-UI: Invalid Argument Type, must only provide functions, undefined, or null.');
      }
    }
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function r(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}

var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
    disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
    _options$productionPr = options.productionPrefix,
    productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
    _options$seed = options.seed,
    seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;
  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;
    if (process.env.NODE_ENV !== 'production') {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }
    return ruleCounter;
  };
  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }
      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
      if (!styleSheet.options.theme[nested] || seed !== '') {
        return prefix;
      }
      return "".concat(prefix, "-").concat(getNextCounterId());
    }
    if (process.env.NODE_ENV === 'production') {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }
    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }
    return "".concat(seedPrefix).concat(suffix);
  };
}

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
    name = params.name,
    props = params.props;
  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221

  var defaultProps = theme.props[name];
  var propName;
  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }
  return props;
}

var isProduction$1 = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction$1) {
    var text = "Warning: " + message;
    if (typeof console !== 'undefined') {
      console.warn(text);
    }
    try {
      throw Error(text);
    } catch (x) {}
  }
}

var _typeof$2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof$2(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof$2(document)) === 'object' && document.nodeType === 9;

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};
  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }
  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }
  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }
  return null;
}
var join = function join(value, by) {
  var result = '';
  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */

var toCssValue = function toCssValue(value) {
  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.

  if (value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }
  return cssValue;
};
function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: '',
      space: ''
    };
  }
  return {
    linebreak: '\n',
    space: ' '
  };
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */

function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }
  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }
  var result = '';
  if (!style) return result;
  var _options = options,
    _options$indent = _options.indent,
    indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;
  if (options.format === false) {
    indent = -Infinity;
  }
  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
    linebreak = _getWhitespaceSymbols.linebreak,
    space = _getWhitespaceSymbols.space;
  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            if (result) result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          if (result) result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }
  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.

  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
};
var BaseStyleRule = /*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
      Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */

  var _proto = BaseStyleRule.prototype;
  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;
    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }
    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }
    var sheet = this.options.sheet;
    if (sheet && sheet.attached) {
      process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }
    return this;
  };
  return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(StyleRule, _BaseStyleRule);
  function StyleRule(key, style, options) {
    var _this;
    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector,
      scoped = options.scoped,
      sheet = options.sheet,
      generateId = options.generateId;
    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(_assertThisInitialized(_assertThisInitialized(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }
    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */

  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;
    if (renderer) {
      var json = this.toJSON();
      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }
    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */;
  _proto2.toJSON = function toJSON() {
    var json = {};
    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }
    return json;
  }
  /**
   * Generates a CSS string.
   */;
  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };
  _createClass$1(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
        renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */,

    get: function get() {
      return this.selectorText;
    }
  }]);
  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }
    return new StyleRule(key, style, options);
  }
};
var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule = /*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));
    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }
    this.rules.process();
  }
  /**
   * Get a rule.
   */

  var _proto = ConditionalRule.prototype;
  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */;
  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */;
  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */;
  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Generates a CSS string.
   */;
  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak;
    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;
    if (options.children === false) {
      return this.query + " {}";
    }
    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
  };
  return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};
var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule = /*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);
    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }
    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
      sheet = options.sheet,
      generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));
    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, options, {
        parent: this
      }));
    }
    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */

  var _proto = KeyframesRule.prototype;
  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak;
    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;
    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }
    var children = this.rules.toString(options);
    if (children) children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };
  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp$1 = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp$1, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }
  return val;
};
/**
 * Replace the reference for a animation name.
 */

var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);
  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};
var pluginKeyframesRule = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;
    if (!sheet) {
      return val;
    }
    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);
      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);
      default:
        return val;
    }
  }
};
var KeyframeRule = /*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(KeyframeRule, _BaseStyleRule);
  function KeyframeRule() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }
  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };
  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }
    return null;
  }
};
var FontFaceRule = /*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */

  var _proto = FontFaceRule.prototype;
  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak;
    if (Array.isArray(this.style)) {
      var str = '';
      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += linebreak;
      }
      return str;
    }
    return toCss(this.at, this.style, options);
  };
  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};
var ViewportRule = /*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */

  var _proto = ViewportRule.prototype;
  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };
  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};
var SimpleRule = /*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars

  var _proto = SimpleRule.prototype;
  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';
      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }
      return str;
    }
    return this.key + " " + this.value + ";";
  };
  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};
var plugins$1 = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];
var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
};
var RuleList = /*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */

  var _proto = RuleList.prototype;
  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
      parent = _this$options.parent,
      sheet = _this$options.sheet,
      jss = _this$options.jss,
      Renderer = _this$options.Renderer,
      generateId = _this$options.generateId,
      scoped = _this$options.scoped;
    var options = _extends({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.

    var key = name;
    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.

    this.raw[key] = decl;
    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }
    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */;
  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);
    if (oldRule) {
      this.remove(oldRule);
    }
    var options = ruleOptions;
    if (oldIndex !== -1) options = _extends({}, ruleOptions, {
      index: oldIndex
    });
    return this.add(name, decl, options);
  }
  /**
   * Get a rule by name or selector.
   */;
  _proto.get = function get(nameOrSelector) {
    return this.map[nameOrSelector];
  }
  /**
   * Delete a rule.
   */;
  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */;
  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */;
  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */;
  _proto.register = function register(rule) {
    this.map[rule.key] = rule;
    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */;
  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];
    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */;
  _proto.update = function update() {
    var name;
    var data;
    var options;
    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0];
      data = arguments.length <= 1 ? undefined : arguments[1];
      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }
    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */;
  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }
    var _this$options2 = this.options,
      plugins = _this$options2.jss.plugins,
      sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }
    var style = rule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== rule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.

      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.

      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */;
  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak;
    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += linebreak;
      str += css;
    }
    return str;
  };
  return RuleList;
}();
var StyleSheet = /*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });
    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }
    this.rules = new RuleList(this.options);
    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }
    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */

  var _proto = StyleSheet.prototype;
  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */;
  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */;
  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);
        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.

    this.deployed = false;
    return rule;
  }
  /**
   * Replace a rule in the current stylesheet.
   */;
  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);
    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }
    if (this.attached) {
      if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }
      return newRule;
    } // We can't replace rules to a detached style node.
    // We will redeploy the sheet once user will attach it.

    this.deployed = false;
    return newRule;
  }
  /**
   * Insert rule into the StyleSheet
   */;
  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */;
  _proto.addRules = function addRules(styles, options) {
    var added = [];
    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }
    return added;
  }
  /**
   * Get a rule by name or selector.
   */;
  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */;
  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);
    if (!rule ||
    // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }
    this.rules.remove(rule);
    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }
    return true;
  }
  /**
   * Get index of a rule.
   */;
  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */;
  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */;
  _proto.update = function update() {
    var _this$rules;
    (_this$rules = this.rules).update.apply(_this$rules, arguments);
    return this;
  }
  /**
   * Updates a single rule.
   */;
  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */;
  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };
  return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }
  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }
    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */;
  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;
    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }
    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */;
  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */;
  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */;
  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */;
  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;
    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }
    return processedValue;
  }
  /**
   * Register a plugin.
   */;
  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }
    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }
    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
          process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }
      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };
  return PluginsRegistry;
}();

/**
 * Sheets registry to access all instances in one place.
 */

var SheetsRegistry = /*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }
  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;
    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.

    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */;
  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */;
  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */;
  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      attached = _ref.attached,
      options = _objectWithoutPropertiesLoose(_ref, ["attached"]);
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak;
    var css = '';
    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];
      if (attached != null && sheet.attached !== attached) {
        continue;
      }
      if (css) css += linebreak;
      css += sheet.toString(options);
    }
    return css;
  };
  _createClass$1(SheetsRegistry, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);
  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }
  var ruleCounter = 0;
  var generateId = function generateId(rule, sheet) {
    ruleCounter += 1;
    if (ruleCounter > maxRules) {
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }
    var jssId = '';
    var prefix = '';
    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }
      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }
    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }
    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };
  return generateId;
};

/**
 * Cache the value from the first time a function is called.
 */

var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */

var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};
/**
 * Set a style property.
 */

var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;
    if (Array.isArray(value)) {
      cssValue = toCssValue(value);
    } // Support CSSTOM.

    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
      var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
      cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
};
/**
 * Remove a style property.
 */

var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
};
/**
 * Set the selector.
 */

var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */

var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}
/**
 * Find attached sheet with the highest index.
 */

function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}
/**
 * Find a comment with "jss" inside.
 */

function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}
/**
 * Find a node before which we can insert the sheet.
 */

function findPrevNode(options) {
  var registry = sheets.registry;
  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.

    sheet = findHighestSheet(registry, options);
    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.

  var insertionPoint = options.insertionPoint;
  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.

    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }
  return false;
}
/**
 * Insert style element into the DOM.
 */

function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);
  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.

  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }
  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */

var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});
var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      container.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
      container.appendRule(rule);
    }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }
  return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }
  return index;
};
var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};
var DomRenderer = /*#__PURE__*/
function () {
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;
    var _ref = this.sheet ? this.sheet.options : {},
      media = _ref.media,
      meta = _ref.meta,
      element = _ref.element;
    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */

  var _proto = DomRenderer.prototype;
  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);
    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */;
  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */;
  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;
    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }
    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */;
  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */;
  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }
    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;
      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.

        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);
        if (latestNativeParent === false) {
          return false;
        }
        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }
      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }
    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
    if (nativeRule === false) {
      return false;
    }
    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };
  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index, 0, cssRule);
    }
  }
  /**
   * Delete a rule.
   */;
  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */;
  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   */;
  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */;
  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };
  return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.10.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: isBrowser ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });
    for (var i = 0; i < plugins$1.length; i++) {
      this.plugins.use(plugins$1[i], {
        queue: 'internal'
      });
    }
    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */

  var _proto = Jss.prototype;
  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }
    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }
    if (options.id) {
      this.options.id = _extends({}, this.options.id, options.id);
    }
    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }
    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread

    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */;
  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options,
      index = _options.index;
    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }
    var sheet = new StyleSheet(styles, _extends({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */;
  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */;
  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }
    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }
    var ruleOptions = _extends({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });
    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
    var rule = createRule(name, style, ruleOptions);
    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */;
  _proto.use = function use() {
    var _this = this;
    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }
    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };
  return Jss;
}();
var createJss = function createJss(options) {
  return new Jss(options);
};

/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;
  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;
    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);
      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }
  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
createJss();

var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;
var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = createRule(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};
      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      }
      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};
        if (process.env.NODE_ENV === 'development') {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      }
      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

var at = '@global';
var atPrefix = '@global ';
var GlobalContainerRule = /*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));
    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }
    this.rules.process();
  }
  /**
   * Get a rule.
   */

  var _proto = GlobalContainerRule.prototype;
  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */;
  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */;
  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Get index of a rule.
   */;
  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */;
  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };
  return GlobalContainerRule;
}();
var GlobalPrefixedRule = /*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this
    }));
  }
  var _proto2 = GlobalPrefixedRule.prototype;
  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };
  return GlobalPrefixedRule;
}();
var separatorRegExp$1 = /\s*,\s*/g;
function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp$1);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}
function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
    style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;
  for (var name in rules) {
    sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }
  delete style[at];
}
function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
    style = rule.style;
  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */

function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;
    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }
    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }
    var parent = options.parent;
    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }
    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }
    return null;
  }
  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }
  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);
      if (rule) {
        return rule.selector;
      }
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }
  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';
    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];
      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }
    return result;
  }
  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return _extends({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
    var options = _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
    });
    delete options.name;
    return options;
  }
  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;
    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);
      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        var name = styleRule.key + "-" + prop;
        if ('replaceRule' in container) {
          // for backward compatibility
          container.replaceRule(name, style[prop], _extends({}, options, {
            selector: selector
          }));
        } else {
          container.addRule(name, style[prop], _extends({}, options, {
            selector: selector
          }));
        }
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }
      delete style[prop];
    }
    return style;
  }
  return {
    onProcessStyle: onProcessStyle
  };
}

/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache$2 = {};
function toHyphenLower(match) {
  return '-' + match.toLowerCase();
}
function hyphenateStyleName(name) {
  if (cache$2.hasOwnProperty(name)) {
    return cache$2[name];
  }
  var hName = name.replace(uppercasePattern, toHyphenLower);
  return cache$2[name] = msPattern.test(hName) ? '-' + hName : hName;
}

/**
 * Convert camel cased property names to dash separated.
 */

function convertCase(style) {
  var converted = {};
  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenateStyleName(prop);
    converted[key] = style[prop];
  }
  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }
  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */

function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }
    return convertCase(style);
  }
  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }
    var hyphenatedProp = hyphenateStyleName(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }
  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

var px = hasCSSTOMSupport && CSS ? CSS.px : 'px';
var ms = hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
var percent = hasCSSTOMSupport && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */

function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}
var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;
  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals
  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }
    return value.toString();
  }
  return value;
}
/**
 * Add unit to numeric values.
 */

function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }
  var camelCasedOptions = addCamelCasedVersion(options);
  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }
    return style;
  }
  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }
  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = isBrowser && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (isBrowser) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var _document$createEleme = document.createElement('p'),
    style = _document$createEleme.style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.

  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.

  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */

var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};
var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;
    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';
      if (camelize(longhand) in style) {
        return prop;
      }
      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }
    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;
    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }
    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;
    if (options.transform) {
      return prop;
    }
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;
    if (options.transition) {
      return prop;
    }
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;
    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }
    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;
    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }
    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;
    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }
    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);
      return _jsProp in style ? "page-" + prop : false;
    }
    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};
var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;
    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }
    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;
    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }
    return prop;
  }
};
var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};
var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);
var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.

var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;
    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];
      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }
      if (!multiple) return false;
      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }
      return newProp.map(prefixCss);
    }
    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, _toConsumableArray(p.noPrefill));
  return a;
}, []);
var el;
var cache = {};
if (isBrowser) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.

  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */

function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.

  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.

  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".

  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }
  return cache[prop];
}
var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}
if (isBrowser) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.

  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.

  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.

  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.

  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}

/**
 * Add vendor prefix to a property name when needed.
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }
  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];
      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }
      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }
    return style;
  }
  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }
  function onChangeValue(value, prop) {
    return supportedValue(prop, toCssValue(value)) || value;
  }
  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }
    return prop0.length - prop1.length;
  };
  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);
      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }
      return newStyle;
    }
  };
}

function jssPreset() {
  return {
    plugins: [functionPlugin(), jssGlobal(), jssNested(), camelCase(), defaultUnit(),
    // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : jssVendorPrefixer(), jssPropsSort()]
  };
}

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
    newClasses = options.newClasses,
    Component = options.Component;
  if (!newClasses) {
    return baseClasses;
  }
  var nextClasses = _extends({}, baseClasses);
  if (process.env.NODE_ENV !== 'production') {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }
  Object.keys(newClasses).forEach(function (key) {
    if (process.env.NODE_ENV !== 'production') {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }
      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }
    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);
    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }
    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};

var ThemeContext = /*#__PURE__*/React__default.createContext(null);
if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'ThemeContext';
}

function useTheme() {
  var theme = React__default.useContext(ThemeContext);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__default.useDebugValue(theme);
  }
  return theme;
}

var jss = createJss(jssPreset()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = createGenerateClassName(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = /*#__PURE__*/React__default.createContext(defaultOptions);
if (process.env.NODE_ENV !== 'production') {
  StylesContext.displayName = 'StylesContext';
}
var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
    _props$injectFirst = props.injectFirst,
    injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
    _props$disableGenerat = props.disableGeneration,
    disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
    localOptions = _objectWithoutProperties(props, ["children", "injectFirst", "disableGeneration"]);
  var outerOptions = React__default.useContext(StylesContext);
  var context = _extends({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);
  if (process.env.NODE_ENV !== 'production') {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    }
  }
  if (process.env.NODE_ENV !== 'production') {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }
  if (process.env.NODE_ENV !== 'production') {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    }
  }
  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }
    context.jss = createJss({
      plugins: jssPreset().plugins,
      insertionPoint: injectFirstNode
    });
  }
  return /*#__PURE__*/React__default.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,
  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: PropTypes.bool,
  /**
   * JSS's class name generator.
   */
  generateClassName: PropTypes.func,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: PropTypes.bool,
  /**
   * JSS's instance.
   */
  jss: PropTypes.object,
  /**
   * @ignore
   */
  serverGenerateClassName: PropTypes.func,
  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: PropTypes.object,
  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: PropTypes.object,
  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: PropTypes.object
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}

/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;
  if (process.env.NODE_ENV !== 'production') {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }
  return indexCounter;
}

// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';
  if (process.env.NODE_ENV !== 'production') {
    if (_typeof$3(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }
  return {
    create: function create(theme, name) {
      var styles;
      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          if (themingEnabled === true && theme === noopTheme) {
            // TODO: prepend error message/name instead
            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }
        throw err;
      }
      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }
      var overrides = theme.overrides[name];
      var stylesWithOverrides = _extends({}, styles);
      Object.keys(overrides).forEach(function (key) {
        if (process.env.NODE_ENV !== 'production') {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }
        stylesWithOverrides[key] = deepmerge(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

function getClasses(_ref, classes, Component) {
  var state = _ref.state,
    stylesOptions = _ref.stylesOptions;
  if (stylesOptions.disableGeneration) {
    return classes || {};
  }
  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.

  var generate = false;
  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }
  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }
  if (generate) {
    state.cacheClasses.value = mergeClasses({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }
  return state.cacheClasses.value;
}
function attach(_ref2, props) {
  var state = _ref2.state,
    theme = _ref2.theme,
    stylesOptions = _ref2.stylesOptions,
    stylesCreator = _ref2.stylesCreator,
    name = _ref2.name;
  if (stylesOptions.disableGeneration) {
    return;
  }
  var sheetManager = multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);
  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    multiKeyStore.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }
  var options = _extends({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });
  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;
  if (sheetManager.refs === 0) {
    var staticSheet;
    if (stylesOptions.sheetsCache) {
      staticSheet = multiKeyStore.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }
    var styles = stylesCreator.create(theme, name);
    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, _extends({
        link: false
      }, options));
      staticSheet.attach();
      if (stylesOptions.sheetsCache) {
        multiKeyStore.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }
    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }
    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = getDynamicStyles(styles);
  }
  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, _extends({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = mergeClasses({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });
    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }
  sheetManager.refs += 1;
}
function update(_ref3, props) {
  var state = _ref3.state;
  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}
function detach(_ref4) {
  var state = _ref4.state,
    theme = _ref4.theme,
    stylesOptions = _ref4.stylesOptions,
    stylesCreator = _ref4.stylesCreator;
  if (stylesOptions.disableGeneration) {
    return;
  }
  var sheetManager = multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;
  if (sheetManager.refs === 0) {
    multiKeyStore.delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }
  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}
function useSynchronousEffect(func, values) {
  var key = React__default.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = React__default.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }
  React__default.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}
function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var name = options.name,
    classNamePrefixOption = options.classNamePrefix,
    Component = options.Component,
    _options$defaultTheme = options.defaultTheme,
    defaultTheme = _options$defaultTheme === void 0 ? noopTheme : _options$defaultTheme,
    stylesOptions2 = _objectWithoutProperties(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);
  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };
  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = useTheme() || defaultTheme;
    var stylesOptions = _extends({}, React__default.useContext(StylesContext), stylesOptions2);
    var instance = React__default.useRef();
    var shouldUpdate = React__default.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    React__default.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }
      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React__default.useDebugValue(classes);
    }
    return classes;
  };
  return useStyles;
}

var reactIs$1 = {exports: {}};

var reactIs_production_min$1 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min$1.AsyncMode = l;
  reactIs_production_min$1.ConcurrentMode = m;
  reactIs_production_min$1.ContextConsumer = k;
  reactIs_production_min$1.ContextProvider = h;
  reactIs_production_min$1.Element = c;
  reactIs_production_min$1.ForwardRef = n;
  reactIs_production_min$1.Fragment = e;
  reactIs_production_min$1.Lazy = t;
  reactIs_production_min$1.Memo = r;
  reactIs_production_min$1.Portal = d;
  reactIs_production_min$1.Profiler = g;
  reactIs_production_min$1.StrictMode = f;
  reactIs_production_min$1.Suspense = p;
  reactIs_production_min$1.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min$1.isConcurrentMode = A;
  reactIs_production_min$1.isContextConsumer = function (a) {
    return z(a) === k;
  };
  reactIs_production_min$1.isContextProvider = function (a) {
    return z(a) === h;
  };
  reactIs_production_min$1.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min$1.isForwardRef = function (a) {
    return z(a) === n;
  };
  reactIs_production_min$1.isFragment = function (a) {
    return z(a) === e;
  };
  reactIs_production_min$1.isLazy = function (a) {
    return z(a) === t;
  };
  reactIs_production_min$1.isMemo = function (a) {
    return z(a) === r;
  };
  reactIs_production_min$1.isPortal = function (a) {
    return z(a) === d;
  };
  reactIs_production_min$1.isProfiler = function (a) {
    return z(a) === g;
  };
  reactIs_production_min$1.isStrictMode = function (a) {
    return z(a) === f;
  };
  reactIs_production_min$1.isSuspense = function (a) {
    return z(a) === p;
  };
  reactIs_production_min$1.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min$1.typeOf = z;
  return reactIs_production_min$1;
}

var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1) return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function () {

      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$1.AsyncMode = AsyncMode;
      reactIs_development$1.ConcurrentMode = ConcurrentMode;
      reactIs_development$1.ContextConsumer = ContextConsumer;
      reactIs_development$1.ContextProvider = ContextProvider;
      reactIs_development$1.Element = Element;
      reactIs_development$1.ForwardRef = ForwardRef;
      reactIs_development$1.Fragment = Fragment;
      reactIs_development$1.Lazy = Lazy;
      reactIs_development$1.Memo = Memo;
      reactIs_development$1.Portal = Portal;
      reactIs_development$1.Profiler = Profiler;
      reactIs_development$1.StrictMode = StrictMode;
      reactIs_development$1.Suspense = Suspense;
      reactIs_development$1.isAsyncMode = isAsyncMode;
      reactIs_development$1.isConcurrentMode = isConcurrentMode;
      reactIs_development$1.isContextConsumer = isContextConsumer;
      reactIs_development$1.isContextProvider = isContextProvider;
      reactIs_development$1.isElement = isElement;
      reactIs_development$1.isForwardRef = isForwardRef;
      reactIs_development$1.isFragment = isFragment;
      reactIs_development$1.isLazy = isLazy;
      reactIs_development$1.isMemo = isMemo;
      reactIs_development$1.isPortal = isPortal;
      reactIs_development$1.isProfiler = isProfiler;
      reactIs_development$1.isStrictMode = isStrictMode;
      reactIs_development$1.isSuspense = isSuspense;
      reactIs_development$1.isValidElementType = isValidElementType;
      reactIs_development$1.typeOf = typeOf;
    })();
  }
  return reactIs_development$1;
}

var hasRequiredReactIs$1;
function requireReactIs$1() {
  if (hasRequiredReactIs$1) return reactIs$1.exports;
  hasRequiredReactIs$1 = 1;
  if (process.env.NODE_ENV === 'production') {
    reactIs$1.exports = requireReactIs_production_min$1();
  } else {
    reactIs$1.exports = requireReactIs_development$1();
  }
  return reactIs$1.exports;
}

var hoistNonReactStatics_cjs;
var hasRequiredHoistNonReactStatics_cjs;
function requireHoistNonReactStatics_cjs() {
  if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
  hasRequiredHoistNonReactStatics_cjs = 1;
  var reactIs = requireReactIs$1();

  /**
   * Copyright 2015, Yahoo! Inc.
   * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
   */
  var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
  };
  var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
  };
  var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
  };
  var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
  };
  var TYPE_STATICS = {};
  TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
  TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
  function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) {
      return MEMO_STATICS;
    } // React v16.12 and above

    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
  }
  var defineProperty = Object.defineProperty;
  var getOwnPropertyNames = Object.getOwnPropertyNames;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var getPrototypeOf = Object.getPrototypeOf;
  var objectPrototype = Object.prototype;
  function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
      // don't hoist over string (html) components
      if (objectPrototype) {
        var inheritedComponent = getPrototypeOf(sourceComponent);
        if (inheritedComponent && inheritedComponent !== objectPrototype) {
          hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
      }
      var keys = getOwnPropertyNames(sourceComponent);
      if (getOwnPropertySymbols) {
        keys = keys.concat(getOwnPropertySymbols(sourceComponent));
      }
      var targetStatics = getStatics(targetComponent);
      var sourceStatics = getStatics(sourceComponent);
      for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
          var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
          try {
            // Avoid failures from read-only properties
            defineProperty(targetComponent, key, descriptor);
          } catch (e) {}
        }
      }
    }
    return targetComponent;
  }
  hoistNonReactStatics_cjs = hoistNonReactStatics;
  return hoistNonReactStatics_cjs;
}

var hoistNonReactStatics_cjsExports = requireHoistNonReactStatics_cjs();
var hoistNonReactStatics = /*@__PURE__*/getDefaultExportFromCjs(hoistNonReactStatics_cjsExports);

// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles$1 = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
      _options$withTheme = options.withTheme,
      withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
      name = options.name,
      stylesOptions = _objectWithoutProperties(options, ["defaultTheme", "withTheme", "name"]);
    if (process.env.NODE_ENV !== 'production') {
      if (Component === undefined) {
        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }
    var classNamePrefix = name;
    if (process.env.NODE_ENV !== 'production') {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);
        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }
    var useStyles = makeStyles(stylesOrCreator, _extends({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/React__default.forwardRef(function WithStyles(props, ref) {
      props.classes;
        var innerRef = props.innerRef,
        other = _objectWithoutProperties(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.

      var classes = useStyles(_extends({}, Component.defaultProps, props));
      var theme;
      var more = other;
      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = useTheme() || defaultTheme;
        if (name) {
          more = getThemeProps({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.

        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }
      return /*#__PURE__*/React__default.createElement(Component, _extends({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
    process.env.NODE_ENV !== "production" ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: PropTypes.object,
      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }
        return null; // return new Error(
        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
        //     'Refs are now automatically forwarded to the inner component.',
        // );
      })
    } : void 0;
    if (process.env.NODE_ENV !== 'production') {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component), ")");
    }
    hoistNonReactStatics(WithStyles, Component);
    if (process.env.NODE_ENV !== 'production') {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }
    return WithStyles;
  };
};

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
    values = _breakpoints$values === void 0 ? {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    } : _breakpoints$values,
    _breakpoints$unit = breakpoints.unit,
    unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
    _breakpoints$step = breakpoints.step,
    step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
    other = _objectWithoutProperties(breakpoints, ["values", "unit", "step"]);
  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }
  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];
    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }
    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }
  function between(start, end) {
    var endIndex = keys.indexOf(end);
    if (endIndex === keys.length - 1) {
      return up(start);
    }
    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }
  function only(key) {
    return between(key, key);
  }
  var warnedOnce = false;
  function width(key) {
    if (process.env.NODE_ENV !== 'production') {
      if (!warnedOnce) {
        warnedOnce = true;
        console.warn(["Material-UI: The `theme.breakpoints.width` utility is deprecated because it's redundant.", 'Use the `theme.breakpoints.values` instead.'].join('\n'));
      }
    }
    return values[key];
  }
  return _extends({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;
  return _extends({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      console.warn(['Material-UI: theme.mixins.gutters() is deprecated.', 'You can use the source of the mixin directly:', "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "].join('\n'));
      return _extends({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, _defineProperty$2({}, breakpoints.up('sm'), _extends({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, _defineProperty$2(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), _defineProperty$2(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

var common = {
  black: '#000',
  white: '#fff'
};

var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};

var indigo = {
  300: '#7986cb',
  500: '#3f51b5',
  700: '#303f9f'};

var pink = {
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};

var red = {
  300: '#e57373',
  500: '#f44336',
  700: '#d32f2f'};

var orange = {
  300: '#ffb74d',
  500: '#ff9800',
  700: '#f57c00'};

var blue = {
  300: '#64b5f6',
  500: '#2196f3',
  700: '#1976d2'};

var green = {
  300: '#81c784',
  500: '#4caf50',
  700: '#388e3c'};

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  if (process.env.NODE_ENV !== 'production') {
    if (value < min || value > max) {
      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }
  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */

function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }
  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
    values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);
  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };
  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }
  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }
  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }
  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : formatMuiErrorMessage(3, color));
  }
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;
  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }
  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }
  return recomposeColor(color);
}

var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common.white,
    default: grey[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: grey[800],
    default: '#303030'
  },
  action: {
    active: common.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}
function createPalette(palette) {
  var _palette$primary = palette.primary,
    primary = _palette$primary === void 0 ? {
      light: indigo[300],
      main: indigo[500],
      dark: indigo[700]
    } : _palette$primary,
    _palette$secondary = palette.secondary,
    secondary = _palette$secondary === void 0 ? {
      light: pink.A200,
      main: pink.A400,
      dark: pink.A700
    } : _palette$secondary,
    _palette$error = palette.error,
    error = _palette$error === void 0 ? {
      light: red[300],
      main: red[500],
      dark: red[700]
    } : _palette$error,
    _palette$warning = palette.warning,
    warning = _palette$warning === void 0 ? {
      light: orange[300],
      main: orange[500],
      dark: orange[700]
    } : _palette$warning,
    _palette$info = palette.info,
    info = _palette$info === void 0 ? {
      light: blue[300],
      main: blue[500],
      dark: blue[700]
    } : _palette$info,
    _palette$success = palette.success,
    success = _palette$success === void 0 ? {
      light: green[300],
      main: green[500],
      dark: green[700]
    } : _palette$success,
    _palette$type = palette.type,
    type = _palette$type === void 0 ? 'light' : _palette$type,
    _palette$contrastThre = palette.contrastThreshold,
    contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
    _palette$tonalOffset = palette.tonalOffset,
    tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
    other = _objectWithoutProperties(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54

  function getContrastText(background) {
    var contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    if (process.env.NODE_ENV !== 'production') {
      var contrast = getContrastRatio(background, contrastText);
      if (contrast < 3) {
        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }
    return contrastText;
  }
  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = _extends({}, color);
    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }
    if (!color.main) {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : formatMuiErrorMessage(4, mainShade));
    }
    if (typeof color.main !== 'string') {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createTheme({ palette: {\n  primary: { main: green[500] },\n} });") : formatMuiErrorMessage(5, JSON.stringify(color.main)));
    }
    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);
    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
    return color;
  };
  var types = {
    dark: dark,
    light: light
  };
  if (process.env.NODE_ENV !== 'production') {
    if (!types[type]) {
      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    }
  }
  var paletteOutput = deepmerge(_extends({
    // A collection of common colors.
    common: common,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}
var warnedOnce = false;
function roundWithDeprecationWarning(value) {
  if (process.env.NODE_ENV !== 'production') {
    if (!warnedOnce) {
      console.warn(['Material-UI: The `theme.typography.round` helper is deprecated.', 'Head to https://mui.com/r/migration-v4/#theme for a migration path.'].join('\n'));
      warnedOnce = true;
    }
  }
  return round(value);
}
var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
    _ref$fontFamily = _ref.fontFamily,
    fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
    _ref$fontWeightLight = _ref.fontWeightLight,
    fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
    _ref$fontWeightRegula = _ref.fontWeightRegular,
    fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
    _ref$fontWeightMedium = _ref.fontWeightMedium,
    fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
    _ref$fontWeightBold = _ref.fontWeightBold,
    fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
    _ref$htmlFontSize = _ref.htmlFontSize,
    htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
    allVariants = _ref.allVariants,
    pxToRem2 = _ref.pxToRem,
    other = _objectWithoutProperties(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
  if (process.env.NODE_ENV !== 'production') {
    if (typeof fontSize !== 'number') {
      console.error('Material-UI: `fontSize` is required to be a number.');
    }
    if (typeof htmlFontSize !== 'number') {
      console.error('Material-UI: `htmlFontSize` is required to be a number.');
    }
  }
  var coef = fontSize / 14;
  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };
  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return _extends({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };
  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return deepmerge(_extends({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: roundWithDeprecationWarning,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep
  });
}

var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;
function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss

var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];

var shape = {
  borderRadius: 4
};

var responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};

var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;
  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (typeof abs !== 'number') {
          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        }
      }
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (abs > themeSpacing.length - 1) {
          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }
  if (process.env.NODE_ENV !== 'production') {
    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }
  return function () {
    return undefined;
  };
}
process.env.NODE_ENV !== 'production' ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage

  var transform = createUnarySpacing({
    spacing: spacingInput
  });
  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (process.env.NODE_ENV !== 'production') {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }
    if (args.length === 0) {
      return transform(1);
    }
    if (args.length === 1) {
      return transform(args[0]);
    }
    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }
      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.

  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (process.env.NODE_ENV !== 'production') {
        if (!warnOnce || process.env.NODE_ENV === 'test') {
          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
        }
        warnOnce = true;
      }
      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */

var transitions = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$duration = options.duration,
      durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
      _options$easing = options.easing,
      easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
      _options$delay = options.delay,
      delay = _options$delay === void 0 ? 0 : _options$delay,
      other = _objectWithoutProperties(options, ["duration", "easing", "delay"]);
    if (process.env.NODE_ENV !== 'production') {
      var isString = function isString(value) {
        return typeof value === 'string';
      };
      var isNumber = function isNumber(value) {
        return !isNaN(parseFloat(value));
      };
      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: Argument "props" must be a string or Array.');
      }
      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }
      if (!isString(easingOption)) {
        console.error('Material-UI: Argument "easing" must be a string.');
      }
      if (!isNumber(delay) && !isString(delay)) {
        console.error('Material-UI: Argument "delay" must be a number or a string.');
      }
      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
      }
    }
    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }
    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};

// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};

function createTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$breakpoints = options.breakpoints,
    breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
    _options$mixins = options.mixins,
    mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
    _options$palette = options.palette,
    paletteInput = _options$palette === void 0 ? {} : _options$palette,
    spacingInput = options.spacing,
    _options$typography = options.typography,
    typographyInput = _options$typography === void 0 ? {} : _options$typography,
    other = _objectWithoutProperties(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);
  var palette = createPalette(paletteInput);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = deepmerge({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: shadows,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: shape,
    transitions: transitions,
    zIndex: zIndex
  }, other);
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  muiTheme = args.reduce(function (acc, argument) {
    return deepmerge(acc, argument);
  }, muiTheme);
  if (process.env.NODE_ENV !== 'production') {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];
    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];
        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: _defineProperty$2({}, "&$".concat(key), child)
            }, null, 2), '', 'https://mui.com/r/pseudo-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.

          node[key] = {};
        }
      }
    };
    traverse(muiTheme.overrides);
  }
  return muiTheme;
}

var defaultTheme = createTheme();

function withStyles(stylesOrCreator, options) {
  return withStyles$1(stylesOrCreator, _extends({
    defaultTheme: defaultTheme
  }, options));
}

var styles$1 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },
    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },
    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },
    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },
    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = /*#__PURE__*/React.forwardRef(function SvgIcon(props, ref) {
  var children = props.children,
    classes = props.classes,
    className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'inherit' : _props$color,
    _props$component = props.component,
    Component = _props$component === void 0 ? 'svg' : _props$component,
    _props$fontSize = props.fontSize,
    fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize,
    htmlColor = props.htmlColor,
    titleAccess = props.titleAccess,
    _props$viewBox = props.viewBox,
    viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
    other = _objectWithoutProperties(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: clsx(classes.root, className, color !== 'inherit' && classes["color".concat(capitalize(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat(capitalize(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? /*#__PURE__*/React.createElement("title", null, titleAccess) : null);
});
process.env.NODE_ENV !== "production" ? SvgIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: PropTypes.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: chainPropTypes(PropTypes.oneOf(['default', 'inherit', 'large', 'medium', 'small']), function (props) {
    var fontSize = props.fontSize;
    if (fontSize === 'default') {
      throw new Error('Material-UI: `fontSize="default"` is deprecated. Use `fontSize="medium"` instead.');
    }
    return null;
  }),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: PropTypes.string,
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: PropTypes.string
} : void 0;
SvgIcon.muiName = 'SvgIcon';
var SvgIcon$1 = withStyles(styles$1, {
  name: 'MuiSvgIcon'
})(SvgIcon);

/**
 * Private module reserved for @material-ui/x packages.
 */

function createSvgIcon(path, displayName) {
  var Component = function Component(props, ref) {
    return /*#__PURE__*/React__default.createElement(SvgIcon$1, _extends({
      ref: ref
    }, props), path);
  };
  if (process.env.NODE_ENV !== 'production') {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = "".concat(displayName, "Icon");
  }
  Component.muiName = SvgIcon$1.muiName;
  return /*#__PURE__*/React__default.memo( /*#__PURE__*/React__default.forwardRef(Component));
}

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var timeout;
  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line consistent-this
    var that = this;
    var later = function later() {
      func.apply(that, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
  debounced.clear = function () {
    clearTimeout(timeout);
  };
  return debounced;
}

function deprecatedPropType(validator, reason) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }
  return function (props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;
    if (typeof props[propName] !== 'undefined') {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }
    return null;
  };
}

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/ /*#__PURE__*/React.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc.defaultView || window;
}

function requirePropFactory(componentNameInError) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }
  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;
      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }
      return null;
    };
  };
  return requireProp;
}

// TODO v5: consider to make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }
  var propFullNameSafe = propFullName || propName;
  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }
  return null;
}

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
function useControlled(_ref) {
  var controlled = _ref.controlled,
    defaultProp = _ref.default,
    name = _ref.name,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'value' : _ref$state;
  var _React$useRef = React.useRef(controlled !== undefined),
    isControlled = _React$useRef.current;
  var _React$useState = React.useState(defaultProp),
    valueState = _React$useState[0],
    setValue = _React$useState[1];
  var value = isControlled ? controlled : valueState;
  if (process.env.NODE_ENV !== 'production') {
    React.useEffect(function () {
      if (isControlled !== (controlled !== undefined)) {
        console.error(["Material-UI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [controlled]);
    var _React$useRef2 = React.useRef(defaultProp),
      defaultValue = _React$useRef2.current;
    React.useEffect(function () {
      if (!isControlled && defaultValue !== defaultProp) {
        console.error(["Material-UI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }
  var setValueIfUncontrolled = React.useCallback(function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = React.useRef(fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return React.useCallback(function () {
    return (ref.current).apply(void 0, arguments);
  }, []);
}

function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return React.useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }
    return function (refValue) {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}

/**
 * Private module reserved for @material-ui/x packages.
 */

function useId(idOverride) {
  var _React$useState = React.useState(idOverride),
    defaultId = _React$useState[0],
    setDefaultId = _React$useState[1];
  var id = idOverride || defaultId;
  React.useEffect(function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}

// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
    tagName = node.tagName;
  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }
  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }
  if (node.isContentEditable) {
    return true;
  }
  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */

function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }
  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */

function handlePointerDown() {
  hadKeyboardEvent = false;
}
function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}
function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}
function isFocusVisible(event) {
  var target = event.target;
  try {
    return target.matches(':focus-visible');
  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
  // we use our own heuristic for those browsers
  // rethrow might be better if it's not the expected error but do we really
  // want to crash if focus-visible malfunctioned?
  // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only

  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */

function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}
function useIsFocusVisible() {
  var ref = React.useCallback(function (instance) {
    var node = ReactDOM.findDOMNode(instance);
    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(isFocusVisible);
  }
  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

var utils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    capitalize: capitalize,
    createChainedFunction: createChainedFunction,
    createSvgIcon: createSvgIcon,
    debounce: debounce,
    deprecatedPropType: deprecatedPropType,
    isMuiElement: isMuiElement,
    ownerDocument: ownerDocument,
    ownerWindow: ownerWindow,
    requirePropFactory: requirePropFactory,
    setRef: setRef,
    unstable_useId: useId,
    unsupportedProp: unsupportedProp,
    useControlled: useControlled,
    useEventCallback: useEventCallback,
    useForkRef: useForkRef,
    useIsFocusVisible: useIsFocusVisible
});

var require$$0$1 = /*@__PURE__*/getAugmentedNamespace(utils);

var hasRequiredCreateSvgIcon;
function requireCreateSvgIcon() {
  if (hasRequiredCreateSvgIcon) return createSvgIcon$1;
  hasRequiredCreateSvgIcon = 1;
  (function (exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "default", {
      enumerable: true,
      get: function get() {
        return _utils.createSvgIcon;
      }
    });
    var _utils = require$$0$1;
  })(createSvgIcon$1);
  return createSvgIcon$1;
}

var hasRequiredAppsOutlined;
function requireAppsOutlined() {
  if (hasRequiredAppsOutlined) return AppsOutlined$1;
  hasRequiredAppsOutlined = 1;
  var _interopRequireDefault = requireInteropRequireDefault();
  var _interopRequireWildcard = requireInteropRequireWildcard();
  Object.defineProperty(AppsOutlined$1, "__esModule", {
    value: true
  });
  AppsOutlined$1.default = void 0;
  var React = _interopRequireWildcard(React__default);
  var _createSvgIcon = _interopRequireDefault( /*@__PURE__*/requireCreateSvgIcon());
  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
    d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
  }), 'AppsOutlined');
  AppsOutlined$1.default = _default;
  return AppsOutlined$1;
}

var AppsOutlinedExports = /*@__PURE__*/ requireAppsOutlined();
var CalculatorIcon = /*@__PURE__*/getDefaultExportFromCjs(AppsOutlinedExports);

var AssignmentTurnedInOutlined$1 = {};

var hasRequiredAssignmentTurnedInOutlined;
function requireAssignmentTurnedInOutlined() {
  if (hasRequiredAssignmentTurnedInOutlined) return AssignmentTurnedInOutlined$1;
  hasRequiredAssignmentTurnedInOutlined = 1;
  var _interopRequireDefault = requireInteropRequireDefault();
  var _interopRequireWildcard = requireInteropRequireWildcard();
  Object.defineProperty(AssignmentTurnedInOutlined$1, "__esModule", {
    value: true
  });
  AssignmentTurnedInOutlined$1.default = void 0;
  var React = _interopRequireWildcard(React__default);
  var _createSvgIcon = _interopRequireDefault( /*@__PURE__*/requireCreateSvgIcon());
  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
    d: "M18 9l-1.41-1.42L10 14.17l-2.59-2.58L6 13l4 4zm1-6h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
  }), 'AssignmentTurnedInOutlined');
  AssignmentTurnedInOutlined$1.default = _default;
  return AssignmentTurnedInOutlined$1;
}

var AssignmentTurnedInOutlinedExports = /*@__PURE__*/ requireAssignmentTurnedInOutlined();
var ApplyIcon = /*@__PURE__*/getDefaultExportFromCjs(AssignmentTurnedInOutlinedExports);

var MonetizationOnOutlined$1 = {};

var hasRequiredMonetizationOnOutlined;
function requireMonetizationOnOutlined() {
  if (hasRequiredMonetizationOnOutlined) return MonetizationOnOutlined$1;
  hasRequiredMonetizationOnOutlined = 1;
  var _interopRequireDefault = requireInteropRequireDefault();
  var _interopRequireWildcard = requireInteropRequireWildcard();
  Object.defineProperty(MonetizationOnOutlined$1, "__esModule", {
    value: true
  });
  MonetizationOnOutlined$1.default = void 0;
  var React = _interopRequireWildcard(React__default);
  var _createSvgIcon = _interopRequireDefault( /*@__PURE__*/requireCreateSvgIcon());
  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z"
  }), 'MonetizationOnOutlined');
  MonetizationOnOutlined$1.default = _default;
  return MonetizationOnOutlined$1;
}

var MonetizationOnOutlinedExports = /*@__PURE__*/ requireMonetizationOnOutlined();
var TransactIcon = /*@__PURE__*/getDefaultExportFromCjs(MonetizationOnOutlinedExports);

const isViteApp = () => {
  return typeof process === 'undefined';
};
// Use this to check if the app is deployed (vs running locally). Returns TRUE in QA, Sandbox, Production.
const isNodeEnvProduction = () => isViteApp() ? undefined : process.env.NODE_ENV === 'production';
// Use this to check if the app is running in our production environment. Returns FALSE in QA, Sandbox.
const isProduction = () => isViteApp() ? undefined : process.env.REACT_APP_BUILD_ENV === 'production';
const getTestEnv = () => isViteApp() ? undefined : process.env.REACT_APP_BUILD_ENV !== 'production' ? isViteApp() ? undefined : process.env.REACT_APP_BUILD_ENV : '';
const usingTestApi = () => isViteApp() ? undefined : process.env.REACT_APP_USE_TEST_API === 'true';
const ACTION = {
  CONTINUE: 'continue',
  NEW_ACCESS_LOAN: 'new_access_loan'
};
const ALL_LOCATIONS = '**-ALL_LOCATIONS-**';
const CARESTACK_SESSION_STORAGE_KEY = 'carestackLocationDetails';
const PWA_SESSION_KEY = 'payWithAlphaeon_session';
const CARESTACK_ENROLL_URL = 'https://alphaeoncredit.formstack.com/forms/carestack';
const buildCareStackEnrollUrl = carestackId => carestackId ? `${CARESTACK_ENROLL_URL}?partner_referral_identifier=${encodeURIComponent(carestackId)}` : CARESTACK_ENROLL_URL;
const ALPHAEON_CONTACT_PHONE = '1-920-306-1794';
const ALPHAEON_CONTACT_EMAIL = 'teamcredit@alphaeon.com';
const INSTALLMENT = 'installment';
const ALPHAEON_FLEX_CONTACT_PHONE = '(888) 920-8966';
const MIN_ANNUAL_INCOME = 10000;
const EXPIRED_TIME = 5; // (minutes) Expiration Time Error message
const ROUTING_NUMBER_LOOKUP_REQUIRED = {
  merchant: false,
  consumer: false
};
const FLEX_PORTAL_URL = isProduction() ? 'https://flex.alphaeon.com' : 'https://flexqa.alphaeontest.com';
const FLEX_QUICK_START_GUIDE_URL = '/Alphaeon_Installment_QSG.pdf';
// Note that the keys here, with the exception of the UNKNOWN_ERROR key, must
// match the "error_code" values returned by the Consumer Application and
// Merchant Management APIs.
const API_ERROR_MAP = {
  application_not_declined: `Your application is not in the correct state for prequalification. Please contact us at ${ALPHAEON_CONTACT_PHONE}.`,
  lender_refused_void: 'The lender declined the void request',
  location_unconfigured_service_provider_profile: `This location does not have a valid service provider profile configuration. Please contact us at ${ALPHAEON_CONTACT_PHONE}.`,
  new_application_required: 'There was an issue with your application. Please resubmit your prequalification.',
  no_credit_application_found: 'Link expired or no active credit application found. Please contact the selected practice for further assistance.',
  no_plans_for_location: `There are no plans for this location. Please contact us at ${ALPHAEON_CONTACT_PHONE}`,
  prequalify_success_without_offers: `No offers have been returned for this application. Please contact us at ${ALPHAEON_CONTACT_PHONE}`,
  UNKNOWN_ERROR: `Received an unknown error code. Please call ${ALPHAEON_CONTACT_PHONE} if the situation persists`,
  no_credit_application_found_one_time: 'The link is either invalid or expired'
};
const APPLICATION = {
  CREDIT_PORTAL: 'credit-portal',
  MERCHANT_PORTAL: 'merchant'
};
const APPLICATION_ROOT_URL = window.location.origin;
const APPLICATION_SEARCH_CRITERION = {
  STATUS: 'status',
  TOKEN: 'token'
};
const DATE_STRING_LENGTH = 10;
const ERROR_STATUS = {
  API_DOWN: 'api-down',
  FORBIDDEN: '403',
  NETWORK_DOWN: 'network-down',
  NOT_FOUND: '404',
  UNAUTHORIZED: '401'
};
const BREAD_LENDER_STATUS = {
  STEP_UP_NEEDED: 'STEP UP NEEDED'
};
const ERROR_STATUS_NAME = {
  UNAUTHORIZED: 'unauthorized'
};
const PATH = {
  // Admin
  ADMIN: '/admin',
  // Application
  AUTHORIZATION_ERROR: '/error/authorization_error',
  CLIENT_ERROR: '/error/client_error',
  ERROR: '/error',
  EXPIRATION_TIME_ERROR: '/error/expiration_time_error',
  SERVER_ERROR: '/error/server_error',
  // Credit Portal
  ACCOUNT_EXISTS: '/account-exists',
  APPLICANT: '/applicant',
  APPLICANTS: '/applicants',
  APPLICATION_FINDER: '/find-application',
  APPLICATION_FOUND: '/application-found',
  APPROVE_AND_CHARGE: '/approve-and-charge',
  FIND_MY_ACCOUNT: '/find-my-account',
  AUTOPAY_AUTH: '/autopay-auth',
  CONTINUE_APPLICATION: '/continue-application',
  CREDIT_APPLICATION: '/apply',
  CREDIT_DECLINED: '/credit-declined',
  CREDIT_PORTAL: '/credit-portal',
  DECLINED: '/declined',
  FLEX_FINALIZE: '/flex-finalize',
  NEXT_STEPS: '/next-steps',
  NEW_ACCESS_LOAN: '/new-access-loan',
  NO_APPLICATIONS: '/no-applications-found',
  TREATMENT_ESTIMATE: '/treatment-estimate',
  PRE_QUALIFICATION_ACCEPT_DECLINED: '/pre-qualification-accept-declined',
  PRE_QUALIFICATION_ACCOUNT_EXISTS: '/pre-qualification-account-exists',
  PRE_QUALIFICATION_DECLINED_ADS_ONLY: '/pre-qualification-declined-card',
  PRE_QUALIFICATION_DECLINED_IMPRINT_ONLY: '/pre-qualification-declined-advantage',
  PRE_QUALIFICATION_DECLINED: '/pre-qualification-declined',
  PRE_QUALIFICATION_INFORMATION_REQUIRED: '/pre-qualification-information-required',
  PRINT: '/print/:terms',
  PUSH_APPLICATION: '/push-application',
  STEP_UP_REQUIRED: '/step-up-required',
  MORE_OFFERS: '/more-offers',
  ONE_TIME_PAYMENT: '/one-time-payment',
  PAY_WITH_ALPHAEON: '/pwa',
  ROOT: '/',
  WIZARD: '/wizard',
  // EDS
  EDS: {
    BASE: '/eds',
    INDEX: '/intro',
    APPLICATION: '/application',
    ADDITIONAL_INFO: '/additional-info',
    WATERFALL: '/waterfall',
    DECLINE: '/decline',
    RESULT: '/result',
    ERROR: '/error'
  },
  // Prove Mobile Idenitty Verification
  PROVE: {
    BASE: '/prove',
    INDEX: '',
    VERIFY: '/verify',
    OTA: '/ota',
    CHECKPHONE: '/checkphone'
  },
  // Legal
  ADVANTAGE_DISCLOSURE: '/advantage-disclosure',
  CA_PRIVACY_NOTICE: '/ca-privacy-notice',
  COMENITY_CAPITAL_PREQUALIFICATION_TERMS: '/comenity-capital-prequalification-terms',
  CONSENT_AUTODIALED: '/consent-autodialed',
  CONSENT_ELECTRONIC_DISCLOSURES: '/consent-electronic-disclosures',
  CONSUMER_FINANCIAL_PRIVACY_POLICY: '/consumer-financial-privacy-policy',
  CREDIT_REPORT_AUTHORIZATION: '/credit-report-authorization',
  FINANCING_PARTNERS: '/financing-partners',
  PARTNERS: '/partners',
  LEGAL: '/legal',
  PREQUALIFICATION_TERMS: '/prequalification-terms',
  PRIVACY_POLICY: '/privacy-policy',
  RIC_MERCHANT_AGREEMENT: '/ric-merchant-agreement',
  TERMS_OF_USE: '/terms-of-use',
  WEBSITE_TERMS_OF_USE: '/website-terms-of-use',
  TERMS_AND_CONDITIONS: '/alphaeon-credit-inc-terms-and-conditions',
  PRIVATE_LABEL_TERMS: '/alphaeon-credit-private-label-credit-card-program-terms-and-conditions',
  WIRELESS_CARRIER_TERMS: '/wireless-carrier-terms',
  //Merchant Portal
  ACCESS_LOANS: '/access-loans',
  ACCOUNT_CREATED: '/account/created',
  ACCOUNT_CREATED_FLEX: '/account/created/flex',
  ACCOUNT_LOOKUP_RESULT: '/account-lookup-result',
  ACCOUNT_LOOKUP_SUMMARY: '/account-lookup/',
  ACCOUNT_LOOKUP: '/account-lookup',
  ADD_SIGNER: '/add-signer',
  TRANSACT_LOOKUP: '/sales/lookup',
  APPLICATION: '/application',
  APPLICATION_ACCOUNT_EXISTS: '/application-account-exists',
  APPLICATION_DECLINED: '/application-declined',
  APPLICATION_PENDING: '/application-pending',
  APPLICATION_STEP_UP: '/application-step-up',
  APPLICATION_REPORT_DETAILS: '/application-reports',
  CALCULATOR: '/calculator',
  COMPARISON_SHEETS: '/comparison-sheets',
  COMPARISON_SHEET_NEW: '/comparison-sheets/new',
  COMPARISON_SHEET_EDIT: '/comparison-sheets/:sheetId',
  CONTACT_US: '/contact-us',
  DECLINED_ACCESS_LOAN_AVAILABLE: '/application-declined/access-loan-available',
  DOC_UPLOAD: '/doc-upload',
  INVOICE_BUILDER: '/invoice-builder',
  NO_MANAGER_ACCESS: '/no-manager-access',
  MARKETING: '/marketing',
  QR_CODE: '/qr-code',
  MARKETING_CUSTOM_LINK: '/custom-link',
  MERCHANT_PORTAL: '/merchant',
  NEW: '/new',
  NEW_DEAL: '/new-deal',
  PAYMENT_DETAILS: '/payment-details',
  PROGRAM_MANAGEMENT: '/program-management',
  LOCATION_MANAGEMENT: '/location-management',
  BANK_VERIFICATION: '/bank-verification',
  DOCUMENT_MANAGEMENT: '/document-management',
  RECONCILIATION_REPORT: '/reconciliation-report',
  REFUND_COMPLETE: '/account/refund/:id/complete',
  REFUND_REQUEST: '/account/refund/:id',
  REPORTS: '/reports',
  SALES_REPORT_DETAILS: '/sales-reports',
  SALES: '/sales',
  SITE_INITIALIZATION: '/i',
  STORE: '/store/',
  LOCATION: '/location/',
  USER: '/users',
  VERIFY_PRACTICE_INFORMATION_URL: '/verify-practice-information',
  VOID_SALE: '/account/void-sale/:id',
  ACCOUNT_VERIFICATION: '/account-verification',
  CREDIT_PORTAL_RECEIPT: '/credit-portal/receipt',
  CARESTACK_LINK_LOCATION_SUCCESS: '/partner_connections/carestack/link_location_success',
  CARESTACK_LINK_LOCATION_CONFIRM: '/partner_connections/carestack/link_location_confirm',
  CARESTACK_NO_MATCHES: '/partner_connections/carestack/no_matches',
  CARESTACK_LINK_LOCATION: '/merchant/partner_connections/carestack/link_location',
  // Internal Portal
  INTERNAL_PORTAL: '/portal',
  GLOBAL_SEARCH: '/global-search',
  CREDIT_APPLICATION_DETAILED: '/detailed-credit-application',
  LOCATIONS: '/locations',
  IDENTITY_VERIFICATION: '/identity-verification',
  PLAN_MANAGEMENT: '/plan-management',
  ADMIN_TOOLS: '/admin-tools',
  BULK_PRACTICE_MANAGERS: '/bulk-practice-managers',
  SERVICING_INSTRUMENTS: '/servicing-instruments',
  CASES: '/cases',
  ENROLLMENTS: '/enrollments',
  MERCHANT_IPS: '/merchant-ips',
  // Partner Integrations
  PARTNER_INTEGRATIONS: '/partners',
  CARESTACK: '/carestack'
};
const URL$1 = {
  PRACTICE_SUPPORT: 'https://www.myalphaeoncredit.com/practice-support',
  PATIENT_SUPPORT: 'https://www.myalphaeoncredit.com/patient-support',
  PATRIOT_ACT: 'https://d.comenity.net/legaldocs/alphaeoncosmetic/legal-documents/patriot-act',
  CCA: 'https://c.comenity.net/legaldocs/alphaeoncosmetic/legal-documents/cca',
  COMENITY_FINANCIAL_PRIVACY: 'https://d.comenity.net/ac/privacy/financial',
  FINANCIAL_PRIVACY: 'https://comenity.com/financial-privacy',
  PRIVACY_POLICY: 'https://comenity.com/privacy-policy',
  LINKEDIN: 'https://www.linkedin.com/company/alphaeoncredit',
  INSTAGARAM: 'https://www.instagram.com/alphaeoncredit/',
  FACEBOOK: 'https://www.facebook.com/AlphaeonCredit/',
  GOOGLE: 'https://www.google.com/',
  IOVATION_JS: isNodeEnvProduction() ? '/iojs/snare.js' : 'https://go.qa.alphaeontest.com/iojs/snare.js',
  //merchant portal
  ALPHAEON_COSMETIC: 'http://www.comenity.net/alphaeoncosmetic',
  ALPHAEON: 'https://goalphaeon.com/',
  MANAGE_ACCOUNT: 'https://d.comenity.net/ac/alphaeon/public/home',
  //imprint
  IMPRINT_PRIVACY_POLICY: 'https://media-assets.imprint.co/imprint/legal/fbt/privacy-en',
  IMPRINT_ECONSENT: 'https://media-assets.imprint.co/imprint/legal/fbt/esign-en',
  SOUTH_CAROLINA_DISCLOSURE: 'https://consumer.sc.gov/sites/consumer/files/Documents/Business%20Resources%20Laws/Regulatory/Registered%20Creditors/ConsumerLoansFAQs.pdf',
  // Internal portal
  INTERNAL_PORTAL: getTestEnv() === '' ? 'https://internal.alphaeon.com' : 'https://internal.sandbox.alphaeontest.com'
};
// Web-enrollment app hosts. Both are exposed (rather than one env-derived
// value) so tooling can build links for either environment.
const ENROLLMENTS_APP_HOSTS = {
  production: 'https://enroll.alphaeon.com',
  qa: 'https://qa.d1i88nxafhqfj5.amplifyapp.com'
};
const VOID_SALE = '/merchant/account/void-sale';
const MERCHANT_SALES_PORTAL = '/merchant/sales';
const MERCHANT_INVOICE_BUILDER = '/merchant/invoice-builder';
const MERCHANT_USER_PORTAL = '/merchant/users';
const MERCHANT_PORTAL_PATHS = {
  ROOT: '/',
  RESULT: '/result',
  DETAIL: '/:id',
  LOAN_ADJUSTMENT: '/:id/loan-adjustment',
  LOAN_ADJUSTMENT_URL: '/loan-adjustment',
  VOID_SALE: '/account/void-sale/',
  REFUND_REQUEST: '/account/refund/',
  REFUND_COMPLETE: '/account/refund/complete'
};
const SALES_PORTAL_PATHS = {
  //Sales
  PAYMENT_DETAILS: '/payment-details/:id',
  PLAN_SELECTION: '/plan-selection',
  SIGN_RECEIPT: '/sign-receipt',
  PAYMENT_DETAILS_AUTH_BUYER: '/payment-details/:id/buyer/:buyerId',
  ACCOUNT_VERIFICATION: '/account-verification',
  AUTHORIZATION_SENT: '/authorization-sent'
};
const INVOICE_BUILDER_PATHS = {
  NEW: '/:id',
  DRAFT: '/:id/:uuid',
  STEP: '/:id/:uuid/:step'
};
const INVOICE_BUILDER_STEPS = {
  INVOICE: 'invoice',
  PLANS: 'plans',
  VERIFICATION: 'verification',
  REVIEW: 'review',
  CONFIRMATION: 'confirmation'
};
const APPLICATION_PATHS = {
  BEGIN: '/begin',
  CONFIRM: '/confirm'
};
const USER_PORTAL_PATHS = {
  LIST: '/',
  ADD: '/add',
  UPDATE: '/update/:id',
  UPDATE_URL: '/update/'
};
const STATES = [{
  key: 'ALABAMA',
  value: 'AL'
}, {
  key: 'ALASKA',
  value: 'AK'
}, {
  key: 'ARIZONA',
  value: 'AZ'
}, {
  key: 'ARKANSAS',
  value: 'AR'
}, {
  key: 'CALIFORNIA',
  value: 'CA'
}, {
  key: 'COLORADO',
  value: 'CO'
}, {
  key: 'CONNECTICUT',
  value: 'CT'
}, {
  key: 'DELAWARE',
  value: 'DE'
}, {
  key: 'DISTRICT OF COLUMBIA',
  value: 'DC'
}, {
  key: 'FLORIDA',
  value: 'FL'
}, {
  key: 'GEORGIA',
  value: 'GA'
}, {
  key: 'HAWAII',
  value: 'HI'
}, {
  key: 'IDAHO',
  value: 'ID'
}, {
  key: 'ILLINOIS',
  value: 'IL'
}, {
  key: 'INDIANA',
  value: 'IN'
}, {
  key: 'IOWA',
  value: 'IA'
}, {
  key: 'KANSAS',
  value: 'KS'
}, {
  key: 'KENTUCKY',
  value: 'KY'
}, {
  key: 'LOUISIANA',
  value: 'LA'
}, {
  key: 'MAINE',
  value: 'ME'
}, {
  key: 'MARYLAND',
  value: 'MD'
}, {
  key: 'MASSACHUSETTS',
  value: 'MA'
}, {
  key: 'MICHIGAN',
  value: 'MI'
}, {
  key: 'MINNESOTA',
  value: 'MN'
}, {
  key: 'MISSISSIPPI',
  value: 'MS'
}, {
  key: 'MISSOURI',
  value: 'MO'
}, {
  key: 'MONTANA',
  value: 'MT'
}, {
  key: 'NEBRASKA',
  value: 'NE'
}, {
  key: 'NEVADA',
  value: 'NV'
}, {
  key: 'NEW HAMPSHIRE',
  value: 'NH'
}, {
  key: 'NEW JERSEY',
  value: 'NJ'
}, {
  key: 'NEW MEXICO',
  value: 'NM'
}, {
  key: 'NEW YORK',
  value: 'NY'
}, {
  key: 'NORTH CAROLINA',
  value: 'NC'
}, {
  key: 'NORTH DAKOTA',
  value: 'ND'
}, {
  key: 'OHIO',
  value: 'OH'
}, {
  key: 'OKLAHOMA',
  value: 'OK'
}, {
  key: 'OREGON',
  value: 'OR'
}, {
  key: 'PENNSYLVANIA',
  value: 'PA'
}, {
  key: 'RHODE ISLAND',
  value: 'RI'
}, {
  key: 'SOUTH CAROLINA',
  value: 'SC'
}, {
  key: 'SOUTH DAKOTA',
  value: 'SD'
}, {
  key: 'TENNESSEE',
  value: 'TN'
}, {
  key: 'TEXAS',
  value: 'TX'
}, {
  key: 'UTAH',
  value: 'UT'
}, {
  key: 'VERMONT',
  value: 'VT'
}, {
  key: 'VIRGINIA',
  value: 'VA'
}, {
  key: 'WASHINGTON',
  value: 'WA'
}, {
  key: 'WEST VIRGINIA',
  value: 'WV'
}, {
  key: 'WISCONSIN',
  value: 'WI'
}, {
  key: 'WYOMING',
  value: 'WY'
}];
const VERIFICATION_METHODS = [{
  key: "Driver's license",
  value: 'drivers-license'
}, {
  key: 'State ID',
  value: 'state-id'
}, {
  key: 'Federal or Government Photo ID',
  value: 'federal-or-government-photo-id'
}, {
  key: 'Military Photo ID',
  value: 'military-photo-id'
}, {
  key: 'Passport',
  value: 'passport'
}, {
  key: 'Border Crossing Card',
  value: 'border-crossing-card'
}, {
  key: 'US Legal Resident Alien ID',
  value: 'us-legal-resident-alien-id'
}, {
  key: 'Travel Visa with a Photo',
  value: 'travel-visa-with-a-photo'
}];
const RECEIPT_TYPE_OPTIONS = [{
  key: 'Digital Receipt',
  value: 'Digital Receipt'
}, {
  key: 'Print Receipt',
  value: 'Print Receipt'
}];
const DOCTOR_SPECIALTIES = [{
  key: 'Audiology',
  value: 'audiology'
}, {
  key: 'Dentistry',
  value: 'dentistry'
}, {
  key: 'Dermatology',
  value: 'dermatology'
}, {
  key: 'Ophthalmology/ Optometry',
  value: 'ophthalmology_optometry'
}, {
  key: 'Plastic Surgery',
  value: 'plastic_surgery'
}, {
  key: 'Veterinary',
  value: 'veterinary'
}];
const OPTIONS_HOUSING = [{
  label: 'Rent',
  value: 'RENT'
}, {
  label: 'Own',
  value: 'OWN'
}, {
  label: 'Other',
  value: 'HOUSING_TYPE_OTHER'
}];
const OPTIONS_INCOME_SOURCE = [{
  label: 'Employment',
  value: 'EMPLOYMENT'
}, {
  label: 'Self-Employment',
  value: 'SELF_EMPLOYMENT'
}, {
  label: 'Business Owner',
  value: 'BUSINESS_OWNER'
}, {
  label: 'Retirement',
  value: 'RETIREMENT'
}, {
  label: 'Unemployment',
  value: 'UNEMPLOYMENT'
}, {
  label: 'Government Assistance',
  value: 'GOVT_ASSISTANCE'
}, {
  label: 'Other',
  value: 'INCOME_SOURCE_OTHER'
}];
const OPTIONS_PAY_FREQUENCY = [{
  label: 'Weekly',
  value: 'W'
}, {
  label: 'Bi-Weekly',
  value: 'B'
}, {
  label: 'Monthly',
  value: 'M'
}, {
  label: 'Twice Monthly',
  value: 'T'
}];
// Path helpers...
const makePath = (...args) => args.join('');
const makeStoreUrl = store_id => `${STORE_URL}${store_id}`;
const makeLocationUrl = location_id => `${LOCATION_URL}${location_id}`;
const makeCreditPortalPath = (...args) => makePath(PATH.CREDIT_PORTAL, ...args);
const makeMerchantPortalPath = (...args) => makePath(PATH.MERCHANT_PORTAL, ...args);
const makeApplicationURL = (...args) => makePath(APPLICATION_ROOT_URL, ...args);
const PERMISSION = {
  ACCOUNT_LOOKUP: 'canAccessAccountLookup',
  APPLICATION_ACTIVITY_TABLE: 'canAccessApplicationActivityTable',
  CALCULATOR: 'canAccessCalculator',
  IS_SIGNER: 'isSigner',
  MANAGE_PROGRAMS: 'canManagePrograms',
  MANAGE_USERS: 'canManageUsers',
  PROCESS_REFUND: 'canProcessRefund',
  PROCESS_SALE: 'canProcessSale',
  PROCESS_VOID: 'canProcessVoid',
  SUBMIT_PUSH_APPLICATIONS: 'canSubmitPushApplications',
  SUBMIT_DASHBOARD_APPLICATIONS: 'canSubmitDashboardApplications',
  VIEW_APPLICATION_TRACKING_REPORT: 'canViewApplicationTrackingReport',
  VIEW_BANK_RECONCILIATION_REPORT: 'canViewBankReconciliationReport',
  VIEW_CREDIT_AVAILABLE_REPORT: 'canViewCreditAvailableReport',
  VIEW_SALE_REPORT: 'canViewSaleReport'
};
const ALL_PERMISSIONS = [PERMISSION.ACCOUNT_LOOKUP, PERMISSION.APPLICATION_ACTIVITY_TABLE, PERMISSION.CALCULATOR, PERMISSION.MANAGE_USERS, PERMISSION.MANAGE_PROGRAMS, PERMISSION.PROCESS_REFUND, PERMISSION.PROCESS_SALE, PERMISSION.PROCESS_VOID, PERMISSION.SUBMIT_DASHBOARD_APPLICATIONS, PERMISSION.SUBMIT_PUSH_APPLICATIONS, PERMISSION.VIEW_APPLICATION_TRACKING_REPORT, PERMISSION.VIEW_BANK_RECONCILIATION_REPORT, PERMISSION.VIEW_CREDIT_AVAILABLE_REPORT, PERMISSION.VIEW_SALE_REPORT];
const FULL_ACCOUNT_ACCESS_KEYS = [PERMISSION.IS_SIGNER];
const ADMIN_PERMISSION_KEYS = [PERMISSION.MANAGE_USERS, PERMISSION.MANAGE_PROGRAMS];
const DEFAULT_PERMISSIONS = {
  [PERMISSION.ACCOUNT_LOOKUP]: true,
  [PERMISSION.APPLICATION_ACTIVITY_TABLE]: true,
  [PERMISSION.CALCULATOR]: true,
  [PERMISSION.MANAGE_PROGRAMS]: false,
  [PERMISSION.MANAGE_USERS]: false,
  [PERMISSION.PROCESS_REFUND]: true,
  [PERMISSION.PROCESS_SALE]: true,
  [PERMISSION.PROCESS_VOID]: true,
  [PERMISSION.SUBMIT_DASHBOARD_APPLICATIONS]: true,
  [PERMISSION.SUBMIT_PUSH_APPLICATIONS]: true,
  [PERMISSION.VIEW_APPLICATION_TRACKING_REPORT]: true,
  [PERMISSION.VIEW_BANK_RECONCILIATION_REPORT]: true,
  [PERMISSION.VIEW_CREDIT_AVAILABLE_REPORT]: true,
  [PERMISSION.VIEW_SALE_REPORT]: true
};
const DEFAULT_PERMISSIONS_KEYS = [PERMISSION.ACCOUNT_LOOKUP, PERMISSION.APPLICATION_ACTIVITY_TABLE, PERMISSION.CALCULATOR, PERMISSION.PROCESS_REFUND, PERMISSION.PROCESS_SALE, PERMISSION.PROCESS_VOID, PERMISSION.SUBMIT_DASHBOARD_APPLICATIONS, PERMISSION.SUBMIT_PUSH_APPLICATIONS, PERMISSION.VIEW_APPLICATION_TRACKING_REPORT, PERMISSION.VIEW_BANK_RECONCILIATION_REPORT, PERMISSION.VIEW_CREDIT_AVAILABLE_REPORT, PERMISSION.VIEW_SALE_REPORT];
const QUERY_KEY = {
  ACTION: 'action',
  APPLICATION: 'app',
  APPLICATION_PATH: 'applicationPath',
  BACK: 'back',
  ERROR: 'error',
  ERROR_DESCRIPTION: 'errorDescription',
  LOCATION_ID: 'locationId',
  LOCATION_NAME: 'locationName',
  OTL: 'otl',
  PRIORITY: 'priority',
  RETURN_TO: 'returnTo',
  STATUS: 'status',
  STORE_LINK_CAMPAIGN: 'storeLinkCampaign',
  SUPPLEMENTED_CCI_ID: 'supplementedConsumerCreditInstrumentId',
  TOKEN: 'token',
  TYPE: 'type'
};
// Must not outlive the OTL it carries, which the API expires after
// EXTERNAL_REFERENCE_VALID_DAYS (default 1 day). A longer-lived cookie strands a
// stale token that can only ever fail validation.
const STORE_LINK_CAMPAIGN_COOKIE_OPTIONS = {
  path: '/',
  maxAge: 60 * 60 * 24
};
const REACT_APP_API_URL = isViteApp() ? undefined : process.env.REACT_APP_API_URL;
const CONSUMER_APP_URL = isViteApp() ? undefined : process.env.REACT_APP_CONSUMER_APP_URL;
const REACT_APP_INTERNAL_PORTAL_GOOGLE_CLIENT_ID = isViteApp() ? undefined : process.env.REACT_APP_INTERNAL_PORTAL_GOOGLE_CLIENT_ID;
// Credit Portal
const CREDIT_PORTAL_URL = makeCreditPortalPath(PATH.CREDIT_APPLICATION);
const FIND_MY_ACCOUNT_URL = makeCreditPortalPath(PATH.FIND_MY_ACCOUNT);
const TREATMENT_ESTIMATE_URL = makeCreditPortalPath(PATH.TREATMENT_ESTIMATE);
const PAY_WITH_ALPHAEON_URL = makeCreditPortalPath(PATH.PAY_WITH_ALPHAEON);
const CONTINUE_APPLICATION_URL = makeCreditPortalPath(PATH.APPLICANTS, PATH.CONTINUE_APPLICATION);
const NEW_ACCESS_LOAN_URL = makeCreditPortalPath(PATH.APPLICANTS, PATH.NEW_ACCESS_LOAN);
const APPLICANTS_URL = makeCreditPortalPath(PATH.APPLICANTS);
const PUSH_APPLICATION_URL = makePath(CONSUMER_APP_URL, PATH.CREDIT_PORTAL, PATH.APPLICANTS, PATH.PUSH_APPLICATION);
const DECLINED_URL = makeCreditPortalPath(PATH.CREDIT_APPLICATION, PATH.DECLINED);
const ACCOUNT_EXISTS_URL = makeCreditPortalPath(PATH.CREDIT_APPLICATION, PATH.ACCOUNT_EXISTS);
const APPLICATION_FINDER_URL = makeCreditPortalPath(PATH.CREDIT_APPLICATION, PATH.APPLICATION_FINDER);
const APPLICATION_FOUND_URL = makeCreditPortalPath(PATH.CREDIT_APPLICATION, PATH.APPLICATION_FOUND);
const NO_APPLICATIONS_URL = makeCreditPortalPath(PATH.CREDIT_APPLICATION, PATH.NO_APPLICATIONS);
const PRE_QUALIFICATION_ACCOUNT_EXISTS_URL = makeCreditPortalPath(PATH.CREDIT_APPLICATION, PATH.PRE_QUALIFICATION_ACCOUNT_EXISTS);
const PRE_QUALIFICATION_DECLINED_URL = makeCreditPortalPath(PATH.CREDIT_APPLICATION, PATH.PRE_QUALIFICATION_DECLINED);
const PRE_QUALIFICATION_INFORMATION_REQUIRED_URL = makeCreditPortalPath(PATH.CREDIT_APPLICATION, PATH.PRE_QUALIFICATION_INFORMATION_REQUIRED);
const PRE_QUALIFICATION_ACCEPT_DECLINED_URL = makeCreditPortalPath(PATH.CREDIT_APPLICATION, PATH.PRE_QUALIFICATION_ACCEPT_DECLINED);
const PRE_QUALIFICATION_DECLINED_ADS_ONLY_URL = makeCreditPortalPath(PATH.CREDIT_APPLICATION, PATH.PRE_QUALIFICATION_DECLINED_ADS_ONLY);
const PRE_QUALIFICATION_DECLINED_IMPRINT_ONLY_URL = makeCreditPortalPath(PATH.CREDIT_APPLICATION, PATH.PRE_QUALIFICATION_DECLINED_IMPRINT_ONLY);
const STEP_UP_REQUIRED_URL = makeCreditPortalPath(PATH.CREDIT_APPLICATION, PATH.STEP_UP_REQUIRED);
const WIZARD_URL = makeCreditPortalPath(PATH.CREDIT_APPLICATION, PATH.WIZARD);
const STORE_URL = makeCreditPortalPath(PATH.STORE);
const LOCATION_URL = makeCreditPortalPath(PATH.LOCATION);
const ACCESS_LOAN_URL = makeCreditPortalPath(PATH.CREDIT_APPLICATION, PATH.ACCESS_LOANS);
const APPLY_URL = isProduction() ? 'https://go.alphaeoncredit.com/credit-portal/apply' : 'https://go.qa.alphaeontest.com/credit-portal/apply';
const CREDIT_DECLINED_URL = makeCreditPortalPath(PATH.CREDIT_APPLICATION, PATH.CREDIT_DECLINED);
const PRINT_URL = '/print';
const WIZARD_STEP = {
  COLLECT_PERSONAL_INFO: 0,
  PERFORM_PREQUALIFICATION: 1,
  APPROVAL: 2
};
// Merchant Portal
const MERCHANT_PORTAL_URL = makePath(PATH.MERCHANT_PORTAL, PATH.ROOT);
const USER_PORTAL_URL = makePath(PATH.MERCHANT_PORTAL, PATH.USER);
const CARESTACK_LINK_LOCATION_SUCCESS_URL = makePath(PATH.MERCHANT_PORTAL, PATH.CARESTACK_LINK_LOCATION_SUCCESS);
const CARESTACK_LINK_LOCATION_CONFIRM_URL = makePath(PATH.MERCHANT_PORTAL, PATH.CARESTACK_LINK_LOCATION_CONFIRM);
const CARESTACK_NO_MATCHES_URL = makePath(PATH.MERCHANT_PORTAL, PATH.CARESTACK_NO_MATCHES);
const CARESTACK_LINK_LOCATION = makePath(PATH.MERCHANT_PORTAL, PATH.CARESTACK_LINK_LOCATION);
const ACCOUNT_LOOKUP_URL = makePath(PATH.MERCHANT_PORTAL, PATH.ACCOUNT_LOOKUP);
const CALCULATOR_URL = makePath(PATH.MERCHANT_PORTAL, PATH.CALCULATOR);
const ACCOUNT_LOOKUP = '/merchant/account-lookup';
const REPORT_URL = makePath(PATH.MERCHANT_PORTAL, PATH.REPORTS);
const CONTACT_US_URL = makePath(PATH.MERCHANT_PORTAL, PATH.CONTACT_US);
const START_APPLICATION_URL = makePath(PATH.MERCHANT_PORTAL, PATH.APPLICATION, APPLICATION_PATHS.CONFIRM);
const ACCOUNT_FULL_APPLICATION_CONFIRM_URL = makePath(PATH.MERCHANT_PORTAL, PATH.APPLICATION, APPLICATION_PATHS.CONFIRM);
const ACCOUNT_FULL_APPLICATION_URL = makePath(PATH.MERCHANT_PORTAL, PATH.APPLICATION, APPLICATION_PATHS.BEGIN);
const MERCHANT_ACCOUNT_EXISTS_URL = makePath(PATH.MERCHANT_PORTAL, PATH.APPLICATION_ACCOUNT_EXISTS);
const MERCHANT_DECLINED_URL = makePath(PATH.MERCHANT_PORTAL, PATH.APPLICATION_DECLINED);
const MERCHANT_DECLINED_ACCESS_LOAN_AVAILABLE = makePath(PATH.MERCHANT_PORTAL, PATH.DECLINED_ACCESS_LOAN_AVAILABLE);
const MERCHANT_PENDING_URL = makePath(PATH.MERCHANT_PORTAL, PATH.APPLICATION_PENDING);
const MERCHANT_STEP_UP_URL = makePath(PATH.MERCHANT_PORTAL, PATH.APPLICATION_STEP_UP);
const MARKETING_CUSTOM_LINK_URL = makePath(PATH.MERCHANT_PORTAL, PATH.MARKETING_CUSTOM_LINK);
const QR_CODE_URL = makePath(PATH.MERCHANT_PORTAL, PATH.QR_CODE);
const MARKETING_MATERIALS = makePath(PATH.MERCHANT_PORTAL, PATH.MARKETING);
const COMPARISON_SHEETS_URL = makePath(PATH.MERCHANT_PORTAL, PATH.COMPARISON_SHEETS);
const COMPARISON_SHEET_NEW_URL = makePath(PATH.MERCHANT_PORTAL, PATH.COMPARISON_SHEET_NEW);
const comparisonSheetEditUrl = sheetId => `${COMPARISON_SHEETS_URL}/${sheetId}`;
const ACCOUNT_CREATED_URL = makePath(PATH.MERCHANT_PORTAL, PATH.ACCOUNT_CREATED);
const ACCOUNT_CREATED_FLEX_URL = makePath(PATH.MERCHANT_PORTAL, PATH.ACCOUNT_CREATED_FLEX);
const ACCOUNT_LOOK_RESULT_URL = makePath(PATH.MERCHANT_PORTAL, PATH.ACCOUNT_LOOKUP_RESULT);
const ACCOUNT_DETAIL_URL = makePath(PATH.MERCHANT_PORTAL, PATH.ACCOUNT_LOOKUP_SUMMARY);
const LOAN_ADJUSTMENT_URL = makePath(MERCHANT_PORTAL_PATHS.LOAN_ADJUSTMENT_URL);
const ACCOUNT_LOOK_UP_RESULT_URL = makePath(PATH.MERCHANT_PORTAL + PATH.ACCOUNT_LOOKUP, MERCHANT_PORTAL_PATHS.RESULT);
const VOID_SALE_URL = makePath(PATH.MERCHANT_PORTAL, MERCHANT_PORTAL_PATHS.VOID_SALE);
const USER_URL = makePath(MERCHANT_USER_PORTAL, '/');
const USER_UPDATE_URL = makePath(MERCHANT_USER_PORTAL, USER_PORTAL_PATHS.UPDATE_URL);
const REFUND_REQUEST_URL = makePath(PATH.MERCHANT_PORTAL, MERCHANT_PORTAL_PATHS.REFUND_REQUEST);
const SALES_URL = makePath(MERCHANT_SALES_PORTAL, PATH.PAYMENT_DETAILS);
const INVOICE_BUILDER_URL = MERCHANT_INVOICE_BUILDER;
const makeInvoiceBuilderPath = (alphaeonAccountNumber, uuid, step) => [INVOICE_BUILDER_URL, alphaeonAccountNumber, uuid, step].filter(Boolean).join('/');
const PLAN_SELECTION_URL = makePath(MERCHANT_SALES_PORTAL, SALES_PORTAL_PATHS.PLAN_SELECTION);
const SIGN_RECEIPT_URL = makePath(MERCHANT_SALES_PORTAL, SALES_PORTAL_PATHS.SIGN_RECEIPT);
const AUTHORIZATION_SENT_URL = makePath(MERCHANT_SALES_PORTAL, SALES_PORTAL_PATHS.AUTHORIZATION_SENT);
const USER_ADD_URL = makePath(MERCHANT_USER_PORTAL, USER_PORTAL_PATHS.ADD);
const PROGRAM_MANAGEMENT_URL = makePath(PATH.MERCHANT_PORTAL, PATH.PROGRAM_MANAGEMENT);
const LOCATION_MANAGEMENT_URL = makePath(PATH.MERCHANT_PORTAL, PATH.LOCATION_MANAGEMENT);
const BANK_VERIFICATION_URL = makePath(PATH.MERCHANT_PORTAL, PATH.BANK_VERIFICATION);
const DOCUMENT_MANAGEMENT_URL = makePath(PATH.MERCHANT_PORTAL, PATH.DOCUMENT_MANAGEMENT);
const ACCOUNT_VERIFICATION_URL = makePath(MERCHANT_SALES_PORTAL, SALES_PORTAL_PATHS.ACCOUNT_VERIFICATION);
const PRIVACY_URL = makePath(PATH.LEGAL, PATH.WEBSITE_TERMS_OF_USE);
const FINANCING_PARTNERS_URL = makePath(PATH.LEGAL, PATH.FINANCING_PARTNERS);
const RIC_MERCHANT_AGREEMENT_URL = makePath(PATH.LEGAL, PATH.RIC_MERCHANT_AGREEMENT);
const TERMS_AND_CONDITIONS_URL = makePath(PATH.LEGAL, PATH.TERMS_AND_CONDITIONS);
const PRIVATE_LABEL_TERMS_URL = makePath(PATH.LEGAL, PATH.PRIVATE_LABEL_TERMS);
const ERROR_EXPIRATION_ERROR_URL = PATH.EXPIRATION_TIME_ERROR;
const INITIALIZATION_CONTACT_US_URL = makeMerchantPortalPath(PATH.SITE_INITIALIZATION, PATH.CONTACT_US);
const NO_MANAGER_ACCESS_URL = makeMerchantPortalPath(PATH.SITE_INITIALIZATION, PATH.NO_MANAGER_ACCESS);
const DASHBOARD_ACTIONS = [{
  id: 'apply',
  title: 'APPLY',
  description: 'Start a new application',
  icon: ApplyIcon,
  link: ACCOUNT_FULL_APPLICATION_CONFIRM_URL,
  requiredPermission: [PERMISSION.SUBMIT_DASHBOARD_APPLICATIONS, PERMISSION.SUBMIT_PUSH_APPLICATIONS]
}, {
  id: 'transact',
  title: 'TRANSACT',
  description: 'Process a sale or refund',
  icon: TransactIcon,
  link: '/merchant/sales/lookup',
  requiredPermission: PERMISSION.ACCOUNT_LOOKUP
}, {
  id: 'calculator',
  title: 'CALCULATOR',
  description: 'Estimate payments',
  icon: CalculatorIcon,
  link: CALCULATOR_URL,
  requiredPermission: PERMISSION.CALCULATOR
}];
// Notfications
const NOTIFICATIONS_INTERVAL_ACTIVE = isViteApp() ? undefined : process.env.REACT_APP_NOTIFICATIONS_INTERVAL_ACTIVE;
// Prove Channel SELECT
const PROVE_CHANNEL_SELECT = isViteApp() ? undefined : process.env.REACT_APP_PROVE_CHANNEL_SELECT;
// Prove Channel PREQUALIFY
const PROVE_CHANNEL_PREQUALIFY = isViteApp() ? undefined : process.env.REACT_APP_PROVE_CHANNEL_PREQUALIFY;
// Analytics
const REACT_APP_ANALYTICS_CFE_GA_ID = isViteApp() ? undefined : process.env.REACT_APP_ANALYTICS_CFE_GA_ID;
const REACT_APP_ANALYTICS_CFE_GTM_ID = isViteApp() ? undefined : process.env.REACT_APP_ANALYTICS_CFE_GTM_ID;
const REACT_APP_ANALYTICS_MFE_GA_ID = isViteApp() ? undefined : process.env.REACT_APP_ANALYTICS_MFE_GA_ID;
const REACT_APP_ANALYTICS_MFE_GTM_ID = isViteApp() ? undefined : process.env.REACT_APP_ANALYTICS_MFE_GTM_ID;
// HyperDX
const REACT_APP_HYPERDX = isViteApp() ? undefined : process.env.REACT_APP_HYPERDX;
// reCAPTCHA
const REACT_APP_RECAPTCHA_SITE_KEY = isViteApp() ? undefined : process.env.REACT_APP_RECAPTCHA_SITE_KEY;
// Auth0 Credentials
const REACT_APP_AUTH0_DOMAIN = isViteApp() ? undefined : process.env.REACT_APP_AUTH0_DOMAIN;
const REACT_APP_ALPHAEON_MERCHANT_AUTH0_CLIENTID = isViteApp() ? undefined : process.env.REACT_APP_ALPHAEON_MERCHANT_AUTH0_CLIENTID;
const REACT_APP_AUTH0_DOMAIN_CONSUMER = isViteApp() ? undefined : process.env.REACT_APP_AUTH0_DOMAIN_CONSUMER;
const REACT_APP_ALPHAEON_CONSUMER_AUTH0_CLIENTID = isViteApp() ? undefined : process.env.REACT_APP_ALPHAEON_CONSUMER_AUTH0_CLIENTID;
const REACT_APP_CONSUMER_TOKEN_SECRET = isViteApp() ? undefined : process.env.REACT_APP_CONSUMER_TOKEN_SECRET;
const REACT_APP_AUTH0_ADMIN_CLIENTID = isViteApp() ? undefined : process.env.REACT_APP_AUTH0_ADMIN_CLIENTID;
const REACT_APP_ALPHAEON_MERCHANT_MUX_API = isViteApp() ? undefined : process.env.REACT_APP_ALPHAEON_MERCHANT_MUX_API;
const REACT_APP_BUILDID_FETCH_INTERVAL = Number(isViteApp() ? undefined : process.env.REACT_APP_BUILDID_FETCH_INTERVAL ?? 60000); // milliseconds
// Retool Parameters
const REACT_APP_ALPHAEON_RETOOL_EMBED_URL = isViteApp() ? undefined : process.env.REACT_APP_ALPHAEON_RETOOL_EMBED_URL;
// CoveredCare-specific environment
const REACT_APP_COVERED_CARE_DOMAIN = isViteApp() ? undefined : process.env.REACT_APP_COVERED_CARE_DOMAIN ?? 'https://alphaeoncredit.apply.coveredcare.com'; // Note that this default is the non-production value
const RELATIONSHIPS = [{
  key: 'Brother',
  value: 'brother'
}, {
  key: 'Cousin',
  value: 'cousin'
}, {
  key: 'Daughter',
  value: 'daughter'
}, {
  key: 'Father',
  value: 'father'
}, {
  key: 'Grand Parent',
  value: 'grandparent'
}, {
  key: 'Husband',
  value: 'husband'
}, {
  key: 'Mother',
  value: 'mother'
}, {
  key: 'Other',
  value: 'other'
}, {
  key: 'Sister',
  value: 'sister'
}, {
  key: 'Son',
  value: 'son'
}, {
  key: 'Aunt',
  value: 'aunt'
}, {
  key: 'Uncle',
  value: 'uncle'
}, {
  key: 'Wife',
  value: 'wife'
}];
const CONTACT_NUMBER = '1-855-497-8176';
const TDD_TTY_NUMBER = '1-888-819-1918';
const AFF_NUMBER = '877-264-2143';
const RISK_NUMBER = '1-920-333-8481';
const SHARE_WITH_FAMILY_OPTIONS = [{
  key: 'Yes',
  value: 'yes'
}, {
  key: 'No',
  value: 'no'
}];
const REPORT_EMAIL = 'teamcredit@alphaeon.com';
const RISK_MESSAGE = `This account is under review. \
The account holder has been sent a text message and needs to verify information. \
Please check back once the account holder has completed the verification or call ${RISK_NUMBER} with any questions.`;
// Transaction status and allowed operations...
const TRANSACTION_STATUS = {
  APPROVED: 'approved',
  ENTERED: 'entered',
  FAILED: 'failed',
  SENT_FOR_SETTLEMENT: 'sent_for_settlement',
  SETTLED: 'settled',
  SETTLEMENT_ISSUE: 'settlement_issue',
  VOIDED: 'voided',
  SIGNED: 'signed',
  PENDING_SIGNATURE: 'pending_signature'
};
const REFUNDABLE_STATES = [TRANSACTION_STATUS.SENT_FOR_SETTLEMENT, TRANSACTION_STATUS.SETTLED];
const PENDING_STATES = [TRANSACTION_STATUS.SIGNED, TRANSACTION_STATUS.PENDING_SIGNATURE, TRANSACTION_STATUS.APPROVED];
const LOC_NEXT_DAY_PENDING_STATES = [TRANSACTION_STATUS.APPROVED, TRANSACTION_STATUS.SIGNED];
const VOIDABLE_STATES = [TRANSACTION_STATUS.APPROVED, TRANSACTION_STATUS.SIGNED, TRANSACTION_STATUS.PENDING_SIGNATURE];
const TRANSACTION_TYPE = {
  CHARGEBACK: 'chargeback',
  REFUND: 'refund',
  SALE: 'sale',
  LOAN: 'loan',
  LOAN_REFUND: 'loan_refund'
};
// Transaction types that return funds to an account against an earlier
// transaction. These cannot themselves be voided or refunded.
const RETURN_TRANSACTION_TYPES = [TRANSACTION_TYPE.CHARGEBACK, TRANSACTION_TYPE.LOAN_REFUND, TRANSACTION_TYPE.REFUND];
const DATE_SELECTION = {
  DATE_RANGE: 'date-range',
  MONTH_TO_DATE: 'month-to-date',
  PRIOR_MONTH: 'prior-month',
  YEAR_TO_DATE: 'year-to-date'
};
const APPLICATION_TRACKING = 'application-tracking';
const BANK_RECONCILIATION = 'bank-reconciliation';
const BANK_RECONCILIATION_V2 = 'bank-reconciliation-v2';
const CREDIT_AVAILABLE = 'credit-available';
const SALES = 'sales';
const DATE_FILTER_TYPE = [{
  key: 'MTD',
  value: DATE_SELECTION.MONTH_TO_DATE
}, {
  key: 'YTD',
  value: DATE_SELECTION.YEAR_TO_DATE
}, {
  key: 'Prior Month',
  value: DATE_SELECTION.PRIOR_MONTH
}, {
  key: 'Date Range',
  value: DATE_SELECTION.DATE_RANGE
}];
const REPORTS_START_OFFSET_DAYS = 30;
const REPORT_TYPES = [{
  label: 'Application Tracking',
  value: APPLICATION_TRACKING
}, {
  label: 'Bank Reconciliation',
  value: BANK_RECONCILIATION
}, {
  label: 'Bank Reconciliation Detailed View',
  value: BANK_RECONCILIATION_V2
}, {
  label: 'Credit Available',
  value: CREDIT_AVAILABLE
}, {
  label: 'Sales',
  value: SALES
}];
const PAGINATION_PAGE_SIZE = 10;
const FULL_ACCOUNT_ACCESS_OPTIONS = [{
  key: 'AUTHORIZED SIGNER',
  value: PERMISSION.IS_SIGNER
}];
const FULL_ACCOUNT_ACCESS_TOOLTIP = 'An authorized signer is an owner or officer of the business that has full access to the account including updating banking information for the practice. This person is authorized to make legally binding decisions for the practice.';
const ADMIN_PERMISSION_OPTIONS = [{
  key: 'MAY MANAGE USERS',
  value: PERMISSION.MANAGE_USERS
}, {
  key: 'MAY MANAGE PROGRAMS AND VIEW LOCATION MANAGEMENT',
  value: PERMISSION.MANAGE_PROGRAMS
}];
const PERMISSION_OPTIONS = [{
  key: 'MAY SUBMIT DASHBOARD APPLICATIONS',
  value: PERMISSION.SUBMIT_DASHBOARD_APPLICATIONS
}, {
  key: 'MAY SUBMIT ONE-TIME APPLICATIONS',
  value: PERMISSION.SUBMIT_PUSH_APPLICATIONS
}, {
  key: 'MAY PROCESS A SALE',
  value: PERMISSION.PROCESS_SALE
}, {
  key: 'MAY PROCESS A REFUND',
  value: PERMISSION.PROCESS_REFUND
}, {
  key: 'MAY PROCESS A VOID',
  value: PERMISSION.PROCESS_VOID
}, {
  key: 'MAY VIEW APPLICATION TRACKING REPORT',
  value: PERMISSION.VIEW_APPLICATION_TRACKING_REPORT
}, {
  key: 'MAY VIEW BANK RECONCILIATION REPORT',
  value: PERMISSION.VIEW_BANK_RECONCILIATION_REPORT
}, {
  key: 'MAY VIEW CREDIT AVAILABLE REPORT',
  value: PERMISSION.VIEW_CREDIT_AVAILABLE_REPORT
}, {
  key: 'MAY VIEW SALE REPORT',
  value: PERMISSION.VIEW_SALE_REPORT
}, {
  key: 'MAY ACCESS CALCULATOR',
  value: PERMISSION.CALCULATOR
}, {
  key: 'MAY ACCESS APPLICATION ACTIVITY TABLE',
  value: PERMISSION.APPLICATION_ACTIVITY_TABLE
}];
const USER_STATUS = [{
  key: 'Active (Can Login)',
  value: 'active'
}, {
  key: 'Inactive (Cannot Login)',
  value: 'inactive'
}];
const USER_ACTIVE_STATUS = [{
  key: 'Active',
  value: 'active'
}, {
  key: 'Inactive',
  value: 'inactive'
}];
// [Report Constants]------------------------------------------------------------
// NOTE: for each report, the number of columns must be the same between the summary
// and detail reports. Unneded columns are filled with empty ('') data.
const SALES_REPORT_SUMMARY_HEADERS = [{
  label: 'Location',
  key: 'column01'
}, {
  label: 'Total Refunds',
  key: 'column02'
}, {
  label: 'Total Sales',
  key: 'column03'
}, {
  label: '',
  key: 'column04'
}, {
  label: '',
  key: 'column05'
}, {
  label: '',
  key: 'column06'
}, {
  label: '',
  key: 'column07'
}, {
  label: '',
  key: 'column08'
}, {
  label: '',
  key: 'column09'
}, {
  label: '',
  key: 'column10'
}, {
  label: '',
  key: 'column11'
}, {
  label: '',
  key: 'column12'
}, {
  label: '',
  key: 'column13'
}];
const CREDIT_AVAILABLE_SUMMARY_HEADERS = [{
  label: 'Location',
  key: 'column01'
}, {
  label: 'Total Available Credit',
  key: 'column02'
}, {
  label: 'Total Credit Limit Outstanding',
  key: 'column03'
}, {
  label: '',
  key: 'column04'
}, {
  label: '',
  key: 'column05'
}, {
  label: '',
  key: 'column06'
}, {
  label: '',
  key: 'column07'
}, {
  label: '',
  key: 'column08'
}, {
  label: '',
  key: 'column09'
}, {
  label: '',
  key: 'column10'
}, {
  label: '',
  key: 'column11'
}, {
  label: '',
  key: 'column12'
}];
const EMPTY_SALES_REPORT_SUMMARY = {
  column01: '',
  column02: '',
  column03: '',
  column04: '',
  column05: '',
  column06: '',
  column07: '',
  column08: '',
  column09: '',
  column10: '',
  column11: '',
  column12: '',
  column13: ''
};
const EMPTY_CREDIT_AVAILABLE_REPORT_SUMMARY = {
  column01: '',
  column02: '',
  column03: '',
  column04: '',
  column05: '',
  column06: '',
  column07: '',
  column08: '',
  column09: '',
  column10: '',
  column11: '',
  column12: '',
  column13: ''
};
const SALES_REPORT_DETAIL_HEADER = {
  column01: 'Location',
  column02: 'Tran Date ',
  column03: 'Customer',
  column04: 'Account/ Loan # (Last 4)',
  column05: 'Auth Code',
  column06: 'Plan Name',
  column07: 'Plan No.',
  column08: 'Product Type',
  column09: 'Transaction Type',
  column10: 'Transaction Amount',
  column11: 'Status',
  column12: 'Associate',
  column13: 'Reference ID'
};
const CREDIT_AVAILABLE_DETAIL_HEADERS = {
  column01: 'Location',
  column02: 'Location #',
  column03: 'Customer',
  column04: 'Birth Month',
  column05: 'Address 1',
  column06: 'City',
  column07: 'State',
  column08: 'ZIP',
  column09: 'Account # Last 4',
  column10: 'Credit Limit',
  column11: 'Credit Available',
  column12: 'Last Purchase Date',
  column13: 'Credit Updated As Of'
};
const APPLICATION_REPORT_SUMMARY_HEADERS = [{
  label: 'Location',
  key: 'column01'
}, {
  label: 'Total Apps',
  key: 'column02'
}, {
  label: 'Approvals',
  key: 'column03'
}, {
  label: 'Declines',
  key: 'column04'
}, {
  label: 'Pending',
  key: 'column05'
}, {
  label: 'Duplicates',
  key: 'column06'
}, {
  label: 'Net App Volume',
  key: 'column07'
}, {
  label: 'Net Approval Rate',
  key: 'column08'
}, {
  label: '',
  key: 'column09'
}];
const EMPTY_APPLICATION_REPORT_SUMMARY = {
  column01: '',
  column02: '',
  column03: '',
  column04: '',
  column05: '',
  column06: '',
  column07: '',
  column08: '',
  column09: ''
};
const APPLICATION_REPORT_DETAIL_HEADER = {
  column01: 'Location',
  column02: 'Application Date',
  column03: 'Application ID',
  column04: 'Customer Name',
  column05: 'Product Type',
  column06: 'Status',
  column07: 'Credit Limit',
  column08: 'Account/ Loan # (Last 4)',
  column09: 'Associate'
};
const RECONCILIATION_REPORT_SUMMARY_HEADERS = [{
  label: 'Location',
  key: 'column01'
}, {
  label: 'Product Type',
  key: 'column02'
}, {
  label: 'Total Sales',
  key: 'column03'
}, {
  label: 'Total Refunds',
  key: 'column04'
}, {
  label: 'Total Credit Adjustments',
  key: 'column05'
}, {
  label: 'Total Debit Adjustments',
  key: 'column06'
}, {
  label: 'Total MDF ',
  key: 'column07'
}, {
  label: 'Total Settlement',
  key: 'column08'
}, {
  label: 'Post Date',
  key: 'column09'
}, {
  label: 'ACH Eff Date',
  key: 'column10'
}, {
  label: '',
  key: 'column11'
}, {
  label: '',
  key: 'column12'
}, {
  label: '',
  key: 'column13'
}, {
  label: '',
  key: 'column14'
}, {
  label: '',
  key: 'column15'
}, {
  label: '',
  key: 'column16'
}, {
  label: '',
  key: 'column17'
}, {
  label: '',
  key: 'column18'
}];
const EMPTY_RECONCILIATION_REPORT_SUMMARY_DETAIL = {
  column01: '',
  column02: '',
  column03: '',
  column04: '',
  column05: '',
  column06: '',
  column07: '',
  column08: '',
  column09: '',
  column10: '',
  column11: '',
  column12: '',
  column13: '',
  column14: '',
  column15: '',
  column16: '',
  column17: '',
  column18: ''
};
const RECONCILIATION_REPORT_DATA_HEADERS = {
  column01: 'Location',
  column02: 'Product Type',
  column03: 'Trans Date',
  column04: 'Customer',
  column05: 'Account/ Loan # (Last 4)',
  column06: 'Post Date',
  column07: 'Auth #',
  column08: 'Plan',
  column09: 'Plan #',
  column10: 'Credit Term',
  column11: 'Origin Code',
  column12: 'Trans Type',
  column13: 'Trans $',
  column14: 'MDF Fee',
  column15: 'MDF Rate 1',
  column16: 'MDF Rate 2',
  column17: 'Settlement $',
  column18: 'ACH Eff Date'
};
const RECONCILIATION_REPORT_V2_DATA_HEADERS = {
  column01: 'Location',
  column02: 'Product Type',
  column03: 'Trans Date',
  column04: 'Customer',
  column05: 'Account/ Loan # (Last 4)',
  column06: 'Plan',
  column07: 'Trans Type',
  column08: 'Trans $',
  column09: 'MDF Fee',
  column10: 'MDF Rate',
  column11: 'Settlement $',
  column12: 'ACH Eff Date',
  column13: 'Bank Acct',
  column14: 'Status',
  column15: 'Return Details',
  column16: 'ACH Details'
};
// ----------------------------------------------------------------------------
const MAX_DISPLAYED_SELECT_ITEMS = 6;
const MENU_HEIGHT = 35;
const PRIME_LENDERS = ['ADS', 'Imprint'];
const PRODUCT_TYPE = {
  ACCESS_LOAN: 'installment',
  AC_PRIME: 'line_of_credit'
};
const PRODUCT_TYPE_MAP = {
  installment: 'ACCESS',
  line_of_credit: 'AC CARD'
};
const PROGRAM_PRODUCT_TYPE_ADVANTAGE = 'advantage';
const PROGRAM_PRODUCT_TYPE_FLEX = 'flex';
const PROGRAM_PRODUCT_TYPE_FLEX_RECOURSE = 'flex_servicing';
const PROGRAM_PRODUCT_TYPE_FLEX_NEAR_PRIME = 'flex_near_prime';
const PROGRAM_PRODUCT_TYPE_MAP = {
  access: 'Access',
  ac_card: 'AC Card',
  advantage: 'Advantage',
  flex: 'Flex',
  flex_servicing: 'Flex Servicing',
  flex_near_prime: 'Flex NP'
};
const PROGRAM_PRODUCT_TYPE_TO_LENDER_NAME_MAP = new Map([['access', 'AFF'], ['ac_card', 'ADS'], ['advantage', 'Imprint'], ['flex', 'ACI'], ['flex_servicing', 'ACI'], ['flex_near_prime', 'ACI']]);
const LENDER_NAME_TO_PRODUCT_TYPE_MAP = new Map([['AFF', 'Access'], ['Imprint', 'Advantage'], ['ADS', 'AC Card'], ['ACI', 'Flex']]);
const PRODUCT_TYPE_BUTTON_CLASS_MAP = new Map([['AC Card', 'button-warn'], ['Access', 'button-warn-access'], ['Advantage', 'button-warn-advantage'], ['Flex', 'button-warn-alp-flex'], ['Unknown', 'button-warn']]);
const PRODUCT_TYPE_BUTTON_OUTLINE_CLASS_MAP = new Map([['AC Card', 'button-warn-outline'], ['Access', 'button-warn-access-outline'], ['Advantage', 'button-warn-advantage-outline'], ['Flex', 'button-warn-alp-flex-outline'], ['Unknown', 'button-warn-outline']]);
const TRANSACTION_TYPE_TO_PRODUCT_TYPE_MAP = {
  chargeback: PRODUCT_TYPE_MAP.line_of_credit,
  loan: PRODUCT_TYPE_MAP.installment,
  loan_refund: PRODUCT_TYPE_MAP.installment,
  refund: PRODUCT_TYPE_MAP.line_of_credit,
  sale: PRODUCT_TYPE_MAP.line_of_credit
};
const TRANSACTION_STATUS_MAP = {
  approved: 'Approved',
  pending_signature: 'Pending Signature',
  signed: 'Signed'
};
const TRANSACTION_FILTERS = {
  CUSTOMER_NAME: 'customer-name',
  ACCOUNT_NUMBER: 'account-number'
};
const FILTER_OPTIONS = [{
  key: 'Customer Name',
  value: TRANSACTION_FILTERS.CUSTOMER_NAME
}, {
  key: 'Account/Loan Number',
  value: TRANSACTION_FILTERS.ACCOUNT_NUMBER
}];
const APPLICATION_STATUS_OPTIONS = [{
  key: 'Pre-approved',
  value: 'Pre-approved'
}, {
  key: 'Approved',
  value: 'Approved'
}, {
  key: 'Contract Sign',
  value: 'Contract Sign'
}, {
  key: 'Down Payment',
  value: 'Down Payment'
}, {
  key: 'Declined',
  value: 'Declined'
}, {
  key: 'All',
  value: 'All'
}];
const POBOX_VARIATIONS = ['pobox', 'Po Box', 'Po box', 'po box', 'PO Box', 'P.O Box', 'P.O. Box', 'Post Office Box'];
const EST_TIMEZONE = 'America/New_York';
const PST_TIMEZONE = 'America/Los_Angeles';
const ACCESS_LOAN_DEFAULT_LIST = [{
  id: null,
  name: 'Plan A',
  description: 'Silver',
  locationPlanSettings: {
    isActive: false
  }
}, {
  id: null,
  name: 'Plan B',
  description: 'Gold',
  locationPlanSettings: {
    isActive: false
  }
}];
const ACCESS_LOAN_DISALLOWED_STATES = ['LA', 'MA', 'NE', 'NH', 'ND', 'OR', 'RI', 'VE'];
const DOWN_PAYMENT_METHODS = [{
  key: 'Card',
  value: 'card'
}, {
  key: 'Cash',
  value: 'cash'
}, {
  key: 'Check',
  value: 'check'
}, {
  key: 'Other',
  value: 'other'
}];
const DEFAULT_MAX_VALUE_FOR_PLANS = 10000000;
const PUSH_APPLICATION_SMS_TEMPLATE_NAME = 'push_prequalification';
const RESEND_APPLICATION_SMS_TEMPLATE_NAME = 'push_prequal_resend';
const BRAND_COLOR = {
  RED: '#D03127',
  // Red
  ORANGE: '#F17C31',
  // Orange
  PURPLE: '#792E9E',
  // Purple
  NAVY: '#32459B',
  // Navy
  GREEN: '#9AAF43' // Green
};
const FLEX_FINALIZE_PARENT_PATH = PATH.CREDIT_PORTAL + PATH.FLEX_FINALIZE;

function apiErrorToErrorMessage(errorCode, message) {
  if (isEmpty(errorCode)) return API_ERROR_MAP.UNKNOWN_ERROR;
  const errorMessage = API_ERROR_MAP[errorCode] ?? message ?? API_ERROR_MAP.UNKNOWN_ERROR;
  return `${errorMessage}`;
}

function approveTerms(...args) {
  const allTerms = flatten(args);
  return allTerms.map(({
    termContentId
  }) => ({
    termContentId,
    acceptedOn: new Date().toISOString()
  }));
}

const ABA_WEIGHTS = [3, 7, 1, 3, 7, 1, 3, 7, 1];
const ROUTING_NUMBER_LENGTH = 9;
class RoutingNumberError extends Error {
  reason;
  constructor(reason, message) {
    super(message);
    this.name = 'RoutingNumberError';
    this.reason = reason;
  }
}
/**
 * Throws a `RoutingNumberError` describing the first problem found, so callers
 * can decide which problems are worth surfacing to the user and when.
 */
function assertRoutingNumber(value) {
  if (!value) {
    throw new RoutingNumberError('required', 'Required');
  }
  if (!/^\d+$/.test(value)) {
    throw new RoutingNumberError('format', 'Enter a valid routing number.');
  }
  if (value.length !== ROUTING_NUMBER_LENGTH) {
    throw new RoutingNumberError('length', 'Enter a valid 9-digit routing number.');
  }
  const checksum = ABA_WEIGHTS.reduce((total, weight, index) => total + weight * Number(value[index]), 0);
  if (checksum % 10 !== 0) {
    throw new RoutingNumberError('checksum', 'Enter a valid routing number.');
  }
}

const calcTransaction = transactions => {
  const transTotal = transactions.reduce((acc, obj) => {
    if (obj) {
      // Refunds, chargebacks and loan refunds return funds, so they come off
      // the total rather than adding to it.
      if (RETURN_TRANSACTION_TYPES.includes(obj.transactionType)) {
        return acc - obj.amount;
      } else {
        return acc + obj.amount;
      }
    } else {
      return 0;
    }
  }, 0);
  return transTotal;
};

function camelToSnake(obj) {
  if (Array.isArray(obj)) {
    return obj.map(camelToSnake);
  } else if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(Object.entries(obj).map(([key, value]) => {
      let snakeKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
      if (snakeKey === 'ssn_last4') {
        snakeKey = 'ssn_last_4';
      }
      return [snakeKey, camelToSnake(value)];
    }));
  }
  return obj;
}
// Dont camelToSnake the request/response of these endpoints
const endpointExceptions = ['getCaseFileDownload', 'manualPostFiles', 'postAffWebhooksV1ContractsUpdateStatus', 'postEnrollmentsV1BankVerificationTokenDocumentsUpload'];
function camelizeResponse(baseQuery) {
  const baseQueryWithCamelize = async (args, api, extraOptions = {}) => {
    const isException = endpointExceptions.includes(api.endpoint);
    if (!isException) {
      const isFormData = typeof FormData !== 'undefined' && typeof args !== 'string' && args.body instanceof FormData;
      if (typeof args !== 'string' && args.body && !isFormData) {
        args = {
          ...args,
          body: camelToSnake(args.body)
        };
      }
    }
    const result = await baseQuery(args, api, extraOptions);
    if (result.data && !isException) {
      result.data = camelize$1(result.data);
    }
    return result;
  };
  return baseQueryWithCamelize;
}

const capitalizeFirstLetterInEachWord = str => {
  if (isEmpty(str)) return str;
  return str.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
};

function checkForNull(value) {
  if (isNil(value)) {
    return;
  }
  if (!isEmpty(value) && value.toLowerCase() !== 'null') {
    return value;
  }
  return;
}

function checkIfESTTimeisPast10Pm(date) {
  const todaysDate = new Date();
  const currentESTDate = utcToZonedTime(todaysDate, EST_TIMEZONE);
  const estDate = utcToZonedTime(new Date(date), EST_TIMEZONE);
  const sameDay = isSameDay(estDate, currentESTDate);
  const estHours = getHours(estDate);
  return estHours <= 22 && sameDay;
}

const composeValidators = (...validators) => value => validators.reduce((error, validator) => error || validator(value), undefined);

function contactFormInitialValues({
  email,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  sms = undefined
}) {
  // Favor SMS over email for the initial value
  // For now, disable considering SMS.
  const patientContactOptions = email;
  return {
    patientContactOptions
  };
}

function createDynamicColumns(data) {
  const index = data[0];
  const keysArray = Object.keys(index);
  function convertKeyNames(key) {
    const stringArr = key.split('');
    const result = [key[0].toUpperCase()];
    for (let i = 1; i < stringArr.length; i++) {
      if (stringArr[i] === stringArr[i].toUpperCase()) {
        result.push(' ', stringArr[i]);
      } else {
        result.push(stringArr[i]);
      }
    }
    return result.join('');
  }
  const columns = keysArray.map(key => {
    return {
      header: convertKeyNames(key),
      accessorKey: key,
      filterFn: 'filterAsString'
    };
  });
  return columns;
}

const dateRawSplit = ({
  dateString,
  order = [2, 0, 1],
  separator = '-'
}) => {
  const fullDate = dateString.split('/');
  const tmpDate = order.map((itm, idx) => {
    return `${fullDate[itm]}${idx < order.length - 1 ? separator : ''}`;
  });
  return tmpDate.join('');
};

function daysAgoInMilliseconds(daysAgo = 1) {
  return 3600 * 24 * daysAgo * 1000;
}

function determinePrequalificationError(error) {
  if (error?.response?.errorCode === 'prequalify_success_without_offers') {
    return {
      pathname: PRE_QUALIFICATION_ACCEPT_DECLINED_URL
    };
  }
}

// Computes the offset between the user's clock and server time so Auth0 can
// validate ID tokens against server-corrected time when the local clock is
// skewed. The offset is stored at module scope and exposed via `getServerNow`,
// which is passed as `nowProvider` to `<Auth0Provider>`. Nothing else in the
// app sees the correction — `Date.now` and `new Date()` are left untouched.
//
// On any failure (network error, timeout, missing/invalid `Date` header) the
// offset stays at 0 and `didServerTimeSyncFail()` returns `true`, so consumers
// can route the user to the device-time-incorrect error page.
const TIME_ENDPOINT_PATH = '/time';
const FETCH_TIMEOUT_MS = 2000;
let offsetMs = 0;
let syncFailed = false;
const didServerTimeSyncFail = () => syncFailed;
const getServerNow = () => Date.now() + offsetMs;
const syncServerTimeOffset = async () => {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
    const beforeMs = Date.now();
    const response = await fetch(`${window.location.origin}${TIME_ENDPOINT_PATH}`, {
      method: 'HEAD',
      mode: 'cors',
      cache: 'no-store',
      signal: controller.signal
    });
    const afterMs = Date.now();
    clearTimeout(timeoutId);
    const dateHeader = response.headers.get('date');
    if (!dateHeader) {
      syncFailed = true;
      return;
    }
    const serverMs = new Date(dateHeader).getTime();
    if (Number.isNaN(serverMs)) {
      syncFailed = true;
      return;
    }
    // The HTTP Date header is second-precision; compare against the midpoint
    // of the request window for sub-second accuracy.
    const localMidpointMs = beforeMs + (afterMs - beforeMs) / 2;
    offsetMs = serverMs - localMidpointMs;
  } catch {
    syncFailed = true;
  }
};

// Adapted from
// https://github.com/jorgegilramos/screen-dpi-detector
const dpiDetector = () => {
  const version = '1.0.0';
  const maxRatio = 8.0;
  const Detector = {
    _version: '',
    screens: {},
    prefix: '',
    devicePixelRatio: 0,
    dppx: 0,
    dpi: 0
  };
  Detector._version = version;
  // support for device-pixel-ratio: prefix for vendor, "" for native or undefined
  Detector.prefix = function () {
    if (window.matchMedia) {
      const prefixes = '-webkit-min- min--moz- -o-min- -ms-min- -khtml-min- '.split(' ');
      const mediaQuery = 'device-pixel-ratio:1.0';
      for (let i = 0; i < prefixes.length; i++) {
        if (window.matchMedia('(' + prefixes[i] + mediaQuery + ')').matches) {
          return prefixes[i];
        }
      }
    }
    return '';
  }();
  // device-pixel-ratio: Number of device pixels per CSS Pixel
  Detector.devicePixelRatio = function () {
    if (Detector.prefix) {
      let maxdpr = 1.0;
      let i = 1.0;
      for (; i <= maxRatio; i = parseFloat((i + 0.1).toFixed(1))) {
        if (window.matchMedia('(' + Detector.prefix + 'device-pixel-ratio:' + i.toFixed(1) + ')').matches === false) {
          break;
        } else {
          maxdpr = i;
        }
      }
      return maxdpr;
    }
    return 0;
  }();
  // dppx: Number of dots per px unit. 1dppx = 96dpi
  Detector.dppx = function () {
    if (window.matchMedia) {
      let maxdppx = 1.0;
      let i = 1.0;
      for (; i <= maxRatio; i = parseFloat((i + 0.1).toFixed(1))) {
        if (window.matchMedia('(min-resolution:' + i.toFixed(1) + 'dppx)').matches === false) {
          break;
        } else {
          maxdppx = i;
        }
      }
      return maxdppx;
    }
    return 0;
  }();
  // dpi: Dots per inch
  Detector.dpi = Detector.dppx && Detector.dppx * 96;
  const test = {
    ldpi: 120,
    mdpi: 160,
    hdpi: 240,
    xhdpi: 320,
    xxhdpi: 480,
    xxxhdpi: 640
  };
  for (const key in test) {
    if (test.hasOwnProperty(key)) {
      Detector.screens[key] = Detector.dpi >= test[key];
    }
  }
  return Detector;
};

function formatErrorMessage(error_message) {
  if (isNil(error_message)) return error_message;
  const mapping = {
    purchase_amount: 'Purchase Amount'
  };
  Object.keys(mapping).forEach(key => {
    error_message = error_message.replaceAll(key, mapping[key]);
  });
  return error_message;
}

function errorMessageFromFormErrors(errors, submitError) {
  // Redux-form processes and returns form submission errors as follows:
  //  + If form validation errors were raised without any external interaction
  //    (e.g., no API call) then "errors" will be set with a property set for each
  //    validation error and "submitError" will be undefined.
  //  + If form validation errors were raised due to custom validations generating
  //    a SubmissionError against a form field, both "errors" and "submitError"
  //    will be defined. Note that this case is differentiated by the content
  //    of the SubmissionError. See the external errors case below.
  //  + If external errors were raised, "submitError.meta.error.response.errorCode" is
  //    set and "submitError" will be defined with an SubmissionError instance whose
  //    "meta.error" property contains the contents of the HttpError.
  //
  // If validation errors have been raised, this function will return either the
  // overall form validation error (errors_error) if it has been set or a generic
  // message. Otherwise, if external errors were raised, this function will return
  // the value of apiErrorToErrorMessage() called with errors._error.
  const hasValidationErrors = !isEmpty(errors) && isEmpty(submitError);
  const hasCustomValidationErrors = submitError?.meta?.error?.name !== 'HttpError';
  const {
    _error: formWideError
  } = errors;
  // The following message is returned from the API infrastructure during form
  // submission when a server error occurs. Do not display this message to the user...
  if (formWideError === "Cannot read properties of undefined (reading 'status')") return;
  if (hasValidationErrors || hasCustomValidationErrors) {
    return formWideError ?? 'Please review the information provided and correct all form errors';
  }
  return apiErrorToErrorMessage(submitError?.meta?.error?.response?.errorCode, formatErrorMessage(submitError?.meta?.error?.response?.message));
}

/**
 * Extracts error code and description from Auth0 error sources.
 *
 * Auth0 errors can come from two sources:
 * 1. URL query parameters (e.g., from callback redirects)
 * 2. Auth0's error object from useAuth0() hook
 *
 * This function prioritizes URL parameters since they're more reliable
 * in cases where Auth0's error object might be empty (e.g., incognito hard refresh).
 *
 * @param urlError - Error code from URL query parameter
 * @param urlErrorDescription - Error description from URL query parameter
 * @param auth0Error - Error object from Auth0's useAuth0() hook (can be Error instance or plain object)
 * @returns Object with errorCode and errorDescription
 */
function extractAuth0Error(urlError, urlErrorDescription, auth0Error) {
  // Prefer URL params if available (more reliable)
  const errorCode = urlError || (auth0Error && typeof auth0Error === 'object' && 'error' in auth0Error ? auth0Error.error : null) || 'unknown_error';
  const errorDescription = urlErrorDescription || (auth0Error && typeof auth0Error === 'object' && 'error_description' in auth0Error ? auth0Error.error_description : null) || 'An authentication error occurred. Please try logging in again.';
  return {
    errorCode,
    errorDescription
  };
}

let errorCount = 0;
async function fetchApplicationBuildId() {
  if (!isNodeEnvProduction() || REACT_APP_BUILDID_FETCH_INTERVAL === 0) {
    return Promise.resolve(`DEFAULT APPLICATION VERSION`);
  }
  if (navigator.onLine) {
    try {
      const response = await fetch(`${APPLICATION_ROOT_URL}/buildHash`, {
        cache: 'no-store'
      });
      const buildHash = await response.json();
      const {
        hash: applicationBuildId
      } = buildHash;
      errorCount = 0;
      return applicationBuildId;
    } catch (error) {
      if (errorCount === 0) {
        ++errorCount;
        // eslint-disable-next-line no-console
        console.warn('[ERROR]: cannot obtain application buildId from server. ERROR: ', error?.message);
        // eslint-disable-next-line no-console
        console.info('[NOTE]: future errors will not be reported until exception is resolved.');
      }
    }
  } else {
    return Promise.resolve(null);
  }
}

function forceRedirect({
  to
}) {
  if (isEmpty(to)) throw new Error('forced redirect with empty redirect path');
  window.location.assign(to);
  return null;
}

function isNumberString(input) {
  return /^\d+$/.test(input);
}

function formatAccountNumber(value) {
  if (!value) {
    return '';
  }
  if (value.length >= 20) {
    return value.slice(0, value.length - 1);
  }
  if (isNumberString(value)) {
    return value;
  }
  return value.slice(0, value.length - 1);
}

// Formats a Number with the specified fixed number of decimal places using
// the in-effect locale.
const formatFixedNumber = (value, fixed = 0) => {
  if (isNil(value)) return 'N/A';
  return value.toLocaleString(undefined, {
    minimumFractionDigits: fixed,
    maximumFractionDigits: fixed
  });
};

const formatCurrency = (amount, decimals = 0) => {
  if (isNil(amount)) return 'N/A';
  if (typeof amount === 'string') amount = Number(amount);
  if (Number.isNaN(amount)) return 'N/A';
  const valueAsCurrency = `$${formatFixedNumber(Math.abs(amount), decimals)}`;
  if (valueAsCurrency === 'N/A') return valueAsCurrency;
  return amount < 0 ? `-${valueAsCurrency}` : valueAsCurrency;
};

function formatDateForAPI(date) {
  if (!date) return '';
  const match = date.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (match) return `${match[3]}-${match[1]}-${match[2]}`;
  return date;
}

const formatDateFromDB = (value, reverse) => {
  if (!value) {
    return '';
  }
  const onlyNumbers = value.replace(/[^\d]/g, '');
  if (onlyNumbers.length < 3) {
    return onlyNumbers;
  }
  if (onlyNumbers.length > 8) {
    return value.slice(0, value.length - 1);
  }
  if (onlyNumbers.length < 5) {
    return onlyNumbers.slice(0, 2) + '/' + onlyNumbers.slice(2);
  }
  if (reverse) {
    return onlyNumbers.slice(4) + '-' + onlyNumbers.slice(0, 2) + '-' + onlyNumbers.slice(2, 4);
  } else {
    return onlyNumbers.slice(4, 6) + '/' + onlyNumbers.slice(6) + '/' + onlyNumbers.slice(0, 4);
  }
};

const formatDateFromInputString = value => {
  if (!value) {
    return '';
  }
  const onlyNumbers = value.replace(/[^\d]/g, '');
  if (onlyNumbers.length < 3) {
    return onlyNumbers;
  }
  if (onlyNumbers.length > 8) {
    return value.slice(0, value.length - 1);
  }
  if (onlyNumbers.length < 5) {
    return onlyNumbers.slice(0, 2) + '/' + onlyNumbers.slice(2);
  }
  return onlyNumbers.slice(0, 2) + '/' + onlyNumbers.slice(2, 4) + '/' + onlyNumbers.slice(4);
};

const formatDateFromISOtoUSdateString = dateString => {
  if (isNil(dateString) || dateString === '') {
    return '';
  }
  const date = new Date(dateString);
  const offset = date.getTimezoneOffset();
  date.setMinutes(date.getMinutes() + offset);
  const convertedDate = date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric'
  });
  return convertedDate;
};

function formatEIN(value) {
  if (!value) {
    return '';
  }
  if (value.length >= 20) {
    return value.slice(0, value.length - 1);
  }
  if (/^[0-9\-]+$/.test(value)) {
    return value;
  }
  return value.slice(0, value.length - 1);
}

function formatEmailAddress(email) {
  if (isNil(email)) return '';
  if (!email.includes('@')) return email;
  const [user] = email.split('@');
  return `${user}@`;
}

const formatISODate = date => {
  if (isNil(date) || String(date).trim() === '') return '';
  return format(date, 'yyyy-MM-dd');
};

const parseUSDayMonthYearDate = dateString => {
  if (isEmpty(dateString)) return;
  if (dateString.length !== DATE_STRING_LENGTH) return;
  if (dateString.includes('-')) {
    return parse(dateString, 'yyyy-MM-dd', new Date());
  }
  return parse(dateString, 'MM/dd/yyyy', new Date());
};

const formatISODateString = dateString => {
  if (isEmpty(dateString)) return dateString;
  if (dateString.length !== DATE_STRING_LENGTH) return dateString;
  return formatISODate(parseUSDayMonthYearDate(dateString));
};

function formatISODateStringAsUSMonthDayYear(dateString) {
  if (isNil(dateString) || dateString.trim() === '') return;
  return format(parseISO(dateString), 'MM/dd/yyyy');
}

function formatLocation(locationName, locationNumber) {
  if (isNil(locationNumber)) return locationName;
  return `${locationName} (${locationNumber})`;
}

function formatNumber(value) {
  if (isNumberString(value)) {
    return value;
  }
  if (!value) {
    return '';
  }
  return value.slice(0, value.length - 1);
}

const formatPhoneNumber = str => {
  if (isEmpty(str)) return str;
  const cleaned = ('' + str).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return str;
};

function formatProductType(productType) {
  if (isNil(productType)) return '';
  return PRODUCT_TYPE_MAP[productType] ?? '';
}

function formatProgramProductType(productType) {
  if (isNil(productType)) return '';
  const response = PROGRAM_PRODUCT_TYPE_MAP[productType] ?? '';
  return response.toUpperCase();
}

const formatSSN = str => {
  if (isEmpty(str)) return str;
  return str?.slice(0, 3) + '-' + str?.slice(3, 5) + '-' + str?.slice(5, 9);
};

const ACRONYMS = ['AC', 'ACH', 'APR', 'DI', 'ID'];
const formatTitleCase = value => {
  if (!value) return '';
  return value.replace(/[A-Za-z0-9']+/g, word => {
    const upper = word.toUpperCase();
    if (ACRONYMS.includes(upper)) return upper;
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
};

const formatUpperCase = value => {
  return value && typeof value === 'string' ? value.toUpperCase() : '';
};

function getFullAddress(address) {
  if (isNil(address)) return 'N/A';
  const {
    street1,
    street2,
    city,
    state,
    zip
  } = address;
  const streetAddress = compact([checkForNull(street1), checkForNull(street2)]).join(' ');
  return `${streetAddress}, ${city}, ${state}, ${zip}`;
}

async function getApplicationBuildID() {
  if (!isNodeEnvProduction() || REACT_APP_BUILDID_FETCH_INTERVAL === 0) {
    return Promise.resolve('DEFAULT APPLICATION VERSION');
  }
  return await fetch(`${APPLICATION_ROOT_URL}/buildid`);
}

const getApplicationPath = application => {
  switch (application) {
    case APPLICATION.MERCHANT_PORTAL:
      return PATH.MERCHANT_PORTAL;
    case APPLICATION.CREDIT_PORTAL:
      return PATH.CREDIT_PORTAL;
    default:
      return PATH.ROOT;
  }
};

function getButtonClassnameForProduct(lenderName, variant) {
  if (variant === 'warn') {
    switch (lenderName) {
      case 'AFF':
        return 'button-warn-access';
      case 'Imprint':
        return 'button-warn-advantage';
      case 'ADS':
        return 'button-warn';
      case 'ACI':
        return 'button-warn-alp-flex';
      default:
        return 'button-warn';
    }
  } else if (variant === 'outline') {
    switch (lenderName) {
      case 'AFF':
        return 'button-warn-access-outline';
      case 'Imprint':
        return 'button-warn-advantage-outline';
      case 'ADS':
        return 'button-warn-outline';
      case 'ACI':
        return 'button-warn-alp-flex-outline';
      default:
        return 'button-warn-outline';
    }
  }
}

function getButtonColorForLender(lenderName) {
  switch (lenderName) {
    case 'ACI':
      return 'orange-flex';
    case 'AFF':
      return 'green';
    case 'Imprint':
      return 'purple';
    case 'ADS':
    default:
      return 'red';
  }
}

// From https://www.w3schools.com/js/js_cookies.asp
const getCookie = cname => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

const getFullName = value => {
  return value ? `${value.firstName} ${value.middleInitial ? value.middleInitial : ''} ${value.lastName}` : '';
};

const getIdentityTypeName = type => {
  return VERIFICATION_METHODS.find(item => item.value === type)?.key;
};

const getMonthFromDate = date => {
  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const currentMonth = date.getMonth();
  return monthNames[currentMonth];
};

function getReportDates({
  dateFilterType,
  fromDate = 0,
  toDate = 0
}) {
  const todaysDate = new Date();
  const startDate = dateFilterType === DATE_SELECTION.DATE_RANGE ? fromDate : startDateFromFilterType(todaysDate, dateFilterType);
  const endDate = dateFilterType === DATE_SELECTION.DATE_RANGE ? toDate : endDateFromFilterType(todaysDate, dateFilterType);
  return {
    startDate: formatISO(startDate, {
      representation: 'date'
    }),
    endDate: formatISO(endDate, {
      representation: 'date'
    })
  };
}
function endDateFromFilterType(todaysDate, dateFilterType) {
  switch (dateFilterType) {
    case DATE_SELECTION.PRIOR_MONTH:
      return endOfMonth(subMonths(todaysDate, 1));
    default:
      return todaysDate;
  }
}
function startDateFromFilterType(todaysDate, dateFilterType) {
  switch (dateFilterType) {
    case DATE_SELECTION.MONTH_TO_DATE:
      return startOfMonth(todaysDate);
    case DATE_SELECTION.PRIOR_MONTH:
      return startOfMonth(subMonths(todaysDate, 1));
    case DATE_SELECTION.YEAR_TO_DATE:
      return startOfYear(todaysDate);
    default:
      throw new Error('unknown date filter type in getReportDates');
  }
}

const getRTKQueryErrorMessage = error => {
  const errorData = error.data;
  return errorData?.message ?? '';
};

// Decamelize and stringify query params object
function stringifyQuery(query) {
  return stringify(decamelizeKeys(query), {
    skipNull: true
  });
}
function makeQueryPath(path, query) {
  if (!query) return path;
  return path + '?' + stringifyQuery(query);
}

const handleClientError = status => {
  const pathname = window.location.pathname;
  window.location.assign(makeQueryPath(PATH.CLIENT_ERROR, {
    [QUERY_KEY.APPLICATION]: getApplicationFromPath(pathname),
    [QUERY_KEY.STATUS]: status
  }));
};
const getApplicationFromPath = pathname => {
  // The application will typically be the first component of the pathname...
  const applicationName = first(pathname.slice(1).split('/'));
  return applicationName ? applicationName : '';
};

const handleServerError = () => {
  window.location.assign(PATH.SERVER_ERROR);
};

function clearCookieAndRedirect() {
  document.cookie = 'portalUser=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/portal';
  document.cookie = 'portalUser=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
  window.location.assign('/portal/login');
}
const isCookieValidMiddleware = () => next => action => {
  if (action && action.type && action.type.includes('internalPortalApi') && process.env.NODE_ENV !== 'test') {
    const cookie = getCookie('portalUser');
    if (!cookie) {
      return next(action);
    }
    let expiration;
    try {
      expiration = JSON.parse(cookie).expiration;
    } catch {
      clearCookieAndRedirect();
      return;
    }
    if (expiration < Date.now()) {
      clearCookieAndRedirect();
      return;
    }
  }
  return next(action);
};

function isPresent(value) {
  return !isEmpty(value);
}

const isRevolving = name => name.toLowerCase().includes('revolving');

/** Whether a URL resolves to an http(s) address, so it is safe to link to or open. Relative paths resolve against the current origin. */
function isSafeUrl(url) {
  try {
    const {
      protocol
    } = new URL(url, window.location.origin);
    return protocol === 'https:' || protocol === 'http:';
  } catch {
    return false;
  }
}

function locationOptions(locations) {
  return locations.map(({
    adsStoreNumber,
    locationId,
    name
  }) => ({
    key: `${name}, ${adsStoreNumber}`,
    value: locationId
  }));
}

function locationOptionsWithLabels(locations) {
  return locations.map(({
    adsStoreNumber,
    locationId,
    name
  }) => ({
    label: `${name}, ${adsStoreNumber}`,
    value: locationId.toString()
  }));
}

let getAccessTokenSilently = () => {};
const manageAuth0AccessToken = {
  getAccessTokenSilently: () => getAccessTokenSilently,
  setAccessTokenSilently: func => getAccessTokenSilently = func
};

function mapTransactionTypeToProductType(transactionType) {
  if (isNil(transactionType)) return false;
  return TRANSACTION_TYPE_TO_PRODUCT_TYPE_MAP[transactionType];
}

function mapTransactionTypeandInstrumentTypeToProductType(transactionType, instrumentType) {
  if (isNil(transactionType) || isNil(instrumentType)) return '';
  if (formatUpperCase(instrumentType).includes('INSTALLMENT')) {
    return PRODUCT_TYPE_MAP.installment;
  }
  const mappedProductType = mapTransactionTypeToProductType(transactionType);
  return mappedProductType ? mappedProductType : '';
}

function maskNumber(number, mask = '•') {
  const last4Digits = number.slice(-4);
  return last4Digits.padStart(number.length, mask);
}

function matchingDetailCriteria(achEffectiveDate, locationNumber, productType, postDate) {
  return function comparator(location) {
    return location.achEffectiveDate === achEffectiveDate && location.locationNumber === locationNumber && location.productType === productType && location.postDate === postDate;
  };
}

function operationPermitted(currentPermissions, requiredPermission, selectionCriteria = 'ALL') {
  if (isNil(currentPermissions)) return false;
  const checkPermissions = permission => {
    const isPermitted = currentPermissions[permission];
    return isNil(isPermitted) ? false : isPermitted;
  };
  if (isArray(requiredPermission)) {
    if (selectionCriteria === 'OR') {
      return requiredPermission.some(permission => checkPermissions(permission));
    }
    return requiredPermission.every(permission => checkPermissions(permission));
  }
  return checkPermissions(requiredPermission);
}

function operationNotPermitted(currentPermissions, requiredPermission, selectionCriteria) {
  return !operationPermitted(currentPermissions, requiredPermission, selectionCriteria);
}

function optionsFromLocations(locations) {
  return locations.map(({
    adsStoreNumber,
    name
  }, index) => ({
    label: `${name}, ${adsStoreNumber}`,
    storeNumber: adsStoreNumber,
    value: index
  }));
}

function ordinalSuffix(n) {
  if (n > 3 && n < 21) return 'th';
  switch (n % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}

const parseAccountNumber = value => {
  if (!value) {
    return '';
  }
  const onlyNumbersAndDash = value.replace(/[^A-Za-z0-9-]/g, '');
  if (onlyNumbersAndDash.length > 16) {
    return onlyNumbersAndDash.slice(0, 16);
  }
  return onlyNumbersAndDash;
};

const parseAmount = amount => {
  return Number(amount.replace(/[^\d.]/g, ''));
};

function parseAndCompareAsc(dateString1, dateString2) {
  if (isNil(dateString1)) return 1;
  if (isNil(dateString2)) return -1;
  const date1 = parseISO(dateString1);
  const date2 = parseISO(dateString2);
  return compareAsc(date1, date2);
}

const parseDateOfBirth = dateOfBirth => {
  const splitDob = dateOfBirth.split('/');
  return `${splitDob[2]}-${splitDob[0]}-${splitDob[1]}`;
};

const parsePhoneNumber = value => {
  if (!value) {
    return '';
  }
  const onlyNumbers = value.replace(/[^\d]/g, '');
  if (onlyNumbers.length < 1) {
    return '';
  }
  if (onlyNumbers.length < 3) {
    return '(' + onlyNumbers;
  }
  if (onlyNumbers.length === 3) {
    return '(' + onlyNumbers;
  }
  if (onlyNumbers.length < 7) {
    return '(' + onlyNumbers.slice(0, 3) + ') ' + onlyNumbers.slice(3);
  }
  if (onlyNumbers.length > 10) {
    return value.slice(0, value.length - 1);
  }
  return '(' + onlyNumbers.slice(0, 3) + ') ' + onlyNumbers.slice(3, 6) + '-' + onlyNumbers.slice(6);
};

function parseQuery(search) {
  if (!search) return {};
  return camelizeKeys(parse$1(search));
}

/**
 * Patches Node.prototype.removeChild and Node.prototype.insertBefore to
 * gracefully handle the case where browser extensions (Google Translate,
 * Grammarly, LastPass, etc.) modify DOM nodes managed by React.
 *
 * When extensions wrap or move text nodes, React's reconciler fails with:
 * "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node."
 *
 * Each patch calls the original native method first. Only when it throws a
 * NotFoundError (the specific DOMException for "not a child of this node")
 * does the fallback logic kick in. All other errors are rethrown so that
 * real DOM/React bugs still fail loudly.
 *
 * See: https://github.com/facebook/react/issues/11538
 *
 * Must be called BEFORE ReactDOM renders.
 */
function isNotFoundError(error) {
  return error instanceof DOMException && error.name === 'NotFoundError';
}
function patchDomForBrowserExtensions() {
  if (typeof window === 'undefined') return;
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    try {
      return originalRemoveChild.call(this, child);
    } catch (error) {
      if (!isNotFoundError(error)) throw error;
      // eslint-disable-next-line no-console
      console.warn('removeChild: node was not a child of the expected parent. ' + 'This is likely caused by a browser extension modifying the DOM.', {
        child,
        expectedParent: this,
        actualParent: child.parentNode
      });
      if (child.parentNode) {
        return originalRemoveChild.call(child.parentNode, child);
      }
      return child;
    }
  };
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    try {
      return originalInsertBefore.call(this, newNode, referenceNode);
    } catch (error) {
      if (!isNotFoundError(error)) throw error;
      // eslint-disable-next-line no-console
      console.warn('insertBefore: referenceNode was not a child of the expected parent. ' + 'This is likely caused by a browser extension modifying the DOM.', {
        newNode,
        referenceNode,
        expectedParent: this,
        actualParent: referenceNode?.parentNode
      });
      if (referenceNode && referenceNode.parentNode) {
        return originalInsertBefore.call(referenceNode.parentNode, newNode, referenceNode);
      }
      return originalInsertBefore.call(this, newNode, null);
    }
  };
}

const removeNonDigits = string => string ? string.replace(/\D/g, '') : '';

function reportAction(actionType, action) {
  const {
    actionData,
    ...rest
  } = action;
  HyperDX.addAction(actionType, {
    ...actionData,
    ...rest
  });
}

function removeTopItemFromStack(error) {
  let stackTrace = error.stack;
  if (!stackTrace) {
    return '';
  }
  //removing stacktrace lines from this file if we are creating the error here.
  const arr = stackTrace.split('\n');
  arr.splice(1, 2); //remove any lines from this file
  stackTrace = arr.join('\n');
  return stackTrace;
}
function FlashError(msg) {
  const error = new Error(msg);
  error.stack = removeTopItemFromStack(error);
  error.name = 'FlashError';
  return error;
}
function ReCaptchaError(msg) {
  const error = new Error(msg);
  error.name = 'ReCaptchaError';
  error.stack = removeTopItemFromStack(error);
  return error;
}
function BoundaryError(msg) {
  const error = new Error(msg);
  error.name = 'BoundaryError';
  error.stack = removeTopItemFromStack(error);
  return error;
}
const ERROR_TYPE_MAP = {
  flashError: FlashError,
  reCaptchaError: ReCaptchaError,
  boundaryError: BoundaryError
};
const buildHoneybadgerErrorDetails = (errorType, error, context) => {
  const enrichedContext = {
    ...context,
    data: error.errData,
    locationId: error.errLocationId,
    customer: error.errCustomer,
    funcName: error.funcName,
    location: error.errLocation
  };
  return {
    message: error.errMsg,
    name: errorType,
    action: error.errType,
    component: error.componentName,
    context: sanitizeData(enrichedContext)
  };
};
const sanitizeData = data => {
  if (typeof data === 'string') {
    // Remove SSN patterns (XXX-XX-XXXX or XXXXXXXXX)
    return data.replace(/\b\d{3}-?\d{2}-?\d{4}\b/g, '[SSN_REDACTED]');
  }
  if (Array.isArray(data)) {
    return data.map(sanitizeData);
  }
  if (data && typeof data === 'object') {
    const sanitized = {};
    for (const [key, value] of Object.entries(data)) {
      // Check for common SSN field names
      if (key.toLowerCase().includes('ssn') || key.toLowerCase().includes('social') || key.toLowerCase().includes('ssid')) {
        sanitized[key] = '[SSN_REDACTED]';
      } else {
        sanitized[key] = sanitizeData(value);
      }
    }
    return sanitized;
  }
  return data;
};
const buildHyperDXErrorDetails = error => {
  const details = {
    componentName: error.componentName,
    errType: error.errType,
    errURL: error.errURL,
    errMsg: error.errMsg,
    errCode: error.errCode,
    errData: error.errData,
    errLocationId: error.errLocationId,
    errCustomer: error.errCustomer,
    funcName: error.funcName,
    errLocation: error.errLocation,
    ...error.context
  };
  return sanitizeData(details);
};
function reportError(errorType, error, exception) {
  //Exclude these errors from Honeybadger logging
  const excludedErrors = ['Authorization link expired.',
  //This occurs when the prove VerifyLink page is refreshed
  "Network is unavailable. Are you sure you're connected to the network?",
  //This error is expected when the client disconnects
  'UnhandledPromiseRejectionWarning: Error: Login required',
  //This error comes from the auth0 react sdk
  'UnhandledPromiseRejectionWarning: Timeout',
  //This error comes from the honeybadger sdk
  "Cannot read properties of undefined (reading 'slice')",
  //This is a known issue with the cleave.js library that is used in the lp-form library which were moving away from
  'Load failed' //Safari's network error when fetch fails (user navigated away or lost connectivity)
  ];
  if (excludedErrors.some(err => exception?.message && typeof exception.message === 'string' && exception.message.includes(err))) {
    return;
  }
  HyperDX.addAction(errorType, buildHyperDXErrorDetails(error));
  if (exception) {
    Honeybadger.notify(exception, {
      context: error.context
    });
  } else {
    const errorClass = ERROR_TYPE_MAP[errorType] || Error;
    const honeybadgerErrorDetails = buildHoneybadgerErrorDetails(errorType, error, error.context);
    Honeybadger.notify(errorClass(error.errMsg), honeybadgerErrorDetails);
  }
}

function safeStringToJson(jsonString) {
  try {
    return JSON.parse(jsonString);
  } catch (ex) {
    return null;
  }
}

// Scroll to the top of the current page
function scrollToTop() {
  return window.scrollTo(0, 0);
}

function titleCase(s) {
  return s.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase());
}

function toAmount(stringValue) {
  if (typeof stringValue !== 'string') throw new Error('Non-string type in toAmount()');
  const number = stringValue.replace(/[^0-9.]/g, '');
  if (number) {
    return Number(number);
  }
  return 0;
}

function toNumber(stringValue) {
  if (typeof stringValue !== 'string') throw new Error('Non-string type in toNumber()');
  return Number(removeNonDigits(stringValue));
}

function validateAddress(value) {
  // Regex to match NON PO box - Same as validation in MC-951 in BE, here:
  // https://github.com/alphaeon-credit/merchant-mux/blob/main/app/api/extensions/validators.rb
  // from: https://stackoverflow.com/questions/52880617/regex-validate-address-string-to-not-contain-po-box-patterns
  const PO_BOX_REGEX = /^(?!.*(?:(.*((p|post)[-.\s]*(o|off|office)[-.\s]*(box|bin)[-.\s]*)|.*((p |post)[-.\s]*(box|bin)[-.\s]*)))).*$/i;
  const addressNotPoBox = !!value?.match(PO_BOX_REGEX);
  if (!!value && !addressNotPoBox) {
    return 'PO Box cannot be used in the address.';
  }
}

const validateCurrency = ({
  min,
  max
}) => value => {
  if (parseAmount(value) <= min.amount) {
    return min.message;
  }
  if (max && parseAmount(value) > max.amount) {
    return max.message;
  }
  return undefined;
};

function validDateOfBirth(dateOfBirth) {
  return (
    // Date of birth must be after 1900
    dateOfBirth && getYear(dateOfBirth) >= 1900 &&
    // Applicant must be 18 years or older
    differenceInYears(new Date(), dateOfBirth) >= 18
  );
}

function validateDateOfBirth(value) {
  if (!value) return undefined;
  const parsedDate = parse(value, 'MM/dd/yyyy', new Date());
  if (!isValid(parsedDate)) {
    return 'Please enter a valid date';
  }
  if (!validDateOfBirth(parsedDate)) {
    return 'Please enter a valid date of birth';
  }
  return undefined;
}

function validateDateOfBirthFormat(dateOfBirth) {
  if (!dateOfBirth) return undefined;
  const isComplete = /^\d{2}\/\d{2}\/[1-9]\d{3}$/.test(dateOfBirth);
  if (!isComplete || !isValid(parseUSDayMonthYearDate(dateOfBirth))) {
    return 'Enter the full date as MM/DD/YYYY';
  }
  return undefined;
}

function validateEIN(value) {
  if (!value) {
    return 'Required';
  }
  if (!/^\d{2}-\d{7}$/.test(value)) {
    return 'Must be in the format XX-XXXXXXX.';
  }
}

/**
 * @name validateEmail
 * @param value
 * @returns
 */
const validateEmail = value => {
  // This is very basic and does not check for domain e.g. (.com)
  const pattern = /(.+)@(.+){2,}\.(.+){2,}/; // https://stackoverflow.com/questions/4964691/super-simple-email-validation-with-javascript
  if (value && pattern.test(value)) {
    return;
  } else {
    return 'Invalid email address';
  }
};
/**
 * @name validateSSN
 * @param value
 * @returns
 */
const validateSSN = value => {
  const pattern = /^(?!000|666)[0-8][0-9]{2}(?!00)[0-9]{2}(?!0000)[0-9]{4}$/; // https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s12.html
  if (value && value.match(pattern)) {
    return;
  } else {
    return 'Invalid social security number';
  }
};
/**
 * @name validatePhoneNumber
 * @param value
 * @returns
 */
const validatePhoneNumber = value => {
  if (value && String(value).trim() === '') {
    return 'Please enter a phone number'; // Check empty strings (spaces)
  }
  const valueFmt = removeNonDigits(String(value)); // Remove all non-digits
  if (valueFmt && valueFmt.trim() === '') {
    return 'Please enter a phone number'; // Recheck for blanks and trim
  }
  if (valueFmt === '') {
    return 'Please enter a phone number'; // Recheck with just blank
  }
  // Check North American #'s
  const pattern = /^\(?([2-9][0-8][0-9])\)?[-.●]?([2-9][0-9]{2})[-.●]?([0-9]{4})$/; // https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s02.html
  if (valueFmt && !valueFmt.match(pattern)) return 'Invalid phone number';
  // Basic check for Area Codes and common abuse numbers
  if (!checkRealPhoneNumber(valueFmt)) {
    return 'Phone Number Is Not Valid';
  }
  // Passes
  return;
};
/**
 * @name LIST_AREA_CODES
 * @description https://www.nationalnanpa.com/enas/geoAreaCodeNumberReport.do
 */
const LIST_AREA_CODES = [201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 212, 213, 214, 215, 216, 217, 218, 219, 220, 223, 224, 225, 226, 227, 228, 229, 231, 234, 236, 239, 240, 242, 246, 248, 249, 250, 251, 252, 253, 254, 256, 260, 262, 263, 264, 267, 268, 269, 270, 272, 274, 276, 279, 281, 283, 284, 289, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 323, 325, 326, 329, 330, 331, 332, 334, 336, 337, 339, 340, 341, 343, 345, 346, 347, 350, 351, 352, 353, 354, 360, 361, 363, 364, 365, 367, 368, 369, 380, 382, 385, 386, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 412, 413, 414, 415, 416, 417, 418, 419, 423, 424, 425, 428, 430, 431, 432, 434, 435, 437, 438, 440, 441, 442, 443, 445, 447, 448, 450, 458, 463, 464, 468, 469, 470, 472, 473, 474, 475, 478, 479, 480, 484, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 512, 513, 514, 515, 516, 517, 518, 519, 520, 530, 531, 534, 539, 540, 541, 548, 551, 557, 559, 561, 562, 563, 564, 567, 570, 571, 572, 573, 574, 575, 579, 580, 581, 582, 584, 585, 586, 587, 601, 602, 603, 604, 605, 606, 607, 608, 609, 610, 612, 613, 614, 615, 616, 617, 618, 619, 620, 623, 624, 626, 628, 629, 630, 631, 636, 639, 640, 641, 645, 646, 647, 649, 650, 651, 656, 657, 658, 659, 660, 661, 662, 664, 667, 669, 670, 671, 672, 678, 680, 681, 682, 683, 684, 689, 701, 702, 703, 704, 705, 706, 707, 708, 709, 712, 713, 714, 715, 716, 717, 718, 719, 720, 721, 724, 725, 726, 727, 728, 730, 731, 732, 734, 737, 740, 742, 743, 747, 753, 754, 757, 758, 760, 762, 763, 765, 767, 769, 770, 771, 772, 773, 774, 775, 778, 779, 780, 781, 782, 784, 785, 786, 787, 801, 802, 803, 804, 805, 806, 807, 808, 809, 810, 812, 813, 814, 815, 816, 817, 818, 819, 820, 825, 826, 828, 829, 830, 831, 832, 835, 838, 839, 840, 843, 845, 847, 848, 849, 850, 854, 856, 857, 858, 859, 860, 861, 862, 863, 864, 865, 867, 868, 869, 870, 872, 873, 876, 878, 901, 902, 903, 904, 905, 906, 907, 908, 909, 910, 912, 913, 914, 915, 916, 917, 918, 919, 920, 925, 928, 929, 930, 931, 934, 936, 937, 938, 939, 940, 941, 943, 945, 947, 948, 949, 951, 952, 954, 956, 959, 970, 971, 972, 973, 975, 978, 979, 980, 983, 984, 985, 986, 989];
/**
 * @name checkRealPhoneNumber
 * @description This is taken and adapted from this old small lib
 * @returns boolean
 */
const checkRealPhoneNumber = phone => {
  // size must be 10
  if (phone.length != 10) {
    return false;
  }
  // split it by parts
  const area_code = Number(phone.substring(0, 3));
  const exchange_code = phone.substring(3, 6);
  const station_code = phone.substring(6, 10);
  if (LIST_AREA_CODES.indexOf(area_code) < 0) {
    return false;
  }
  // exchange code sanity check: cannot end in two 1's
  if (exchange_code.substring(1) == '11') {
    return false;
  }
  // this is a funky exchange code
  if (exchange_code == '555') {
    // directory assistance and national use
    if (station_code == '1212' || station_code == '4334') {
      return false;
    }
    // fictitious numbers
    if (station_code[0] == '0') {
      const station_code_number = Number(station_code);
      if (station_code_number >= 100 && station_code_number <= 199) {
        return false;
      }
    }
  }
  // eeeeyy
  return true;
};

const validateIdExpirationDate = value => {
  if (!value) return undefined;
  const date = new Date(value);
  if (value.length !== 0 && value.length !== 10 || isNaN(date.getTime())) {
    return 'Expected format should be mm/dd/yyyy';
  }
  if (date.toISOString() < new Date().toISOString()) {
    return 'ID Expiration Date must be in the future';
  }
  return undefined;
};

const validateLength = (minLength, maxLength, message = 'Invalid Length') => value => {
  if (value.length > maxLength || value.length < minLength) {
    return message;
  }
};

function validateName(value) {
  return value && /^[a-z ,.'-]+$/i.test(value) ? undefined : 'Invalid characters';
}

function validateRequired(value) {
  return value ? undefined : 'Required';
}

function validateRoutingNumber(value) {
  if (!value) {
    return 'Required';
  }
  if (value.length !== 9) {
    return 'Enter a valid 9-digit routing number.';
  }
}

/**
 * @name windowOpenAndPrint
 * @type Function
 * @param {string|URL|undefined} pdfWindowURL url to load the PDF into
 * @param {boolean|undefined} sameWindow whether to open the PDF in the same window
 * @param {boolean|undefined} print whether to print the PDF
 * @return
 */
const windowOpenAndPrint = (pdfWindowURL, sameWindow = false, print = true) => {
  const _target = sameWindow ? '_self' : isIpad() ? '_top' : '_blank';
  const pdfWindow = window.open(pdfWindowURL, _target, 'noopener');
  print && pdfWindow && pdfWindow.print();
};
/**
 * @name isIpad
 * @description Checks for the latest way to detect iPads ref: https://stackoverflow.com/a/64559209
 *              Security issues with target='_blank' https://www.js-craft.io/blog/window-open-and-target_blank-have-a-security-vulnerability/
 * @returns {boolean}
 */
const isIpad = () => navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0 || navigator.platform === 'iPad';

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = React__default,
    k = Symbol.for("react.element"),
    l = Symbol.for("react.fragment"),
    m = Object.prototype.hasOwnProperty,
    n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    p = {
      key: true,
      ref: true,
      __self: true,
      __source: true
    };
  function q(c, a, g) {
    var b,
      d = {},
      e = null,
      h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a) m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
    return {
      $$typeof: k,
      type: c,
      key: e,
      ref: h,
      props: d,
      _owner: n.current
    };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function () {

      var React = React__default;

      // ATTENTION
      // When adding new symbols to this file,
      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
      // The Symbol used to tag the ReactElement-like types.
      var REACT_ELEMENT_TYPE = Symbol.for('react.element');
      var REACT_PORTAL_TYPE = Symbol.for('react.portal');
      var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
      var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
      var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
      var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
      var REACT_CONTEXT_TYPE = Symbol.for('react.context');
      var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
      var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
      var REACT_MEMO_TYPE = Symbol.for('react.memo');
      var REACT_LAZY_TYPE = Symbol.for('react.lazy');
      var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator';
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning('error', format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum();
          if (stack !== '') {
            format += '%s';
            args = args.concat([stack]);
          } // eslint-disable-next-line react-internal/safe-string-coercion

          var argsWithFormat = args.map(function (item) {
            return String(item);
          }); // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610
          // eslint-disable-next-line react-internal/no-production-logging

          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }

      // -----------------------------------------------------------------------------

      var enableScopeAPI = false; // Experimental Create Event Handle API.
      var enableCacheElement = false;
      var enableTransitionTracing = false; // No known bugs, but needs performance testing

      var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
      // stuff. Intended to enable React core members to more easily debug scheduling
      // issues in DEV builds.

      var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
      }
      function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') {
          return true;
        } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).

        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === 'object' && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE ||
          // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
      } // Keep in sync with react-reconciler/getComponentNameFromFiber

      function getContextName(type) {
        return type.displayName || 'Context';
      } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.

      function getComponentNameFromType(type) {
        if (type == null) {
          // Host root, text node or just invalid type.
          return null;
        }
        {
          if (typeof type.tag === 'number') {
            error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
          }
        }
        if (typeof type === 'function') {
          return type.displayName || type.name || null;
        }
        if (typeof type === 'string') {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return 'Fragment';
          case REACT_PORTAL_TYPE:
            return 'Portal';
          case REACT_PROFILER_TYPE:
            return 'Profiler';
          case REACT_STRICT_MODE_TYPE:
            return 'StrictMode';
          case REACT_SUSPENSE_TYPE:
            return 'Suspense';
          case REACT_SUSPENSE_LIST_TYPE:
            return 'SuspenseList';
        }
        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || 'Memo';
            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                  return getComponentNameFromType(init(payload));
                } catch (x) {
                  return null;
                }
              }

            // eslint-disable-next-line no-fallthrough
          }
        }
        return null;
      }
      var assign = Object.assign;

      // Helpers to patch console.logs to avoid logging during side-effect free
      // replaying on render function. This currently only patches the object
      // lazily which won't cover if the log function was extracted eagerly.
      // We could also eagerly patch the method.
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {}
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            }; // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
            /* eslint-enable react-internal/no-production-logging */
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            }; // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
            /* eslint-enable react-internal/no-production-logging */
          }
          if (disabledDepth < 0) {
            error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === undefined) {
            // Extract the VM specific prefix used by each line.
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || '';
            }
          } // We use the prefix to ensure our stacks line up with native stack frames.

          return '\n' + prefix + name;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) {
          return '';
        }
        {
          var frame = componentFrameCache.get(fn);
          if (frame !== undefined) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
          // for warnings.

          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          // This should throw.
          if (construct) {
            // Something should be setting the props in the constructor.
            var Fake = function () {
              throw Error();
            }; // $FlowFixMe

            Object.defineProperty(Fake.prototype, 'props', {
              set: function () {
                // We use a throwing setter instead of frozen or non-writable props
                // because that won't throw in a non-strict mode function.
                throw Error();
              }
            });
            if (typeof Reflect === 'object' && Reflect.construct) {
              // We construct a different control for this case to include any extra
              // frames added by the construct call.
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }
            fn();
          }
        } catch (sample) {
          // This is inlined manually because closure doesn't do it for us.
          if (sample && control && typeof sample.stack === 'string') {
            // This extracts the first frame from the sample that isn't also in the control.
            // Skipping one frame that we assume is the frame that calls the two.
            var sampleLines = sample.stack.split('\n');
            var controlLines = control.stack.split('\n');
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;
            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              // We expect at least one stack frame to be shared.
              // Typically this will be the root most one. However, stack frames may be
              // cut off due to maximum stack limits. In this case, one maybe cut off
              // earlier than the other. We assume that the sample is longer or the same
              // and there for cut off earlier. So we should find the root most frame in
              // the sample somewhere in the control.
              c--;
            }
            for (; s >= 1 && c >= 0; s--, c--) {
              // Next we find the first one that isn't the same which should be the
              // frame that called our sample function and the control.
              if (sampleLines[s] !== controlLines[c]) {
                // In V8, the first line is describing the message but other VMs don't.
                // If we're about to return the first line, and the control is also on the same
                // line, that's a pretty good indicator that our sample threw at same line as
                // the control. I.e. before we entered the sample frame. So we ignore this result.
                // This can happen if you passed a class to function component, or non-function.
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--; // We may still have similar intermediate frames from the construct call.
                    // The next one that isn't the same should be our match though.

                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                      var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                      // but we have a user-provided "displayName"
                      // splice it in to make the stack more readable.

                      if (fn.displayName && _frame.includes('<anonymous>')) {
                        _frame = _frame.replace('<anonymous>', fn.displayName);
                      }
                      {
                        if (typeof fn === 'function') {
                          componentFrameCache.set(fn, _frame);
                        }
                      } // Return the line we found.

                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.

        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        {
          if (typeof fn === 'function') {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }
      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return '';
        }
        if (typeof type === 'function') {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === 'string') {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame('Suspense');
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              // Memo may contain any component type so we recursively resolve it.
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                  // Lazy may contain any component type so we recursively resolve it.
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
              }
          }
        }
        return '';
      }
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          // $FlowFixMe This is okay but Flow doesn't know it.
          var has = Function.call.bind(hasOwnProperty);
          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
              // fail the render phase where it didn't fail before. So we log it.
              // After these have been cleaned up, we'll let them throw.

              try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                  // eslint-disable-next-line react-internal/prod-error-codes
                  var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                  err.name = 'Invariant Violation';
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

      function isArray(a) {
        return isArrayImpl(a);
      }

      /*
       * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
       * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
       *
       * The functions in this module will throw an easier-to-understand,
       * easier-to-debug exception with a clear errors message message explaining the
       * problem. (Instead of a confusing exception thrown inside the implementation
       * of the `value` object).
       */
      // $FlowFixMe only called in DEV, so void return is not possible.
      function typeName(value) {
        {
          // toStringTag is needed for namespaced types like Temporal.Instant
          var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
          return type;
        }
      } // $FlowFixMe only called in DEV, so void return is not possible.

      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== undefined;
      }
      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== undefined;
      }
      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === 'string' && ReactCurrentOwner.current && self) ;
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function () {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function () {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      /**
       * Factory method to create a new React element. This no longer adheres to
       * the class pattern, so do not use new to call it. Also, instanceof check
       * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
       * if something is a React Element.
       *
       * @param {*} type
       * @param {*} props
       * @param {*} key
       * @param {string|object} ref
       * @param {*} owner
       * @param {*} self A *temporary* helper to detect places where `this` is
       * different from the `owner` when React.createElement is called, so that we
       * can warn. We want to get rid of owner and replace string `ref`s with arrow
       * functions, and as long as `this` and owner are the same, there will be no
       * change in behavior.
       * @param {*} source An annotation object (added by a transpiler or otherwise)
       * indicating filename, line number, and/or other information.
       * @internal
       */

      var ReactElement = function (type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type: type,
          key: key,
          ref: ref,
          props: props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          // The validation flag is currently mutative. We put it on
          // an external backing store so that we can freeze the whole object.
          // This can be replaced with a WeakMap once they are implemented in
          // commonly used development environments.
          element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
          // the validation flag non-enumerable (where possible, which should
          // include every environment we run tests in), so the test framework
          // ignores it.

          Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          }); // self and source are DEV only properties.

          Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          }); // Two elements created in two different places should be considered
          // equal for testing purposes and therefore we hide it from enumeration.

          Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      /**
       * https://github.com/reactjs/rfcs/pull/107
       * @param {*} type
       * @param {object} props
       * @param {string} key
       */

      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName; // Reserved names are extracted

          var props = {};
          var key = null;
          var ref = null; // Currently, key can be spread in as a prop. This causes a potential
          // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
          // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
          // but as an intermediary step, we will use jsxDEV for everything except
          // <div {...props} key="Hi" />, because we aren't currently able to tell if
          // key is explicitly declared to be undefined or not.

          if (maybeKey !== undefined) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = '' + maybeKey;
          }
          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = '' + config.key;
          }
          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          } // Remaining properties are added to a new props object

          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          } // Resolve default props

          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === undefined) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      /**
       * Verifies the object is a ReactElement.
       * See https://reactjs.org/docs/react-api.html#isvalidelement
       * @param {?object} object
       * @return {boolean} True if `object` is a ReactElement.
       * @final
       */

      function isValidElement(object) {
        {
          return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) {
              return '\n\nCheck the render method of `' + name + '`.';
            }
          }
          return '';
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          return '';
        }
      }
      /**
       * Warn if there's no key explicitly set on dynamic arrays of children or
       * object keys are not valid. This allows us to keep track of children between
       * updates.
       */

      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      /**
       * Warn if the element doesn't have an explicit key assigned to it.
       * This element is in an array. The array could grow and shrink or be
       * reordered. All children that haven't already been validated are required to
       * have a "key" property assigned to it. Error statuses are cached so a warning
       * will only be shown once.
       *
       * @internal
       * @param {ReactElement} element Element that requires a key.
       * @param {*} parentType element's parent's type.
       */

      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
          // property, it may be the creator of the child that's responsible for
          // assigning it a key.

          var childOwner = '';
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            // Give the component that originally created this child.
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      /**
       * Ensure that every element either is passed in a static location, in an
       * array with an explicit keys property defined, or in an object literal
       * with valid key property.
       *
       * @internal
       * @param {ReactNode} node Statically passed child of any type.
       * @param {*} parentType node's parent's type.
       */

      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== 'object') {
            return;
          }
          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            // This element was passed in a valid location.
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === 'function') {
              // Entry iterators used to provide implicit keys,
              // but now we print a separate warning for them later.
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      /**
       * Given an element, validate that its props follow the propTypes definition,
       * provided by the type.
       *
       * @param {ReactElement} element
       */

      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === undefined || typeof type === 'string') {
            return;
          }
          var propTypes;
          if (typeof type === 'function') {
            propTypes = type.propTypes;
          } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE ||
          // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }
          if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
          } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

            var _name = getComponentNameFromType(type);
            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
          }
          if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
            error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
          }
        }
      }
      /**
       * Given a fragment, validate that it can only be provided with fragment props
       * @param {ReactElement} fragment
       */

      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== 'children' && key !== 'key') {
              setCurrentlyValidatingElement$1(fragment);
              error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
          // succeed and there will likely be errors in render.

          if (!validType) {
            var info = '';
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
              info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum();
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = 'null';
            } else if (isArray(type)) {
              typeString = 'array';
            } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
              info = ' Did you accidentally export a JSX literal instead of a component?';
            } else {
              typeString = typeof type;
            }
            error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
          // TODO: Drop this when these are no longer allowed as the type argument.

          if (element == null) {
            return element;
          } // Skip key warning if the type isn't valid since our key validation logic
          // doesn't expect a non-string/function type and can throw confusing errors.
          // We don't want exception behavior to differ between dev and prod.
          // (Rendering will throw with a helpful message and as soon as the type is
          // fixed, the key warnings will appear.)

          if (validType) {
            var children = props.children;
            if (children !== undefined) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      } // These two functions exist to still get child warnings in dev
      // even with the prod transform. This means that jsxDEV is purely
      // opt-in behavior for better messages but that we won't stop
      // giving you warnings if you use production apis.

      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
      // for now we can ship identical prod functions

      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }
  return reactJsxRuntime_development;
}

var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  hasRequiredJsxRuntime = 1;
  if (process.env.NODE_ENV === 'production') {
    jsxRuntime.exports = requireReactJsxRuntime_production_min();
  } else {
    jsxRuntime.exports = requireReactJsxRuntime_development();
  }
  return jsxRuntime.exports;
}

var jsxRuntimeExports = requireJsxRuntime();

const GET_PROPOSED_ENROLLMENT_DATA_CHANGES = [{
  id: 183,
  bank_name: 'Chase',
  practice_name: 'Core Surgery Center Inc',
  legal_business_name: 'Core Surgery Center Inc',
  legal_entity_type: 'Corporation',
  federal_tax_id: '423424242',
  routing_number: '123456789',
  account_number: '987654321',
  status: 'created',
  comment: null,
  files: []
}];
const GET_BANK_NAME = {
  name: 'PH Bank',
  details: {}
};

var mockData = /*#__PURE__*/Object.freeze({
    __proto__: null,
    GET_BANK_NAME: GET_BANK_NAME,
    GET_PROPOSED_ENROLLMENT_DATA_CHANGES: GET_PROPOSED_ENROLLMENT_DATA_CHANGES
});

function withApiAuth(actionCreatorMap) {
  if (process.env.STORYBOOK_RUNNING === 'true') {
    return Component => {
      function WrappedComponent({
        ...rest
      }) {
        const actionCreatorWithAuth = async (actionCreator, ...args) => {
          const accessToken = '12345';
          if (actionCreator && actionCreator.hasOwnProperty('type')) {
            const actionList = {
              actions: {
                ...actionCreator(...args, accessToken)
              },
              type: actionCreator(...args, accessToken).type
            };
            const actionObj = Object.getOwnPropertySymbols(actionList.actions).map(s => actionList.actions[s]).at(0);
            const tmpData = {
              ...mockData
            };
            return new Promise(resolve => {
              const tmpType = actionObj.type;
              const returnData = tmpData[tmpType];
              resolve(returnData);
            });
          } else {
            return new Promise(reject => {
              reject(null);
            });
          }
        };
        const mappedActionCreators = mapValues(actionCreatorMap, actionValue => (...args) => {
          return actionCreatorWithAuth(actionValue, ...args);
        });
        return jsxRuntimeExports.jsx(Component, {
          ...mappedActionCreators,
          ...rest
        });
      }
      WrappedComponent.displayName = `withApiAuth(${Component.displayName || Component.name})`;
      return WrappedComponent;
    };
  } else {
    return Component => {
      function WrappedComponent({
        ...rest
      }) {
        const dispatch = useDispatch();
        const {
          getAccessTokenSilently
        } = useAuth0();
        const actionCreatorWithAuth = async (actionCreator, ...args) => {
          const accessToken = await getAccessTokenSilently();
          const actionObj = actionCreator(...args, accessToken);
          const dispatchObj = await dispatch(actionObj);
          /**
           * DEBUG REDUX ACTIONS/DISPATCH
           */
          if (!isNodeEnvProduction() && String(process.env.REACT_APP_REDUX_API_DEBUG) === 'true') {
            if (actionCreator && actionCreator.hasOwnProperty('type')) {
              const actionList = {
                actions: {
                  ...actionCreator(...args, accessToken)
                },
                type: actionCreator(...args, accessToken).type
              };
              const actionObj = Object.getOwnPropertySymbols(actionList.actions).map(s => actionList.actions[s]).at(0);
              /* eslint-disable no-console */
              console.info('action: ', actionObj.type);
              /* eslint-disable no-console */
              console.info('resp: ', dispatchObj);
            }
          }
          /**
           * END DEBUG
           */
          // Return Dispatch (don't forget)
          return dispatchObj;
        };
        const mappedActionCreators = mapValues(actionCreatorMap, actionValue => (...args) => actionCreatorWithAuth(actionValue, ...args));
        return jsxRuntimeExports.jsx(Component, {
          ...mappedActionCreators,
          ...rest
        });
      }
      WrappedComponent.displayName = `withApiAuth(${Component.displayName || Component.name})`;
      return WrappedComponent;
    };
  }
}

function withGoogleAuth(actionCreatorMap) {
  if (process.env.STORYBOOK_RUNNING === 'true') {
    return Component => {
      function WrappedComponent({
        ...rest
      }) {
        const actionCreatorWithAuth = async (actionCreator, ...args) => {
          const accessToken = '12345';
          if (actionCreator && actionCreator.hasOwnProperty('type')) {
            const actionList = {
              actions: {
                ...actionCreator(...args, accessToken)
              },
              type: actionCreator(...args, accessToken).type
            };
            const actionObj = Object.getOwnPropertySymbols(actionList.actions).map(s => actionList.actions[s]).at(0);
            const tmpData = {
              ...mockData
            };
            return new Promise(resolve => {
              const tmpType = actionObj.type;
              const returnData = tmpData[tmpType];
              resolve(returnData);
            });
          } else {
            return new Promise(reject => {
              reject(null);
            });
          }
        };
        const mappedActionCreators = mapValues(actionCreatorMap, actionValue => (...args) => {
          return actionCreatorWithAuth(actionValue, ...args);
        });
        return jsxRuntimeExports.jsx(Component, {
          ...mappedActionCreators,
          ...rest
        });
      }
      WrappedComponent.displayName = `withApiAuth(${Component.displayName || Component.name})`;
      return WrappedComponent;
    };
  } else {
    return Component => {
      function WrappedComponent({
        ...rest
      }) {
        const [cookies] = useCookies(['portalUser']);
        const dispatch = useDispatch();
        const actionCreatorWithAuth = async (actionCreator, ...args) => {
          const accessToken = cookies.portalUser?.credential ?? {};
          const actionObj = actionCreator(...args, accessToken);
          const dispatchObj = await dispatch(actionObj);
          /**
           * DEBUG REDUX ACTIONS/DISPATCH
           */
          if (!isNodeEnvProduction() && String(process.env.REACT_APP_REDUX_API_DEBUG) === 'true') {
            if (actionCreator && actionCreator.hasOwnProperty('type')) {
              const actionList = {
                actions: {
                  ...actionCreator(...args, accessToken)
                },
                type: actionCreator(...args, accessToken).type
              };
              const actionObj = Object.getOwnPropertySymbols(actionList.actions).map(s => actionList.actions[s]).at(0);
              /* eslint-disable no-console */
              console.info('action: ', actionObj.type);
              /* eslint-disable no-console */
              console.info('resp: ', dispatchObj);
            }
          }
          /**
           * END DEBUG
           */
          // Return Dispatch (don't forget)
          return dispatchObj;
        };
        const mappedActionCreators = mapValues(actionCreatorMap, actionValue => (...args) => actionCreatorWithAuth(actionValue, ...args));
        return jsxRuntimeExports.jsx(Component, {
          ...mappedActionCreators,
          ...rest
        });
      }
      WrappedComponent.displayName = `withGoogleAuth(${Component.displayName || Component.name})`;
      return WrappedComponent;
    };
  }
}

var SIZE = 44;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-block'
    },
    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create('transform')
    },
    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: '$circular-rotate 1.4s linear infinite'
    },
    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {
      transition: theme.transitions.create('transform')
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    /* Styles applied to the `svg` element. */
    svg: {
      display: 'block' // Keeps the progress centered
    },
    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',
    },
    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },
    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: '$circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
    },
    /* Styles applied to the `circle` svg path if `variant="determinate"`. */
    circleDeterminate: {
      transition: theme.transitions.create('stroke-dashoffset')
    },
    '@keyframes circular-rotate': {
      '0%': {
        // Fix IE 11 wobbly
        transformOrigin: '50% 50%'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-125px'
      }
    },
    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: 'none'
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var CircularProgress = /*#__PURE__*/React.forwardRef(function CircularProgress(props, ref) {
  var classes = props.classes,
    className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    _props$disableShrink = props.disableShrink,
    disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
    _props$size = props.size,
    size = _props$size === void 0 ? 40 : _props$size,
    style = props.style,
    _props$thickness = props.thickness,
    thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
    _props$value = props.value,
    value = _props$value === void 0 ? 0 : _props$value,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
    other = _objectWithoutProperties(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);
  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};
  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
    rootStyle.transform = 'rotate(-90deg)';
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx(classes.root, className, color !== 'inherit' && classes["color".concat(capitalize(color))], {
      'determinate': classes.determinate,
      'indeterminate': classes.indeterminate,
      'static': classes.static
    }[variant]),
    style: _extends({
      width: size,
      height: size
    }, rootStyle, style),
    ref: ref,
    role: "progressbar"
  }, rootProps, other), /*#__PURE__*/React.createElement("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, /*#__PURE__*/React.createElement("circle", {
    className: clsx(classes.circle, disableShrink && classes.circleDisableShrink, {
      'determinate': classes.circleDeterminate,
      'indeterminate': classes.circleIndeterminate,
      'static': classes.circleStatic
    }[variant]),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
});
process.env.NODE_ENV !== "production" ? CircularProgress.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary']),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   */
  disableShrink: chainPropTypes(PropTypes.bool, function (props) {
    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
      return new Error('Material-UI: You have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
    }
    return null;
  }),
  /**
   * The size of the circle.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g '3rem'.
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The thickness of the circle.
   */
  thickness: PropTypes.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */
  value: PropTypes.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   */
  variant: chainPropTypes(PropTypes.oneOf(['determinate', 'indeterminate', 'static']), function (props) {
    var variant = props.variant;
    if (variant === 'static') {
      throw new Error('Material-UI: `variant="static"` was deprecated. Use `variant="determinate"` instead.');
    }
    return null;
  })
} : void 0;
var CircularProgress$1 = withStyles(styles, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress);

var Visibility$1 = {};

var hasRequiredVisibility;
function requireVisibility() {
  if (hasRequiredVisibility) return Visibility$1;
  hasRequiredVisibility = 1;
  var _interopRequireDefault = requireInteropRequireDefault();
  var _interopRequireWildcard = requireInteropRequireWildcard();
  Object.defineProperty(Visibility$1, "__esModule", {
    value: true
  });
  Visibility$1.default = void 0;
  var React = _interopRequireWildcard(React__default);
  var _createSvgIcon = _interopRequireDefault( /*@__PURE__*/requireCreateSvgIcon());
  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
  }), 'Visibility');
  Visibility$1.default = _default;
  return Visibility$1;
}

var VisibilityExports = /*@__PURE__*/ requireVisibility();
var VisibilityIcon = /*@__PURE__*/getDefaultExportFromCjs(VisibilityExports);

var VisibilityOff$1 = {};

var hasRequiredVisibilityOff;
function requireVisibilityOff() {
  if (hasRequiredVisibilityOff) return VisibilityOff$1;
  hasRequiredVisibilityOff = 1;
  var _interopRequireDefault = requireInteropRequireDefault();
  var _interopRequireWildcard = requireInteropRequireWildcard();
  Object.defineProperty(VisibilityOff$1, "__esModule", {
    value: true
  });
  VisibilityOff$1.default = void 0;
  var React = _interopRequireWildcard(React__default);
  var _createSvgIcon = _interopRequireDefault( /*@__PURE__*/requireCreateSvgIcon());
  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
  }), 'VisibilityOff');
  VisibilityOff$1.default = _default;
  return VisibilityOff$1;
}

var VisibilityOffExports = /*@__PURE__*/ requireVisibilityOff();
var VisibilityOffIcon = /*@__PURE__*/getDefaultExportFromCjs(VisibilityOffExports);

function BaseText({
  tag,
  type,
  className = '',
  children,
  ...rest
}) {
  const combinedClassName = classNames('base-text', type, className);
  const element = /*#__PURE__*/createElement(tag, {
    className: combinedClassName,
    ...rest
  }, children);
  return element;
}

function A({
  children,
  variant,
  className = '',
  bold = false,
  blue = false,
  underline = true,
  ...rest
}) {
  const styles = classNames({
    'text-decoration-none': !underline,
    'font-bold': bold,
    'text-blue': blue,
    [className]: className
  });
  return jsxRuntimeExports.jsx(BaseText, {
    tag: "a",
    type: variant,
    className: styles,
    ...rest,
    children: children
  });
}

function H1({
  children,
  variant = 'headline-large',
  className = '',
  ...rest
}) {
  return jsxRuntimeExports.jsx(BaseText, {
    tag: "h1",
    type: variant,
    className: className,
    ...rest,
    children: children
  });
}

function H2({
  children,
  variant = 'headline-medium',
  className = '',
  bold = false,
  ...rest
}) {
  return jsxRuntimeExports.jsx(BaseText, {
    tag: "h2",
    type: variant,
    className: classNames({
      [className]: className,
      'font-bold': bold
    }),
    ...rest,
    children: children
  });
}

function H3({
  children,
  variant = 'headline-small',
  className = '',
  bold = false,
  ...rest
}) {
  return jsxRuntimeExports.jsx(BaseText, {
    tag: "h3",
    type: variant,
    className: classNames({
      [className]: className,
      'font-bold': bold
    }),
    ...rest,
    children: children
  });
}

function H4({
  children,
  variant = 'title-medium',
  className = '',
  ...rest
}) {
  return jsxRuntimeExports.jsx(BaseText, {
    tag: "h4",
    type: variant,
    className: className,
    ...rest,
    children: children
  });
}

function H5({
  children,
  variant = 'title-small',
  className = '',
  ...rest
}) {
  return jsxRuntimeExports.jsx(BaseText, {
    tag: "h5",
    type: variant,
    className: className,
    ...rest,
    children: children
  });
}

function H6({
  children,
  variant = 'title-extra-small',
  className = '',
  ...rest
}) {
  return jsxRuntimeExports.jsx(BaseText, {
    tag: "h6",
    type: variant,
    className: className,
    ...rest,
    children: children
  });
}

function Label({
  children,
  size = 'medium',
  htmlFor,
  className,
  unbold = false,
  ...rest
}) {
  return jsxRuntimeExports.jsx("label", {
    htmlFor: htmlFor,
    className: classNames(`label-${size}`, className, unbold ? 'unbold' : ''),
    ...rest,
    children: children
  });
}

function Li({
  children,
  variant,
  className = '',
  bold = false,
  listStyle = 'decimal',
  ...rest
}) {
  return jsxRuntimeExports.jsx(BaseText, {
    tag: "li",
    type: variant,
    className: classNames({
      [className]: className,
      'font-bold': bold,
      decimal: listStyle === 'decimal',
      'lower-alpha': listStyle === 'lower-alpha',
      'lower-roman': listStyle === 'lower-roman',
      'list-style-disc': listStyle === 'disc'
    }),
    ...rest,
    children: children
  });
}

function P({
  children,
  variant = 'body-large',
  className = '',
  bold = false,
  ...rest
}) {
  return jsxRuntimeExports.jsx(BaseText, {
    tag: "p",
    type: variant,
    className: classNames({
      [className]: className,
      'font-bold': bold
    }),
    ...rest,
    children: children
  });
}

function Span({
  children,
  variant = 'body-large',
  className = '',
  bold = false,
  ...rest
}) {
  return jsxRuntimeExports.jsx(BaseText, {
    tag: "span",
    type: variant,
    className: `${className} ${bold ? 'font-bold' : ''}`,
    ...rest,
    children: children
  });
}

const convertAsterisksToBullets = str => str.replace(/\*/g, '•');
function AccountNumber({
  accountNumberString,
  fontVariant = 'body-large',
  maskedLenderAccountIdentifier,
  onReveal
}) {
  const [visible, setVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [revealedNumber, setRevealedNumber] = useState(null);
  const getMaskedDisplay = useCallback(() => {
    if (maskedLenderAccountIdentifier) {
      return convertAsterisksToBullets(maskedLenderAccountIdentifier);
    }
    return maskNumber(accountNumberString);
  }, [maskedLenderAccountIdentifier, accountNumberString]);
  const getVisibleDisplay = useCallback(() => {
    if (revealedNumber) {
      return revealedNumber;
    }
    return accountNumberString;
  }, [revealedNumber, accountNumberString]);
  const handleVisibility = async () => {
    if (isLoading) return;
    if (visible) {
      setVisible(false);
      return;
    }
    if (onReveal && !revealedNumber) {
      setIsLoading(true);
      try {
        const revealed = await onReveal();
        if (revealed) {
          setRevealedNumber(revealed);
        }
      } finally {
        setIsLoading(false);
      }
    }
    setVisible(true);
  };
  const displayNumber = visible ? getVisibleDisplay() : getMaskedDisplay();
  const renderIcon = () => {
    if (isLoading) {
      return jsxRuntimeExports.jsx(CircularProgress$1, {
        size: 20
      });
    }
    return visible ? jsxRuntimeExports.jsx(VisibilityOffIcon, {}) : jsxRuntimeExports.jsx(VisibilityIcon, {});
  };
  return jsxRuntimeExports.jsxs("div", {
    className: "account-number",
    children: [jsxRuntimeExports.jsx(P, {
      variant: fontVariant,
      className: "number",
      children: displayNumber
    }), jsxRuntimeExports.jsx(Button$2, {
      type: "button",
      onClick: handleVisibility,
      className: "account-number__visibility-button",
      children: renderIcon()
    })]
  });
}
var AccountNumber$1 = /*#__PURE__*/memo(AccountNumber);

const AppsOutlined = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
  })
});

const ArrowBackIos = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
  })
});

const AssignmentTurnedInOutlined = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
  })
});

const Cake = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root jss179",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z"
  })
});

const Close$1 = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  })
});

const Done = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
  })
});

const Edit = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
  })
});

const Email = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root jss179",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
  })
});

const Error$2 = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
  })
});

const ErrorOutlined = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  })
});

const Facebook = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z"
  })
});

const FilterList$1 = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
  })
});

const ImportExport$1 = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M9 3L5 7h3v10h2V7h3L9 3zm6 14l4-4h-3V3h-2v10h-3l4 4z"
  })
});

const Info = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
  })
});

const Instagram = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
  })
});

const KeyboardArrowDown = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root jss179",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
  })
});

const KeyboardArrowUp = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root jss179",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
  })
});

const Language = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
  })
});

const LinkedIn = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"
  })
});

const LocalPhone = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
  })
});

const LockOutlined$1 = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
  })
});

const MonetizationOnOutlined = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z"
  })
});

const NavigateBefore$1 = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
  })
});

const NavigateNext$1 = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
  })
});

const Pencil = () => jsxRuntimeExports.jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [jsxRuntimeExports.jsx("path", {
    d: "M11.0534 4.53322L4.21171 11.7749C3.95338 12.0499 3.70338 12.5916 3.65338 12.9666L3.34504 15.6666C3.23671 16.6416 3.93671 17.3082 4.90338 17.1416L7.58671 16.6832C7.96171 16.6166 8.48671 16.3416 8.74504 16.0582L15.5867 8.81655C16.77 7.56655 17.3034 6.14155 15.4617 4.39989C13.6284 2.67489 12.2367 3.28322 11.0534 4.53322Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsxRuntimeExports.jsx("path", {
    d: "M9.91211 5.74121C10.2704 8.04121 12.1371 9.79954 14.4538 10.0329",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});

const Plan = () => jsxRuntimeExports.jsxs("svg", {
  focusable: "false",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  fill: "currentColor",
  children: [jsxRuntimeExports.jsx("path", {
    d: "M9.1665 16.25H17.4998",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsxRuntimeExports.jsx("path", {
    d: "M9.1665 10.418H17.4998",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsxRuntimeExports.jsx("path", {
    d: "M9.1665 4.58203H17.4998",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsxRuntimeExports.jsx("path", {
    d: "M2.5 4.58464L3.33333 5.41797L5.83333 2.91797",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsxRuntimeExports.jsx("path", {
    d: "M2.5 10.4167L3.33333 11.25L5.83333 8.75",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsxRuntimeExports.jsx("path", {
    d: "M2.5 16.2487L3.33333 17.082L5.83333 14.582",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});

const Replay$1 = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
  })
});

const Room = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
  })
});

const Visibility = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
  })
});

const VisibilityOff = () => jsxRuntimeExports.jsx("svg", {
  className: "MuiSvgIcon-root",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  children: jsxRuntimeExports.jsx("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
  })
});

// Colors defined in _colors.scss.
// Any changes to this file should also be made in _colors.scss.
const INLINE_COLORS = {
  // Black
  blackBase: '#00000e',
  blackLight: '#707077',
  blackTooltip: '#2F2F2F',
  // White
  whiteBase: '#ffffff',
  // Grey
  greyBase: '#c6c5c5',
  greyLight: '#eae9e9',
  // Light Grey
  lightgreyBase: '#e5e5e4',
  lightgreyLight: '#f5f5f5',
  lightgreyLighter: '#fcfcfc',
  // Dark Grey
  darkgreyBase: '#6d6d6d',
  darkgreyMedium: '#6b6b6b',
  darkgreyLight: '#adadad',
  darkgreyLighter: '#c8c8c8',
  // Red
  redBase: '#bf2536',
  redMedium: '#d03127',
  redLight: '#fdf6f7',
  redBackground: '#bf25360f',
  // Blue
  blueBase: '#32459b',
  blueMedium: '#1d6c8b',
  lightblueBase: '#f2fbff',
  // Green
  greenBase: '#43a03c',
  greenMedium: '#9aaf43',
  greenLight: '#ecf6ec',
  greenAccess: '#99ae3b',
  greenDark: '#206b1a',
  // Purple
  purpleBase: '#792e9e',
  purpleBackground: '#792e9e0f',
  // Orange
  orangeBase: '#f17c31',
  orangeFlex: '#98501e'
};

/**
 * @name AnimationFail
 * @desc Animation with red x and mostly complete circle
 * @notes SVG file location: src/images/svg/failmark_200x200.svg, src/images/svg/cutcircle_200x200.svg
 * @param color string
 * @param width string
 * @param height string
 * @param margin string
 * @param minHeight string
 * @param maxHeight string
 * @returns
 */
const AnimationFail = ({
  color = INLINE_COLORS.redBase,
  width = '20vw',
  height = '20vw',
  margin = '40px auto',
  minHeight = '120px',
  maxHeight = '240px'
}) => {
  const transition1 = {
    delay: 0.4,
    duration: 0.6,
    yoyo: Infinity,
    ease: 'easeInOut'
  };
  const transition2 = {
    delay: 0.5,
    duration: 0.6,
    yoyo: Infinity,
    ease: 'easeInOut'
  };
  const transitionCircle = {
    duration: 0.8,
    yoyo: Infinity,
    ease: 'easeInOut'
  };
  return jsxRuntimeExports.jsxs("div", {
    style: {
      width: width,
      height: height,
      margin: margin,
      minHeight: minHeight,
      maxHeight: maxHeight,
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    children: [jsxRuntimeExports.jsxs("svg", {
      style: {
        position: 'absolute',
        minWidth: '60px'
      },
      width: '60%',
      height: '60%',
      viewBox: "0 0 127 164",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: [jsxRuntimeExports.jsx(motion.path, {
        fill: "none",
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: "15",
        stroke: color,
        d: "M10.651,151.238l52.602,-69.714l51.773,-70.873",
        initial: {
          opacity: 0,
          pathLength: 0,
          pathOffset: 1
        },
        animate: {
          opacity: 1,
          pathLength: 1,
          pathOffset: 0
        },
        transition: transition1
      }), jsxRuntimeExports.jsx(motion.path, {
        fill: "none",
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: "15",
        stroke: color,
        d: "M115.871,152.396l-104.376,-140.588",
        initial: {
          opacity: 0,
          pathLength: 0,
          pathOffset: 1
        },
        animate: {
          opacity: 1,
          pathLength: 1,
          pathOffset: 0
        },
        transition: transition2
      })]
    }), jsxRuntimeExports.jsx("svg", {
      style: {
        position: 'absolute',
        minWidth: '120px'
      },
      width: "100%",
      height: "100%",
      viewBox: "0 0 265 265",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: jsxRuntimeExports.jsx(motion.path, {
        fill: "none",
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: "12",
        stroke: color,
        d: "M173.102,247.223c-13.005,6.931 -26.226,10.37 -40.972,10.37c-69.245,-0 -125.463,-56.218 -125.463,-125.463c-0,-69.245 56.218,-125.463 125.463,-125.463c69.245,-0 125.689,56.218 125.463,125.463c-0.106,32.225 -9.919,51.089 -28.096,74.914",
        initial: {
          opacity: 0,
          scale: 0.5,
          pathLength: 0,
          pathOffset: 1
        },
        animate: {
          opacity: 1,
          scale: 1,
          pathLength: 1,
          pathOffset: 0
        },
        transition: transitionCircle
      })
    })]
  });
};

var img$8 = "data:image/png;base64,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";

var img$7 = "data:image/png;base64,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";

/**
 * @name AnimationPhoneWait
 */
const AnimationPhoneWait = () => {
  // Animation Container
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        delay: 1.15,
        staggerChildren: 0.25
      }
    }
  };
  // Animation Item
  const item = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: [0, 1, 0],
      y: [0, 13, -15, 0],
      transition: {
        repeat: Infinity,
        repeatDelay: 0.5,
        repeatType: 'mirror'
      }
    }
  };
  return jsxRuntimeExports.jsxs("div", {
    className: "check-phone-image",
    children: [jsxRuntimeExports.jsx("div", {
      className: "phone-image",
      children: jsxRuntimeExports.jsx(motion.div, {
        initial: {
          opacity: 0,
          scale: 0.5
        },
        animate: {
          opacity: 1,
          scale: 1
        },
        transition: {
          delay: 0.25,
          duration: 0.5
        },
        className: "animate-check-phone-image",
        children: jsxRuntimeExports.jsx("img", {
          src: img$7,
          alt: "phone"
        })
      })
    }), jsxRuntimeExports.jsx("div", {
      className: "phone-animation",
      children: jsxRuntimeExports.jsxs(motion.ol, {
        variants: container,
        initial: "hidden",
        animate: "show",
        className: "animate-check-phone-image",
        children: [jsxRuntimeExports.jsx(motion.li, {
          variants: item,
          className: "animation_ball_bounce"
        }), jsxRuntimeExports.jsx(motion.li, {
          variants: item,
          className: "animation_ball_bounce"
        }), jsxRuntimeExports.jsx(motion.li, {
          variants: item,
          className: "animation_ball_bounce"
        })]
      })
    }), jsxRuntimeExports.jsx("div", {
      className: "phone-bg",
      children: jsxRuntimeExports.jsx("img", {
        src: img$8,
        alt: "phone"
      })
    })]
  });
};

/**
 * @name AnimationFail
 * @desc Animation with green checkmar and mostly complete circle
 * @notes SVG file location: src/images/svg/checkmark_200x200.svg, src/images/svg/cutcircle_200x200.svg
 * @param color string
 * @param width string
 * @param height string
 * @param margin string
 * @param minHeight string
 * @param maxHeight string
 * @returns
 */
const AnimationSuccess = ({
  color = INLINE_COLORS.greenBase,
  width = '20vw',
  height = '20vw',
  margin = '40px auto',
  minHeight = '120px',
  maxHeight = '240px',
  top = 'initial',
  left = 'initial'
}) => {
  const transitionCheckmark = {
    delay: 0.4,
    duration: 0.6,
    yoyo: Infinity,
    ease: 'easeInOut'
  };
  const transitionCircle = {
    duration: 0.8,
    yoyo: Infinity,
    ease: 'easeInOut'
  };
  return jsxRuntimeExports.jsxs("div", {
    style: {
      width: width,
      height: height,
      margin: margin,
      minHeight: minHeight,
      maxHeight: maxHeight,
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      top: top,
      left: left
    },
    children: [jsxRuntimeExports.jsx("svg", {
      style: {
        position: 'absolute',
        minWidth: '60px'
      },
      width: '60%',
      height: '60%',
      viewBox: "0 0 173 162",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: jsxRuntimeExports.jsx(motion.path, {
        fill: "none",
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: "15",
        stroke: color,
        d: "M10.651,91.595l46.862,59.643l104.376,-140.587",
        initial: {
          opacity: 0,
          pathLength: 0,
          pathOffset: 1
        },
        animate: {
          opacity: 1,
          pathLength: 1,
          pathOffset: 0
        },
        transition: transitionCheckmark
      })
    }), jsxRuntimeExports.jsx("svg", {
      style: {
        position: 'absolute',
        minWidth: '120px'
      },
      width: "100%",
      height: "100%",
      viewBox: "0 0 265 265",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: jsxRuntimeExports.jsx(motion.path, {
        fill: "none",
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: "12",
        stroke: color,
        d: "M173.102,247.223c-13.005,6.931 -26.226,10.37 -40.972,10.37c-69.245,-0 -125.463,-56.218 -125.463,-125.463c-0,-69.245 56.218,-125.463 125.463,-125.463c69.245,-0 125.689,56.218 125.463,125.463c-0.106,32.225 -9.919,51.089 -28.096,74.914",
        initial: {
          opacity: 0,
          scale: 0.5,
          pathLength: 0,
          pathOffset: 1
        },
        animate: {
          opacity: 1,
          scale: 1,
          pathLength: 1,
          pathOffset: 0
        },
        transition: transitionCircle
      })
    })]
  });
};

function AuthBuyerSaleCard({
  paymentDetails,
  currentLocation
}) {
  const {
    alphaeonAccountNumber,
    creditLimit,
    name,
    availableCreditLimit,
    dateOfBirth,
    buyer
  } = paymentDetails;
  return jsxRuntimeExports.jsx("div", {
    className: "account-summary refund-complete",
    children: jsxRuntimeExports.jsx("div", {
      className: "summary__card card m-t-30",
      children: jsxRuntimeExports.jsxs("div", {
        className: "card-content",
        children: [jsxRuntimeExports.jsx("div", {
          className: "card-half",
          children: jsxRuntimeExports.jsxs("div", {
            className: "summary__account-info",
            children: [jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              className: "mar-y-8",
              children: `${buyer && buyer.firstName} ${buyer && buyer.lastName} `
            }), jsxRuntimeExports.jsx("div", {
              className: "card-main",
              children: jsxRuntimeExports.jsxs("div", {
                className: "card-main__left",
                children: [jsxRuntimeExports.jsx("div", {
                  className: "info-container",
                  children: jsxRuntimeExports.jsx(P, {
                    variant: "body-large",
                    className: "mar-y-8",
                    children: jsxRuntimeExports.jsx("strong", {
                      children: "Authorized Buyer"
                    })
                  })
                }), jsxRuntimeExports.jsxs("div", {
                  className: "info-container",
                  children: [jsxRuntimeExports.jsx(P, {
                    variant: "body-large",
                    className: "mar-y-8",
                    children: jsxRuntimeExports.jsx("strong", {
                      children: "Account Number:"
                    })
                  }), jsxRuntimeExports.jsx(AccountNumber$1, {
                    accountNumberString: alphaeonAccountNumber
                  })]
                }), jsxRuntimeExports.jsx("div", {
                  className: "info-container",
                  children: jsxRuntimeExports.jsxs(P, {
                    variant: "body-large",
                    className: "mar-y-8",
                    children: [jsxRuntimeExports.jsx("strong", {
                      children: "Available Credit"
                    }), ' ', formatCurrency(availableCreditLimit, 2)]
                  })
                }), dateOfBirth && jsxRuntimeExports.jsx("div", {
                  className: "info-container",
                  children: jsxRuntimeExports.jsxs(P, {
                    variant: "body-large",
                    className: "mar-y-8",
                    children: [jsxRuntimeExports.jsx("strong", {
                      children: "Date of Birth"
                    }), ' ', formatISODateStringAsUSMonthDayYear(dateOfBirth) ?? 'N/A']
                  })
                })]
              })
            })]
          })
        }), jsxRuntimeExports.jsx("div", {
          className: "card-half card-half__right",
          children: jsxRuntimeExports.jsxs("div", {
            className: "summary__account-info",
            children: [jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              className: "mar-y-8",
              children: `${name?.firstName} ${name?.lastName}`
            }), jsxRuntimeExports.jsx("div", {
              className: "card-main",
              children: jsxRuntimeExports.jsxs("div", {
                className: "card-main__left",
                children: [jsxRuntimeExports.jsx("div", {
                  className: "info-container",
                  children: jsxRuntimeExports.jsx(P, {
                    variant: "body-large",
                    className: "mar-y-8",
                    children: jsxRuntimeExports.jsx("strong", {
                      children: "Responsible Party"
                    })
                  })
                }), jsxRuntimeExports.jsx("div", {
                  className: "info-container",
                  children: jsxRuntimeExports.jsx(P, {
                    variant: "body-large",
                    className: "mar-y-8",
                    children: jsxRuntimeExports.jsx("strong", {
                      children: "\u00A0"
                    })
                  })
                }), jsxRuntimeExports.jsx("div", {
                  className: "info-container",
                  children: jsxRuntimeExports.jsxs(P, {
                    variant: "body-large",
                    className: "mar-y-8",
                    children: [jsxRuntimeExports.jsx("strong", {
                      children: "Credit Limit"
                    }), ' ', formatCurrency(creditLimit, 2)]
                  })
                }), jsxRuntimeExports.jsx("div", {
                  className: "info-container",
                  children: jsxRuntimeExports.jsxs(P, {
                    variant: "body-large",
                    className: "mar-y-8",
                    children: [jsxRuntimeExports.jsx("strong", {
                      children: "Location"
                    }), " ", currentLocation.name]
                  })
                })]
              })
            })]
          })
        })]
      })
    })
  });
}

function AuthorizationTooltip({
  children,
  displayed,
  message = '',
  ...rest
}) {
  return jsxRuntimeExports.jsx(Tooltip, {
    arrow: true,
    enterTouchDelay: 0,
    placement: "top",
    title: !displayed ? '' : message ? jsxRuntimeExports.jsx("p", {
      style: {
        fontSize: '14px',
        color: INLINE_COLORS.whiteBase
      },
      children: message
    }) : jsxRuntimeExports.jsxs("span", {
      style: {
        fontSize: '1.4em'
      },
      children: ["Permission for this functionality is disabled.", jsxRuntimeExports.jsx("br", {}), "Please contact your administrator to enable."]
    }),
    ...rest,
    children: children
  });
}
var AuthorizationTooltip$1 = /*#__PURE__*/memo(AuthorizationTooltip);

function calculateClassName({
  className,
  pristine,
  invalid,
  submitting
}) {
  return classNames({
    'is-disabled': pristine || invalid,
    'in-progress': submitting
  }, className);
}
/**
 * @deprecated Use ButtonV2 instead
 */
function Button({
  children,
  type,
  pristine,
  invalid,
  submitting,
  className,
  onClick,
  disabledToolTip = '',
  ...rest
}, ref) {
  const disabled = pristine || invalid ? true : false;
  const message = disabled && disabledToolTip ? disabledToolTip : null;
  return jsxRuntimeExports.jsx(AuthorizationTooltip$1, {
    displayed: disabled && !!message,
    message: message,
    children: jsxRuntimeExports.jsx("button", {
      type: type,
      ref: ref,
      className: calculateClassName({
        className,
        pristine,
        invalid,
        submitting
      }),
      "aria-disabled": disabled,
      onClick: disabled || submitting ? noop : onClick,
      ...rest,
      children: children
    })
  });
}
var Button$1 = /*#__PURE__*/forwardRef(Button);

// A button that is styled to appear as a link...
function ButtonLink({
  children,
  className = 'link-primary',
  disabled = false,
  ...rest
}) {
  return jsxRuntimeExports.jsx("button", {
    className: className,
    ...rest,
    disabled: disabled,
    children: children
  });
}
var ButtonLink$1 = /*#__PURE__*/memo(ButtonLink);

function Spinner({
  centerPage = false,
  color = 'red',
  dataTestId,
  size = 'medium',
  className
}) {
  return jsxRuntimeExports.jsx("div", {
    "data-testid": dataTestId,
    className: `${centerPage ? 'spinner-center-shell' : 'spinner-default'} ${className}`,
    children: jsxRuntimeExports.jsx("div", {
      className: `${centerPage ? 'spinner-center' : ''}`,
      children: jsxRuntimeExports.jsx("div", {
        id: "spinner",
        className: `spinner-${size} spinner-${color}`
      })
    })
  });
}

/**
 * Version 2 of the Button component.
 * - [Storybook Demo](http://localhost:6006/?path=/story/global-components-button--red)
 * @param {String} [variant] - The variant of the button, options: 'filled', 'outline', 'ghost'.
 * @param {String} [color] - The lender specific color of the button, options: 'red', 'purple', 'green', 'orange-flex', 'black', 'blue'.
 * @param {String} [size] - The size of the button, options: 'xx-small', 'extra-small', 'small', 'medium', 'large'.
 * @param {Boolean} [disabled] - Whether the button is disabled.
 * @param {Boolean} [submitting] - Whether the button is submitting.
 * @param {Boolean} [fullWidth] - if true, the button will be the width of its container.
 * @param {Boolean} [hugText] - if true, the button drops its size-based min-width and sizes to its text content.
 * @param {Boolean} [overwriteCasing] - if true, doesn't capitalize the first letter of each word.
 * @param {React.FC<React.SVGProps<SVGSVGElement>>} [SvgIcon] - The SVG react component to display on the button, must be a react component with the fill and stroke set to 'currentColor'. Ex. `images/svg-components/Plan.tsx`
 * @param {String} [iconPosition] - Where the SvgIcon renders relative to the text, options: 'start', 'end'.
 * @param {Boolean} [underline] - Whether the 'text' variant underlines its label.
 * @param {String} [disabledMessage] - The message to display on hover when the button is disabled.
 * @param {String} children - Button text.
 * @param {String} [className] - Any additional classes to add to the button.
 */
function ButtonV2({
  variant = 'filled',
  color = 'red',
  size = 'medium',
  disabled = false,
  submitting = false,
  fullWidth = false,
  hugText = false,
  overwriteCasing = false,
  SvgIcon = undefined,
  iconPosition = 'start',
  underline = true,
  disabledMessage = '',
  children,
  className = '',
  dataAnalyticsId = undefined,
  ...props
}) {
  const buttonRef = useRef(null);
  const buttonSizeToSpinnerSizeMap = new Map([['xx-small', 'extra-small'], ['extra-small', 'extra-small'], ['small', 'extra-small'], ['medium', 'small'], ['large', 'medium']]);
  useLayoutEffect(() => {
    /*
      We need to increase the min-width if the text is long enough to
      cause the button to shrink when in the 'submitting' state
    */
    if (buttonRef.current && !fullWidth) {
      const computedStyle = getComputedStyle(buttonRef.current);
      const minWidth = computedStyle.minWidth;
      const width = computedStyle.width;
      const minWidthNum = parseFloat(minWidth);
      const widthNum = parseFloat(width);
      if (widthNum > minWidthNum) {
        buttonRef.current.style.minWidth = width;
      }
    }
  }, [children, buttonRef, fullWidth, hugText]);
  return jsxRuntimeExports.jsx(AuthorizationTooltip$1, {
    displayed: !!disabledMessage && disabled,
    message: disabledMessage,
    children: jsxRuntimeExports.jsx("button", {
      className: classNames({
        'button-v2': true,
        [variant]: true,
        [color]: true,
        [size]: true,
        'full-width': fullWidth,
        'hug-text': hugText,
        'icon-end': iconPosition === 'end',
        'no-underline': !underline,
        ['capitalize-first-letter']: !overwriteCasing,
        [className]: className !== ''
      }),
      disabled: disabled || submitting,
      ref: buttonRef,
      "data-analytics-id": dataAnalyticsId ?? `button-${children}`,
      ...props,
      children: submitting ? jsxRuntimeExports.jsx("div", {
        className: "inner-spinner",
        children: jsxRuntimeExports.jsx(Spinner, {
          size: buttonSizeToSpinnerSizeMap.get(size),
          dataTestId: "spinner"
        })
      }) : jsxRuntimeExports.jsxs("div", {
        className: "inner-content",
        children: [SvgIcon && iconPosition === 'start' && jsxRuntimeExports.jsx(SvgIcon, {}), children, SvgIcon && iconPosition === 'end' && jsxRuntimeExports.jsx(SvgIcon, {})]
      })
    })
  });
}

const CardRow = ({
  title,
  value,
  titleBold = false
}) => {
  return jsxRuntimeExports.jsxs("div", {
    className: "flex space-between",
    children: [jsxRuntimeExports.jsxs("span", {
      className: `${titleBold ? 'text-bold' : ''}`,
      children: [title ?? '', ":"]
    }), jsxRuntimeExports.jsx("span", {
      children: value ?? '---'
    })]
  });
};

function CodeInput5Digit({
  setInputValue,
  hasError,
  value = '',
  disabled
}) {
  const [currentIndex, setCurrentIndex] = useState(1);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  useEffect(() => {
    inputRef1?.current?.focus();
  }, []);
  const updateInputValue = useCallback(() => {
    setInputValue(`${inputRef1.current?.value || ''}${inputRef2.current?.value || ''}${inputRef3.current?.value || ''}${inputRef4.current?.value || ''}${inputRef5.current?.value || ''}`);
  }, [setInputValue]);
  useEffect(() => {
    if (currentIndex === 1) {
      inputRef1?.current?.focus();
    } else if (currentIndex === 2) {
      inputRef2?.current?.focus();
    } else if (currentIndex === 3) {
      inputRef3?.current?.focus();
    } else if (currentIndex === 4) {
      inputRef4?.current?.focus();
    } else if (currentIndex === 5) {
      inputRef5?.current?.focus();
    }
  }, [currentIndex]);
  return jsxRuntimeExports.jsxs("div", {
    className: "code-input-container",
    children: [jsxRuntimeExports.jsx(DigitInput$1, {
      index: 1,
      setCurrentIndex: setCurrentIndex,
      inputRef: inputRef1,
      updateInputValue: updateInputValue,
      hasError: hasError,
      disabled: disabled,
      externalValue: value[0] || ''
    }), jsxRuntimeExports.jsx(DigitInput$1, {
      index: 2,
      setCurrentIndex: setCurrentIndex,
      inputRef: inputRef2,
      updateInputValue: updateInputValue,
      hasError: hasError,
      disabled: disabled,
      externalValue: value[1] || ''
    }), jsxRuntimeExports.jsx(DigitInput$1, {
      index: 3,
      setCurrentIndex: setCurrentIndex,
      inputRef: inputRef3,
      updateInputValue: updateInputValue,
      hasError: hasError,
      disabled: disabled,
      externalValue: value[2] || ''
    }), jsxRuntimeExports.jsx(DigitInput$1, {
      index: 4,
      setCurrentIndex: setCurrentIndex,
      inputRef: inputRef4,
      updateInputValue: updateInputValue,
      hasError: hasError,
      disabled: disabled,
      externalValue: value[3] || ''
    }), jsxRuntimeExports.jsx(DigitInput$1, {
      index: 5,
      setCurrentIndex: setCurrentIndex,
      inputRef: inputRef5,
      updateInputValue: updateInputValue,
      hasError: hasError,
      disabled: disabled,
      externalValue: value[4] || ''
    })]
  });
}
function DigitInput$1({
  index,
  setCurrentIndex,
  inputRef,
  updateInputValue,
  hasError,
  externalValue = '',
  disabled
}) {
  const [value, setValue] = useState(externalValue);
  useEffect(() => {
    setValue(externalValue);
  }, [externalValue]);
  useEffect(() => {
    updateInputValue();
  }, [value, updateInputValue]);
  const isValidNumber = number => {
    return /^[0-9]*$/.test(number);
  };
  const handleFocus = () => {
    setCurrentIndex(index);
  };
  const handleKeyDown = e => {
    if (e.key === 'Backspace') {
      setValue('');
      if (index > 1) {
        setCurrentIndex(index - 1);
      }
    } else if (!isValidNumber(e.key) || e.key === value) {
      return;
    } else if (e.target.selectionStart === 0) {
      setValue(e.key);
      if (index < 5) {
        setCurrentIndex(index + 1);
      }
    } else if (value.length === 1) {
      if (index < 5) {
        setCurrentIndex(index + 1);
      }
    }
  };
  return jsxRuntimeExports.jsx("input", {
    className: `digit-input ${hasError ? 'digit-input--error' : ''}`,
    type: "tel",
    maxLength: 1,
    onFocus: handleFocus,
    value: value,
    onKeyDown: handleKeyDown,
    ref: inputRef,
    disabled: disabled
  });
}

function CodeInput({
  setInputValue
}) {
  const [currentIndex, setCurrentIndex] = useState(1);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  useEffect(() => {
    inputRef1?.current?.focus();
  }, []);
  const updateInputValue = () => {
    setInputValue(`${inputRef1.current?.value}${inputRef2.current?.value}${inputRef3.current?.value}${inputRef4.current?.value}`);
  };
  useEffect(() => {
    if (currentIndex === 1) {
      inputRef1?.current?.focus();
    } else if (currentIndex === 2) {
      inputRef2?.current?.focus();
    } else if (currentIndex === 3) {
      inputRef3?.current?.focus();
    } else if (currentIndex === 4) {
      inputRef4?.current?.focus();
    }
  }, [currentIndex]);
  return jsxRuntimeExports.jsxs("div", {
    className: "code-input-container",
    children: [jsxRuntimeExports.jsx(DigitInput, {
      index: 1,
      setCurrentIndex: setCurrentIndex,
      inputRef: inputRef1,
      updateInputValue: updateInputValue
    }), jsxRuntimeExports.jsx(DigitInput, {
      index: 2,
      setCurrentIndex: setCurrentIndex,
      inputRef: inputRef2,
      updateInputValue: updateInputValue
    }), jsxRuntimeExports.jsx(DigitInput, {
      index: 3,
      setCurrentIndex: setCurrentIndex,
      inputRef: inputRef3,
      updateInputValue: updateInputValue
    }), jsxRuntimeExports.jsx(DigitInput, {
      index: 4,
      setCurrentIndex: setCurrentIndex,
      inputRef: inputRef4,
      updateInputValue: updateInputValue
    })]
  });
}
function DigitInput({
  index,
  setCurrentIndex,
  inputRef,
  updateInputValue
}) {
  const [value, setValue] = useState('');
  useEffect(() => {
    updateInputValue();
  }, [value]);
  const isValidNumber = number => {
    return /^[0-9]*$/.test(number);
  };
  const handleFocus = () => {
    setCurrentIndex(index);
  };
  const handleKeyDown = e => {
    if (e.key === 'Backspace') {
      setValue('');
      setCurrentIndex(index - 1);
    } else if (!isValidNumber(e.key) || e.key === value) {
      return;
    } else if (e.target.selectionStart === 0) {
      setValue(e.key);
      setCurrentIndex(index + 1);
    } else if (value.length === 1) {
      setCurrentIndex(index + 1);
    }
  };
  return jsxRuntimeExports.jsx("input", {
    className: "digit-input",
    type: "tel",
    maxLength: 1,
    onFocus: handleFocus,
    value: value,
    onKeyDown: handleKeyDown,
    ref: inputRef
  });
}

var _Error = {};

var hasRequired_Error;
function require_Error() {
  if (hasRequired_Error) return _Error;
  hasRequired_Error = 1;
  var _interopRequireDefault = requireInteropRequireDefault();
  var _interopRequireWildcard = requireInteropRequireWildcard();
  Object.defineProperty(_Error, "__esModule", {
    value: true
  });
  _Error.default = void 0;
  var React = _interopRequireWildcard(React__default);
  var _createSvgIcon = _interopRequireDefault( /*@__PURE__*/requireCreateSvgIcon());
  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
  }), 'Error');
  _Error.default = _default;
  return _Error;
}

var _ErrorExports = /*@__PURE__*/ require_Error();
var ErrorIcon$1 = /*@__PURE__*/getDefaultExportFromCjs(_ErrorExports);

function CustomErrorPage({
  title,
  description,
  withBackButton = false
}) {
  const history = useHistory();
  return jsxRuntimeExports.jsx("div", {
    className: "page-container centered-container",
    children: jsxRuntimeExports.jsxs("div", {
      className: "error-page-container",
      children: [jsxRuntimeExports.jsx(ErrorIcon$1, {
        style: {
          fontSize: 100
        },
        color: "disabled"
      }), jsxRuntimeExports.jsx("h4", {
        className: "error-page-title",
        children: title
      }), jsxRuntimeExports.jsx("p", {
        className: "error-page-paragraph",
        children: description
      }), withBackButton && jsxRuntimeExports.jsx(Button$1, {
        "data-testid": "back-button",
        type: "button",
        className: "button-warn-outline",
        onClick: () => history.goBack(),
        children: "Go Back"
      })]
    })
  });
}

function ComponentWithValue({
  input,
  comps
}) {
  return comps(input.value);
}
function FormSpy({
  children,
  ...props
}) {
  return jsxRuntimeExports.jsx(Field, {
    component: ComponentWithValue,
    comps: children,
    ...props
  });
}

const MaskedInputWithToolTip = props => {
  const [focus, setFocus] = useState(false);
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsx(MaskedInput, {
      onFocus: () => {
        setFocus(true);
      },
      ...props
    }), jsxRuntimeExports.jsx(FormSpy, {
      name: props.input.name,
      focused: focus,
      children: val => {
        if ((val || focus) && props.tooltips) {
          return jsxRuntimeExports.jsx(props.tooltips, {});
        }
        return null;
      }
    })]
  });
};
var CustomFields = {
  MaskedInputWithToolTip
};

function ExternalLink({
  children,
  className = '',
  href,
  styleAsAnchor = false,
  variant = 'title-large',
  ...rest
}) {
  // Ensure that all web addresses begin with a protocol (the expectation). If
  // they don't, assume the current protocol (typically https) by prepending
  // "//" to the URL.
  const normalizedUrl = href.startsWith('http') ? href : `//${href}`;
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsx(A, {
      className: styleAsAnchor ? '' : classNames('external-link', className),
      bold: true,
      blue: true,
      variant: variant,
      target: "_blank",
      rel: "noopener noreferrer",
      href: normalizedUrl,
      ...rest,
      children: children
    }), jsxRuntimeExports.jsx("span", {
      hidden: true,
      children: "Opens in a new window"
    })]
  });
}
var ExternalLink$1 = /*#__PURE__*/memo(ExternalLink);

function ExternalLinkButton({
  children,
  className,
  href,
  invalid,
  ...rest
}, ref) {
  // Ensure that all web addresses begin with a protocol (the expectation). If
  // they don't, assume the current protocol (typically https) by prepending
  // "//" to the URL.
  const normalizedUrl = href.startsWith('http') ? href : `//${href}`;
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsx("a", {
      className: "external-link",
      target: "_blank",
      rel: "noopener noreferrer",
      href: normalizedUrl,
      ...rest,
      children: jsxRuntimeExports.jsx(Button$1, {
        type: "button",
        className: `${className} external-link-button`,
        invalid: invalid,
        ref: ref,
        children: children
      })
    }), jsxRuntimeExports.jsx("span", {
      hidden: true,
      children: "Opens in a new window"
    })]
  });
}
var ExternalLinkButton_default = /*#__PURE__*/forwardRef(ExternalLinkButton);

/*
  This component is displayed when an error occurs that breaks react rendering and would otherwise show a stacktrace to the user.
  If a user lands on this screen, there's a bug in the FE code that needs to be fixed.

  Errors that do not break react rendering will be handled by useErrorListener.ts, which will log to HB.
*/
function FallbackErrorScreen({
  error
}) {
  const unknownErrorMessage = 'An unknown error occurred.';
  let errorMessage = '';
  try {
    if (!error) errorMessage = unknownErrorMessage;else if (typeof error === 'string') errorMessage = error;else if (error instanceof Error) errorMessage = error.message;else if (typeof error === 'object') errorMessage = JSON.stringify(error);
    reportError('boundaryError', {
      componentName: 'FallbackErrorScreen',
      errType: 'error',
      errURL: window.location.pathname,
      errMsg: errorMessage,
      context: {
        error: error,
        originalStack: error?.stack,
        componentStack: error?.componentStack
      }
    });
  } catch {
    errorMessage = '';
  }
  return jsxRuntimeExports.jsx("div", {
    className: "page-container centered-container",
    children: jsxRuntimeExports.jsxs("div", {
      className: "error-page-container",
      children: [jsxRuntimeExports.jsx(ErrorIcon$1, {
        style: {
          fontSize: 100
        },
        color: "disabled"
      }), jsxRuntimeExports.jsx("h4", {
        className: "error-page-title",
        children: "An error occurred"
      }), jsxRuntimeExports.jsx("p", {
        className: "error-page-paragraph",
        children: errorMessage ?? unknownErrorMessage
      })]
    })
  });
}

function FlexEstimateFootnotes({
  estimate
}) {
  const {
    termMonths,
    apr,
    promoPeriodMonths,
    suggestedMonthlyPayment
  } = estimate;
  return jsxRuntimeExports.jsxs("div", {
    className: "flex-estimate-footnotes",
    children: [jsxRuntimeExports.jsxs(P, {
      variant: "body-small",
      children: [jsxRuntimeExports.jsx("sup", {
        children: "1"
      }), ' ', jsxRuntimeExports.jsxs(Span, {
        variant: "body-small",
        bold: true,
        children: [termMonths, "-month term"]
      }), ' ', "at", ' ', jsxRuntimeExports.jsxs(Span, {
        variant: "body-small",
        bold: true,
        children: [apr, "% APR"]
      })]
    }), suggestedMonthlyPayment != null && promoPeriodMonths != null && jsxRuntimeExports.jsxs(P, {
      variant: "body-small",
      children: [jsxRuntimeExports.jsx("sup", {
        children: "2"
      }), " Pays off within the", ' ', jsxRuntimeExports.jsxs(Span, {
        variant: "body-small",
        bold: true,
        children: [promoPeriodMonths, "-month promotion period."]
      }), ' ', "No finance charge requires all minimum payments to be made on or before the contractual due date and a total of the financed amount paid within the promotional period."]
    })]
  });
}

var img$6 = "data:image/svg+xml,%3csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M9.1665 16.25H17.4998' stroke='%23C75000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M9.1665 10.418H17.4998' stroke='%23C75000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M9.1665 4.58203H17.4998' stroke='%23C75000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M2.5 4.58464L3.33333 5.41797L5.83333 2.91797' stroke='%23C75000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M2.5 10.4167L3.33333 11.25L5.83333 8.75' stroke='%23C75000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M2.5 16.2487L3.33333 17.082L5.83333 14.582' stroke='%23C75000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

function FlexOptionCard({
  estimate = null,
  optionNumber = undefined,
  hasError = false
}) {
  if (hasError) return null;
  const title = optionNumber ? `Option ${optionNumber}` : 'Treatment Estimate';
  return jsxRuntimeExports.jsx("div", {
    className: "flex-option-card",
    children: estimate ? jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
      children: [jsxRuntimeExports.jsxs("div", {
        className: "flex-option-card__header",
        children: [jsxRuntimeExports.jsx("div", {
          className: "flex-option-card__icon",
          children: jsxRuntimeExports.jsx("img", {
            src: img$6,
            alt: "",
            width: 18,
            height: 18
          })
        }), jsxRuntimeExports.jsx(Label, {
          size: "medium",
          children: title
        })]
      }), jsxRuntimeExports.jsxs("div", {
        className: "flex-option-card__metric",
        children: [jsxRuntimeExports.jsxs(P, {
          variant: "body-medium",
          children: ["Pay Over Time", jsxRuntimeExports.jsx("sup", {
            children: "1"
          })]
        }), jsxRuntimeExports.jsxs("div", {
          className: "flex-option-card__amount",
          children: [jsxRuntimeExports.jsx(Span, {
            variant: "headline-medium",
            bold: true,
            children: formatCurrency(estimate.minimumMonthlyPayment, 2)
          }), jsxRuntimeExports.jsx(Span, {
            variant: "body-medium",
            children: "/month"
          }), jsxRuntimeExports.jsxs(Span, {
            variant: "body-medium",
            className: "flex-option-card__payment-count",
            children: [estimate.termMonths, " payments"]
          })]
        })]
      }), estimate.suggestedMonthlyPayment != null && jsxRuntimeExports.jsxs("div", {
        className: "flex-option-card__metric flex-option-card__metric--divided",
        children: [jsxRuntimeExports.jsxs(P, {
          variant: "body-medium",
          children: ["Save On Finance Charges", jsxRuntimeExports.jsx("sup", {
            children: "2"
          })]
        }), jsxRuntimeExports.jsxs("div", {
          className: "flex-option-card__amount",
          children: [jsxRuntimeExports.jsx(Span, {
            variant: "headline-medium",
            bold: true,
            children: formatCurrency(estimate.suggestedMonthlyPayment, 2)
          }), jsxRuntimeExports.jsx(Span, {
            variant: "body-medium",
            children: "/month"
          }), estimate.promoPeriodMonths != null && jsxRuntimeExports.jsxs(Span, {
            variant: "body-medium",
            className: "flex-option-card__payment-count",
            children: [estimate.promoPeriodMonths, " payments"]
          })]
        })]
      }), jsxRuntimeExports.jsxs("div", {
        className: "flex-option-card__breakdown",
        children: [jsxRuntimeExports.jsxs("div", {
          className: "flex-option-card__breakdown-row",
          children: [jsxRuntimeExports.jsx(Span, {
            variant: "body-medium",
            children: "Total Treatment Amount"
          }), jsxRuntimeExports.jsx(Span, {
            variant: "body-medium",
            children: formatCurrency(estimate.amount, 2)
          })]
        }), jsxRuntimeExports.jsxs("div", {
          className: "flex-option-card__breakdown-row flex-option-card__breakdown-row--highlighted",
          children: [jsxRuntimeExports.jsx(Span, {
            variant: "body-medium",
            children: "Down Payment"
          }), jsxRuntimeExports.jsxs(Span, {
            variant: "body-medium",
            children: ["- ", formatCurrency(estimate.downPayment, 2)]
          })]
        }), jsxRuntimeExports.jsx("div", {
          className: "flex-option-card__breakdown-divider"
        }), jsxRuntimeExports.jsxs("div", {
          className: "flex-option-card__breakdown-row",
          children: [jsxRuntimeExports.jsx(Span, {
            variant: "body-medium",
            children: "Total Financed Amount"
          }), jsxRuntimeExports.jsxs(Span, {
            variant: "body-medium",
            bold: true,
            children: ["= ", formatCurrency(estimate.financedAmount, 2)]
          })]
        })]
      })]
    }) : jsxRuntimeExports.jsxs("div", {
      className: "flex-option-card__loading",
      children: [jsxRuntimeExports.jsx(Spinner, {
        color: "orange",
        size: "small",
        dataTestId: `flex-option-card-spinner-${optionNumber ?? 1}`
      }), jsxRuntimeExports.jsx(P, {
        variant: "body-medium",
        children: "Calculating treatment plan..."
      })]
    })
  });
}

function GradientStepper({
  totalSteps,
  currentStep,
  label = '',
  className = ''
}) {
  const steps = Math.max(0, Math.floor(totalSteps));
  const filled = Math.min(Math.max(Math.floor(currentStep), 0), steps);
  return jsxRuntimeExports.jsxs("div", {
    className: classNames('gradient-stepper', className),
    children: [jsxRuntimeExports.jsx("div", {
      className: "gradient-stepper__track",
      role: "progressbar",
      "aria-label": label || 'Progress',
      "aria-valuemin": 0,
      "aria-valuemax": steps,
      "aria-valuenow": filled,
      children: Array.from({
        length: steps
      }, (_, i) => {
        const isFilled = i < filled;
        // The gradient (defined in SCSS as --gs-gradient) spans the whole track;
        // size it to N segments and shift it so this segment shows its own window.
        const style = isFilled ? {
          backgroundSize: `${steps * 100}% 100%`,
          backgroundPositionX: steps > 1 ? `${i / (steps - 1) * 100}%` : '0%'
        } : undefined;
        return jsxRuntimeExports.jsx("div", {
          className: classNames('gradient-stepper__segment', {
            'gradient-stepper__segment--filled': isFilled
          }),
          style: style,
          "data-testid": `gradient-stepper-segment-${i}`
        }, i);
      })
    }), label && jsxRuntimeExports.jsx(P, {
      variant: "body-medium",
      className: "gradient-stepper__label",
      children: label
    })]
  });
}

function InputTip(props) {
  const [focus, setFocus] = useState(false);
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsx(props.inputType, {
      onFocus: () => {
        setFocus(true);
      },
      ...props
    }), jsxRuntimeExports.jsx(FormSpy, {
      name: props.input.name,
      focused: focus,
      children: val => {
        if ((val || focus) && props.tooltips) {
          return jsxRuntimeExports.jsx(props.tooltips, {});
        }
        return null;
      }
    })]
  });
}

function InputWithToolTip({
  input,
  tooltips: ToolTips,
  ...rest
}) {
  const [focus, setFocus] = useState(false);
  return jsxRuntimeExports.jsxs("div", {
    children: [jsxRuntimeExports.jsx(Input, {
      onFocus: () => {
        setFocus(true);
      },
      ...rest
    }), jsxRuntimeExports.jsx(FormSpy, {
      name: input.name,
      focused: focus,
      children: val => {
        if (val || focus) {
          return jsxRuntimeExports.jsx(ToolTips, {});
        }
        return null;
      }
    })]
  });
}

function InputCheckbox({
  input,
  meta,
  dataTestId,
  hideBreakTag = false,
  rest
}) {
  const cleanRest = omit(rest, ['label', 'dataTestId', 'hideBreakTag']);
  const hasError = (meta.error || meta.submitError) && meta.touched;
  return jsxRuntimeExports.jsxs("span", {
    className: "input-checkbox-container",
    children: [hasError && jsxRuntimeExports.jsx("div", {
      className: "input-checkbox-error-message",
      children: jsxRuntimeExports.jsx(Span, {
        variant: "headline-medium",
        children: "*"
      })
    }), hideBreakTag ? null : jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx("input", {
      ...input,
      ...cleanRest,
      type: "checkbox",
      className: classNames({
        'input-checkbox': true,
        'input-checkbox-error': hasError
      }),
      "data-testid": dataTestId
    })]
  });
}

function InputDate({
  fieldName,
  dataTestId,
  fieldLabel,
  additionalValidators
}) {
  return jsxRuntimeExports.jsx(Field$1, {
    id: fieldName,
    name: fieldName,
    type: "text",
    "data-testid": dataTestId,
    placeholder: "MM/DD/YYYY",
    validate: composeValidators(validateRequired, validateLength(10, 10, 'Expected format should be mm/dd/yyyy'), ...(additionalValidators ?? [])),
    parse: formatDateFromInputString,
    children: ({
      input,
      meta
    }) => jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
      children: [' ', jsxRuntimeExports.jsx(Label, {
        size: "medium",
        htmlFor: fieldName,
        className: meta.error && meta.touched ? 'invalid' : '',
        children: fieldLabel
      }), jsxRuntimeExports.jsx("input", {
        ...input,
        id: fieldName,
        className: meta.error && meta.touched ? 'invalid' : '',
        placeholder: "mm/dd/yyyy"
      }), meta.error && meta.touched ? jsxRuntimeExports.jsx("span", {
        className: "error",
        children: meta.error
      }) : jsxRuntimeExports.jsx("span", {})]
    })
  });
}

const InputDateMask = ({
  input,
  meta,
  ...rest
}) => {
  const {
    label = '',
    placeholder = '',
    required,
    requiredIndicator = ' *',
    altclass = null
  } = rest;
  /*
    https://www.npmjs.com/package/react-imask
    use ref to get access to internal "masked = ref.current.maskRef"
    const ref = React.useRef(null);
    const inputRef = React.useRef(null);
  */
  const labelClass = classNames({
    'form-label': altclass === 'coreUI'
  });
  const inputClass = classNames({
    'form-control': altclass === 'coreUI'
  });
  return jsxRuntimeExports.jsxs("fieldset", {
    "data-testid": `fieldset-${input.name}`,
    className: `input-date-mask-fieldset ${input.className ? input.className : undefined}`,
    children: [jsxRuntimeExports.jsx("span", {
      children: jsxRuntimeExports.jsxs("label", {
        "data-testid": `label-${input.name}`,
        htmlFor: input.name,
        className: `${altclass ? labelClass : ''}`,
        children: [label, required && jsxRuntimeExports.jsx("span", {
          className: "required-indicator",
          "aria-hidden": "true",
          children: requiredIndicator
        })]
      })
    }), jsxRuntimeExports.jsx("div", {
      className: "input-wrapper",
      children: jsxRuntimeExports.jsx(IMaskInput, {
        ...input,
        ...rest,
        onAccept: input.onChange,
        type: "tel",
        placeholder: placeholder,
        name: input.name,
        pattern: 'm/d/Y',
        parse: str => {
          const fullDate = str.split('/');
          return new Date(Number(fullDate[2]),
          // Year
          Number(fullDate[0]) - 1,
          // Month
          Number(fullDate[1]) // Day
          );
        },
        className: `input-date-mask ${altclass ? inputClass : ''}`,
        format: date => {
          if (date) {
            let day = date.getDate().toString();
            let month = String(date.getMonth() + 1);
            const year = date.getFullYear();
            if (Number(day) < 10) day = '0' + day;
            if (Number(month) < 10) month = '0' + month;
            return [month, day, year].join('/');
          }
        },
        "data-testid": `input-${input.name}`
      })
    }), (meta.error || meta.submitError) && meta.touched && jsxRuntimeExports.jsx("span", {
      className: "error-message",
      children: meta.error || meta.submitError
    })]
  });
};

const InputMask = ({
  input,
  meta,
  ...rest
}) => {
  const {
    label = '',
    // placeholder = '',
    required,
    requiredIndicator = ' *',
    labelnote = null,
    hinttype = null
  } = rest;
  const fieldClass = classNames({
    [input.className]: input.className,
    'error-fieldset': meta.error && meta.touched || meta.error && meta.pristine === false
  });
  /*
    https://www.npmjs.com/package/react-imask
    use ref to get access to internal "masked = ref.current.maskRef"
    const ref = React.useRef(null);
    const inputRef = React.useRef(null);
  */
  return jsxRuntimeExports.jsxs("fieldset", {
    "data-testid": `fieldset-${input.name}`,
    className: fieldClass,
    children: [jsxRuntimeExports.jsxs("span", {
      children: [jsxRuntimeExports.jsxs(Label, {
        size: "medium",
        "data-testid": `label-${input.name}`,
        htmlFor: input.name,
        children: [label, required && jsxRuntimeExports.jsx(Span, {
          variant: "title-medium",
          className: "required-indicator",
          "aria-hidden": "true",
          children: requiredIndicator
        })]
      }), labelnote && labelnote]
    }), jsxRuntimeExports.jsx("div", {
      className: "input-wrapper",
      children: jsxRuntimeExports.jsx(IMaskInput, {
        placeholder: input.placeholder ?? '',
        ...input,
        ...rest,
        "data-testid": `input-${input.name}`
      })
    }), (meta.error || meta.submitError) && meta.touched && jsxRuntimeExports.jsx(Span, {
      variant: "title-medium",
      className: "error-message",
      children: meta.error || meta.submitError
    }), meta.modified && hinttype ? hinttype : null]
  });
};

const InputMask2 = ({
  input,
  meta,
  ...rest
}) => {
  const {
    label = '',
    placeholder = '',
    required,
    requiredIndicator = ' *',
    mask,
    maskChar = ' '
  } = rest;
  /*
    https://www.npmjs.com/package/react-imask
    use ref to get access to internal "masked = ref.current.maskRef"
    const ref = React.useRef(null);
    const inputRef = React.useRef(null);
  */
  return jsxRuntimeExports.jsxs("fieldset", {
    "data-testid": `fieldset-${input.name}`,
    className: `${input.className ? input.className : undefined}`,
    children: [jsxRuntimeExports.jsx("span", {
      children: jsxRuntimeExports.jsxs("label", {
        "data-testid": `label-${input.name}`,
        htmlFor: input.name,
        children: [label, required && jsxRuntimeExports.jsx("span", {
          className: "required-indicator",
          "aria-hidden": "true",
          children: requiredIndicator
        })]
      })
    }), jsxRuntimeExports.jsx("div", {
      className: "input-wrapper",
      children: jsxRuntimeExports.jsx(InputMask$1, {
        ...input,
        ...rest,
        maskChar: maskChar,
        mask: mask,
        placeholder: placeholder,
        "data-testid": `input-${input.name}`
      })
    }), (meta.error || meta.submitError) && meta.touched && jsxRuntimeExports.jsx("span", {
      className: "error-message",
      children: meta.error || meta.submitError
    })]
  });
};

const InputNumber = ({
  input,
  meta,
  ...rest
}) => {
  const {
    label = '',
    placeholder = '',
    required,
    requiredIndicator = ' *',
    labelnote = null,
    hinttype = null,
    isAllowed = undefined,
    hiddenicon = 'false',
    preicon = false,
    allowLeadingZeros = true,
    datatestid = '',
    altclass = null,
    fieldclass = ''
  } = rest;
  const [typePassword, setTypePassword] = useState(hiddenicon);
  const [iconOpen, setIconOpen] = useState(false);
  const handleClickIcon = () => {
    setIconOpen(!iconOpen);
  };
  const inputType = useMemo(() => {
    if (typePassword === 'true') {
      return 'password';
    } else {
      return 'tel';
    }
  }, [typePassword]);
  useEffect(() => {
    if (iconOpen) {
      setTypePassword('false');
    } else {
      setTypePassword('true');
    }
  }, [iconOpen]);
  useEffect(() => {
    setTypePassword(hiddenicon);
  }, [hiddenicon]);
  const fieldClass = input && meta ? classNames({
    [fieldclass]: fieldclass ?? false,
    'error-fieldset': meta.error && meta.touched || meta.error && meta.pristine === false,
    'pre-icon': rest.preicon
  }) : '';
  const labelClass = classNames({
    'form-label': altclass === 'coreUI'
  });
  const inputClass = classNames({
    'form-control': altclass === 'coreUI'
  });
  const inputName = input ? input.name : datatestid;
  return jsxRuntimeExports.jsxs("fieldset", {
    "data-testid": `fieldset-${inputName}`,
    className: fieldClass,
    children: [jsxRuntimeExports.jsxs("span", {
      className: "whitespace-nowrap",
      children: [jsxRuntimeExports.jsxs(Label, {
        size: "medium",
        "data-testid": `label-${inputName}`,
        htmlFor: inputName,
        className: `${altclass ? labelClass : ''}`,
        children: [label, required && jsxRuntimeExports.jsx("span", {
          className: "required-indicator",
          "aria-hidden": "true",
          children: requiredIndicator
        }), rest.tooltip ? jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
          children: rest.tooltip
        }) : null]
      }), labelnote && labelnote]
    }), jsxRuntimeExports.jsx("div", {
      className: "input-wrapper",
      children: jsxRuntimeExports.jsxs("div", {
        className: "flex-center",
        children: [preicon ? jsxRuntimeExports.jsx("div", {
          className: "pre-icon-container",
          children: preicon
        }) : null, jsxRuntimeExports.jsx(NumericFormat, {
          ...input,
          ...rest,
          className: `${altclass ? inputClass : ''}`,
          name: inputName,
          allowLeadingZeros: allowLeadingZeros,
          "data-testid": `input-${inputName}`,
          placeholder: placeholder,
          isAllowed: isAllowed,
          type: inputType
        }), jsxRuntimeExports.jsx("div", {
          className: "input-hidden-icon",
          children: hiddenicon === 'true' ? jsxRuntimeExports.jsx("button", {
            type: "button",
            onClick: handleClickIcon,
            children: iconOpen ? jsxRuntimeExports.jsx(VisibilityIcon, {}) : jsxRuntimeExports.jsx(VisibilityOffIcon, {})
          }) : null
        })]
      })
    }), meta && (meta.error || meta.submitError) && (meta.touched || meta.modified) && jsxRuntimeExports.jsx("span", {
      className: "error-message",
      children: meta.error || meta.submitError
    }), meta && (meta.active || meta.modified || meta.touched) && hinttype ? hinttype : null]
  });
};

const InputPattern = ({
  input,
  meta,
  ...rest
}) => {
  const {
    label = '',
    placeholder = '',
    required,
    requiredIndicator = ' *',
    labelnote = null,
    hinttype = null,
    isAllowed = undefined,
    formattype,
    altclass = null
  } = rest;
  const hasInputVal = input.value !== '';
  const fieldClass = classNames({
    [input.className]: input.className,
    'error-fieldset': meta.error && meta.touched || meta.error && meta.pristine === false && hasInputVal
  });
  const labelClass = classNames({
    'form-label': altclass === 'coreUI'
  });
  const inputClass = classNames({
    'form-control': altclass === 'coreUI'
  });
  return jsxRuntimeExports.jsxs("fieldset", {
    "data-testid": `fieldset-${input.name}`,
    className: fieldClass,
    children: [jsxRuntimeExports.jsxs("span", {
      children: [jsxRuntimeExports.jsxs(Label, {
        size: "medium",
        "data-testid": `label-${input.name}`,
        htmlFor: input.name,
        className: `${altclass ? labelClass : ''}`,
        children: [label, required && jsxRuntimeExports.jsx("span", {
          className: "required-indicator",
          "aria-hidden": "true",
          children: requiredIndicator
        }), rest.tooltip ? jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
          children: rest.tooltip
        }) : null]
      }), labelnote && labelnote]
    }), jsxRuntimeExports.jsx("div", {
      className: "input-wrapper",
      children: jsxRuntimeExports.jsx(PatternFormat, {
        ...input,
        ...rest,
        className: `${altclass ? inputClass : ''}`,
        format: formattype,
        name: input.name,
        "data-testid": `input-${input.name}`,
        placeholder: placeholder,
        isAllowed: isAllowed,
        type: "tel",
        renderText: value => jsxRuntimeExports.jsx("b", {
          children: value
        })
      })
    }), (meta.error || meta.submitError) && meta.touched && jsxRuntimeExports.jsx("span", {
      className: "error-message",
      children: meta.error || meta.submitError
    }), (meta.active || meta.modified || meta.touched || hasInputVal) && hinttype ? hinttype : null]
  });
};

function InputRadio({
  input,
  meta,
  ...rest
}) {
  const cleanRest = {
    ...rest,
    label: undefined,
    // Removed or console error
    radiotext: undefined,
    errhide: undefined
  };
  return jsxRuntimeExports.jsxs("div", {
    children: [jsxRuntimeExports.jsxs("div", {
      className: "flex align-center",
      children: [jsxRuntimeExports.jsx("input", {
        type: "radio",
        ...input,
        ...cleanRest,
        "data-testid": `input-radio-${input.name}`
      }), rest.radiotext ? jsxRuntimeExports.jsxs("span", {
        children: [" ", rest.radiotext]
      }) : null]
    }), (meta.error || meta.submitError) && meta.touched && !rest.errhide && jsxRuntimeExports.jsx("span", {
      className: "error-message",
      children: meta.error || meta.submitError
    })]
  });
}

const InputSelectNative = ({
  label = 'State',
  name = 'state',
  placeholder = 'Select',
  placeholderDisabled = true,
  options = STATES,
  altclass = undefined,
  fieldclass = '',
  disabled = false,
  required = false,
  validators = []
}) => {
  const labelClass = classNames({
    'form-label': altclass === 'coreUI'
  });
  const inputClass = classNames({
    'form-control': altclass === 'coreUI'
  });
  const combinedValidations = required ? [validateRequired, ...validators] : validators;
  return jsxRuntimeExports.jsx(Field$1, {
    name: name,
    subscription: {
      touched: true,
      error: true
    },
    render: ({
      meta: {
        touched,
        error,
        submitError
      }
    }) => jsxRuntimeExports.jsxs("fieldset", {
      "data-testid": `fieldset-${name}`,
      className: classNames({
        'error-fieldset': (error || submitError) && touched,
        [fieldclass]: true
      }),
      children: [jsxRuntimeExports.jsxs(Label, {
        size: "medium",
        className: `${altclass ? labelClass : ''} label-medium`,
        htmlFor: name,
        children: [label, required && jsxRuntimeExports.jsx("span", {
          className: "required-indicator",
          "aria-hidden": "true",
          children: ' *'
        })]
      }), jsxRuntimeExports.jsxs(Field$1, {
        required: required,
        disabled: disabled,
        name: name,
        component: "select",
        defaultValue: '',
        className: `${altclass ? inputClass : ''}`,
        "data-testid": `input-${name}`,
        validate: composeValidators(...combinedValidations),
        children: [jsxRuntimeExports.jsx("option", {
          value: "",
          disabled: placeholderDisabled,
          children: placeholder
        }), options.map((itm, idx) => {
          return jsxRuntimeExports.jsx("option", {
            value: itm.value,
            children: itm.key ?? itm.label
          }, `select-option-${name}-${itm.key ?? itm.label}-${idx}`);
        })]
      }), jsxRuntimeExports.jsx(Error$1, {
        name: name
      })]
    })
  });
};
const Error$1 = ({
  name
}) => jsxRuntimeExports.jsx(Field$1, {
  name: name,
  subscription: {
    touched: true,
    error: true
  },
  render: ({
    meta: {
      touched,
      error,
      submitError
    }
  }) => (error || submitError) && touched ? jsxRuntimeExports.jsx("span", {
    className: "error-message select-error",
    children: error || submitError
  }) : null
});

var LockOutlined = {};

var hasRequiredLockOutlined;
function requireLockOutlined() {
  if (hasRequiredLockOutlined) return LockOutlined;
  hasRequiredLockOutlined = 1;
  var _interopRequireDefault = requireInteropRequireDefault();
  var _interopRequireWildcard = requireInteropRequireWildcard();
  Object.defineProperty(LockOutlined, "__esModule", {
    value: true
  });
  LockOutlined.default = void 0;
  var React = _interopRequireWildcard(React__default);
  var _createSvgIcon = _interopRequireDefault( /*@__PURE__*/requireCreateSvgIcon());
  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
  }), 'LockOutlined');
  LockOutlined.default = _default;
  return LockOutlined;
}

var LockOutlinedExports = /*@__PURE__*/ requireLockOutlined();
var LockOutlinedIcon = /*@__PURE__*/getDefaultExportFromCjs(LockOutlinedExports);

function InputSSN({
  input,
  meta,
  placeholder = 'Social Security Number / ITIN',
  label = 'Social Security Number',
  altClass = null,
  required = false,
  requiredIndicator = ' *',
  tooltip = null,
  labelNote = null,
  formChange,
  resetDisplaySSN,
  setResetDisplaySSN
}) {
  const [rawSSN, setRawSSN] = useState('');
  const [displayValue, setDisplayValue] = useState('');
  const [isCensored, setIsCensored] = useState(true);
  const applyMask = value => {
    let maskedValue = value.split('').map((char, index) => index < 5 && isCensored ? 'X' : char).join('');
    if (maskedValue.length > 3 && maskedValue.length < 6) {
      maskedValue = maskedValue.slice(0, 3) + '-' + maskedValue.slice(3);
    } else if (maskedValue.length > 5) {
      maskedValue = maskedValue.slice(0, 3) + '-' + maskedValue.slice(3, 5) + '-' + maskedValue.slice(5);
    }
    return maskedValue;
  };
  const handleChange = e => {
    if (e.target.value.length > 11) {
      return;
    }
    if (e.target.value.length <= displayValue.length) {
      let newDisplayValue = displayValue.slice(0, -1);
      if (newDisplayValue.slice(-1) === '-') {
        newDisplayValue = newDisplayValue.slice(0, -1);
      }
      setDisplayValue(newDisplayValue);
      setRawSSN(rawSSN.slice(0, -1));
    } else {
      const onlyNums = e.target.value.replace(/[^0-9]+/g, '');
      const lastDigit = onlyNums.slice(-1);
      if (!isNumberString(lastDigit)) {
        return;
      }
      const newValue = rawSSN + lastDigit;
      setRawSSN(newValue);
      setDisplayValue(applyMask(newValue));
    }
  };
  useEffect(() => {
    const onlyNumbers = rawSSN.replace(/[^0-9]+/g, '');
    formChange(input.name, onlyNumbers);
  }, [rawSSN]);
  useEffect(() => {
    if (input.value) {
      setDisplayValue(applyMask(input.value));
    }
  }, [isCensored]);
  useEffect(() => {
    if (resetDisplaySSN && setResetDisplaySSN) {
      setDisplayValue('');
      setResetDisplaySSN(false);
    }
  }, [resetDisplaySSN]);
  const fieldClass = classNames({
    [input.className]: input.className,
    'error-fieldset': meta.error && meta.touched || meta.error && meta.pristine === false && input.value !== ''
  });
  const labelClass = classNames({
    'form-label': altClass === 'coreUI'
  });
  const inputClass = classNames({
    'form-control': altClass === 'coreUI'
  });
  return jsxRuntimeExports.jsxs("fieldset", {
    "data-testid": `fieldset-${input.name}`,
    className: fieldClass,
    children: [jsxRuntimeExports.jsxs("span", {
      children: [jsxRuntimeExports.jsxs(Label, {
        size: "medium",
        "data-testid": `label-${input.name}`,
        htmlFor: input.name,
        className: `${altClass ? labelClass : ''}`,
        children: [label, required && jsxRuntimeExports.jsx("span", {
          className: "required-indicator",
          "aria-hidden": "true",
          children: requiredIndicator
        }), tooltip ? jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
          children: tooltip
        }) : null]
      }), labelNote && labelNote]
    }), jsxRuntimeExports.jsxs("div", {
      className: "input-wrapper",
      children: [jsxRuntimeExports.jsxs("div", {
        className: "flex-center",
        children: [jsxRuntimeExports.jsx("input", {
          type: "tel",
          ...input,
          name: `fake-${input.name}`,
          onChange: handleChange,
          value: displayValue,
          placeholder: placeholder,
          className: `${altClass ? inputClass : ''}`
        }), jsxRuntimeExports.jsx("input", {
          type: "hidden",
          ...input
        }), jsxRuntimeExports.jsx("div", {
          className: "input-hidden-icon",
          children: jsxRuntimeExports.jsx("button", {
            onClick: () => setIsCensored(!isCensored),
            type: "button",
            children: isCensored ? jsxRuntimeExports.jsx(VisibilityOffIcon, {}) : jsxRuntimeExports.jsx(VisibilityIcon, {})
          })
        })]
      }), (meta.error || meta.submitError) && meta.touched && jsxRuntimeExports.jsx("span", {
        className: "error-message",
        children: meta.error || meta.submitError
      }), (meta.touched || meta.active) && jsxRuntimeExports.jsxs("div", {
        className: "ssn-tip",
        children: [jsxRuntimeExports.jsx(LockOutlinedIcon, {
          className: "gray-icon"
        }), jsxRuntimeExports.jsx(P, {
          children: "\u00A0We use your social security or ITIN number to validate your information and check your credit. Your information is transmitted securely."
        })]
      })]
    })]
  });
}

const InputText = ({
  input,
  meta,
  ...rest
}) => {
  const {
    label = '',
    placeholder = '',
    required,
    requiredIndicator = ' *',
    labelNote = '',
    altclass = null,
    preicon = false,
    posticon = false,
    fieldsetclass = '',
    labelclass = '',
    errors
  } = rest;
  const fieldClass = classNames({
    [input.className]: input.className,
    'error-fieldset': meta.error && meta.touched || meta.error && meta.pristine === false && input.value !== '',
    [fieldsetclass]: fieldsetclass
  });
  const labelClass = classNames({
    'form-label': altclass === 'coreUI'
  });
  const inputClass = classNames({
    'form-control': altclass === 'coreUI'
  });
  return jsxRuntimeExports.jsxs("fieldset", {
    "data-testid": `fieldset-${input.name}`,
    className: fieldClass,
    children: [jsxRuntimeExports.jsx("span", {
      children: jsxRuntimeExports.jsxs(Label, {
        size: "medium",
        "data-testid": `label-${input.name}`,
        htmlFor: input.name,
        className: classNames({
          [altclass ? labelClass : '']: altclass,
          [labelclass]: labelclass
        }),
        children: [label, required && jsxRuntimeExports.jsx(Span, {
          variant: "title-medium",
          className: "required-indicator",
          "aria-hidden": "true",
          children: requiredIndicator
        }), labelNote && jsxRuntimeExports.jsx(Span, {
          variant: "title-medium",
          className: "label-note",
          children: `- ${labelNote}`
        }), rest.tooltip ? jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
          children: rest.tooltip
        }) : null]
      })
    }), jsxRuntimeExports.jsxs("div", {
      className: "input-wrapper",
      children: [preicon ? jsxRuntimeExports.jsx("div", {
        className: "pre-icon-container",
        children: preicon
      }) : null, jsxRuntimeExports.jsx("input", {
        ...input,
        ...rest,
        "data-testid": `input-${input.name}`,
        type: 'text',
        placeholder: placeholder,
        className: `${altclass ? inputClass : ''}`
      }), posticon ? jsxRuntimeExports.jsx("div", {
        className: "post-icon-container",
        children: posticon
      }) : null]
    }), ((meta.error || meta.submitError) && meta.touched || errors) && jsxRuntimeExports.jsx(Span, {
      variant: "title-medium",
      className: "error-message",
      children: errors || meta.error || meta.submitError
    })]
  });
};

const Checkbox = /*#__PURE__*/forwardRef(({
  hasError,
  labelElement = null,
  color = 'red',
  alignment = 'center',
  ...rest
}, ref) => jsxRuntimeExports.jsxs("div", {
  className: `input-checkbox-container-v2 input-checkbox-container-v2--align-${alignment}`,
  children: [jsxRuntimeExports.jsx("input", {
    ref: ref,
    type: "checkbox",
    className: `input-checkbox-v2 input-checkbox-v2--${color} ${hasError ? 'with-error' : ''}`,
    "data-testid": `input-checkbox-${rest.name}`,
    ...rest
  }), labelElement && jsxRuntimeExports.jsx("label", {
    htmlFor: rest.name,
    className: "input-checkbox-v2-label",
    children: labelElement
  })]
}));
Checkbox.displayName = 'CheckboxV2';

function InputContainer({
  children,
  labelElement = null,
  error,
  name,
  type = 'text'
}) {
  function getClassPrefix() {
    switch (type) {
      case 'text':
        return 'input-text-v2';
      case 'textarea':
        return 'text-area';
      case 'select':
        return 'input-select-v2';
    }
  }
  const classPrefix = getClassPrefix();
  return jsxRuntimeExports.jsxs("div", {
    className: `${classPrefix}-container`,
    children: [labelElement && jsxRuntimeExports.jsx("label", {
      htmlFor: name,
      children: labelElement
    }), children, error && jsxRuntimeExports.jsx("p", {
      className: `${classPrefix}-error-message`,
      children: error
    })]
  });
}

const InputAmountV2 = /*#__PURE__*/forwardRef(({
  name,
  placeholder = '',
  error = null,
  labelElement = null,
  symbol = '$',
  plainSymbol = false,
  ...rest
}, ref) => jsxRuntimeExports.jsx(InputContainer, {
  name: name,
  labelElement: labelElement,
  error: error,
  children: jsxRuntimeExports.jsxs("div", {
    className: `input-amount-v2-wrapper ${plainSymbol ? 'input-amount-v2-wrapper--plain' : ''}`,
    children: [jsxRuntimeExports.jsx("span", {
      "aria-hidden": "true",
      className: "input-amount-v2-symbol",
      children: symbol
    }), jsxRuntimeExports.jsx(NumericFormat, {
      type: "tel",
      placeholder: placeholder,
      className: `input-text-v2 input-amount-v2-input ${error ? 'input-text-v2-error' : ''}`,
      name: name,
      thousandSeparator: ",",
      decimalScale: 2,
      allowNegative: false,
      "data-testid": `input-amount-${name}`,
      ...rest,
      getInputRef: ref
    })]
  })
}));
InputAmountV2.displayName = 'InputAmountV2';

const InputDOB = /*#__PURE__*/forwardRef(({
  placeholder = 'Enter date of birth',
  error = null,
  withDays = true,
  labelElement = null,
  name,
  ...rest
}, ref) => jsxRuntimeExports.jsx(InputContainer, {
  name: name,
  labelElement: labelElement,
  error: error,
  children: jsxRuntimeExports.jsx(PatternFormat, {
    type: "tel",
    format: withDays ? '##/##/####' : '##/####',
    placeholder: placeholder,
    className: `input-text-v2 ${error ? 'input-text-v2-error' : ''}`,
    name: name,
    "data-testid": `input-dob-${name}`,
    ...rest,
    getInputRef: ref
  })
}));
InputDOB.displayName = 'InputDOB';

const InputNumberV2 = /*#__PURE__*/forwardRef(({
  placeholder = 'Enter zip code',
  error = null,
  labelElement = null,
  name,
  ...rest
}, ref) => jsxRuntimeExports.jsx(InputContainer, {
  name: name,
  labelElement: labelElement,
  error: error,
  children: jsxRuntimeExports.jsx(NumericFormat, {
    type: "tel",
    placeholder: placeholder,
    className: `input-text-v2 ${error ? 'input-text-v2-error' : ''}`,
    name: name,
    "data-testid": `input-zip-${name}`,
    getInputRef: ref,
    ...rest
  })
}));
InputNumberV2.displayName = 'InputNumberV2';

const InputPhone = /*#__PURE__*/forwardRef(({
  placeholder = 'Enter phone number',
  error = null,
  labelElement = null,
  name,
  ...rest
}, ref) => jsxRuntimeExports.jsx(InputContainer, {
  name: name,
  labelElement: labelElement,
  error: error,
  children: jsxRuntimeExports.jsx(PatternFormat, {
    type: "tel",
    format: "(###) ###-####",
    placeholder: placeholder,
    className: `input-text-v2 ${error ? 'input-text-v2-error' : ''}`,
    ...rest,
    "data-testid": `input-phone-${name}`,
    name: name,
    getInputRef: ref
  })
}));
InputPhone.displayName = 'InputPhoneV2';

const InputSSNV2 = /*#__PURE__*/forwardRef(({
  placeholder = 'Enter SSN',
  error = null,
  labelElement = null,
  name,
  ...rest
}, ref) => jsxRuntimeExports.jsx(InputContainer, {
  name: name,
  labelElement: labelElement,
  error: error,
  children: jsxRuntimeExports.jsx(PatternFormat, {
    type: "tel",
    format: "###-##-####",
    placeholder: placeholder,
    className: `input-text-v2 ${error ? 'input-text-v2-error' : ''}`,
    name: name,
    "data-testid": `input-ssn-${name}`,
    ...rest,
    getInputRef: ref
  })
}));
InputSSNV2.displayName = 'InputSSNV2';

const InputTaxId = /*#__PURE__*/forwardRef(({
  placeholder = 'Enter Tax ID',
  error = null,
  labelElement = null,
  name,
  ...rest
}, ref) => jsxRuntimeExports.jsx(InputContainer, {
  name: name,
  labelElement: labelElement,
  error: error,
  children: jsxRuntimeExports.jsx(PatternFormat, {
    type: "tel",
    format: "##-#######",
    placeholder: placeholder,
    className: `input-text-v2 ${error ? 'input-text-v2-error' : ''}`,
    name: name,
    "data-testid": `input-tax-id-${name}`,
    ...rest,
    getInputRef: ref
  })
}));
InputTaxId.displayName = 'InputTaxId';

const InputTextV2 = /*#__PURE__*/forwardRef(({
  placeholder = '',
  error = null,
  labelElement = null,
  allowSpecialCharacters = true,
  onChange,
  ...rest
}, ref) => {
  const handleChange = e => {
    if (!allowSpecialCharacters) {
      const sanitized = e.target.value.replace(/[!$#%^]/g, '');
      if (sanitized !== e.target.value) {
        e.target.value = sanitized;
      }
    }
    onChange?.(e);
  };
  return jsxRuntimeExports.jsx(InputContainer, {
    name: rest.name,
    labelElement: labelElement,
    error: error,
    children: jsxRuntimeExports.jsx("input", {
      ref: ref,
      type: "text",
      placeholder: placeholder,
      className: `input-text-v2 ${error ? 'input-text-v2-error' : ''}`,
      "data-testid": `input-text-${rest.name}`,
      onChange: handleChange,
      ...rest
    })
  });
});
InputTextV2.displayName = 'InputTextV2';

const InputZipV2 = /*#__PURE__*/forwardRef(({
  placeholder = 'Enter zip code',
  error = null,
  labelElement = null,
  name,
  ...rest
}, ref) => jsxRuntimeExports.jsx(InputNumberV2, {
  name: name,
  placeholder: placeholder,
  error: error,
  decimalScale: 0,
  allowLeadingZeros: false,
  allowNegative: false,
  labelElement: labelElement,
  isAllowed: values => {
    const {
      value
    } = values;
    return value.length <= 5;
  },
  "data-testid": `input-zip-${name}`,
  ...rest,
  getInputRef: ref
}));
InputZipV2.displayName = 'InputZipV2';

const Radio = /*#__PURE__*/forwardRef(({
  labelElement,
  color = 'red',
  ...rest
}, ref) => {
  const generatedId = useId$1();
  const inputId = rest.id ?? generatedId;
  return jsxRuntimeExports.jsxs("div", {
    className: "input-radio-container-v2",
    children: [jsxRuntimeExports.jsx("input", {
      ref: ref,
      type: "radio",
      className: `input-radio-v2 input-radio-v2--${color}`,
      ...rest,
      id: inputId,
      "data-testid": `input-radio-${rest.id ?? rest.name}`
    }), labelElement && jsxRuntimeExports.jsx("label", {
      htmlFor: inputId,
      className: "input-radio-v2-label",
      children: labelElement
    })]
  });
});
Radio.displayName = 'Radio';

const Select$1 = /*#__PURE__*/forwardRef(({
  options,
  placeholder = 'Select an option',
  error = null,
  labelElement = null,
  fancyMode = false,
  fancyOnChange,
  ...rest
}, ref) => jsxRuntimeExports.jsx(InputContainer, {
  name: rest.name,
  labelElement: labelElement,
  error: error,
  type: "select",
  children: fancyMode ? jsxRuntimeExports.jsx(ReactSelect, {
    options: options,
    value: options.find(o => o.value === rest.value) ?? null,
    onChange: selected => fancyOnChange?.(selected?.value ?? ''),
    styles: {
      control: baseStyles => ({
        ...baseStyles,
        border: `1px solid ${INLINE_COLORS.greyBase}`,
        borderRadius: '8px',
        margin: 0,
        padding: '4px 8px',
        fontSize: '0.875rem'
      }),
      container: baseStyles => ({
        ...baseStyles
      }),
      singleValue: baseStyles => ({
        ...baseStyles,
        color: '#00000e'
      }),
      menu: baseStyles => ({
        ...baseStyles,
        borderRadius: 0
      }),
      indicatorSeparator: baseStyles => ({
        ...baseStyles,
        display: 'none'
      }),
      dropdownIndicator: baseStyles => ({
        ...baseStyles,
        color: INLINE_COLORS.blackBase
      })
    },
    placeholder: placeholder
  }) : jsxRuntimeExports.jsxs("select", {
    ref: ref,
    ...rest,
    name: rest.name,
    className: `input-select-v2 ${error ? 'select-error' : ''}`,
    defaultValue: "",
    "data-testid": `input-select-${rest.name}`,
    children: [jsxRuntimeExports.jsx("option", {
      value: "",
      children: placeholder
    }), options.map(option => jsxRuntimeExports.jsx("option", {
      value: option.value,
      children: option.label
    }, option.value))]
  })
}));
Select$1.displayName = 'SelectV2';

const TextArea = /*#__PURE__*/forwardRef(({
  placeholder = '',
  error = null,
  labelElement = null,
  name,
  ...rest
}, ref) => {
  return jsxRuntimeExports.jsx(InputContainer, {
    name: name,
    labelElement: labelElement,
    error: error,
    type: "textarea",
    children: jsxRuntimeExports.jsx("textarea", {
      ref: ref,
      className: `text-area ${error ? 'text-area-error' : ''}`,
      placeholder: placeholder,
      name: name,
      "data-testid": `input-textarea-${name}`,
      ...rest
    })
  });
});
TextArea.displayName = 'TextArea';

function LinkButton({
  children,
  className,
  invalid,
  to = '#',
  ...rest
}, ref) {
  const buttonClassName = className ?? 'button-secondary';
  const buttonInvalid = invalid ?? false;
  return jsxRuntimeExports.jsx(Link, {
    to: buttonInvalid ? '#' : to,
    ...rest,
    children: jsxRuntimeExports.jsx(Button$1, {
      ref: ref,
      type: "button",
      className: buttonClassName,
      invalid: buttonInvalid,
      children: children
    })
  });
}
var LinkButton_default = /*#__PURE__*/forwardRef(LinkButton);

var img$5 = "data:image/svg+xml,%3csvg preserveAspectRatio='none' overflow='visible' style='display: block%3b' width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg id='close-circle'%3e%3cg id='Vector'%3e%3c/g%3e%3cpath id='Vector_2' d='M5.83333 14.1667L14.1667 5.83333' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round' stroke='%2300000E'/%3e%3cpath id='Vector_3' d='M14.1667 14.1667L5.83333 5.83333' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round' stroke='%2300000E'/%3e%3cg id='Vector_4' opacity='0'%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

function Modal({
  isOpen,
  setIsOpen,
  children,
  header,
  onAfterOpen,
  onRequestClose,
  contentLabel,
  contentClassName = '',
  modalTestId,
  closeBtnTestId,
  withCloseButton = true,
  withHandle = false
}) {
  const rootElement = document.getElementById('root');
  const handleClose = () => {
    if (onRequestClose) {
      onRequestClose();
    }
    setIsOpen(false);
  };
  return jsxRuntimeExports.jsx("div", {
    className: "modal-container",
    children: jsxRuntimeExports.jsxs(ReactModal, {
      isOpen: isOpen,
      onRequestClose: onRequestClose,
      onAfterOpen: onAfterOpen,
      contentLabel: contentLabel,
      appElement: rootElement || undefined,
      portalClassName: isOpen ? 'modal is-active' : 'modal is-inactive',
      className: classNames('modal-inner shared-modal flex-dir-col', contentClassName, withHandle ? 'with-handle' : ''),
      overlayClassName: "modal-fade-screen",
      bodyOpenClassName: "modal-open",
      "data-testid": modalTestId,
      children: [withCloseButton && jsxRuntimeExports.jsx("button", {
        onClick: handleClose,
        className: "modal-close",
        "aria-label": "Close Modal",
        "data-testid": closeBtnTestId,
        children: jsxRuntimeExports.jsx("img", {
          src: img$5,
          alt: "",
          width: 20,
          height: 20
        })
      }), jsxRuntimeExports.jsxs("div", {
        className: "modal-body",
        "data-testid": modalTestId,
        children: [header && jsxRuntimeExports.jsx("div", {
          className: "modal-header-row",
          children: header
        }), children]
      })]
    })
  });
}

const ReceiptAccountInfo = ({
  buyer,
  paymentDetails,
  lenderSettings = undefined,
  currentLocation,
  name,
  accountNumberLastFour,
  maskedLenderAccountIdentifier,
  onMissingAccountLastFour,
  availableCreditLimit,
  creditLimit,
  amount,
  authorizationCode,
  referenceId
}) => {
  const showSaleInText = lenderSettings?.lenderProductType != 'LTO';
  const CREDIT_TEXT = showSaleInText ? 'Available Credit' : 'Available Amount';
  const SALE_TEXT = showSaleInText ? 'Total Sales Amount' : 'Total Amount';
  const CREDIT_LIMIT_TEXT = showSaleInText ? 'Credit Limit' : 'Account Limit';
  const lastFourValue = accountNumberLastFour ?? maskedLenderAccountIdentifier?.slice(-4);
  const isLastFourMissing = lastFourValue == null || lastFourValue === '';
  const lastFourDisplay = isLastFourMissing ? '' : lastFourValue;
  const hasNotifiedMissingRef = useRef(false);
  useEffect(() => {
    if (isLastFourMissing && onMissingAccountLastFour && !hasNotifiedMissingRef.current) {
      hasNotifiedMissingRef.current = true;
      onMissingAccountLastFour();
    }
  }, [isLastFourMissing, onMissingAccountLastFour]);
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [buyer && jsxRuntimeExports.jsx(AuthBuyerSaleCard, {
      paymentDetails: {
        ...paymentDetails
      },
      currentLocation: currentLocation
    }), !buyer && jsxRuntimeExports.jsx("div", {
      className: "summary__card card m-t-30",
      children: jsxRuntimeExports.jsx("div", {
        className: "card-content",
        children: jsxRuntimeExports.jsxs("div", {
          className: "summary__account-info",
          children: [jsxRuntimeExports.jsxs(H2, {
            variant: "headline-medium",
            className: "mar-y-8",
            children: [name.firstName, " ", name.lastName]
          }), jsxRuntimeExports.jsxs("div", {
            className: "card-main",
            children: [jsxRuntimeExports.jsxs("div", {
              className: "card-main__left",
              children: [jsxRuntimeExports.jsx("div", {
                className: "info-container",
                children: jsxRuntimeExports.jsxs(P, {
                  variant: "body-large",
                  className: "mar-y-8",
                  children: [jsxRuntimeExports.jsx("strong", {
                    children: "Last 4 of Account Number: "
                  }), lastFourDisplay]
                })
              }), jsxRuntimeExports.jsx("div", {
                className: "info-container",
                children: jsxRuntimeExports.jsxs(P, {
                  variant: "body-large",
                  className: "mar-y-8",
                  children: [jsxRuntimeExports.jsx("strong", {
                    children: CREDIT_TEXT
                  }), ' ', formatCurrency(availableCreditLimit, 2)]
                })
              })]
            }), jsxRuntimeExports.jsxs("div", {
              className: "card-main__right",
              children: [jsxRuntimeExports.jsx("div", {
                className: "info-container",
                children: jsxRuntimeExports.jsxs(P, {
                  variant: "body-large",
                  className: "mar-y-8",
                  children: [jsxRuntimeExports.jsx("strong", {
                    children: CREDIT_LIMIT_TEXT
                  }), ' ', formatCurrency(creditLimit, 2)]
                })
              }), jsxRuntimeExports.jsx("div", {
                className: "info-container",
                children: jsxRuntimeExports.jsxs(P, {
                  variant: "body-large",
                  className: "mar-y-8",
                  children: [jsxRuntimeExports.jsx("strong", {
                    children: "Location "
                  }), currentLocation.name, " - ", currentLocation.adsStoreNumber]
                })
              })]
            })]
          })]
        })
      })
    }), jsxRuntimeExports.jsx("div", {
      className: "summary__card--bottom card",
      children: jsxRuntimeExports.jsx("div", {
        className: "card-content",
        children: jsxRuntimeExports.jsx("div", {
          className: "summary__account-info",
          children: jsxRuntimeExports.jsxs("div", {
            className: "card-main",
            children: [jsxRuntimeExports.jsxs("div", {
              className: "card-main__left",
              children: [jsxRuntimeExports.jsx("div", {
                className: "info-container ",
                children: jsxRuntimeExports.jsxs(P, {
                  variant: "body-large",
                  className: "mar-y-8",
                  children: [jsxRuntimeExports.jsx("strong", {
                    children: SALE_TEXT
                  }), " ", formatCurrency(amount, 2)]
                })
              }), jsxRuntimeExports.jsx("div", {
                className: "info-container",
                children: jsxRuntimeExports.jsxs(P, {
                  variant: "body-large",
                  className: "mar-y-8",
                  children: [jsxRuntimeExports.jsx("strong", {
                    children: "Authorization Code"
                  }), " ", authorizationCode]
                })
              })]
            }), jsxRuntimeExports.jsx("div", {
              className: "card-main__right",
              children: jsxRuntimeExports.jsx("div", {
                className: "info-container",
                children: jsxRuntimeExports.jsxs(P, {
                  variant: "body-large",
                  className: "mar-y-8",
                  children: [jsxRuntimeExports.jsx("strong", {
                    children: "Reference ID"
                  }), " ", referenceId]
                })
              })
            })]
          })
        })
      })
    })]
  });
};

const ReceiptDisplay = ({
  buyer,
  name,
  currentLocation,
  selectedPlanName,
  authorizationCode,
  lenderSettings = undefined,
  accountNumberLastFour,
  maskedLenderAccountIdentifier,
  onMissingAccountLastFour,
  isContractSignature,
  terms,
  amount
}) => {
  const isLTO = lenderSettings?.lenderProductType == 'LTO';
  const SALE_TEXT = isLTO ? 'Receipt' : 'Sales Receipt';
  const lastFourValue = accountNumberLastFour ?? maskedLenderAccountIdentifier?.slice(-4);
  const isLastFourMissing = lastFourValue == null || lastFourValue === '';
  const lastFourDisplay = isLastFourMissing ? '' : lastFourValue;
  const hasNotifiedMissingRef = useRef(false);
  if (isLastFourMissing && onMissingAccountLastFour && !hasNotifiedMissingRef.current) {
    hasNotifiedMissingRef.current = true;
    onMissingAccountLastFour();
  }
  const amountText = useCallback(() => {
    if (isLTO) {
      return 'Transaction Amount';
    } else if (isContractSignature) {
      return 'Amount Financed';
    } else {
      return 'Amount Charged';
    }
  }, [isContractSignature, isLTO]);
  return jsxRuntimeExports.jsxs("div", {
    className: "refund-complete__receipt m-t-50",
    children: [jsxRuntimeExports.jsx(H2, {
      variant: "headline-medium",
      className: "refund-complete__receipt--header",
      children: SALE_TEXT
    }), jsxRuntimeExports.jsxs("div", {
      className: "refund-complete__receipt--body",
      children: [!isContractSignature && jsxRuntimeExports.jsxs("div", {
        className: "refund-complete__receipt--info-container",
        children: [jsxRuntimeExports.jsxs("div", {
          className: "refund-complete__receipt--info",
          children: [jsxRuntimeExports.jsx(H3, {
            variant: "headline-small",
            className: "key",
            children: "Date"
          }), jsxRuntimeExports.jsx(H4, {
            variant: "title-large",
            className: "value",
            children: format(new Date(), 'MM/dd/yyyy')
          })]
        }), !isNil(buyer) && jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
          children: jsxRuntimeExports.jsxs("div", {
            className: "refund-complete__receipt--info",
            children: [jsxRuntimeExports.jsx(H3, {
              variant: "headline-small",
              className: "key",
              children: "Authorized Buyer"
            }), jsxRuntimeExports.jsx(H4, {
              variant: "title-large",
              className: "value",
              children: ` ${buyer.firstName} ${buyer.lastName}`
            })]
          })
        }), jsxRuntimeExports.jsxs("div", {
          className: "refund-complete__receipt--info",
          children: [jsxRuntimeExports.jsx(H3, {
            variant: "headline-small",
            className: "key",
            children: isNil(buyer) ? `Account Holder` : 'Responsible Party'
          }), jsxRuntimeExports.jsxs(H4, {
            variant: "title-large",
            className: "value",
            children: [' ', `${name.firstName} ${name.lastName}`]
          })]
        }), jsxRuntimeExports.jsxs("div", {
          className: "refund-complete__receipt--info",
          children: [jsxRuntimeExports.jsx(H3, {
            variant: "headline-small",
            className: "key",
            children: "Location"
          }), jsxRuntimeExports.jsxs(H4, {
            variant: "title-large",
            className: "value",
            children: [currentLocation.name, " - ", currentLocation.adsStoreNumber]
          })]
        }), jsxRuntimeExports.jsxs("div", {
          className: "refund-complete__receipt--info",
          children: [jsxRuntimeExports.jsx(H3, {
            variant: "headline-small",
            className: "key",
            children: "Plan Selected"
          }), jsxRuntimeExports.jsx(H4, {
            variant: "title-large",
            className: "value",
            children: selectedPlanName
          })]
        }), jsxRuntimeExports.jsx("div", {
          className: "disclaimer",
          children: terms.map(({
            text
          }, index) => jsxRuntimeExports.jsx("p", {
            className: "terms",
            dangerouslySetInnerHTML: {
              __html: text
            }
          }, index))
        })]
      }), jsxRuntimeExports.jsx("div", {
        className: "seperator"
      }), jsxRuntimeExports.jsxs("div", {
        className: "refund-complete__receipt--info-container",
        children: [!isContractSignature && jsxRuntimeExports.jsxs("div", {
          className: "refund-complete__receipt--info",
          children: [jsxRuntimeExports.jsx(H3, {
            variant: "headline-small",
            className: "key",
            children: "Authorization#"
          }), jsxRuntimeExports.jsx(H4, {
            variant: "title-large",
            className: "value",
            children: authorizationCode
          })]
        }), jsxRuntimeExports.jsxs("div", {
          className: "refund-complete__receipt--info",
          children: [jsxRuntimeExports.jsx(H3, {
            variant: "headline-small",
            className: "key",
            children: "Last Four of Account#"
          }), jsxRuntimeExports.jsxs(H4, {
            variant: "title-large",
            className: "value",
            children: [' ', lastFourDisplay]
          })]
        }), jsxRuntimeExports.jsxs("div", {
          className: "refund-complete__receipt--info",
          children: [jsxRuntimeExports.jsx(H3, {
            variant: "headline-small",
            className: "key",
            children: amountText()
          }), jsxRuntimeExports.jsx(H4, {
            variant: "title-large",
            className: "value",
            children: formatCurrency(amount, 2)
          })]
        }), jsxRuntimeExports.jsx("div", {
          className: "disclaimer",
          children: isContractSignature ? jsxRuntimeExports.jsxs(P, {
            variant: "body-large",
            children: ["Should be I agree to ", isLTO ? 'lease' : 'pay', " for these goods or services according to the terms of my ALPHAEON Alphaeon Access Program and if applicable, which may apply to this transaction.", ' ', isLTO ? '' : "If any purchase is not satisfactory, it will be subject to provider's refund policy."]
          }) : jsxRuntimeExports.jsx(P, {
            variant: "body-large",
            children: "I agree to pay for these goods or services according to the terms of my ALPHAEON Credit Card Agreement and if applicable, any Promotional Credit Plan, which may apply to this transaction. If any purchase is not satisfactory, it will be subject to provider's refund policy."
          })
        })]
      })]
    })]
  });
};

/**
 * @public
 * @name filterOptions
 * @description custom function for the Select component (react-select) to filter csv lists
 * @param candidate
 * @param input
 * @returns
 */
const filterOptions = (candidate, input) => {
  const labelLowercased = String(candidate.label).toLocaleLowerCase();
  const labelValue = candidate.value;
  // Multi-Search
  if (input.includes(',')) {
    const inputSplit = String(input).split(',');
    const isListNum = input.search(/([0-9])\w+/g); // is the array a list of store numbers
    const isListNames = input.search(/([a-z])\w+/g); // is the array a list of store numbers
    let checkOnly = false;
    if (isListNum >= 0 && isListNames < 0) {
      checkOnly = true; //inputSplit.length !== isListNum // dont match against the location id's
    }
    // Filter list vs search input
    const multiList = inputSplit.filter(itm => {
      if (checkOnly) {
        if (checkSelectMatch(labelLowercased, labelValue, itm, checkOnly)) return true;
      } else {
        if (checkSelectMatch(labelLowercased, labelValue, itm)) return true;
      }
    });
    return !!multiList.length;
    // Single-Search
  } else {
    if (checkSelectMatch(labelLowercased, labelValue, input)) return true;
  }
  return false; // default return required
};
/**
 * @private
 * @name checkSelectMatch
 * @description Check label or value match search input, or just id's
 */
const checkSelectMatch = (label, value, input, checkOnly = false) => {
  if (checkOnly) {
    // v2 - Checks only the end portion of the label
    const labelSplit = label.split(',');
    const lastItm = labelSplit.pop();
    if (String(lastItm).trim() == String(input).trim()) {
      return true;
    } else {
      return false;
    }
    // v1 - Checks whole string
  }
  if (label.includes(input.toLocaleLowerCase()) || Number(value) == Number(input) || arrayStringsIntersect(label, input)) {
    return true;
  }
};
/**
 * @private
 * @name arrayStringsIntersect
 * @description Finds common words between two strings
 */
const arrayStringsIntersect = (arr1, arr2) => {
  const arr2Split = arr2.split(' ');
  const hasLength = arr1.split(' ').filter(x => arr2Split.includes(x));
  if (hasLength.length) {
    return hasLength.length > 0 ? !!hasLength.length : false;
  } else {
    return false;
  }
};

const MenuList = ({
  options,
  children,
  maxHeight,
  getValue
}) => {
  const [value] = getValue();
  const height = options.length * MENU_HEIGHT;
  const isSmallSelect = height < maxHeight;
  const initialOffset = options.indexOf(value) >= 0 && !isSmallSelect ? options.indexOf(value) * MENU_HEIGHT : 0;
  return jsxRuntimeExports.jsx(FixedSizeList, {
    height: height < maxHeight ? height : maxHeight,
    itemCount: Children.count(children),
    itemSize: MENU_HEIGHT,
    initialScrollOffset: initialOffset,
    width: "100%",
    children: ({
      index,
      style
    }) => {
      return jsxRuntimeExports.jsxs("div", {
        style: style,
        children: [children && children[index], ' ']
      });
    }
  });
};
const Select = ({
  allOption = {
    label: 'Select all',
    value: '*'
  },
  allowSelectAll,
  className,
  initialValue,
  input,
  label,
  meta,
  options,
  required,
  placeholder,
  maxDisplay = MAX_DISPLAYED_SELECT_ITEMS,
  ...rest
}) => {
  const [defaultValue, setDefaultValue] = useState(initialValue);
  const [selectInput, setSelectInput] = useState('');
  const optionsData = allowSelectAll ? [allOption, ...options] : options;
  const MultiValue = ({
    index,
    getValue,
    ...rest
  }) => {
    const overflow = getValue().slice(maxDisplay).map(item => item.label);
    if (index < maxDisplay) {
      return jsxRuntimeExports.jsx(components.MultiValue, {
        ...rest,
        index: index,
        getValue: getValue
      });
    } else if (index === maxDisplay) {
      return jsxRuntimeExports.jsx(MoreSelectedBadge, {
        items: overflow
      });
    }
    return null;
  };
  return jsxRuntimeExports.jsxs("div", {
    className: classNames('select-container', className),
    children: [jsxRuntimeExports.jsxs(Label, {
      size: "small",
      htmlFor: input?.name,
      children: [label, required && jsxRuntimeExports.jsx("span", {
        className: "required-indicator",
        "aria-hidden": "true",
        children: "*"
      })]
    }), jsxRuntimeExports.jsxs("div", {
      className: "select-input",
      children: [jsxRuntimeExports.jsx(ReactSelect, {
        ...rest,
        classNamePrefix: "custom-select",
        onBlur: event => event.preventDefault(),
        filterOption: allowSelectAll ? filterOptions : createFilter({
          ignoreAccents: false
        }),
        components: {
          Option,
          MenuList,
          MultiValue
        },
        options: optionsData,
        value: defaultValue ? defaultValue : input?.value,
        defaultValue: defaultValue,
        placeholder: placeholder,
        inputValue: selectInput,
        onChange: selected => {
          if (selected !== null && selected.length > 0 && selected[selected.length - 1].value === allOption?.value) {
            return input.onChange(options);
          }
          setSelectInput('');
          setDefaultValue(undefined);
          return input.onChange(selected);
        },
        onInputChange: (newValue, action) => {
          // many selectable
          if (allowSelectAll) {
            // prevents resetting search
            if (action.action === 'input-change') {
              setSelectInput(newValue);
            }
          } else {
            if (action.action === 'input-change' || action.action === 'set-value') {
              setSelectInput(newValue);
            }
          }
        }
      }), meta && meta.touched && meta.error && jsxRuntimeExports.jsx("span", {
        className: "error-message",
        children: meta.error
      })]
    })]
  });
};
const Option = props => {
  return jsxRuntimeExports.jsx("div", {
    children: jsxRuntimeExports.jsx(components.Option, {
      ...props,
      className: "custom-option",
      children: jsxRuntimeExports.jsx("label", {
        children: props.label
      })
    })
  });
};
const MoreSelectedBadge = ({
  items
}) => {
  const length = items.length;
  const label = `+ ${length} item${length !== 1 ? 's' : ''} selected`;
  return jsxRuntimeExports.jsx("div", {
    className: "custom-select__truncation-label",
    children: label
  });
};

function isFetchError(e) {
  return e instanceof TypeError && e.message === 'Failed to fetch';
}
function ServerStatusOverlay({
  api
}) {
  const [showOverlay, setShowOverlay] = useState(false);
  const API_URL = api.defaults.root;
  useEffect(() => {
    // Ping server on mount
    if (API_URL) {
      api.get('/').catch(e => {
        if (isFetchError(e)) setShowOverlay(true);
      });
    }
  }, []);
  if (process.env.REACT_APP_HIDE_SERVER_STATUS_OVERLAY || !showOverlay) return null;
  return jsxRuntimeExports.jsxs("div", {
    className: "server-status-overlay",
    children: ["Warning: there is no server running at your configured API url: ", API_URL]
  });
}
var ServerStatusOverlay_default = /*#__PURE__*/memo(ServerStatusOverlay);

/**
 * @deprecated use `InputSelectNative` or `Select` instead
 */
const SingleSelect = ({
  input,
  ...rest
}) => jsxRuntimeExports.jsx(ReactSelect, {
  ...input,
  ...rest,
  styles: {
    control: baseStyles => ({
      ...baseStyles,
      border: 'none',
      borderRadius: '0',
      borderBottom: '1px solid black',
      margin: 0,
      padding: '6px 0',
      textAlign: 'left'
    }),
    container: baseStyles => ({
      ...baseStyles,
      textAlign: 'left'
    }),
    singleValue: baseStyles => ({
      ...baseStyles,
      color: INLINE_COLORS.blackBase
    }),
    menu: baseStyles => ({
      ...baseStyles,
      borderRadius: 0
    }),
    indicatorSeparator: baseStyles => ({
      ...baseStyles,
      display: 'none'
    }),
    dropdownIndicator: baseStyles => ({
      ...baseStyles,
      color: INLINE_COLORS.blackBase
    })
  }
});

/*
  This component is deprecated, use InputSSN instead
*/
function SSNInput(props) {
  const [focus, setFocus] = useState(false);
  const [visible, setVisible] = useState(false);
  const [rawSSN, setRawSSN] = useState('');
  const [showTip, setShowTip] = useState({
    ssn: false
  });
  const {
    input: {
      onChange
    },
    hidenote = false
  } = props;
  const format = v => {
    v = v.slice(0, 11).replace(/-/g, '');
    if (v.length <= 3) {
      return v;
    }
    if (v.length > 3 && v.length <= 5) {
      return `${v.slice(0, 3)}-${v.slice(3)}`;
    }
    if (v.length > 5) {
      return `${v.slice(0, 3)}-${v.slice(3, 5)}-${v.slice(5)}`;
    }
    return '';
  };
  const handleShowTip = tip => {
    setShowTip({
      ...showTip,
      [tip]: true
    });
  };
  const mask = v => {
    const masked = v.slice(0, 6).replace(/[0-9]/g, 'X');
    const unmaskedValue = v.length > 6 && v.slice(6, 11);
    return unmaskedValue ? `${masked}${unmaskedValue}` : masked;
  };
  const handleChange = e => {
    const {
      value
    } = e.target;
    if (value.replace(/-/g, '').length < rawSSN.length) {
      const last = rawSSN.length - 1;
      setRawSSN(rawSSN.slice(0, last));
      return;
    }
    const numValue = value.replace(/\D/g, '');
    let newSSN = '';
    if (rawSSN.length > 5) {
      newSSN = visible ? numValue : rawSSN.slice(0, 5) + numValue;
    } else {
      newSSN = visible ? numValue : rawSSN + numValue;
    }
    if (newSSN.length > 9) {
      return;
    }
    setRawSSN(newSSN);
    onChange(format(newSSN));
  };
  const handleVisibility = () => {
    setVisible(!visible);
    onChange(format(rawSSN));
  };
  return jsxRuntimeExports.jsxs("div", {
    className: "ssn-input--wrapper",
    children: [jsxRuntimeExports.jsxs("div", {
      className: "ssn-input d-flex-center",
      children: [jsxRuntimeExports.jsx("div", {
        style: {
          display: 'none'
        },
        children: jsxRuntimeExports.jsx(props.inputType, {
          name: props.input.name,
          ...props
        })
      }), props.label && jsxRuntimeExports.jsxs("label", {
        htmlFor: props.input.name,
        children: [`${props.label ? props.label : 'Social Security Number / Individual Taxpayer Identification Number'}`, jsxRuntimeExports.jsx("span", {
          className: "required-indicator",
          "aria-hidden": "true",
          children: "\u00A0*"
        })]
      }), jsxRuntimeExports.jsx("input", {
        type: "tel",
        onFocus: () => {
          setFocus(true);
          handleShowTip('ssn');
        },
        placeholder: "Social Security Number / ITIN",
        onChange: handleChange,
        required: true,
        value: visible ? format(rawSSN) : mask(format(rawSSN)),
        onClick: () => {
          handleShowTip('ssn');
        }
      }), props.meta.touched && props.meta.error && jsxRuntimeExports.jsx("span", {
        id: "securityNumberError",
        className: "error-message",
        children: props.meta.error
      }), jsxRuntimeExports.jsx("div", {
        onClick: handleVisibility,
        className: "ssn-input__visibility-icon",
        role: "button",
        tabIndex: 0,
        onKeyDown: e => {
          if (e.key === 'Enter') {
            handleVisibility();
          }
        },
        children: visible ? jsxRuntimeExports.jsx(VisibilityIcon, {}) : jsxRuntimeExports.jsx(VisibilityOffIcon, {})
      })]
    }), jsxRuntimeExports.jsx(FormSpy, {
      name: props.input.name,
      focused: focus,
      children: val => {
        if ((val || focus) && props.tooltips) {
          return jsxRuntimeExports.jsx(props.tooltips, {});
        }
        return null;
      }
    }), showTip.ssn && hidenote === false && jsxRuntimeExports.jsxs("div", {
      className: "field-note social-security",
      children: [jsxRuntimeExports.jsx(LockOutlinedIcon, {
        className: "gray-icon"
      }), jsxRuntimeExports.jsx("p", {
        children: "\u00A0We use your social security or ITIN number to validate your information and check your credit. Your information is transmitted securely."
      })]
    })]
  });
}

var ArrowDownward = {};

var hasRequiredArrowDownward;
function requireArrowDownward() {
  if (hasRequiredArrowDownward) return ArrowDownward;
  hasRequiredArrowDownward = 1;
  var _interopRequireDefault = requireInteropRequireDefault();
  var _interopRequireWildcard = requireInteropRequireWildcard();
  Object.defineProperty(ArrowDownward, "__esModule", {
    value: true
  });
  ArrowDownward.default = void 0;
  var React = _interopRequireWildcard(React__default);
  var _createSvgIcon = _interopRequireDefault( /*@__PURE__*/requireCreateSvgIcon());
  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
  }), 'ArrowDownward');
  ArrowDownward.default = _default;
  return ArrowDownward;
}

var ArrowDownwardExports = /*@__PURE__*/ requireArrowDownward();
var ArrowDownwardIcon = /*@__PURE__*/getDefaultExportFromCjs(ArrowDownwardExports);

var ArrowUpward = {};

var hasRequiredArrowUpward;
function requireArrowUpward() {
  if (hasRequiredArrowUpward) return ArrowUpward;
  hasRequiredArrowUpward = 1;
  var _interopRequireDefault = requireInteropRequireDefault();
  var _interopRequireWildcard = requireInteropRequireWildcard();
  Object.defineProperty(ArrowUpward, "__esModule", {
    value: true
  });
  ArrowUpward.default = void 0;
  var React = _interopRequireWildcard(React__default);
  var _createSvgIcon = _interopRequireDefault( /*@__PURE__*/requireCreateSvgIcon());
  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
  }), 'ArrowUpward');
  ArrowUpward.default = _default;
  return ArrowUpward;
}

var ArrowUpwardExports = /*@__PURE__*/ requireArrowUpward();
var ArrowUpwardIcon = /*@__PURE__*/getDefaultExportFromCjs(ArrowUpwardExports);

var Close = {};

var hasRequiredClose;
function requireClose() {
  if (hasRequiredClose) return Close;
  hasRequiredClose = 1;
  var _interopRequireDefault = requireInteropRequireDefault();
  var _interopRequireWildcard = requireInteropRequireWildcard();
  Object.defineProperty(Close, "__esModule", {
    value: true
  });
  Close.default = void 0;
  var React = _interopRequireWildcard(React__default);
  var _createSvgIcon = _interopRequireDefault( /*@__PURE__*/requireCreateSvgIcon());
  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), 'Close');
  Close.default = _default;
  return Close;
}

var CloseExports = /*@__PURE__*/ requireClose();
var CloseIcon = /*@__PURE__*/getDefaultExportFromCjs(CloseExports);

var FilterList = {};

var hasRequiredFilterList;
function requireFilterList() {
  if (hasRequiredFilterList) return FilterList;
  hasRequiredFilterList = 1;
  var _interopRequireDefault = requireInteropRequireDefault();
  var _interopRequireWildcard = requireInteropRequireWildcard();
  Object.defineProperty(FilterList, "__esModule", {
    value: true
  });
  FilterList.default = void 0;
  var React = _interopRequireWildcard(React__default);
  var _createSvgIcon = _interopRequireDefault( /*@__PURE__*/requireCreateSvgIcon());
  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
  }), 'FilterList');
  FilterList.default = _default;
  return FilterList;
}

var FilterListExports = /*@__PURE__*/ requireFilterList();
var FilterListIcon = /*@__PURE__*/getDefaultExportFromCjs(FilterListExports);

var ImportExport = {};

var hasRequiredImportExport;
function requireImportExport() {
  if (hasRequiredImportExport) return ImportExport;
  hasRequiredImportExport = 1;
  var _interopRequireDefault = requireInteropRequireDefault();
  var _interopRequireWildcard = requireInteropRequireWildcard();
  Object.defineProperty(ImportExport, "__esModule", {
    value: true
  });
  ImportExport.default = void 0;
  var React = _interopRequireWildcard(React__default);
  var _createSvgIcon = _interopRequireDefault( /*@__PURE__*/requireCreateSvgIcon());
  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
    d: "M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"
  }), 'ImportExport');
  ImportExport.default = _default;
  return ImportExport;
}

var ImportExportExports = /*@__PURE__*/ requireImportExport();
var ImportExportIcon = /*@__PURE__*/getDefaultExportFromCjs(ImportExportExports);

var NavigateBefore = {};

var hasRequiredNavigateBefore;
function requireNavigateBefore() {
  if (hasRequiredNavigateBefore) return NavigateBefore;
  hasRequiredNavigateBefore = 1;
  var _interopRequireDefault = requireInteropRequireDefault();
  var _interopRequireWildcard = requireInteropRequireWildcard();
  Object.defineProperty(NavigateBefore, "__esModule", {
    value: true
  });
  NavigateBefore.default = void 0;
  var React = _interopRequireWildcard(React__default);
  var _createSvgIcon = _interopRequireDefault( /*@__PURE__*/requireCreateSvgIcon());
  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
  }), 'NavigateBefore');
  NavigateBefore.default = _default;
  return NavigateBefore;
}

var NavigateBeforeExports = /*@__PURE__*/ requireNavigateBefore();
var NavigateBeforeIcon = /*@__PURE__*/getDefaultExportFromCjs(NavigateBeforeExports);

var NavigateNext = {};

var hasRequiredNavigateNext;
function requireNavigateNext() {
  if (hasRequiredNavigateNext) return NavigateNext;
  hasRequiredNavigateNext = 1;
  var _interopRequireDefault = requireInteropRequireDefault();
  var _interopRequireWildcard = requireInteropRequireWildcard();
  Object.defineProperty(NavigateNext, "__esModule", {
    value: true
  });
  NavigateNext.default = void 0;
  var React = _interopRequireWildcard(React__default);
  var _createSvgIcon = _interopRequireDefault( /*@__PURE__*/requireCreateSvgIcon());
  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
  }), 'NavigateNext');
  NavigateNext.default = _default;
  return NavigateNext;
}

var NavigateNextExports = /*@__PURE__*/ requireNavigateNext();
var NavigateNextIcon = /*@__PURE__*/getDefaultExportFromCjs(NavigateNextExports);

var Replay = {};

var hasRequiredReplay;
function requireReplay() {
  if (hasRequiredReplay) return Replay;
  hasRequiredReplay = 1;
  var _interopRequireDefault = requireInteropRequireDefault();
  var _interopRequireWildcard = requireInteropRequireWildcard();
  Object.defineProperty(Replay, "__esModule", {
    value: true
  });
  Replay.default = void 0;
  var React = _interopRequireWildcard(React__default);
  var _createSvgIcon = _interopRequireDefault( /*@__PURE__*/requireCreateSvgIcon());
  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
    d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
  }), 'Replay');
  Replay.default = _default;
  return Replay;
}

var ReplayExports = /*@__PURE__*/ requireReplay();
var ReplayIcon = /*@__PURE__*/getDefaultExportFromCjs(ReplayExports);

/**
 * Plugins
 */
const PLUGINS = {
  'credit-portal': [REACT_APP_ANALYTICS_CFE_GA_ID ? googleAnalyticsPlugin({
    measurementIds: [REACT_APP_ANALYTICS_CFE_GA_ID]
  }) : null, REACT_APP_ANALYTICS_CFE_GTM_ID ? googleTagManager({
    containerId: REACT_APP_ANALYTICS_CFE_GTM_ID
  }) : null].filter(itm => itm),
  'merchant-portal': [REACT_APP_ANALYTICS_MFE_GA_ID ? googleAnalyticsPlugin({
    measurementIds: [REACT_APP_ANALYTICS_MFE_GA_ID]
  }) : null, REACT_APP_ANALYTICS_MFE_GTM_ID ? googleTagManager({
    containerId: REACT_APP_ANALYTICS_MFE_GTM_ID
  }) : null].filter(itm => itm)
};
/**
 * Base Config
 */
const baseConfig = {
  app: undefined,
  version: 1,
  debug: false,
  plugins: []
};
/**
 * Base Context
 */
const baseContext = {
  analytics: null,
  setAppName: null
};

// Context
const AnalyticsContext = /*#__PURE__*/createContext(baseContext);
// Component
const AnalyticsProvider = ({
  children,
  appName: initialAppName
}) => {
  // State
  const [appName, setAppName] = useState(initialAppName || null);
  const [config, setConfig] = useState(baseConfig);
  const [analytics, setAnalytics] = useState(null);
  // Effect - First set appName
  useEffect(() => {
    if (appName !== null && (!!config.plugins?.length || !!PLUGINS[appName]?.length)) {
      baseConfig.plugins = PLUGINS[appName];
      setConfig({
        ...baseConfig,
        app: appName
      });
    }
  }, [appName]);
  // Effect - Second set config and analytics object
  useEffect(() => {
    if (config.app !== null) {
      const tmpAnalytics = Analytics(config);
      setAnalytics(tmpAnalytics);
    }
  }, [config]);
  return jsxRuntimeExports.jsx(AnalyticsContext.Provider, {
    value: {
      analytics,
      setAppName
    },
    children: children
  });
};

/**
 * Custom hook to identify user in Google Analytics with email attribute
 * This sets user attributes without overwriting the internal Google Analytics user ID
 */
const useAnalyticsIdentify = ({
  userEmail,
  userId,
  userTraits = {}
}) => {
  const {
    analytics
  } = useContext(AnalyticsContext);
  useEffect(() => {
    if (analytics && userEmail) {
      // Use identify to set user attributes including email
      // The analytics library will handle this properly with Google Analytics
      analytics.identify(userId || userEmail, {
        email: userEmail,
        ...userTraits
      });
    }
  }, [analytics, userEmail, userId, userTraits]);
};

const useButtonClickTracker = () => {
  const {
    analytics
  } = useContext(AnalyticsContext);
  const location = useLocation();
  useEffect(() => {
    const handleClick = event => {
      const target = event.target;
      const element = target.closest(`button, a, .analytics-target, [role="button"]`);
      if (!element) return;
      let tag = null;
      if (element.tagName === 'BUTTON' || element.role === 'button') {
        tag = 'button';
      } else if (element.tagName === 'A') {
        tag = 'link';
      }
      if (tag === 'button') {
        analytics?.track('button_click', {
          button_id: element.dataset['analyticsId'] || element.id || element.innerText,
          page: location.pathname
        });
      } else if (tag === 'link') {
        analytics?.track('link_click', {
          anchor_id: element.dataset['analyticsId'] || element.id || element.innerText,
          page: location.pathname
        });
      }
    };
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [analytics]);
};

const useErrorListener = () => {
  const unhandledRejectionListener = event => {
    reportError('promiseRejection', {
      componentName: event.reason.stack,
      errType: 'error',
      errURL: window.location.pathname,
      errMsg: event.reason.message,
      context: {
        stack: event.reason.stack,
        response: event.reason.response
      }
    }, event.reason);
  };
  const errorListener = event => {
    reportError('error', {
      componentName: event.message,
      errType: 'error',
      errURL: window.location.pathname,
      errMsg: event.message,
      context: {
        stack: event.error?.stack,
        response: event.message,
        eventMessage: event.message,
        eventFilename: event.filename
      }
    }, event.error);
  };
  useEffect(() => {
    window.addEventListener('unhandledrejection', unhandledRejectionListener);
    window.addEventListener('error', errorListener);
    return () => {
      window.removeEventListener('unhandledrejection', unhandledRejectionListener);
      window.removeEventListener('error', errorListener);
    };
  }, []);
};

function useInterval(callback, {
  interval,
  invokeFirst = false
}) {
  useEffect(() => {
    if (invokeFirst) callback();
    if (!isNil(interval) && interval > 0) {
      const intervalId = setInterval(callback, interval);
      return () => clearInterval(intervalId);
    }
  }, [callback, interval]);
}

const useIovation = () => {
  useEffect(() => {
    return () => {};
  }, []);
  const getBlackboxData = () => {
    let blackboxData;
    try {
      blackboxData = 'nonesense';
    } catch (e) {
      alert('Unable to get blackbox. ' + e);
    }
    return blackboxData;
  };
  return [getBlackboxData];
};

function useIsInViewport(ref) {
  const [isInViewport, setIsInViewport] = useState(false);
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const observer = new IntersectionObserver(([entry]) => setIsInViewport(entry.isIntersecting));
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref]);
  return isInViewport;
}

const MOBILE_MAX_WIDTH = 767; // matches $mobile-max in scss/settings/variables/_breakpoints.scss
function useIsMobile() {
  const query = `(max-width: ${MOBILE_MAX_WIDTH}px)`;
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = e => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  return isMobile;
}

const useIsOnline = () => {
  const [isOnline, setIsOnline] = useState(true);
  const handleOnlineListener = useCallback(() => {
    setIsOnline(navigator.onLine);
  }, []);
  useEffect(() => {
    window.addEventListener('online', handleOnlineListener);
    window.addEventListener('offline', handleOnlineListener);
    return () => {
      window.removeEventListener('online', handleOnlineListener);
      window.removeEventListener('offline', handleOnlineListener);
    };
  }, []);
  return {
    isOnline
  };
};

const usePageRefreshTracker = () => {
  const {
    analytics
  } = useContext(AnalyticsContext);
  const location = useLocation();
  useEffect(() => {
    const trackPageRefresh = () => {
      const navEntries = performance.getEntriesByType('navigation');
      if (navEntries.length > 0 && navEntries[0].type === 'reload') {
        analytics?.track('page_refresh', {
          page: location.pathname,
          timestamp: new Date().toISOString()
        });
      }
    };
    trackPageRefresh();
  }, [analytics, location.pathname]);
};
/**
 * Hook to track back button clicks
 */
const useBackButtonTracker = () => {
  const {
    analytics
  } = useContext(AnalyticsContext);
  const location = useLocation();
  useEffect(() => {
    const handlePopState = () => {
      analytics?.track('back_button', {
        page: location.pathname,
        timestamp: new Date().toISOString()
      });
    };
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [analytics, location.pathname]);
};
/**
 * Combined hook for tracking both page refreshes and back button clicks
 */
const useNavigationTracker = () => {
  usePageRefreshTracker();
  useBackButtonTracker();
};

const useVisibilityChange = () => {
  const [isDocVisible, setIsDocVisible] = useState(!document.hidden);
  const handleVisibilityListener = useCallback(() => {
    setIsDocVisible(!document.hidden);
  }, [document.hidden]);
  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityListener);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityListener);
    };
  }, []);
  return {
    isDocVisible
  };
};

const useNetworkErrorReporter = ({
  toastError,
  toastSuccess
}) => {
  const {
    isDocVisible
  } = useVisibilityChange();
  const {
    isOnline
  } = useIsOnline();
  const [wentOffline, setWentOffline] = useState(null);
  useEffect(() => {
    if (!isOnline) {
      if (isDocVisible) {
        const errMsg = "Network is unavailable. Are you sure you're connected to the network?";
        toastError(errMsg);
      }
      setWentOffline(true);
    }
  }, [isOnline]);
  useEffect(() => {
    if (wentOffline && isOnline) {
      toastSuccess('Network is available', 5000);
      setWentOffline(false);
    }
  }, [isOnline, wentOffline]);
};

const useNewTab = onClose => {
  const [newTab, setNewTab] = useState(null);
  const [isAwaitingClose, setIsAwaitingClose] = useState(false);
  const closeNewTab = () => {
    newTab && newTab.close();
  };
  useEffect(() => {
    if (newTab) {
      //poll for close event
      setIsAwaitingClose(true);
      const interval = setInterval(async () => {
        if (newTab.closed) {
          clearInterval(interval);
          setIsAwaitingClose(false);
          await onClose();
        }
      }, 500);
    }
  }, [newTab, onClose]);
  return {
    newTab,
    setNewTab,
    isAwaitingClose,
    closeNewTab
  };
};

const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

/**
 * PostMessage utility for communicating credit application and receipt events
 * to a parent window when Alphaeon is embedded in an iframe.
 *
 * Events mirror the backend webhook payloads for consistency.
 */
/**
 * Check if the current window is running inside an iframe
 */
function isInIframe() {
  try {
    return window.self !== window.top;
  } catch {
    // Cross-origin restriction means we're definitely in an iframe
    return true;
  }
}
/**
 * Derive the parent window's origin from the document referrer.
 * Returns null if the origin cannot be determined safely.
 */
function getParentOrigin() {
  try {
    const referrer = document.referrer;
    if (!referrer) {
      return null;
    }
    const url = new URL(referrer);
    return url.origin;
  } catch {
    return null;
  }
}
/**
 * Send an event to the parent window if we're in an iframe.
 * No-ops silently if not in an iframe or if the parent origin
 * cannot be determined safely.
 */
function sendToParent(event) {
  if (!isInIframe()) {
    return;
  }
  const targetOrigin = getParentOrigin();
  if (!targetOrigin) {
    return;
  }
  window.parent.postMessage(event, targetOrigin);
}

function useParentMessaging() {
  const isEmbedded = useMemo(() => isInIframe(), []);
  const sendApplicationCreated = useCallback(({
    applicationId,
    partnerTrackingGuid
  }) => {
    sendToParent({
      source: 'alphaeon-credit-portal',
      eventType: 'application_created',
      payload: {
        application_id: applicationId,
        partner_tracking_guid: partnerTrackingGuid,
        status: '',
        requested_amount: null,
        prequalified_amount: null,
        timestamp: new Date().toISOString()
      }
    });
  }, []);
  const sendPrequalification = useCallback(({
    applicationId,
    partnerTrackingGuid,
    status,
    requestedAmount,
    prequalifiedAmount
  }) => {
    sendToParent({
      source: 'alphaeon-credit-portal',
      eventType: 'prequalification',
      payload: {
        application_id: applicationId,
        partner_tracking_guid: partnerTrackingGuid,
        status,
        requested_amount: requestedAmount,
        prequalified_amount: prequalifiedAmount,
        timestamp: new Date().toISOString()
      }
    });
  }, []);
  const sendCreditDecision = useCallback(({
    applicationId,
    partnerTrackingGuid,
    status,
    availableCredit,
    accountMember,
    consumerCreditInstrument,
    cardNumber
  }) => {
    sendToParent({
      source: 'alphaeon-credit-portal',
      eventType: 'credit_decision',
      payload: {
        application_id: applicationId,
        partner_tracking_guid: partnerTrackingGuid,
        status,
        available_credit: availableCredit,
        account_member: accountMember,
        consumer_credit_instrument: consumerCreditInstrument,
        card_number: cardNumber,
        timestamp: new Date().toISOString()
      }
    });
  }, []);
  const sendReceiptSigned = useCallback(({
    status,
    transactionId,
    receiptUuid,
    amount,
    referenceId
  }) => {
    sendToParent({
      source: 'alphaeon-credit-portal',
      eventType: 'receipt_signed',
      payload: {
        status,
        transaction_id: transactionId,
        receipt_uuid: receiptUuid,
        amount,
        reference_id: referenceId,
        timestamp: new Date().toISOString()
      }
    });
  }, []);
  return {
    isEmbedded,
    sendApplicationCreated,
    sendPrequalification,
    sendCreditDecision,
    sendReceiptSigned
  };
}

function loadPendoScript(apiKey) {
  if (document.getElementById('pendo-script')) return; /* eslint-disable */
  (function (p, e, n, d, o) {
    var v, w, x, y, z;
    o = p[d] = p[d] || {};
    o._q = o._q || [];
    v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track', 'trackAgent'];
    for (w = 0, x = v.length; w < x; ++w) (function (m) {
      o[m] = o[m] || function () {
        o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
      };
    })(v[w]);
    y = e.createElement(n);
    y.async = true;
    y.id = 'pendo-script';
    y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
    z = e.getElementsByTagName(n)[0];
    z.parentNode.insertBefore(y, z);
  })(window, document, 'script', 'pendo', {});
  /* eslint-enable */
}
function stripUndefined(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== undefined && v !== null));
}
const usePendo = ({
  visitor,
  account
}) => {
  const initialized = useRef(false);
  const apiKey = process.env.REACT_APP_PENDO_API_KEY;
  useEffect(() => {
    if (apiKey) loadPendoScript(apiKey);
  }, [apiKey]);
  useEffect(() => {
    if (!apiKey || !window.pendo || !visitor.id) return;
    const options = {
      visitor: stripUndefined({
        id: visitor.id,
        email: visitor.email,
        full_name: visitor.full_name,
        email_verified: visitor.email_verified
      }),
      account: stripUndefined({
        id: account.id,
        name: account.name,
        storeNumber: account.storeNumber,
        state: account.state,
        vertical: account.vertical,
        pushApplicationEnabled: account.pushApplicationEnabled,
        dashboardApplicationEnabled: account.dashboardApplicationEnabled,
        supplementalFundingEnabled: account.supplementalFundingEnabled
      })
    };
    if (!initialized.current) {
      window.pendo.initialize(options);
      initialized.current = true;
    } else {
      window.pendo.identify(options);
    }
  }, [visitor.id, visitor.email, visitor.full_name, visitor.email_verified, account.id, account.name, account.storeNumber, account.state, account.vertical, account.pushApplicationEnabled, account.dashboardApplicationEnabled, account.supplementalFundingEnabled, apiKey]);
};

/**
 * @name useQuery
 * @desc A custom hook that builds on useLocation to parse the query string for you.
 * @ref https://v5.reactrouter.com/web/example/query-parameters
 * @returns queryObject (e.g. query.get("name")) and queryString which is the full query string without the ?
 */
const useQuery = () => {
  const {
    search
  } = useLocation();
  const queryObject = useMemo(() => new URLSearchParams(search), [search]);
  const queryString = useMemo(() => search ? search.slice(1) : '', [search]);
  return {
    queryObject,
    queryString
  };
};

const useRouteTracker = () => {
  const location = useLocation();
  const {
    analytics
  } = useContext(AnalyticsContext);
  useEffect(() => {
    analytics?.track('page_view', {
      page: location.pathname
    });
  }, [location, analytics]);
};

function Table({
  data,
  columns,
  tableName,
  rowAnalyticsId,
  serverSide
}) {
  const [sorting, setSorting] = useState([]);
  const [filtering, setFiltering] = useState('');
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      sorting: serverSide?.sorting ?? sorting,
      globalFilter: filtering,
      ...(serverSide && {
        pagination: serverSide.pagination,
        columnFilters: serverSide.columnFilters
      })
    },
    onSortingChange: serverSide?.onSortingChange ?? setSorting,
    onGlobalFilterChange: setFiltering,
    enableSortingRemoval: true,
    ...(serverSide && {
      manualPagination: true,
      manualSorting: true,
      manualFiltering: true,
      pageCount: serverSide.pageCount,
      onPaginationChange: serverSide.onPaginationChange,
      onColumnFiltersChange: serverSide.onColumnFiltersChange
    })
  });
  const {
    analytics
  } = useContext(AnalyticsContext);
  const handlePrev = () => {
    table.previousPage();
  };
  const handleNext = () => {
    table.nextPage();
  };
  return jsxRuntimeExports.jsxs("div", {
    className: "filterable-sortable-table",
    children: [jsxRuntimeExports.jsxs("table", {
      children: [jsxRuntimeExports.jsx("thead", {
        children: table.getHeaderGroups().map(headerGroup => jsxRuntimeExports.jsx("tr", {
          children: headerGroup.headers.map(header => jsxRuntimeExports.jsx("th", {
            className: header.column.columnDef.meta?.className,
            "aria-sort": header.column.getCanSort() ? SORT_ARIA_VALUES[String(header.column.getIsSorted())] : undefined,
            children: jsxRuntimeExports.jsx("div", {
              children: flexRender(jsxRuntimeExports.jsxs("div", {
                className: "sort-controls",
                children: [header.column.columnDef.header, header.column.getCanSort() && jsxRuntimeExports.jsx("div", {
                  onClick: e => {
                    analytics?.track('table_sort', {
                      table_name: tableName,
                      column_name: header.column.columnDef.header,
                      page: location.pathname
                    });
                    header.column.getToggleSortingHandler()(e);
                  },
                  role: "button",
                  tabIndex: 0,
                  "aria-label": `Sort by ${header.column.columnDef.header}`,
                  onKeyDown: e => {
                    if (e.key === 'Enter') {
                      header.column.getToggleSortingHandler()(e);
                    }
                  },
                  children: jsxRuntimeExports.jsx(SortIcon, {
                    direction: header.column.getIsSorted()
                  })
                }), header.column.getCanFilter() && jsxRuntimeExports.jsx(FilterContainer, {
                  header: header,
                  table: table,
                  tableName: tableName
                })]
              }), header.getContext())
            })
          }, header.id))
        }, headerGroup.id))
      }), jsxRuntimeExports.jsxs("tbody", {
        className: serverSide?.isFetching ? 'filterable-sortable-body--fetching' : undefined,
        children: [table.getRowModel().rows.map(row => jsxRuntimeExports.jsx("tr", {
          "data-analytics-id": rowAnalyticsId,
          children: row.getVisibleCells().map(cell => jsxRuntimeExports.jsx("td", {
            children: flexRender(cell.column.columnDef.cell, cell.getContext())
          }, cell.id))
        }, row.id)), table.getRowModel().rows.length === 0 && jsxRuntimeExports.jsx("tr", {
          children: jsxRuntimeExports.jsx("td", {
            colSpan: table.getAllLeafColumns().length,
            className: "filterable-sortable-empty",
            children: "No matching results"
          })
        })]
      })]
    }), jsxRuntimeExports.jsxs("div", {
      className: "filterable-sortable-pagination",
      children: [jsxRuntimeExports.jsx("button", {
        onClick: handlePrev,
        disabled: serverSide?.isFetching || !table.getCanPreviousPage(),
        "aria-label": "Previous page",
        children: jsxRuntimeExports.jsx(NavigateBeforeIcon, {})
      }), jsxRuntimeExports.jsx("div", {
        children: "Page"
      }), jsxRuntimeExports.jsxs("strong", {
        children: [table.getState().pagination.pageIndex + 1, " of", ' ', Math.max(table.getPageCount(), 1)]
      }), jsxRuntimeExports.jsx("button", {
        onClick: handleNext,
        disabled: serverSide?.isFetching || !table.getCanNextPage(),
        "aria-label": "Next page",
        children: jsxRuntimeExports.jsx(NavigateNextIcon, {})
      })]
    })]
  });
}
const SORT_ARIA_VALUES = {
  asc: 'ascending',
  desc: 'descending',
  false: 'none'
};
function SortIcon({
  direction
}) {
  if (direction === 'asc') {
    return jsxRuntimeExports.jsx(ArrowUpwardIcon, {
      fontSize: "small",
      className: "sort-or-filter-icon"
    });
  }
  if (direction === 'desc') {
    return jsxRuntimeExports.jsx(ArrowDownwardIcon, {
      fontSize: "small",
      className: "sort-or-filter-icon"
    });
  }
  return jsxRuntimeExports.jsx(ImportExportIcon, {
    fontSize: "small",
    className: "sort-or-filter-icon"
  });
}
function FilterContainer({
  header,
  table,
  tableName
}) {
  const modalRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  useOnClickOutside(modalRef, () => setIsOpen(false));
  const {
    analytics
  } = useContext(AnalyticsContext);
  return jsxRuntimeExports.jsxs("div", {
    children: [jsxRuntimeExports.jsx("div", {
      onClick: () => {
        analytics?.track('table_sort', {
          table_name: tableName,
          column_name: header.column.columnDef.header,
          page: location.pathname
        });
        setIsOpen(!isOpen);
      },
      role: "button",
      tabIndex: 0,
      "aria-label": `Filter by ${header.column.columnDef.header}`,
      onKeyDown: e => {
        if (e.key === 'Enter') {
          setIsOpen(!isOpen);
        }
      },
      children: jsxRuntimeExports.jsx(FilterListIcon, {
        fontSize: "small",
        className: "sort-or-filter-icon"
      })
    }), isOpen && jsxRuntimeExports.jsxs("div", {
      className: "filter-modal",
      ref: modalRef,
      children: [jsxRuntimeExports.jsx(Filter, {
        column: header.column,
        table: table
      }), jsxRuntimeExports.jsx(CloseIcon, {
        onClick: () => {
          setIsOpen(!isOpen);
        },
        className: "filter-close",
        "aria-label": "Close Filter",
        fontSize: "small"
      })]
    })]
  });
}
function Filter({
  column,
  table
}) {
  const firstValue = table.getPreFilteredRowModel().flatRows[0]?.getValue(column.id);
  const columnFilterValue = column.getFilterValue();
  const sortedUniqueValues = useMemo(() => typeof firstValue === 'number' ? [] : Array.from(column.getFacetedUniqueValues().keys()).sort(), [column.getFacetedUniqueValues()]);
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsx("datalist", {
      id: column.id + 'list',
      children: sortedUniqueValues.slice(0, 5000).map(value => jsxRuntimeExports.jsx("option", {
        value: value
      }, value))
    }), jsxRuntimeExports.jsxs("div", {
      className: "input-and-reset",
      children: [jsxRuntimeExports.jsx(DebouncedInput, {
        type: "text",
        value: columnFilterValue ?? '',
        onChange: value => column.setFilterValue(value),
        placeholder: "Type to filter...",
        className: "w-36 border shadow rounded",
        list: column.id + 'list'
      }), jsxRuntimeExports.jsx("div", {
        onClick: () => {
          column.setFilterValue('');
        },
        role: "button",
        tabIndex: 0,
        onKeyDown: e => {
          if (e.key === 'Enter') {
            column.setFilterValue('');
          }
        },
        className: "reset-icon",
        children: jsxRuntimeExports.jsx(ReplayIcon, {})
      })]
    }), jsxRuntimeExports.jsx("div", {
      className: "h-1"
    })]
  });
}
// A debounced input react component
function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}) {
  const [value, setValue] = useState(initialValue);
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);
  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);
    return () => clearTimeout(timeout);
  }, [value]);
  return jsxRuntimeExports.jsx("input", {
    ...props,
    value: value,
    onChange: e => setValue(e.target.value)
  });
}

function TestEnvironmentBanner({
  env
}) {
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsx("div", {
      className: "ribbon ribbon-top-right",
      children: jsxRuntimeExports.jsx("span", {
        children: `${env.toUpperCase()}`
      })
    }), jsxRuntimeExports.jsxs("div", {
      className: "test-environment-banner",
      children: [jsxRuntimeExports.jsx("div", {
        className: "sandbox-mode-title",
        children: `${env.toUpperCase()} MODE`
      }), jsxRuntimeExports.jsx("p", {
        children: `You are viewing the ${env.toUpperCase()} mode used for testing purposes only.`
      })]
    })]
  });
}

function ToastDismissButton({
  closeToast
}) {
  return jsxRuntimeExports.jsx(ButtonLink$1, {
    onClick: closeToast,
    className: "link-secondary",
    children: "Dismiss"
  });
}

const TooZoom = () => {
  const MAX_ZOOM = 175; // percent screen zoom
  // State
  const [showMsg, setShowMsg] = useState(false);
  const handleWindowResize = () => {
    checkZoom();
  };
  // Left in case we want to allow user to disable
  const handleDontShowMsg = () => {
    document.cookie = 'showZoomMsg=false';
    setShowMsg(false);
    window.removeEventListener('resize', handleWindowResize);
  };
  const getZoom = () => {
    const highDPI = isHighDPI();
    if (highDPI) {
      return Math.round(window.devicePixelRatio * 50);
    } else {
      return Math.round(window.devicePixelRatio * 100);
    }
  };
  const checkZoom = () => {
    const zoomCookie = getCookie('showZoomMsg');
    if (zoomCookie === 'false') return;
    if (!window.matchMedia('(pointer: coarse)').matches) {
      const zoomLevel = getZoom();
      if (zoomLevel >= MAX_ZOOM) {
        setShowMsg(true);
      } else {
        setShowMsg(false);
      }
    }
  };
  const isHighDPI = () => {
    const dpiMap = dpiDetector();
    const hasDPIArr = Object.values(dpiMap.screens).filter(itm => {
      return itm;
    });
    if (hasDPIArr.length > 0 && window.visualViewport.width >= 1000) {
      return true;
    } else {
      return false;
    }
  };
  const isMac = useMemo(() => {
    // Currently Typescript doesn't ship with type declarations for the experimental navigator.userAgentData which is why we have to cast it as any here
    // StackOverflow thread: https://stackoverflow.com/questions/71392342/property-useragentdata-does-not-exist-on-type-navigator
    if (navigator.userAgentData && navigator.userAgentData.platform) {
      return navigator.userAgentData.platform === 'macOS';
    } else {
      if ('platform' in navigator) {
        if (navigator.platform) {
          return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        }
      } else {
        return false;
      }
    }
  }, [showMsg]);
  useEffect(() => {
    const zoomCookie = getCookie('showZoomMsg');
    if (zoomCookie !== 'false') {
      checkZoom();
      window.addEventListener('resize', handleWindowResize);
    }
    return () => {
      if (zoomCookie !== 'false') {
        window.removeEventListener('resize', handleWindowResize);
      }
    };
  }, []);
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [showMsg ? jsxRuntimeExports.jsx("div", {
      className: "too-zoom-shell",
      children: jsxRuntimeExports.jsxs("div", {
        className: "too-zoom",
        children: [jsxRuntimeExports.jsx(H2, {
          variant: "headline-medium",
          children: "You are too zoomed in!"
        }), jsxRuntimeExports.jsxs(P, {
          variant: "body-large",
          children: ["Reset the screen by pressing \"", isMac ? 'cmd' : 'ctrl', " + 0\""]
        }), jsxRuntimeExports.jsx(ButtonV2, {
          type: "button",
          className: "mar-t-24",
          onClick: handleDontShowMsg,
          children: "Click here to disable this message"
        })]
      })
    }) : null, showMsg ? jsxRuntimeExports.jsx("div", {
      className: "too-zoom-bg"
    }) : null]
  });
};

const urlTimeouts = {
  '/merchant_management/v1/reports/sales': 15000,
  '/merchant_management/v1/reports/applications': 15000
};
function transformer(file, api) {
  const j = api.jscodeshift;
  const root = j(file.source);
  root.find(j.TSTypeLiteral).forEach(path => {
    path.value.members.forEach(member => {
      //@ts-expect-error
      member.key.name = camelCase$1(member.key.name);
    });
  });
  // Convert camelCase to snake_case for returnAccountDetails
  root.find(j.Identifier, {
    name: 'returnAccountDetails'
  }).forEach(path => {
    path.value.name = 'return_account_details';
  });
  root.find(j.ObjectExpression).forEach(path => {
    // Check if there is a `url` property with the value `'sales'`
    let url = '';
    const urlInTimeouts = path.value.properties.find(property => {
      if ((property.type === 'ObjectProperty' || property.type === 'Property') && property.key.type === 'Identifier' && property.key.name === 'url') {
        if (property.value.type === 'TemplateLiteral') {
          url = property.value.quasis[0].value.raw;
          return urlTimeouts.hasOwnProperty(url);
        } else if (property.value.type === 'Literal' && typeof property.value.value === 'string') {
          url = property.value.value;
          return urlTimeouts.hasOwnProperty(url);
        }
      }
    });
    if (urlInTimeouts) {
      const timeoutValue = urlTimeouts[url];
      // Check if the `timeout` property already exists
      const hasTimeout = path.value.properties.some(property => {
        return (property.type === 'ObjectProperty' || property.type === 'Property') && property.key.type === 'Identifier' && property.key.name === 'timeout';
      });
      // If `timeout` does not exist, add it
      if (!hasTimeout) {
        path.value.properties.push(j.property('init', j.identifier('timeout'), j.literal(timeoutValue)) // Set timeout to value from urlTimeouts
        );
      }
    }
  });
  return root.toSource();
}

// Local storage interactions go here.
const LOCATION_KEY = 'location';
function getLocation() {
  const persistedLocation = getItem(LOCATION_KEY);
  return persistedLocation;
}
function setLocation(location) {
  return setItem(LOCATION_KEY, location);
}
function clearLocation() {
  return removeItem(LOCATION_KEY);
}
/* HELPERS */
// Get item from localStorage, falling back to session storage
function getItem(key) {
  const serializedItem = localStorage.getItem(key) || sessionStorage.getItem(key);
  if (serializedItem === null) return undefined;
  try {
    return JSON.parse(serializedItem);
  } catch (e) {
    return serializedItem;
  }
}
// Remove item from local storage and session storage
function removeItem(key) {
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
}
// Set item in local storage or session storage (if specified)
function setItem(key, value, options = {}) {
  const {
    persist = true
  } = options;
  const serializedValue = JSON.stringify(value);
  removeItem(key);
  return persist ? localStorage.setItem(key, serializedValue) : sessionStorage.setItem(key, serializedValue);
}
/**
 * Given a key, returns functions for getting, setting, and clearing that key
 * @param {string} key - The unique name for the value to be stored at
 * @param {Object} [options={}] - An options configuration object. This can be overridden by individual setter invocations.
 * @param {boolean} [options.persist=true] - Option to save value across browser sessions.
 *
 * @example
 * export const [
 *  getSelectedMembership,
 *  setSelectedMembership,
 *  clearSelectedMembership
 * ] = createStorageAccessor('selectedMembership', { persist: false })
 *
 * @example
 * setSelectedMembership({ id: 2, name: 'Patron' }, { persist: true })
 **/
function createStorageAccessor(key, defaultOptions = {}) {
  const get = () => getItem(key);
  const set = (value, options = {}) => setItem(key, value, {
    ...defaultOptions,
    ...options
  });
  const clear = () => removeItem(key);
  return [get, set, clear];
}

var localStorage$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    clearLocation: clearLocation,
    createStorageAccessor: createStorageAccessor,
    getLocation: getLocation,
    setItem: setItem,
    setLocation: setLocation
});

// Configure lp-redux-api middleware
// This function will be passed the request options before every request.
// You can use it to set additional options or override existing ones.
function before(options) {
  const hyperDxCookie = getCookie('__rum_sid');
  const testAutomationCookie = getCookie('TestAutomation');
  return {
    ...options,
    headers: {
      ...options.headers,
      'Hyperdx-Session-Info': hyperDxCookie,
      'X-Client-Page': window.location.href,
      ...(testAutomationCookie ? {
        TestAutomation: testAutomationCookie
      } : {})
    }
  };
}
function onSuccess(res) {
  return res;
}
function onFailure(httpError) {
  const clientErrors = [401, 403, 404];
  // An undefined httpError.status indicates a failure to send an API request, likely due
  // to the connection with the backend API not being available.
  const status = httpError?.status;
  if (isNil(status)) return handleClientError(ERROR_STATUS.API_DOWN);
  if (clientErrors.includes(status)) return handleClientError(status.toString());
  if (status === 503) return handleServerError();
  return httpError;
}
// Global handler to trigger when API receives a response with a 401 code.
// This is invoked _in addition to_ the failureAction option.
function onUnauthorized() {
  return function /* dispatch */
  () {
    // dispatch(sessionsActions.logout())
    window.location.reload();
  };
}
const config$1 = {
  root: process.env.REACT_APP_API_URL,
  before,
  onSuccess,
  onFailure,
  onUnauthorized,
  mode: 'cors'
};
const middleware = middleware$1(http, config$1);
const api = configureApi(config$1);
var apiMiddlewareLegacy = {
  middleware,
  api
};

// Shared global history
const browserHistory = createBrowserHistory();

const createMockData = (defaultData, overwrites = {}) => ({
  ...defaultData,
  ...overwrites
});

function mockWindow() {
  Object.defineProperty(window, 'matchMedia', {
    writable: true,
    value: jest.fn().mockImplementation(query => ({
      matches: false,
      media: query,
      onchange: null,
      addListener: jest.fn(),
      // Deprecated
      removeListener: jest.fn(),
      // Deprecated
      addEventListener: jest.fn(),
      removeEventListener: jest.fn(),
      dispatchEvent: jest.fn()
    }))
  });
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

var regeneratorRuntime$1 = {exports: {}};

var hasRequiredRegeneratorRuntime;
function requireRegeneratorRuntime() {
  if (hasRequiredRegeneratorRuntime) return regeneratorRuntime$1.exports;
  hasRequiredRegeneratorRuntime = 1;
  (function (module) {
    var _typeof = require_typeof()["default"];
    function _regeneratorRuntime() {

      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
      module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
        return e;
      }, module.exports.__esModule = true, module.exports["default"] = module.exports;
      var t,
        e = {},
        r = Object.prototype,
        n = r.hasOwnProperty,
        o = Object.defineProperty || function (t, e, r) {
          t[e] = r.value;
        },
        i = "function" == typeof Symbol ? Symbol : {},
        a = i.iterator || "@@iterator",
        c = i.asyncIterator || "@@asyncIterator",
        u = i.toStringTag || "@@toStringTag";
      function define(t, e, r) {
        return Object.defineProperty(t, e, {
          value: r,
          enumerable: true,
          configurable: true,
          writable: true
        }), t[e];
      }
      try {
        define({}, "");
      } catch (t) {
        define = function define(t, e, r) {
          return t[e] = r;
        };
      }
      function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator,
          a = Object.create(i.prototype),
          c = new Context(n || []);
        return o(a, "_invoke", {
          value: makeInvokeMethod(t, r, c)
        }), a;
      }
      function tryCatch(t, e, r) {
        try {
          return {
            type: "normal",
            arg: t.call(e, r)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }
      e.wrap = wrap;
      var h = "suspendedStart",
        l = "suspendedYield",
        f = "executing",
        s = "completed",
        y = {};
      function Generator() {}
      function GeneratorFunction() {}
      function GeneratorFunctionPrototype() {}
      var p = {};
      define(p, a, function () {
        return this;
      });
      var d = Object.getPrototypeOf,
        v = d && d(d(values([])));
      v && v !== r && n.call(v, a) && (p = v);
      var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
      function defineIteratorMethods(t) {
        ["next", "throw", "return"].forEach(function (e) {
          define(t, e, function (t) {
            return this._invoke(e, t);
          });
        });
      }
      function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
          var c = tryCatch(t[r], t, o);
          if ("throw" !== c.type) {
            var u = c.arg,
              h = u.value;
            return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
              invoke("next", t, i, a);
            }, function (t) {
              invoke("throw", t, i, a);
            }) : e.resolve(h).then(function (t) {
              u.value = t, i(u);
            }, function (t) {
              return invoke("throw", t, i, a);
            });
          }
          a(c.arg);
        }
        var r;
        o(this, "_invoke", {
          value: function value(t, n) {
            function callInvokeWithMethodAndArg() {
              return new e(function (e, r) {
                invoke(t, n, e, r);
              });
            }
            return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
          }
        });
      }
      function makeInvokeMethod(e, r, n) {
        var o = h;
        return function (i, a) {
          if (o === f) throw Error("Generator is already running");
          if (o === s) {
            if ("throw" === i) throw a;
            return {
              value: t,
              done: true
            };
          }
          for (n.method = i, n.arg = a;;) {
            var c = n.delegate;
            if (c) {
              var u = maybeInvokeDelegate(c, n);
              if (u) {
                if (u === y) continue;
                return u;
              }
            }
            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (o === h) throw o = s, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            o = f;
            var p = tryCatch(e, r, n);
            if ("normal" === p.type) {
              if (o = n.done ? s : l, p.arg === y) continue;
              return {
                value: p.arg,
                done: n.done
              };
            }
            "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
          }
        };
      }
      function maybeInvokeDelegate(e, r) {
        var n = r.method,
          o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
      }
      function pushTryEntry(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }
      function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }
      function Context(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(pushTryEntry, this), this.reset(true);
      }
      function values(e) {
        if (e || "" === e) {
          var r = e[a];
          if (r) return r.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var o = -1,
              i = function next() {
                for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = false, next;
                return next.value = t, next.done = true, next;
              };
            return i.next = i;
          }
        }
        throw new TypeError(_typeof(e) + " is not iterable");
      }
      return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
      }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
      }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
      }, e.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
      }, e.awrap = function (t) {
        return {
          __await: t
        };
      }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
        return this;
      }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
          return t.done ? t.value : a.next();
        });
      }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
        return this;
      }), define(g, "toString", function () {
        return "[object Generator]";
      }), e.keys = function (t) {
        var e = Object(t),
          r = [];
        for (var n in e) r.push(n);
        return r.reverse(), function next() {
          for (; r.length;) {
            var t = r.pop();
            if (t in e) return next.value = t, next.done = false, next;
          }
          return next.done = true, next;
        };
      }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = false, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
          this.done = true;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var r = this;
          function handle(n, o) {
            return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
          }
          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var i = this.tryEntries[o],
              a = i.completion;
            if ("root" === i.tryLoc) return handle("end");
            if (i.tryLoc <= this.prev) {
              var c = n.call(i, "catchLoc"),
                u = n.call(i, "finallyLoc");
              if (c && u) {
                if (this.prev < i.catchLoc) return handle(i.catchLoc, true);
                if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
              } else if (c) {
                if (this.prev < i.catchLoc) return handle(i.catchLoc, true);
              } else {
                if (!u) throw Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];
            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
          }
        },
        "catch": function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.tryLoc === t) {
              var n = r.completion;
              if ("throw" === n.type) {
                var o = n.arg;
                resetTryEntry(r);
              }
              return o;
            }
          }
          throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
          return this.delegate = {
            iterator: values(e),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = t), y;
        }
      }, e;
    }
    module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(regeneratorRuntime$1);
  return regeneratorRuntime$1.exports;
}

var regenerator;
var hasRequiredRegenerator;
function requireRegenerator() {
  if (hasRequiredRegenerator) return regenerator;
  hasRequiredRegenerator = 1;
  // TODO(Babel 8): Remove this file.

  var runtime = requireRegeneratorRuntime()();
  regenerator = runtime;

  // Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    if (typeof globalThis === "object") {
      globalThis.regeneratorRuntime = runtime;
    } else {
      Function("r", "regeneratorRuntime = r")(runtime);
    }
  }
  return regenerator;
}

var regeneratorExports = requireRegenerator();
var _regeneratorRuntime = /*@__PURE__*/getDefaultExportFromCjs(regeneratorExports);

var build = {};

var ansiStyles = {exports: {}};

ansiStyles.exports;
var hasRequiredAnsiStyles;
function requireAnsiStyles() {
  if (hasRequiredAnsiStyles) return ansiStyles.exports;
  hasRequiredAnsiStyles = 1;
  (function (module) {

    const ANSI_BACKGROUND_OFFSET = 10;
    const wrapAnsi256 = (offset = 0) => code => `\u001B[${38 + offset};5;${code}m`;
    const wrapAnsi16m = (offset = 0) => (red, green, blue) => `\u001B[${38 + offset};2;${red};${green};${blue}m`;
    function assembleStyles() {
      const codes = new Map();
      const styles = {
        modifier: {
          reset: [0, 0],
          // 21 isn't widely supported and 22 does the same thing
          bold: [1, 22],
          dim: [2, 22],
          italic: [3, 23],
          underline: [4, 24],
          overline: [53, 55],
          inverse: [7, 27],
          hidden: [8, 28],
          strikethrough: [9, 29]
        },
        color: {
          black: [30, 39],
          red: [31, 39],
          green: [32, 39],
          yellow: [33, 39],
          blue: [34, 39],
          magenta: [35, 39],
          cyan: [36, 39],
          white: [37, 39],
          // Bright color
          blackBright: [90, 39],
          redBright: [91, 39],
          greenBright: [92, 39],
          yellowBright: [93, 39],
          blueBright: [94, 39],
          magentaBright: [95, 39],
          cyanBright: [96, 39],
          whiteBright: [97, 39]
        },
        bgColor: {
          bgBlack: [40, 49],
          bgRed: [41, 49],
          bgGreen: [42, 49],
          bgYellow: [43, 49],
          bgBlue: [44, 49],
          bgMagenta: [45, 49],
          bgCyan: [46, 49],
          bgWhite: [47, 49],
          // Bright color
          bgBlackBright: [100, 49],
          bgRedBright: [101, 49],
          bgGreenBright: [102, 49],
          bgYellowBright: [103, 49],
          bgBlueBright: [104, 49],
          bgMagentaBright: [105, 49],
          bgCyanBright: [106, 49],
          bgWhiteBright: [107, 49]
        }
      };

      // Alias bright black as gray (and grey)
      styles.color.gray = styles.color.blackBright;
      styles.bgColor.bgGray = styles.bgColor.bgBlackBright;
      styles.color.grey = styles.color.blackBright;
      styles.bgColor.bgGrey = styles.bgColor.bgBlackBright;
      for (const [groupName, group] of Object.entries(styles)) {
        for (const [styleName, style] of Object.entries(group)) {
          styles[styleName] = {
            open: `\u001B[${style[0]}m`,
            close: `\u001B[${style[1]}m`
          };
          group[styleName] = styles[styleName];
          codes.set(style[0], style[1]);
        }
        Object.defineProperty(styles, groupName, {
          value: group,
          enumerable: false
        });
      }
      Object.defineProperty(styles, 'codes', {
        value: codes,
        enumerable: false
      });
      styles.color.close = '\u001B[39m';
      styles.bgColor.close = '\u001B[49m';
      styles.color.ansi256 = wrapAnsi256();
      styles.color.ansi16m = wrapAnsi16m();
      styles.bgColor.ansi256 = wrapAnsi256(ANSI_BACKGROUND_OFFSET);
      styles.bgColor.ansi16m = wrapAnsi16m(ANSI_BACKGROUND_OFFSET);

      // From https://github.com/Qix-/color-convert/blob/3f0e0d4e92e235796ccb17f6e85c72094a651f49/conversions.js
      Object.defineProperties(styles, {
        rgbToAnsi256: {
          value: (red, green, blue) => {
            // We use the extended greyscale palette here, with the exception of
            // black and white. normal palette only has 4 greyscale shades.
            if (red === green && green === blue) {
              if (red < 8) {
                return 16;
              }
              if (red > 248) {
                return 231;
              }
              return Math.round((red - 8) / 247 * 24) + 232;
            }
            return 16 + 36 * Math.round(red / 255 * 5) + 6 * Math.round(green / 255 * 5) + Math.round(blue / 255 * 5);
          },
          enumerable: false
        },
        hexToRgb: {
          value: hex => {
            const matches = /(?<colorString>[a-f\d]{6}|[a-f\d]{3})/i.exec(hex.toString(16));
            if (!matches) {
              return [0, 0, 0];
            }
            let {
              colorString
            } = matches.groups;
            if (colorString.length === 3) {
              colorString = colorString.split('').map(character => character + character).join('');
            }
            const integer = Number.parseInt(colorString, 16);
            return [integer >> 16 & 0xFF, integer >> 8 & 0xFF, integer & 0xFF];
          },
          enumerable: false
        },
        hexToAnsi256: {
          value: hex => styles.rgbToAnsi256(...styles.hexToRgb(hex)),
          enumerable: false
        }
      });
      return styles;
    }

    // Make the export immutable
    Object.defineProperty(module, 'exports', {
      enumerable: true,
      get: assembleStyles
    });
  })(ansiStyles);
  return ansiStyles.exports;
}

var collections = {};

var hasRequiredCollections;
function requireCollections() {
  if (hasRequiredCollections) return collections;
  hasRequiredCollections = 1;
  Object.defineProperty(collections, '__esModule', {
    value: true
  });
  collections.printIteratorEntries = printIteratorEntries;
  collections.printIteratorValues = printIteratorValues;
  collections.printListItems = printListItems;
  collections.printObjectProperties = printObjectProperties;

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   */
  const getKeysOfEnumerableProperties = (object, compareKeys) => {
    const keys = Object.keys(object).sort(compareKeys);
    if (Object.getOwnPropertySymbols) {
      Object.getOwnPropertySymbols(object).forEach(symbol => {
        if (Object.getOwnPropertyDescriptor(object, symbol).enumerable) {
          keys.push(symbol);
        }
      });
    }
    return keys;
  };
  /**
   * Return entries (for example, of a map)
   * with spacing, indentation, and comma
   * without surrounding punctuation (for example, braces)
   */

  function printIteratorEntries(iterator, config, indentation, depth, refs, printer,
  // Too bad, so sad that separator for ECMAScript Map has been ' => '
  // What a distracting diff if you change a data structure to/from
  // ECMAScript Object or Immutable.Map/OrderedMap which use the default.
  separator = ': ') {
    let result = '';
    let current = iterator.next();
    if (!current.done) {
      result += config.spacingOuter;
      const indentationNext = indentation + config.indent;
      while (!current.done) {
        const name = printer(current.value[0], config, indentationNext, depth, refs);
        const value = printer(current.value[1], config, indentationNext, depth, refs);
        result += indentationNext + name + separator + value;
        current = iterator.next();
        if (!current.done) {
          result += ',' + config.spacingInner;
        } else if (!config.min) {
          result += ',';
        }
      }
      result += config.spacingOuter + indentation;
    }
    return result;
  }
  /**
   * Return values (for example, of a set)
   * with spacing, indentation, and comma
   * without surrounding punctuation (braces or brackets)
   */

  function printIteratorValues(iterator, config, indentation, depth, refs, printer) {
    let result = '';
    let current = iterator.next();
    if (!current.done) {
      result += config.spacingOuter;
      const indentationNext = indentation + config.indent;
      while (!current.done) {
        result += indentationNext + printer(current.value, config, indentationNext, depth, refs);
        current = iterator.next();
        if (!current.done) {
          result += ',' + config.spacingInner;
        } else if (!config.min) {
          result += ',';
        }
      }
      result += config.spacingOuter + indentation;
    }
    return result;
  }
  /**
   * Return items (for example, of an array)
   * with spacing, indentation, and comma
   * without surrounding punctuation (for example, brackets)
   **/

  function printListItems(list, config, indentation, depth, refs, printer) {
    let result = '';
    if (list.length) {
      result += config.spacingOuter;
      const indentationNext = indentation + config.indent;
      for (let i = 0; i < list.length; i++) {
        result += indentationNext;
        if (i in list) {
          result += printer(list[i], config, indentationNext, depth, refs);
        }
        if (i < list.length - 1) {
          result += ',' + config.spacingInner;
        } else if (!config.min) {
          result += ',';
        }
      }
      result += config.spacingOuter + indentation;
    }
    return result;
  }
  /**
   * Return properties of an object
   * with spacing, indentation, and comma
   * without surrounding punctuation (for example, braces)
   */

  function printObjectProperties(val, config, indentation, depth, refs, printer) {
    let result = '';
    const keys = getKeysOfEnumerableProperties(val, config.compareKeys);
    if (keys.length) {
      result += config.spacingOuter;
      const indentationNext = indentation + config.indent;
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const name = printer(key, config, indentationNext, depth, refs);
        const value = printer(val[key], config, indentationNext, depth, refs);
        result += indentationNext + name + ': ' + value;
        if (i < keys.length - 1) {
          result += ',' + config.spacingInner;
        } else if (!config.min) {
          result += ',';
        }
      }
      result += config.spacingOuter + indentation;
    }
    return result;
  }
  return collections;
}

var AsymmetricMatcher = {};

var hasRequiredAsymmetricMatcher;
function requireAsymmetricMatcher() {
  if (hasRequiredAsymmetricMatcher) return AsymmetricMatcher;
  hasRequiredAsymmetricMatcher = 1;
  Object.defineProperty(AsymmetricMatcher, '__esModule', {
    value: true
  });
  AsymmetricMatcher.test = AsymmetricMatcher.serialize = AsymmetricMatcher.default = void 0;
  var _collections = requireCollections();
  var global = function () {
    if (typeof globalThis !== 'undefined') {
      return globalThis;
    } else if (typeof global !== 'undefined') {
      return global;
    } else if (typeof self !== 'undefined') {
      return self;
    } else if (typeof window !== 'undefined') {
      return window;
    } else {
      return Function('return this')();
    }
  }();
  var Symbol = global['jest-symbol-do-not-touch'] || global.Symbol;
  const asymmetricMatcher = typeof Symbol === 'function' && Symbol.for ? Symbol.for('jest.asymmetricMatcher') : 0x1357a5;
  const SPACE = ' ';
  const serialize = (val, config, indentation, depth, refs, printer) => {
    const stringedValue = val.toString();
    if (stringedValue === 'ArrayContaining' || stringedValue === 'ArrayNotContaining') {
      if (++depth > config.maxDepth) {
        return '[' + stringedValue + ']';
      }
      return stringedValue + SPACE + '[' + (0, _collections.printListItems)(val.sample, config, indentation, depth, refs, printer) + ']';
    }
    if (stringedValue === 'ObjectContaining' || stringedValue === 'ObjectNotContaining') {
      if (++depth > config.maxDepth) {
        return '[' + stringedValue + ']';
      }
      return stringedValue + SPACE + '{' + (0, _collections.printObjectProperties)(val.sample, config, indentation, depth, refs, printer) + '}';
    }
    if (stringedValue === 'StringMatching' || stringedValue === 'StringNotMatching') {
      return stringedValue + SPACE + printer(val.sample, config, indentation, depth, refs);
    }
    if (stringedValue === 'StringContaining' || stringedValue === 'StringNotContaining') {
      return stringedValue + SPACE + printer(val.sample, config, indentation, depth, refs);
    }
    return val.toAsymmetricMatcher();
  };
  AsymmetricMatcher.serialize = serialize;
  const test = val => val && val.$$typeof === asymmetricMatcher;
  AsymmetricMatcher.test = test;
  const plugin = {
    serialize,
    test
  };
  var _default = plugin;
  AsymmetricMatcher.default = _default;
  return AsymmetricMatcher;
}

var ConvertAnsi = {};

var ansiRegex;
var hasRequiredAnsiRegex;
function requireAnsiRegex() {
  if (hasRequiredAnsiRegex) return ansiRegex;
  hasRequiredAnsiRegex = 1;
  ansiRegex = ({
    onlyFirst = false
  } = {}) => {
    const pattern = ['[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)', '(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))'].join('|');
    return new RegExp(pattern, onlyFirst ? undefined : 'g');
  };
  return ansiRegex;
}

var hasRequiredConvertAnsi;
function requireConvertAnsi() {
  if (hasRequiredConvertAnsi) return ConvertAnsi;
  hasRequiredConvertAnsi = 1;
  Object.defineProperty(ConvertAnsi, '__esModule', {
    value: true
  });
  ConvertAnsi.test = ConvertAnsi.serialize = ConvertAnsi.default = void 0;
  var _ansiRegex = _interopRequireDefault(requireAnsiRegex());
  var _ansiStyles = _interopRequireDefault(requireAnsiStyles());
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  const toHumanReadableAnsi = text => text.replace((0, _ansiRegex.default)(), match => {
    switch (match) {
      case _ansiStyles.default.red.close:
      case _ansiStyles.default.green.close:
      case _ansiStyles.default.cyan.close:
      case _ansiStyles.default.gray.close:
      case _ansiStyles.default.white.close:
      case _ansiStyles.default.yellow.close:
      case _ansiStyles.default.bgRed.close:
      case _ansiStyles.default.bgGreen.close:
      case _ansiStyles.default.bgYellow.close:
      case _ansiStyles.default.inverse.close:
      case _ansiStyles.default.dim.close:
      case _ansiStyles.default.bold.close:
      case _ansiStyles.default.reset.open:
      case _ansiStyles.default.reset.close:
        return '</>';
      case _ansiStyles.default.red.open:
        return '<red>';
      case _ansiStyles.default.green.open:
        return '<green>';
      case _ansiStyles.default.cyan.open:
        return '<cyan>';
      case _ansiStyles.default.gray.open:
        return '<gray>';
      case _ansiStyles.default.white.open:
        return '<white>';
      case _ansiStyles.default.yellow.open:
        return '<yellow>';
      case _ansiStyles.default.bgRed.open:
        return '<bgRed>';
      case _ansiStyles.default.bgGreen.open:
        return '<bgGreen>';
      case _ansiStyles.default.bgYellow.open:
        return '<bgYellow>';
      case _ansiStyles.default.inverse.open:
        return '<inverse>';
      case _ansiStyles.default.dim.open:
        return '<dim>';
      case _ansiStyles.default.bold.open:
        return '<bold>';
      default:
        return '';
    }
  });
  const test = val => typeof val === 'string' && !!val.match((0, _ansiRegex.default)());
  ConvertAnsi.test = test;
  const serialize = (val, config, indentation, depth, refs, printer) => printer(toHumanReadableAnsi(val), config, indentation, depth, refs);
  ConvertAnsi.serialize = serialize;
  const plugin = {
    serialize,
    test
  };
  var _default = plugin;
  ConvertAnsi.default = _default;
  return ConvertAnsi;
}

var DOMCollection$1 = {};

var hasRequiredDOMCollection;
function requireDOMCollection() {
  if (hasRequiredDOMCollection) return DOMCollection$1;
  hasRequiredDOMCollection = 1;
  Object.defineProperty(DOMCollection$1, '__esModule', {
    value: true
  });
  DOMCollection$1.test = DOMCollection$1.serialize = DOMCollection$1.default = void 0;
  var _collections = requireCollections();

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  /* eslint-disable local/ban-types-eventually */
  const SPACE = ' ';
  const OBJECT_NAMES = ['DOMStringMap', 'NamedNodeMap'];
  const ARRAY_REGEXP = /^(HTML\w*Collection|NodeList)$/;
  const testName = name => OBJECT_NAMES.indexOf(name) !== -1 || ARRAY_REGEXP.test(name);
  const test = val => val && val.constructor && !!val.constructor.name && testName(val.constructor.name);
  DOMCollection$1.test = test;
  const isNamedNodeMap = collection => collection.constructor.name === 'NamedNodeMap';
  const serialize = (collection, config, indentation, depth, refs, printer) => {
    const name = collection.constructor.name;
    if (++depth > config.maxDepth) {
      return '[' + name + ']';
    }
    return (config.min ? '' : name + SPACE) + (OBJECT_NAMES.indexOf(name) !== -1 ? '{' + (0, _collections.printObjectProperties)(isNamedNodeMap(collection) ? Array.from(collection).reduce((props, attribute) => {
      props[attribute.name] = attribute.value;
      return props;
    }, {}) : {
      ...collection
    }, config, indentation, depth, refs, printer) + '}' : '[' + (0, _collections.printListItems)(Array.from(collection), config, indentation, depth, refs, printer) + ']');
  };
  DOMCollection$1.serialize = serialize;
  const plugin = {
    serialize,
    test
  };
  var _default = plugin;
  DOMCollection$1.default = _default;
  return DOMCollection$1;
}

var DOMElement = {};

var markup = {};

var escapeHTML$1 = {};

var hasRequiredEscapeHTML;
function requireEscapeHTML() {
  if (hasRequiredEscapeHTML) return escapeHTML$1;
  hasRequiredEscapeHTML = 1;
  Object.defineProperty(escapeHTML$1, '__esModule', {
    value: true
  });
  escapeHTML$1.default = escapeHTML;

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  function escapeHTML(str) {
    return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  return escapeHTML$1;
}

var hasRequiredMarkup;
function requireMarkup() {
  if (hasRequiredMarkup) return markup;
  hasRequiredMarkup = 1;
  Object.defineProperty(markup, '__esModule', {
    value: true
  });
  markup.printText = markup.printProps = markup.printElementAsLeaf = markup.printElement = markup.printComment = markup.printChildren = void 0;
  var _escapeHTML = _interopRequireDefault(requireEscapeHTML());
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  // Return empty string if keys is empty.
  const printProps = (keys, props, config, indentation, depth, refs, printer) => {
    const indentationNext = indentation + config.indent;
    const colors = config.colors;
    return keys.map(key => {
      const value = props[key];
      let printed = printer(value, config, indentationNext, depth, refs);
      if (typeof value !== 'string') {
        if (printed.indexOf('\n') !== -1) {
          printed = config.spacingOuter + indentationNext + printed + config.spacingOuter + indentation;
        }
        printed = '{' + printed + '}';
      }
      return config.spacingInner + indentation + colors.prop.open + key + colors.prop.close + '=' + colors.value.open + printed + colors.value.close;
    }).join('');
  }; // Return empty string if children is empty.

  markup.printProps = printProps;
  const printChildren = (children, config, indentation, depth, refs, printer) => children.map(child => config.spacingOuter + indentation + (typeof child === 'string' ? printText(child, config) : printer(child, config, indentation, depth, refs))).join('');
  markup.printChildren = printChildren;
  const printText = (text, config) => {
    const contentColor = config.colors.content;
    return contentColor.open + (0, _escapeHTML.default)(text) + contentColor.close;
  };
  markup.printText = printText;
  const printComment = (comment, config) => {
    const commentColor = config.colors.comment;
    return commentColor.open + '<!--' + (0, _escapeHTML.default)(comment) + '-->' + commentColor.close;
  }; // Separate the functions to format props, children, and element,
  // so a plugin could override a particular function, if needed.
  // Too bad, so sad: the traditional (but unnecessary) space
  // in a self-closing tagColor requires a second test of printedProps.

  markup.printComment = printComment;
  const printElement = (type, printedProps, printedChildren, config, indentation) => {
    const tagColor = config.colors.tag;
    return tagColor.open + '<' + type + (printedProps && tagColor.close + printedProps + config.spacingOuter + indentation + tagColor.open) + (printedChildren ? '>' + tagColor.close + printedChildren + config.spacingOuter + indentation + tagColor.open + '</' + type : (printedProps && !config.min ? '' : ' ') + '/') + '>' + tagColor.close;
  };
  markup.printElement = printElement;
  const printElementAsLeaf = (type, config) => {
    const tagColor = config.colors.tag;
    return tagColor.open + '<' + type + tagColor.close + ' …' + tagColor.open + ' />' + tagColor.close;
  };
  markup.printElementAsLeaf = printElementAsLeaf;
  return markup;
}

var hasRequiredDOMElement;
function requireDOMElement() {
  if (hasRequiredDOMElement) return DOMElement;
  hasRequiredDOMElement = 1;
  Object.defineProperty(DOMElement, '__esModule', {
    value: true
  });
  DOMElement.test = DOMElement.serialize = DOMElement.default = void 0;
  var _markup = requireMarkup();

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  const ELEMENT_NODE = 1;
  const TEXT_NODE = 3;
  const COMMENT_NODE = 8;
  const FRAGMENT_NODE = 11;
  const ELEMENT_REGEXP = /^((HTML|SVG)\w*)?Element$/;
  const testHasAttribute = val => {
    try {
      return typeof val.hasAttribute === 'function' && val.hasAttribute('is');
    } catch {
      return false;
    }
  };
  const testNode = val => {
    const constructorName = val.constructor.name;
    const {
      nodeType,
      tagName
    } = val;
    const isCustomElement = typeof tagName === 'string' && tagName.includes('-') || testHasAttribute(val);
    return nodeType === ELEMENT_NODE && (ELEMENT_REGEXP.test(constructorName) || isCustomElement) || nodeType === TEXT_NODE && constructorName === 'Text' || nodeType === COMMENT_NODE && constructorName === 'Comment' || nodeType === FRAGMENT_NODE && constructorName === 'DocumentFragment';
  };
  const test = val => {
    var _val$constructor;
    return (val === null || val === void 0 ? void 0 : (_val$constructor = val.constructor) === null || _val$constructor === void 0 ? void 0 : _val$constructor.name) && testNode(val);
  };
  DOMElement.test = test;
  function nodeIsText(node) {
    return node.nodeType === TEXT_NODE;
  }
  function nodeIsComment(node) {
    return node.nodeType === COMMENT_NODE;
  }
  function nodeIsFragment(node) {
    return node.nodeType === FRAGMENT_NODE;
  }
  const serialize = (node, config, indentation, depth, refs, printer) => {
    if (nodeIsText(node)) {
      return (0, _markup.printText)(node.data, config);
    }
    if (nodeIsComment(node)) {
      return (0, _markup.printComment)(node.data, config);
    }
    const type = nodeIsFragment(node) ? 'DocumentFragment' : node.tagName.toLowerCase();
    if (++depth > config.maxDepth) {
      return (0, _markup.printElementAsLeaf)(type, config);
    }
    return (0, _markup.printElement)(type, (0, _markup.printProps)(nodeIsFragment(node) ? [] : Array.from(node.attributes).map(attr => attr.name).sort(), nodeIsFragment(node) ? {} : Array.from(node.attributes).reduce((props, attribute) => {
      props[attribute.name] = attribute.value;
      return props;
    }, {}), config, indentation + config.indent, depth, refs, printer), (0, _markup.printChildren)(Array.prototype.slice.call(node.childNodes || node.children), config, indentation + config.indent, depth, refs, printer), config, indentation);
  };
  DOMElement.serialize = serialize;
  const plugin = {
    serialize,
    test
  };
  var _default = plugin;
  DOMElement.default = _default;
  return DOMElement;
}

var Immutable = {};

var hasRequiredImmutable;
function requireImmutable() {
  if (hasRequiredImmutable) return Immutable;
  hasRequiredImmutable = 1;
  Object.defineProperty(Immutable, '__esModule', {
    value: true
  });
  Immutable.test = Immutable.serialize = Immutable.default = void 0;
  var _collections = requireCollections();

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  // SENTINEL constants are from https://github.com/facebook/immutable-js
  const IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  const IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
  const IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  const IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
  const IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
  const IS_RECORD_SENTINEL = '@@__IMMUTABLE_RECORD__@@'; // immutable v4

  const IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
  const IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
  const IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
  const getImmutableName = name => 'Immutable.' + name;
  const printAsLeaf = name => '[' + name + ']';
  const SPACE = ' ';
  const LAZY = '…'; // Seq is lazy if it calls a method like filter

  const printImmutableEntries = (val, config, indentation, depth, refs, printer, type) => ++depth > config.maxDepth ? printAsLeaf(getImmutableName(type)) : getImmutableName(type) + SPACE + '{' + (0, _collections.printIteratorEntries)(val.entries(), config, indentation, depth, refs, printer) + '}'; // Record has an entries method because it is a collection in immutable v3.
  // Return an iterator for Immutable Record from version v3 or v4.

  function getRecordEntries(val) {
    let i = 0;
    return {
      next() {
        if (i < val._keys.length) {
          const key = val._keys[i++];
          return {
            done: false,
            value: [key, val.get(key)]
          };
        }
        return {
          done: true,
          value: undefined
        };
      }
    };
  }
  const printImmutableRecord = (val, config, indentation, depth, refs, printer) => {
    // _name property is defined only for an Immutable Record instance
    // which was constructed with a second optional descriptive name arg
    const name = getImmutableName(val._name || 'Record');
    return ++depth > config.maxDepth ? printAsLeaf(name) : name + SPACE + '{' + (0, _collections.printIteratorEntries)(getRecordEntries(val), config, indentation, depth, refs, printer) + '}';
  };
  const printImmutableSeq = (val, config, indentation, depth, refs, printer) => {
    const name = getImmutableName('Seq');
    if (++depth > config.maxDepth) {
      return printAsLeaf(name);
    }
    if (val[IS_KEYED_SENTINEL]) {
      return name + SPACE + '{' + (
      // from Immutable collection of entries or from ECMAScript object
      val._iter || val._object ? (0, _collections.printIteratorEntries)(val.entries(), config, indentation, depth, refs, printer) : LAZY) + '}';
    }
    return name + SPACE + '[' + (val._iter ||
    // from Immutable collection of values
    val._array ||
    // from ECMAScript array
    val._collection ||
    // from ECMAScript collection in immutable v4
    val._iterable // from ECMAScript collection in immutable v3
    ? (0, _collections.printIteratorValues)(val.values(), config, indentation, depth, refs, printer) : LAZY) + ']';
  };
  const printImmutableValues = (val, config, indentation, depth, refs, printer, type) => ++depth > config.maxDepth ? printAsLeaf(getImmutableName(type)) : getImmutableName(type) + SPACE + '[' + (0, _collections.printIteratorValues)(val.values(), config, indentation, depth, refs, printer) + ']';
  const serialize = (val, config, indentation, depth, refs, printer) => {
    if (val[IS_MAP_SENTINEL]) {
      return printImmutableEntries(val, config, indentation, depth, refs, printer, val[IS_ORDERED_SENTINEL] ? 'OrderedMap' : 'Map');
    }
    if (val[IS_LIST_SENTINEL]) {
      return printImmutableValues(val, config, indentation, depth, refs, printer, 'List');
    }
    if (val[IS_SET_SENTINEL]) {
      return printImmutableValues(val, config, indentation, depth, refs, printer, val[IS_ORDERED_SENTINEL] ? 'OrderedSet' : 'Set');
    }
    if (val[IS_STACK_SENTINEL]) {
      return printImmutableValues(val, config, indentation, depth, refs, printer, 'Stack');
    }
    if (val[IS_SEQ_SENTINEL]) {
      return printImmutableSeq(val, config, indentation, depth, refs, printer);
    } // For compatibility with immutable v3 and v4, let record be the default.

    return printImmutableRecord(val, config, indentation, depth, refs, printer);
  }; // Explicitly comparing sentinel properties to true avoids false positive
  // when mock identity-obj-proxy returns the key as the value for any key.

  Immutable.serialize = serialize;
  const test = val => val && (val[IS_ITERABLE_SENTINEL] === true || val[IS_RECORD_SENTINEL] === true);
  Immutable.test = test;
  const plugin = {
    serialize,
    test
  };
  var _default = plugin;
  Immutable.default = _default;
  return Immutable;
}

var ReactElement = {};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = 60103,
    c = 60106,
    d = 60107,
    e = 60108,
    f = 60114,
    g = 60109,
    h = 60110,
    k = 60112,
    l = 60113,
    m = 60120,
    n = 60115,
    p = 60116,
    q = 60121,
    r = 60122,
    u = 60117,
    v = 60129,
    w = 60131;
  if ("function" === typeof Symbol && Symbol.for) {
    var x = Symbol.for;
    b = x("react.element");
    c = x("react.portal");
    d = x("react.fragment");
    e = x("react.strict_mode");
    f = x("react.profiler");
    g = x("react.provider");
    h = x("react.context");
    k = x("react.forward_ref");
    l = x("react.suspense");
    m = x("react.suspense_list");
    n = x("react.memo");
    p = x("react.lazy");
    q = x("react.block");
    r = x("react.server.block");
    u = x("react.fundamental");
    v = x("react.debug_trace_mode");
    w = x("react.legacy_hidden");
  }
  function y(a) {
    if ("object" === typeof a && null !== a) {
      var t = a.$$typeof;
      switch (t) {
        case b:
          switch (a = a.type, a) {
            case d:
            case f:
            case e:
            case l:
            case m:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case h:
                case k:
                case p:
                case n:
                case g:
                  return a;
                default:
                  return t;
              }
          }
        case c:
          return t;
      }
    }
  }
  var z = g,
    A = b,
    B = k,
    C = d,
    D = p,
    E = n,
    F = c,
    G = f,
    H = e,
    I = l;
  reactIs_production_min.ContextConsumer = h;
  reactIs_production_min.ContextProvider = z;
  reactIs_production_min.Element = A;
  reactIs_production_min.ForwardRef = B;
  reactIs_production_min.Fragment = C;
  reactIs_production_min.Lazy = D;
  reactIs_production_min.Memo = E;
  reactIs_production_min.Portal = F;
  reactIs_production_min.Profiler = G;
  reactIs_production_min.StrictMode = H;
  reactIs_production_min.Suspense = I;
  reactIs_production_min.isAsyncMode = function () {
    return false;
  };
  reactIs_production_min.isConcurrentMode = function () {
    return false;
  };
  reactIs_production_min.isContextConsumer = function (a) {
    return y(a) === h;
  };
  reactIs_production_min.isContextProvider = function (a) {
    return y(a) === g;
  };
  reactIs_production_min.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
  };
  reactIs_production_min.isForwardRef = function (a) {
    return y(a) === k;
  };
  reactIs_production_min.isFragment = function (a) {
    return y(a) === d;
  };
  reactIs_production_min.isLazy = function (a) {
    return y(a) === p;
  };
  reactIs_production_min.isMemo = function (a) {
    return y(a) === n;
  };
  reactIs_production_min.isPortal = function (a) {
    return y(a) === c;
  };
  reactIs_production_min.isProfiler = function (a) {
    return y(a) === f;
  };
  reactIs_production_min.isStrictMode = function (a) {
    return y(a) === e;
  };
  reactIs_production_min.isSuspense = function (a) {
    return y(a) === l;
  };
  reactIs_production_min.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === v || a === e || a === l || a === m || a === w || "object" === typeof a && null !== a && (a.$$typeof === p || a.$$typeof === n || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r) ? true : false;
  };
  reactIs_production_min.typeOf = y;
  return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function () {

      // ATTENTION
      // When adding new symbols to this file,
      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var REACT_ELEMENT_TYPE = 0xeac7;
      var REACT_PORTAL_TYPE = 0xeaca;
      var REACT_FRAGMENT_TYPE = 0xeacb;
      var REACT_STRICT_MODE_TYPE = 0xeacc;
      var REACT_PROFILER_TYPE = 0xead2;
      var REACT_PROVIDER_TYPE = 0xeacd;
      var REACT_CONTEXT_TYPE = 0xeace;
      var REACT_FORWARD_REF_TYPE = 0xead0;
      var REACT_SUSPENSE_TYPE = 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = 0xead8;
      var REACT_MEMO_TYPE = 0xead3;
      var REACT_LAZY_TYPE = 0xead4;
      var REACT_BLOCK_TYPE = 0xead9;
      var REACT_SERVER_BLOCK_TYPE = 0xeada;
      var REACT_FUNDAMENTAL_TYPE = 0xead5;
      var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
      var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
      if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
        REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
        REACT_PROFILER_TYPE = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        symbolFor('react.scope');
        symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
      }

      // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

      var enableScopeAPI = false; // Experimental Create Event Handle API.

      function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') {
          return true;
        } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).

        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
          return true;
        }
        if (typeof type === 'object' && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
            return true;
          }
        }
        return false;
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      }
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
          }
        }
        return false;
      }
      function isConcurrentMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
          }
        }
        return false;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}

var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === 'production') {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}

var hasRequiredReactElement;
function requireReactElement() {
  if (hasRequiredReactElement) return ReactElement;
  hasRequiredReactElement = 1;
  Object.defineProperty(ReactElement, '__esModule', {
    value: true
  });
  ReactElement.test = ReactElement.serialize = ReactElement.default = void 0;
  var ReactIs = _interopRequireWildcard(requireReactIs());
  var _markup = requireMarkup();
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== 'function') return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function (nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== 'object' && typeof obj !== 'function') {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  // Given element.props.children, or subtree during recursive traversal,
  // return flattened array of children.
  const getChildren = (arg, children = []) => {
    if (Array.isArray(arg)) {
      arg.forEach(item => {
        getChildren(item, children);
      });
    } else if (arg != null && arg !== false) {
      children.push(arg);
    }
    return children;
  };
  const getType = element => {
    const type = element.type;
    if (typeof type === 'string') {
      return type;
    }
    if (typeof type === 'function') {
      return type.displayName || type.name || 'Unknown';
    }
    if (ReactIs.isFragment(element)) {
      return 'React.Fragment';
    }
    if (ReactIs.isSuspense(element)) {
      return 'React.Suspense';
    }
    if (typeof type === 'object' && type !== null) {
      if (ReactIs.isContextProvider(element)) {
        return 'Context.Provider';
      }
      if (ReactIs.isContextConsumer(element)) {
        return 'Context.Consumer';
      }
      if (ReactIs.isForwardRef(element)) {
        if (type.displayName) {
          return type.displayName;
        }
        const functionName = type.render.displayName || type.render.name || '';
        return functionName !== '' ? 'ForwardRef(' + functionName + ')' : 'ForwardRef';
      }
      if (ReactIs.isMemo(element)) {
        const functionName = type.displayName || type.type.displayName || type.type.name || '';
        return functionName !== '' ? 'Memo(' + functionName + ')' : 'Memo';
      }
    }
    return 'UNDEFINED';
  };
  const getPropKeys = element => {
    const {
      props
    } = element;
    return Object.keys(props).filter(key => key !== 'children' && props[key] !== undefined).sort();
  };
  const serialize = (element, config, indentation, depth, refs, printer) => ++depth > config.maxDepth ? (0, _markup.printElementAsLeaf)(getType(element), config) : (0, _markup.printElement)(getType(element), (0, _markup.printProps)(getPropKeys(element), element.props, config, indentation + config.indent, depth, refs, printer), (0, _markup.printChildren)(getChildren(element.props.children), config, indentation + config.indent, depth, refs, printer), config, indentation);
  ReactElement.serialize = serialize;
  const test = val => val != null && ReactIs.isElement(val);
  ReactElement.test = test;
  const plugin = {
    serialize,
    test
  };
  var _default = plugin;
  ReactElement.default = _default;
  return ReactElement;
}

var ReactTestComponent = {};

var hasRequiredReactTestComponent;
function requireReactTestComponent() {
  if (hasRequiredReactTestComponent) return ReactTestComponent;
  hasRequiredReactTestComponent = 1;
  Object.defineProperty(ReactTestComponent, '__esModule', {
    value: true
  });
  ReactTestComponent.test = ReactTestComponent.serialize = ReactTestComponent.default = void 0;
  var _markup = requireMarkup();
  var global = function () {
    if (typeof globalThis !== 'undefined') {
      return globalThis;
    } else if (typeof global !== 'undefined') {
      return global;
    } else if (typeof self !== 'undefined') {
      return self;
    } else if (typeof window !== 'undefined') {
      return window;
    } else {
      return Function('return this')();
    }
  }();
  var Symbol = global['jest-symbol-do-not-touch'] || global.Symbol;
  const testSymbol = typeof Symbol === 'function' && Symbol.for ? Symbol.for('react.test.json') : 0xea71357;
  const getPropKeys = object => {
    const {
      props
    } = object;
    return props ? Object.keys(props).filter(key => props[key] !== undefined).sort() : [];
  };
  const serialize = (object, config, indentation, depth, refs, printer) => ++depth > config.maxDepth ? (0, _markup.printElementAsLeaf)(object.type, config) : (0, _markup.printElement)(object.type, object.props ? (0, _markup.printProps)(getPropKeys(object), object.props, config, indentation + config.indent, depth, refs, printer) : '', object.children ? (0, _markup.printChildren)(object.children, config, indentation + config.indent, depth, refs, printer) : '', config, indentation);
  ReactTestComponent.serialize = serialize;
  const test = val => val && val.$$typeof === testSymbol;
  ReactTestComponent.test = test;
  const plugin = {
    serialize,
    test
  };
  var _default = plugin;
  ReactTestComponent.default = _default;
  return ReactTestComponent;
}

var hasRequiredBuild;
function requireBuild() {
  if (hasRequiredBuild) return build;
  hasRequiredBuild = 1;
  Object.defineProperty(build, '__esModule', {
    value: true
  });
  build.default = build.DEFAULT_OPTIONS = void 0;
  build.format = format;
  build.plugins = void 0;
  var _ansiStyles = _interopRequireDefault(requireAnsiStyles());
  var _collections = requireCollections();
  var _AsymmetricMatcher = _interopRequireDefault(requireAsymmetricMatcher());
  var _ConvertAnsi = _interopRequireDefault(requireConvertAnsi());
  var _DOMCollection = _interopRequireDefault(requireDOMCollection());
  var _DOMElement = _interopRequireDefault(requireDOMElement());
  var _Immutable = _interopRequireDefault(requireImmutable());
  var _ReactElement = _interopRequireDefault(requireReactElement());
  var _ReactTestComponent = _interopRequireDefault(requireReactTestComponent());
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  /* eslint-disable local/ban-types-eventually */
  const toString = Object.prototype.toString;
  const toISOString = Date.prototype.toISOString;
  const errorToString = Error.prototype.toString;
  const regExpToString = RegExp.prototype.toString;
  /**
   * Explicitly comparing typeof constructor to function avoids undefined as name
   * when mock identity-obj-proxy returns the key as the value for any key.
   */

  const getConstructorName = val => typeof val.constructor === 'function' && val.constructor.name || 'Object';
  /* global window */

  /** Is val is equal to global window object? Works even if it does not exist :) */

  const isWindow = val => typeof window !== 'undefined' && val === window;
  const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
  const NEWLINE_REGEXP = /\n/gi;
  class PrettyFormatPluginError extends Error {
    constructor(message, stack) {
      super(message);
      this.stack = stack;
      this.name = this.constructor.name;
    }
  }
  function isToStringedArrayType(toStringed) {
    return toStringed === '[object Array]' || toStringed === '[object ArrayBuffer]' || toStringed === '[object DataView]' || toStringed === '[object Float32Array]' || toStringed === '[object Float64Array]' || toStringed === '[object Int8Array]' || toStringed === '[object Int16Array]' || toStringed === '[object Int32Array]' || toStringed === '[object Uint8Array]' || toStringed === '[object Uint8ClampedArray]' || toStringed === '[object Uint16Array]' || toStringed === '[object Uint32Array]';
  }
  function printNumber(val) {
    return Object.is(val, -0) ? '-0' : String(val);
  }
  function printBigInt(val) {
    return String(`${val}n`);
  }
  function printFunction(val, printFunctionName) {
    if (!printFunctionName) {
      return '[Function]';
    }
    return '[Function ' + (val.name || 'anonymous') + ']';
  }
  function printSymbol(val) {
    return String(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  }
  function printError(val) {
    return '[' + errorToString.call(val) + ']';
  }
  /**
   * The first port of call for printing an object, handles most of the
   * data-types in JS.
   */

  function printBasicValue(val, printFunctionName, escapeRegex, escapeString) {
    if (val === true || val === false) {
      return '' + val;
    }
    if (val === undefined) {
      return 'undefined';
    }
    if (val === null) {
      return 'null';
    }
    const typeOf = typeof val;
    if (typeOf === 'number') {
      return printNumber(val);
    }
    if (typeOf === 'bigint') {
      return printBigInt(val);
    }
    if (typeOf === 'string') {
      if (escapeString) {
        return '"' + val.replace(/"|\\/g, '\\$&') + '"';
      }
      return '"' + val + '"';
    }
    if (typeOf === 'function') {
      return printFunction(val, printFunctionName);
    }
    if (typeOf === 'symbol') {
      return printSymbol(val);
    }
    const toStringed = toString.call(val);
    if (toStringed === '[object WeakMap]') {
      return 'WeakMap {}';
    }
    if (toStringed === '[object WeakSet]') {
      return 'WeakSet {}';
    }
    if (toStringed === '[object Function]' || toStringed === '[object GeneratorFunction]') {
      return printFunction(val, printFunctionName);
    }
    if (toStringed === '[object Symbol]') {
      return printSymbol(val);
    }
    if (toStringed === '[object Date]') {
      return isNaN(+val) ? 'Date { NaN }' : toISOString.call(val);
    }
    if (toStringed === '[object Error]') {
      return printError(val);
    }
    if (toStringed === '[object RegExp]') {
      if (escapeRegex) {
        // https://github.com/benjamingr/RegExp.escape/blob/main/polyfill.js
        return regExpToString.call(val).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
      }
      return regExpToString.call(val);
    }
    if (val instanceof Error) {
      return printError(val);
    }
    return null;
  }
  /**
   * Handles more complex objects ( such as objects with circular references.
   * maps and sets etc )
   */

  function printComplexValue(val, config, indentation, depth, refs, hasCalledToJSON) {
    if (refs.indexOf(val) !== -1) {
      return '[Circular]';
    }
    refs = refs.slice();
    refs.push(val);
    const hitMaxDepth = ++depth > config.maxDepth;
    const min = config.min;
    if (config.callToJSON && !hitMaxDepth && val.toJSON && typeof val.toJSON === 'function' && !hasCalledToJSON) {
      return printer(val.toJSON(), config, indentation, depth, refs, true);
    }
    const toStringed = toString.call(val);
    if (toStringed === '[object Arguments]') {
      return hitMaxDepth ? '[Arguments]' : (min ? '' : 'Arguments ') + '[' + (0, _collections.printListItems)(val, config, indentation, depth, refs, printer) + ']';
    }
    if (isToStringedArrayType(toStringed)) {
      return hitMaxDepth ? '[' + val.constructor.name + ']' : (min ? '' : !config.printBasicPrototype && val.constructor.name === 'Array' ? '' : val.constructor.name + ' ') + '[' + (0, _collections.printListItems)(val, config, indentation, depth, refs, printer) + ']';
    }
    if (toStringed === '[object Map]') {
      return hitMaxDepth ? '[Map]' : 'Map {' + (0, _collections.printIteratorEntries)(val.entries(), config, indentation, depth, refs, printer, ' => ') + '}';
    }
    if (toStringed === '[object Set]') {
      return hitMaxDepth ? '[Set]' : 'Set {' + (0, _collections.printIteratorValues)(val.values(), config, indentation, depth, refs, printer) + '}';
    } // Avoid failure to serialize global window object in jsdom test environment.
    // For example, not even relevant if window is prop of React element.

    return hitMaxDepth || isWindow(val) ? '[' + getConstructorName(val) + ']' : (min ? '' : !config.printBasicPrototype && getConstructorName(val) === 'Object' ? '' : getConstructorName(val) + ' ') + '{' + (0, _collections.printObjectProperties)(val, config, indentation, depth, refs, printer) + '}';
  }
  function isNewPlugin(plugin) {
    return plugin.serialize != null;
  }
  function printPlugin(plugin, val, config, indentation, depth, refs) {
    let printed;
    try {
      printed = isNewPlugin(plugin) ? plugin.serialize(val, config, indentation, depth, refs, printer) : plugin.print(val, valChild => printer(valChild, config, indentation, depth, refs), str => {
        const indentationNext = indentation + config.indent;
        return indentationNext + str.replace(NEWLINE_REGEXP, '\n' + indentationNext);
      }, {
        edgeSpacing: config.spacingOuter,
        min: config.min,
        spacing: config.spacingInner
      }, config.colors);
    } catch (error) {
      throw new PrettyFormatPluginError(error.message, error.stack);
    }
    if (typeof printed !== 'string') {
      throw new Error(`pretty-format: Plugin must return type "string" but instead returned "${typeof printed}".`);
    }
    return printed;
  }
  function findPlugin(plugins, val) {
    for (let p = 0; p < plugins.length; p++) {
      try {
        if (plugins[p].test(val)) {
          return plugins[p];
        }
      } catch (error) {
        throw new PrettyFormatPluginError(error.message, error.stack);
      }
    }
    return null;
  }
  function printer(val, config, indentation, depth, refs, hasCalledToJSON) {
    const plugin = findPlugin(config.plugins, val);
    if (plugin !== null) {
      return printPlugin(plugin, val, config, indentation, depth, refs);
    }
    const basicResult = printBasicValue(val, config.printFunctionName, config.escapeRegex, config.escapeString);
    if (basicResult !== null) {
      return basicResult;
    }
    return printComplexValue(val, config, indentation, depth, refs, hasCalledToJSON);
  }
  const DEFAULT_THEME = {
    comment: 'gray',
    content: 'reset',
    prop: 'yellow',
    tag: 'cyan',
    value: 'green'
  };
  const DEFAULT_THEME_KEYS = Object.keys(DEFAULT_THEME);
  const DEFAULT_OPTIONS = {
    callToJSON: true,
    compareKeys: undefined,
    escapeRegex: false,
    escapeString: true,
    highlight: false,
    indent: 2,
    maxDepth: Infinity,
    min: false,
    plugins: [],
    printBasicPrototype: true,
    printFunctionName: true,
    theme: DEFAULT_THEME
  };
  build.DEFAULT_OPTIONS = DEFAULT_OPTIONS;
  function validateOptions(options) {
    Object.keys(options).forEach(key => {
      if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
        throw new Error(`pretty-format: Unknown option "${key}".`);
      }
    });
    if (options.min && options.indent !== undefined && options.indent !== 0) {
      throw new Error('pretty-format: Options "min" and "indent" cannot be used together.');
    }
    if (options.theme !== undefined) {
      if (options.theme === null) {
        throw new Error('pretty-format: Option "theme" must not be null.');
      }
      if (typeof options.theme !== 'object') {
        throw new Error(`pretty-format: Option "theme" must be of type "object" but instead received "${typeof options.theme}".`);
      }
    }
  }
  const getColorsHighlight = options => DEFAULT_THEME_KEYS.reduce((colors, key) => {
    const value = options.theme && options.theme[key] !== undefined ? options.theme[key] : DEFAULT_THEME[key];
    const color = value && _ansiStyles.default[value];
    if (color && typeof color.close === 'string' && typeof color.open === 'string') {
      colors[key] = color;
    } else {
      throw new Error(`pretty-format: Option "theme" has a key "${key}" whose value "${value}" is undefined in ansi-styles.`);
    }
    return colors;
  }, Object.create(null));
  const getColorsEmpty = () => DEFAULT_THEME_KEYS.reduce((colors, key) => {
    colors[key] = {
      close: '',
      open: ''
    };
    return colors;
  }, Object.create(null));
  const getPrintFunctionName = options => options && options.printFunctionName !== undefined ? options.printFunctionName : DEFAULT_OPTIONS.printFunctionName;
  const getEscapeRegex = options => options && options.escapeRegex !== undefined ? options.escapeRegex : DEFAULT_OPTIONS.escapeRegex;
  const getEscapeString = options => options && options.escapeString !== undefined ? options.escapeString : DEFAULT_OPTIONS.escapeString;
  const getConfig = options => {
    var _options$printBasicPr;
    return {
      callToJSON: options && options.callToJSON !== undefined ? options.callToJSON : DEFAULT_OPTIONS.callToJSON,
      colors: options && options.highlight ? getColorsHighlight(options) : getColorsEmpty(),
      compareKeys: options && typeof options.compareKeys === 'function' ? options.compareKeys : DEFAULT_OPTIONS.compareKeys,
      escapeRegex: getEscapeRegex(options),
      escapeString: getEscapeString(options),
      indent: options && options.min ? '' : createIndent(options && options.indent !== undefined ? options.indent : DEFAULT_OPTIONS.indent),
      maxDepth: options && options.maxDepth !== undefined ? options.maxDepth : DEFAULT_OPTIONS.maxDepth,
      min: options && options.min !== undefined ? options.min : DEFAULT_OPTIONS.min,
      plugins: options && options.plugins !== undefined ? options.plugins : DEFAULT_OPTIONS.plugins,
      printBasicPrototype: (_options$printBasicPr = options === null || options === void 0 ? void 0 : options.printBasicPrototype) !== null && _options$printBasicPr !== void 0 ? _options$printBasicPr : true,
      printFunctionName: getPrintFunctionName(options),
      spacingInner: options && options.min ? ' ' : '\n',
      spacingOuter: options && options.min ? '' : '\n'
    };
  };
  function createIndent(indent) {
    return new Array(indent + 1).join(' ');
  }
  /**
   * Returns a presentation string of your `val` object
   * @param val any potential JavaScript object
   * @param options Custom settings
   */

  function format(val, options) {
    if (options) {
      validateOptions(options);
      if (options.plugins) {
        const plugin = findPlugin(options.plugins, val);
        if (plugin !== null) {
          return printPlugin(plugin, val, getConfig(options), '', 0, []);
        }
      }
    }
    const basicResult = printBasicValue(val, getPrintFunctionName(options), getEscapeRegex(options), getEscapeString(options));
    if (basicResult !== null) {
      return basicResult;
    }
    return printComplexValue(val, getConfig(options), '', 0, []);
  }
  const plugins = {
    AsymmetricMatcher: _AsymmetricMatcher.default,
    ConvertAnsi: _ConvertAnsi.default,
    DOMCollection: _DOMCollection.default,
    DOMElement: _DOMElement.default,
    Immutable: _Immutable.default,
    ReactElement: _ReactElement.default,
    ReactTestComponent: _ReactTestComponent.default
  };
  build.plugins = plugins;
  var _default = format;
  build.default = _default;
  return build;
}

var buildExports = requireBuild();

/**
 * @source {https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Polyfill}
 * but without thisArg (too hard to type, no need to `this`)
 */
var toStr = Object.prototype.toString;
function isCallable$1(fn) {
  return typeof fn === "function" || toStr.call(fn) === "[object Function]";
}
function toInteger(value) {
  var number = Number(value);
  if (isNaN(number)) {
    return 0;
  }
  if (number === 0 || !isFinite(number)) {
    return number;
  }
  return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
}
var maxSafeInteger = Math.pow(2, 53) - 1;
function toLength(value) {
  var len = toInteger(value);
  return Math.min(Math.max(len, 0), maxSafeInteger);
}
/**
 * Creates an array from an iterable object.
 * @param iterable An iterable object to convert to an array.
 */

/**
 * Creates an array from an iterable object.
 * @param iterable An iterable object to convert to an array.
 * @param mapfn A mapping function to call on every element of the array.
 * @param thisArg Value of 'this' used to invoke the mapfn.
 */
function arrayFrom(arrayLike, mapFn) {
  // 1. Let C be the this value.
  // edit(@eps1lon): we're not calling it as Array.from
  var C = Array;

  // 2. Let items be ToObject(arrayLike).
  var items = Object(arrayLike);

  // 3. ReturnIfAbrupt(items).
  if (arrayLike == null) {
    throw new TypeError("Array.from requires an array-like object - not null or undefined");
  }

  // 10. Let lenValue be Get(items, "length").
  // 11. Let len be ToLength(lenValue).
  var len = toLength(items.length);

  // 13. If IsConstructor(C) is true, then
  // 13. a. Let A be the result of calling the [[Construct]] internal method
  // of C with an argument list containing the single item len.
  // 14. a. Else, Let A be ArrayCreate(len).
  var A = isCallable$1(C) ? Object(new C(len)) : new Array(len);

  // 16. Let k be 0.
  var k = 0;
  // 17. Repeat, while k < len… (also steps a - h)
  var kValue;
  while (k < len) {
    kValue = items[k];
    {
      A[k] = kValue;
    }
    k += 1;
  }
  // 18. Let putStatus be Put(A, "length", len, true).
  A.length = len;
  // 20. Return A.
  return A;
}

function _typeof$1(obj) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$1(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty$1(obj, key, value) { key = _toPropertyKey$1(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$1(arg) { var key = _toPrimitive$1(arg, "string"); return _typeof$1(key) === "symbol" ? key : String(key); }
function _toPrimitive$1(input, hint) { if (_typeof$1(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint); if (_typeof$1(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// for environments without Set we fallback to arrays with unique members
var SetLike = /*#__PURE__*/function () {
  function SetLike() {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _classCallCheck(this, SetLike);
    _defineProperty$1(this, "items", void 0);
    this.items = items;
  }
  _createClass(SetLike, [{
    key: "add",
    value: function add(value) {
      if (this.has(value) === false) {
        this.items.push(value);
      }
      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.items = [];
    }
  }, {
    key: "delete",
    value: function _delete(value) {
      var previousLength = this.items.length;
      this.items = this.items.filter(function (item) {
        return item !== value;
      });
      return previousLength !== this.items.length;
    }
  }, {
    key: "forEach",
    value: function forEach(callbackfn) {
      var _this = this;
      this.items.forEach(function (item) {
        callbackfn(item, item, _this);
      });
    }
  }, {
    key: "has",
    value: function has(value) {
      return this.items.indexOf(value) !== -1;
    }
  }, {
    key: "size",
    get: function get() {
      return this.items.length;
    }
  }]);
  return SetLike;
}();
var SetLike$1 = typeof Set === "undefined" ? Set : SetLike;

// https://w3c.github.io/html-aria/#document-conformance-requirements-for-use-of-aria-attributes-in-html

/**
 * Safe Element.localName for all supported environments
 * @param element
 */
function getLocalName(element) {
  var _element$localName;
  return (// eslint-disable-next-line no-restricted-properties -- actual guard for environments without localName
    (_element$localName = element.localName) !== null && _element$localName !== void 0 ? _element$localName :
    // eslint-disable-next-line no-restricted-properties -- required for the fallback
    element.tagName.toLowerCase()
  );
}
var localNameToRoleMappings = {
  article: "article",
  aside: "complementary",
  button: "button",
  datalist: "listbox",
  dd: "definition",
  details: "group",
  dialog: "dialog",
  dt: "term",
  fieldset: "group",
  figure: "figure",
  // WARNING: Only with an accessible name
  form: "form",
  footer: "contentinfo",
  h1: "heading",
  h2: "heading",
  h3: "heading",
  h4: "heading",
  h5: "heading",
  h6: "heading",
  header: "banner",
  hr: "separator",
  html: "document",
  legend: "legend",
  li: "listitem",
  math: "math",
  main: "main",
  menu: "list",
  nav: "navigation",
  ol: "list",
  optgroup: "group",
  // WARNING: Only in certain context
  option: "option",
  output: "status",
  progress: "progressbar",
  // WARNING: Only with an accessible name
  section: "region",
  summary: "button",
  table: "table",
  tbody: "rowgroup",
  textarea: "textbox",
  tfoot: "rowgroup",
  // WARNING: Only in certain context
  td: "cell",
  th: "columnheader",
  thead: "rowgroup",
  tr: "row",
  ul: "list"
};
var prohibitedAttributes = {
  caption: new Set(["aria-label", "aria-labelledby"]),
  code: new Set(["aria-label", "aria-labelledby"]),
  deletion: new Set(["aria-label", "aria-labelledby"]),
  emphasis: new Set(["aria-label", "aria-labelledby"]),
  generic: new Set(["aria-label", "aria-labelledby", "aria-roledescription"]),
  insertion: new Set(["aria-label", "aria-labelledby"]),
  paragraph: new Set(["aria-label", "aria-labelledby"]),
  presentation: new Set(["aria-label", "aria-labelledby"]),
  strong: new Set(["aria-label", "aria-labelledby"]),
  subscript: new Set(["aria-label", "aria-labelledby"]),
  superscript: new Set(["aria-label", "aria-labelledby"])
};

/**
 *
 * @param element
 * @param role The role used for this element. This is specified to control whether you want to use the implicit or explicit role.
 */
function hasGlobalAriaAttributes(element, role) {
  // https://rawgit.com/w3c/aria/stable/#global_states
  // commented attributes are deprecated
  return ["aria-atomic", "aria-busy", "aria-controls", "aria-current", "aria-describedby", "aria-details",
  // "disabled",
  "aria-dropeffect",
  // "errormessage",
  "aria-flowto", "aria-grabbed",
  // "haspopup",
  "aria-hidden",
  // "invalid",
  "aria-keyshortcuts", "aria-label", "aria-labelledby", "aria-live", "aria-owns", "aria-relevant", "aria-roledescription"].some(function (attributeName) {
    var _prohibitedAttributes;
    return element.hasAttribute(attributeName) && !((_prohibitedAttributes = prohibitedAttributes[role]) !== null && _prohibitedAttributes !== void 0 && _prohibitedAttributes.has(attributeName));
  });
}
function ignorePresentationalRole(element, implicitRole) {
  // https://rawgit.com/w3c/aria/stable/#conflict_resolution_presentation_none
  return hasGlobalAriaAttributes(element, implicitRole);
}
function getRole(element) {
  var explicitRole = getExplicitRole(element);
  if (explicitRole === null || explicitRole === "presentation") {
    var implicitRole = getImplicitRole(element);
    if (explicitRole !== "presentation" || ignorePresentationalRole(element, implicitRole || "")) {
      return implicitRole;
    }
  }
  return explicitRole;
}
function getImplicitRole(element) {
  var mappedByTag = localNameToRoleMappings[getLocalName(element)];
  if (mappedByTag !== undefined) {
    return mappedByTag;
  }
  switch (getLocalName(element)) {
    case "a":
    case "area":
    case "link":
      if (element.hasAttribute("href")) {
        return "link";
      }
      break;
    case "img":
      if (element.getAttribute("alt") === "" && !ignorePresentationalRole(element, "img")) {
        return "presentation";
      }
      return "img";
    case "input":
      {
        var _ref = element,
          type = _ref.type;
        switch (type) {
          case "button":
          case "image":
          case "reset":
          case "submit":
            return "button";
          case "checkbox":
          case "radio":
            return type;
          case "range":
            return "slider";
          case "email":
          case "tel":
          case "text":
          case "url":
            if (element.hasAttribute("list")) {
              return "combobox";
            }
            return "textbox";
          case "search":
            if (element.hasAttribute("list")) {
              return "combobox";
            }
            return "searchbox";
          case "number":
            return "spinbutton";
          default:
            return null;
        }
      }
    case "select":
      if (element.hasAttribute("multiple") || element.size > 1) {
        return "listbox";
      }
      return "combobox";
  }
  return null;
}
function getExplicitRole(element) {
  var role = element.getAttribute("role");
  if (role !== null) {
    var explicitRole = role.trim().split(" ")[0];
    // String.prototype.split(sep, limit) will always return an array with at least one member
    // as long as limit is either undefined or > 0
    if (explicitRole.length > 0) {
      return explicitRole;
    }
  }
  return null;
}

function isElement(node) {
  return node !== null && node.nodeType === node.ELEMENT_NODE;
}
function isHTMLTableCaptionElement(node) {
  return isElement(node) && getLocalName(node) === "caption";
}
function isHTMLInputElement(node) {
  return isElement(node) && getLocalName(node) === "input";
}
function isHTMLOptGroupElement(node) {
  return isElement(node) && getLocalName(node) === "optgroup";
}
function isHTMLSelectElement(node) {
  return isElement(node) && getLocalName(node) === "select";
}
function isHTMLTableElement(node) {
  return isElement(node) && getLocalName(node) === "table";
}
function isHTMLTextAreaElement(node) {
  return isElement(node) && getLocalName(node) === "textarea";
}
function safeWindow(node) {
  var _ref = node.ownerDocument === null ? node : node.ownerDocument,
    defaultView = _ref.defaultView;
  if (defaultView === null) {
    throw new TypeError("no window available");
  }
  return defaultView;
}
function isHTMLFieldSetElement(node) {
  return isElement(node) && getLocalName(node) === "fieldset";
}
function isHTMLLegendElement(node) {
  return isElement(node) && getLocalName(node) === "legend";
}
function isHTMLSlotElement(node) {
  return isElement(node) && getLocalName(node) === "slot";
}
function isSVGElement(node) {
  return isElement(node) && node.ownerSVGElement !== undefined;
}
function isSVGSVGElement(node) {
  return isElement(node) && getLocalName(node) === "svg";
}
function isSVGTitleElement(node) {
  return isSVGElement(node) && getLocalName(node) === "title";
}

/**
 *
 * @param {Node} node -
 * @param {string} attributeName -
 * @returns {Element[]} -
 */
function queryIdRefs(node, attributeName) {
  if (isElement(node) && node.hasAttribute(attributeName)) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute check
    var ids = node.getAttribute(attributeName).split(" ");

    // Browsers that don't support shadow DOM won't have getRootNode
    var root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
    return ids.map(function (id) {
      return root.getElementById(id);
    }).filter(function (element) {
      return element !== null;
    }
    // TODO: why does this not narrow?
    );
  }

  return [];
}
function hasAnyConcreteRoles(node, roles) {
  if (isElement(node)) {
    return roles.indexOf(getRole(node)) !== -1;
  }
  return false;
}

/**
 * implements https://w3c.github.io/accname/
 */

/**
 *  A string of characters where all carriage returns, newlines, tabs, and form-feeds are replaced with a single space, and multiple spaces are reduced to a single space. The string contains only character data; it does not contain any markup.
 */

/**
 *
 * @param {string} string -
 * @returns {FlatString} -
 */
function asFlatString(s) {
  return s.trim().replace(/\s\s+/g, " ");
}

/**
 *
 * @param node -
 * @param options - These are not optional to prevent accidentally calling it without options in `computeAccessibleName`
 * @returns {boolean} -
 */
function isHidden(node, getComputedStyleImplementation) {
  if (!isElement(node)) {
    return false;
  }
  if (node.hasAttribute("hidden") || node.getAttribute("aria-hidden") === "true") {
    return true;
  }
  var style = getComputedStyleImplementation(node);
  return style.getPropertyValue("display") === "none" || style.getPropertyValue("visibility") === "hidden";
}

/**
 * @param {Node} node -
 * @returns {boolean} - As defined in step 2E of https://w3c.github.io/accname/#mapping_additional_nd_te
 */
function isControl(node) {
  return hasAnyConcreteRoles(node, ["button", "combobox", "listbox", "textbox"]) || hasAbstractRole(node, "range");
}
function hasAbstractRole(node, role) {
  if (!isElement(node)) {
    return false;
  }
  switch (role) {
    case "range":
      return hasAnyConcreteRoles(node, ["meter", "progressbar", "scrollbar", "slider", "spinbutton"]);
    default:
      throw new TypeError("No knowledge about abstract role '".concat(role, "'. This is likely a bug :("));
  }
}

/**
 * element.querySelectorAll but also considers owned tree
 * @param element
 * @param selectors
 */
function querySelectorAllSubtree(element, selectors) {
  var elements = arrayFrom(element.querySelectorAll(selectors));
  queryIdRefs(element, "aria-owns").forEach(function (root) {
    // babel transpiles this assuming an iterator
    elements.push.apply(elements, arrayFrom(root.querySelectorAll(selectors)));
  });
  return elements;
}
function querySelectedOptions(listbox) {
  if (isHTMLSelectElement(listbox)) {
    // IE11 polyfill
    return listbox.selectedOptions || querySelectorAllSubtree(listbox, "[selected]");
  }
  return querySelectorAllSubtree(listbox, '[aria-selected="true"]');
}
function isMarkedPresentational(node) {
  return hasAnyConcreteRoles(node, ["none", "presentation"]);
}

/**
 * Elements specifically listed in html-aam
 *
 * We don't need this for `label` or `legend` elements.
 * Their implicit roles already allow "naming from content".
 *
 * sources:
 *
 * - https://w3c.github.io/html-aam/#table-element
 */
function isNativeHostLanguageTextAlternativeElement(node) {
  return isHTMLTableCaptionElement(node);
}

/**
 * https://w3c.github.io/aria/#namefromcontent
 */
function allowsNameFromContent(node) {
  return hasAnyConcreteRoles(node, ["button", "cell", "checkbox", "columnheader", "gridcell", "heading", "label", "legend", "link", "menuitem", "menuitemcheckbox", "menuitemradio", "option", "radio", "row", "rowheader", "switch", "tab", "tooltip", "treeitem"]);
}

/**
 * TODO https://github.com/eps1lon/dom-accessibility-api/issues/100
 */
function isDescendantOfNativeHostLanguageTextAlternativeElement(
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- not implemented yet
node) {
  return false;
}
function getValueOfTextbox(element) {
  if (isHTMLInputElement(element) || isHTMLTextAreaElement(element)) {
    return element.value;
  }
  // https://github.com/eps1lon/dom-accessibility-api/issues/4
  return element.textContent || "";
}
function getTextualContent(declaration) {
  var content = declaration.getPropertyValue("content");
  if (/^["'].*["']$/.test(content)) {
    return content.slice(1, -1);
  }
  return "";
}

/**
 * https://html.spec.whatwg.org/multipage/forms.html#category-label
 * TODO: form-associated custom elements
 * @param element
 */
function isLabelableElement(element) {
  var localName = getLocalName(element);
  return localName === "button" || localName === "input" && element.getAttribute("type") !== "hidden" || localName === "meter" || localName === "output" || localName === "progress" || localName === "select" || localName === "textarea";
}

/**
 * > [...], then the first such descendant in tree order is the label element's labeled control.
 * -- https://html.spec.whatwg.org/multipage/forms.html#labeled-control
 * @param element
 */
function findLabelableElement(element) {
  if (isLabelableElement(element)) {
    return element;
  }
  var labelableElement = null;
  element.childNodes.forEach(function (childNode) {
    if (labelableElement === null && isElement(childNode)) {
      var descendantLabelableElement = findLabelableElement(childNode);
      if (descendantLabelableElement !== null) {
        labelableElement = descendantLabelableElement;
      }
    }
  });
  return labelableElement;
}

/**
 * Polyfill of HTMLLabelElement.control
 * https://html.spec.whatwg.org/multipage/forms.html#labeled-control
 * @param label
 */
function getControlOfLabel(label) {
  if (label.control !== undefined) {
    return label.control;
  }
  var htmlFor = label.getAttribute("for");
  if (htmlFor !== null) {
    return label.ownerDocument.getElementById(htmlFor);
  }
  return findLabelableElement(label);
}

/**
 * Polyfill of HTMLInputElement.labels
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/labels
 * @param element
 */
function getLabels$1(element) {
  var labelsProperty = element.labels;
  if (labelsProperty === null) {
    return labelsProperty;
  }
  if (labelsProperty !== undefined) {
    return arrayFrom(labelsProperty);
  }

  // polyfill
  if (!isLabelableElement(element)) {
    return null;
  }
  var document = element.ownerDocument;
  return arrayFrom(document.querySelectorAll("label")).filter(function (label) {
    return getControlOfLabel(label) === element;
  });
}

/**
 * Gets the contents of a slot used for computing the accname
 * @param slot
 */
function getSlotContents(slot) {
  // Computing the accessible name for elements containing slots is not
  // currently defined in the spec. This implementation reflects the
  // behavior of NVDA 2020.2/Firefox 81 and iOS VoiceOver/Safari 13.6.
  var assignedNodes = slot.assignedNodes();
  if (assignedNodes.length === 0) {
    // if no nodes are assigned to the slot, it displays the default content
    return arrayFrom(slot.childNodes);
  }
  return assignedNodes;
}

/**
 * implements https://w3c.github.io/accname/#mapping_additional_nd_te
 * @param root
 * @param options
 * @returns
 */
function computeTextAlternative(root) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var consultedNodes = new SetLike$1();
  var window = safeWindow(root);
  var _options$compute = options.compute,
    compute = _options$compute === void 0 ? "name" : _options$compute,
    _options$computedStyl = options.computedStyleSupportsPseudoElements,
    computedStyleSupportsPseudoElements = _options$computedStyl === void 0 ? options.getComputedStyle !== undefined : _options$computedStyl,
    _options$getComputedS = options.getComputedStyle,
    getComputedStyle = _options$getComputedS === void 0 ? window.getComputedStyle.bind(window) : _options$getComputedS,
    _options$hidden = options.hidden,
    hidden = _options$hidden === void 0 ? false : _options$hidden;

  // 2F.i
  function computeMiscTextAlternative(node, context) {
    var accumulatedText = "";
    if (isElement(node) && computedStyleSupportsPseudoElements) {
      var pseudoBefore = getComputedStyle(node, "::before");
      var beforeContent = getTextualContent(pseudoBefore);
      accumulatedText = "".concat(beforeContent, " ").concat(accumulatedText);
    }

    // FIXME: Including aria-owns is not defined in the spec
    // But it is required in the web-platform-test
    var childNodes = isHTMLSlotElement(node) ? getSlotContents(node) : arrayFrom(node.childNodes).concat(queryIdRefs(node, "aria-owns"));
    childNodes.forEach(function (child) {
      var result = computeTextAlternative(child, {
        isEmbeddedInLabel: context.isEmbeddedInLabel,
        isReferenced: false,
        recursion: true
      });
      // TODO: Unclear why display affects delimiter
      // see https://github.com/w3c/accname/issues/3
      var display = isElement(child) ? getComputedStyle(child).getPropertyValue("display") : "inline";
      var separator = display !== "inline" ? " " : "";
      // trailing separator for wpt tests
      accumulatedText += "".concat(separator).concat(result).concat(separator);
    });
    if (isElement(node) && computedStyleSupportsPseudoElements) {
      var pseudoAfter = getComputedStyle(node, "::after");
      var afterContent = getTextualContent(pseudoAfter);
      accumulatedText = "".concat(accumulatedText, " ").concat(afterContent);
    }
    return accumulatedText.trim();
  }

  /**
   *
   * @param element
   * @param attributeName
   * @returns A string non-empty string or `null`
   */
  function useAttribute(element, attributeName) {
    var attribute = element.getAttributeNode(attributeName);
    if (attribute !== null && !consultedNodes.has(attribute) && attribute.value.trim() !== "") {
      consultedNodes.add(attribute);
      return attribute.value;
    }
    return null;
  }
  function computeTooltipAttributeValue(node) {
    if (!isElement(node)) {
      return null;
    }
    return useAttribute(node, "title");
  }
  function computeElementTextAlternative(node) {
    if (!isElement(node)) {
      return null;
    }

    // https://w3c.github.io/html-aam/#fieldset-and-legend-elements
    if (isHTMLFieldSetElement(node)) {
      consultedNodes.add(node);
      var children = arrayFrom(node.childNodes);
      for (var i = 0; i < children.length; i += 1) {
        var child = children[i];
        if (isHTMLLegendElement(child)) {
          return computeTextAlternative(child, {
            isEmbeddedInLabel: false,
            isReferenced: false,
            recursion: false
          });
        }
      }
    } else if (isHTMLTableElement(node)) {
      // https://w3c.github.io/html-aam/#table-element
      consultedNodes.add(node);
      var _children = arrayFrom(node.childNodes);
      for (var _i = 0; _i < _children.length; _i += 1) {
        var _child = _children[_i];
        if (isHTMLTableCaptionElement(_child)) {
          return computeTextAlternative(_child, {
            isEmbeddedInLabel: false,
            isReferenced: false,
            recursion: false
          });
        }
      }
    } else if (isSVGSVGElement(node)) {
      // https://www.w3.org/TR/svg-aam-1.0/
      consultedNodes.add(node);
      var _children2 = arrayFrom(node.childNodes);
      for (var _i2 = 0; _i2 < _children2.length; _i2 += 1) {
        var _child2 = _children2[_i2];
        if (isSVGTitleElement(_child2)) {
          return _child2.textContent;
        }
      }
      return null;
    } else if (getLocalName(node) === "img" || getLocalName(node) === "area") {
      // https://w3c.github.io/html-aam/#area-element
      // https://w3c.github.io/html-aam/#img-element
      var nameFromAlt = useAttribute(node, "alt");
      if (nameFromAlt !== null) {
        return nameFromAlt;
      }
    } else if (isHTMLOptGroupElement(node)) {
      var nameFromLabel = useAttribute(node, "label");
      if (nameFromLabel !== null) {
        return nameFromLabel;
      }
    }
    if (isHTMLInputElement(node) && (node.type === "button" || node.type === "submit" || node.type === "reset")) {
      // https://w3c.github.io/html-aam/#input-type-text-input-type-password-input-type-search-input-type-tel-input-type-email-input-type-url-and-textarea-element-accessible-description-computation
      var nameFromValue = useAttribute(node, "value");
      if (nameFromValue !== null) {
        return nameFromValue;
      }

      // TODO: l10n
      if (node.type === "submit") {
        return "Submit";
      }
      // TODO: l10n
      if (node.type === "reset") {
        return "Reset";
      }
    }
    var labels = getLabels$1(node);
    if (labels !== null && labels.length !== 0) {
      consultedNodes.add(node);
      return arrayFrom(labels).map(function (element) {
        return computeTextAlternative(element, {
          isEmbeddedInLabel: true,
          isReferenced: false,
          recursion: true
        });
      }).filter(function (label) {
        return label.length > 0;
      }).join(" ");
    }

    // https://w3c.github.io/html-aam/#input-type-image-accessible-name-computation
    // TODO: wpt test consider label elements but html-aam does not mention them
    // We follow existing implementations over spec
    if (isHTMLInputElement(node) && node.type === "image") {
      var _nameFromAlt = useAttribute(node, "alt");
      if (_nameFromAlt !== null) {
        return _nameFromAlt;
      }
      var nameFromTitle = useAttribute(node, "title");
      if (nameFromTitle !== null) {
        return nameFromTitle;
      }

      // TODO: l10n
      return "Submit Query";
    }
    if (hasAnyConcreteRoles(node, ["button"])) {
      // https://www.w3.org/TR/html-aam-1.0/#button-element
      var nameFromSubTree = computeMiscTextAlternative(node, {
        isEmbeddedInLabel: false});
      if (nameFromSubTree !== "") {
        return nameFromSubTree;
      }
    }
    return null;
  }
  function computeTextAlternative(current, context) {
    if (consultedNodes.has(current)) {
      return "";
    }

    // 2A
    if (!hidden && isHidden(current, getComputedStyle) && !context.isReferenced) {
      consultedNodes.add(current);
      return "";
    }

    // 2B
    var labelAttributeNode = isElement(current) ? current.getAttributeNode("aria-labelledby") : null;
    // TODO: Do we generally need to block query IdRefs of attributes we have already consulted?
    var labelElements = labelAttributeNode !== null && !consultedNodes.has(labelAttributeNode) ? queryIdRefs(current, "aria-labelledby") : [];
    if (compute === "name" && !context.isReferenced && labelElements.length > 0) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- Can't be null here otherwise labelElements would be empty
      consultedNodes.add(labelAttributeNode);
      return labelElements.map(function (element) {
        // TODO: Chrome will consider repeated values i.e. use a node multiple times while we'll bail out in computeTextAlternative.
        return computeTextAlternative(element, {
          isEmbeddedInLabel: context.isEmbeddedInLabel,
          isReferenced: true,
          // this isn't recursion as specified, otherwise we would skip
          // `aria-label` in
          // <input id="myself" aria-label="foo" aria-labelledby="myself"
          recursion: false
        });
      }).join(" ");
    }

    // 2C
    // Changed from the spec in anticipation of https://github.com/w3c/accname/issues/64
    // spec says we should only consider skipping if we have a non-empty label
    var skipToStep2E = context.recursion && isControl(current) && compute === "name";
    if (!skipToStep2E) {
      var ariaLabel = (isElement(current) && current.getAttribute("aria-label") || "").trim();
      if (ariaLabel !== "" && compute === "name") {
        consultedNodes.add(current);
        return ariaLabel;
      }

      // 2D
      if (!isMarkedPresentational(current)) {
        var elementTextAlternative = computeElementTextAlternative(current);
        if (elementTextAlternative !== null) {
          consultedNodes.add(current);
          return elementTextAlternative;
        }
      }
    }

    // special casing, cheating to make tests pass
    // https://github.com/w3c/accname/issues/67
    if (hasAnyConcreteRoles(current, ["menu"])) {
      consultedNodes.add(current);
      return "";
    }

    // 2E
    if (skipToStep2E || context.isEmbeddedInLabel || context.isReferenced) {
      if (hasAnyConcreteRoles(current, ["combobox", "listbox"])) {
        consultedNodes.add(current);
        var selectedOptions = querySelectedOptions(current);
        if (selectedOptions.length === 0) {
          // defined per test `name_heading_combobox`
          return isHTMLInputElement(current) ? current.value : "";
        }
        return arrayFrom(selectedOptions).map(function (selectedOption) {
          return computeTextAlternative(selectedOption, {
            isEmbeddedInLabel: context.isEmbeddedInLabel,
            isReferenced: false,
            recursion: true
          });
        }).join(" ");
      }
      if (hasAbstractRole(current, "range")) {
        consultedNodes.add(current);
        if (current.hasAttribute("aria-valuetext")) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute guard
          return current.getAttribute("aria-valuetext");
        }
        if (current.hasAttribute("aria-valuenow")) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute guard
          return current.getAttribute("aria-valuenow");
        }
        // Otherwise, use the value as specified by a host language attribute.
        return current.getAttribute("value") || "";
      }
      if (hasAnyConcreteRoles(current, ["textbox"])) {
        consultedNodes.add(current);
        return getValueOfTextbox(current);
      }
    }

    // 2F: https://w3c.github.io/accname/#step2F
    if (allowsNameFromContent(current) || isElement(current) && context.isReferenced || isNativeHostLanguageTextAlternativeElement(current) || isDescendantOfNativeHostLanguageTextAlternativeElement()) {
      var accumulatedText2F = computeMiscTextAlternative(current, {
        isEmbeddedInLabel: context.isEmbeddedInLabel});
      if (accumulatedText2F !== "") {
        consultedNodes.add(current);
        return accumulatedText2F;
      }
    }
    if (current.nodeType === current.TEXT_NODE) {
      consultedNodes.add(current);
      return current.textContent || "";
    }
    if (context.recursion) {
      consultedNodes.add(current);
      return computeMiscTextAlternative(current, {
        isEmbeddedInLabel: context.isEmbeddedInLabel});
    }
    var tooltipAttributeValue = computeTooltipAttributeValue(current);
    if (tooltipAttributeValue !== null) {
      consultedNodes.add(current);
      return tooltipAttributeValue;
    }

    // TODO should this be reachable?
    consultedNodes.add(current);
    return "";
  }
  return asFlatString(computeTextAlternative(root, {
    isEmbeddedInLabel: false,
    // by spec computeAccessibleDescription starts with the referenced elements as roots
    isReferenced: compute === "description",
    recursion: false
  }));
}

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

/**
 * @param root
 * @param options
 * @returns
 */
function computeAccessibleDescription(root) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var description = queryIdRefs(root, "aria-describedby").map(function (element) {
    return computeTextAlternative(element, _objectSpread(_objectSpread({}, options), {}, {
      compute: "description"
    }));
  }).join(" ");

  // TODO: Technically we need to make sure that node wasn't used for the accessible name
  //       This causes `description_1.0_combobox-focusable-manual` to fail
  //
  // https://www.w3.org/TR/html-aam-1.0/#accessible-name-and-description-computation
  // says for so many elements to use the `title` that we assume all elements are considered
  if (description === "") {
    var title = root.getAttribute("title");
    description = title === null ? "" : title;
  }
  return description;
}

/**
 * https://w3c.github.io/aria/#namefromprohibited
 */
function prohibitsNaming(node) {
  return hasAnyConcreteRoles(node, ["caption", "code", "deletion", "emphasis", "generic", "insertion", "paragraph", "presentation", "strong", "subscript", "superscript"]);
}

/**
 * implements https://w3c.github.io/accname/#mapping_additional_nd_name
 * @param root
 * @param options
 * @returns
 */
function computeAccessibleName(root) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (prohibitsNaming(root)) {
    return "";
  }
  return computeTextAlternative(root, options);
}

var lib = {};

var ariaPropsMap = {};

var iterationDecorator = {};

var iteratorProxy = {};

var hasRequiredIteratorProxy;
function requireIteratorProxy() {
  if (hasRequiredIteratorProxy) return iteratorProxy;
  hasRequiredIteratorProxy = 1;
  Object.defineProperty(iteratorProxy, "__esModule", {
    value: true
  });
  iteratorProxy.default = void 0;

  // eslint-disable-next-line no-unused-vars
  function iteratorProxy$1() {
    var values = this;
    var index = 0;
    var iter = {
      '@@iterator': function iterator() {
        return iter;
      },
      next: function next() {
        if (index < values.length) {
          var value = values[index];
          index = index + 1;
          return {
            done: false,
            value: value
          };
        } else {
          return {
            done: true
          };
        }
      }
    };
    return iter;
  }
  var _default = iteratorProxy$1;
  iteratorProxy.default = _default;
  return iteratorProxy;
}

var hasRequiredIterationDecorator;
function requireIterationDecorator() {
  if (hasRequiredIterationDecorator) return iterationDecorator;
  hasRequiredIterationDecorator = 1;
  Object.defineProperty(iterationDecorator, "__esModule", {
    value: true
  });
  iterationDecorator.default = iterationDecorator$1;
  var _iteratorProxy = _interopRequireDefault(requireIteratorProxy());
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function iterationDecorator$1(collection, entries) {
    if (typeof Symbol === 'function' && _typeof(Symbol.iterator) === 'symbol') {
      Object.defineProperty(collection, Symbol.iterator, {
        value: _iteratorProxy.default.bind(entries)
      });
    }
    return collection;
  }
  return iterationDecorator;
}

var hasRequiredAriaPropsMap;
function requireAriaPropsMap() {
  if (hasRequiredAriaPropsMap) return ariaPropsMap;
  hasRequiredAriaPropsMap = 1;
  Object.defineProperty(ariaPropsMap, "__esModule", {
    value: true
  });
  ariaPropsMap.default = void 0;
  var _iterationDecorator = _interopRequireDefault(requireIterationDecorator());
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike) {
        if (it) o = it;
        var i = 0;
        var F = function F() {};
        return {
          s: F,
          n: function n() {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function e(_e2) {
            throw _e2;
          },
          f: F
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true,
      didErr = false,
      err;
    return {
      s: function s() {
        it = it.call(o);
      },
      n: function n() {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function e(_e3) {
        didErr = true;
        err = _e3;
      },
      f: function f() {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  var properties = [['aria-activedescendant', {
    'type': 'id'
  }], ['aria-atomic', {
    'type': 'boolean'
  }], ['aria-autocomplete', {
    'type': 'token',
    'values': ['inline', 'list', 'both', 'none']
  }], ['aria-busy', {
    'type': 'boolean'
  }], ['aria-checked', {
    'type': 'tristate'
  }], ['aria-colcount', {
    type: 'integer'
  }], ['aria-colindex', {
    type: 'integer'
  }], ['aria-colspan', {
    type: 'integer'
  }], ['aria-controls', {
    'type': 'idlist'
  }], ['aria-current', {
    type: 'token',
    values: ['page', 'step', 'location', 'date', 'time', true, false]
  }], ['aria-describedby', {
    'type': 'idlist'
  }], ['aria-details', {
    'type': 'id'
  }], ['aria-disabled', {
    'type': 'boolean'
  }], ['aria-dropeffect', {
    'type': 'tokenlist',
    'values': ['copy', 'execute', 'link', 'move', 'none', 'popup']
  }], ['aria-errormessage', {
    'type': 'id'
  }], ['aria-expanded', {
    'type': 'boolean',
    'allowundefined': true
  }], ['aria-flowto', {
    'type': 'idlist'
  }], ['aria-grabbed', {
    'type': 'boolean',
    'allowundefined': true
  }], ['aria-haspopup', {
    'type': 'token',
    'values': [false, true, 'menu', 'listbox', 'tree', 'grid', 'dialog']
  }], ['aria-hidden', {
    'type': 'boolean',
    'allowundefined': true
  }], ['aria-invalid', {
    'type': 'token',
    'values': ['grammar', false, 'spelling', true]
  }], ['aria-keyshortcuts', {
    type: 'string'
  }], ['aria-label', {
    'type': 'string'
  }], ['aria-labelledby', {
    'type': 'idlist'
  }], ['aria-level', {
    'type': 'integer'
  }], ['aria-live', {
    'type': 'token',
    'values': ['assertive', 'off', 'polite']
  }], ['aria-modal', {
    type: 'boolean'
  }], ['aria-multiline', {
    'type': 'boolean'
  }], ['aria-multiselectable', {
    'type': 'boolean'
  }], ['aria-orientation', {
    'type': 'token',
    'values': ['vertical', 'undefined', 'horizontal']
  }], ['aria-owns', {
    'type': 'idlist'
  }], ['aria-placeholder', {
    type: 'string'
  }], ['aria-posinset', {
    'type': 'integer'
  }], ['aria-pressed', {
    'type': 'tristate'
  }], ['aria-readonly', {
    'type': 'boolean'
  }], ['aria-relevant', {
    'type': 'tokenlist',
    'values': ['additions', 'all', 'removals', 'text']
  }], ['aria-required', {
    'type': 'boolean'
  }], ['aria-roledescription', {
    type: 'string'
  }], ['aria-rowcount', {
    type: 'integer'
  }], ['aria-rowindex', {
    type: 'integer'
  }], ['aria-rowspan', {
    type: 'integer'
  }], ['aria-selected', {
    'type': 'boolean',
    'allowundefined': true
  }], ['aria-setsize', {
    'type': 'integer'
  }], ['aria-sort', {
    'type': 'token',
    'values': ['ascending', 'descending', 'none', 'other']
  }], ['aria-valuemax', {
    'type': 'number'
  }], ['aria-valuemin', {
    'type': 'number'
  }], ['aria-valuenow', {
    'type': 'number'
  }], ['aria-valuetext', {
    'type': 'string'
  }]];
  var ariaPropsMap$1 = {
    entries: function entries() {
      return properties;
    },
    forEach: function forEach(fn) {
      var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var _iterator = _createForOfIteratorHelper(properties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            values = _step$value[1];
          fn.call(thisArg, values, key, properties);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    get: function get(key) {
      var item = properties.find(function (tuple) {
        return tuple[0] === key ? true : false;
      });
      return item && item[1];
    },
    has: function has(key) {
      return !!ariaPropsMap$1.get(key);
    },
    keys: function keys() {
      return properties.map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          key = _ref2[0];
        return key;
      });
    },
    values: function values() {
      return properties.map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          values = _ref4[1];
        return values;
      });
    }
  };
  var _default = (0, _iterationDecorator.default)(ariaPropsMap$1, ariaPropsMap$1.entries());
  ariaPropsMap.default = _default;
  return ariaPropsMap;
}

var domMap = {};

var hasRequiredDomMap;
function requireDomMap() {
  if (hasRequiredDomMap) return domMap;
  hasRequiredDomMap = 1;
  Object.defineProperty(domMap, "__esModule", {
    value: true
  });
  domMap.default = void 0;
  var _iterationDecorator = _interopRequireDefault(requireIterationDecorator());
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike) {
        if (it) o = it;
        var i = 0;
        var F = function F() {};
        return {
          s: F,
          n: function n() {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function e(_e2) {
            throw _e2;
          },
          f: F
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true,
      didErr = false,
      err;
    return {
      s: function s() {
        it = it.call(o);
      },
      n: function n() {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function e(_e3) {
        didErr = true;
        err = _e3;
      },
      f: function f() {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  var dom = [['a', {
    reserved: false
  }], ['abbr', {
    reserved: false
  }], ['acronym', {
    reserved: false
  }], ['address', {
    reserved: false
  }], ['applet', {
    reserved: false
  }], ['area', {
    reserved: false
  }], ['article', {
    reserved: false
  }], ['aside', {
    reserved: false
  }], ['audio', {
    reserved: false
  }], ['b', {
    reserved: false
  }], ['base', {
    reserved: true
  }], ['bdi', {
    reserved: false
  }], ['bdo', {
    reserved: false
  }], ['big', {
    reserved: false
  }], ['blink', {
    reserved: false
  }], ['blockquote', {
    reserved: false
  }], ['body', {
    reserved: false
  }], ['br', {
    reserved: false
  }], ['button', {
    reserved: false
  }], ['canvas', {
    reserved: false
  }], ['caption', {
    reserved: false
  }], ['center', {
    reserved: false
  }], ['cite', {
    reserved: false
  }], ['code', {
    reserved: false
  }], ['col', {
    reserved: true
  }], ['colgroup', {
    reserved: true
  }], ['content', {
    reserved: false
  }], ['data', {
    reserved: false
  }], ['datalist', {
    reserved: false
  }], ['dd', {
    reserved: false
  }], ['del', {
    reserved: false
  }], ['details', {
    reserved: false
  }], ['dfn', {
    reserved: false
  }], ['dialog', {
    reserved: false
  }], ['dir', {
    reserved: false
  }], ['div', {
    reserved: false
  }], ['dl', {
    reserved: false
  }], ['dt', {
    reserved: false
  }], ['em', {
    reserved: false
  }], ['embed', {
    reserved: false
  }], ['fieldset', {
    reserved: false
  }], ['figcaption', {
    reserved: false
  }], ['figure', {
    reserved: false
  }], ['font', {
    reserved: false
  }], ['footer', {
    reserved: false
  }], ['form', {
    reserved: false
  }], ['frame', {
    reserved: false
  }], ['frameset', {
    reserved: false
  }], ['h1', {
    reserved: false
  }], ['h2', {
    reserved: false
  }], ['h3', {
    reserved: false
  }], ['h4', {
    reserved: false
  }], ['h5', {
    reserved: false
  }], ['h6', {
    reserved: false
  }], ['head', {
    reserved: true
  }], ['header', {
    reserved: false
  }], ['hgroup', {
    reserved: false
  }], ['hr', {
    reserved: false
  }], ['html', {
    reserved: true
  }], ['i', {
    reserved: false
  }], ['iframe', {
    reserved: false
  }], ['img', {
    reserved: false
  }], ['input', {
    reserved: false
  }], ['ins', {
    reserved: false
  }], ['kbd', {
    reserved: false
  }], ['keygen', {
    reserved: false
  }], ['label', {
    reserved: false
  }], ['legend', {
    reserved: false
  }], ['li', {
    reserved: false
  }], ['link', {
    reserved: true
  }], ['main', {
    reserved: false
  }], ['map', {
    reserved: false
  }], ['mark', {
    reserved: false
  }], ['marquee', {
    reserved: false
  }], ['menu', {
    reserved: false
  }], ['menuitem', {
    reserved: false
  }], ['meta', {
    reserved: true
  }], ['meter', {
    reserved: false
  }], ['nav', {
    reserved: false
  }], ['noembed', {
    reserved: true
  }], ['noscript', {
    reserved: true
  }], ['object', {
    reserved: false
  }], ['ol', {
    reserved: false
  }], ['optgroup', {
    reserved: false
  }], ['option', {
    reserved: false
  }], ['output', {
    reserved: false
  }], ['p', {
    reserved: false
  }], ['param', {
    reserved: true
  }], ['picture', {
    reserved: true
  }], ['pre', {
    reserved: false
  }], ['progress', {
    reserved: false
  }], ['q', {
    reserved: false
  }], ['rp', {
    reserved: false
  }], ['rt', {
    reserved: false
  }], ['rtc', {
    reserved: false
  }], ['ruby', {
    reserved: false
  }], ['s', {
    reserved: false
  }], ['samp', {
    reserved: false
  }], ['script', {
    reserved: true
  }], ['section', {
    reserved: false
  }], ['select', {
    reserved: false
  }], ['small', {
    reserved: false
  }], ['source', {
    reserved: true
  }], ['spacer', {
    reserved: false
  }], ['span', {
    reserved: false
  }], ['strike', {
    reserved: false
  }], ['strong', {
    reserved: false
  }], ['style', {
    reserved: true
  }], ['sub', {
    reserved: false
  }], ['summary', {
    reserved: false
  }], ['sup', {
    reserved: false
  }], ['table', {
    reserved: false
  }], ['tbody', {
    reserved: false
  }], ['td', {
    reserved: false
  }], ['textarea', {
    reserved: false
  }], ['tfoot', {
    reserved: false
  }], ['th', {
    reserved: false
  }], ['thead', {
    reserved: false
  }], ['time', {
    reserved: false
  }], ['title', {
    reserved: true
  }], ['tr', {
    reserved: false
  }], ['track', {
    reserved: true
  }], ['tt', {
    reserved: false
  }], ['u', {
    reserved: false
  }], ['ul', {
    reserved: false
  }], ['var', {
    reserved: false
  }], ['video', {
    reserved: false
  }], ['wbr', {
    reserved: false
  }], ['xmp', {
    reserved: false
  }]];
  var domMap$1 = {
    entries: function entries() {
      return dom;
    },
    forEach: function forEach(fn) {
      var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var _iterator = _createForOfIteratorHelper(dom),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            values = _step$value[1];
          fn.call(thisArg, values, key, dom);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    get: function get(key) {
      var item = dom.find(function (tuple) {
        return tuple[0] === key ? true : false;
      });
      return item && item[1];
    },
    has: function has(key) {
      return !!domMap$1.get(key);
    },
    keys: function keys() {
      return dom.map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          key = _ref2[0];
        return key;
      });
    },
    values: function values() {
      return dom.map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          values = _ref4[1];
        return values;
      });
    }
  };
  var _default = (0, _iterationDecorator.default)(domMap$1, domMap$1.entries());
  domMap.default = _default;
  return domMap;
}

var rolesMap = {};

var ariaAbstractRoles = {};

var commandRole = {};

var hasRequiredCommandRole;
function requireCommandRole() {
  if (hasRequiredCommandRole) return commandRole;
  hasRequiredCommandRole = 1;
  Object.defineProperty(commandRole, "__esModule", {
    value: true
  });
  commandRole.default = void 0;
  var commandRole$1 = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'menuitem'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget']]
  };
  var _default = commandRole$1;
  commandRole.default = _default;
  return commandRole;
}

var compositeRole = {};

var hasRequiredCompositeRole;
function requireCompositeRole() {
  if (hasRequiredCompositeRole) return compositeRole;
  hasRequiredCompositeRole = 1;
  Object.defineProperty(compositeRole, "__esModule", {
    value: true
  });
  compositeRole.default = void 0;
  var compositeRole$1 = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-activedescendant': null,
      'aria-disabled': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget']]
  };
  var _default = compositeRole$1;
  compositeRole.default = _default;
  return compositeRole;
}

var inputRole = {};

var hasRequiredInputRole;
function requireInputRole() {
  if (hasRequiredInputRole) return inputRole;
  hasRequiredInputRole = 1;
  Object.defineProperty(inputRole, "__esModule", {
    value: true
  });
  inputRole.default = void 0;
  var inputRole$1 = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null
    },
    relatedConcepts: [{
      concept: {
        name: 'input'
      },
      module: 'XForms'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget']]
  };
  var _default = inputRole$1;
  inputRole.default = _default;
  return inputRole;
}

var landmarkRole = {};

var hasRequiredLandmarkRole;
function requireLandmarkRole() {
  if (hasRequiredLandmarkRole) return landmarkRole;
  hasRequiredLandmarkRole = 1;
  Object.defineProperty(landmarkRole, "__esModule", {
    value: true
  });
  landmarkRole.default = void 0;
  var landmarkRole$1 = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = landmarkRole$1;
  landmarkRole.default = _default;
  return landmarkRole;
}

var rangeRole = {};

var hasRequiredRangeRole;
function requireRangeRole() {
  if (hasRequiredRangeRole) return rangeRole;
  hasRequiredRangeRole = 1;
  Object.defineProperty(rangeRole, "__esModule", {
    value: true
  });
  rangeRole.default = void 0;
  var rangeRole$1 = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-valuemax': null,
      'aria-valuemin': null,
      'aria-valuenow': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = rangeRole$1;
  rangeRole.default = _default;
  return rangeRole;
}

var roletypeRole = {};

var hasRequiredRoletypeRole;
function requireRoletypeRole() {
  if (hasRequiredRoletypeRole) return roletypeRole;
  hasRequiredRoletypeRole = 1;
  Object.defineProperty(roletypeRole, "__esModule", {
    value: true
  });
  roletypeRole.default = void 0;
  var roletypeRole$1 = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {
      'aria-atomic': null,
      'aria-busy': null,
      'aria-controls': null,
      'aria-current': null,
      'aria-describedby': null,
      'aria-details': null,
      'aria-dropeffect': null,
      'aria-flowto': null,
      'aria-grabbed': null,
      'aria-hidden': null,
      'aria-keyshortcuts': null,
      'aria-label': null,
      'aria-labelledby': null,
      'aria-live': null,
      'aria-owns': null,
      'aria-relevant': null,
      'aria-roledescription': null
    },
    relatedConcepts: [{
      concept: {
        name: 'rel'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'role'
      },
      module: 'XHTML'
    }, {
      concept: {
        name: 'type'
      },
      module: 'Dublin Core'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: []
  };
  var _default = roletypeRole$1;
  roletypeRole.default = _default;
  return roletypeRole;
}

var sectionRole = {};

var hasRequiredSectionRole;
function requireSectionRole() {
  if (hasRequiredSectionRole) return sectionRole;
  hasRequiredSectionRole = 1;
  Object.defineProperty(sectionRole, "__esModule", {
    value: true
  });
  sectionRole.default = void 0;
  var sectionRole$1 = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'frontmatter'
      },
      module: 'DTB'
    }, {
      concept: {
        name: 'level'
      },
      module: 'DTB'
    }, {
      concept: {
        name: 'level'
      },
      module: 'SMIL'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = sectionRole$1;
  sectionRole.default = _default;
  return sectionRole;
}

var sectionheadRole = {};

var hasRequiredSectionheadRole;
function requireSectionheadRole() {
  if (hasRequiredSectionheadRole) return sectionheadRole;
  hasRequiredSectionheadRole = 1;
  Object.defineProperty(sectionheadRole, "__esModule", {
    value: true
  });
  sectionheadRole.default = void 0;
  var sectionheadRole$1 = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = sectionheadRole$1;
  sectionheadRole.default = _default;
  return sectionheadRole;
}

var selectRole = {};

var hasRequiredSelectRole;
function requireSelectRole() {
  if (hasRequiredSelectRole) return selectRole;
  hasRequiredSelectRole = 1;
  Object.defineProperty(selectRole, "__esModule", {
    value: true
  });
  selectRole.default = void 0;
  var selectRole$1 = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-orientation': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite'], ['roletype', 'structure', 'section', 'group']]
  };
  var _default = selectRole$1;
  selectRole.default = _default;
  return selectRole;
}

var structureRole = {};

var hasRequiredStructureRole;
function requireStructureRole() {
  if (hasRequiredStructureRole) return structureRole;
  hasRequiredStructureRole = 1;
  Object.defineProperty(structureRole, "__esModule", {
    value: true
  });
  structureRole.default = void 0;
  var structureRole$1 = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype']]
  };
  var _default = structureRole$1;
  structureRole.default = _default;
  return structureRole;
}

var widgetRole = {};

var hasRequiredWidgetRole;
function requireWidgetRole() {
  if (hasRequiredWidgetRole) return widgetRole;
  hasRequiredWidgetRole = 1;
  Object.defineProperty(widgetRole, "__esModule", {
    value: true
  });
  widgetRole.default = void 0;
  var widgetRole$1 = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype']]
  };
  var _default = widgetRole$1;
  widgetRole.default = _default;
  return widgetRole;
}

var windowRole = {};

var hasRequiredWindowRole;
function requireWindowRole() {
  if (hasRequiredWindowRole) return windowRole;
  hasRequiredWindowRole = 1;
  Object.defineProperty(windowRole, "__esModule", {
    value: true
  });
  windowRole.default = void 0;
  var windowRole$1 = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-modal': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype']]
  };
  var _default = windowRole$1;
  windowRole.default = _default;
  return windowRole;
}

var hasRequiredAriaAbstractRoles;
function requireAriaAbstractRoles() {
  if (hasRequiredAriaAbstractRoles) return ariaAbstractRoles;
  hasRequiredAriaAbstractRoles = 1;
  Object.defineProperty(ariaAbstractRoles, "__esModule", {
    value: true
  });
  ariaAbstractRoles.default = void 0;
  var _commandRole = _interopRequireDefault(requireCommandRole());
  var _compositeRole = _interopRequireDefault(requireCompositeRole());
  var _inputRole = _interopRequireDefault(requireInputRole());
  var _landmarkRole = _interopRequireDefault(requireLandmarkRole());
  var _rangeRole = _interopRequireDefault(requireRangeRole());
  var _roletypeRole = _interopRequireDefault(requireRoletypeRole());
  var _sectionRole = _interopRequireDefault(requireSectionRole());
  var _sectionheadRole = _interopRequireDefault(requireSectionheadRole());
  var _selectRole = _interopRequireDefault(requireSelectRole());
  var _structureRole = _interopRequireDefault(requireStructureRole());
  var _widgetRole = _interopRequireDefault(requireWidgetRole());
  var _windowRole = _interopRequireDefault(requireWindowRole());
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var ariaAbstractRoles$1 = [['command', _commandRole.default], ['composite', _compositeRole.default], ['input', _inputRole.default], ['landmark', _landmarkRole.default], ['range', _rangeRole.default], ['roletype', _roletypeRole.default], ['section', _sectionRole.default], ['sectionhead', _sectionheadRole.default], ['select', _selectRole.default], ['structure', _structureRole.default], ['widget', _widgetRole.default], ['window', _windowRole.default]];
  var _default = ariaAbstractRoles$1;
  ariaAbstractRoles.default = _default;
  return ariaAbstractRoles;
}

var ariaLiteralRoles = {};

var alertRole = {};

var hasRequiredAlertRole;
function requireAlertRole() {
  if (hasRequiredAlertRole) return alertRole;
  hasRequiredAlertRole = 1;
  Object.defineProperty(alertRole, "__esModule", {
    value: true
  });
  alertRole.default = void 0;
  var alertRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-atomic': 'true',
      'aria-live': 'assertive'
    },
    relatedConcepts: [{
      concept: {
        name: 'alert'
      },
      module: 'XForms'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = alertRole$1;
  alertRole.default = _default;
  return alertRole;
}

var alertdialogRole = {};

var hasRequiredAlertdialogRole;
function requireAlertdialogRole() {
  if (hasRequiredAlertdialogRole) return alertdialogRole;
  hasRequiredAlertdialogRole = 1;
  Object.defineProperty(alertdialogRole, "__esModule", {
    value: true
  });
  alertdialogRole.default = void 0;
  var alertdialogRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'alert'
      },
      module: 'XForms'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'alert'], ['roletype', 'window', 'dialog']]
  };
  var _default = alertdialogRole$1;
  alertdialogRole.default = _default;
  return alertdialogRole;
}

var applicationRole = {};

var hasRequiredApplicationRole;
function requireApplicationRole() {
  if (hasRequiredApplicationRole) return applicationRole;
  hasRequiredApplicationRole = 1;
  Object.defineProperty(applicationRole, "__esModule", {
    value: true
  });
  applicationRole.default = void 0;
  var applicationRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-activedescendant': null,
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'Device Independence Delivery Unit'
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = applicationRole$1;
  applicationRole.default = _default;
  return applicationRole;
}

var articleRole = {};

var hasRequiredArticleRole;
function requireArticleRole() {
  if (hasRequiredArticleRole) return articleRole;
  hasRequiredArticleRole = 1;
  Object.defineProperty(articleRole, "__esModule", {
    value: true
  });
  articleRole.default = void 0;
  var articleRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-posinset': null,
      'aria-setsize': null
    },
    relatedConcepts: [{
      concept: {
        name: 'article'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'document']]
  };
  var _default = articleRole$1;
  articleRole.default = _default;
  return articleRole;
}

var bannerRole = {};

var hasRequiredBannerRole;
function requireBannerRole() {
  if (hasRequiredBannerRole) return bannerRole;
  hasRequiredBannerRole = 1;
  Object.defineProperty(bannerRole, "__esModule", {
    value: true
  });
  bannerRole.default = void 0;
  var bannerRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        constraints: ['direct descendant of document'],
        name: 'header'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = bannerRole$1;
  bannerRole.default = _default;
  return bannerRole;
}

var blockquoteRole = {};

var hasRequiredBlockquoteRole;
function requireBlockquoteRole() {
  if (hasRequiredBlockquoteRole) return blockquoteRole;
  hasRequiredBlockquoteRole = 1;
  Object.defineProperty(blockquoteRole, "__esModule", {
    value: true
  });
  blockquoteRole.default = void 0;
  var blockquoteRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = blockquoteRole$1;
  blockquoteRole.default = _default;
  return blockquoteRole;
}

var buttonRole = {};

var hasRequiredButtonRole;
function requireButtonRole() {
  if (hasRequiredButtonRole) return buttonRole;
  hasRequiredButtonRole = 1;
  Object.defineProperty(buttonRole, "__esModule", {
    value: true
  });
  buttonRole.default = void 0;
  var buttonRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-pressed': null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'aria-pressed'
        }, {
          name: 'type',
          value: 'checkbox'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'aria-expanded',
          value: 'false'
        }],
        name: 'summary'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'aria-expanded',
          value: 'true'
        }],
        constraints: ['direct descendant of details element with the open attribute defined'],
        name: 'summary'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'type',
          value: 'button'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'type',
          value: 'image'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'type',
          value: 'reset'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'type',
          value: 'submit'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'button'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'trigger'
      },
      module: 'XForms'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'command']]
  };
  var _default = buttonRole$1;
  buttonRole.default = _default;
  return buttonRole;
}

var captionRole = {};

var hasRequiredCaptionRole;
function requireCaptionRole() {
  if (hasRequiredCaptionRole) return captionRole;
  hasRequiredCaptionRole = 1;
  Object.defineProperty(captionRole, "__esModule", {
    value: true
  });
  captionRole.default = void 0;
  var captionRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: ['figure', 'grid', 'table'],
    requiredContextRole: ['figure', 'grid', 'table'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = captionRole$1;
  captionRole.default = _default;
  return captionRole;
}

var cellRole = {};

var hasRequiredCellRole;
function requireCellRole() {
  if (hasRequiredCellRole) return cellRole;
  hasRequiredCellRole = 1;
  Object.defineProperty(cellRole, "__esModule", {
    value: true
  });
  cellRole.default = void 0;
  var cellRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-colindex': null,
      'aria-colspan': null,
      'aria-rowindex': null,
      'aria-rowspan': null
    },
    relatedConcepts: [{
      concept: {
        constraints: ['descendant of table'],
        name: 'td'
      },
      module: 'HTML'
    }],
    requireContextRole: ['row'],
    requiredContextRole: ['row'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = cellRole$1;
  cellRole.default = _default;
  return cellRole;
}

var checkboxRole = {};

var hasRequiredCheckboxRole;
function requireCheckboxRole() {
  if (hasRequiredCheckboxRole) return checkboxRole;
  hasRequiredCheckboxRole = 1;
  Object.defineProperty(checkboxRole, "__esModule", {
    value: true
  });
  checkboxRole.default = void 0;
  var checkboxRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-checked': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-invalid': null,
      'aria-readonly': null,
      'aria-required': null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: 'type',
          value: 'checkbox'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'option'
      },
      module: 'ARIA'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-checked': null
    },
    superClass: [['roletype', 'widget', 'input']]
  };
  var _default = checkboxRole$1;
  checkboxRole.default = _default;
  return checkboxRole;
}

var codeRole = {};

var hasRequiredCodeRole;
function requireCodeRole() {
  if (hasRequiredCodeRole) return codeRole;
  hasRequiredCodeRole = 1;
  Object.defineProperty(codeRole, "__esModule", {
    value: true
  });
  codeRole.default = void 0;
  var codeRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = codeRole$1;
  codeRole.default = _default;
  return codeRole;
}

var columnheaderRole = {};

var hasRequiredColumnheaderRole;
function requireColumnheaderRole() {
  if (hasRequiredColumnheaderRole) return columnheaderRole;
  hasRequiredColumnheaderRole = 1;
  Object.defineProperty(columnheaderRole, "__esModule", {
    value: true
  });
  columnheaderRole.default = void 0;
  var columnheaderRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-sort': null
    },
    relatedConcepts: [{
      attributes: [{
        name: 'scope',
        value: 'col'
      }],
      concept: {
        name: 'th'
      },
      module: 'HTML'
    }],
    requireContextRole: ['row'],
    requiredContextRole: ['row'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'cell'], ['roletype', 'structure', 'section', 'cell', 'gridcell'], ['roletype', 'widget', 'gridcell'], ['roletype', 'structure', 'sectionhead']]
  };
  var _default = columnheaderRole$1;
  columnheaderRole.default = _default;
  return columnheaderRole;
}

var comboboxRole = {};

var hasRequiredComboboxRole;
function requireComboboxRole() {
  if (hasRequiredComboboxRole) return comboboxRole;
  hasRequiredComboboxRole = 1;
  Object.defineProperty(comboboxRole, "__esModule", {
    value: true
  });
  comboboxRole.default = void 0;
  var comboboxRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-activedescendant': null,
      'aria-autocomplete': null,
      'aria-errormessage': null,
      'aria-invalid': null,
      'aria-readonly': null,
      'aria-required': null,
      'aria-expanded': 'false',
      'aria-haspopup': 'listbox'
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'list'
        }, {
          name: 'type',
          value: 'email'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'list'
        }, {
          name: 'type',
          value: 'search'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'list'
        }, {
          name: 'type',
          value: 'tel'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'list'
        }, {
          name: 'type',
          value: 'text'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'list'
        }, {
          name: 'type',
          value: 'url'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'list'
        }, {
          name: 'type',
          value: 'url'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'multiple'
        }, {
          constraints: ['undefined'],
          name: 'size'
        }],
        name: 'select'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'multiple'
        }, {
          name: 'size',
          value: 1
        }],
        name: 'select'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'select'
      },
      module: 'XForms'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-controls': null,
      'aria-expanded': 'false'
    },
    superClass: [['roletype', 'widget', 'input']]
  };
  var _default = comboboxRole$1;
  comboboxRole.default = _default;
  return comboboxRole;
}

var complementaryRole = {};

var hasRequiredComplementaryRole;
function requireComplementaryRole() {
  if (hasRequiredComplementaryRole) return complementaryRole;
  hasRequiredComplementaryRole = 1;
  Object.defineProperty(complementaryRole, "__esModule", {
    value: true
  });
  complementaryRole.default = void 0;
  var complementaryRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'aside'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = complementaryRole$1;
  complementaryRole.default = _default;
  return complementaryRole;
}

var contentinfoRole = {};

var hasRequiredContentinfoRole;
function requireContentinfoRole() {
  if (hasRequiredContentinfoRole) return contentinfoRole;
  hasRequiredContentinfoRole = 1;
  Object.defineProperty(contentinfoRole, "__esModule", {
    value: true
  });
  contentinfoRole.default = void 0;
  var contentinfoRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        constraints: ['direct descendant of document'],
        name: 'footer'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = contentinfoRole$1;
  contentinfoRole.default = _default;
  return contentinfoRole;
}

var definitionRole = {};

var hasRequiredDefinitionRole;
function requireDefinitionRole() {
  if (hasRequiredDefinitionRole) return definitionRole;
  hasRequiredDefinitionRole = 1;
  Object.defineProperty(definitionRole, "__esModule", {
    value: true
  });
  definitionRole.default = void 0;
  var definitionRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'dd'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = definitionRole$1;
  definitionRole.default = _default;
  return definitionRole;
}

var deletionRole = {};

var hasRequiredDeletionRole;
function requireDeletionRole() {
  if (hasRequiredDeletionRole) return deletionRole;
  hasRequiredDeletionRole = 1;
  Object.defineProperty(deletionRole, "__esModule", {
    value: true
  });
  deletionRole.default = void 0;
  var deletionRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = deletionRole$1;
  deletionRole.default = _default;
  return deletionRole;
}

var dialogRole = {};

var hasRequiredDialogRole;
function requireDialogRole() {
  if (hasRequiredDialogRole) return dialogRole;
  hasRequiredDialogRole = 1;
  Object.defineProperty(dialogRole, "__esModule", {
    value: true
  });
  dialogRole.default = void 0;
  var dialogRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'dialog'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'window']]
  };
  var _default = dialogRole$1;
  dialogRole.default = _default;
  return dialogRole;
}

var directoryRole = {};

var hasRequiredDirectoryRole;
function requireDirectoryRole() {
  if (hasRequiredDirectoryRole) return directoryRole;
  hasRequiredDirectoryRole = 1;
  Object.defineProperty(directoryRole, "__esModule", {
    value: true
  });
  directoryRole.default = void 0;
  var directoryRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      module: 'DAISY Guide'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'list']]
  };
  var _default = directoryRole$1;
  directoryRole.default = _default;
  return directoryRole;
}

var documentRole = {};

var hasRequiredDocumentRole;
function requireDocumentRole() {
  if (hasRequiredDocumentRole) return documentRole;
  hasRequiredDocumentRole = 1;
  Object.defineProperty(documentRole, "__esModule", {
    value: true
  });
  documentRole.default = void 0;
  var documentRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'Device Independence Delivery Unit'
      }
    }, {
      concept: {
        name: 'body'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = documentRole$1;
  documentRole.default = _default;
  return documentRole;
}

var emphasisRole = {};

var hasRequiredEmphasisRole;
function requireEmphasisRole() {
  if (hasRequiredEmphasisRole) return emphasisRole;
  hasRequiredEmphasisRole = 1;
  Object.defineProperty(emphasisRole, "__esModule", {
    value: true
  });
  emphasisRole.default = void 0;
  var emphasisRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = emphasisRole$1;
  emphasisRole.default = _default;
  return emphasisRole;
}

var feedRole = {};

var hasRequiredFeedRole;
function requireFeedRole() {
  if (hasRequiredFeedRole) return feedRole;
  hasRequiredFeedRole = 1;
  Object.defineProperty(feedRole, "__esModule", {
    value: true
  });
  feedRole.default = void 0;
  var feedRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['article']],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'list']]
  };
  var _default = feedRole$1;
  feedRole.default = _default;
  return feedRole;
}

var figureRole = {};

var hasRequiredFigureRole;
function requireFigureRole() {
  if (hasRequiredFigureRole) return figureRole;
  hasRequiredFigureRole = 1;
  Object.defineProperty(figureRole, "__esModule", {
    value: true
  });
  figureRole.default = void 0;
  var figureRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'figure'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = figureRole$1;
  figureRole.default = _default;
  return figureRole;
}

var formRole = {};

var hasRequiredFormRole;
function requireFormRole() {
  if (hasRequiredFormRole) return formRole;
  hasRequiredFormRole = 1;
  Object.defineProperty(formRole, "__esModule", {
    value: true
  });
  formRole.default = void 0;
  var formRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'aria-label'
        }],
        name: 'form'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'aria-labelledby'
        }],
        name: 'form'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'name'
        }],
        name: 'form'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = formRole$1;
  formRole.default = _default;
  return formRole;
}

var genericRole = {};

var hasRequiredGenericRole;
function requireGenericRole() {
  if (hasRequiredGenericRole) return genericRole;
  hasRequiredGenericRole = 1;
  Object.defineProperty(genericRole, "__esModule", {
    value: true
  });
  genericRole.default = void 0;
  var genericRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'span'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'div'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = genericRole$1;
  genericRole.default = _default;
  return genericRole;
}

var gridRole = {};

var hasRequiredGridRole;
function requireGridRole() {
  if (hasRequiredGridRole) return gridRole;
  hasRequiredGridRole = 1;
  Object.defineProperty(gridRole, "__esModule", {
    value: true
  });
  gridRole.default = void 0;
  var gridRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-multiselectable': null,
      'aria-readonly': null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: 'role',
          value: 'grid'
        }],
        name: 'table'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['row'], ['row', 'rowgroup']],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite'], ['roletype', 'structure', 'section', 'table']]
  };
  var _default = gridRole$1;
  gridRole.default = _default;
  return gridRole;
}

var gridcellRole = {};

var hasRequiredGridcellRole;
function requireGridcellRole() {
  if (hasRequiredGridcellRole) return gridcellRole;
  hasRequiredGridcellRole = 1;
  Object.defineProperty(gridcellRole, "__esModule", {
    value: true
  });
  gridcellRole.default = void 0;
  var gridcellRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null,
      'aria-readonly': null,
      'aria-required': null,
      'aria-selected': null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: 'role',
          value: 'gridcell'
        }],
        name: 'td'
      },
      module: 'HTML'
    }],
    requireContextRole: ['row'],
    requiredContextRole: ['row'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'cell'], ['roletype', 'widget']]
  };
  var _default = gridcellRole$1;
  gridcellRole.default = _default;
  return gridcellRole;
}

var groupRole = {};

var hasRequiredGroupRole;
function requireGroupRole() {
  if (hasRequiredGroupRole) return groupRole;
  hasRequiredGroupRole = 1;
  Object.defineProperty(groupRole, "__esModule", {
    value: true
  });
  groupRole.default = void 0;
  var groupRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-activedescendant': null,
      'aria-disabled': null
    },
    relatedConcepts: [{
      concept: {
        name: 'details'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'fieldset'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'optgroup'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = groupRole$1;
  groupRole.default = _default;
  return groupRole;
}

var headingRole = {};

var hasRequiredHeadingRole;
function requireHeadingRole() {
  if (hasRequiredHeadingRole) return headingRole;
  hasRequiredHeadingRole = 1;
  Object.defineProperty(headingRole, "__esModule", {
    value: true
  });
  headingRole.default = void 0;
  var headingRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-level': '2'
    },
    relatedConcepts: [{
      concept: {
        name: 'h1'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'h2'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'h3'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'h4'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'h5'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'h6'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-level': '2'
    },
    superClass: [['roletype', 'structure', 'sectionhead']]
  };
  var _default = headingRole$1;
  headingRole.default = _default;
  return headingRole;
}

var imgRole = {};

var hasRequiredImgRole;
function requireImgRole() {
  if (hasRequiredImgRole) return imgRole;
  hasRequiredImgRole = 1;
  Object.defineProperty(imgRole, "__esModule", {
    value: true
  });
  imgRole.default = void 0;
  var imgRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'alt'
        }],
        name: 'img'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'alt'
        }],
        name: 'img'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'imggroup'
      },
      module: 'DTB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = imgRole$1;
  imgRole.default = _default;
  return imgRole;
}

var insertionRole = {};

var hasRequiredInsertionRole;
function requireInsertionRole() {
  if (hasRequiredInsertionRole) return insertionRole;
  hasRequiredInsertionRole = 1;
  Object.defineProperty(insertionRole, "__esModule", {
    value: true
  });
  insertionRole.default = void 0;
  var insertionRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = insertionRole$1;
  insertionRole.default = _default;
  return insertionRole;
}

var linkRole = {};

var hasRequiredLinkRole;
function requireLinkRole() {
  if (hasRequiredLinkRole) return linkRole;
  hasRequiredLinkRole = 1;
  Object.defineProperty(linkRole, "__esModule", {
    value: true
  });
  linkRole.default = void 0;
  var linkRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-expanded': null,
      'aria-haspopup': null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: 'href'
        }],
        name: 'a'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'href'
        }],
        name: 'area'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'href'
        }],
        name: 'link'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'command']]
  };
  var _default = linkRole$1;
  linkRole.default = _default;
  return linkRole;
}

var listRole = {};

var hasRequiredListRole;
function requireListRole() {
  if (hasRequiredListRole) return listRole;
  hasRequiredListRole = 1;
  Object.defineProperty(listRole, "__esModule", {
    value: true
  });
  listRole.default = void 0;
  var listRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'menu'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'ol'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'ul'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['listitem']],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = listRole$1;
  listRole.default = _default;
  return listRole;
}

var listboxRole = {};

var hasRequiredListboxRole;
function requireListboxRole() {
  if (hasRequiredListboxRole) return listboxRole;
  hasRequiredListboxRole = 1;
  Object.defineProperty(listboxRole, "__esModule", {
    value: true
  });
  listboxRole.default = void 0;
  var listboxRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-invalid': null,
      'aria-multiselectable': null,
      'aria-readonly': null,
      'aria-required': null,
      'aria-orientation': 'vertical'
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ['>1'],
          name: 'size'
        }, {
          name: 'multiple'
        }],
        name: 'select'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['>1'],
          name: 'size'
        }],
        name: 'select'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'multiple'
        }],
        name: 'select'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'datalist'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'list'
      },
      module: 'ARIA'
    }, {
      concept: {
        name: 'select'
      },
      module: 'XForms'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['option', 'group'], ['option']],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
  };
  var _default = listboxRole$1;
  listboxRole.default = _default;
  return listboxRole;
}

var listitemRole = {};

var hasRequiredListitemRole;
function requireListitemRole() {
  if (hasRequiredListitemRole) return listitemRole;
  hasRequiredListitemRole = 1;
  Object.defineProperty(listitemRole, "__esModule", {
    value: true
  });
  listitemRole.default = void 0;
  var listitemRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-level': null,
      'aria-posinset': null,
      'aria-setsize': null
    },
    relatedConcepts: [{
      concept: {
        constraints: ['direct descendant of ol, ul or menu'],
        name: 'li'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'item'
      },
      module: 'XForms'
    }],
    requireContextRole: ['directory', 'list'],
    requiredContextRole: ['directory', 'list'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = listitemRole$1;
  listitemRole.default = _default;
  return listitemRole;
}

var logRole = {};

var hasRequiredLogRole;
function requireLogRole() {
  if (hasRequiredLogRole) return logRole;
  hasRequiredLogRole = 1;
  Object.defineProperty(logRole, "__esModule", {
    value: true
  });
  logRole.default = void 0;
  var logRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-live': 'polite'
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = logRole$1;
  logRole.default = _default;
  return logRole;
}

var mainRole = {};

var hasRequiredMainRole;
function requireMainRole() {
  if (hasRequiredMainRole) return mainRole;
  hasRequiredMainRole = 1;
  Object.defineProperty(mainRole, "__esModule", {
    value: true
  });
  mainRole.default = void 0;
  var mainRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'main'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = mainRole$1;
  mainRole.default = _default;
  return mainRole;
}

var marqueeRole = {};

var hasRequiredMarqueeRole;
function requireMarqueeRole() {
  if (hasRequiredMarqueeRole) return marqueeRole;
  hasRequiredMarqueeRole = 1;
  Object.defineProperty(marqueeRole, "__esModule", {
    value: true
  });
  marqueeRole.default = void 0;
  var marqueeRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = marqueeRole$1;
  marqueeRole.default = _default;
  return marqueeRole;
}

var mathRole = {};

var hasRequiredMathRole;
function requireMathRole() {
  if (hasRequiredMathRole) return mathRole;
  hasRequiredMathRole = 1;
  Object.defineProperty(mathRole, "__esModule", {
    value: true
  });
  mathRole.default = void 0;
  var mathRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'math'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = mathRole$1;
  mathRole.default = _default;
  return mathRole;
}

var menuRole = {};

var hasRequiredMenuRole;
function requireMenuRole() {
  if (hasRequiredMenuRole) return menuRole;
  hasRequiredMenuRole = 1;
  Object.defineProperty(menuRole, "__esModule", {
    value: true
  });
  menuRole.default = void 0;
  var menuRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-orientation': 'vertical'
    },
    relatedConcepts: [{
      concept: {
        name: 'MENU'
      },
      module: 'JAPI'
    }, {
      concept: {
        name: 'list'
      },
      module: 'ARIA'
    }, {
      concept: {
        name: 'select'
      },
      module: 'XForms'
    }, {
      concept: {
        name: 'sidebar'
      },
      module: 'DTB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['menuitem', 'group'], ['menuitemradio', 'group'], ['menuitemcheckbox', 'group'], ['menuitem'], ['menuitemcheckbox'], ['menuitemradio']],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
  };
  var _default = menuRole$1;
  menuRole.default = _default;
  return menuRole;
}

var menubarRole = {};

var hasRequiredMenubarRole;
function requireMenubarRole() {
  if (hasRequiredMenubarRole) return menubarRole;
  hasRequiredMenubarRole = 1;
  Object.defineProperty(menubarRole, "__esModule", {
    value: true
  });
  menubarRole.default = void 0;
  var menubarRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-orientation': 'horizontal'
    },
    relatedConcepts: [{
      concept: {
        name: 'toolbar'
      },
      module: 'ARIA'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['menuitem', 'group'], ['menuitemradio', 'group'], ['menuitemcheckbox', 'group'], ['menuitem'], ['menuitemcheckbox'], ['menuitemradio']],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite', 'select', 'menu'], ['roletype', 'structure', 'section', 'group', 'select', 'menu']]
  };
  var _default = menubarRole$1;
  menubarRole.default = _default;
  return menubarRole;
}

var menuitemRole = {};

var hasRequiredMenuitemRole;
function requireMenuitemRole() {
  if (hasRequiredMenuitemRole) return menuitemRole;
  hasRequiredMenuitemRole = 1;
  Object.defineProperty(menuitemRole, "__esModule", {
    value: true
  });
  menuitemRole.default = void 0;
  var menuitemRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-posinset': null,
      'aria-setsize': null
    },
    relatedConcepts: [{
      concept: {
        name: 'MENU_ITEM'
      },
      module: 'JAPI'
    }, {
      concept: {
        name: 'listitem'
      },
      module: 'ARIA'
    }, {
      concept: {
        name: 'menuitem'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'option'
      },
      module: 'ARIA'
    }],
    requireContextRole: ['group', 'menu', 'menubar'],
    requiredContextRole: ['group', 'menu', 'menubar'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'command']]
  };
  var _default = menuitemRole$1;
  menuitemRole.default = _default;
  return menuitemRole;
}

var menuitemcheckboxRole = {};

var hasRequiredMenuitemcheckboxRole;
function requireMenuitemcheckboxRole() {
  if (hasRequiredMenuitemcheckboxRole) return menuitemcheckboxRole;
  hasRequiredMenuitemcheckboxRole = 1;
  Object.defineProperty(menuitemcheckboxRole, "__esModule", {
    value: true
  });
  menuitemcheckboxRole.default = void 0;
  var menuitemcheckboxRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'menuitem'
      },
      module: 'ARIA'
    }],
    requireContextRole: ['group', 'menu', 'menubar'],
    requiredContextRole: ['group', 'menu', 'menubar'],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-checked': null
    },
    superClass: [['roletype', 'widget', 'input', 'checkbox'], ['roletype', 'widget', 'command', 'menuitem']]
  };
  var _default = menuitemcheckboxRole$1;
  menuitemcheckboxRole.default = _default;
  return menuitemcheckboxRole;
}

var menuitemradioRole = {};

var hasRequiredMenuitemradioRole;
function requireMenuitemradioRole() {
  if (hasRequiredMenuitemradioRole) return menuitemradioRole;
  hasRequiredMenuitemradioRole = 1;
  Object.defineProperty(menuitemradioRole, "__esModule", {
    value: true
  });
  menuitemradioRole.default = void 0;
  var menuitemradioRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'menuitem'
      },
      module: 'ARIA'
    }],
    requireContextRole: ['group', 'menu', 'menubar'],
    requiredContextRole: ['group', 'menu', 'menubar'],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-checked': null
    },
    superClass: [['roletype', 'widget', 'input', 'checkbox', 'menuitemcheckbox'], ['roletype', 'widget', 'command', 'menuitem', 'menuitemcheckbox'], ['roletype', 'widget', 'input', 'radio']]
  };
  var _default = menuitemradioRole$1;
  menuitemradioRole.default = _default;
  return menuitemradioRole;
}

var meterRole = {};

var hasRequiredMeterRole;
function requireMeterRole() {
  if (hasRequiredMeterRole) return meterRole;
  hasRequiredMeterRole = 1;
  Object.defineProperty(meterRole, "__esModule", {
    value: true
  });
  meterRole.default = void 0;
  var meterRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-valuetext': null,
      'aria-valuemax': '100',
      'aria-valuemin': '0'
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-valuenow': null
    },
    superClass: [['roletype', 'structure', 'range']]
  };
  var _default = meterRole$1;
  meterRole.default = _default;
  return meterRole;
}

var navigationRole = {};

var hasRequiredNavigationRole;
function requireNavigationRole() {
  if (hasRequiredNavigationRole) return navigationRole;
  hasRequiredNavigationRole = 1;
  Object.defineProperty(navigationRole, "__esModule", {
    value: true
  });
  navigationRole.default = void 0;
  var navigationRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'nav'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = navigationRole$1;
  navigationRole.default = _default;
  return navigationRole;
}

var noneRole = {};

var hasRequiredNoneRole;
function requireNoneRole() {
  if (hasRequiredNoneRole) return noneRole;
  hasRequiredNoneRole = 1;
  Object.defineProperty(noneRole, "__esModule", {
    value: true
  });
  noneRole.default = void 0;
  var noneRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: []
  };
  var _default = noneRole$1;
  noneRole.default = _default;
  return noneRole;
}

var noteRole = {};

var hasRequiredNoteRole;
function requireNoteRole() {
  if (hasRequiredNoteRole) return noteRole;
  hasRequiredNoteRole = 1;
  Object.defineProperty(noteRole, "__esModule", {
    value: true
  });
  noteRole.default = void 0;
  var noteRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = noteRole$1;
  noteRole.default = _default;
  return noteRole;
}

var optionRole = {};

var hasRequiredOptionRole;
function requireOptionRole() {
  if (hasRequiredOptionRole) return optionRole;
  hasRequiredOptionRole = 1;
  Object.defineProperty(optionRole, "__esModule", {
    value: true
  });
  optionRole.default = void 0;
  var optionRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-checked': null,
      'aria-posinset': null,
      'aria-setsize': null,
      'aria-selected': 'false'
    },
    relatedConcepts: [{
      concept: {
        name: 'item'
      },
      module: 'XForms'
    }, {
      concept: {
        name: 'listitem'
      },
      module: 'ARIA'
    }, {
      concept: {
        name: 'option'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-selected': 'false'
    },
    superClass: [['roletype', 'widget', 'input']]
  };
  var _default = optionRole$1;
  optionRole.default = _default;
  return optionRole;
}

var paragraphRole = {};

var hasRequiredParagraphRole;
function requireParagraphRole() {
  if (hasRequiredParagraphRole) return paragraphRole;
  hasRequiredParagraphRole = 1;
  Object.defineProperty(paragraphRole, "__esModule", {
    value: true
  });
  paragraphRole.default = void 0;
  var paragraphRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = paragraphRole$1;
  paragraphRole.default = _default;
  return paragraphRole;
}

var presentationRole = {};

var hasRequiredPresentationRole;
function requirePresentationRole() {
  if (hasRequiredPresentationRole) return presentationRole;
  hasRequiredPresentationRole = 1;
  Object.defineProperty(presentationRole, "__esModule", {
    value: true
  });
  presentationRole.default = void 0;
  var presentationRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = presentationRole$1;
  presentationRole.default = _default;
  return presentationRole;
}

var progressbarRole = {};

var hasRequiredProgressbarRole;
function requireProgressbarRole() {
  if (hasRequiredProgressbarRole) return progressbarRole;
  hasRequiredProgressbarRole = 1;
  Object.defineProperty(progressbarRole, "__esModule", {
    value: true
  });
  progressbarRole.default = void 0;
  var progressbarRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-valuetext': null
    },
    relatedConcepts: [{
      concept: {
        name: 'progress'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'status'
      },
      module: 'ARIA'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'range'], ['roletype', 'widget']]
  };
  var _default = progressbarRole$1;
  progressbarRole.default = _default;
  return progressbarRole;
}

var radioRole = {};

var hasRequiredRadioRole;
function requireRadioRole() {
  if (hasRequiredRadioRole) return radioRole;
  hasRequiredRadioRole = 1;
  Object.defineProperty(radioRole, "__esModule", {
    value: true
  });
  radioRole.default = void 0;
  var radioRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-checked': null,
      'aria-posinset': null,
      'aria-setsize': null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: 'type',
          value: 'radio'
        }],
        name: 'input'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-checked': null
    },
    superClass: [['roletype', 'widget', 'input']]
  };
  var _default = radioRole$1;
  radioRole.default = _default;
  return radioRole;
}

var radiogroupRole = {};

var hasRequiredRadiogroupRole;
function requireRadiogroupRole() {
  if (hasRequiredRadiogroupRole) return radiogroupRole;
  hasRequiredRadiogroupRole = 1;
  Object.defineProperty(radiogroupRole, "__esModule", {
    value: true
  });
  radiogroupRole.default = void 0;
  var radiogroupRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-invalid': null,
      'aria-readonly': null,
      'aria-required': null
    },
    relatedConcepts: [{
      concept: {
        name: 'list'
      },
      module: 'ARIA'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['radio']],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
  };
  var _default = radiogroupRole$1;
  radiogroupRole.default = _default;
  return radiogroupRole;
}

var regionRole = {};

var hasRequiredRegionRole;
function requireRegionRole() {
  if (hasRequiredRegionRole) return regionRole;
  hasRequiredRegionRole = 1;
  Object.defineProperty(regionRole, "__esModule", {
    value: true
  });
  regionRole.default = void 0;
  var regionRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'aria-label'
        }],
        name: 'section'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'aria-labelledby'
        }],
        name: 'section'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'Device Independence Glossart perceivable unit'
      }
    }, {
      concept: {
        name: 'frame'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = regionRole$1;
  regionRole.default = _default;
  return regionRole;
}

var rowRole = {};

var hasRequiredRowRole;
function requireRowRole() {
  if (hasRequiredRowRole) return rowRole;
  hasRequiredRowRole = 1;
  Object.defineProperty(rowRole, "__esModule", {
    value: true
  });
  rowRole.default = void 0;
  var rowRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-colindex': null,
      'aria-expanded': null,
      'aria-level': null,
      'aria-posinset': null,
      'aria-rowindex': null,
      'aria-selected': null,
      'aria-setsize': null
    },
    relatedConcepts: [{
      concept: {
        name: 'tr'
      },
      module: 'HTML'
    }],
    requireContextRole: ['grid', 'rowgroup', 'table', 'treegrid'],
    requiredContextRole: ['grid', 'rowgroup', 'table', 'treegrid'],
    requiredOwnedElements: [['cell'], ['columnheader'], ['gridcell'], ['rowheader']],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'group'], ['roletype', 'widget']]
  };
  var _default = rowRole$1;
  rowRole.default = _default;
  return rowRole;
}

var rowgroupRole = {};

var hasRequiredRowgroupRole;
function requireRowgroupRole() {
  if (hasRequiredRowgroupRole) return rowgroupRole;
  hasRequiredRowgroupRole = 1;
  Object.defineProperty(rowgroupRole, "__esModule", {
    value: true
  });
  rowgroupRole.default = void 0;
  var rowgroupRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'tbody'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'tfoot'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'thead'
      },
      module: 'HTML'
    }],
    requireContextRole: ['grid', 'table', 'treegrid'],
    requiredContextRole: ['grid', 'table', 'treegrid'],
    requiredOwnedElements: [['row']],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = rowgroupRole$1;
  rowgroupRole.default = _default;
  return rowgroupRole;
}

var rowheaderRole = {};

var hasRequiredRowheaderRole;
function requireRowheaderRole() {
  if (hasRequiredRowheaderRole) return rowheaderRole;
  hasRequiredRowheaderRole = 1;
  Object.defineProperty(rowheaderRole, "__esModule", {
    value: true
  });
  rowheaderRole.default = void 0;
  var rowheaderRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-sort': null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: 'scope',
          value: 'row'
        }],
        name: 'th'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'scope',
          value: 'rowgroup'
        }],
        name: 'th'
      },
      module: 'HTML'
    }],
    requireContextRole: ['row', 'rowgroup'],
    requiredContextRole: ['row', 'rowgroup'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'cell'], ['roletype', 'structure', 'section', 'cell', 'gridcell'], ['roletype', 'widget', 'gridcell'], ['roletype', 'structure', 'sectionhead']]
  };
  var _default = rowheaderRole$1;
  rowheaderRole.default = _default;
  return rowheaderRole;
}

var scrollbarRole = {};

var hasRequiredScrollbarRole;
function requireScrollbarRole() {
  if (hasRequiredScrollbarRole) return scrollbarRole;
  hasRequiredScrollbarRole = 1;
  Object.defineProperty(scrollbarRole, "__esModule", {
    value: true
  });
  scrollbarRole.default = void 0;
  var scrollbarRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-valuetext': null,
      'aria-orientation': 'vertical',
      'aria-valuemax': '100',
      'aria-valuemin': '0'
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-controls': null,
      'aria-valuenow': null
    },
    superClass: [['roletype', 'structure', 'range'], ['roletype', 'widget']]
  };
  var _default = scrollbarRole$1;
  scrollbarRole.default = _default;
  return scrollbarRole;
}

var searchRole = {};

var hasRequiredSearchRole;
function requireSearchRole() {
  if (hasRequiredSearchRole) return searchRole;
  hasRequiredSearchRole = 1;
  Object.defineProperty(searchRole, "__esModule", {
    value: true
  });
  searchRole.default = void 0;
  var searchRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = searchRole$1;
  searchRole.default = _default;
  return searchRole;
}

var searchboxRole = {};

var hasRequiredSearchboxRole;
function requireSearchboxRole() {
  if (hasRequiredSearchboxRole) return searchboxRole;
  hasRequiredSearchboxRole = 1;
  Object.defineProperty(searchboxRole, "__esModule", {
    value: true
  });
  searchboxRole.default = void 0;
  var searchboxRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'list'
        }, {
          name: 'type',
          value: 'search'
        }],
        name: 'input'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'input', 'textbox']]
  };
  var _default = searchboxRole$1;
  searchboxRole.default = _default;
  return searchboxRole;
}

var separatorRole = {};

var hasRequiredSeparatorRole;
function requireSeparatorRole() {
  if (hasRequiredSeparatorRole) return separatorRole;
  hasRequiredSeparatorRole = 1;
  Object.defineProperty(separatorRole, "__esModule", {
    value: true
  });
  separatorRole.default = void 0;
  var separatorRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-orientation': 'horizontal',
      'aria-valuemax': '100',
      'aria-valuemin': '0',
      'aria-valuenow': null,
      'aria-valuetext': null
    },
    relatedConcepts: [{
      concept: {
        name: 'hr'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = separatorRole$1;
  separatorRole.default = _default;
  return separatorRole;
}

var sliderRole = {};

var hasRequiredSliderRole;
function requireSliderRole() {
  if (hasRequiredSliderRole) return sliderRole;
  hasRequiredSliderRole = 1;
  Object.defineProperty(sliderRole, "__esModule", {
    value: true
  });
  sliderRole.default = void 0;
  var sliderRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-haspopup': null,
      'aria-invalid': null,
      'aria-readonly': null,
      'aria-valuetext': null,
      'aria-orientation': 'horizontal',
      'aria-valuemax': '100',
      'aria-valuemin': '0'
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: 'type',
          value: 'range'
        }],
        name: 'input'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-valuenow': null
    },
    superClass: [['roletype', 'widget', 'input'], ['roletype', 'structure', 'range']]
  };
  var _default = sliderRole$1;
  sliderRole.default = _default;
  return sliderRole;
}

var spinbuttonRole = {};

var hasRequiredSpinbuttonRole;
function requireSpinbuttonRole() {
  if (hasRequiredSpinbuttonRole) return spinbuttonRole;
  hasRequiredSpinbuttonRole = 1;
  Object.defineProperty(spinbuttonRole, "__esModule", {
    value: true
  });
  spinbuttonRole.default = void 0;
  var spinbuttonRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-invalid': null,
      'aria-readonly': null,
      'aria-required': null,
      'aria-valuetext': null,
      'aria-valuenow': '0'
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: 'type',
          value: 'number'
        }],
        name: 'input'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite'], ['roletype', 'widget', 'input'], ['roletype', 'structure', 'range']]
  };
  var _default = spinbuttonRole$1;
  spinbuttonRole.default = _default;
  return spinbuttonRole;
}

var statusRole = {};

var hasRequiredStatusRole;
function requireStatusRole() {
  if (hasRequiredStatusRole) return statusRole;
  hasRequiredStatusRole = 1;
  Object.defineProperty(statusRole, "__esModule", {
    value: true
  });
  statusRole.default = void 0;
  var statusRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-atomic': 'true',
      'aria-live': 'polite'
    },
    relatedConcepts: [{
      concept: {
        name: 'output'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = statusRole$1;
  statusRole.default = _default;
  return statusRole;
}

var strongRole = {};

var hasRequiredStrongRole;
function requireStrongRole() {
  if (hasRequiredStrongRole) return strongRole;
  hasRequiredStrongRole = 1;
  Object.defineProperty(strongRole, "__esModule", {
    value: true
  });
  strongRole.default = void 0;
  var strongRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = strongRole$1;
  strongRole.default = _default;
  return strongRole;
}

var subscriptRole = {};

var hasRequiredSubscriptRole;
function requireSubscriptRole() {
  if (hasRequiredSubscriptRole) return subscriptRole;
  hasRequiredSubscriptRole = 1;
  Object.defineProperty(subscriptRole, "__esModule", {
    value: true
  });
  subscriptRole.default = void 0;
  var subscriptRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = subscriptRole$1;
  subscriptRole.default = _default;
  return subscriptRole;
}

var superscriptRole = {};

var hasRequiredSuperscriptRole;
function requireSuperscriptRole() {
  if (hasRequiredSuperscriptRole) return superscriptRole;
  hasRequiredSuperscriptRole = 1;
  Object.defineProperty(superscriptRole, "__esModule", {
    value: true
  });
  superscriptRole.default = void 0;
  var superscriptRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = superscriptRole$1;
  superscriptRole.default = _default;
  return superscriptRole;
}

var switchRole = {};

var hasRequiredSwitchRole;
function requireSwitchRole() {
  if (hasRequiredSwitchRole) return switchRole;
  hasRequiredSwitchRole = 1;
  Object.defineProperty(switchRole, "__esModule", {
    value: true
  });
  switchRole.default = void 0;
  var switchRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'button'
      },
      module: 'ARIA'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-checked': null
    },
    superClass: [['roletype', 'widget', 'input', 'checkbox']]
  };
  var _default = switchRole$1;
  switchRole.default = _default;
  return switchRole;
}

var tabRole = {};

var hasRequiredTabRole;
function requireTabRole() {
  if (hasRequiredTabRole) return tabRole;
  hasRequiredTabRole = 1;
  Object.defineProperty(tabRole, "__esModule", {
    value: true
  });
  tabRole.default = void 0;
  var tabRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-posinset': null,
      'aria-setsize': null,
      'aria-selected': 'false'
    },
    relatedConcepts: [],
    requireContextRole: ['tablist'],
    requiredContextRole: ['tablist'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'sectionhead'], ['roletype', 'widget']]
  };
  var _default = tabRole$1;
  tabRole.default = _default;
  return tabRole;
}

var tableRole = {};

var hasRequiredTableRole;
function requireTableRole() {
  if (hasRequiredTableRole) return tableRole;
  hasRequiredTableRole = 1;
  Object.defineProperty(tableRole, "__esModule", {
    value: true
  });
  tableRole.default = void 0;
  var tableRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-colcount': null,
      'aria-rowcount': null
    },
    relatedConcepts: [{
      concept: {
        name: 'table'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['row'], ['row', 'rowgroup']],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = tableRole$1;
  tableRole.default = _default;
  return tableRole;
}

var tablistRole = {};

var hasRequiredTablistRole;
function requireTablistRole() {
  if (hasRequiredTablistRole) return tablistRole;
  hasRequiredTablistRole = 1;
  Object.defineProperty(tablistRole, "__esModule", {
    value: true
  });
  tablistRole.default = void 0;
  var tablistRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-level': null,
      'aria-multiselectable': null,
      'aria-orientation': 'horizontal'
    },
    relatedConcepts: [{
      module: 'DAISY',
      concept: {
        name: 'guide'
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['tab']],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite']]
  };
  var _default = tablistRole$1;
  tablistRole.default = _default;
  return tablistRole;
}

var tabpanelRole = {};

var hasRequiredTabpanelRole;
function requireTabpanelRole() {
  if (hasRequiredTabpanelRole) return tabpanelRole;
  hasRequiredTabpanelRole = 1;
  Object.defineProperty(tabpanelRole, "__esModule", {
    value: true
  });
  tabpanelRole.default = void 0;
  var tabpanelRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = tabpanelRole$1;
  tabpanelRole.default = _default;
  return tabpanelRole;
}

var termRole = {};

var hasRequiredTermRole;
function requireTermRole() {
  if (hasRequiredTermRole) return termRole;
  hasRequiredTermRole = 1;
  Object.defineProperty(termRole, "__esModule", {
    value: true
  });
  termRole.default = void 0;
  var termRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'dfn'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'dt'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = termRole$1;
  termRole.default = _default;
  return termRole;
}

var textboxRole = {};

var hasRequiredTextboxRole;
function requireTextboxRole() {
  if (hasRequiredTextboxRole) return textboxRole;
  hasRequiredTextboxRole = 1;
  Object.defineProperty(textboxRole, "__esModule", {
    value: true
  });
  textboxRole.default = void 0;
  var textboxRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-activedescendant': null,
      'aria-autocomplete': null,
      'aria-errormessage': null,
      'aria-haspopup': null,
      'aria-invalid': null,
      'aria-multiline': null,
      'aria-placeholder': null,
      'aria-readonly': null,
      'aria-required': null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'type'
        }, {
          constraints: ['undefined'],
          name: 'list'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'list'
        }, {
          name: 'type',
          value: 'email'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'list'
        }, {
          name: 'type',
          value: 'tel'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'list'
        }, {
          name: 'type',
          value: 'text'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'list'
        }, {
          name: 'type',
          value: 'url'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'input'
      },
      module: 'XForms'
    }, {
      concept: {
        name: 'textarea'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'input']]
  };
  var _default = textboxRole$1;
  textboxRole.default = _default;
  return textboxRole;
}

var timeRole = {};

var hasRequiredTimeRole;
function requireTimeRole() {
  if (hasRequiredTimeRole) return timeRole;
  hasRequiredTimeRole = 1;
  Object.defineProperty(timeRole, "__esModule", {
    value: true
  });
  timeRole.default = void 0;
  var timeRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = timeRole$1;
  timeRole.default = _default;
  return timeRole;
}

var timerRole = {};

var hasRequiredTimerRole;
function requireTimerRole() {
  if (hasRequiredTimerRole) return timerRole;
  hasRequiredTimerRole = 1;
  Object.defineProperty(timerRole, "__esModule", {
    value: true
  });
  timerRole.default = void 0;
  var timerRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'status']]
  };
  var _default = timerRole$1;
  timerRole.default = _default;
  return timerRole;
}

var toolbarRole = {};

var hasRequiredToolbarRole;
function requireToolbarRole() {
  if (hasRequiredToolbarRole) return toolbarRole;
  hasRequiredToolbarRole = 1;
  Object.defineProperty(toolbarRole, "__esModule", {
    value: true
  });
  toolbarRole.default = void 0;
  var toolbarRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-orientation': 'horizontal'
    },
    relatedConcepts: [{
      concept: {
        name: 'menubar'
      },
      module: 'ARIA'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'group']]
  };
  var _default = toolbarRole$1;
  toolbarRole.default = _default;
  return toolbarRole;
}

var tooltipRole = {};

var hasRequiredTooltipRole;
function requireTooltipRole() {
  if (hasRequiredTooltipRole) return tooltipRole;
  hasRequiredTooltipRole = 1;
  Object.defineProperty(tooltipRole, "__esModule", {
    value: true
  });
  tooltipRole.default = void 0;
  var tooltipRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = tooltipRole$1;
  tooltipRole.default = _default;
  return tooltipRole;
}

var treeRole = {};

var hasRequiredTreeRole;
function requireTreeRole() {
  if (hasRequiredTreeRole) return treeRole;
  hasRequiredTreeRole = 1;
  Object.defineProperty(treeRole, "__esModule", {
    value: true
  });
  treeRole.default = void 0;
  var treeRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-invalid': null,
      'aria-multiselectable': null,
      'aria-required': null,
      'aria-orientation': 'vertical'
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['treeitem', 'group'], ['treeitem']],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
  };
  var _default = treeRole$1;
  treeRole.default = _default;
  return treeRole;
}

var treegridRole = {};

var hasRequiredTreegridRole;
function requireTreegridRole() {
  if (hasRequiredTreegridRole) return treegridRole;
  hasRequiredTreegridRole = 1;
  Object.defineProperty(treegridRole, "__esModule", {
    value: true
  });
  treegridRole.default = void 0;
  var treegridRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['row'], ['row', 'rowgroup']],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite', 'grid'], ['roletype', 'structure', 'section', 'table', 'grid'], ['roletype', 'widget', 'composite', 'select', 'tree'], ['roletype', 'structure', 'section', 'group', 'select', 'tree']]
  };
  var _default = treegridRole$1;
  treegridRole.default = _default;
  return treegridRole;
}

var treeitemRole = {};

var hasRequiredTreeitemRole;
function requireTreeitemRole() {
  if (hasRequiredTreeitemRole) return treeitemRole;
  hasRequiredTreeitemRole = 1;
  Object.defineProperty(treeitemRole, "__esModule", {
    value: true
  });
  treeitemRole.default = void 0;
  var treeitemRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-expanded': null,
      'aria-haspopup': null
    },
    relatedConcepts: [],
    requireContextRole: ['group', 'tree'],
    requiredContextRole: ['group', 'tree'],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-selected': null
    },
    superClass: [['roletype', 'structure', 'section', 'listitem'], ['roletype', 'widget', 'input', 'option']]
  };
  var _default = treeitemRole$1;
  treeitemRole.default = _default;
  return treeitemRole;
}

var hasRequiredAriaLiteralRoles;
function requireAriaLiteralRoles() {
  if (hasRequiredAriaLiteralRoles) return ariaLiteralRoles;
  hasRequiredAriaLiteralRoles = 1;
  Object.defineProperty(ariaLiteralRoles, "__esModule", {
    value: true
  });
  ariaLiteralRoles.default = void 0;
  var _alertRole = _interopRequireDefault(requireAlertRole());
  var _alertdialogRole = _interopRequireDefault(requireAlertdialogRole());
  var _applicationRole = _interopRequireDefault(requireApplicationRole());
  var _articleRole = _interopRequireDefault(requireArticleRole());
  var _bannerRole = _interopRequireDefault(requireBannerRole());
  var _blockquoteRole = _interopRequireDefault(requireBlockquoteRole());
  var _buttonRole = _interopRequireDefault(requireButtonRole());
  var _captionRole = _interopRequireDefault(requireCaptionRole());
  var _cellRole = _interopRequireDefault(requireCellRole());
  var _checkboxRole = _interopRequireDefault(requireCheckboxRole());
  var _codeRole = _interopRequireDefault(requireCodeRole());
  var _columnheaderRole = _interopRequireDefault(requireColumnheaderRole());
  var _comboboxRole = _interopRequireDefault(requireComboboxRole());
  var _complementaryRole = _interopRequireDefault(requireComplementaryRole());
  var _contentinfoRole = _interopRequireDefault(requireContentinfoRole());
  var _definitionRole = _interopRequireDefault(requireDefinitionRole());
  var _deletionRole = _interopRequireDefault(requireDeletionRole());
  var _dialogRole = _interopRequireDefault(requireDialogRole());
  var _directoryRole = _interopRequireDefault(requireDirectoryRole());
  var _documentRole = _interopRequireDefault(requireDocumentRole());
  var _emphasisRole = _interopRequireDefault(requireEmphasisRole());
  var _feedRole = _interopRequireDefault(requireFeedRole());
  var _figureRole = _interopRequireDefault(requireFigureRole());
  var _formRole = _interopRequireDefault(requireFormRole());
  var _genericRole = _interopRequireDefault(requireGenericRole());
  var _gridRole = _interopRequireDefault(requireGridRole());
  var _gridcellRole = _interopRequireDefault(requireGridcellRole());
  var _groupRole = _interopRequireDefault(requireGroupRole());
  var _headingRole = _interopRequireDefault(requireHeadingRole());
  var _imgRole = _interopRequireDefault(requireImgRole());
  var _insertionRole = _interopRequireDefault(requireInsertionRole());
  var _linkRole = _interopRequireDefault(requireLinkRole());
  var _listRole = _interopRequireDefault(requireListRole());
  var _listboxRole = _interopRequireDefault(requireListboxRole());
  var _listitemRole = _interopRequireDefault(requireListitemRole());
  var _logRole = _interopRequireDefault(requireLogRole());
  var _mainRole = _interopRequireDefault(requireMainRole());
  var _marqueeRole = _interopRequireDefault(requireMarqueeRole());
  var _mathRole = _interopRequireDefault(requireMathRole());
  var _menuRole = _interopRequireDefault(requireMenuRole());
  var _menubarRole = _interopRequireDefault(requireMenubarRole());
  var _menuitemRole = _interopRequireDefault(requireMenuitemRole());
  var _menuitemcheckboxRole = _interopRequireDefault(requireMenuitemcheckboxRole());
  var _menuitemradioRole = _interopRequireDefault(requireMenuitemradioRole());
  var _meterRole = _interopRequireDefault(requireMeterRole());
  var _navigationRole = _interopRequireDefault(requireNavigationRole());
  var _noneRole = _interopRequireDefault(requireNoneRole());
  var _noteRole = _interopRequireDefault(requireNoteRole());
  var _optionRole = _interopRequireDefault(requireOptionRole());
  var _paragraphRole = _interopRequireDefault(requireParagraphRole());
  var _presentationRole = _interopRequireDefault(requirePresentationRole());
  var _progressbarRole = _interopRequireDefault(requireProgressbarRole());
  var _radioRole = _interopRequireDefault(requireRadioRole());
  var _radiogroupRole = _interopRequireDefault(requireRadiogroupRole());
  var _regionRole = _interopRequireDefault(requireRegionRole());
  var _rowRole = _interopRequireDefault(requireRowRole());
  var _rowgroupRole = _interopRequireDefault(requireRowgroupRole());
  var _rowheaderRole = _interopRequireDefault(requireRowheaderRole());
  var _scrollbarRole = _interopRequireDefault(requireScrollbarRole());
  var _searchRole = _interopRequireDefault(requireSearchRole());
  var _searchboxRole = _interopRequireDefault(requireSearchboxRole());
  var _separatorRole = _interopRequireDefault(requireSeparatorRole());
  var _sliderRole = _interopRequireDefault(requireSliderRole());
  var _spinbuttonRole = _interopRequireDefault(requireSpinbuttonRole());
  var _statusRole = _interopRequireDefault(requireStatusRole());
  var _strongRole = _interopRequireDefault(requireStrongRole());
  var _subscriptRole = _interopRequireDefault(requireSubscriptRole());
  var _superscriptRole = _interopRequireDefault(requireSuperscriptRole());
  var _switchRole = _interopRequireDefault(requireSwitchRole());
  var _tabRole = _interopRequireDefault(requireTabRole());
  var _tableRole = _interopRequireDefault(requireTableRole());
  var _tablistRole = _interopRequireDefault(requireTablistRole());
  var _tabpanelRole = _interopRequireDefault(requireTabpanelRole());
  var _termRole = _interopRequireDefault(requireTermRole());
  var _textboxRole = _interopRequireDefault(requireTextboxRole());
  var _timeRole = _interopRequireDefault(requireTimeRole());
  var _timerRole = _interopRequireDefault(requireTimerRole());
  var _toolbarRole = _interopRequireDefault(requireToolbarRole());
  var _tooltipRole = _interopRequireDefault(requireTooltipRole());
  var _treeRole = _interopRequireDefault(requireTreeRole());
  var _treegridRole = _interopRequireDefault(requireTreegridRole());
  var _treeitemRole = _interopRequireDefault(requireTreeitemRole());
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var ariaLiteralRoles$1 = [['alert', _alertRole.default], ['alertdialog', _alertdialogRole.default], ['application', _applicationRole.default], ['article', _articleRole.default], ['banner', _bannerRole.default], ['blockquote', _blockquoteRole.default], ['button', _buttonRole.default], ['caption', _captionRole.default], ['cell', _cellRole.default], ['checkbox', _checkboxRole.default], ['code', _codeRole.default], ['columnheader', _columnheaderRole.default], ['combobox', _comboboxRole.default], ['complementary', _complementaryRole.default], ['contentinfo', _contentinfoRole.default], ['definition', _definitionRole.default], ['deletion', _deletionRole.default], ['dialog', _dialogRole.default], ['directory', _directoryRole.default], ['document', _documentRole.default], ['emphasis', _emphasisRole.default], ['feed', _feedRole.default], ['figure', _figureRole.default], ['form', _formRole.default], ['generic', _genericRole.default], ['grid', _gridRole.default], ['gridcell', _gridcellRole.default], ['group', _groupRole.default], ['heading', _headingRole.default], ['img', _imgRole.default], ['insertion', _insertionRole.default], ['link', _linkRole.default], ['list', _listRole.default], ['listbox', _listboxRole.default], ['listitem', _listitemRole.default], ['log', _logRole.default], ['main', _mainRole.default], ['marquee', _marqueeRole.default], ['math', _mathRole.default], ['menu', _menuRole.default], ['menubar', _menubarRole.default], ['menuitem', _menuitemRole.default], ['menuitemcheckbox', _menuitemcheckboxRole.default], ['menuitemradio', _menuitemradioRole.default], ['meter', _meterRole.default], ['navigation', _navigationRole.default], ['none', _noneRole.default], ['note', _noteRole.default], ['option', _optionRole.default], ['paragraph', _paragraphRole.default], ['presentation', _presentationRole.default], ['progressbar', _progressbarRole.default], ['radio', _radioRole.default], ['radiogroup', _radiogroupRole.default], ['region', _regionRole.default], ['row', _rowRole.default], ['rowgroup', _rowgroupRole.default], ['rowheader', _rowheaderRole.default], ['scrollbar', _scrollbarRole.default], ['search', _searchRole.default], ['searchbox', _searchboxRole.default], ['separator', _separatorRole.default], ['slider', _sliderRole.default], ['spinbutton', _spinbuttonRole.default], ['status', _statusRole.default], ['strong', _strongRole.default], ['subscript', _subscriptRole.default], ['superscript', _superscriptRole.default], ['switch', _switchRole.default], ['tab', _tabRole.default], ['table', _tableRole.default], ['tablist', _tablistRole.default], ['tabpanel', _tabpanelRole.default], ['term', _termRole.default], ['textbox', _textboxRole.default], ['time', _timeRole.default], ['timer', _timerRole.default], ['toolbar', _toolbarRole.default], ['tooltip', _tooltipRole.default], ['tree', _treeRole.default], ['treegrid', _treegridRole.default], ['treeitem', _treeitemRole.default]];
  var _default = ariaLiteralRoles$1;
  ariaLiteralRoles.default = _default;
  return ariaLiteralRoles;
}

var ariaDpubRoles = {};

var docAbstractRole = {};

var hasRequiredDocAbstractRole;
function requireDocAbstractRole() {
  if (hasRequiredDocAbstractRole) return docAbstractRole;
  hasRequiredDocAbstractRole = 1;
  Object.defineProperty(docAbstractRole, "__esModule", {
    value: true
  });
  docAbstractRole.default = void 0;
  var docAbstractRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'abstract [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = docAbstractRole$1;
  docAbstractRole.default = _default;
  return docAbstractRole;
}

var docAcknowledgmentsRole = {};

var hasRequiredDocAcknowledgmentsRole;
function requireDocAcknowledgmentsRole() {
  if (hasRequiredDocAcknowledgmentsRole) return docAcknowledgmentsRole;
  hasRequiredDocAcknowledgmentsRole = 1;
  Object.defineProperty(docAcknowledgmentsRole, "__esModule", {
    value: true
  });
  docAcknowledgmentsRole.default = void 0;
  var docAcknowledgmentsRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'acknowledgments [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docAcknowledgmentsRole$1;
  docAcknowledgmentsRole.default = _default;
  return docAcknowledgmentsRole;
}

var docAfterwordRole = {};

var hasRequiredDocAfterwordRole;
function requireDocAfterwordRole() {
  if (hasRequiredDocAfterwordRole) return docAfterwordRole;
  hasRequiredDocAfterwordRole = 1;
  Object.defineProperty(docAfterwordRole, "__esModule", {
    value: true
  });
  docAfterwordRole.default = void 0;
  var docAfterwordRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'afterword [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docAfterwordRole$1;
  docAfterwordRole.default = _default;
  return docAfterwordRole;
}

var docAppendixRole = {};

var hasRequiredDocAppendixRole;
function requireDocAppendixRole() {
  if (hasRequiredDocAppendixRole) return docAppendixRole;
  hasRequiredDocAppendixRole = 1;
  Object.defineProperty(docAppendixRole, "__esModule", {
    value: true
  });
  docAppendixRole.default = void 0;
  var docAppendixRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'appendix [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docAppendixRole$1;
  docAppendixRole.default = _default;
  return docAppendixRole;
}

var docBacklinkRole = {};

var hasRequiredDocBacklinkRole;
function requireDocBacklinkRole() {
  if (hasRequiredDocBacklinkRole) return docBacklinkRole;
  hasRequiredDocBacklinkRole = 1;
  Object.defineProperty(docBacklinkRole, "__esModule", {
    value: true
  });
  docBacklinkRole.default = void 0;
  var docBacklinkRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'content'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'referrer [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'command', 'link']]
  };
  var _default = docBacklinkRole$1;
  docBacklinkRole.default = _default;
  return docBacklinkRole;
}

var docBiblioentryRole = {};

var hasRequiredDocBiblioentryRole;
function requireDocBiblioentryRole() {
  if (hasRequiredDocBiblioentryRole) return docBiblioentryRole;
  hasRequiredDocBiblioentryRole = 1;
  Object.defineProperty(docBiblioentryRole, "__esModule", {
    value: true
  });
  docBiblioentryRole.default = void 0;
  var docBiblioentryRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'EPUB biblioentry [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: ['doc-bibliography'],
    requiredContextRole: ['doc-bibliography'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'listitem']]
  };
  var _default = docBiblioentryRole$1;
  docBiblioentryRole.default = _default;
  return docBiblioentryRole;
}

var docBibliographyRole = {};

var hasRequiredDocBibliographyRole;
function requireDocBibliographyRole() {
  if (hasRequiredDocBibliographyRole) return docBibliographyRole;
  hasRequiredDocBibliographyRole = 1;
  Object.defineProperty(docBibliographyRole, "__esModule", {
    value: true
  });
  docBibliographyRole.default = void 0;
  var docBibliographyRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'bibliography [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['doc-biblioentry']],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docBibliographyRole$1;
  docBibliographyRole.default = _default;
  return docBibliographyRole;
}

var docBibliorefRole = {};

var hasRequiredDocBibliorefRole;
function requireDocBibliorefRole() {
  if (hasRequiredDocBibliorefRole) return docBibliorefRole;
  hasRequiredDocBibliorefRole = 1;
  Object.defineProperty(docBibliorefRole, "__esModule", {
    value: true
  });
  docBibliorefRole.default = void 0;
  var docBibliorefRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'biblioref [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'command', 'link']]
  };
  var _default = docBibliorefRole$1;
  docBibliorefRole.default = _default;
  return docBibliorefRole;
}

var docChapterRole = {};

var hasRequiredDocChapterRole;
function requireDocChapterRole() {
  if (hasRequiredDocChapterRole) return docChapterRole;
  hasRequiredDocChapterRole = 1;
  Object.defineProperty(docChapterRole, "__esModule", {
    value: true
  });
  docChapterRole.default = void 0;
  var docChapterRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'chapter [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docChapterRole$1;
  docChapterRole.default = _default;
  return docChapterRole;
}

var docColophonRole = {};

var hasRequiredDocColophonRole;
function requireDocColophonRole() {
  if (hasRequiredDocColophonRole) return docColophonRole;
  hasRequiredDocColophonRole = 1;
  Object.defineProperty(docColophonRole, "__esModule", {
    value: true
  });
  docColophonRole.default = void 0;
  var docColophonRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'colophon [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = docColophonRole$1;
  docColophonRole.default = _default;
  return docColophonRole;
}

var docConclusionRole = {};

var hasRequiredDocConclusionRole;
function requireDocConclusionRole() {
  if (hasRequiredDocConclusionRole) return docConclusionRole;
  hasRequiredDocConclusionRole = 1;
  Object.defineProperty(docConclusionRole, "__esModule", {
    value: true
  });
  docConclusionRole.default = void 0;
  var docConclusionRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'conclusion [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docConclusionRole$1;
  docConclusionRole.default = _default;
  return docConclusionRole;
}

var docCoverRole = {};

var hasRequiredDocCoverRole;
function requireDocCoverRole() {
  if (hasRequiredDocCoverRole) return docCoverRole;
  hasRequiredDocCoverRole = 1;
  Object.defineProperty(docCoverRole, "__esModule", {
    value: true
  });
  docCoverRole.default = void 0;
  var docCoverRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'cover [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'img']]
  };
  var _default = docCoverRole$1;
  docCoverRole.default = _default;
  return docCoverRole;
}

var docCreditRole = {};

var hasRequiredDocCreditRole;
function requireDocCreditRole() {
  if (hasRequiredDocCreditRole) return docCreditRole;
  hasRequiredDocCreditRole = 1;
  Object.defineProperty(docCreditRole, "__esModule", {
    value: true
  });
  docCreditRole.default = void 0;
  var docCreditRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'credit [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = docCreditRole$1;
  docCreditRole.default = _default;
  return docCreditRole;
}

var docCreditsRole = {};

var hasRequiredDocCreditsRole;
function requireDocCreditsRole() {
  if (hasRequiredDocCreditsRole) return docCreditsRole;
  hasRequiredDocCreditsRole = 1;
  Object.defineProperty(docCreditsRole, "__esModule", {
    value: true
  });
  docCreditsRole.default = void 0;
  var docCreditsRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'credits [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docCreditsRole$1;
  docCreditsRole.default = _default;
  return docCreditsRole;
}

var docDedicationRole = {};

var hasRequiredDocDedicationRole;
function requireDocDedicationRole() {
  if (hasRequiredDocDedicationRole) return docDedicationRole;
  hasRequiredDocDedicationRole = 1;
  Object.defineProperty(docDedicationRole, "__esModule", {
    value: true
  });
  docDedicationRole.default = void 0;
  var docDedicationRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'dedication [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = docDedicationRole$1;
  docDedicationRole.default = _default;
  return docDedicationRole;
}

var docEndnoteRole = {};

var hasRequiredDocEndnoteRole;
function requireDocEndnoteRole() {
  if (hasRequiredDocEndnoteRole) return docEndnoteRole;
  hasRequiredDocEndnoteRole = 1;
  Object.defineProperty(docEndnoteRole, "__esModule", {
    value: true
  });
  docEndnoteRole.default = void 0;
  var docEndnoteRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'rearnote [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: ['doc-endnotes'],
    requiredContextRole: ['doc-endnotes'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'listitem']]
  };
  var _default = docEndnoteRole$1;
  docEndnoteRole.default = _default;
  return docEndnoteRole;
}

var docEndnotesRole = {};

var hasRequiredDocEndnotesRole;
function requireDocEndnotesRole() {
  if (hasRequiredDocEndnotesRole) return docEndnotesRole;
  hasRequiredDocEndnotesRole = 1;
  Object.defineProperty(docEndnotesRole, "__esModule", {
    value: true
  });
  docEndnotesRole.default = void 0;
  var docEndnotesRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'rearnotes [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['doc-endnote']],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docEndnotesRole$1;
  docEndnotesRole.default = _default;
  return docEndnotesRole;
}

var docEpigraphRole = {};

var hasRequiredDocEpigraphRole;
function requireDocEpigraphRole() {
  if (hasRequiredDocEpigraphRole) return docEpigraphRole;
  hasRequiredDocEpigraphRole = 1;
  Object.defineProperty(docEpigraphRole, "__esModule", {
    value: true
  });
  docEpigraphRole.default = void 0;
  var docEpigraphRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'epigraph [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = docEpigraphRole$1;
  docEpigraphRole.default = _default;
  return docEpigraphRole;
}

var docEpilogueRole = {};

var hasRequiredDocEpilogueRole;
function requireDocEpilogueRole() {
  if (hasRequiredDocEpilogueRole) return docEpilogueRole;
  hasRequiredDocEpilogueRole = 1;
  Object.defineProperty(docEpilogueRole, "__esModule", {
    value: true
  });
  docEpilogueRole.default = void 0;
  var docEpilogueRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'epilogue [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docEpilogueRole$1;
  docEpilogueRole.default = _default;
  return docEpilogueRole;
}

var docErrataRole = {};

var hasRequiredDocErrataRole;
function requireDocErrataRole() {
  if (hasRequiredDocErrataRole) return docErrataRole;
  hasRequiredDocErrataRole = 1;
  Object.defineProperty(docErrataRole, "__esModule", {
    value: true
  });
  docErrataRole.default = void 0;
  var docErrataRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'errata [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docErrataRole$1;
  docErrataRole.default = _default;
  return docErrataRole;
}

var docExampleRole = {};

var hasRequiredDocExampleRole;
function requireDocExampleRole() {
  if (hasRequiredDocExampleRole) return docExampleRole;
  hasRequiredDocExampleRole = 1;
  Object.defineProperty(docExampleRole, "__esModule", {
    value: true
  });
  docExampleRole.default = void 0;
  var docExampleRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = docExampleRole$1;
  docExampleRole.default = _default;
  return docExampleRole;
}

var docFootnoteRole = {};

var hasRequiredDocFootnoteRole;
function requireDocFootnoteRole() {
  if (hasRequiredDocFootnoteRole) return docFootnoteRole;
  hasRequiredDocFootnoteRole = 1;
  Object.defineProperty(docFootnoteRole, "__esModule", {
    value: true
  });
  docFootnoteRole.default = void 0;
  var docFootnoteRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'footnote [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = docFootnoteRole$1;
  docFootnoteRole.default = _default;
  return docFootnoteRole;
}

var docForewordRole = {};

var hasRequiredDocForewordRole;
function requireDocForewordRole() {
  if (hasRequiredDocForewordRole) return docForewordRole;
  hasRequiredDocForewordRole = 1;
  Object.defineProperty(docForewordRole, "__esModule", {
    value: true
  });
  docForewordRole.default = void 0;
  var docForewordRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'foreword [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docForewordRole$1;
  docForewordRole.default = _default;
  return docForewordRole;
}

var docGlossaryRole = {};

var hasRequiredDocGlossaryRole;
function requireDocGlossaryRole() {
  if (hasRequiredDocGlossaryRole) return docGlossaryRole;
  hasRequiredDocGlossaryRole = 1;
  Object.defineProperty(docGlossaryRole, "__esModule", {
    value: true
  });
  docGlossaryRole.default = void 0;
  var docGlossaryRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'glossary [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['definition'], ['term']],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docGlossaryRole$1;
  docGlossaryRole.default = _default;
  return docGlossaryRole;
}

var docGlossrefRole = {};

var hasRequiredDocGlossrefRole;
function requireDocGlossrefRole() {
  if (hasRequiredDocGlossrefRole) return docGlossrefRole;
  hasRequiredDocGlossrefRole = 1;
  Object.defineProperty(docGlossrefRole, "__esModule", {
    value: true
  });
  docGlossrefRole.default = void 0;
  var docGlossrefRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'glossref [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'command', 'link']]
  };
  var _default = docGlossrefRole$1;
  docGlossrefRole.default = _default;
  return docGlossrefRole;
}

var docIndexRole = {};

var hasRequiredDocIndexRole;
function requireDocIndexRole() {
  if (hasRequiredDocIndexRole) return docIndexRole;
  hasRequiredDocIndexRole = 1;
  Object.defineProperty(docIndexRole, "__esModule", {
    value: true
  });
  docIndexRole.default = void 0;
  var docIndexRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'index [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark', 'navigation']]
  };
  var _default = docIndexRole$1;
  docIndexRole.default = _default;
  return docIndexRole;
}

var docIntroductionRole = {};

var hasRequiredDocIntroductionRole;
function requireDocIntroductionRole() {
  if (hasRequiredDocIntroductionRole) return docIntroductionRole;
  hasRequiredDocIntroductionRole = 1;
  Object.defineProperty(docIntroductionRole, "__esModule", {
    value: true
  });
  docIntroductionRole.default = void 0;
  var docIntroductionRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'introduction [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docIntroductionRole$1;
  docIntroductionRole.default = _default;
  return docIntroductionRole;
}

var docNoterefRole = {};

var hasRequiredDocNoterefRole;
function requireDocNoterefRole() {
  if (hasRequiredDocNoterefRole) return docNoterefRole;
  hasRequiredDocNoterefRole = 1;
  Object.defineProperty(docNoterefRole, "__esModule", {
    value: true
  });
  docNoterefRole.default = void 0;
  var docNoterefRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'noteref [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'command', 'link']]
  };
  var _default = docNoterefRole$1;
  docNoterefRole.default = _default;
  return docNoterefRole;
}

var docNoticeRole = {};

var hasRequiredDocNoticeRole;
function requireDocNoticeRole() {
  if (hasRequiredDocNoticeRole) return docNoticeRole;
  hasRequiredDocNoticeRole = 1;
  Object.defineProperty(docNoticeRole, "__esModule", {
    value: true
  });
  docNoticeRole.default = void 0;
  var docNoticeRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'notice [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'note']]
  };
  var _default = docNoticeRole$1;
  docNoticeRole.default = _default;
  return docNoticeRole;
}

var docPagebreakRole = {};

var hasRequiredDocPagebreakRole;
function requireDocPagebreakRole() {
  if (hasRequiredDocPagebreakRole) return docPagebreakRole;
  hasRequiredDocPagebreakRole = 1;
  Object.defineProperty(docPagebreakRole, "__esModule", {
    value: true
  });
  docPagebreakRole.default = void 0;
  var docPagebreakRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'pagebreak [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'separator']]
  };
  var _default = docPagebreakRole$1;
  docPagebreakRole.default = _default;
  return docPagebreakRole;
}

var docPagelistRole = {};

var hasRequiredDocPagelistRole;
function requireDocPagelistRole() {
  if (hasRequiredDocPagelistRole) return docPagelistRole;
  hasRequiredDocPagelistRole = 1;
  Object.defineProperty(docPagelistRole, "__esModule", {
    value: true
  });
  docPagelistRole.default = void 0;
  var docPagelistRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'page-list [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark', 'navigation']]
  };
  var _default = docPagelistRole$1;
  docPagelistRole.default = _default;
  return docPagelistRole;
}

var docPartRole = {};

var hasRequiredDocPartRole;
function requireDocPartRole() {
  if (hasRequiredDocPartRole) return docPartRole;
  hasRequiredDocPartRole = 1;
  Object.defineProperty(docPartRole, "__esModule", {
    value: true
  });
  docPartRole.default = void 0;
  var docPartRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'part [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docPartRole$1;
  docPartRole.default = _default;
  return docPartRole;
}

var docPrefaceRole = {};

var hasRequiredDocPrefaceRole;
function requireDocPrefaceRole() {
  if (hasRequiredDocPrefaceRole) return docPrefaceRole;
  hasRequiredDocPrefaceRole = 1;
  Object.defineProperty(docPrefaceRole, "__esModule", {
    value: true
  });
  docPrefaceRole.default = void 0;
  var docPrefaceRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'preface [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docPrefaceRole$1;
  docPrefaceRole.default = _default;
  return docPrefaceRole;
}

var docPrologueRole = {};

var hasRequiredDocPrologueRole;
function requireDocPrologueRole() {
  if (hasRequiredDocPrologueRole) return docPrologueRole;
  hasRequiredDocPrologueRole = 1;
  Object.defineProperty(docPrologueRole, "__esModule", {
    value: true
  });
  docPrologueRole.default = void 0;
  var docPrologueRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'prologue [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docPrologueRole$1;
  docPrologueRole.default = _default;
  return docPrologueRole;
}

var docPullquoteRole = {};

var hasRequiredDocPullquoteRole;
function requireDocPullquoteRole() {
  if (hasRequiredDocPullquoteRole) return docPullquoteRole;
  hasRequiredDocPullquoteRole = 1;
  Object.defineProperty(docPullquoteRole, "__esModule", {
    value: true
  });
  docPullquoteRole.default = void 0;
  var docPullquoteRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'pullquote [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['none']]
  };
  var _default = docPullquoteRole$1;
  docPullquoteRole.default = _default;
  return docPullquoteRole;
}

var docQnaRole = {};

var hasRequiredDocQnaRole;
function requireDocQnaRole() {
  if (hasRequiredDocQnaRole) return docQnaRole;
  hasRequiredDocQnaRole = 1;
  Object.defineProperty(docQnaRole, "__esModule", {
    value: true
  });
  docQnaRole.default = void 0;
  var docQnaRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'qna [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = docQnaRole$1;
  docQnaRole.default = _default;
  return docQnaRole;
}

var docSubtitleRole = {};

var hasRequiredDocSubtitleRole;
function requireDocSubtitleRole() {
  if (hasRequiredDocSubtitleRole) return docSubtitleRole;
  hasRequiredDocSubtitleRole = 1;
  Object.defineProperty(docSubtitleRole, "__esModule", {
    value: true
  });
  docSubtitleRole.default = void 0;
  var docSubtitleRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'subtitle [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'sectionhead']]
  };
  var _default = docSubtitleRole$1;
  docSubtitleRole.default = _default;
  return docSubtitleRole;
}

var docTipRole = {};

var hasRequiredDocTipRole;
function requireDocTipRole() {
  if (hasRequiredDocTipRole) return docTipRole;
  hasRequiredDocTipRole = 1;
  Object.defineProperty(docTipRole, "__esModule", {
    value: true
  });
  docTipRole.default = void 0;
  var docTipRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'help [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'note']]
  };
  var _default = docTipRole$1;
  docTipRole.default = _default;
  return docTipRole;
}

var docTocRole = {};

var hasRequiredDocTocRole;
function requireDocTocRole() {
  if (hasRequiredDocTocRole) return docTocRole;
  hasRequiredDocTocRole = 1;
  Object.defineProperty(docTocRole, "__esModule", {
    value: true
  });
  docTocRole.default = void 0;
  var docTocRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'toc [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark', 'navigation']]
  };
  var _default = docTocRole$1;
  docTocRole.default = _default;
  return docTocRole;
}

var hasRequiredAriaDpubRoles;
function requireAriaDpubRoles() {
  if (hasRequiredAriaDpubRoles) return ariaDpubRoles;
  hasRequiredAriaDpubRoles = 1;
  Object.defineProperty(ariaDpubRoles, "__esModule", {
    value: true
  });
  ariaDpubRoles.default = void 0;
  var _docAbstractRole = _interopRequireDefault(requireDocAbstractRole());
  var _docAcknowledgmentsRole = _interopRequireDefault(requireDocAcknowledgmentsRole());
  var _docAfterwordRole = _interopRequireDefault(requireDocAfterwordRole());
  var _docAppendixRole = _interopRequireDefault(requireDocAppendixRole());
  var _docBacklinkRole = _interopRequireDefault(requireDocBacklinkRole());
  var _docBiblioentryRole = _interopRequireDefault(requireDocBiblioentryRole());
  var _docBibliographyRole = _interopRequireDefault(requireDocBibliographyRole());
  var _docBibliorefRole = _interopRequireDefault(requireDocBibliorefRole());
  var _docChapterRole = _interopRequireDefault(requireDocChapterRole());
  var _docColophonRole = _interopRequireDefault(requireDocColophonRole());
  var _docConclusionRole = _interopRequireDefault(requireDocConclusionRole());
  var _docCoverRole = _interopRequireDefault(requireDocCoverRole());
  var _docCreditRole = _interopRequireDefault(requireDocCreditRole());
  var _docCreditsRole = _interopRequireDefault(requireDocCreditsRole());
  var _docDedicationRole = _interopRequireDefault(requireDocDedicationRole());
  var _docEndnoteRole = _interopRequireDefault(requireDocEndnoteRole());
  var _docEndnotesRole = _interopRequireDefault(requireDocEndnotesRole());
  var _docEpigraphRole = _interopRequireDefault(requireDocEpigraphRole());
  var _docEpilogueRole = _interopRequireDefault(requireDocEpilogueRole());
  var _docErrataRole = _interopRequireDefault(requireDocErrataRole());
  var _docExampleRole = _interopRequireDefault(requireDocExampleRole());
  var _docFootnoteRole = _interopRequireDefault(requireDocFootnoteRole());
  var _docForewordRole = _interopRequireDefault(requireDocForewordRole());
  var _docGlossaryRole = _interopRequireDefault(requireDocGlossaryRole());
  var _docGlossrefRole = _interopRequireDefault(requireDocGlossrefRole());
  var _docIndexRole = _interopRequireDefault(requireDocIndexRole());
  var _docIntroductionRole = _interopRequireDefault(requireDocIntroductionRole());
  var _docNoterefRole = _interopRequireDefault(requireDocNoterefRole());
  var _docNoticeRole = _interopRequireDefault(requireDocNoticeRole());
  var _docPagebreakRole = _interopRequireDefault(requireDocPagebreakRole());
  var _docPagelistRole = _interopRequireDefault(requireDocPagelistRole());
  var _docPartRole = _interopRequireDefault(requireDocPartRole());
  var _docPrefaceRole = _interopRequireDefault(requireDocPrefaceRole());
  var _docPrologueRole = _interopRequireDefault(requireDocPrologueRole());
  var _docPullquoteRole = _interopRequireDefault(requireDocPullquoteRole());
  var _docQnaRole = _interopRequireDefault(requireDocQnaRole());
  var _docSubtitleRole = _interopRequireDefault(requireDocSubtitleRole());
  var _docTipRole = _interopRequireDefault(requireDocTipRole());
  var _docTocRole = _interopRequireDefault(requireDocTocRole());
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var ariaDpubRoles$1 = [['doc-abstract', _docAbstractRole.default], ['doc-acknowledgments', _docAcknowledgmentsRole.default], ['doc-afterword', _docAfterwordRole.default], ['doc-appendix', _docAppendixRole.default], ['doc-backlink', _docBacklinkRole.default], ['doc-biblioentry', _docBiblioentryRole.default], ['doc-bibliography', _docBibliographyRole.default], ['doc-biblioref', _docBibliorefRole.default], ['doc-chapter', _docChapterRole.default], ['doc-colophon', _docColophonRole.default], ['doc-conclusion', _docConclusionRole.default], ['doc-cover', _docCoverRole.default], ['doc-credit', _docCreditRole.default], ['doc-credits', _docCreditsRole.default], ['doc-dedication', _docDedicationRole.default], ['doc-endnote', _docEndnoteRole.default], ['doc-endnotes', _docEndnotesRole.default], ['doc-epigraph', _docEpigraphRole.default], ['doc-epilogue', _docEpilogueRole.default], ['doc-errata', _docErrataRole.default], ['doc-example', _docExampleRole.default], ['doc-footnote', _docFootnoteRole.default], ['doc-foreword', _docForewordRole.default], ['doc-glossary', _docGlossaryRole.default], ['doc-glossref', _docGlossrefRole.default], ['doc-index', _docIndexRole.default], ['doc-introduction', _docIntroductionRole.default], ['doc-noteref', _docNoterefRole.default], ['doc-notice', _docNoticeRole.default], ['doc-pagebreak', _docPagebreakRole.default], ['doc-pagelist', _docPagelistRole.default], ['doc-part', _docPartRole.default], ['doc-preface', _docPrefaceRole.default], ['doc-prologue', _docPrologueRole.default], ['doc-pullquote', _docPullquoteRole.default], ['doc-qna', _docQnaRole.default], ['doc-subtitle', _docSubtitleRole.default], ['doc-tip', _docTipRole.default], ['doc-toc', _docTocRole.default]];
  var _default = ariaDpubRoles$1;
  ariaDpubRoles.default = _default;
  return ariaDpubRoles;
}

var ariaGraphicsRoles = {};

var graphicsDocumentRole = {};

var hasRequiredGraphicsDocumentRole;
function requireGraphicsDocumentRole() {
  if (hasRequiredGraphicsDocumentRole) return graphicsDocumentRole;
  hasRequiredGraphicsDocumentRole = 1;
  Object.defineProperty(graphicsDocumentRole, "__esModule", {
    value: true
  });
  graphicsDocumentRole.default = void 0;
  var graphicsDocumentRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      module: 'GRAPHICS',
      concept: {
        name: 'graphics-object'
      }
    }, {
      module: 'ARIA',
      concept: {
        name: 'img'
      }
    }, {
      module: 'ARIA',
      concept: {
        name: 'article'
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'document']]
  };
  var _default = graphicsDocumentRole$1;
  graphicsDocumentRole.default = _default;
  return graphicsDocumentRole;
}

var graphicsObjectRole = {};

var hasRequiredGraphicsObjectRole;
function requireGraphicsObjectRole() {
  if (hasRequiredGraphicsObjectRole) return graphicsObjectRole;
  hasRequiredGraphicsObjectRole = 1;
  Object.defineProperty(graphicsObjectRole, "__esModule", {
    value: true
  });
  graphicsObjectRole.default = void 0;
  var graphicsObjectRole$1 = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      module: 'GRAPHICS',
      concept: {
        name: 'graphics-document'
      }
    }, {
      module: 'ARIA',
      concept: {
        name: 'group'
      }
    }, {
      module: 'ARIA',
      concept: {
        name: 'img'
      }
    }, {
      module: 'GRAPHICS',
      concept: {
        name: 'graphics-symbol'
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'group']]
  };
  var _default = graphicsObjectRole$1;
  graphicsObjectRole.default = _default;
  return graphicsObjectRole;
}

var graphicsSymbolRole = {};

var hasRequiredGraphicsSymbolRole;
function requireGraphicsSymbolRole() {
  if (hasRequiredGraphicsSymbolRole) return graphicsSymbolRole;
  hasRequiredGraphicsSymbolRole = 1;
  Object.defineProperty(graphicsSymbolRole, "__esModule", {
    value: true
  });
  graphicsSymbolRole.default = void 0;
  var graphicsSymbolRole$1 = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'img']]
  };
  var _default = graphicsSymbolRole$1;
  graphicsSymbolRole.default = _default;
  return graphicsSymbolRole;
}

var hasRequiredAriaGraphicsRoles;
function requireAriaGraphicsRoles() {
  if (hasRequiredAriaGraphicsRoles) return ariaGraphicsRoles;
  hasRequiredAriaGraphicsRoles = 1;
  Object.defineProperty(ariaGraphicsRoles, "__esModule", {
    value: true
  });
  ariaGraphicsRoles.default = void 0;
  var _graphicsDocumentRole = _interopRequireDefault(requireGraphicsDocumentRole());
  var _graphicsObjectRole = _interopRequireDefault(requireGraphicsObjectRole());
  var _graphicsSymbolRole = _interopRequireDefault(requireGraphicsSymbolRole());
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var ariaGraphicsRoles$1 = [['graphics-document', _graphicsDocumentRole.default], ['graphics-object', _graphicsObjectRole.default], ['graphics-symbol', _graphicsSymbolRole.default]];
  var _default = ariaGraphicsRoles$1;
  ariaGraphicsRoles.default = _default;
  return ariaGraphicsRoles;
}

var hasRequiredRolesMap;
function requireRolesMap() {
  if (hasRequiredRolesMap) return rolesMap;
  hasRequiredRolesMap = 1;
  Object.defineProperty(rolesMap, "__esModule", {
    value: true
  });
  rolesMap.default = void 0;
  var _ariaAbstractRoles = _interopRequireDefault(requireAriaAbstractRoles());
  var _ariaLiteralRoles = _interopRequireDefault(requireAriaLiteralRoles());
  var _ariaDpubRoles = _interopRequireDefault(requireAriaDpubRoles());
  var _ariaGraphicsRoles = _interopRequireDefault(requireAriaGraphicsRoles());
  var _iterationDecorator = _interopRequireDefault(requireIterationDecorator());
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike) {
        if (it) o = it;
        var i = 0;
        var F = function F() {};
        return {
          s: F,
          n: function n() {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function e(_e2) {
            throw _e2;
          },
          f: F
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true,
      didErr = false,
      err;
    return {
      s: function s() {
        it = it.call(o);
      },
      n: function n() {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function e(_e3) {
        didErr = true;
        err = _e3;
      },
      f: function f() {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  var roles = [].concat(_ariaAbstractRoles.default, _ariaLiteralRoles.default, _ariaDpubRoles.default, _ariaGraphicsRoles.default);
  roles.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      roleDefinition = _ref2[1];
    // Conglomerate the properties
    var _iterator = _createForOfIteratorHelper(roleDefinition.superClass),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var superClassIter = _step.value;
        var _iterator2 = _createForOfIteratorHelper(superClassIter),
          _step2;
        try {
          var _loop = function _loop() {
            var superClassName = _step2.value;
            var superClassRoleTuple = roles.find(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 1),
                name = _ref4[0];
              return name === superClassName;
            });
            if (superClassRoleTuple) {
              var superClassDefinition = superClassRoleTuple[1];
              for (var _i2 = 0, _Object$keys = Object.keys(superClassDefinition.props); _i2 < _Object$keys.length; _i2++) {
                var prop = _Object$keys[_i2];
                if (
                // $FlowIssue Accessing the hasOwnProperty on the Object prototype is fine.
                !Object.prototype.hasOwnProperty.call(roleDefinition.props, prop)) {
                  Object.assign(roleDefinition.props, _defineProperty({}, prop, superClassDefinition.props[prop]));
                }
              }
            }
          };
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
  var rolesMap$1 = {
    entries: function entries() {
      return roles;
    },
    forEach: function forEach(fn) {
      var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var _iterator3 = _createForOfIteratorHelper(roles),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
            key = _step3$value[0],
            values = _step3$value[1];
          fn.call(thisArg, values, key, roles);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    },
    get: function get(key) {
      var item = roles.find(function (tuple) {
        return tuple[0] === key ? true : false;
      });
      return item && item[1];
    },
    has: function has(key) {
      return !!rolesMap$1.get(key);
    },
    keys: function keys() {
      return roles.map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 1),
          key = _ref6[0];
        return key;
      });
    },
    values: function values() {
      return roles.map(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          values = _ref8[1];
        return values;
      });
    }
  };
  var _default = (0, _iterationDecorator.default)(rolesMap$1, rolesMap$1.entries());
  rolesMap.default = _default;
  return rolesMap;
}

var elementRoleMap = {};

var isArguments$1;
var hasRequiredIsArguments$1;
function requireIsArguments$1() {
  if (hasRequiredIsArguments$1) return isArguments$1;
  hasRequiredIsArguments$1 = 1;
  var toStr = Object.prototype.toString;
  isArguments$1 = function isArguments(value) {
    var str = toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) {
      isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
    }
    return isArgs;
  };
  return isArguments$1;
}

var implementation$4;
var hasRequiredImplementation$4;
function requireImplementation$4() {
  if (hasRequiredImplementation$4) return implementation$4;
  hasRequiredImplementation$4 = 1;
  var keysShim;
  if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var has = Object.prototype.hasOwnProperty;
    var toStr = Object.prototype.toString;
    var isArgs = requireIsArguments$1(); // eslint-disable-line global-require
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({
      toString: null
    }, 'toString');
    var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
    var dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];
    var equalsConstructorPrototype = function (o) {
      var ctor = o.constructor;
      return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
      $applicationCache: true,
      $console: true,
      $external: true,
      $frame: true,
      $frameElement: true,
      $frames: true,
      $innerHeight: true,
      $innerWidth: true,
      $onmozfullscreenchange: true,
      $onmozfullscreenerror: true,
      $outerHeight: true,
      $outerWidth: true,
      $pageXOffset: true,
      $pageYOffset: true,
      $parent: true,
      $scrollLeft: true,
      $scrollTop: true,
      $scrollX: true,
      $scrollY: true,
      $self: true,
      $webkitIndexedDB: true,
      $webkitStorageInfo: true,
      $window: true
    };
    var hasAutomationEqualityBug = function () {
      /* global window */
      if (typeof window === 'undefined') {
        return false;
      }
      for (var k in window) {
        try {
          if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
            try {
              equalsConstructorPrototype(window[k]);
            } catch (e) {
              return true;
            }
          }
        } catch (e) {
          return true;
        }
      }
      return false;
    }();
    var equalsConstructorPrototypeIfNotBuggy = function (o) {
      /* global window */
      if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
        return equalsConstructorPrototype(o);
      }
      try {
        return equalsConstructorPrototype(o);
      } catch (e) {
        return false;
      }
    };
    keysShim = function keys(object) {
      var isObject = object !== null && typeof object === 'object';
      var isFunction = toStr.call(object) === '[object Function]';
      var isArguments = isArgs(object);
      var isString = isObject && toStr.call(object) === '[object String]';
      var theKeys = [];
      if (!isObject && !isFunction && !isArguments) {
        throw new TypeError('Object.keys called on a non-object');
      }
      var skipProto = hasProtoEnumBug && isFunction;
      if (isString && object.length > 0 && !has.call(object, 0)) {
        for (var i = 0; i < object.length; ++i) {
          theKeys.push(String(i));
        }
      }
      if (isArguments && object.length > 0) {
        for (var j = 0; j < object.length; ++j) {
          theKeys.push(String(j));
        }
      } else {
        for (var name in object) {
          if (!(skipProto && name === 'prototype') && has.call(object, name)) {
            theKeys.push(String(name));
          }
        }
      }
      if (hasDontEnumBug) {
        var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
        for (var k = 0; k < dontEnums.length; ++k) {
          if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
            theKeys.push(dontEnums[k]);
          }
        }
      }
      return theKeys;
    };
  }
  implementation$4 = keysShim;
  return implementation$4;
}

var objectKeys;
var hasRequiredObjectKeys;
function requireObjectKeys() {
  if (hasRequiredObjectKeys) return objectKeys;
  hasRequiredObjectKeys = 1;
  var slice = Array.prototype.slice;
  var isArgs = requireIsArguments$1();
  var origKeys = Object.keys;
  var keysShim = origKeys ? function keys(o) {
    return origKeys(o);
  } : requireImplementation$4();
  var originalKeys = Object.keys;
  keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
      var keysWorksWithArguments = function () {
        // Safari 5.0 bug
        var args = Object.keys(arguments);
        return args && args.length === arguments.length;
      }(1, 2);
      if (!keysWorksWithArguments) {
        Object.keys = function keys(object) {
          // eslint-disable-line func-name-matching
          if (isArgs(object)) {
            return originalKeys(slice.call(object));
          }
          return originalKeys(object);
        };
      }
    } else {
      Object.keys = keysShim;
    }
    return Object.keys || keysShim;
  };
  objectKeys = keysShim;
  return objectKeys;
}

var esErrors;
var hasRequiredEsErrors;
function requireEsErrors() {
  if (hasRequiredEsErrors) return esErrors;
  hasRequiredEsErrors = 1;

  /** @type {import('.')} */
  esErrors = Error;
  return esErrors;
}

var _eval;
var hasRequired_eval;
function require_eval() {
  if (hasRequired_eval) return _eval;
  hasRequired_eval = 1;

  /** @type {import('./eval')} */
  _eval = EvalError;
  return _eval;
}

var range;
var hasRequiredRange;
function requireRange() {
  if (hasRequiredRange) return range;
  hasRequiredRange = 1;

  /** @type {import('./range')} */
  range = RangeError;
  return range;
}

var ref;
var hasRequiredRef;
function requireRef() {
  if (hasRequiredRef) return ref;
  hasRequiredRef = 1;

  /** @type {import('./ref')} */
  ref = ReferenceError;
  return ref;
}

var syntax;
var hasRequiredSyntax;
function requireSyntax() {
  if (hasRequiredSyntax) return syntax;
  hasRequiredSyntax = 1;

  /** @type {import('./syntax')} */
  syntax = SyntaxError;
  return syntax;
}

var type;
var hasRequiredType;
function requireType() {
  if (hasRequiredType) return type;
  hasRequiredType = 1;

  /** @type {import('./type')} */
  type = TypeError;
  return type;
}

var uri;
var hasRequiredUri;
function requireUri() {
  if (hasRequiredUri) return uri;
  hasRequiredUri = 1;

  /** @type {import('./uri')} */
  uri = URIError;
  return uri;
}

var shams$1;
var hasRequiredShams$1;
function requireShams$1() {
  if (hasRequiredShams$1) return shams$1;
  hasRequiredShams$1 = 1;

  /* eslint complexity: [2, 18], max-statements: [2, 33] */
  shams$1 = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
      return false;
    }
    if (typeof Symbol.iterator === 'symbol') {
      return true;
    }
    var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') {
      return false;
    }
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
      return false;
    }
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
      return false;
    }

    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }

    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

    var symVal = 42;
    obj[sym] = symVal;
    for (sym in obj) {
      return false;
    } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
      return false;
    }
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
      return false;
    }
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) {
      return false;
    }
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
      return false;
    }
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
      var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
      if (descriptor.value !== symVal || descriptor.enumerable !== true) {
        return false;
      }
    }
    return true;
  };
  return shams$1;
}

var hasSymbols;
var hasRequiredHasSymbols;
function requireHasSymbols() {
  if (hasRequiredHasSymbols) return hasSymbols;
  hasRequiredHasSymbols = 1;
  var origSymbol = typeof Symbol !== 'undefined' && Symbol;
  var hasSymbolSham = requireShams$1();
  hasSymbols = function hasNativeSymbols() {
    if (typeof origSymbol !== 'function') {
      return false;
    }
    if (typeof Symbol !== 'function') {
      return false;
    }
    if (typeof origSymbol('foo') !== 'symbol') {
      return false;
    }
    if (typeof Symbol('bar') !== 'symbol') {
      return false;
    }
    return hasSymbolSham();
  };
  return hasSymbols;
}

var hasProto;
var hasRequiredHasProto;
function requireHasProto() {
  if (hasRequiredHasProto) return hasProto;
  hasRequiredHasProto = 1;
  var test = {
    __proto__: null,
    foo: {}
  };
  var $Object = Object;

  /** @type {import('.')} */
  hasProto = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return {
      __proto__: test
    }.foo === test.foo && !(test instanceof $Object);
  };
  return hasProto;
}

var implementation$3;
var hasRequiredImplementation$3;
function requireImplementation$3() {
  if (hasRequiredImplementation$3) return implementation$3;
  hasRequiredImplementation$3 = 1;

  /* eslint no-invalid-this: 1 */

  var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
  var toStr = Object.prototype.toString;
  var max = Math.max;
  var funcType = '[object Function]';
  var concatty = function concatty(a, b) {
    var arr = [];
    for (var i = 0; i < a.length; i += 1) {
      arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
      arr[j + a.length] = b[j];
    }
    return arr;
  };
  var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset, j = 0; i < arrLike.length; i += 1, j += 1) {
      arr[j] = arrLike[i];
    }
    return arr;
  };
  var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
      str += arr[i];
      if (i + 1 < arr.length) {
        str += joiner;
      }
    }
    return str;
  };
  implementation$3 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
      throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);
    var bound;
    var binder = function () {
      if (this instanceof bound) {
        var result = target.apply(this, concatty(args, arguments));
        if (Object(result) === result) {
          return result;
        }
        return this;
      }
      return target.apply(that, concatty(args, arguments));
    };
    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
      boundArgs[i] = '$' + i;
    }
    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
      var Empty = function Empty() {};
      Empty.prototype = target.prototype;
      bound.prototype = new Empty();
      Empty.prototype = null;
    }
    return bound;
  };
  return implementation$3;
}

var functionBind;
var hasRequiredFunctionBind;
function requireFunctionBind() {
  if (hasRequiredFunctionBind) return functionBind;
  hasRequiredFunctionBind = 1;
  var implementation = requireImplementation$3();
  functionBind = Function.prototype.bind || implementation;
  return functionBind;
}

var hasown;
var hasRequiredHasown;
function requireHasown() {
  if (hasRequiredHasown) return hasown;
  hasRequiredHasown = 1;
  var call = Function.prototype.call;
  var $hasOwn = Object.prototype.hasOwnProperty;
  var bind = requireFunctionBind();

  /** @type {import('.')} */
  hasown = bind.call(call, $hasOwn);
  return hasown;
}

var getIntrinsic;
var hasRequiredGetIntrinsic;
function requireGetIntrinsic() {
  if (hasRequiredGetIntrinsic) return getIntrinsic;
  hasRequiredGetIntrinsic = 1;
  var undefined$1;
  var $Error = /*@__PURE__*/requireEsErrors();
  var $EvalError = /*@__PURE__*/require_eval();
  var $RangeError = /*@__PURE__*/requireRange();
  var $ReferenceError = /*@__PURE__*/requireRef();
  var $SyntaxError = /*@__PURE__*/requireSyntax();
  var $TypeError = /*@__PURE__*/requireType();
  var $URIError = /*@__PURE__*/requireUri();
  var $Function = Function;

  // eslint-disable-next-line consistent-return
  var getEvalledConstructor = function (expressionSyntax) {
    try {
      return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
  };
  var $gOPD = Object.getOwnPropertyDescriptor;
  if ($gOPD) {
    try {
      $gOPD({}, '');
    } catch (e) {
      $gOPD = null; // this is IE 8, which has a broken gOPD
    }
  }
  var throwTypeError = function () {
    throw new $TypeError();
  };
  var ThrowTypeError = $gOPD ? function () {
    try {
      // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
      arguments.callee; // IE 8 does not throw here
      return throwTypeError;
    } catch (calleeThrows) {
      try {
        // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
        return $gOPD(arguments, 'callee').get;
      } catch (gOPDthrows) {
        return throwTypeError;
      }
    }
  }() : throwTypeError;
  var hasSymbols = requireHasSymbols()();
  var hasProto = /*@__PURE__*/requireHasProto()();
  var getProto = Object.getPrototypeOf || (hasProto ? function (x) {
    return x.__proto__;
  } // eslint-disable-line no-proto
  : null);
  var needsEval = {};
  var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined$1 : getProto(Uint8Array);
  var INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
    '%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined$1,
    '%AsyncFromSyncIteratorPrototype%': undefined$1,
    '%AsyncFunction%': needsEval,
    '%AsyncGenerator%': needsEval,
    '%AsyncGeneratorFunction%': needsEval,
    '%AsyncIteratorPrototype%': needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined$1 : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined$1 : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $Error,
    '%eval%': eval,
    // eslint-disable-line no-eval
    '%EvalError%': $EvalError,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
    '%Function%': $Function,
    '%GeneratorFunction%': needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
    '%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
    '%RangeError%': $RangeError,
    '%ReferenceError%': $ReferenceError,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined$1,
    '%Symbol%': hasSymbols ? Symbol : undefined$1,
    '%SyntaxError%': $SyntaxError,
    '%ThrowTypeError%': ThrowTypeError,
    '%TypedArray%': TypedArray,
    '%TypeError%': $TypeError,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
    '%URIError%': $URIError,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
  };
  if (getProto) {
    try {
      null.error; // eslint-disable-line no-unused-expressions
    } catch (e) {
      // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
      var errorProto = getProto(getProto(e));
      INTRINSICS['%Error.prototype%'] = errorProto;
    }
  }
  var doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') {
      value = getEvalledConstructor('async function () {}');
    } else if (name === '%GeneratorFunction%') {
      value = getEvalledConstructor('function* () {}');
    } else if (name === '%AsyncGeneratorFunction%') {
      value = getEvalledConstructor('async function* () {}');
    } else if (name === '%AsyncGenerator%') {
      var fn = doEval('%AsyncGeneratorFunction%');
      if (fn) {
        value = fn.prototype;
      }
    } else if (name === '%AsyncIteratorPrototype%') {
      var gen = doEval('%AsyncGenerator%');
      if (gen && getProto) {
        value = getProto(gen.prototype);
      }
    }
    INTRINSICS[name] = value;
    return value;
  };
  var LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
    '%ArrayPrototype%': ['Array', 'prototype'],
    '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
    '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
    '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
    '%ArrayProto_values%': ['Array', 'prototype', 'values'],
    '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
    '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
    '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
    '%BooleanPrototype%': ['Boolean', 'prototype'],
    '%DataViewPrototype%': ['DataView', 'prototype'],
    '%DatePrototype%': ['Date', 'prototype'],
    '%ErrorPrototype%': ['Error', 'prototype'],
    '%EvalErrorPrototype%': ['EvalError', 'prototype'],
    '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
    '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
    '%FunctionPrototype%': ['Function', 'prototype'],
    '%Generator%': ['GeneratorFunction', 'prototype'],
    '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
    '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
    '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
    '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
    '%JSONParse%': ['JSON', 'parse'],
    '%JSONStringify%': ['JSON', 'stringify'],
    '%MapPrototype%': ['Map', 'prototype'],
    '%NumberPrototype%': ['Number', 'prototype'],
    '%ObjectPrototype%': ['Object', 'prototype'],
    '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
    '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
    '%PromisePrototype%': ['Promise', 'prototype'],
    '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
    '%Promise_all%': ['Promise', 'all'],
    '%Promise_reject%': ['Promise', 'reject'],
    '%Promise_resolve%': ['Promise', 'resolve'],
    '%RangeErrorPrototype%': ['RangeError', 'prototype'],
    '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
    '%RegExpPrototype%': ['RegExp', 'prototype'],
    '%SetPrototype%': ['Set', 'prototype'],
    '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
    '%StringPrototype%': ['String', 'prototype'],
    '%SymbolPrototype%': ['Symbol', 'prototype'],
    '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
    '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
    '%TypeErrorPrototype%': ['TypeError', 'prototype'],
    '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
    '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
    '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
    '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
    '%URIErrorPrototype%': ['URIError', 'prototype'],
    '%WeakMapPrototype%': ['WeakMap', 'prototype'],
    '%WeakSetPrototype%': ['WeakSet', 'prototype']
  };
  var bind = requireFunctionBind();
  var hasOwn = /*@__PURE__*/requireHasown();
  var $concat = bind.call(Function.call, Array.prototype.concat);
  var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
  var $replace = bind.call(Function.call, String.prototype.replace);
  var $strSlice = bind.call(Function.call, String.prototype.slice);
  var $exec = bind.call(Function.call, RegExp.prototype.exec);

  /* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
  var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
  var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
  var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === '%' && last !== '%') {
      throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
    } else if (last === '%' && first !== '%') {
      throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
    }
    var result = [];
    $replace(string, rePropName, function (match, number, quote, subString) {
      result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
    });
    return result;
  };
  /* end adaptation */

  var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
      alias = LEGACY_ALIASES[intrinsicName];
      intrinsicName = '%' + alias[0] + '%';
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
      var value = INTRINSICS[intrinsicName];
      if (value === needsEval) {
        value = doEval(intrinsicName);
      }
      if (typeof value === 'undefined' && !allowMissing) {
        throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
      }
      return {
        alias: alias,
        name: intrinsicName,
        value: value
      };
    }
    throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
  };
  getIntrinsic = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) {
      throw new $TypeError('intrinsic name must be a non-empty string');
    }
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
      throw new $TypeError('"allowMissing" argument must be a boolean');
    }
    if ($exec(/^%?[^%]*%?$/, name) === null) {
      throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    }
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
      intrinsicBaseName = alias[0];
      $spliceApply(parts, $concat([0, 1], alias));
    }
    for (var i = 1, isOwn = true; i < parts.length; i += 1) {
      var part = parts[i];
      var first = $strSlice(part, 0, 1);
      var last = $strSlice(part, -1);
      if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) {
        throw new $SyntaxError('property names with quotes must have matching quotes');
      }
      if (part === 'constructor' || !isOwn) {
        skipFurtherCaching = true;
      }
      intrinsicBaseName += '.' + part;
      intrinsicRealName = '%' + intrinsicBaseName + '%';
      if (hasOwn(INTRINSICS, intrinsicRealName)) {
        value = INTRINSICS[intrinsicRealName];
      } else if (value != null) {
        if (!(part in value)) {
          if (!allowMissing) {
            throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
          }
          return void undefined$1;
        }
        if ($gOPD && i + 1 >= parts.length) {
          var desc = $gOPD(value, part);
          isOwn = !!desc;

          // By convention, when a data property is converted to an accessor
          // property to emulate a data property that does not suffer from
          // the override mistake, that accessor's getter is marked with
          // an `originalValue` property. Here, when we detect this, we
          // uphold the illusion by pretending to see that original data
          // property, i.e., returning the value rather than the getter
          // itself.
          if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
            value = desc.get;
          } else {
            value = value[part];
          }
        } else {
          isOwn = hasOwn(value, part);
          value = value[part];
        }
        if (isOwn && !skipFurtherCaching) {
          INTRINSICS[intrinsicRealName] = value;
        }
      }
    }
    return value;
  };
  return getIntrinsic;
}

var esDefineProperty;
var hasRequiredEsDefineProperty;
function requireEsDefineProperty() {
  if (hasRequiredEsDefineProperty) return esDefineProperty;
  hasRequiredEsDefineProperty = 1;
  var GetIntrinsic = /*@__PURE__*/requireGetIntrinsic();

  /** @type {import('.')} */
  var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
  if ($defineProperty) {
    try {
      $defineProperty({}, 'a', {
        value: 1
      });
    } catch (e) {
      // IE 8 has a broken defineProperty
      $defineProperty = false;
    }
  }
  esDefineProperty = $defineProperty;
  return esDefineProperty;
}

var gopd;
var hasRequiredGopd;
function requireGopd() {
  if (hasRequiredGopd) return gopd;
  hasRequiredGopd = 1;
  var GetIntrinsic = /*@__PURE__*/requireGetIntrinsic();
  var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
  if ($gOPD) {
    try {
      $gOPD([], 'length');
    } catch (e) {
      // IE 8 has a broken gOPD
      $gOPD = null;
    }
  }
  gopd = $gOPD;
  return gopd;
}

var defineDataProperty;
var hasRequiredDefineDataProperty;
function requireDefineDataProperty() {
  if (hasRequiredDefineDataProperty) return defineDataProperty;
  hasRequiredDefineDataProperty = 1;
  var $defineProperty = /*@__PURE__*/requireEsDefineProperty();
  var $SyntaxError = /*@__PURE__*/requireSyntax();
  var $TypeError = /*@__PURE__*/requireType();
  var gopd = /*@__PURE__*/requireGopd();

  /** @type {import('.')} */
  defineDataProperty = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') {
      throw new $TypeError('`obj` must be an object or a function`');
    }
    if (typeof property !== 'string' && typeof property !== 'symbol') {
      throw new $TypeError('`property` must be a string or a symbol`');
    }
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
      throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
    }
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
      throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
    }
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
      throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
    }
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
      throw new $TypeError('`loose`, if provided, must be a boolean');
    }
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;

    /* @type {false | TypedPropertyDescriptor<unknown>} */
    var desc = !!gopd && gopd(obj, property);
    if ($defineProperty) {
      $defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
      });
    } else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
      // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
      obj[property] = value; // eslint-disable-line no-param-reassign
    } else {
      throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
    }
  };
  return defineDataProperty;
}

var hasPropertyDescriptors_1;
var hasRequiredHasPropertyDescriptors;
function requireHasPropertyDescriptors() {
  if (hasRequiredHasPropertyDescriptors) return hasPropertyDescriptors_1;
  hasRequiredHasPropertyDescriptors = 1;
  var $defineProperty = /*@__PURE__*/requireEsDefineProperty();
  var hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$defineProperty;
  };
  hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$defineProperty) {
      return null;
    }
    try {
      return $defineProperty([], 'length', {
        value: 1
      }).length !== 1;
    } catch (e) {
      // In Firefox 4-22, defining length on an array throws an exception.
      return true;
    }
  };
  hasPropertyDescriptors_1 = hasPropertyDescriptors;
  return hasPropertyDescriptors_1;
}

var defineProperties_1;
var hasRequiredDefineProperties;
function requireDefineProperties() {
  if (hasRequiredDefineProperties) return defineProperties_1;
  hasRequiredDefineProperties = 1;
  var keys = requireObjectKeys();
  var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
  var toStr = Object.prototype.toString;
  var concat = Array.prototype.concat;
  var defineDataProperty = /*@__PURE__*/requireDefineDataProperty();
  var isFunction = function (fn) {
    return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
  };
  var supportsDescriptors = /*@__PURE__*/requireHasPropertyDescriptors()();
  var defineProperty = function (object, name, value, predicate) {
    if (name in object) {
      if (predicate === true) {
        if (object[name] === value) {
          return;
        }
      } else if (!isFunction(predicate) || !predicate()) {
        return;
      }
    }
    if (supportsDescriptors) {
      defineDataProperty(object, name, value, true);
    } else {
      defineDataProperty(object, name, value);
    }
  };
  var defineProperties = function (object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = keys(map);
    if (hasSymbols) {
      props = concat.call(props, Object.getOwnPropertySymbols(map));
    }
    for (var i = 0; i < props.length; i += 1) {
      defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
    }
  };
  defineProperties.supportsDescriptors = !!supportsDescriptors;
  defineProperties_1 = defineProperties;
  return defineProperties_1;
}

var callBind = {exports: {}};

var setFunctionLength;
var hasRequiredSetFunctionLength;
function requireSetFunctionLength() {
  if (hasRequiredSetFunctionLength) return setFunctionLength;
  hasRequiredSetFunctionLength = 1;
  var GetIntrinsic = /*@__PURE__*/requireGetIntrinsic();
  var define = /*@__PURE__*/requireDefineDataProperty();
  var hasDescriptors = /*@__PURE__*/requireHasPropertyDescriptors()();
  var gOPD = /*@__PURE__*/requireGopd();
  var $TypeError = /*@__PURE__*/requireType();
  var $floor = GetIntrinsic('%Math.floor%');

  /** @type {import('.')} */
  setFunctionLength = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') {
      throw new $TypeError('`fn` is not a function');
    }
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
      throw new $TypeError('`length` must be a positive 32-bit integer');
    }
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && gOPD) {
      var desc = gOPD(fn, 'length');
      if (desc && !desc.configurable) {
        functionLengthIsConfigurable = false;
      }
      if (desc && !desc.writable) {
        functionLengthIsWritable = false;
      }
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
      if (hasDescriptors) {
        define( /** @type {Parameters<define>[0]} */fn, 'length', length, true, true);
      } else {
        define( /** @type {Parameters<define>[0]} */fn, 'length', length);
      }
    }
    return fn;
  };
  return setFunctionLength;
}

var hasRequiredCallBind;
function requireCallBind() {
  if (hasRequiredCallBind) return callBind.exports;
  hasRequiredCallBind = 1;
  (function (module) {

    var bind = requireFunctionBind();
    var GetIntrinsic = /*@__PURE__*/requireGetIntrinsic();
    var setFunctionLength = /*@__PURE__*/requireSetFunctionLength();
    var $TypeError = /*@__PURE__*/requireType();
    var $apply = GetIntrinsic('%Function.prototype.apply%');
    var $call = GetIntrinsic('%Function.prototype.call%');
    var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
    var $defineProperty = /*@__PURE__*/requireEsDefineProperty();
    var $max = GetIntrinsic('%Math.max%');
    module.exports = function callBind(originalFunction) {
      if (typeof originalFunction !== 'function') {
        throw new $TypeError('a function is required');
      }
      var func = $reflectApply(bind, $call, arguments);
      return setFunctionLength(func, 1 + $max(0, originalFunction.length - (arguments.length - 1)), true);
    };
    var applyBind = function applyBind() {
      return $reflectApply(bind, $apply, arguments);
    };
    if ($defineProperty) {
      $defineProperty(module.exports, 'apply', {
        value: applyBind
      });
    } else {
      module.exports.apply = applyBind;
    }
  })(callBind);
  return callBind.exports;
}

var callBound;
var hasRequiredCallBound;
function requireCallBound() {
  if (hasRequiredCallBound) return callBound;
  hasRequiredCallBound = 1;
  var GetIntrinsic = /*@__PURE__*/requireGetIntrinsic();
  var callBind = requireCallBind();
  var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
  callBound = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = GetIntrinsic(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
      return callBind(intrinsic);
    }
    return intrinsic;
  };
  return callBound;
}

var implementation$2;
var hasRequiredImplementation$2;
function requireImplementation$2() {
  if (hasRequiredImplementation$2) return implementation$2;
  hasRequiredImplementation$2 = 1;

  // modified from https://github.com/es-shims/es6-shim
  var objectKeys = requireObjectKeys();
  var hasSymbols = requireShams$1()();
  var callBound = requireCallBound();
  var toObject = Object;
  var $push = callBound('Array.prototype.push');
  var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
  var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;

  // eslint-disable-next-line no-unused-vars
  implementation$2 = function assign(target, source1) {
    if (target == null) {
      throw new TypeError('target must be an object');
    }
    var to = toObject(target); // step 1
    if (arguments.length === 1) {
      return to; // step 2
    }
    for (var s = 1; s < arguments.length; ++s) {
      var from = toObject(arguments[s]); // step 3.a.i

      // step 3.a.ii:
      var keys = objectKeys(from);
      var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
      if (getSymbols) {
        var syms = getSymbols(from);
        for (var j = 0; j < syms.length; ++j) {
          var key = syms[j];
          if ($propIsEnumerable(from, key)) {
            $push(keys, key);
          }
        }
      }

      // step 3.a.iii:
      for (var i = 0; i < keys.length; ++i) {
        var nextKey = keys[i];
        if ($propIsEnumerable(from, nextKey)) {
          // step 3.a.iii.2
          var propValue = from[nextKey]; // step 3.a.iii.2.a
          to[nextKey] = propValue; // step 3.a.iii.2.b
        }
      }
    }
    return to; // step 4
  };
  return implementation$2;
}

var polyfill$2;
var hasRequiredPolyfill$2;
function requirePolyfill$2() {
  if (hasRequiredPolyfill$2) return polyfill$2;
  hasRequiredPolyfill$2 = 1;
  var implementation = requireImplementation$2();
  var lacksProperEnumerationOrder = function () {
    if (!Object.assign) {
      return false;
    }
    /*
     * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
     * note: this does not detect the bug unless there's 20 characters
     */
    var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for (var i = 0; i < letters.length; ++i) {
      map[letters[i]] = letters[i];
    }
    var obj = Object.assign({}, map);
    var actual = '';
    for (var k in obj) {
      actual += k;
    }
    return str !== actual;
  };
  var assignHasPendingExceptions = function () {
    if (!Object.assign || !Object.preventExtensions) {
      return false;
    }
    /*
     * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
     * which is 72% slower than our shim, and Firefox 40's native implementation.
     */
    var thrower = Object.preventExtensions({
      1: 2
    });
    try {
      Object.assign(thrower, 'xy');
    } catch (e) {
      return thrower[1] === 'y';
    }
    return false;
  };
  polyfill$2 = function getPolyfill() {
    if (!Object.assign) {
      return implementation;
    }
    if (lacksProperEnumerationOrder()) {
      return implementation;
    }
    if (assignHasPendingExceptions()) {
      return implementation;
    }
    return Object.assign;
  };
  return polyfill$2;
}

var shim$2;
var hasRequiredShim$2;
function requireShim$2() {
  if (hasRequiredShim$2) return shim$2;
  hasRequiredShim$2 = 1;
  var define = requireDefineProperties();
  var getPolyfill = requirePolyfill$2();
  shim$2 = function shimAssign() {
    var polyfill = getPolyfill();
    define(Object, {
      assign: polyfill
    }, {
      assign: function () {
        return Object.assign !== polyfill;
      }
    });
    return polyfill;
  };
  return shim$2;
}

var object_assign;
var hasRequiredObject_assign;
function requireObject_assign() {
  if (hasRequiredObject_assign) return object_assign;
  hasRequiredObject_assign = 1;
  var defineProperties = requireDefineProperties();
  var callBind = requireCallBind();
  var implementation = requireImplementation$2();
  var getPolyfill = requirePolyfill$2();
  var shim = requireShim$2();
  var polyfill = callBind.apply(getPolyfill());
  // eslint-disable-next-line no-unused-vars
  var bound = function assign(target, source1) {
    return polyfill(Object, arguments);
  };
  defineProperties(bound, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
  });
  object_assign = bound;
  return object_assign;
}

var functionsHaveNames_1;
var hasRequiredFunctionsHaveNames;
function requireFunctionsHaveNames() {
  if (hasRequiredFunctionsHaveNames) return functionsHaveNames_1;
  hasRequiredFunctionsHaveNames = 1;
  var functionsHaveNames = function functionsHaveNames() {
    return typeof function f() {}.name === 'string';
  };
  var gOPD = Object.getOwnPropertyDescriptor;
  if (gOPD) {
    try {
      gOPD([], 'length');
    } catch (e) {
      // IE 8 has a broken gOPD
      gOPD = null;
    }
  }
  functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!functionsHaveNames() || !gOPD) {
      return false;
    }
    var desc = gOPD(function () {}, 'name');
    return !!desc && !!desc.configurable;
  };
  var $bind = Function.prototype.bind;
  functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
  };
  functionsHaveNames_1 = functionsHaveNames;
  return functionsHaveNames_1;
}

var setFunctionName;
var hasRequiredSetFunctionName;
function requireSetFunctionName() {
  if (hasRequiredSetFunctionName) return setFunctionName;
  hasRequiredSetFunctionName = 1;
  var define = /*@__PURE__*/requireDefineDataProperty();
  var hasDescriptors = /*@__PURE__*/requireHasPropertyDescriptors()();
  var functionsHaveConfigurableNames = requireFunctionsHaveNames().functionsHaveConfigurableNames();
  var $TypeError = /*@__PURE__*/requireType();

  /** @type {import('.')} */
  setFunctionName = function setFunctionName(fn, name) {
    if (typeof fn !== 'function') {
      throw new $TypeError('`fn` is not a function');
    }
    var loose = arguments.length > 2 && !!arguments[2];
    if (!loose || functionsHaveConfigurableNames) {
      if (hasDescriptors) {
        define( /** @type {Parameters<define>[0]} */fn, 'name', name, true, true);
      } else {
        define( /** @type {Parameters<define>[0]} */fn, 'name', name);
      }
    }
    return fn;
  };
  return setFunctionName;
}

var implementation$1;
var hasRequiredImplementation$1;
function requireImplementation$1() {
  if (hasRequiredImplementation$1) return implementation$1;
  hasRequiredImplementation$1 = 1;
  var setFunctionName = requireSetFunctionName();
  var $TypeError = /*@__PURE__*/requireType();
  var $Object = Object;
  implementation$1 = setFunctionName(function flags() {
    if (this == null || this !== $Object(this)) {
      throw new $TypeError('RegExp.prototype.flags getter called on non-object');
    }
    var result = '';
    if (this.hasIndices) {
      result += 'd';
    }
    if (this.global) {
      result += 'g';
    }
    if (this.ignoreCase) {
      result += 'i';
    }
    if (this.multiline) {
      result += 'm';
    }
    if (this.dotAll) {
      result += 's';
    }
    if (this.unicode) {
      result += 'u';
    }
    if (this.unicodeSets) {
      result += 'v';
    }
    if (this.sticky) {
      result += 'y';
    }
    return result;
  }, 'get flags', true);
  return implementation$1;
}

var polyfill$1;
var hasRequiredPolyfill$1;
function requirePolyfill$1() {
  if (hasRequiredPolyfill$1) return polyfill$1;
  hasRequiredPolyfill$1 = 1;
  var implementation = requireImplementation$1();
  var supportsDescriptors = requireDefineProperties().supportsDescriptors;
  var $gOPD = Object.getOwnPropertyDescriptor;
  polyfill$1 = function getPolyfill() {
    if (supportsDescriptors && /a/mig.flags === 'gim') {
      var descriptor = $gOPD(RegExp.prototype, 'flags');
      if (descriptor && typeof descriptor.get === 'function' && typeof RegExp.prototype.dotAll === 'boolean' && typeof RegExp.prototype.hasIndices === 'boolean') {
        /* eslint getter-return: 0 */
        var calls = '';
        var o = {};
        Object.defineProperty(o, 'hasIndices', {
          get: function () {
            calls += 'd';
          }
        });
        Object.defineProperty(o, 'sticky', {
          get: function () {
            calls += 'y';
          }
        });
        if (calls === 'dy') {
          return descriptor.get;
        }
      }
    }
    return implementation;
  };
  return polyfill$1;
}

var shim$1;
var hasRequiredShim$1;
function requireShim$1() {
  if (hasRequiredShim$1) return shim$1;
  hasRequiredShim$1 = 1;
  var supportsDescriptors = requireDefineProperties().supportsDescriptors;
  var getPolyfill = requirePolyfill$1();
  var gOPD = Object.getOwnPropertyDescriptor;
  var defineProperty = Object.defineProperty;
  var TypeErr = TypeError;
  var getProto = Object.getPrototypeOf;
  var regex = /a/;
  shim$1 = function shimFlags() {
    if (!supportsDescriptors || !getProto) {
      throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
    }
    var polyfill = getPolyfill();
    var proto = getProto(regex);
    var descriptor = gOPD(proto, 'flags');
    if (!descriptor || descriptor.get !== polyfill) {
      defineProperty(proto, 'flags', {
        configurable: true,
        enumerable: false,
        get: polyfill
      });
    }
    return polyfill;
  };
  return shim$1;
}

var regexp_prototype_flags;
var hasRequiredRegexp_prototype_flags;
function requireRegexp_prototype_flags() {
  if (hasRequiredRegexp_prototype_flags) return regexp_prototype_flags;
  hasRequiredRegexp_prototype_flags = 1;
  var define = requireDefineProperties();
  var callBind = requireCallBind();
  var implementation = requireImplementation$1();
  var getPolyfill = requirePolyfill$1();
  var shim = requireShim$1();
  var flagsBound = callBind(getPolyfill());
  define(flagsBound, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
  });
  regexp_prototype_flags = flagsBound;
  return regexp_prototype_flags;
}

var esGetIterator = {exports: {}};

var shams;
var hasRequiredShams;
function requireShams() {
  if (hasRequiredShams) return shams;
  hasRequiredShams = 1;
  var hasSymbols = requireShams$1();

  /** @type {import('.')} */
  shams = function hasToStringTagShams() {
    return hasSymbols() && !!Symbol.toStringTag;
  };
  return shams;
}

var isArguments;
var hasRequiredIsArguments;
function requireIsArguments() {
  if (hasRequiredIsArguments) return isArguments;
  hasRequiredIsArguments = 1;
  var hasToStringTag = requireShams()();
  var callBound = requireCallBound();
  var $toString = callBound('Object.prototype.toString');
  var isStandardArguments = function isArguments(value) {
    if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
      return false;
    }
    return $toString(value) === '[object Arguments]';
  };
  var isLegacyArguments = function isArguments(value) {
    if (isStandardArguments(value)) {
      return true;
    }
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $toString(value) !== '[object Array]' && $toString(value.callee) === '[object Function]';
  };
  var supportsStandardArguments = function () {
    return isStandardArguments(arguments);
  }();
  isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

  isArguments = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
  return isArguments;
}

var _nodeResolve_empty = {};

var _nodeResolve_empty$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: _nodeResolve_empty
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty$1);

var objectInspect;
var hasRequiredObjectInspect;
function requireObjectInspect() {
  if (hasRequiredObjectInspect) return objectInspect;
  hasRequiredObjectInspect = 1;
  var hasMap = typeof Map === 'function' && Map.prototype;
  var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
  var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
  var mapForEach = hasMap && Map.prototype.forEach;
  var hasSet = typeof Set === 'function' && Set.prototype;
  var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
  var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
  var setForEach = hasSet && Set.prototype.forEach;
  var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
  var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
  var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
  var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
  var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
  var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
  var booleanValueOf = Boolean.prototype.valueOf;
  var objectToString = Object.prototype.toString;
  var functionToString = Function.prototype.toString;
  var $match = String.prototype.match;
  var $slice = String.prototype.slice;
  var $replace = String.prototype.replace;
  var $toUpperCase = String.prototype.toUpperCase;
  var $toLowerCase = String.prototype.toLowerCase;
  var $test = RegExp.prototype.test;
  var $concat = Array.prototype.concat;
  var $join = Array.prototype.join;
  var $arrSlice = Array.prototype.slice;
  var $floor = Math.floor;
  var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
  var gOPS = Object.getOwnPropertySymbols;
  var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
  var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
  // ie, `has-tostringtag/shams
  var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
  var isEnumerable = Object.prototype.propertyIsEnumerable;
  var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
  ? function (O) {
    return O.__proto__; // eslint-disable-line no-proto
  } : null);
  function addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1e3 && num < 1000 || $test.call(/e/, str)) {
      return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
      var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
      if (int !== num) {
        var intStr = String(int);
        var dec = $slice.call(str, intStr.length + 1);
        return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
      }
    }
    return $replace.call(str, sepRegex, '$&_');
  }
  var utilInspect = require$$0;
  var inspectCustom = utilInspect.custom;
  var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
  objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if (has(opts, 'quoteStyle') && opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double') {
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
      throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }
    if (has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') {
      return 'undefined';
    }
    if (obj === null) {
      return 'null';
    }
    if (typeof obj === 'boolean') {
      return obj ? 'true' : 'false';
    }
    if (typeof obj === 'string') {
      return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
      if (obj === 0) {
        return Infinity / obj > 0 ? '0' : '-0';
      }
      var str = String(obj);
      return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
      var bigIntStr = String(obj) + 'n';
      return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') {
      depth = 0;
    }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
      return isArray(obj) ? '[Array]' : '[Object]';
    }
    var indent = getIndent(opts, depth);
    if (typeof seen === 'undefined') {
      seen = [];
    } else if (indexOf(seen, obj) >= 0) {
      return '[Circular]';
    }
    function inspect(value, from, noIndent) {
      if (from) {
        seen = $arrSlice.call(seen);
        seen.push(from);
      }
      if (noIndent) {
        var newOpts = {
          depth: opts.depth
        };
        if (has(opts, 'quoteStyle')) {
          newOpts.quoteStyle = opts.quoteStyle;
        }
        return inspect_(value, newOpts, depth + 1, seen);
      }
      return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !isRegExp(obj)) {
      // in older engines, regexes are callable
      var name = nameOf(obj);
      var keys = arrObjKeys(obj, inspect);
      return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
      var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
      return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
      var s = '<' + $toLowerCase.call(String(obj.nodeName));
      var attrs = obj.attributes || [];
      for (var i = 0; i < attrs.length; i++) {
        s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
      }
      s += '>';
      if (obj.childNodes && obj.childNodes.length) {
        s += '...';
      }
      s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
      return s;
    }
    if (isArray(obj)) {
      if (obj.length === 0) {
        return '[]';
      }
      var xs = arrObjKeys(obj, inspect);
      if (indent && !singleLineValues(xs)) {
        return '[' + indentedJoin(xs, indent) + ']';
      }
      return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
      var parts = arrObjKeys(obj, inspect);
      if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
        return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
      }
      if (parts.length === 0) {
        return '[' + String(obj) + ']';
      }
      return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
      if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
        return utilInspect(obj, {
          depth: maxDepth - depth
        });
      } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
        return obj.inspect();
      }
    }
    if (isMap(obj)) {
      var mapParts = [];
      if (mapForEach) {
        mapForEach.call(obj, function (value, key) {
          mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
      }
      return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
      var setParts = [];
      if (setForEach) {
        setForEach.call(obj, function (value) {
          setParts.push(inspect(value, obj));
        });
      }
      return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
      return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
      return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
      return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
      return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
      return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
      return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
      return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
      return '{ [object Window] }';
    }
    if (obj === commonjsGlobal) {
      return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
      var ys = arrObjKeys(obj, inspect);
      var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
      var protoTag = obj instanceof Object ? '' : 'null prototype';
      var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
      var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
      var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
      if (ys.length === 0) {
        return tag + '{}';
      }
      if (indent) {
        return tag + '{' + indentedJoin(ys, indent) + '}';
      }
      return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
  };
  function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
  }
  function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
  }
  function isArray(obj) {
    return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
  }
  function isDate(obj) {
    return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
  }
  function isRegExp(obj) {
    return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
  }
  function isError(obj) {
    return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
  }
  function isString(obj) {
    return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
  }
  function isNumber(obj) {
    return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
  }
  function isBoolean(obj) {
    return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
  }

  // Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
  function isSymbol(obj) {
    if (hasShammedSymbols) {
      return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
      return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
      return false;
    }
    try {
      symToString.call(obj);
      return true;
    } catch (e) {}
    return false;
  }
  function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
      return false;
    }
    try {
      bigIntValueOf.call(obj);
      return true;
    } catch (e) {}
    return false;
  }
  var hasOwn = Object.prototype.hasOwnProperty || function (key) {
    return key in this;
  };
  function has(obj, key) {
    return hasOwn.call(obj, key);
  }
  function toStr(obj) {
    return objectToString.call(obj);
  }
  function nameOf(f) {
    if (f.name) {
      return f.name;
    }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) {
      return m[1];
    }
    return null;
  }
  function indexOf(xs, x) {
    if (xs.indexOf) {
      return xs.indexOf(x);
    }
    for (var i = 0, l = xs.length; i < l; i++) {
      if (xs[i] === x) {
        return i;
      }
    }
    return -1;
  }
  function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
      return false;
    }
    try {
      mapSize.call(x);
      try {
        setSize.call(x);
      } catch (s) {
        return true;
      }
      return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
  }
  function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
      return false;
    }
    try {
      weakMapHas.call(x, weakMapHas);
      try {
        weakSetHas.call(x, weakSetHas);
      } catch (s) {
        return true;
      }
      return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
  }
  function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
      return false;
    }
    try {
      weakRefDeref.call(x);
      return true;
    } catch (e) {}
    return false;
  }
  function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
      return false;
    }
    try {
      setSize.call(x);
      try {
        mapSize.call(x);
      } catch (m) {
        return true;
      }
      return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
  }
  function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
      return false;
    }
    try {
      weakSetHas.call(x, weakSetHas);
      try {
        weakMapHas.call(x, weakMapHas);
      } catch (s) {
        return true;
      }
      return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
  }
  function isElement(x) {
    if (!x || typeof x !== 'object') {
      return false;
    }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
      return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
  }
  function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
      var remaining = str.length - opts.maxStringLength;
      var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
      return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
  }
  function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
      8: 'b',
      9: 't',
      10: 'n',
      12: 'f',
      13: 'r'
    }[n];
    if (x) {
      return '\\' + x;
    }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
  }
  function markBoxed(str) {
    return 'Object(' + str + ')';
  }
  function weakCollectionOf(type) {
    return type + ' { ? }';
  }
  function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
  }
  function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
      if (indexOf(xs[i], '\n') >= 0) {
        return false;
      }
    }
    return true;
  }
  function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
      baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
      baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
      return null;
    }
    return {
      base: baseIndent,
      prev: $join.call(Array(depth + 1), baseIndent)
    };
  }
  function indentedJoin(xs, indent) {
    if (xs.length === 0) {
      return '';
    }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
  }
  function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
      xs.length = obj.length;
      for (var i = 0; i < obj.length; i++) {
        xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
      }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
      symMap = {};
      for (var k = 0; k < syms.length; k++) {
        symMap['$' + syms[k]] = syms[k];
      }
    }
    for (var key in obj) {
      // eslint-disable-line no-restricted-syntax
      if (!has(obj, key)) {
        continue;
      } // eslint-disable-line no-restricted-syntax, no-continue
      if (isArr && String(Number(key)) === key && key < obj.length) {
        continue;
      } // eslint-disable-line no-restricted-syntax, no-continue
      if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
        // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
        continue; // eslint-disable-line no-restricted-syntax, no-continue
      } else if ($test.call(/[^\w$]/, key)) {
        xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
      } else {
        xs.push(key + ': ' + inspect(obj[key], obj));
      }
    }
    if (typeof gOPS === 'function') {
      for (var j = 0; j < syms.length; j++) {
        if (isEnumerable.call(obj, syms[j])) {
          xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
        }
      }
    }
    return xs;
  }
  return objectInspect;
}

var sideChannel;
var hasRequiredSideChannel;
function requireSideChannel() {
  if (hasRequiredSideChannel) return sideChannel;
  hasRequiredSideChannel = 1;
  var GetIntrinsic = /*@__PURE__*/requireGetIntrinsic();
  var callBound = requireCallBound();
  var inspect = /*@__PURE__*/requireObjectInspect();
  var $TypeError = /*@__PURE__*/requireType();
  var $WeakMap = GetIntrinsic('%WeakMap%', true);
  var $Map = GetIntrinsic('%Map%', true);
  var $weakMapGet = callBound('WeakMap.prototype.get', true);
  var $weakMapSet = callBound('WeakMap.prototype.set', true);
  var $weakMapHas = callBound('WeakMap.prototype.has', true);
  var $mapGet = callBound('Map.prototype.get', true);
  var $mapSet = callBound('Map.prototype.set', true);
  var $mapHas = callBound('Map.prototype.has', true);

  /*
  * This function traverses the list returning the node corresponding to the given key.
  *
  * That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
  */
  /** @type {import('.').listGetNode} */
  var listGetNode = function (list, key) {
    // eslint-disable-line consistent-return
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */
    var prev = list;
    /** @type {(typeof list)['next']} */
    var curr;
    for (; (curr = prev.next) !== null; prev = curr) {
      if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
      }
    }
  };

  /** @type {import('.').listGet} */
  var listGet = function (objects, key) {
    var node = listGetNode(objects, key);
    return node && node.value;
  };
  /** @type {import('.').listSet} */
  var listSet = function (objects, key, value) {
    var node = listGetNode(objects, key);
    if (node) {
      node.value = value;
    } else {
      // Prepend the new node to the beginning of the list
      objects.next = /** @type {import('.').ListNode<typeof value>} */{
        // eslint-disable-line no-param-reassign, no-extra-parens
        key: key,
        next: objects.next,
        value: value
      };
    }
  };
  /** @type {import('.').listHas} */
  var listHas = function (objects, key) {
    return !!listGetNode(objects, key);
  };

  /** @type {import('.')} */
  sideChannel = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */var $wm;
    /** @type {Map<object, unknown>} */
    var $m;
    /** @type {import('.').RootNode<unknown>} */
    var $o;

    /** @type {import('.').Channel} */
    var channel = {
      assert: function (key) {
        if (!channel.has(key)) {
          throw new $TypeError('Side channel does not contain ' + inspect(key));
        }
      },
      get: function (key) {
        // eslint-disable-line consistent-return
        if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
          if ($wm) {
            return $weakMapGet($wm, key);
          }
        } else if ($Map) {
          if ($m) {
            return $mapGet($m, key);
          }
        } else {
          if ($o) {
            // eslint-disable-line no-lonely-if
            return listGet($o, key);
          }
        }
      },
      has: function (key) {
        if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
          if ($wm) {
            return $weakMapHas($wm, key);
          }
        } else if ($Map) {
          if ($m) {
            return $mapHas($m, key);
          }
        } else {
          if ($o) {
            // eslint-disable-line no-lonely-if
            return listHas($o, key);
          }
        }
        return false;
      },
      set: function (key, value) {
        if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
          if (!$wm) {
            $wm = new $WeakMap();
          }
          $weakMapSet($wm, key, value);
        } else if ($Map) {
          if (!$m) {
            $m = new $Map();
          }
          $mapSet($m, key, value);
        } else {
          if (!$o) {
            // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
              key: {},
              next: null
            };
          }
          listSet($o, key, value);
        }
      }
    };
    return channel;
  };
  return sideChannel;
}

var internalSlot;
var hasRequiredInternalSlot;
function requireInternalSlot() {
  if (hasRequiredInternalSlot) return internalSlot;
  hasRequiredInternalSlot = 1;
  var hasOwn = /*@__PURE__*/requireHasown();
  var channel = requireSideChannel()();
  var $TypeError = /*@__PURE__*/requireType();
  var SLOT = {
    assert: function (O, slot) {
      if (!O || typeof O !== 'object' && typeof O !== 'function') {
        throw new $TypeError('`O` is not an object');
      }
      if (typeof slot !== 'string') {
        throw new $TypeError('`slot` must be a string');
      }
      channel.assert(O);
      if (!SLOT.has(O, slot)) {
        throw new $TypeError('`' + slot + '` is not present on `O`');
      }
    },
    get: function (O, slot) {
      if (!O || typeof O !== 'object' && typeof O !== 'function') {
        throw new $TypeError('`O` is not an object');
      }
      if (typeof slot !== 'string') {
        throw new $TypeError('`slot` must be a string');
      }
      var slots = channel.get(O);
      return slots && slots['$' + slot];
    },
    has: function (O, slot) {
      if (!O || typeof O !== 'object' && typeof O !== 'function') {
        throw new $TypeError('`O` is not an object');
      }
      if (typeof slot !== 'string') {
        throw new $TypeError('`slot` must be a string');
      }
      var slots = channel.get(O);
      return !!slots && hasOwn(slots, '$' + slot);
    },
    set: function (O, slot, V) {
      if (!O || typeof O !== 'object' && typeof O !== 'function') {
        throw new $TypeError('`O` is not an object');
      }
      if (typeof slot !== 'string') {
        throw new $TypeError('`slot` must be a string');
      }
      var slots = channel.get(O);
      if (!slots) {
        slots = {};
        channel.set(O, slots);
      }
      slots['$' + slot] = V;
    }
  };
  if (Object.freeze) {
    Object.freeze(SLOT);
  }
  internalSlot = SLOT;
  return internalSlot;
}

var stopIterationIterator;
var hasRequiredStopIterationIterator;
function requireStopIterationIterator() {
  if (hasRequiredStopIterationIterator) return stopIterationIterator;
  hasRequiredStopIterationIterator = 1;
  var SLOT = requireInternalSlot();
  var $SyntaxError = SyntaxError;
  var $StopIteration = typeof StopIteration === 'object' ? StopIteration : null;
  stopIterationIterator = function getStopIterationIterator(origIterator) {
    if (!$StopIteration) {
      throw new $SyntaxError('this environment lacks StopIteration');
    }
    SLOT.set(origIterator, '[[Done]]', false);
    var siIterator = {
      next: function next() {
        var iterator = SLOT.get(this, '[[Iterator]]');
        var done = SLOT.get(iterator, '[[Done]]');
        try {
          return {
            done: done,
            value: done ? void undefined : iterator.next()
          };
        } catch (e) {
          SLOT.set(iterator, '[[Done]]', true);
          if (e !== $StopIteration) {
            throw e;
          }
          return {
            done: true,
            value: void undefined
          };
        }
      }
    };
    SLOT.set(siIterator, '[[Iterator]]', origIterator);
    return siIterator;
  };
  return stopIterationIterator;
}

var isarray;
var hasRequiredIsarray;
function requireIsarray() {
  if (hasRequiredIsarray) return isarray;
  hasRequiredIsarray = 1;
  var toString = {}.toString;
  isarray = Array.isArray || function (arr) {
    return toString.call(arr) == '[object Array]';
  };
  return isarray;
}

var isString;
var hasRequiredIsString;
function requireIsString() {
  if (hasRequiredIsString) return isString;
  hasRequiredIsString = 1;
  var strValue = String.prototype.valueOf;
  var tryStringObject = function tryStringObject(value) {
    try {
      strValue.call(value);
      return true;
    } catch (e) {
      return false;
    }
  };
  var toStr = Object.prototype.toString;
  var strClass = '[object String]';
  var hasToStringTag = requireShams()();
  isString = function isString(value) {
    if (typeof value === 'string') {
      return true;
    }
    if (typeof value !== 'object') {
      return false;
    }
    return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
  };
  return isString;
}

var isMap;
var hasRequiredIsMap;
function requireIsMap() {
  if (hasRequiredIsMap) return isMap;
  hasRequiredIsMap = 1;

  /** @const */
  var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
  var $Set = typeof Set === 'function' && Set.prototype ? Set : null;
  var exported;
  if (!$Map) {
    /** @type {import('.')} */
    // eslint-disable-next-line no-unused-vars
    exported = function isMap(x) {
      // `Map` is not present in this environment.
      return false;
    };
  }
  var $mapHas = $Map ? Map.prototype.has : null;
  var $setHas = $Set ? Set.prototype.has : null;
  if (!exported && !$mapHas) {
    /** @type {import('.')} */
    // eslint-disable-next-line no-unused-vars
    exported = function isMap(x) {
      // `Map` does not have a `has` method
      return false;
    };
  }

  /** @type {import('.')} */
  isMap = exported || function isMap(x) {
    if (!x || typeof x !== 'object') {
      return false;
    }
    try {
      $mapHas.call(x);
      if ($setHas) {
        try {
          $setHas.call(x);
        } catch (e) {
          return true;
        }
      }
      // @ts-expect-error TS can't figure out that $Map is always truthy here
      return x instanceof $Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
  };
  return isMap;
}

var isSet;
var hasRequiredIsSet;
function requireIsSet() {
  if (hasRequiredIsSet) return isSet;
  hasRequiredIsSet = 1;
  var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
  var $Set = typeof Set === 'function' && Set.prototype ? Set : null;
  var exported;
  if (!$Set) {
    /** @type {import('.')} */
    // eslint-disable-next-line no-unused-vars
    exported = function isSet(x) {
      // `Set` is not present in this environment.
      return false;
    };
  }
  var $mapHas = $Map ? Map.prototype.has : null;
  var $setHas = $Set ? Set.prototype.has : null;
  if (!exported && !$setHas) {
    /** @type {import('.')} */
    // eslint-disable-next-line no-unused-vars
    exported = function isSet(x) {
      // `Set` does not have a `has` method
      return false;
    };
  }

  /** @type {import('.')} */
  isSet = exported || function isSet(x) {
    if (!x || typeof x !== 'object') {
      return false;
    }
    try {
      $setHas.call(x);
      if ($mapHas) {
        try {
          $mapHas.call(x);
        } catch (e) {
          return true;
        }
      }
      // @ts-expect-error TS can't figure out that $Set is always truthy here
      return x instanceof $Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
  };
  return isSet;
}

var hasRequiredEsGetIterator;
function requireEsGetIterator() {
  if (hasRequiredEsGetIterator) return esGetIterator.exports;
  hasRequiredEsGetIterator = 1;

  /* eslint global-require: 0 */
  // the code is structured this way so that bundlers can
  // alias out `has-symbols` to `() => true` or `() => false` if your target
  // environments' Symbol capabilities are known, and then use
  // dead code elimination on the rest of this module.
  //
  // Similarly, `isarray` can be aliased to `Array.isArray` if
  // available in all target environments.

  var isArguments = requireIsArguments();
  var getStopIterationIterator = requireStopIterationIterator();
  if (requireHasSymbols()() || requireShams$1()()) {
    var $iterator = Symbol.iterator;
    // Symbol is available natively or shammed
    // natively:
    //  - Chrome >= 38
    //  - Edge 12-14?, Edge >= 15 for sure
    //  - FF >= 36
    //  - Safari >= 9
    //  - node >= 0.12
    esGetIterator.exports = function getIterator(iterable) {
      // alternatively, `iterable[$iterator]?.()`
      if (iterable != null && typeof iterable[$iterator] !== 'undefined') {
        return iterable[$iterator]();
      }
      if (isArguments(iterable)) {
        // arguments objects lack Symbol.iterator
        // - node 0.12
        return Array.prototype[$iterator].call(iterable);
      }
    };
  } else {
    // Symbol is not available, native or shammed
    var isArray = requireIsarray();
    var isString = requireIsString();
    var GetIntrinsic = /*@__PURE__*/requireGetIntrinsic();
    var $Map = GetIntrinsic('%Map%', true);
    var $Set = GetIntrinsic('%Set%', true);
    var callBound = requireCallBound();
    var $arrayPush = callBound('Array.prototype.push');
    var $charCodeAt = callBound('String.prototype.charCodeAt');
    var $stringSlice = callBound('String.prototype.slice');
    var advanceStringIndex = function advanceStringIndex(S, index) {
      var length = S.length;
      if (index + 1 >= length) {
        return index + 1;
      }
      var first = $charCodeAt(S, index);
      if (first < 0xD800 || first > 0xDBFF) {
        return index + 1;
      }
      var second = $charCodeAt(S, index + 1);
      if (second < 0xDC00 || second > 0xDFFF) {
        return index + 1;
      }
      return index + 2;
    };
    var getArrayIterator = function getArrayIterator(arraylike) {
      var i = 0;
      return {
        next: function next() {
          var done = i >= arraylike.length;
          var value;
          if (!done) {
            value = arraylike[i];
            i += 1;
          }
          return {
            done: done,
            value: value
          };
        }
      };
    };
    var getNonCollectionIterator = function getNonCollectionIterator(iterable, noPrimordialCollections) {
      if (isArray(iterable) || isArguments(iterable)) {
        return getArrayIterator(iterable);
      }
      if (isString(iterable)) {
        var i = 0;
        return {
          next: function next() {
            var nextIndex = advanceStringIndex(iterable, i);
            var value = $stringSlice(iterable, i, nextIndex);
            i = nextIndex;
            return {
              done: nextIndex > iterable.length,
              value: value
            };
          }
        };
      }

      // es6-shim and es-shims' es-map use a string "_es6-shim iterator_" property on different iterables, such as MapIterator.
      if (noPrimordialCollections && typeof iterable['_es6-shim iterator_'] !== 'undefined') {
        return iterable['_es6-shim iterator_']();
      }
    };
    if (!$Map && !$Set) {
      // the only language iterables are Array, String, arguments
      // - Safari <= 6.0
      // - Chrome < 38
      // - node < 0.12
      // - FF < 13
      // - IE < 11
      // - Edge < 11

      esGetIterator.exports = function getIterator(iterable) {
        if (iterable != null) {
          return getNonCollectionIterator(iterable, true);
        }
      };
    } else {
      // either Map or Set are available, but Symbol is not
      // - es6-shim on an ES5 browser
      // - Safari 6.2 (maybe 6.1?)
      // - FF v[13, 36)
      // - IE 11
      // - Edge 11
      // - Safari v[6, 9)

      var isMap = /*@__PURE__*/requireIsMap();
      var isSet = /*@__PURE__*/requireIsSet();

      // Firefox >= 27, IE 11, Safari 6.2 - 9, Edge 11, es6-shim in older envs, all have forEach
      var $mapForEach = callBound('Map.prototype.forEach', true);
      var $setForEach = callBound('Set.prototype.forEach', true);
      if (typeof process === 'undefined' || !process.versions || !process.versions.node) {
        // "if is not node"

        // Firefox 17 - 26 has `.iterator()`, whose iterator `.next()` either
        // returns a value, or throws a StopIteration object. These browsers
        // do not have any other mechanism for iteration.
        var $mapIterator = callBound('Map.prototype.iterator', true);
        var $setIterator = callBound('Set.prototype.iterator', true);
      }
      // Firefox 27-35, and some older es6-shim versions, use a string "@@iterator" property
      // this returns a proper iterator object, so we should use it instead of forEach.
      // newer es6-shim versions use a string "_es6-shim iterator_" property.
      var $mapAtAtIterator = callBound('Map.prototype.@@iterator', true) || callBound('Map.prototype._es6-shim iterator_', true);
      var $setAtAtIterator = callBound('Set.prototype.@@iterator', true) || callBound('Set.prototype._es6-shim iterator_', true);
      var getCollectionIterator = function getCollectionIterator(iterable) {
        if (isMap(iterable)) {
          if ($mapIterator) {
            return getStopIterationIterator($mapIterator(iterable));
          }
          if ($mapAtAtIterator) {
            return $mapAtAtIterator(iterable);
          }
          if ($mapForEach) {
            var entries = [];
            $mapForEach(iterable, function (v, k) {
              $arrayPush(entries, [k, v]);
            });
            return getArrayIterator(entries);
          }
        }
        if (isSet(iterable)) {
          if ($setIterator) {
            return getStopIterationIterator($setIterator(iterable));
          }
          if ($setAtAtIterator) {
            return $setAtAtIterator(iterable);
          }
          if ($setForEach) {
            var values = [];
            $setForEach(iterable, function (v) {
              $arrayPush(values, v);
            });
            return getArrayIterator(values);
          }
        }
      };
      esGetIterator.exports = function getIterator(iterable) {
        return getCollectionIterator(iterable) || getNonCollectionIterator(iterable);
      };
    }
  }
  return esGetIterator.exports;
}

var implementation;
var hasRequiredImplementation;
function requireImplementation() {
  if (hasRequiredImplementation) return implementation;
  hasRequiredImplementation = 1;
  var numberIsNaN = function (value) {
    return value !== value;
  };
  implementation = function is(a, b) {
    if (a === 0 && b === 0) {
      return 1 / a === 1 / b;
    }
    if (a === b) {
      return true;
    }
    if (numberIsNaN(a) && numberIsNaN(b)) {
      return true;
    }
    return false;
  };
  return implementation;
}

var polyfill;
var hasRequiredPolyfill;
function requirePolyfill() {
  if (hasRequiredPolyfill) return polyfill;
  hasRequiredPolyfill = 1;
  var implementation = requireImplementation();
  polyfill = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : implementation;
  };
  return polyfill;
}

var shim;
var hasRequiredShim;
function requireShim() {
  if (hasRequiredShim) return shim;
  hasRequiredShim = 1;
  var getPolyfill = requirePolyfill();
  var define = requireDefineProperties();
  shim = function shimObjectIs() {
    var polyfill = getPolyfill();
    define(Object, {
      is: polyfill
    }, {
      is: function testObjectIs() {
        return Object.is !== polyfill;
      }
    });
    return polyfill;
  };
  return shim;
}

var objectIs;
var hasRequiredObjectIs;
function requireObjectIs() {
  if (hasRequiredObjectIs) return objectIs;
  hasRequiredObjectIs = 1;
  var define = requireDefineProperties();
  var callBind = requireCallBind();
  var implementation = requireImplementation();
  var getPolyfill = requirePolyfill();
  var shim = requireShim();
  var polyfill = callBind(getPolyfill(), Object);
  define(polyfill, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
  });
  objectIs = polyfill;
  return objectIs;
}

var isArrayBuffer;
var hasRequiredIsArrayBuffer;
function requireIsArrayBuffer() {
  if (hasRequiredIsArrayBuffer) return isArrayBuffer;
  hasRequiredIsArrayBuffer = 1;
  var callBind = requireCallBind();
  var callBound = requireCallBound();
  var GetIntrinsic = /*@__PURE__*/requireGetIntrinsic();
  var $ArrayBuffer = GetIntrinsic('%ArrayBuffer%', true);
  /** @type {undefined | ((receiver: ArrayBuffer) => number) | ((receiver: unknown) => never)} */
  var $byteLength = callBound('ArrayBuffer.prototype.byteLength', true);
  var $toString = callBound('Object.prototype.toString');

  // in node 0.10, ArrayBuffers have no prototype methods, but have an own slot-checking `slice` method
  var abSlice = !!$ArrayBuffer && !$byteLength && new $ArrayBuffer(0).slice;
  var $abSlice = !!abSlice && callBind(abSlice);

  /** @type {import('.')} */
  isArrayBuffer = $byteLength || $abSlice ? function isArrayBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
      return false;
    }
    try {
      if ($byteLength) {
        // @ts-expect-error no idea why TS can't handle the overload
        $byteLength(obj);
      } else {
        // @ts-expect-error TS chooses not to type-narrow inside a closure
        $abSlice(obj, 0);
      }
      return true;
    } catch (e) {
      return false;
    }
  } : $ArrayBuffer
  // in node 0.8, ArrayBuffers have no prototype or own methods, but also no Symbol.toStringTag
  ? function isArrayBuffer(obj) {
    return $toString(obj) === '[object ArrayBuffer]';
  } : function isArrayBuffer(obj) {
    // eslint-disable-line no-unused-vars
    return false;
  };
  return isArrayBuffer;
}

var isDateObject;
var hasRequiredIsDateObject;
function requireIsDateObject() {
  if (hasRequiredIsDateObject) return isDateObject;
  hasRequiredIsDateObject = 1;
  var getDay = Date.prototype.getDay;
  var tryDateObject = function tryDateGetDayCall(value) {
    try {
      getDay.call(value);
      return true;
    } catch (e) {
      return false;
    }
  };
  var toStr = Object.prototype.toString;
  var dateClass = '[object Date]';
  var hasToStringTag = requireShams()();
  isDateObject = function isDateObject(value) {
    if (typeof value !== 'object' || value === null) {
      return false;
    }
    return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
  };
  return isDateObject;
}

var isRegex;
var hasRequiredIsRegex;
function requireIsRegex() {
  if (hasRequiredIsRegex) return isRegex;
  hasRequiredIsRegex = 1;
  var callBound = requireCallBound();
  var hasToStringTag = requireShams()();
  var has;
  var $exec;
  var isRegexMarker;
  var badStringifier;
  if (hasToStringTag) {
    has = callBound('Object.prototype.hasOwnProperty');
    $exec = callBound('RegExp.prototype.exec');
    isRegexMarker = {};
    var throwRegexMarker = function () {
      throw isRegexMarker;
    };
    badStringifier = {
      toString: throwRegexMarker,
      valueOf: throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') {
      badStringifier[Symbol.toPrimitive] = throwRegexMarker;
    }
  }
  var $toString = callBound('Object.prototype.toString');
  var gOPD = Object.getOwnPropertyDescriptor;
  var regexClass = '[object RegExp]';
  isRegex = hasToStringTag
  // eslint-disable-next-line consistent-return
  ? function isRegex(value) {
    if (!value || typeof value !== 'object') {
      return false;
    }
    var descriptor = gOPD(value, 'lastIndex');
    var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
    if (!hasLastIndexDataProperty) {
      return false;
    }
    try {
      $exec(value, badStringifier);
    } catch (e) {
      return e === isRegexMarker;
    }
  } : function isRegex(value) {
    // In older browsers, typeof regex incorrectly returns 'function'
    if (!value || typeof value !== 'object' && typeof value !== 'function') {
      return false;
    }
    return $toString(value) === regexClass;
  };
  return isRegex;
}

var isSharedArrayBuffer;
var hasRequiredIsSharedArrayBuffer;
function requireIsSharedArrayBuffer() {
  if (hasRequiredIsSharedArrayBuffer) return isSharedArrayBuffer;
  hasRequiredIsSharedArrayBuffer = 1;
  var callBound = requireCallBound();
  var $byteLength = callBound('SharedArrayBuffer.prototype.byteLength', true);

  /** @type {import('.')} */
  isSharedArrayBuffer = $byteLength ? function isSharedArrayBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
      return false;
    }
    try {
      $byteLength(obj);
      return true;
    } catch (e) {
      return false;
    }
  } : function isSharedArrayBuffer(obj) {
    // eslint-disable-line no-unused-vars
    return false;
  };
  return isSharedArrayBuffer;
}

var isNumberObject;
var hasRequiredIsNumberObject;
function requireIsNumberObject() {
  if (hasRequiredIsNumberObject) return isNumberObject;
  hasRequiredIsNumberObject = 1;
  var numToStr = Number.prototype.toString;
  var tryNumberObject = function tryNumberObject(value) {
    try {
      numToStr.call(value);
      return true;
    } catch (e) {
      return false;
    }
  };
  var toStr = Object.prototype.toString;
  var numClass = '[object Number]';
  var hasToStringTag = requireShams()();
  isNumberObject = function isNumberObject(value) {
    if (typeof value === 'number') {
      return true;
    }
    if (typeof value !== 'object') {
      return false;
    }
    return hasToStringTag ? tryNumberObject(value) : toStr.call(value) === numClass;
  };
  return isNumberObject;
}

var isBooleanObject;
var hasRequiredIsBooleanObject;
function requireIsBooleanObject() {
  if (hasRequiredIsBooleanObject) return isBooleanObject;
  hasRequiredIsBooleanObject = 1;
  var callBound = requireCallBound();
  var $boolToStr = callBound('Boolean.prototype.toString');
  var $toString = callBound('Object.prototype.toString');
  var tryBooleanObject = function booleanBrandCheck(value) {
    try {
      $boolToStr(value);
      return true;
    } catch (e) {
      return false;
    }
  };
  var boolClass = '[object Boolean]';
  var hasToStringTag = requireShams()();
  isBooleanObject = function isBoolean(value) {
    if (typeof value === 'boolean') {
      return true;
    }
    if (value === null || typeof value !== 'object') {
      return false;
    }
    return hasToStringTag && Symbol.toStringTag in value ? tryBooleanObject(value) : $toString(value) === boolClass;
  };
  return isBooleanObject;
}

var isSymbol = {exports: {}};

var hasRequiredIsSymbol;
function requireIsSymbol() {
  if (hasRequiredIsSymbol) return isSymbol.exports;
  hasRequiredIsSymbol = 1;
  var toStr = Object.prototype.toString;
  var hasSymbols = requireHasSymbols()();
  if (hasSymbols) {
    var symToStr = Symbol.prototype.toString;
    var symStringRegex = /^Symbol\(.*\)$/;
    var isSymbolObject = function isRealSymbolObject(value) {
      if (typeof value.valueOf() !== 'symbol') {
        return false;
      }
      return symStringRegex.test(symToStr.call(value));
    };
    isSymbol.exports = function isSymbol(value) {
      if (typeof value === 'symbol') {
        return true;
      }
      if (toStr.call(value) !== '[object Symbol]') {
        return false;
      }
      try {
        return isSymbolObject(value);
      } catch (e) {
        return false;
      }
    };
  } else {
    isSymbol.exports = function isSymbol(value) {
      // this environment does not support Symbols.
      return false;
    };
  }
  return isSymbol.exports;
}

var isBigint = {exports: {}};

var hasBigints;
var hasRequiredHasBigints;
function requireHasBigints() {
  if (hasRequiredHasBigints) return hasBigints;
  hasRequiredHasBigints = 1;
  var $BigInt = typeof BigInt !== 'undefined' && BigInt;
  hasBigints = function hasNativeBigInts() {
    return typeof $BigInt === 'function' && typeof BigInt === 'function' && typeof $BigInt(42) === 'bigint' // eslint-disable-line no-magic-numbers
    && typeof BigInt(42) === 'bigint'; // eslint-disable-line no-magic-numbers
  };
  return hasBigints;
}

var hasRequiredIsBigint;
function requireIsBigint() {
  if (hasRequiredIsBigint) return isBigint.exports;
  hasRequiredIsBigint = 1;
  var hasBigInts = requireHasBigints()();
  if (hasBigInts) {
    var bigIntValueOf = BigInt.prototype.valueOf;
    var tryBigInt = function tryBigIntObject(value) {
      try {
        bigIntValueOf.call(value);
        return true;
      } catch (e) {}
      return false;
    };
    isBigint.exports = function isBigInt(value) {
      if (value === null || typeof value === 'undefined' || typeof value === 'boolean' || typeof value === 'string' || typeof value === 'number' || typeof value === 'symbol' || typeof value === 'function') {
        return false;
      }
      if (typeof value === 'bigint') {
        return true;
      }
      return tryBigInt(value);
    };
  } else {
    isBigint.exports = function isBigInt(value) {
      return false;
    };
  }
  return isBigint.exports;
}

var whichBoxedPrimitive;
var hasRequiredWhichBoxedPrimitive;
function requireWhichBoxedPrimitive() {
  if (hasRequiredWhichBoxedPrimitive) return whichBoxedPrimitive;
  hasRequiredWhichBoxedPrimitive = 1;
  var isString = requireIsString();
  var isNumber = requireIsNumberObject();
  var isBoolean = requireIsBooleanObject();
  var isSymbol = requireIsSymbol();
  var isBigInt = requireIsBigint();

  // eslint-disable-next-line consistent-return
  whichBoxedPrimitive = function whichBoxedPrimitive(value) {
    // eslint-disable-next-line eqeqeq
    if (value == null || typeof value !== 'object' && typeof value !== 'function') {
      return null;
    }
    if (isString(value)) {
      return 'String';
    }
    if (isNumber(value)) {
      return 'Number';
    }
    if (isBoolean(value)) {
      return 'Boolean';
    }
    if (isSymbol(value)) {
      return 'Symbol';
    }
    if (isBigInt(value)) {
      return 'BigInt';
    }
  };
  return whichBoxedPrimitive;
}

var isWeakmap;
var hasRequiredIsWeakmap;
function requireIsWeakmap() {
  if (hasRequiredIsWeakmap) return isWeakmap;
  hasRequiredIsWeakmap = 1;
  var $WeakMap = typeof WeakMap === 'function' && WeakMap.prototype ? WeakMap : null;
  var $WeakSet = typeof WeakSet === 'function' && WeakSet.prototype ? WeakSet : null;
  var exported;
  if (!$WeakMap) {
    /** @type {import('.')} */
    // eslint-disable-next-line no-unused-vars
    exported = function isWeakMap(x) {
      // `WeakMap` is not present in this environment.
      return false;
    };
  }
  var $mapHas = $WeakMap ? $WeakMap.prototype.has : null;
  var $setHas = $WeakSet ? $WeakSet.prototype.has : null;
  if (!exported && !$mapHas) {
    /** @type {import('.')} */
    // eslint-disable-next-line no-unused-vars
    exported = function isWeakMap(x) {
      // `WeakMap` does not have a `has` method
      return false;
    };
  }

  /** @type {import('.')} */
  isWeakmap = exported || function isWeakMap(x) {
    if (!x || typeof x !== 'object') {
      return false;
    }
    try {
      $mapHas.call(x, $mapHas);
      if ($setHas) {
        try {
          $setHas.call(x, $setHas);
        } catch (e) {
          return true;
        }
      }
      // @ts-expect-error TS can't figure out that $WeakMap is always truthy here
      return x instanceof $WeakMap; // core-js workaround, pre-v3
    } catch (e) {}
    return false;
  };
  return isWeakmap;
}

var isWeakset = {exports: {}};

var hasRequiredIsWeakset;
function requireIsWeakset() {
  if (hasRequiredIsWeakset) return isWeakset.exports;
  hasRequiredIsWeakset = 1;
  var GetIntrinsic = /*@__PURE__*/requireGetIntrinsic();
  var callBound = requireCallBound();
  var $WeakSet = GetIntrinsic('%WeakSet%', true);
  var $setHas = callBound('WeakSet.prototype.has', true);
  if ($setHas) {
    var $mapHas = callBound('WeakMap.prototype.has', true);

    /** @type {import('.')} */
    isWeakset.exports = function isWeakSet(x) {
      if (!x || typeof x !== 'object') {
        return false;
      }
      try {
        $setHas(x, $setHas);
        if ($mapHas) {
          try {
            $mapHas(x, $mapHas);
          } catch (e) {
            return true;
          }
        }
        // @ts-expect-error TS can't figure out that $WeakSet is always truthy here
        return x instanceof $WeakSet; // core-js workaround, pre-v3
      } catch (e) {}
      return false;
    };
  } else {
    /** @type {import('.')} */
    // eslint-disable-next-line no-unused-vars
    isWeakset.exports = function isWeakSet(x) {
      // `WeakSet` does not exist, or does not have a `has` method
      return false;
    };
  }
  return isWeakset.exports;
}

var whichCollection;
var hasRequiredWhichCollection;
function requireWhichCollection() {
  if (hasRequiredWhichCollection) return whichCollection;
  hasRequiredWhichCollection = 1;
  var isMap = /*@__PURE__*/requireIsMap();
  var isSet = /*@__PURE__*/requireIsSet();
  var isWeakMap = requireIsWeakmap();
  var isWeakSet = /*@__PURE__*/requireIsWeakset();

  /** @type {import('.')} */
  whichCollection = function whichCollection( /** @type {unknown} */value) {
    if (value && typeof value === 'object') {
      if (isMap(value)) {
        return 'Map';
      }
      if (isSet(value)) {
        return 'Set';
      }
      if (isWeakMap(value)) {
        return 'WeakMap';
      }
      if (isWeakSet(value)) {
        return 'WeakSet';
      }
    }
    return false;
  };
  return whichCollection;
}

var isCallable;
var hasRequiredIsCallable;
function requireIsCallable() {
  if (hasRequiredIsCallable) return isCallable;
  hasRequiredIsCallable = 1;
  var fnToStr = Function.prototype.toString;
  var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
  var badArrayLike;
  var isCallableMarker;
  if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
    try {
      badArrayLike = Object.defineProperty({}, 'length', {
        get: function () {
          throw isCallableMarker;
        }
      });
      isCallableMarker = {};
      // eslint-disable-next-line no-throw-literal
      reflectApply(function () {
        throw 42;
      }, null, badArrayLike);
    } catch (_) {
      if (_ !== isCallableMarker) {
        reflectApply = null;
      }
    }
  } else {
    reflectApply = null;
  }
  var constructorRegex = /^\s*class\b/;
  var isES6ClassFn = function isES6ClassFunction(value) {
    try {
      var fnStr = fnToStr.call(value);
      return constructorRegex.test(fnStr);
    } catch (e) {
      return false; // not a function
    }
  };
  var tryFunctionObject = function tryFunctionToStr(value) {
    try {
      if (isES6ClassFn(value)) {
        return false;
      }
      fnToStr.call(value);
      return true;
    } catch (e) {
      return false;
    }
  };
  var toStr = Object.prototype.toString;
  var objectClass = '[object Object]';
  var fnClass = '[object Function]';
  var genClass = '[object GeneratorFunction]';
  var ddaClass = '[object HTMLAllCollection]'; // IE 11
  var ddaClass2 = '[object HTML document.all class]';
  var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
  var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

  var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

  var isDDA = function isDocumentDotAll() {
    return false;
  };
  if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var all = document.all;
    if (toStr.call(all) === toStr.call(document.all)) {
      isDDA = function isDocumentDotAll(value) {
        /* globals document: false */
        // in IE 6-8, typeof document.all is "object" and it's truthy
        if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
          try {
            var str = toStr.call(value);
            return (str === ddaClass || str === ddaClass2 || str === ddaClass3 // opera 12.16
            || str === objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
          } catch (e) {/**/}
        }
        return false;
      };
    }
  }
  isCallable = reflectApply ? function isCallable(value) {
    if (isDDA(value)) {
      return true;
    }
    if (!value) {
      return false;
    }
    if (typeof value !== 'function' && typeof value !== 'object') {
      return false;
    }
    try {
      reflectApply(value, null, badArrayLike);
    } catch (e) {
      if (e !== isCallableMarker) {
        return false;
      }
    }
    return !isES6ClassFn(value) && tryFunctionObject(value);
  } : function isCallable(value) {
    if (isDDA(value)) {
      return true;
    }
    if (!value) {
      return false;
    }
    if (typeof value !== 'function' && typeof value !== 'object') {
      return false;
    }
    if (hasToStringTag) {
      return tryFunctionObject(value);
    }
    if (isES6ClassFn(value)) {
      return false;
    }
    var strClass = toStr.call(value);
    if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) {
      return false;
    }
    return tryFunctionObject(value);
  };
  return isCallable;
}

var forEach_1;
var hasRequiredForEach;
function requireForEach() {
  if (hasRequiredForEach) return forEach_1;
  hasRequiredForEach = 1;
  var isCallable = requireIsCallable();
  var toStr = Object.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
      if (hasOwnProperty.call(array, i)) {
        if (receiver == null) {
          iterator(array[i], i, array);
        } else {
          iterator.call(receiver, array[i], i, array);
        }
      }
    }
  };
  var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
      // no such thing as a sparse string.
      if (receiver == null) {
        iterator(string.charAt(i), i, string);
      } else {
        iterator.call(receiver, string.charAt(i), i, string);
      }
    }
  };
  var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
      if (hasOwnProperty.call(object, k)) {
        if (receiver == null) {
          iterator(object[k], k, object);
        } else {
          iterator.call(receiver, object[k], k, object);
        }
      }
    }
  };
  var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
      throw new TypeError('iterator must be a function');
    }
    var receiver;
    if (arguments.length >= 3) {
      receiver = thisArg;
    }
    if (toStr.call(list) === '[object Array]') {
      forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
      forEachString(list, iterator, receiver);
    } else {
      forEachObject(list, iterator, receiver);
    }
  };
  forEach_1 = forEach;
  return forEach_1;
}

var possibleTypedArrayNames;
var hasRequiredPossibleTypedArrayNames;
function requirePossibleTypedArrayNames() {
  if (hasRequiredPossibleTypedArrayNames) return possibleTypedArrayNames;
  hasRequiredPossibleTypedArrayNames = 1;

  /** @type {import('.')} */
  possibleTypedArrayNames = ['Float32Array', 'Float64Array', 'Int8Array', 'Int16Array', 'Int32Array', 'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'BigInt64Array', 'BigUint64Array'];
  return possibleTypedArrayNames;
}

var availableTypedArrays;
var hasRequiredAvailableTypedArrays;
function requireAvailableTypedArrays() {
  if (hasRequiredAvailableTypedArrays) return availableTypedArrays;
  hasRequiredAvailableTypedArrays = 1;
  var possibleNames = /*@__PURE__*/requirePossibleTypedArrayNames();
  var g = typeof globalThis === 'undefined' ? commonjsGlobal : globalThis;

  /** @type {import('.')} */
  availableTypedArrays = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */out = [];
    for (var i = 0; i < possibleNames.length; i++) {
      if (typeof g[possibleNames[i]] === 'function') {
        // @ts-expect-error
        out[out.length] = possibleNames[i];
      }
    }
    return out;
  };
  return availableTypedArrays;
}

var whichTypedArray;
var hasRequiredWhichTypedArray;
function requireWhichTypedArray() {
  if (hasRequiredWhichTypedArray) return whichTypedArray;
  hasRequiredWhichTypedArray = 1;
  var forEach = requireForEach();
  var availableTypedArrays = /*@__PURE__*/requireAvailableTypedArrays();
  var callBind = requireCallBind();
  var callBound = requireCallBound();
  var gOPD = /*@__PURE__*/requireGopd();

  /** @type {(O: object) => string} */
  var $toString = callBound('Object.prototype.toString');
  var hasToStringTag = requireShams()();
  var g = typeof globalThis === 'undefined' ? commonjsGlobal : globalThis;
  var typedArrays = availableTypedArrays();
  var $slice = callBound('String.prototype.slice');
  var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');

  /** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */
  var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for (var i = 0; i < array.length; i += 1) {
      if (array[i] === value) {
        return i;
      }
    }
    return -1;
  };

  /** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */
  /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */
  var cache = {
    __proto__: null
  };
  if (hasToStringTag && gOPD && getPrototypeOf) {
    forEach(typedArrays, function (typedArray) {
      var arr = new g[typedArray]();
      if (Symbol.toStringTag in arr) {
        var proto = getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = gOPD(proto, Symbol.toStringTag);
        if (!descriptor) {
          var superProto = getPrototypeOf(proto);
          // @ts-expect-error TS won't narrow inside a closure
          descriptor = gOPD(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        cache['$' + typedArray] = callBind(descriptor.get);
      }
    });
  } else {
    forEach(typedArrays, function (typedArray) {
      var arr = new g[typedArray]();
      var fn = arr.slice || arr.set;
      if (fn) {
        // @ts-expect-error TODO: fix
        cache['$' + typedArray] = callBind(fn);
      }
    });
  }

  /** @type {(value: object) => false | import('.').TypedArrayName} */
  var tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */var found = false;
    forEach(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */
    cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
    function (getter, typedArray) {
      if (!found) {
        try {
          // @ts-expect-error TODO: fix
          if ('$' + getter(value) === typedArray) {
            found = $slice(typedArray, 1);
          }
        } catch (e) {/**/}
      }
    });
    return found;
  };

  /** @type {(value: object) => false | import('.').TypedArrayName} */
  var trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */var found = false;
    forEach(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */
    cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */function (getter, name) {
      if (!found) {
        try {
          // @ts-expect-error TODO: fix
          getter(value);
          found = $slice(name, 1);
        } catch (e) {/**/}
      }
    });
    return found;
  };

  /** @type {import('.')} */
  whichTypedArray = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') {
      return false;
    }
    if (!hasToStringTag) {
      /** @type {string} */
      var tag = $slice($toString(value), 8, -1);
      if ($indexOf(typedArrays, tag) > -1) {
        return tag;
      }
      if (tag !== 'Object') {
        return false;
      }
      // node < 0.6 hits here on real Typed Arrays
      return trySlices(value);
    }
    if (!gOPD) {
      return null;
    } // unknown engine
    return tryTypedArrays(value);
  };
  return whichTypedArray;
}

var arrayBufferByteLength;
var hasRequiredArrayBufferByteLength;
function requireArrayBufferByteLength() {
  if (hasRequiredArrayBufferByteLength) return arrayBufferByteLength;
  hasRequiredArrayBufferByteLength = 1;
  var callBound = requireCallBound();
  var $byteLength = callBound('ArrayBuffer.prototype.byteLength', true);
  var isArrayBuffer = /*@__PURE__*/requireIsArrayBuffer();

  /** @type {import('.')} */
  arrayBufferByteLength = function byteLength(ab) {
    if (!isArrayBuffer(ab)) {
      return NaN;
    }
    return $byteLength ? $byteLength(ab) : ab.byteLength;
  }; // in node < 0.11, byteLength is an own nonconfigurable property
  return arrayBufferByteLength;
}

var deepEqual;
var hasRequiredDeepEqual;
function requireDeepEqual() {
  if (hasRequiredDeepEqual) return deepEqual;
  hasRequiredDeepEqual = 1;
  var assign = requireObject_assign();
  var callBound = requireCallBound();
  var flags = requireRegexp_prototype_flags();
  var GetIntrinsic = /*@__PURE__*/requireGetIntrinsic();
  var getIterator = requireEsGetIterator();
  var getSideChannel = requireSideChannel();
  var is = requireObjectIs();
  var isArguments = requireIsArguments();
  var isArray = requireIsarray();
  var isArrayBuffer = /*@__PURE__*/requireIsArrayBuffer();
  var isDate = requireIsDateObject();
  var isRegex = requireIsRegex();
  var isSharedArrayBuffer = /*@__PURE__*/requireIsSharedArrayBuffer();
  var objectKeys = requireObjectKeys();
  var whichBoxedPrimitive = requireWhichBoxedPrimitive();
  var whichCollection = /*@__PURE__*/requireWhichCollection();
  var whichTypedArray = /*@__PURE__*/requireWhichTypedArray();
  var byteLength = /*@__PURE__*/requireArrayBufferByteLength();
  var sabByteLength = callBound('SharedArrayBuffer.prototype.byteLength', true);
  var $getTime = callBound('Date.prototype.getTime');
  var gPO = Object.getPrototypeOf;
  var $objToString = callBound('Object.prototype.toString');
  var $Set = GetIntrinsic('%Set%', true);
  var $mapHas = callBound('Map.prototype.has', true);
  var $mapGet = callBound('Map.prototype.get', true);
  var $mapSize = callBound('Map.prototype.size', true);
  var $setAdd = callBound('Set.prototype.add', true);
  var $setDelete = callBound('Set.prototype.delete', true);
  var $setHas = callBound('Set.prototype.has', true);
  var $setSize = callBound('Set.prototype.size', true);

  // taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L401-L414
  function setHasEqualElement(set, val1, opts, channel) {
    var i = getIterator(set);
    var result;
    while ((result = i.next()) && !result.done) {
      if (internalDeepEqual(val1, result.value, opts, channel)) {
        // eslint-disable-line no-use-before-define
        // Remove the matching element to make sure we do not check that again.
        $setDelete(set, result.value);
        return true;
      }
    }
    return false;
  }

  // taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L416-L439
  function findLooseMatchingPrimitives(prim) {
    if (typeof prim === 'undefined') {
      return null;
    }
    if (typeof prim === 'object') {
      // Only pass in null as object!
      return void 0;
    }
    if (typeof prim === 'symbol') {
      return false;
    }
    if (typeof prim === 'string' || typeof prim === 'number') {
      // Loose equal entries exist only if the string is possible to convert to a regular number and not NaN.
      return +prim === +prim; // eslint-disable-line no-implicit-coercion
    }
    return true;
  }

  // taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L449-L460
  function mapMightHaveLoosePrim(a, b, prim, item, opts, channel) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) {
      return altValue;
    }
    var curB = $mapGet(b, altValue);
    var looseOpts = assign({}, opts, {
      strict: false
    });
    if (typeof curB === 'undefined' && !$mapHas(b, altValue)
    // eslint-disable-next-line no-use-before-define
    || !internalDeepEqual(item, curB, looseOpts, channel)) {
      return false;
    }
    // eslint-disable-next-line no-use-before-define
    return !$mapHas(a, altValue) && internalDeepEqual(item, curB, looseOpts, channel);
  }

  // taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L441-L447
  function setMightHaveLoosePrim(a, b, prim) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) {
      return altValue;
    }
    return $setHas(b, altValue) && !$setHas(a, altValue);
  }

  // taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L518-L533
  function mapHasEqualEntry(set, map, key1, item1, opts, channel) {
    var i = getIterator(set);
    var result;
    var key2;
    while ((result = i.next()) && !result.done) {
      key2 = result.value;
      if (
      // eslint-disable-next-line no-use-before-define
      internalDeepEqual(key1, key2, opts, channel)
      // eslint-disable-next-line no-use-before-define
      && internalDeepEqual(item1, $mapGet(map, key2), opts, channel)) {
        $setDelete(set, key2);
        return true;
      }
    }
    return false;
  }
  function internalDeepEqual(actual, expected, options, channel) {
    var opts = options || {};

    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? is(actual, expected) : actual === expected) {
      return true;
    }
    var actualBoxed = whichBoxedPrimitive(actual);
    var expectedBoxed = whichBoxedPrimitive(expected);
    if (actualBoxed !== expectedBoxed) {
      return false;
    }

    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') {
      return opts.strict ? is(actual, expected) : actual == expected; // eslint-disable-line eqeqeq
    }

    /*
     * 7.4. For all other Object pairs, including Array objects, equivalence is
     * determined by having the same number of owned properties (as verified
     * with Object.prototype.hasOwnProperty.call), the same set of keys
     * (although not necessarily the same order), equivalent values for every
     * corresponding key, and an identical 'prototype' property. Note: this
     * accounts for both named and indexed properties on Arrays.
     */
    // see https://github.com/nodejs/node/commit/d3aafd02efd3a403d646a3044adcf14e63a88d32 for memos/channel inspiration

    var hasActual = channel.has(actual);
    var hasExpected = channel.has(expected);
    var sentinel;
    if (hasActual && hasExpected) {
      if (channel.get(actual) === channel.get(expected)) {
        return true;
      }
    } else {
      sentinel = {};
    }
    if (!hasActual) {
      channel.set(actual, sentinel);
    }
    if (!hasExpected) {
      channel.set(expected, sentinel);
    }

    // eslint-disable-next-line no-use-before-define
    return objEquiv(actual, expected, opts, channel);
  }
  function isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
      return false;
    }
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
      return false;
    }
    if (x.length > 0 && typeof x[0] !== 'number') {
      return false;
    }
    return !!(x.constructor && x.constructor.isBuffer && x.constructor.isBuffer(x));
  }
  function setEquiv(a, b, opts, channel) {
    if ($setSize(a) !== $setSize(b)) {
      return false;
    }
    var iA = getIterator(a);
    var iB = getIterator(b);
    var resultA;
    var resultB;
    var set;
    while ((resultA = iA.next()) && !resultA.done) {
      if (resultA.value && typeof resultA.value === 'object') {
        if (!set) {
          set = new $Set();
        }
        $setAdd(set, resultA.value);
      } else if (!$setHas(b, resultA.value)) {
        if (opts.strict) {
          return false;
        }
        if (!setMightHaveLoosePrim(a, b, resultA.value)) {
          return false;
        }
        if (!set) {
          set = new $Set();
        }
        $setAdd(set, resultA.value);
      }
    }
    if (set) {
      while ((resultB = iB.next()) && !resultB.done) {
        // We have to check if a primitive value is already matching and only if it's not, go hunting for it.
        if (resultB.value && typeof resultB.value === 'object') {
          if (!setHasEqualElement(set, resultB.value, opts.strict, channel)) {
            return false;
          }
        } else if (!opts.strict && !$setHas(a, resultB.value) && !setHasEqualElement(set, resultB.value, opts.strict, channel)) {
          return false;
        }
      }
      return $setSize(set) === 0;
    }
    return true;
  }
  function mapEquiv(a, b, opts, channel) {
    if ($mapSize(a) !== $mapSize(b)) {
      return false;
    }
    var iA = getIterator(a);
    var iB = getIterator(b);
    var resultA;
    var resultB;
    var set;
    var key;
    var item1;
    var item2;
    while ((resultA = iA.next()) && !resultA.done) {
      key = resultA.value[0];
      item1 = resultA.value[1];
      if (key && typeof key === 'object') {
        if (!set) {
          set = new $Set();
        }
        $setAdd(set, key);
      } else {
        item2 = $mapGet(b, key);
        if (typeof item2 === 'undefined' && !$mapHas(b, key) || !internalDeepEqual(item1, item2, opts, channel)) {
          if (opts.strict) {
            return false;
          }
          if (!mapMightHaveLoosePrim(a, b, key, item1, opts, channel)) {
            return false;
          }
          if (!set) {
            set = new $Set();
          }
          $setAdd(set, key);
        }
      }
    }
    if (set) {
      while ((resultB = iB.next()) && !resultB.done) {
        key = resultB.value[0];
        item2 = resultB.value[1];
        if (key && typeof key === 'object') {
          if (!mapHasEqualEntry(set, a, key, item2, opts, channel)) {
            return false;
          }
        } else if (!opts.strict && (!a.has(key) || !internalDeepEqual($mapGet(a, key), item2, opts, channel)) && !mapHasEqualEntry(set, a, key, item2, assign({}, opts, {
          strict: false
        }), channel)) {
          return false;
        }
      }
      return $setSize(set) === 0;
    }
    return true;
  }
  function objEquiv(a, b, opts, channel) {
    /* eslint max-statements: [2, 100], max-lines-per-function: [2, 120], max-depth: [2, 5], max-lines: [2, 400] */
    var i, key;
    if (typeof a !== typeof b) {
      return false;
    }
    if (a == null || b == null) {
      return false;
    }
    if ($objToString(a) !== $objToString(b)) {
      return false;
    }
    if (isArguments(a) !== isArguments(b)) {
      return false;
    }
    var aIsArray = isArray(a);
    var bIsArray = isArray(b);
    if (aIsArray !== bIsArray) {
      return false;
    }

    // TODO: replace when a cross-realm brand check is available
    var aIsError = a instanceof Error;
    var bIsError = b instanceof Error;
    if (aIsError !== bIsError) {
      return false;
    }
    if (aIsError || bIsError) {
      if (a.name !== b.name || a.message !== b.message) {
        return false;
      }
    }
    var aIsRegex = isRegex(a);
    var bIsRegex = isRegex(b);
    if (aIsRegex !== bIsRegex) {
      return false;
    }
    if ((aIsRegex || bIsRegex) && (a.source !== b.source || flags(a) !== flags(b))) {
      return false;
    }
    var aIsDate = isDate(a);
    var bIsDate = isDate(b);
    if (aIsDate !== bIsDate) {
      return false;
    }
    if (aIsDate || bIsDate) {
      // && would work too, because both are true or both false here
      if ($getTime(a) !== $getTime(b)) {
        return false;
      }
    }
    if (opts.strict && gPO && gPO(a) !== gPO(b)) {
      return false;
    }
    var aWhich = whichTypedArray(a);
    var bWhich = whichTypedArray(b);
    if (aWhich !== bWhich) {
      return false;
    }
    if (aWhich || bWhich) {
      // && would work too, because both are true or both false here
      if (a.length !== b.length) {
        return false;
      }
      for (i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) {
          return false;
        }
      }
      return true;
    }
    var aIsBuffer = isBuffer(a);
    var bIsBuffer = isBuffer(b);
    if (aIsBuffer !== bIsBuffer) {
      return false;
    }
    if (aIsBuffer || bIsBuffer) {
      // && would work too, because both are true or both false here
      if (a.length !== b.length) {
        return false;
      }
      for (i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) {
          return false;
        }
      }
      return true;
    }
    var aIsArrayBuffer = isArrayBuffer(a);
    var bIsArrayBuffer = isArrayBuffer(b);
    if (aIsArrayBuffer !== bIsArrayBuffer) {
      return false;
    }
    if (aIsArrayBuffer || bIsArrayBuffer) {
      // && would work too, because both are true or both false here
      if (byteLength(a) !== byteLength(b)) {
        return false;
      }
      return typeof Uint8Array === 'function' && internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
    }
    var aIsSAB = isSharedArrayBuffer(a);
    var bIsSAB = isSharedArrayBuffer(b);
    if (aIsSAB !== bIsSAB) {
      return false;
    }
    if (aIsSAB || bIsSAB) {
      // && would work too, because both are true or both false here
      if (sabByteLength(a) !== sabByteLength(b)) {
        return false;
      }
      return typeof Uint8Array === 'function' && internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
    }
    if (typeof a !== typeof b) {
      return false;
    }
    var ka = objectKeys(a);
    var kb = objectKeys(b);
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) {
      return false;
    }

    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for (i = ka.length - 1; i >= 0; i--) {
      if (ka[i] != kb[i]) {
        return false;
      } // eslint-disable-line eqeqeq
    }

    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for (i = ka.length - 1; i >= 0; i--) {
      key = ka[i];
      if (!internalDeepEqual(a[key], b[key], opts, channel)) {
        return false;
      }
    }
    var aCollection = whichCollection(a);
    var bCollection = whichCollection(b);
    if (aCollection !== bCollection) {
      return false;
    }
    if (aCollection === 'Set' || bCollection === 'Set') {
      // aCollection === bCollection
      return setEquiv(a, b, opts, channel);
    }
    if (aCollection === 'Map') {
      // aCollection === bCollection
      return mapEquiv(a, b, opts, channel);
    }
    return true;
  }
  deepEqual = function deepEqual(a, b, opts) {
    return internalDeepEqual(a, b, opts, getSideChannel());
  };
  return deepEqual;
}

var hasRequiredElementRoleMap;
function requireElementRoleMap() {
  if (hasRequiredElementRoleMap) return elementRoleMap;
  hasRequiredElementRoleMap = 1;
  Object.defineProperty(elementRoleMap, "__esModule", {
    value: true
  });
  elementRoleMap.default = void 0;
  var _deepEqual = _interopRequireDefault(requireDeepEqual());
  var _iterationDecorator = _interopRequireDefault(requireIterationDecorator());
  var _rolesMap = _interopRequireDefault(requireRolesMap());
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike) {
        if (it) o = it;
        var i = 0;
        var F = function F() {};
        return {
          s: F,
          n: function n() {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function e(_e2) {
            throw _e2;
          },
          f: F
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true,
      didErr = false,
      err;
    return {
      s: function s() {
        it = it.call(o);
      },
      n: function n() {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function e(_e3) {
        didErr = true;
        err = _e3;
      },
      f: function f() {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  var elementRoles = [];
  var keys = _rolesMap.default.keys();
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var role = _rolesMap.default.get(key);
    if (role) {
      var concepts = [].concat(role.baseConcepts, role.relatedConcepts);
      for (var k = 0; k < concepts.length; k++) {
        var relation = concepts[k];
        if (relation.module === 'HTML') {
          var concept = relation.concept;
          if (concept) {
            (function () {
              var conceptStr = JSON.stringify(concept);
              var elementRoleRelation = elementRoles.find(function (relation) {
                return JSON.stringify(relation[0]) === conceptStr;
              });
              var roles = void 0;
              if (elementRoleRelation) {
                roles = elementRoleRelation[1];
              } else {
                roles = [];
              }
              var isUnique = true;
              for (var _i = 0; _i < roles.length; _i++) {
                if (roles[_i] === key) {
                  isUnique = false;
                  break;
                }
              }
              if (isUnique) {
                roles.push(key);
              }
              elementRoles.push([concept, roles]);
            })();
          }
        }
      }
    }
  }
  var elementRoleMap$1 = {
    entries: function entries() {
      return elementRoles;
    },
    forEach: function forEach(fn) {
      var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var _iterator = _createForOfIteratorHelper(elementRoles),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            _key = _step$value[0],
            values = _step$value[1];
          fn.call(thisArg, values, _key, elementRoles);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    get: function get(key) {
      var item = elementRoles.find(function (tuple) {
        return (0, _deepEqual.default)(key, tuple[0]);
      });
      return item && item[1];
    },
    has: function has(key) {
      return !!elementRoleMap$1.get(key);
    },
    keys: function keys() {
      return elementRoles.map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          key = _ref2[0];
        return key;
      });
    },
    values: function values() {
      return elementRoles.map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          values = _ref4[1];
        return values;
      });
    }
  };
  var _default = (0, _iterationDecorator.default)(elementRoleMap$1, elementRoleMap$1.entries());
  elementRoleMap.default = _default;
  return elementRoleMap;
}

var roleElementMap = {};

var hasRequiredRoleElementMap;
function requireRoleElementMap() {
  if (hasRequiredRoleElementMap) return roleElementMap;
  hasRequiredRoleElementMap = 1;
  Object.defineProperty(roleElementMap, "__esModule", {
    value: true
  });
  roleElementMap.default = void 0;
  var _iterationDecorator = _interopRequireDefault(requireIterationDecorator());
  var _rolesMap = _interopRequireDefault(requireRolesMap());
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike) {
        if (it) o = it;
        var i = 0;
        var F = function F() {};
        return {
          s: F,
          n: function n() {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function e(_e2) {
            throw _e2;
          },
          f: F
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true,
      didErr = false,
      err;
    return {
      s: function s() {
        it = it.call(o);
      },
      n: function n() {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function e(_e3) {
        didErr = true;
        err = _e3;
      },
      f: function f() {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  var roleElement = [];
  var keys = _rolesMap.default.keys();
  var _loop = function _loop(i) {
    var key = keys[i];
    var role = _rolesMap.default.get(key);
    if (role) {
      var concepts = [].concat(role.baseConcepts, role.relatedConcepts);
      for (var k = 0; k < concepts.length; k++) {
        var relation = concepts[k];
        if (relation.module === 'HTML') {
          var concept = relation.concept;
          if (concept) {
            var roleElementRelation = roleElement.find(function (item) {
              return item[0] === key;
            });
            var relationConcepts = void 0;
            if (roleElementRelation) {
              relationConcepts = roleElementRelation[1];
            } else {
              relationConcepts = [];
            }
            relationConcepts.push(concept);
            roleElement.push([key, relationConcepts]);
          }
        }
      }
    }
  };
  for (var i = 0; i < keys.length; i++) {
    _loop(i);
  }
  var roleElementMap$1 = {
    entries: function entries() {
      return roleElement;
    },
    forEach: function forEach(fn) {
      var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var _iterator = _createForOfIteratorHelper(roleElement),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            values = _step$value[1];
          fn.call(thisArg, values, key, roleElement);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    get: function get(key) {
      var item = roleElement.find(function (tuple) {
        return tuple[0] === key ? true : false;
      });
      return item && item[1];
    },
    has: function has(key) {
      return !!roleElementMap$1.get(key);
    },
    keys: function keys() {
      return roleElement.map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          key = _ref2[0];
        return key;
      });
    },
    values: function values() {
      return roleElement.map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          values = _ref4[1];
        return values;
      });
    }
  };
  var _default = (0, _iterationDecorator.default)(roleElementMap$1, roleElementMap$1.entries());
  roleElementMap.default = _default;
  return roleElementMap;
}

var hasRequiredLib;
function requireLib() {
  if (hasRequiredLib) return lib;
  hasRequiredLib = 1;
  Object.defineProperty(lib, "__esModule", {
    value: true
  });
  lib.roles = lib.roleElements = lib.elementRoles = lib.dom = lib.aria = void 0;
  var _ariaPropsMap = _interopRequireDefault(requireAriaPropsMap());
  var _domMap = _interopRequireDefault(requireDomMap());
  var _rolesMap = _interopRequireDefault(requireRolesMap());
  var _elementRoleMap = _interopRequireDefault(requireElementRoleMap());
  var _roleElementMap = _interopRequireDefault(requireRoleElementMap());
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var aria = _ariaPropsMap.default;
  lib.aria = aria;
  var dom = _domMap.default;
  lib.dom = dom;
  var roles = _rolesMap.default;
  lib.roles = roles;
  var elementRoles = _elementRoleMap.default;
  lib.elementRoles = elementRoles;
  var roleElements = _roleElementMap.default;
  lib.roleElements = roleElements;
  return lib;
}

var libExports = requireLib();

var lzString$1 = {exports: {}};

var hasRequiredLzString;
function requireLzString() {
  if (hasRequiredLzString) return lzString$1.exports;
  hasRequiredLzString = 1;
  (function (module) {
    // Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
    // This work is free. You can redistribute it and/or modify it
    // under the terms of the WTFPL, Version 2
    // For more information see LICENSE.txt or http://www.wtfpl.net/
    //
    // For more information, the home page:
    // http://pieroxy.net/blog/pages/lz-string/testing.html
    //
    // LZ-based compression algorithm, version 1.4.5
    var LZString = function () {
      // private property
      var f = String.fromCharCode;
      var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
      var baseReverseDic = {};
      function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
          baseReverseDic[alphabet] = {};
          for (var i = 0; i < alphabet.length; i++) {
            baseReverseDic[alphabet][alphabet.charAt(i)] = i;
          }
        }
        return baseReverseDic[alphabet][character];
      }
      var LZString = {
        compressToBase64: function (input) {
          if (input == null) return "";
          var res = LZString._compress(input, 6, function (a) {
            return keyStrBase64.charAt(a);
          });
          switch (res.length % 4) {
            // To produce valid Base64
            default: // When could this happen ?
            case 0:
              return res;
            case 1:
              return res + "===";
            case 2:
              return res + "==";
            case 3:
              return res + "=";
          }
        },
        decompressFromBase64: function (input) {
          if (input == null) return "";
          if (input == "") return null;
          return LZString._decompress(input.length, 32, function (index) {
            return getBaseValue(keyStrBase64, input.charAt(index));
          });
        },
        compressToUTF16: function (input) {
          if (input == null) return "";
          return LZString._compress(input, 15, function (a) {
            return f(a + 32);
          }) + " ";
        },
        decompressFromUTF16: function (compressed) {
          if (compressed == null) return "";
          if (compressed == "") return null;
          return LZString._decompress(compressed.length, 16384, function (index) {
            return compressed.charCodeAt(index) - 32;
          });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function (uncompressed) {
          var compressed = LZString.compress(uncompressed);
          var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character

          for (var i = 0, TotalLen = compressed.length; i < TotalLen; i++) {
            var current_value = compressed.charCodeAt(i);
            buf[i * 2] = current_value >>> 8;
            buf[i * 2 + 1] = current_value % 256;
          }
          return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function (compressed) {
          if (compressed === null || compressed === undefined) {
            return LZString.decompress(compressed);
          } else {
            var buf = new Array(compressed.length / 2); // 2 bytes per character
            for (var i = 0, TotalLen = buf.length; i < TotalLen; i++) {
              buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
            }
            var result = [];
            buf.forEach(function (c) {
              result.push(f(c));
            });
            return LZString.decompress(result.join(''));
          }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function (input) {
          if (input == null) return "";
          return LZString._compress(input, 6, function (a) {
            return keyStrUriSafe.charAt(a);
          });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function (input) {
          if (input == null) return "";
          if (input == "") return null;
          input = input.replace(/ /g, "+");
          return LZString._decompress(input.length, 32, function (index) {
            return getBaseValue(keyStrUriSafe, input.charAt(index));
          });
        },
        compress: function (uncompressed) {
          return LZString._compress(uncompressed, 16, function (a) {
            return f(a);
          });
        },
        _compress: function (uncompressed, bitsPerChar, getCharFromInt) {
          if (uncompressed == null) return "";
          var i,
            value,
            context_dictionary = {},
            context_dictionaryToCreate = {},
            context_c = "",
            context_wc = "",
            context_w = "",
            context_enlargeIn = 2,
            // Compensate for the first entry which should not count
            context_dictSize = 3,
            context_numBits = 2,
            context_data = [],
            context_data_val = 0,
            context_data_position = 0,
            ii;
          for (ii = 0; ii < uncompressed.length; ii += 1) {
            context_c = uncompressed.charAt(ii);
            if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
              context_dictionary[context_c] = context_dictSize++;
              context_dictionaryToCreate[context_c] = true;
            }
            context_wc = context_w + context_c;
            if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) {
              context_w = context_wc;
            } else {
              if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                if (context_w.charCodeAt(0) < 256) {
                  for (i = 0; i < context_numBits; i++) {
                    context_data_val = context_data_val << 1;
                    if (context_data_position == bitsPerChar - 1) {
                      context_data_position = 0;
                      context_data.push(getCharFromInt(context_data_val));
                      context_data_val = 0;
                    } else {
                      context_data_position++;
                    }
                  }
                  value = context_w.charCodeAt(0);
                  for (i = 0; i < 8; i++) {
                    context_data_val = context_data_val << 1 | value & 1;
                    if (context_data_position == bitsPerChar - 1) {
                      context_data_position = 0;
                      context_data.push(getCharFromInt(context_data_val));
                      context_data_val = 0;
                    } else {
                      context_data_position++;
                    }
                    value = value >> 1;
                  }
                } else {
                  value = 1;
                  for (i = 0; i < context_numBits; i++) {
                    context_data_val = context_data_val << 1 | value;
                    if (context_data_position == bitsPerChar - 1) {
                      context_data_position = 0;
                      context_data.push(getCharFromInt(context_data_val));
                      context_data_val = 0;
                    } else {
                      context_data_position++;
                    }
                    value = 0;
                  }
                  value = context_w.charCodeAt(0);
                  for (i = 0; i < 16; i++) {
                    context_data_val = context_data_val << 1 | value & 1;
                    if (context_data_position == bitsPerChar - 1) {
                      context_data_position = 0;
                      context_data.push(getCharFromInt(context_data_val));
                      context_data_val = 0;
                    } else {
                      context_data_position++;
                    }
                    value = value >> 1;
                  }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                  context_enlargeIn = Math.pow(2, context_numBits);
                  context_numBits++;
                }
                delete context_dictionaryToCreate[context_w];
              } else {
                value = context_dictionary[context_w];
                for (i = 0; i < context_numBits; i++) {
                  context_data_val = context_data_val << 1 | value & 1;
                  if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                  value = value >> 1;
                }
              }
              context_enlargeIn--;
              if (context_enlargeIn == 0) {
                context_enlargeIn = Math.pow(2, context_numBits);
                context_numBits++;
              }
              // Add wc to the dictionary.
              context_dictionary[context_wc] = context_dictSize++;
              context_w = String(context_c);
            }
          }

          // Output the code for w.
          if (context_w !== "") {
            if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
              if (context_w.charCodeAt(0) < 256) {
                for (i = 0; i < context_numBits; i++) {
                  context_data_val = context_data_val << 1;
                  if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                }
                value = context_w.charCodeAt(0);
                for (i = 0; i < 8; i++) {
                  context_data_val = context_data_val << 1 | value & 1;
                  if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                  value = value >> 1;
                }
              } else {
                value = 1;
                for (i = 0; i < context_numBits; i++) {
                  context_data_val = context_data_val << 1 | value;
                  if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                  value = 0;
                }
                value = context_w.charCodeAt(0);
                for (i = 0; i < 16; i++) {
                  context_data_val = context_data_val << 1 | value & 1;
                  if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                  value = value >> 1;
                }
              }
              context_enlargeIn--;
              if (context_enlargeIn == 0) {
                context_enlargeIn = Math.pow(2, context_numBits);
                context_numBits++;
              }
              delete context_dictionaryToCreate[context_w];
            } else {
              value = context_dictionary[context_w];
              for (i = 0; i < context_numBits; i++) {
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                  context_data_position = 0;
                  context_data.push(getCharFromInt(context_data_val));
                  context_data_val = 0;
                } else {
                  context_data_position++;
                }
                value = value >> 1;
              }
            }
            context_enlargeIn--;
            if (context_enlargeIn == 0) {
              context_enlargeIn = Math.pow(2, context_numBits);
              context_numBits++;
            }
          }

          // Mark the end of the stream
          value = 2;
          for (i = 0; i < context_numBits; i++) {
            context_data_val = context_data_val << 1 | value & 1;
            if (context_data_position == bitsPerChar - 1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }

          // Flush the last char
          while (true) {
            context_data_val = context_data_val << 1;
            if (context_data_position == bitsPerChar - 1) {
              context_data.push(getCharFromInt(context_data_val));
              break;
            } else context_data_position++;
          }
          return context_data.join('');
        },
        decompress: function (compressed) {
          if (compressed == null) return "";
          if (compressed == "") return null;
          return LZString._decompress(compressed.length, 32768, function (index) {
            return compressed.charCodeAt(index);
          });
        },
        _decompress: function (length, resetValue, getNextValue) {
          var dictionary = [],
            enlargeIn = 4,
            dictSize = 4,
            numBits = 3,
            entry = "",
            result = [],
            i,
            w,
            bits,
            resb,
            maxpower,
            power,
            c,
            data = {
              val: getNextValue(0),
              position: resetValue,
              index: 1
            };
          for (i = 0; i < 3; i += 1) {
            dictionary[i] = i;
          }
          bits = 0;
          maxpower = Math.pow(2, 2);
          power = 1;
          while (power != maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb > 0 ? 1 : 0) * power;
            power <<= 1;
          }
          switch (bits) {
            case 0:
              bits = 0;
              maxpower = Math.pow(2, 8);
              power = 1;
              while (power != maxpower) {
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                  data.position = resetValue;
                  data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
              }
              c = f(bits);
              break;
            case 1:
              bits = 0;
              maxpower = Math.pow(2, 16);
              power = 1;
              while (power != maxpower) {
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                  data.position = resetValue;
                  data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
              }
              c = f(bits);
              break;
            case 2:
              return "";
          }
          dictionary[3] = c;
          w = c;
          result.push(c);
          while (true) {
            if (data.index > length) {
              return "";
            }
            bits = 0;
            maxpower = Math.pow(2, numBits);
            power = 1;
            while (power != maxpower) {
              resb = data.val & data.position;
              data.position >>= 1;
              if (data.position == 0) {
                data.position = resetValue;
                data.val = getNextValue(data.index++);
              }
              bits |= (resb > 0 ? 1 : 0) * power;
              power <<= 1;
            }
            switch (c = bits) {
              case 0:
                bits = 0;
                maxpower = Math.pow(2, 8);
                power = 1;
                while (power != maxpower) {
                  resb = data.val & data.position;
                  data.position >>= 1;
                  if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                  }
                  bits |= (resb > 0 ? 1 : 0) * power;
                  power <<= 1;
                }
                dictionary[dictSize++] = f(bits);
                c = dictSize - 1;
                enlargeIn--;
                break;
              case 1:
                bits = 0;
                maxpower = Math.pow(2, 16);
                power = 1;
                while (power != maxpower) {
                  resb = data.val & data.position;
                  data.position >>= 1;
                  if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                  }
                  bits |= (resb > 0 ? 1 : 0) * power;
                  power <<= 1;
                }
                dictionary[dictSize++] = f(bits);
                c = dictSize - 1;
                enlargeIn--;
                break;
              case 2:
                return result.join('');
            }
            if (enlargeIn == 0) {
              enlargeIn = Math.pow(2, numBits);
              numBits++;
            }
            if (dictionary[c]) {
              entry = dictionary[c];
            } else {
              if (c === dictSize) {
                entry = w + w.charAt(0);
              } else {
                return null;
              }
            }
            result.push(entry);

            // Add w+entry[0] to the dictionary.
            dictionary[dictSize++] = w + entry.charAt(0);
            enlargeIn--;
            w = entry;
            if (enlargeIn == 0) {
              enlargeIn = Math.pow(2, numBits);
              numBits++;
            }
          }
        }
      };
      return LZString;
    }();
    if (module != null) {
      module.exports = LZString;
    } else if (typeof angular !== 'undefined' && angular != null) {
      angular.module('LZString', []).factory('LZString', function () {
        return LZString;
      });
    }
  })(lzString$1);
  return lzString$1.exports;
}

var lzStringExports = requireLzString();
var lzString = /*@__PURE__*/getDefaultExportFromCjs(lzStringExports);

/**
 * Source: https://github.com/facebook/jest/blob/e7bb6a1e26ffab90611b2593912df15b69315611/packages/pretty-format/src/plugins/DOMElement.ts
 */
/* eslint-disable -- trying to stay as close to the original as possible */
/* istanbul ignore file */

function escapeHTML(str) {
  return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
// Return empty string if keys is empty.
const printProps = (keys, props, config, indentation, depth, refs, printer) => {
  const indentationNext = indentation + config.indent;
  const colors = config.colors;
  return keys.map(key => {
    const value = props[key];
    let printed = printer(value, config, indentationNext, depth, refs);
    if (typeof value !== 'string') {
      if (printed.indexOf('\n') !== -1) {
        printed = config.spacingOuter + indentationNext + printed + config.spacingOuter + indentation;
      }
      printed = '{' + printed + '}';
    }
    return config.spacingInner + indentation + colors.prop.open + key + colors.prop.close + '=' + colors.value.open + printed + colors.value.close;
  }).join('');
};

// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#node_type_constants
const NodeTypeTextNode = 3;

// Return empty string if children is empty.
const printChildren = (children, config, indentation, depth, refs, printer) => children.map(child => {
  const printedChild = typeof child === 'string' ? printText(child, config) : printer(child, config, indentation, depth, refs);
  if (printedChild === '' && typeof child === 'object' && child !== null && child.nodeType !== NodeTypeTextNode) {
    // A plugin serialized this Node to '' meaning we should ignore it.
    return '';
  }
  return config.spacingOuter + indentation + printedChild;
}).join('');
const printText = (text, config) => {
  const contentColor = config.colors.content;
  return contentColor.open + escapeHTML(text) + contentColor.close;
};
const printComment = (comment, config) => {
  const commentColor = config.colors.comment;
  return commentColor.open + '<!--' + escapeHTML(comment) + '-->' + commentColor.close;
};

// Separate the functions to format props, children, and element,
// so a plugin could override a particular function, if needed.
// Too bad, so sad: the traditional (but unnecessary) space
// in a self-closing tagColor requires a second test of printedProps.
const printElement = (type, printedProps, printedChildren, config, indentation) => {
  const tagColor = config.colors.tag;
  return tagColor.open + '<' + type + (printedProps && tagColor.close + printedProps + config.spacingOuter + indentation + tagColor.open) + (printedChildren ? '>' + tagColor.close + printedChildren + config.spacingOuter + indentation + tagColor.open + '</' + type : (printedProps && !config.min ? '' : ' ') + '/') + '>' + tagColor.close;
};
const printElementAsLeaf = (type, config) => {
  const tagColor = config.colors.tag;
  return tagColor.open + '<' + type + tagColor.close + ' …' + tagColor.open + ' />' + tagColor.close;
};
const ELEMENT_NODE$1 = 1;
const TEXT_NODE$1 = 3;
const COMMENT_NODE$1 = 8;
const FRAGMENT_NODE = 11;
const ELEMENT_REGEXP = /^((HTML|SVG)\w*)?Element$/;
const testNode = val => {
  const constructorName = val.constructor.name;
  const {
    nodeType,
    tagName
  } = val;
  const isCustomElement = typeof tagName === 'string' && tagName.includes('-') || typeof val.hasAttribute === 'function' && val.hasAttribute('is');
  return nodeType === ELEMENT_NODE$1 && (ELEMENT_REGEXP.test(constructorName) || isCustomElement) || nodeType === TEXT_NODE$1 && constructorName === 'Text' || nodeType === COMMENT_NODE$1 && constructorName === 'Comment' || nodeType === FRAGMENT_NODE && constructorName === 'DocumentFragment';
};
function nodeIsText(node) {
  return node.nodeType === TEXT_NODE$1;
}
function nodeIsComment(node) {
  return node.nodeType === COMMENT_NODE$1;
}
function nodeIsFragment(node) {
  return node.nodeType === FRAGMENT_NODE;
}
function createDOMElementFilter(filterNode) {
  return {
    test: val => {
      var _val$constructor2;
      return (val == null ? void 0 : (_val$constructor2 = val.constructor) == null ? void 0 : _val$constructor2.name) && testNode(val);
    },
    serialize: (node, config, indentation, depth, refs, printer) => {
      if (nodeIsText(node)) {
        return printText(node.data, config);
      }
      if (nodeIsComment(node)) {
        return printComment(node.data, config);
      }
      const type = nodeIsFragment(node) ? "DocumentFragment" : node.tagName.toLowerCase();
      if (++depth > config.maxDepth) {
        return printElementAsLeaf(type, config);
      }
      return printElement(type, printProps(nodeIsFragment(node) ? [] : Array.from(node.attributes).map(attr => attr.name).sort(), nodeIsFragment(node) ? {} : Array.from(node.attributes).reduce((props, attribute) => {
        props[attribute.name] = attribute.value;
        return props;
      }, {}), config, indentation + config.indent, depth, refs, printer), printChildren(Array.prototype.slice.call(node.childNodes || node.children).filter(filterNode), config, indentation + config.indent, depth, refs, printer), config, indentation);
    }
  };
}

// We try to load node dependencies
let chalk = null;
let readFileSync = null;
let codeFrameColumns = null;
try {
  const nodeRequire = module && module.require;
  readFileSync = nodeRequire.call(module, 'fs').readFileSync;
  codeFrameColumns = nodeRequire.call(module, '@babel/code-frame').codeFrameColumns;
  chalk = nodeRequire.call(module, 'chalk');
} catch {
  // We're in a browser environment
}

// frame has the form "at myMethod (location/to/my/file.js:10:2)"
function getCodeFrame(frame) {
  const locationStart = frame.indexOf('(') + 1;
  const locationEnd = frame.indexOf(')');
  const frameLocation = frame.slice(locationStart, locationEnd);
  const frameLocationElements = frameLocation.split(':');
  const [filename, line, column] = [frameLocationElements[0], parseInt(frameLocationElements[1], 10), parseInt(frameLocationElements[2], 10)];
  let rawFileContents = '';
  try {
    rawFileContents = readFileSync(filename, 'utf-8');
  } catch {
    return '';
  }
  const codeFrame = codeFrameColumns(rawFileContents, {
    start: {
      line,
      column
    }
  }, {
    highlightCode: true,
    linesBelow: 0
  });
  return chalk.dim(frameLocation) + "\n" + codeFrame + "\n";
}
function getUserCodeFrame() {
  // If we couldn't load dependencies, we can't generate the user trace
  /* istanbul ignore next */
  if (!readFileSync || !codeFrameColumns) {
    return '';
  }
  const err = new Error();
  const firstClientCodeFrame = err.stack.split('\n').slice(1) // Remove first line which has the form "Error: TypeError"
  .find(frame => !frame.includes('node_modules/')); // Ignore frames from 3rd party libraries

  return getCodeFrame(firstClientCodeFrame);
}

// Constant node.nodeType for text nodes, see:
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#Node_type_constants
const TEXT_NODE = 3;
function jestFakeTimersAreEnabled() {
  /* istanbul ignore else */
  // eslint-disable-next-line
  if (typeof jest !== 'undefined' && jest !== null) {
    return (
      // legacy timers
      setTimeout._isMockFunction === true ||
      // modern timers
      Object.prototype.hasOwnProperty.call(setTimeout, 'clock')
    );
  }
  // istanbul ignore next
  return false;
}
function getDocument() {
  /* istanbul ignore if */
  if (typeof window === 'undefined') {
    throw new Error('Could not find default container');
  }
  return window.document;
}
function getWindowFromNode(node) {
  if (node.defaultView) {
    // node is document
    return node.defaultView;
  } else if (node.ownerDocument && node.ownerDocument.defaultView) {
    // node is a DOM node
    return node.ownerDocument.defaultView;
  } else if (node.window) {
    // node is window
    return node.window;
  } else if (node.ownerDocument && node.ownerDocument.defaultView === null) {
    throw new Error("It looks like the window object is not available for the provided node.");
  } else if (node.then instanceof Function) {
    throw new Error("It looks like you passed a Promise object instead of a DOM node. Did you do something like `fireEvent.click(screen.findBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`, or await the findBy query `fireEvent.click(await screen.findBy...`?");
  } else if (Array.isArray(node)) {
    throw new Error("It looks like you passed an Array instead of a DOM node. Did you do something like `fireEvent.click(screen.getAllBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`?");
  } else if (typeof node.debug === 'function' && typeof node.logTestingPlaygroundURL === 'function') {
    throw new Error("It looks like you passed a `screen` object. Did you do something like `fireEvent.click(screen, ...` when you meant to use a query, e.g. `fireEvent.click(screen.getBy..., `?");
  } else {
    // The user passed something unusual to a calling function
    throw new Error("The given node is not an Element, the node type is: " + typeof node + ".");
  }
}
function checkContainerType(container) {
  if (!container || !(typeof container.querySelector === 'function') || !(typeof container.querySelectorAll === 'function')) {
    throw new TypeError("Expected container to be an Element, a Document or a DocumentFragment but got " + getTypeName(container) + ".");
  }
  function getTypeName(object) {
    if (typeof object === 'object') {
      return object === null ? 'null' : object.constructor.name;
    }
    return typeof object;
  }
}
const shouldHighlight = () => {
  let colors;
  try {
    var _process, _process$env;
    colors = JSON.parse((_process = process) == null ? void 0 : (_process$env = _process.env) == null ? void 0 : _process$env.COLORS);
  } catch (e) {
    // If this throws, process?.env?.COLORS wasn't parsable. Since we only
    // care about `true` or `false`, we can safely ignore the error.
  }
  if (typeof colors === 'boolean') {
    // If `colors` is set explicitly (both `true` and `false`), use that value.
    return colors;
  } else {
    // If `colors` is not set, colorize if we're in node.
    return typeof process !== 'undefined' && process.versions !== undefined && process.versions.node !== undefined;
  }
};
const {
  DOMCollection
} = buildExports.plugins;

// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#node_type_constants
const ELEMENT_NODE = 1;
const COMMENT_NODE = 8;

// https://github.com/facebook/jest/blob/615084195ae1ae61ddd56162c62bbdda17587569/packages/pretty-format/src/plugins/DOMElement.ts#L50
function filterCommentsAndDefaultIgnoreTagsTags(value) {
  return value.nodeType !== COMMENT_NODE && (value.nodeType !== ELEMENT_NODE || !value.matches(getConfig().defaultIgnore));
}
function prettyDOM(dom, maxLength, options) {
  if (options === void 0) {
    options = {};
  }
  if (!dom) {
    dom = getDocument().body;
  }
  if (typeof maxLength !== 'number') {
    maxLength = typeof process !== 'undefined' && process.env.DEBUG_PRINT_LIMIT || 7000;
  }
  if (maxLength === 0) {
    return '';
  }
  if (dom.documentElement) {
    dom = dom.documentElement;
  }
  let domTypeName = typeof dom;
  if (domTypeName === 'object') {
    domTypeName = dom.constructor.name;
  } else {
    // To don't fall with `in` operator
    dom = {};
  }
  if (!('outerHTML' in dom)) {
    throw new TypeError("Expected an element or document but got " + domTypeName);
  }
  const {
    filterNode = filterCommentsAndDefaultIgnoreTagsTags,
    ...prettyFormatOptions
  } = options;
  const debugContent = buildExports.format(dom, {
    plugins: [createDOMElementFilter(filterNode), DOMCollection],
    printFunctionName: false,
    highlight: shouldHighlight(),
    ...prettyFormatOptions
  });
  return maxLength !== undefined && dom.outerHTML.length > maxLength ? debugContent.slice(0, maxLength) + "..." : debugContent;
}
const logDOM = function () {
  const userCodeFrame = getUserCodeFrame();
  if (userCodeFrame) {
    console.log(prettyDOM(...arguments) + "\n\n" + userCodeFrame);
  } else {
    console.log(prettyDOM(...arguments));
  }
};

// It would be cleaner for this to live inside './queries', but
// other parts of the code assume that all exports from
// './queries' are query functions.
let config = {
  testIdAttribute: 'data-testid',
  asyncUtilTimeout: 1000,
  // asyncWrapper and advanceTimersWrapper is to support React's async `act` function.
  // forcing react-testing-library to wrap all async functions would've been
  // a total nightmare (consider wrapping every findBy* query and then also
  // updating `within` so those would be wrapped too. Total nightmare).
  // so we have this config option that's really only intended for
  // react-testing-library to use. For that reason, this feature will remain
  // undocumented.
  asyncWrapper: cb => cb(),
  unstable_advanceTimersWrapper: cb => cb(),
  eventWrapper: cb => cb(),
  // default value for the `hidden` option in `ByRole` queries
  defaultHidden: false,
  // default value for the `ignore` option in `ByText` queries
  defaultIgnore: 'script, style',
  // showOriginalStackTrace flag to show the full error stack traces for async errors
  showOriginalStackTrace: false,
  // throw errors w/ suggestions for better queries. Opt in so off by default.
  throwSuggestions: false,
  // called when getBy* queries fail. (message, container) => Error
  getElementError(message, container) {
    const prettifiedDOM = prettyDOM(container);
    const error = new Error([message, "Ignored nodes: comments, " + config.defaultIgnore + "\n" + prettifiedDOM].filter(Boolean).join('\n\n'));
    error.name = 'TestingLibraryElementError';
    return error;
  },
  _disableExpensiveErrorDiagnostics: false,
  computedStyleSupportsPseudoElements: false
};
function runWithExpensiveErrorDiagnosticsDisabled(callback) {
  try {
    config._disableExpensiveErrorDiagnostics = true;
    return callback();
  } finally {
    config._disableExpensiveErrorDiagnostics = false;
  }
}
function configure(newConfig) {
  if (typeof newConfig === 'function') {
    // Pass the existing config out to the provided function
    // and accept a delta in return
    newConfig = newConfig(config);
  }

  // Merge the incoming config delta
  config = {
    ...config,
    ...newConfig
  };
}
function getConfig() {
  return config;
}
const labelledNodeNames = ['button', 'meter', 'output', 'progress', 'select', 'textarea', 'input'];
function getTextContent(node) {
  if (labelledNodeNames.includes(node.nodeName.toLowerCase())) {
    return '';
  }
  if (node.nodeType === TEXT_NODE) return node.textContent;
  return Array.from(node.childNodes).map(childNode => getTextContent(childNode)).join('');
}
function getLabelContent(element) {
  let textContent;
  if (element.tagName.toLowerCase() === 'label') {
    textContent = getTextContent(element);
  } else {
    textContent = element.value || element.textContent;
  }
  return textContent;
}

// Based on https://github.com/eps1lon/dom-accessibility-api/pull/352
function getRealLabels(element) {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- types are not aware of older browsers that don't implement `labels`
  if (element.labels !== undefined) {
    var _labels;
    return (_labels = element.labels) != null ? _labels : [];
  }
  if (!isLabelable(element)) return [];
  const labels = element.ownerDocument.querySelectorAll('label');
  return Array.from(labels).filter(label => label.control === element);
}
function isLabelable(element) {
  return /BUTTON|METER|OUTPUT|PROGRESS|SELECT|TEXTAREA/.test(element.tagName) || element.tagName === 'INPUT' && element.getAttribute('type') !== 'hidden';
}
function getLabels(container, element, _temp) {
  let {
    selector = '*'
  } = _temp === void 0 ? {} : _temp;
  const ariaLabelledBy = element.getAttribute('aria-labelledby');
  const labelsId = ariaLabelledBy ? ariaLabelledBy.split(' ') : [];
  return labelsId.length ? labelsId.map(labelId => {
    const labellingElement = container.querySelector("[id=\"" + labelId + "\"]");
    return labellingElement ? {
      content: getLabelContent(labellingElement),
      formControl: null
    } : {
      content: '',
      formControl: null
    };
  }) : Array.from(getRealLabels(element)).map(label => {
    const textToMatch = getLabelContent(label);
    const formControlSelector = 'button, input, meter, output, progress, select, textarea';
    const labelledFormControl = Array.from(label.querySelectorAll(formControlSelector)).filter(formControlElement => formControlElement.matches(selector))[0];
    return {
      content: textToMatch,
      formControl: labelledFormControl
    };
  });
}
function assertNotNullOrUndefined(matcher) {
  if (matcher === null || matcher === undefined) {
    throw new Error(
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- implicitly converting `T` to `string`
    "It looks like " + matcher + " was passed instead of a matcher. Did you do something like getByText(" + matcher + ")?");
  }
}
function fuzzyMatches(textToMatch, node, matcher, normalizer) {
  if (typeof textToMatch !== 'string') {
    return false;
  }
  assertNotNullOrUndefined(matcher);
  const normalizedText = normalizer(textToMatch);
  if (typeof matcher === 'string' || typeof matcher === 'number') {
    return normalizedText.toLowerCase().includes(matcher.toString().toLowerCase());
  } else if (typeof matcher === 'function') {
    return matcher(normalizedText, node);
  } else {
    return matchRegExp(matcher, normalizedText);
  }
}
function matches(textToMatch, node, matcher, normalizer) {
  if (typeof textToMatch !== 'string') {
    return false;
  }
  assertNotNullOrUndefined(matcher);
  const normalizedText = normalizer(textToMatch);
  if (matcher instanceof Function) {
    return matcher(normalizedText, node);
  } else if (matcher instanceof RegExp) {
    return matchRegExp(matcher, normalizedText);
  } else {
    return normalizedText === String(matcher);
  }
}
function getDefaultNormalizer(_temp) {
  let {
    trim = true,
    collapseWhitespace = true
  } = _temp === void 0 ? {} : _temp;
  return text => {
    let normalizedText = text;
    normalizedText = trim ? normalizedText.trim() : normalizedText;
    normalizedText = collapseWhitespace ? normalizedText.replace(/\s+/g, ' ') : normalizedText;
    return normalizedText;
  };
}

/**
 * Constructs a normalizer to pass to functions in matches.js
 * @param {boolean|undefined} trim The user-specified value for `trim`, without
 * any defaulting having been applied
 * @param {boolean|undefined} collapseWhitespace The user-specified value for
 * `collapseWhitespace`, without any defaulting having been applied
 * @param {Function|undefined} normalizer The user-specified normalizer
 * @returns {Function} A normalizer
 */

function makeNormalizer(_ref) {
  let {
    trim,
    collapseWhitespace,
    normalizer
  } = _ref;
  if (!normalizer) {
    // No custom normalizer specified. Just use default.
    return getDefaultNormalizer({
      trim,
      collapseWhitespace
    });
  }
  if (typeof trim !== 'undefined' || typeof collapseWhitespace !== 'undefined') {
    // They've also specified a value for trim or collapseWhitespace
    throw new Error('trim and collapseWhitespace are not supported with a normalizer. ' + 'If you want to use the default trim and collapseWhitespace logic in your normalizer, ' + 'use "getDefaultNormalizer({trim, collapseWhitespace})" and compose that into your normalizer');
  }
  return normalizer;
}
function matchRegExp(matcher, text) {
  const match = matcher.test(text);
  if (matcher.global && matcher.lastIndex !== 0) {
    console.warn("To match all elements we had to reset the lastIndex of the RegExp because the global flag is enabled. We encourage to remove the global flag from the RegExp.");
    matcher.lastIndex = 0;
  }
  return match;
}
function getNodeText(node) {
  if (node.matches('input[type=submit], input[type=button], input[type=reset]')) {
    return node.value;
  }
  return Array.from(node.childNodes).filter(child => child.nodeType === TEXT_NODE && Boolean(child.textContent)).map(c => c.textContent).join('');
}
const elementRoleList = buildElementRoleList(libExports.elementRoles);

/**
 * @param {Element} element -
 * @returns {boolean} - `true` if `element` and its subtree are inaccessible
 */
function isSubtreeInaccessible(element) {
  if (element.hidden === true) {
    return true;
  }
  if (element.getAttribute('aria-hidden') === 'true') {
    return true;
  }
  const window = element.ownerDocument.defaultView;
  if (window.getComputedStyle(element).display === 'none') {
    return true;
  }
  return false;
}

/**
 * Partial implementation https://www.w3.org/TR/wai-aria-1.2/#tree_exclusion
 * which should only be used for elements with a non-presentational role i.e.
 * `role="none"` and `role="presentation"` will not be excluded.
 *
 * Implements aria-hidden semantics (i.e. parent overrides child)
 * Ignores "Child Presentational: True" characteristics
 *
 * @param {Element} element -
 * @param {object} [options] -
 * @param {function (element: Element): boolean} options.isSubtreeInaccessible -
 * can be used to return cached results from previous isSubtreeInaccessible calls
 * @returns {boolean} true if excluded, otherwise false
 */
function isInaccessible(element, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    isSubtreeInaccessible: isSubtreeInaccessibleImpl = isSubtreeInaccessible
  } = options;
  const window = element.ownerDocument.defaultView;
  // since visibility is inherited we can exit early
  if (window.getComputedStyle(element).visibility === 'hidden') {
    return true;
  }
  let currentElement = element;
  while (currentElement) {
    if (isSubtreeInaccessibleImpl(currentElement)) {
      return true;
    }
    currentElement = currentElement.parentElement;
  }
  return false;
}
function getImplicitAriaRoles(currentNode) {
  // eslint bug here:
  // eslint-disable-next-line no-unused-vars
  for (const {
    match,
    roles
  } of elementRoleList) {
    if (match(currentNode)) {
      return [...roles];
    }
  }
  return [];
}
function buildElementRoleList(elementRolesMap) {
  function makeElementSelector(_ref) {
    let {
      name,
      attributes
    } = _ref;
    return "" + name + attributes.map(_ref2 => {
      let {
        name: attributeName,
        value,
        constraints = []
      } = _ref2;
      const shouldNotExist = constraints.indexOf('undefined') !== -1;
      if (shouldNotExist) {
        return ":not([" + attributeName + "])";
      } else if (value) {
        return "[" + attributeName + "=\"" + value + "\"]";
      } else {
        return "[" + attributeName + "]";
      }
    }).join('');
  }
  function getSelectorSpecificity(_ref3) {
    let {
      attributes = []
    } = _ref3;
    return attributes.length;
  }
  function bySelectorSpecificity(_ref4, _ref5) {
    let {
      specificity: leftSpecificity
    } = _ref4;
    let {
      specificity: rightSpecificity
    } = _ref5;
    return rightSpecificity - leftSpecificity;
  }
  function match(element) {
    let {
      attributes = []
    } = element;

    // https://github.com/testing-library/dom-testing-library/issues/814
    const typeTextIndex = attributes.findIndex(attribute => attribute.value && attribute.name === 'type' && attribute.value === 'text');
    if (typeTextIndex >= 0) {
      // not using splice to not mutate the attributes array
      attributes = [...attributes.slice(0, typeTextIndex), ...attributes.slice(typeTextIndex + 1)];
    }
    const selector = makeElementSelector({
      ...element,
      attributes
    });
    return node => {
      if (typeTextIndex >= 0 && node.type !== 'text') {
        return false;
      }
      return node.matches(selector);
    };
  }
  let result = [];

  // eslint bug here:
  // eslint-disable-next-line no-unused-vars
  for (const [element, roles] of elementRolesMap.entries()) {
    result = [...result, {
      match: match(element),
      roles: Array.from(roles),
      specificity: getSelectorSpecificity(element)
    }];
  }
  return result.sort(bySelectorSpecificity);
}
function getRoles(container, _temp) {
  let {
    hidden = false
  } = _temp === void 0 ? {} : _temp;
  function flattenDOM(node) {
    return [node, ...Array.from(node.children).reduce((acc, child) => [...acc, ...flattenDOM(child)], [])];
  }
  return flattenDOM(container).filter(element => {
    return hidden === false ? isInaccessible(element) === false : true;
  }).reduce((acc, node) => {
    let roles = [];
    // TODO: This violates html-aria which does not allow any role on every element
    if (node.hasAttribute('role')) {
      roles = node.getAttribute('role').split(' ').slice(0, 1);
    } else {
      roles = getImplicitAriaRoles(node);
    }
    return roles.reduce((rolesAcc, role) => Array.isArray(rolesAcc[role]) ? {
      ...rolesAcc,
      [role]: [...rolesAcc[role], node]
    } : {
      ...rolesAcc,
      [role]: [node]
    }, acc);
  }, {});
}
function prettyRoles(dom, _ref6) {
  let {
    hidden,
    includeDescription
  } = _ref6;
  const roles = getRoles(dom, {
    hidden
  });
  // We prefer to skip generic role, we don't recommend it
  return Object.entries(roles).filter(_ref7 => {
    let [role] = _ref7;
    return role !== 'generic';
  }).map(_ref8 => {
    let [role, elements] = _ref8;
    const delimiterBar = '-'.repeat(50);
    const elementsString = elements.map(el => {
      const nameString = "Name \"" + computeAccessibleName(el, {
        computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
      }) + "\":\n";
      const domString = prettyDOM(el.cloneNode(false));
      if (includeDescription) {
        const descriptionString = "Description \"" + computeAccessibleDescription(el, {
          computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
        }) + "\":\n";
        return "" + nameString + descriptionString + domString;
      }
      return "" + nameString + domString;
    }).join('\n\n');
    return role + ":\n\n" + elementsString + "\n\n" + delimiterBar;
  }).join('\n');
}

/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)selected, undefined if not selectable
 */
function computeAriaSelected(element) {
  // implicit value from html-aam mappings: https://www.w3.org/TR/html-aam-1.0/#html-attribute-state-and-property-mappings
  // https://www.w3.org/TR/html-aam-1.0/#details-id-97
  if (element.tagName === 'OPTION') {
    return element.selected;
  }

  // explicit value
  return checkBooleanAttribute(element, 'aria-selected');
}

/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)checked, undefined if not checked-able
 */
function computeAriaChecked(element) {
  // implicit value from html-aam mappings: https://www.w3.org/TR/html-aam-1.0/#html-attribute-state-and-property-mappings
  // https://www.w3.org/TR/html-aam-1.0/#details-id-56
  // https://www.w3.org/TR/html-aam-1.0/#details-id-67
  if ('indeterminate' in element && element.indeterminate) {
    return undefined;
  }
  if ('checked' in element) {
    return element.checked;
  }

  // explicit value
  return checkBooleanAttribute(element, 'aria-checked');
}

/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)pressed, undefined if not press-able
 */
function computeAriaPressed(element) {
  // https://www.w3.org/TR/wai-aria-1.1/#aria-pressed
  return checkBooleanAttribute(element, 'aria-pressed');
}

/**
 * @param {Element} element -
 * @returns {boolean | string | null} -
 */
function computeAriaCurrent(element) {
  var _ref9, _checkBooleanAttribut;
  // https://www.w3.org/TR/wai-aria-1.1/#aria-current
  return (_ref9 = (_checkBooleanAttribut = checkBooleanAttribute(element, 'aria-current')) != null ? _checkBooleanAttribut : element.getAttribute('aria-current')) != null ? _ref9 : false;
}

/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)expanded, undefined if not expand-able
 */
function computeAriaExpanded(element) {
  // https://www.w3.org/TR/wai-aria-1.1/#aria-expanded
  return checkBooleanAttribute(element, 'aria-expanded');
}
function checkBooleanAttribute(element, attribute) {
  const attributeValue = element.getAttribute(attribute);
  if (attributeValue === 'true') {
    return true;
  }
  if (attributeValue === 'false') {
    return false;
  }
  return undefined;
}

/**
 * @param {Element} element -
 * @returns {number | undefined} - number if implicit heading or aria-level present, otherwise undefined
 */
function computeHeadingLevel(element) {
  // https://w3c.github.io/html-aam/#el-h1-h6
  // https://w3c.github.io/html-aam/#el-h1-h6
  const implicitHeadingLevels = {
    H1: 1,
    H2: 2,
    H3: 3,
    H4: 4,
    H5: 5,
    H6: 6
  };
  // explicit aria-level value
  // https://www.w3.org/TR/wai-aria-1.2/#aria-level
  const ariaLevelAttribute = element.getAttribute('aria-level') && Number(element.getAttribute('aria-level'));
  return ariaLevelAttribute || implicitHeadingLevels[element.tagName];
}
const normalize = getDefaultNormalizer();
function escapeRegExp(string) {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
function getRegExpMatcher(string) {
  return new RegExp(escapeRegExp(string.toLowerCase()), 'i');
}
function makeSuggestion(queryName, element, content, _ref) {
  let {
    variant,
    name
  } = _ref;
  let warning = '';
  const queryOptions = {};
  const queryArgs = [['Role', 'TestId'].includes(queryName) ? content : getRegExpMatcher(content)];
  if (name) {
    queryOptions.name = getRegExpMatcher(name);
  }
  if (queryName === 'Role' && isInaccessible(element)) {
    queryOptions.hidden = true;
    warning = "Element is inaccessible. This means that the element and all its children are invisible to screen readers.\n    If you are using the aria-hidden prop, make sure this is the right choice for your case.\n    ";
  }
  if (Object.keys(queryOptions).length > 0) {
    queryArgs.push(queryOptions);
  }
  const queryMethod = variant + "By" + queryName;
  return {
    queryName,
    queryMethod,
    queryArgs,
    variant,
    warning,
    toString() {
      if (warning) {
        console.warn(warning);
      }
      let [text, options] = queryArgs;
      text = typeof text === 'string' ? "'" + text + "'" : text;
      options = options ? ", { " + Object.entries(options).map(_ref2 => {
        let [k, v] = _ref2;
        return k + ": " + v;
      }).join(', ') + " }" : '';
      return queryMethod + "(" + text + options + ")";
    }
  };
}
function canSuggest(currentMethod, requestedMethod, data) {
  return data && (true);
}
function getSuggestedQuery(element, variant, method) {
  var _element$getAttribute, _getImplicitAriaRoles;
  if (variant === void 0) {
    variant = 'get';
  }
  // don't create suggestions for script and style elements
  if (element.matches(getConfig().defaultIgnore)) {
    return undefined;
  }

  //We prefer to suggest something else if the role is generic
  const role = (_element$getAttribute = element.getAttribute('role')) != null ? _element$getAttribute : (_getImplicitAriaRoles = getImplicitAriaRoles(element)) == null ? void 0 : _getImplicitAriaRoles[0];
  if (role !== 'generic' && canSuggest('Role', method, role)) {
    return makeSuggestion('Role', element, role, {
      variant,
      name: computeAccessibleName(element, {
        computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
      })
    });
  }
  const labelText = getLabels(document, element).map(label => label.content).join(' ');
  if (canSuggest('LabelText', method, labelText)) {
    return makeSuggestion('LabelText', element, labelText, {
      variant
    });
  }
  const placeholderText = element.getAttribute('placeholder');
  if (canSuggest('PlaceholderText', method, placeholderText)) {
    return makeSuggestion('PlaceholderText', element, placeholderText, {
      variant
    });
  }
  const textContent = normalize(getNodeText(element));
  if (canSuggest('Text', method, textContent)) {
    return makeSuggestion('Text', element, textContent, {
      variant
    });
  }
  if (canSuggest('DisplayValue', method, element.value)) {
    return makeSuggestion('DisplayValue', element, normalize(element.value), {
      variant
    });
  }
  const alt = element.getAttribute('alt');
  if (canSuggest('AltText', method, alt)) {
    return makeSuggestion('AltText', element, alt, {
      variant
    });
  }
  const title = element.getAttribute('title');
  if (canSuggest('Title', method, title)) {
    return makeSuggestion('Title', element, title, {
      variant
    });
  }
  const testId = element.getAttribute(getConfig().testIdAttribute);
  if (canSuggest('TestId', method, testId)) {
    return makeSuggestion('TestId', element, testId, {
      variant
    });
  }
  return undefined;
}

// This is so the stack trace the developer sees is one that's
// closer to their code (because async stack traces are hard to follow).
function copyStackTrace(target, source) {
  target.stack = source.stack.replace(source.message, target.message);
}
function waitFor(callback, _ref) {
  let {
    container = getDocument(),
    timeout = getConfig().asyncUtilTimeout,
    showOriginalStackTrace = getConfig().showOriginalStackTrace,
    stackTraceError,
    interval = 50,
    onTimeout = error => {
      error.message = getConfig().getElementError(error.message, container).message;
      return error;
    },
    mutationObserverOptions = {
      subtree: true,
      childList: true,
      attributes: true,
      characterData: true
    }
  } = _ref;
  if (typeof callback !== 'function') {
    throw new TypeError('Received `callback` arg must be a function');
  }
  return new Promise(async (resolve, reject) => {
    let lastError, intervalId, observer;
    let finished = false;
    let promiseStatus = 'idle';
    const overallTimeoutTimer = setTimeout(handleTimeout, timeout);
    const usingJestFakeTimers = jestFakeTimersAreEnabled();
    if (usingJestFakeTimers) {
      const {
        unstable_advanceTimersWrapper: advanceTimersWrapper
      } = getConfig();
      checkCallback();
      // this is a dangerous rule to disable because it could lead to an
      // infinite loop. However, eslint isn't smart enough to know that we're
      // setting finished inside `onDone` which will be called when we're done
      // waiting or when we've timed out.
      // eslint-disable-next-line no-unmodified-loop-condition
      while (!finished) {
        if (!jestFakeTimersAreEnabled()) {
          const error = new Error("Changed from using fake timers to real timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to real timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
          if (!showOriginalStackTrace) copyStackTrace(error, stackTraceError);
          reject(error);
          return;
        }
        // we *could* (maybe should?) use `advanceTimersToNextTimer` but it's
        // possible that could make this loop go on forever if someone is using
        // third party code that's setting up recursive timers so rapidly that
        // the user's timer's don't get a chance to resolve. So we'll advance
        // by an interval instead. (We have a test for this case).
        advanceTimersWrapper(() => {
          jest.advanceTimersByTime(interval);
        });

        // It's really important that checkCallback is run *before* we flush
        // in-flight promises. To be honest, I'm not sure why, and I can't quite
        // think of a way to reproduce the problem in a test, but I spent
        // an entire day banging my head against a wall on this.
        checkCallback();
        if (finished) {
          break;
        }

        // In this rare case, we *need* to wait for in-flight promises
        // to resolve before continuing. We don't need to take advantage
        // of parallelization so we're fine.
        // https://stackoverflow.com/a/59243586/971592
        // eslint-disable-next-line no-await-in-loop
        await advanceTimersWrapper(async () => {
          await new Promise(r => {
            setTimeout(r, 0);
            jest.advanceTimersByTime(0);
          });
        });
      }
    } else {
      try {
        checkContainerType(container);
      } catch (e) {
        reject(e);
        return;
      }
      intervalId = setInterval(checkRealTimersCallback, interval);
      const {
        MutationObserver
      } = getWindowFromNode(container);
      observer = new MutationObserver(checkRealTimersCallback);
      observer.observe(container, mutationObserverOptions);
      checkCallback();
    }
    function onDone(error, result) {
      finished = true;
      clearTimeout(overallTimeoutTimer);
      if (!usingJestFakeTimers) {
        clearInterval(intervalId);
        observer.disconnect();
      }
      if (error) {
        reject(error);
      } else {
        resolve(result);
      }
    }
    function checkRealTimersCallback() {
      if (jestFakeTimersAreEnabled()) {
        const error = new Error("Changed from using real timers to fake timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to fake timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
        if (!showOriginalStackTrace) copyStackTrace(error, stackTraceError);
        return reject(error);
      } else {
        return checkCallback();
      }
    }
    function checkCallback() {
      if (promiseStatus === 'pending') return;
      try {
        const result = runWithExpensiveErrorDiagnosticsDisabled(callback);
        if (typeof (result == null ? void 0 : result.then) === 'function') {
          promiseStatus = 'pending';
          result.then(resolvedValue => {
            promiseStatus = 'resolved';
            onDone(null, resolvedValue);
          }, rejectedValue => {
            promiseStatus = 'rejected';
            lastError = rejectedValue;
          });
        } else {
          onDone(null, result);
        }
        // If `callback` throws, wait for the next mutation, interval, or timeout.
      } catch (error) {
        // Save the most recent callback error to reject the promise with it in the event of a timeout
        lastError = error;
      }
    }
    function handleTimeout() {
      let error;
      if (lastError) {
        error = lastError;
        if (!showOriginalStackTrace && error.name === 'TestingLibraryElementError') {
          copyStackTrace(error, stackTraceError);
        }
      } else {
        error = new Error('Timed out in waitFor.');
        if (!showOriginalStackTrace) {
          copyStackTrace(error, stackTraceError);
        }
      }
      onDone(onTimeout(error), null);
    }
  });
}
function waitForWrapper(callback, options) {
  // create the error here so its stack trace is as close to the
  // calling code as possible
  const stackTraceError = new Error('STACK_TRACE_MESSAGE');
  return getConfig().asyncWrapper(() => waitFor(callback, {
    stackTraceError,
    ...options
  }));
}

/*
eslint
  max-lines-per-function: ["error", {"max": 200}],
*/

function getElementError(message, container) {
  return getConfig().getElementError(message, container);
}
function getMultipleElementsFoundError(message, container) {
  return getElementError(message + "\n\n(If this is intentional, then use the `*AllBy*` variant of the query (like `queryAllByText`, `getAllByText`, or `findAllByText`)).", container);
}
function queryAllByAttribute(attribute, container, text, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  return Array.from(container.querySelectorAll("[" + attribute + "]")).filter(node => matcher(node.getAttribute(attribute), node, text, matchNormalizer));
}

// this accepts a query function and returns a function which throws an error
// if more than one elements is returned, otherwise it returns the first
// element or null
function makeSingleQuery(allQuery, getMultipleError) {
  return function (container) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const els = allQuery(container, ...args);
    if (els.length > 1) {
      const elementStrings = els.map(element => getElementError(null, element).message).join('\n\n');
      throw getMultipleElementsFoundError(getMultipleError(container, ...args) + "\n\nHere are the matching elements:\n\n" + elementStrings, container);
    }
    return els[0] || null;
  };
}
function getSuggestionError(suggestion, container) {
  return getConfig().getElementError("A better query is available, try this:\n" + suggestion.toString() + "\n", container);
}

// this accepts a query function and returns a function which throws an error
// if an empty list of elements is returned
function makeGetAllQuery(allQuery, getMissingError) {
  return function (container) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    const els = allQuery(container, ...args);
    if (!els.length) {
      throw getConfig().getElementError(getMissingError(container, ...args), container);
    }
    return els;
  };
}

// this accepts a getter query function and returns a function which calls
// waitFor and passing a function which invokes the getter.
function makeFindQuery(getter) {
  return (container, text, options, waitForOptions) => {
    return waitForWrapper(() => {
      return getter(container, text, options);
    }, {
      container,
      ...waitForOptions
    });
  };
}
const wrapSingleQueryWithSuggestion = (query, queryAllByName, variant) => function (container) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }
  const element = query(container, ...args);
  const [{
    suggest = getConfig().throwSuggestions
  } = {}] = args.slice(-1);
  if (element && suggest) {
    const suggestion = getSuggestedQuery(element, variant);
    if (suggestion && !queryAllByName.endsWith(suggestion.queryName)) {
      throw getSuggestionError(suggestion.toString(), container);
    }
  }
  return element;
};
const wrapAllByQueryWithSuggestion = (query, queryAllByName, variant) => function (container) {
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }
  const els = query(container, ...args);
  const [{
    suggest = getConfig().throwSuggestions
  } = {}] = args.slice(-1);
  if (els.length && suggest) {
    // get a unique list of all suggestion messages.  We are only going to make a suggestion if
    // all the suggestions are the same
    const uniqueSuggestionMessages = [...new Set(els.map(element => {
      var _getSuggestedQuery;
      return (_getSuggestedQuery = getSuggestedQuery(element, variant)) == null ? void 0 : _getSuggestedQuery.toString();
    }))];
    if (
    // only want to suggest if all the els have the same suggestion.
    uniqueSuggestionMessages.length === 1 && !queryAllByName.endsWith(
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- TODO: Can this be null at runtime?
    getSuggestedQuery(els[0], variant).queryName)) {
      throw getSuggestionError(uniqueSuggestionMessages[0], container);
    }
  }
  return els;
};

// TODO: This deviates from the published declarations
// However, the implementation always required a dyadic (after `container`) not variadic `queryAllBy` considering the implementation of `makeFindQuery`
// This is at least statically true and can be verified by accepting `QueryMethod<Arguments, HTMLElement[]>`
function buildQueries(queryAllBy, getMultipleError, getMissingError) {
  const queryBy = wrapSingleQueryWithSuggestion(makeSingleQuery(queryAllBy, getMultipleError), queryAllBy.name, 'query');
  const getAllBy = makeGetAllQuery(queryAllBy, getMissingError);
  const getBy = makeSingleQuery(getAllBy, getMultipleError);
  const getByWithSuggestions = wrapSingleQueryWithSuggestion(getBy, queryAllBy.name, 'get');
  const getAllWithSuggestions = wrapAllByQueryWithSuggestion(getAllBy, queryAllBy.name.replace('query', 'get'), 'getAll');
  const findAllBy = makeFindQuery(wrapAllByQueryWithSuggestion(getAllBy, queryAllBy.name, 'findAll'));
  const findBy = makeFindQuery(wrapSingleQueryWithSuggestion(getBy, queryAllBy.name, 'find'));
  return [queryBy, getAllWithSuggestions, getByWithSuggestions, findAllBy, findBy];
}
function queryAllLabels(container) {
  return Array.from(container.querySelectorAll('label,input')).map(node => {
    return {
      node,
      textToMatch: getLabelContent(node)
    };
  }).filter(_ref => {
    let {
      textToMatch
    } = _ref;
    return textToMatch !== null;
  });
}
const queryAllLabelsByText = function (container, text, _temp) {
  let {
    exact = true,
    trim,
    collapseWhitespace,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  const textToMatchByLabels = queryAllLabels(container);
  return textToMatchByLabels.filter(_ref2 => {
    let {
      node,
      textToMatch
    } = _ref2;
    return matcher(textToMatch, node, text, matchNormalizer);
  }).map(_ref3 => {
    let {
      node
    } = _ref3;
    return node;
  });
};
const queryAllByLabelText = function (container, text, _temp2) {
  let {
    selector = '*',
    exact = true,
    collapseWhitespace,
    trim,
    normalizer
  } = _temp2 === void 0 ? {} : _temp2;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  const matchingLabelledElements = Array.from(container.querySelectorAll('*')).filter(element => {
    return getRealLabels(element).length || element.hasAttribute('aria-labelledby');
  }).reduce((labelledElements, labelledElement) => {
    const labelList = getLabels(container, labelledElement, {
      selector
    });
    labelList.filter(label => Boolean(label.formControl)).forEach(label => {
      if (matcher(label.content, label.formControl, text, matchNormalizer) && label.formControl) labelledElements.push(label.formControl);
    });
    const labelsValue = labelList.filter(label => Boolean(label.content)).map(label => label.content);
    if (matcher(labelsValue.join(' '), labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
    if (labelsValue.length > 1) {
      labelsValue.forEach((labelValue, index) => {
        if (matcher(labelValue, labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
        const labelsFiltered = [...labelsValue];
        labelsFiltered.splice(index, 1);
        if (labelsFiltered.length > 1) {
          if (matcher(labelsFiltered.join(' '), labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
        }
      });
    }
    return labelledElements;
  }, []).concat(queryAllByAttribute('aria-label', container, text, {
    exact,
    normalizer: matchNormalizer
  }));
  return Array.from(new Set(matchingLabelledElements)).filter(element => element.matches(selector));
};

// the getAll* query would normally look like this:
// const getAllByLabelText = makeGetAllQuery(
//   queryAllByLabelText,
//   (c, text) => `Unable to find a label with the text of: ${text}`,
// )
// however, we can give a more helpful error message than the generic one,
// so we're writing this one out by hand.
const getAllByLabelText = function (container, text) {
  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }
  const els = queryAllByLabelText(container, text, ...rest);
  if (!els.length) {
    const labels = queryAllLabelsByText(container, text, ...rest);
    if (labels.length) {
      const tagNames = labels.map(label => getTagNameOfElementAssociatedWithLabelViaFor(container, label)).filter(tagName => !!tagName);
      if (tagNames.length) {
        throw getConfig().getElementError(tagNames.map(tagName => "Found a label with the text of: " + text + ", however the element associated with this label (<" + tagName + " />) is non-labellable [https://html.spec.whatwg.org/multipage/forms.html#category-label]. If you really need to label a <" + tagName + " />, you can use aria-label or aria-labelledby instead.").join('\n\n'), container);
      } else {
        throw getConfig().getElementError("Found a label with the text of: " + text + ", however no form control was found associated to that label. Make sure you're using the \"for\" attribute or \"aria-labelledby\" attribute correctly.", container);
      }
    } else {
      throw getConfig().getElementError("Unable to find a label with the text of: " + text, container);
    }
  }
  return els;
};
function getTagNameOfElementAssociatedWithLabelViaFor(container, label) {
  const htmlFor = label.getAttribute('for');
  if (!htmlFor) {
    return null;
  }
  const element = container.querySelector("[id=\"" + htmlFor + "\"]");
  return element ? element.tagName.toLowerCase() : null;
}

// the reason mentioned above is the same reason we're not using buildQueries
const getMultipleError$7 = (c, text) => "Found multiple elements with the text of: " + text;
const queryByLabelText = wrapSingleQueryWithSuggestion(makeSingleQuery(queryAllByLabelText, getMultipleError$7), queryAllByLabelText.name, 'query');
const getByLabelText = makeSingleQuery(getAllByLabelText, getMultipleError$7);
const findAllByLabelText = makeFindQuery(wrapAllByQueryWithSuggestion(getAllByLabelText, getAllByLabelText.name, 'findAll'));
const findByLabelText = makeFindQuery(wrapSingleQueryWithSuggestion(getByLabelText, getAllByLabelText.name, 'find'));
const getAllByLabelTextWithSuggestions = wrapAllByQueryWithSuggestion(getAllByLabelText, getAllByLabelText.name, 'getAll');
const getByLabelTextWithSuggestions = wrapSingleQueryWithSuggestion(getByLabelText, getAllByLabelText.name, 'get');
const queryAllByLabelTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByLabelText, queryAllByLabelText.name, 'queryAll');
const queryAllByPlaceholderText = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  checkContainerType(args[0]);
  return queryAllByAttribute('placeholder', ...args);
};
const getMultipleError$6 = (c, text) => "Found multiple elements with the placeholder text of: " + text;
const getMissingError$6 = (c, text) => "Unable to find an element with the placeholder text of: " + text;
const queryAllByPlaceholderTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByPlaceholderText, queryAllByPlaceholderText.name, 'queryAll');
const [queryByPlaceholderText, getAllByPlaceholderText, getByPlaceholderText, findAllByPlaceholderText, findByPlaceholderText] = buildQueries(queryAllByPlaceholderText, getMultipleError$6, getMissingError$6);
const queryAllByText = function (container, text, _temp) {
  let {
    selector = '*',
    exact = true,
    collapseWhitespace,
    trim,
    ignore = getConfig().defaultIgnore,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  let baseArray = [];
  if (typeof container.matches === 'function' && container.matches(selector)) {
    baseArray = [container];
  }
  return [...baseArray, ...Array.from(container.querySelectorAll(selector))]
  // TODO: `matches` according lib.dom.d.ts can get only `string` but according our code it can handle also boolean :)
  .filter(node => !ignore || !node.matches(ignore)).filter(node => matcher(getNodeText(node), node, text, matchNormalizer));
};
const getMultipleError$5 = (c, text) => "Found multiple elements with the text: " + text;
const getMissingError$5 = function (c, text, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    collapseWhitespace,
    trim,
    normalizer,
    selector
  } = options;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  const normalizedText = matchNormalizer(text.toString());
  const isNormalizedDifferent = normalizedText !== text.toString();
  const isCustomSelector = (selector != null ? selector : '*') !== '*';
  return "Unable to find an element with the text: " + (isNormalizedDifferent ? normalizedText + " (normalized from '" + text + "')" : text) + (isCustomSelector ? ", which matches selector '" + selector + "'" : '') + ". This could be because the text is broken up by multiple elements. In this case, you can provide a function for your text matcher to make your matcher more flexible.";
};
const queryAllByTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByText, queryAllByText.name, 'queryAll');
const [queryByText, getAllByText, getByText, findAllByText, findByText] = buildQueries(queryAllByText, getMultipleError$5, getMissingError$5);
const queryAllByDisplayValue = function (container, value, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  return Array.from(container.querySelectorAll("input,textarea,select")).filter(node => {
    if (node.tagName === 'SELECT') {
      const selectedOptions = Array.from(node.options).filter(option => option.selected);
      return selectedOptions.some(optionNode => matcher(getNodeText(optionNode), optionNode, value, matchNormalizer));
    } else {
      return matcher(node.value, node, value, matchNormalizer);
    }
  });
};
const getMultipleError$4 = (c, value) => "Found multiple elements with the display value: " + value + ".";
const getMissingError$4 = (c, value) => "Unable to find an element with the display value: " + value + ".";
const queryAllByDisplayValueWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByDisplayValue, queryAllByDisplayValue.name, 'queryAll');
const [queryByDisplayValue, getAllByDisplayValue, getByDisplayValue, findAllByDisplayValue, findByDisplayValue] = buildQueries(queryAllByDisplayValue, getMultipleError$4, getMissingError$4);

// Valid tags are img, input, area and custom elements
const VALID_TAG_REGEXP = /^(img|input|area|.+-.+)$/i;
const queryAllByAltText = function (container, alt, options) {
  if (options === void 0) {
    options = {};
  }
  checkContainerType(container);
  return queryAllByAttribute('alt', container, alt, options).filter(node => VALID_TAG_REGEXP.test(node.tagName));
};
const getMultipleError$3 = (c, alt) => "Found multiple elements with the alt text: " + alt;
const getMissingError$3 = (c, alt) => "Unable to find an element with the alt text: " + alt;
const queryAllByAltTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByAltText, queryAllByAltText.name, 'queryAll');
const [queryByAltText, getAllByAltText, getByAltText, findAllByAltText, findByAltText] = buildQueries(queryAllByAltText, getMultipleError$3, getMissingError$3);
const isSvgTitle = node => {
  var _node$parentElement;
  return node.tagName.toLowerCase() === 'title' && ((_node$parentElement = node.parentElement) == null ? void 0 : _node$parentElement.tagName.toLowerCase()) === 'svg';
};
const queryAllByTitle = function (container, text, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  return Array.from(container.querySelectorAll('[title], svg > title')).filter(node => matcher(node.getAttribute('title'), node, text, matchNormalizer) || isSvgTitle(node) && matcher(getNodeText(node), node, text, matchNormalizer));
};
const getMultipleError$2 = (c, title) => "Found multiple elements with the title: " + title + ".";
const getMissingError$2 = (c, title) => "Unable to find an element with the title: " + title + ".";
const queryAllByTitleWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByTitle, queryAllByTitle.name, 'queryAll');
const [queryByTitle, getAllByTitle, getByTitle, findAllByTitle, findByTitle] = buildQueries(queryAllByTitle, getMultipleError$2, getMissingError$2);
function queryAllByRole(container, role, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    hidden = getConfig().defaultHidden,
    name,
    description,
    trim,
    normalizer,
    queryFallbacks = false,
    selected,
    checked,
    pressed,
    current,
    level,
    expanded
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  if (selected !== undefined) {
    var _allRoles$get;
    // guard against unknown roles
    if (((_allRoles$get = libExports.roles.get(role)) == null ? void 0 : _allRoles$get.props['aria-selected']) === undefined) {
      throw new Error("\"aria-selected\" is not supported on role \"" + role + "\".");
    }
  }
  if (checked !== undefined) {
    var _allRoles$get2;
    // guard against unknown roles
    if (((_allRoles$get2 = libExports.roles.get(role)) == null ? void 0 : _allRoles$get2.props['aria-checked']) === undefined) {
      throw new Error("\"aria-checked\" is not supported on role \"" + role + "\".");
    }
  }
  if (pressed !== undefined) {
    var _allRoles$get3;
    // guard against unknown roles
    if (((_allRoles$get3 = libExports.roles.get(role)) == null ? void 0 : _allRoles$get3.props['aria-pressed']) === undefined) {
      throw new Error("\"aria-pressed\" is not supported on role \"" + role + "\".");
    }
  }
  if (current !== undefined) {
    var _allRoles$get4;
    /* istanbul ignore next */
    // guard against unknown roles
    // All currently released ARIA versions support `aria-current` on all roles.
    // Leaving this for symetry and forward compatibility
    if (((_allRoles$get4 = libExports.roles.get(role)) == null ? void 0 : _allRoles$get4.props['aria-current']) === undefined) {
      throw new Error("\"aria-current\" is not supported on role \"" + role + "\".");
    }
  }
  if (level !== undefined) {
    // guard against using `level` option with any role other than `heading`
    if (role !== 'heading') {
      throw new Error("Role \"" + role + "\" cannot have \"level\" property.");
    }
  }
  if (expanded !== undefined) {
    var _allRoles$get5;
    // guard against unknown roles
    if (((_allRoles$get5 = libExports.roles.get(role)) == null ? void 0 : _allRoles$get5.props['aria-expanded']) === undefined) {
      throw new Error("\"aria-expanded\" is not supported on role \"" + role + "\".");
    }
  }
  const subtreeIsInaccessibleCache = new WeakMap();
  function cachedIsSubtreeInaccessible(element) {
    if (!subtreeIsInaccessibleCache.has(element)) {
      subtreeIsInaccessibleCache.set(element, isSubtreeInaccessible(element));
    }
    return subtreeIsInaccessibleCache.get(element);
  }
  return Array.from(container.querySelectorAll(
  // Only query elements that can be matched by the following filters
  makeRoleSelector(role, exact, normalizer ? matchNormalizer : undefined))).filter(node => {
    const isRoleSpecifiedExplicitly = node.hasAttribute('role');
    if (isRoleSpecifiedExplicitly) {
      const roleValue = node.getAttribute('role');
      if (queryFallbacks) {
        return roleValue.split(' ').filter(Boolean).some(text => matcher(text, node, role, matchNormalizer));
      }
      // if a custom normalizer is passed then let normalizer handle the role value
      if (normalizer) {
        return matcher(roleValue, node, role, matchNormalizer);
      }
      // other wise only send the first word to match
      const [firstWord] = roleValue.split(' ');
      return matcher(firstWord, node, role, matchNormalizer);
    }
    const implicitRoles = getImplicitAriaRoles(node);
    return implicitRoles.some(implicitRole => matcher(implicitRole, node, role, matchNormalizer));
  }).filter(element => {
    if (selected !== undefined) {
      return selected === computeAriaSelected(element);
    }
    if (checked !== undefined) {
      return checked === computeAriaChecked(element);
    }
    if (pressed !== undefined) {
      return pressed === computeAriaPressed(element);
    }
    if (current !== undefined) {
      return current === computeAriaCurrent(element);
    }
    if (expanded !== undefined) {
      return expanded === computeAriaExpanded(element);
    }
    if (level !== undefined) {
      return level === computeHeadingLevel(element);
    }
    // don't care if aria attributes are unspecified
    return true;
  }).filter(element => {
    if (name === undefined) {
      // Don't care
      return true;
    }
    return matches(computeAccessibleName(element, {
      computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
    }), element, name, text => text);
  }).filter(element => {
    if (description === undefined) {
      // Don't care
      return true;
    }
    return matches(computeAccessibleDescription(element, {
      computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
    }), element, description, text => text);
  }).filter(element => {
    return hidden === false ? isInaccessible(element, {
      isSubtreeInaccessible: cachedIsSubtreeInaccessible
    }) === false : true;
  });
}
function makeRoleSelector(role, exact, customNormalizer) {
  var _roleElements$get;
  if (typeof role !== 'string') {
    // For non-string role parameters we can not determine the implicitRoleSelectors.
    return '*';
  }
  const explicitRoleSelector = exact && !customNormalizer ? "*[role~=\"" + role + "\"]" : '*[role]';
  const roleRelations = (_roleElements$get = libExports.roleElements.get(role)) != null ? _roleElements$get : new Set();
  const implicitRoleSelectors = new Set(Array.from(roleRelations).map(_ref => {
    let {
      name
    } = _ref;
    return name;
  }));

  // Current transpilation config sometimes assumes `...` is always applied to arrays.
  // `...` is equivalent to `Array.prototype.concat` for arrays.
  // If you replace this code with `[explicitRoleSelector, ...implicitRoleSelectors]`, make sure every transpilation target retains the `...` in favor of `Array.prototype.concat`.
  return [explicitRoleSelector].concat(Array.from(implicitRoleSelectors)).join(',');
}
const getNameHint = name => {
  let nameHint = '';
  if (name === undefined) {
    nameHint = '';
  } else if (typeof name === 'string') {
    nameHint = " and name \"" + name + "\"";
  } else {
    nameHint = " and name `" + name + "`";
  }
  return nameHint;
};
const getMultipleError$1 = function (c, role, _temp2) {
  let {
    name
  } = _temp2 === void 0 ? {} : _temp2;
  return "Found multiple elements with the role \"" + role + "\"" + getNameHint(name);
};
const getMissingError$1 = function (container, role, _temp3) {
  let {
    hidden = getConfig().defaultHidden,
    name,
    description
  } = _temp3 === void 0 ? {} : _temp3;
  if (getConfig()._disableExpensiveErrorDiagnostics) {
    return "Unable to find role=\"" + role + "\"" + getNameHint(name);
  }
  let roles = '';
  Array.from(container.children).forEach(childElement => {
    roles += prettyRoles(childElement, {
      hidden,
      includeDescription: description !== undefined
    });
  });
  let roleMessage;
  if (roles.length === 0) {
    if (hidden === false) {
      roleMessage = 'There are no accessible roles. But there might be some inaccessible roles. ' + 'If you wish to access them, then set the `hidden` option to `true`. ' + 'Learn more about this here: https://testing-library.com/docs/dom-testing-library/api-queries#byrole';
    } else {
      roleMessage = 'There are no available roles.';
    }
  } else {
    roleMessage = ("\nHere are the " + (hidden === false ? 'accessible' : 'available') + " roles:\n\n  " + roles.replace(/\n/g, '\n  ').replace(/\n\s\s\n/g, '\n\n') + "\n").trim();
  }
  let nameHint = '';
  if (name === undefined) {
    nameHint = '';
  } else if (typeof name === 'string') {
    nameHint = " and name \"" + name + "\"";
  } else {
    nameHint = " and name `" + name + "`";
  }
  let descriptionHint = '';
  if (description === undefined) {
    descriptionHint = '';
  } else if (typeof description === 'string') {
    descriptionHint = " and description \"" + description + "\"";
  } else {
    descriptionHint = " and description `" + description + "`";
  }
  return ("\nUnable to find an " + (hidden === false ? 'accessible ' : '') + "element with the role \"" + role + "\"" + nameHint + descriptionHint + "\n\n" + roleMessage).trim();
};
const queryAllByRoleWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByRole, queryAllByRole.name, 'queryAll');
const [queryByRole, getAllByRole, getByRole, findAllByRole, findByRole] = buildQueries(queryAllByRole, getMultipleError$1, getMissingError$1);
const getTestIdAttribute = () => getConfig().testIdAttribute;
const queryAllByTestId = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  checkContainerType(args[0]);
  return queryAllByAttribute(getTestIdAttribute(), ...args);
};
const getMultipleError = (c, id) => "Found multiple elements by: [" + getTestIdAttribute() + "=\"" + id + "\"]";
const getMissingError = (c, id) => "Unable to find an element by: [" + getTestIdAttribute() + "=\"" + id + "\"]";
const queryAllByTestIdWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByTestId, queryAllByTestId.name, 'queryAll');
const [queryByTestId, getAllByTestId, getByTestId, findAllByTestId, findByTestId] = buildQueries(queryAllByTestId, getMultipleError, getMissingError);
var queries = /*#__PURE__*/Object.freeze({
  __proto__: null,
  queryAllByLabelText: queryAllByLabelTextWithSuggestions,
  queryByLabelText: queryByLabelText,
  getAllByLabelText: getAllByLabelTextWithSuggestions,
  getByLabelText: getByLabelTextWithSuggestions,
  findAllByLabelText: findAllByLabelText,
  findByLabelText: findByLabelText,
  queryByPlaceholderText: queryByPlaceholderText,
  queryAllByPlaceholderText: queryAllByPlaceholderTextWithSuggestions,
  getByPlaceholderText: getByPlaceholderText,
  getAllByPlaceholderText: getAllByPlaceholderText,
  findAllByPlaceholderText: findAllByPlaceholderText,
  findByPlaceholderText: findByPlaceholderText,
  queryByText: queryByText,
  queryAllByText: queryAllByTextWithSuggestions,
  getByText: getByText,
  getAllByText: getAllByText,
  findAllByText: findAllByText,
  findByText: findByText,
  queryByDisplayValue: queryByDisplayValue,
  queryAllByDisplayValue: queryAllByDisplayValueWithSuggestions,
  getByDisplayValue: getByDisplayValue,
  getAllByDisplayValue: getAllByDisplayValue,
  findAllByDisplayValue: findAllByDisplayValue,
  findByDisplayValue: findByDisplayValue,
  queryByAltText: queryByAltText,
  queryAllByAltText: queryAllByAltTextWithSuggestions,
  getByAltText: getByAltText,
  getAllByAltText: getAllByAltText,
  findAllByAltText: findAllByAltText,
  findByAltText: findByAltText,
  queryByTitle: queryByTitle,
  queryAllByTitle: queryAllByTitleWithSuggestions,
  getByTitle: getByTitle,
  getAllByTitle: getAllByTitle,
  findAllByTitle: findAllByTitle,
  findByTitle: findByTitle,
  queryByRole: queryByRole,
  queryAllByRole: queryAllByRoleWithSuggestions,
  getAllByRole: getAllByRole,
  getByRole: getByRole,
  findAllByRole: findAllByRole,
  findByRole: findByRole,
  queryByTestId: queryByTestId,
  queryAllByTestId: queryAllByTestIdWithSuggestions,
  getByTestId: getByTestId,
  getAllByTestId: getAllByTestId,
  findAllByTestId: findAllByTestId,
  findByTestId: findByTestId
});

/**
 * @typedef {{[key: string]: Function}} FuncMap
 */

/**
 * @param {HTMLElement} element container
 * @param {FuncMap} queries object of functions
 * @param {Object} initialValue for reducer
 * @returns {FuncMap} returns object of functions bound to container
 */
function getQueriesForElement(element, queries$1, initialValue) {
  if (queries$1 === void 0) {
    queries$1 = queries;
  }
  if (initialValue === void 0) {
    initialValue = {};
  }
  return Object.keys(queries$1).reduce((helpers, key) => {
    const fn = queries$1[key];
    helpers[key] = fn.bind(null, element);
    return helpers;
  }, initialValue);
}

/*
eslint
  require-await: "off"
*/

const eventMap = {
  // Clipboard Events
  copy: {
    EventType: 'ClipboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  cut: {
    EventType: 'ClipboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  paste: {
    EventType: 'ClipboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Composition Events
  compositionEnd: {
    EventType: 'CompositionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  compositionStart: {
    EventType: 'CompositionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  compositionUpdate: {
    EventType: 'CompositionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Keyboard Events
  keyDown: {
    EventType: 'KeyboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  keyPress: {
    EventType: 'KeyboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  keyUp: {
    EventType: 'KeyboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  // Focus Events
  focus: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  blur: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  focusIn: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  focusOut: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  // Form Events
  change: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  input: {
    EventType: 'InputEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  invalid: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: true
    }
  },
  submit: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  reset: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  // Mouse Events
  click: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      button: 0,
      composed: true
    }
  },
  contextMenu: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dblClick: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  drag: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragEnd: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragEnter: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragExit: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragLeave: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragOver: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragStart: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  drop: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseDown: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseEnter: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  mouseLeave: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  mouseMove: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseOut: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseOver: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseUp: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Selection Events
  select: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // Touch Events
  touchCancel: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  touchEnd: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  touchMove: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  touchStart: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // UI Events
  resize: {
    EventType: 'UIEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  scroll: {
    EventType: 'UIEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Wheel Events
  wheel: {
    EventType: 'WheelEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Media Events
  abort: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  canPlay: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  canPlayThrough: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  durationChange: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  emptied: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  encrypted: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  ended: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadedData: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadedMetadata: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadStart: {
    EventType: 'ProgressEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  pause: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  play: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  playing: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  progress: {
    EventType: 'ProgressEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  rateChange: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  seeked: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  seeking: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  stalled: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  suspend: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  timeUpdate: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  volumeChange: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  waiting: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Events
  load: {
    // TODO: load events can be UIEvent or Event depending on what generated them
    // This is where this abstraction breaks down.
    // But the common targets are <img />, <script /> and window.
    // Neither of these targets receive a UIEvent
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  error: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Animation Events
  animationStart: {
    EventType: 'AnimationEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  animationEnd: {
    EventType: 'AnimationEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  animationIteration: {
    EventType: 'AnimationEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // Transition Events
  transitionCancel: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  transitionEnd: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  transitionRun: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  transitionStart: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // pointer events
  pointerOver: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerEnter: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  pointerDown: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerMove: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerUp: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerCancel: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  pointerOut: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerLeave: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  gotPointerCapture: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  lostPointerCapture: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  // history events
  popState: {
    EventType: 'PopStateEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // window events
  offline: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  online: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  }
};
const eventAliasMap = {
  doubleClick: 'dblClick'
};
function fireEvent$1(element, event) {
  return getConfig().eventWrapper(() => {
    if (!event) {
      throw new Error("Unable to fire an event - please provide an event object.");
    }
    if (!element) {
      throw new Error("Unable to fire a \"" + event.type + "\" event - please provide a DOM element.");
    }
    return element.dispatchEvent(event);
  });
}
function createEvent(eventName, node, init, _temp) {
  let {
    EventType = 'Event',
    defaultInit = {}
  } = _temp === void 0 ? {} : _temp;
  if (!node) {
    throw new Error("Unable to fire a \"" + eventName + "\" event - please provide a DOM element.");
  }
  const eventInit = {
    ...defaultInit,
    ...init
  };
  const {
    target: {
      value,
      files,
      ...targetProperties
    } = {}
  } = eventInit;
  if (value !== undefined) {
    setNativeValue(node, value);
  }
  if (files !== undefined) {
    // input.files is a read-only property so this is not allowed:
    // input.files = [file]
    // so we have to use this workaround to set the property
    Object.defineProperty(node, 'files', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: files
    });
  }
  Object.assign(node, targetProperties);
  const window = getWindowFromNode(node);
  const EventConstructor = window[EventType] || window.Event;
  let event;
  /* istanbul ignore else  */
  if (typeof EventConstructor === 'function') {
    event = new EventConstructor(eventName, eventInit);
  } else {
    // IE11 polyfill from https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
    event = window.document.createEvent(EventType);
    const {
      bubbles,
      cancelable,
      detail,
      ...otherInit
    } = eventInit;
    event.initEvent(eventName, bubbles, cancelable, detail);
    Object.keys(otherInit).forEach(eventKey => {
      event[eventKey] = otherInit[eventKey];
    });
  }

  // DataTransfer is not supported in jsdom: https://github.com/jsdom/jsdom/issues/1568
  const dataTransferProperties = ['dataTransfer', 'clipboardData'];
  dataTransferProperties.forEach(dataTransferKey => {
    const dataTransferValue = eventInit[dataTransferKey];
    if (typeof dataTransferValue === 'object') {
      /* istanbul ignore if  */
      if (typeof window.DataTransfer === 'function') {
        Object.defineProperty(event, dataTransferKey, {
          value: Object.getOwnPropertyNames(dataTransferValue).reduce((acc, propName) => {
            Object.defineProperty(acc, propName, {
              value: dataTransferValue[propName]
            });
            return acc;
          }, new window.DataTransfer())
        });
      } else {
        Object.defineProperty(event, dataTransferKey, {
          value: dataTransferValue
        });
      }
    }
  });
  return event;
}
Object.keys(eventMap).forEach(key => {
  const {
    EventType,
    defaultInit
  } = eventMap[key];
  const eventName = key.toLowerCase();
  createEvent[key] = (node, init) => createEvent(eventName, node, init, {
    EventType,
    defaultInit
  });
  fireEvent$1[key] = (node, init) => fireEvent$1(node, createEvent[key](node, init));
});

// function written after some investigation here:
// https://github.com/facebook/react/issues/10135#issuecomment-401496776
function setNativeValue(element, value) {
  const {
    set: valueSetter
  } = Object.getOwnPropertyDescriptor(element, 'value') || {};
  const prototype = Object.getPrototypeOf(element);
  const {
    set: prototypeValueSetter
  } = Object.getOwnPropertyDescriptor(prototype, 'value') || {};
  if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
    prototypeValueSetter.call(element, value);
  } else {
    /* istanbul ignore if */
    // eslint-disable-next-line no-lonely-if -- Can't be ignored by istanbul otherwise
    if (valueSetter) {
      valueSetter.call(element, value);
    } else {
      throw new Error('The given element does not have a value setter');
    }
  }
}
Object.keys(eventAliasMap).forEach(aliasKey => {
  const key = eventAliasMap[aliasKey];
  fireEvent$1[aliasKey] = function () {
    return fireEvent$1[key](...arguments);
  };
});

/* eslint complexity:["error", 9] */

// WARNING: `lz-string` only has a default export but statically we assume named exports are allowd
function unindent(string) {
  // remove white spaces first, to save a few bytes.
  // testing-playground will reformat on load any ways.
  return string.replace(/[ \t]*[\n][ \t]*/g, '\n');
}
function encode(value) {
  return lzString.compressToEncodedURIComponent(unindent(value));
}
function getPlaygroundUrl(markup) {
  return "https://testing-playground.com/#markup=" + encode(markup);
}
const debug = (element, maxLength, options) => Array.isArray(element) ? element.forEach(el => logDOM(el, maxLength, options)) : logDOM(element, maxLength, options);
const logTestingPlaygroundURL = function (element) {
  if (element === void 0) {
    element = getDocument().body;
  }
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!element || !('innerHTML' in element)) {
    console.log("The element you're providing isn't a valid DOM element.");
    return;
  }
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!element.innerHTML) {
    console.log("The provided element doesn't have any children.");
    return;
  }
  const playgroundUrl = getPlaygroundUrl(element.innerHTML);
  console.log("Open this URL in your browser\n\n" + playgroundUrl);
  return playgroundUrl;
};
const initialValue = {
  debug,
  logTestingPlaygroundURL
};
typeof document !== 'undefined' && document.body // eslint-disable-line @typescript-eslint/no-unnecessary-condition
? getQueriesForElement(document.body, queries, initialValue) : Object.keys(queries).reduce((helpers, key) => {
  // `key` is for all intents and purposes the type of keyof `helpers`, which itself is the type of `initialValue` plus incoming properties from `queries`
  // if `Object.keys(something)` returned Array<keyof typeof something> this explicit type assertion would not be necessary
  // see https://stackoverflow.com/questions/55012174/why-doesnt-object-keys-return-a-keyof-type-in-typescript
  helpers[key] = () => {
    throw new TypeError('For queries bound to document.body a global document has to be available... Learn more: https://testing-library.com/s/screen-global-error');
  };
  return helpers;
}, initialValue);

var testUtils = {exports: {}};

var reactDomTestUtils_production_min = {};

/**
 * @license React
 * react-dom-test-utils.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactDomTestUtils_production_min;
function requireReactDomTestUtils_production_min() {
  if (hasRequiredReactDomTestUtils_production_min) return reactDomTestUtils_production_min;
  hasRequiredReactDomTestUtils_production_min = 1;
  var k = React__default,
    l = ReactDOM__default;
  function m(a) {
    var b = a,
      c = a;
    if (a.alternate) for (; b.return;) b = b.return;else {
      a = b;
      do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return; while (a);
    }
    return 3 === b.tag ? c : null;
  }
  function n(a) {
    if (m(a) !== a) throw Error("Unable to find node on an unmounted component.");
  }
  function p(a) {
    var b = a.alternate;
    if (!b) {
      b = m(a);
      if (null === b) throw Error("Unable to find node on an unmounted component.");
      return b !== a ? null : a;
    }
    for (var c = a, d = b;;) {
      var f = c.return;
      if (null === f) break;
      var g = f.alternate;
      if (null === g) {
        d = f.return;
        if (null !== d) {
          c = d;
          continue;
        }
        break;
      }
      if (f.child === g.child) {
        for (g = f.child; g;) {
          if (g === c) return n(f), a;
          if (g === d) return n(f), b;
          g = g.sibling;
        }
        throw Error("Unable to find node on an unmounted component.");
      }
      if (c.return !== d.return) c = f, d = g;else {
        for (var e = false, h = f.child; h;) {
          if (h === c) {
            e = true;
            c = f;
            d = g;
            break;
          }
          if (h === d) {
            e = true;
            d = f;
            c = g;
            break;
          }
          h = h.sibling;
        }
        if (!e) {
          for (h = g.child; h;) {
            if (h === c) {
              e = true;
              c = g;
              d = f;
              break;
            }
            if (h === d) {
              e = true;
              d = g;
              c = f;
              break;
            }
            h = h.sibling;
          }
          if (!e) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
        }
      }
      if (c.alternate !== d) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
    }
    if (3 !== c.tag) throw Error("Unable to find node on an unmounted component.");
    return c.stateNode.current === c ? a : b;
  }
  var q = Object.assign;
  function r(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
  }
  function t() {
    return true;
  }
  function u() {
    return false;
  }
  function v(a) {
    function b(c, b, f, g, e) {
      this._reactName = c;
      this._targetInst = f;
      this.type = b;
      this.nativeEvent = g;
      this.target = e;
      this.currentTarget = null;
      for (var d in a) a.hasOwnProperty(d) && (c = a[d], this[d] = c ? c(g) : g[d]);
      this.isDefaultPrevented = (null != g.defaultPrevented ? g.defaultPrevented : false === g.returnValue) ? t : u;
      this.isPropagationStopped = u;
      return this;
    }
    q(b.prototype, {
      preventDefault: function () {
        this.defaultPrevented = true;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = false), this.isDefaultPrevented = t);
      },
      stopPropagation: function () {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = true), this.isPropagationStopped = t);
      },
      persist: function () {},
      isPersistent: t
    });
    return b;
  }
  var w = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function (a) {
        return a.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    },
    x = v(w),
    y = q({}, w, {
      view: 0,
      detail: 0
    });
  v(y);
  var z,
    A,
    B,
    D = q({}, y, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: C,
      button: 0,
      buttons: 0,
      relatedTarget: function (a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
      },
      movementX: function (a) {
        if ("movementX" in a) return a.movementX;
        a !== B && (B && "mousemove" === a.type ? (z = a.screenX - B.screenX, A = a.screenY - B.screenY) : A = z = 0, B = a);
        return z;
      },
      movementY: function (a) {
        return "movementY" in a ? a.movementY : A;
      }
    });
  v(D);
  var E = q({}, D, {
    dataTransfer: 0
  });
  v(E);
  var F = q({}, y, {
    relatedTarget: 0
  });
  v(F);
  var aa = q({}, w, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  });
  v(aa);
  var ba = q({}, w, {
    clipboardData: function (a) {
      return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
  });
  v(ba);
  var ca = q({}, w, {
    data: 0
  });
  v(ca);
  var da = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    },
    ea = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    },
    fa = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
  function ha(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = fa[a]) ? !!b[a] : false;
  }
  function C() {
    return ha;
  }
  var ia = q({}, y, {
    key: function (a) {
      if (a.key) {
        var b = da[a.key] || a.key;
        if ("Unidentified" !== b) return b;
      }
      return "keypress" === a.type ? (a = r(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? ea[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: C,
    charCode: function (a) {
      return "keypress" === a.type ? r(a) : 0;
    },
    keyCode: function (a) {
      return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function (a) {
      return "keypress" === a.type ? r(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
  });
  v(ia);
  var ja = q({}, D, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  });
  v(ja);
  var ka = q({}, y, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: C
  });
  v(ka);
  var la = q({}, w, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  });
  v(la);
  var ma = q({}, D, {
    deltaX: function (a) {
      return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function (a) {
      return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  });
  v(ma);
  function na(a, b, c, d, f, g, e, h, N) {
    var G = Array.prototype.slice.call(arguments, 3);
    try {
      b.apply(c, G);
    } catch (oa) {
      this.onError(oa);
    }
  }
  var H = false,
    I = null,
    J = false,
    K = null,
    pa = {
      onError: function (a) {
        H = true;
        I = a;
      }
    };
  function qa(a, b, c, d, f, g, e, h, N) {
    H = false;
    I = null;
    na.apply(pa, arguments);
  }
  function ra(a, b, c, d, f, g, e, h, N) {
    qa.apply(this, arguments);
    if (H) {
      if (H) {
        var G = I;
        H = false;
        I = null;
      } else throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
      J || (J = true, K = G);
    }
  }
  var L = Array.isArray,
    M = l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Events,
    sa = M[0],
    ta = M[1],
    ua = M[2],
    va = M[3],
    wa = M[4],
    xa = k.unstable_act;
  function ya() {}
  function za(a, b) {
    if (!a) return [];
    a = p(a);
    if (!a) return [];
    for (var c = a, d = [];;) {
      if (5 === c.tag || 6 === c.tag || 1 === c.tag || 0 === c.tag) {
        var f = c.stateNode;
        b(f) && d.push(f);
      }
      if (c.child) c.child.return = c, c = c.child;else {
        if (c === a) return d;
        for (; !c.sibling;) {
          if (!c.return || c.return === a) return d;
          c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
      }
    }
  }
  function O(a, b) {
    if (a && !a._reactInternals) {
      var c = String(a);
      a = L(a) ? "an array" : a && 1 === a.nodeType && a.tagName ? "a DOM node" : "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c;
      throw Error(b + "(...): the first argument must be a React class instance. Instead received: " + (a + "."));
    }
  }
  function P(a) {
    return !(!a || 1 !== a.nodeType || !a.tagName);
  }
  function Q(a) {
    return P(a) ? false : null != a && "function" === typeof a.render && "function" === typeof a.setState;
  }
  function R(a, b) {
    return Q(a) ? a._reactInternals.type === b : false;
  }
  function S(a, b) {
    O(a, "findAllInRenderedTree");
    return a ? za(a._reactInternals, b) : [];
  }
  function T(a, b) {
    O(a, "scryRenderedDOMComponentsWithClass");
    return S(a, function (a) {
      if (P(a)) {
        var c = a.className;
        "string" !== typeof c && (c = a.getAttribute("class") || "");
        var f = c.split(/\s+/);
        if (!L(b)) {
          if (void 0 === b) throw Error("TestUtils.scryRenderedDOMComponentsWithClass expects a className as a second argument.");
          b = b.split(/\s+/);
        }
        return b.every(function (a) {
          return -1 !== f.indexOf(a);
        });
      }
      return false;
    });
  }
  function U(a, b) {
    O(a, "scryRenderedDOMComponentsWithTag");
    return S(a, function (a) {
      return P(a) && a.tagName.toUpperCase() === b.toUpperCase();
    });
  }
  function V(a, b) {
    O(a, "scryRenderedComponentsWithType");
    return S(a, function (a) {
      return R(a, b);
    });
  }
  function W(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = ta(c);
    ra(d, b, void 0, a);
    a.currentTarget = null;
  }
  function X(a, b, c) {
    for (var d = []; a;) {
      d.push(a);
      do a = a.return; while (a && 5 !== a.tag);
      a = a ? a : null;
    }
    for (a = d.length; 0 < a--;) b(d[a], "captured", c);
    for (a = 0; a < d.length; a++) b(d[a], "bubbled", c);
  }
  function Y(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = ua(c);
    if (!d) return null;
    c = d[b];
    a: switch (b) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
        a = !d;
        break a;
      default:
        a = false;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error("Expected `" + b + "` listener to be a function, instead got a value of `" + typeof c + "` type.");
    return c;
  }
  function Aa(a, b, c) {
    a && c && c._reactName && (b = Y(a, c._reactName)) && (null == c._dispatchListeners && (c._dispatchListeners = []), null == c._dispatchInstances && (c._dispatchInstances = []), c._dispatchListeners.push(b), c._dispatchInstances.push(a));
  }
  function Ba(a, b, c) {
    var d = c._reactName;
    "captured" === b && (d += "Capture");
    if (b = Y(a, d)) null == c._dispatchListeners && (c._dispatchListeners = []), null == c._dispatchInstances && (c._dispatchInstances = []), c._dispatchListeners.push(b), c._dispatchInstances.push(a);
  }
  var Z = {},
    Ca = new Set(["mouseEnter", "mouseLeave", "pointerEnter", "pointerLeave"]);
  function Da(a) {
    return function (b, c) {
      if (k.isValidElement(b)) throw Error("TestUtils.Simulate expected a DOM node as the first argument but received a React element. Pass the DOM node you wish to simulate the event on instead. Note that TestUtils.Simulate will not work if you are using shallow rendering.");
      if (Q(b)) throw Error("TestUtils.Simulate expected a DOM node as the first argument but received a component instance. Pass the DOM node you wish to simulate the event on instead.");
      var d = "on" + a[0].toUpperCase() + a.slice(1),
        f = new ya();
      f.target = b;
      f.type = a.toLowerCase();
      var g = sa(b),
        e = new x(d, f.type, g, f, b);
      e.persist();
      q(e, c);
      Ca.has(a) ? e && e._reactName && Aa(e._targetInst, null, e) : e && e._reactName && X(e._targetInst, Ba, e);
      l.unstable_batchedUpdates(function () {
        va(b);
        if (e) {
          var a = e._dispatchListeners,
            c = e._dispatchInstances;
          if (L(a)) for (var d = 0; d < a.length && !e.isPropagationStopped(); d++) W(e, a[d], c[d]);else a && W(e, a, c);
          e._dispatchListeners = null;
          e._dispatchInstances = null;
          e.isPersistent() || e.constructor.release(e);
        }
        if (J) throw a = K, J = false, K = null, a;
      });
      wa();
    };
  }
  "blur cancel click close contextMenu copy cut auxClick doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play pointerCancel pointerDown pointerUp rateChange reset resize seeked submit touchCancel touchEnd touchStart volumeChange drag dragEnter dragExit dragLeave dragOver mouseMove mouseOut mouseOver pointerMove pointerOut pointerOver scroll toggle touchMove wheel abort animationEnd animationIteration animationStart canPlay canPlayThrough durationChange emptied encrypted ended error gotPointerCapture load loadedData loadedMetadata loadStart lostPointerCapture playing progress seeking stalled suspend timeUpdate transitionEnd waiting mouseEnter mouseLeave pointerEnter pointerLeave change select beforeInput compositionEnd compositionStart compositionUpdate".split(" ").forEach(function (a) {
    Z[a] = Da(a);
  });
  reactDomTestUtils_production_min.Simulate = Z;
  reactDomTestUtils_production_min.act = xa;
  reactDomTestUtils_production_min.findAllInRenderedTree = S;
  reactDomTestUtils_production_min.findRenderedComponentWithType = function (a, b) {
    O(a, "findRenderedComponentWithType");
    a = V(a, b);
    if (1 !== a.length) throw Error("Did not find exactly one match (found: " + a.length + ") for componentType:" + b);
    return a[0];
  };
  reactDomTestUtils_production_min.findRenderedDOMComponentWithClass = function (a, b) {
    O(a, "findRenderedDOMComponentWithClass");
    a = T(a, b);
    if (1 !== a.length) throw Error("Did not find exactly one match (found: " + a.length + ") for class:" + b);
    return a[0];
  };
  reactDomTestUtils_production_min.findRenderedDOMComponentWithTag = function (a, b) {
    O(a, "findRenderedDOMComponentWithTag");
    a = U(a, b);
    if (1 !== a.length) throw Error("Did not find exactly one match (found: " + a.length + ") for tag:" + b);
    return a[0];
  };
  reactDomTestUtils_production_min.isCompositeComponent = Q;
  reactDomTestUtils_production_min.isCompositeComponentWithType = R;
  reactDomTestUtils_production_min.isDOMComponent = P;
  reactDomTestUtils_production_min.isDOMComponentElement = function (a) {
    return !!(a && k.isValidElement(a) && a.tagName);
  };
  reactDomTestUtils_production_min.isElement = function (a) {
    return k.isValidElement(a);
  };
  reactDomTestUtils_production_min.isElementOfType = function (a, b) {
    return k.isValidElement(a) && a.type === b;
  };
  reactDomTestUtils_production_min.mockComponent = function (a, b) {
    b = b || a.mockTagName || "div";
    a.prototype.render.mockImplementation(function () {
      return k.createElement(b, null, this.props.children);
    });
    return this;
  };
  reactDomTestUtils_production_min.nativeTouchData = function (a, b) {
    return {
      touches: [{
        pageX: a,
        pageY: b
      }]
    };
  };
  reactDomTestUtils_production_min.renderIntoDocument = function (a) {
    var b = document.createElement("div");
    return l.render(a, b);
  };
  reactDomTestUtils_production_min.scryRenderedComponentsWithType = V;
  reactDomTestUtils_production_min.scryRenderedDOMComponentsWithClass = T;
  reactDomTestUtils_production_min.scryRenderedDOMComponentsWithTag = U;
  reactDomTestUtils_production_min.traverseTwoPhase = X;
  return reactDomTestUtils_production_min;
}

var reactDomTestUtils_development = {};

/**
 * @license React
 * react-dom-test-utils.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactDomTestUtils_development;
function requireReactDomTestUtils_development() {
  if (hasRequiredReactDomTestUtils_development) return reactDomTestUtils_development;
  hasRequiredReactDomTestUtils_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function () {

      var React = React__default;
      var ReactDOM = ReactDOM__default;
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

      // by calls to these methods by a Babel plugin.
      //
      // In PROD (or in packages without access to React internals),
      // they are left as they are instead.

      function warn(format) {
        {
          {
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }
            printWarning('warn', format, args);
          }
        }
      }
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning('error', format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum();
          if (stack !== '') {
            format += '%s';
            args = args.concat([stack]);
          } // eslint-disable-next-line react-internal/safe-string-coercion

          var argsWithFormat = args.map(function (item) {
            return String(item);
          }); // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610
          // eslint-disable-next-line react-internal/no-production-logging

          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }

      /**
       * `ReactInstanceMap` maintains a mapping from a public facing stateful
       * instance (key) and the internal representation (value). This allows public
       * methods to accept the user facing instance as an argument and map them back
       * to internal methods.
       *
       * Note that this module is currently shared and assumed to be stateless.
       * If this becomes an actual Map, that will break.
       */
      function get(key) {
        return key._reactInternals;
      }
      var FunctionComponent = 0;
      var ClassComponent = 1;
      var HostRoot = 3; // Root of a host tree. Could be nested inside another node.

      var HostComponent = 5;
      var HostText = 6;

      // Don't change these two values. They're used by React Dev Tools.
      var NoFlags = /*                      */
      0;
      var Placement = /*                    */
      2;
      var Hydrating = /*                    */
      4096;
      ReactSharedInternals.ReactCurrentOwner;
      function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
          // If there is no alternate, this might be a new tree that isn't inserted
          // yet. If it is, then it will have a pending insertion effect on it.
          var nextNode = node;
          do {
            node = nextNode;
            if ((node.flags & (Placement | Hydrating)) !== NoFlags) {
              // This is an insertion or in-progress hydration. The nearest possible
              // mounted fiber is the parent but we need to continue to figure out
              // if that one is still mounted.
              nearestMounted = node.return;
            }
            nextNode = node.return;
          } while (nextNode);
        } else {
          while (node.return) {
            node = node.return;
          }
        }
        if (node.tag === HostRoot) {
          // TODO: Check if this was a nested HostRoot when used with
          // renderContainerIntoSubtree.
          return nearestMounted;
        } // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.

        return null;
      }
      function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) {
          throw new Error('Unable to find node on an unmounted component.');
        }
      }
      function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
          // If there is no alternate, then we only need to check if it is mounted.
          var nearestMounted = getNearestMountedFiber(fiber);
          if (nearestMounted === null) {
            throw new Error('Unable to find node on an unmounted component.');
          }
          if (nearestMounted !== fiber) {
            return null;
          }
          return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.

        var a = fiber;
        var b = alternate;
        while (true) {
          var parentA = a.return;
          if (parentA === null) {
            // We're at the root.
            break;
          }
          var parentB = parentA.alternate;
          if (parentB === null) {
            // There is no alternate. This is an unusual case. Currently, it only
            // happens when a Suspense component is hidden. An extra fragment fiber
            // is inserted in between the Suspense fiber and its children. Skip
            // over this extra fragment fiber and proceed to the next parent.
            var nextParent = parentA.return;
            if (nextParent !== null) {
              a = b = nextParent;
              continue;
            } // If there's no parent, we're at the root.

            break;
          } // If both copies of the parent fiber point to the same child, we can
          // assume that the child is current. This happens when we bailout on low
          // priority: the bailed out fiber's child reuses the current child.

          if (parentA.child === parentB.child) {
            var child = parentA.child;
            while (child) {
              if (child === a) {
                // We've determined that A is the current branch.
                assertIsMounted(parentA);
                return fiber;
              }
              if (child === b) {
                // We've determined that B is the current branch.
                assertIsMounted(parentA);
                return alternate;
              }
              child = child.sibling;
            } // We should never have an alternate for any mounting node. So the only
            // way this could possibly happen is if this was unmounted, if at all.

            throw new Error('Unable to find node on an unmounted component.');
          }
          if (a.return !== b.return) {
            // The return pointer of A and the return pointer of B point to different
            // fibers. We assume that return pointers never criss-cross, so A must
            // belong to the child set of A.return, and B must belong to the child
            // set of B.return.
            a = parentA;
            b = parentB;
          } else {
            // The return pointers point to the same fiber. We'll have to use the
            // default, slow path: scan the child sets of each parent alternate to see
            // which child belongs to which set.
            //
            // Search parent A's child set
            var didFindChild = false;
            var _child = parentA.child;
            while (_child) {
              if (_child === a) {
                didFindChild = true;
                a = parentA;
                b = parentB;
                break;
              }
              if (_child === b) {
                didFindChild = true;
                b = parentA;
                a = parentB;
                break;
              }
              _child = _child.sibling;
            }
            if (!didFindChild) {
              // Search parent B's child set
              _child = parentB.child;
              while (_child) {
                if (_child === a) {
                  didFindChild = true;
                  a = parentB;
                  b = parentA;
                  break;
                }
                if (_child === b) {
                  didFindChild = true;
                  b = parentB;
                  a = parentA;
                  break;
                }
                _child = _child.sibling;
              }
              if (!didFindChild) {
                throw new Error('Child was not found in either parent set. This indicates a bug ' + 'in React related to the return pointer. Please file an issue.');
              }
            }
          }
          if (a.alternate !== b) {
            throw new Error("Return fibers should always be each others' alternates. " + 'This error is likely caused by a bug in React. Please file an issue.');
          }
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.

        if (a.tag !== HostRoot) {
          throw new Error('Unable to find node on an unmounted component.');
        }
        if (a.stateNode.current === a) {
          // We've determined that A is the current branch.
          return fiber;
        } // Otherwise B has to be current branch.

        return alternate;
      }
      var assign = Object.assign;

      /**
       * `charCode` represents the actual "character code" and is safe to use with
       * `String.fromCharCode`. As such, only keys that correspond to printable
       * characters produce a valid `charCode`, the only exception to this is Enter.
       * The Tab-key is considered non-printable and does not have a `charCode`,
       * presumably because it does not produce a tab-character in browsers.
       *
       * @param {object} nativeEvent Native browser event.
       * @return {number} Normalized `charCode` property.
       */
      function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ('charCode' in nativeEvent) {
          charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.

          if (charCode === 0 && keyCode === 13) {
            charCode = 13;
          }
        } else {
          // IE8 does not implement `charCode`, but `keyCode` has the correct value.
          charCode = keyCode;
        } // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.

        if (charCode === 10) {
          charCode = 13;
        } // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.

        if (charCode >= 32 || charCode === 13) {
          return charCode;
        }
        return 0;
      }
      function functionThatReturnsTrue() {
        return true;
      }
      function functionThatReturnsFalse() {
        return false;
      } // This is intentionally a factory so that we have different returned constructors.
      // If we had a single constructor, it would be megamorphic and engines would deopt.

      function createSyntheticEvent(Interface) {
        /**
         * Synthetic events are dispatched by event plugins, typically in response to a
         * top-level event delegation handler.
         *
         * These systems should generally use pooling to reduce the frequency of garbage
         * collection. The system should check `isPersistent` to determine whether the
         * event should be released into the pool after being dispatched. Users that
         * need a persisted event should invoke `persist`.
         *
         * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
         * normalizing browser quirks. Subclasses do not necessarily have to implement a
         * DOM interface; custom application-specific events can also subclass this.
         */
        function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
          this._reactName = reactName;
          this._targetInst = targetInst;
          this.type = reactEventType;
          this.nativeEvent = nativeEvent;
          this.target = nativeEventTarget;
          this.currentTarget = null;
          for (var _propName in Interface) {
            if (!Interface.hasOwnProperty(_propName)) {
              continue;
            }
            var normalize = Interface[_propName];
            if (normalize) {
              this[_propName] = normalize(nativeEvent);
            } else {
              this[_propName] = nativeEvent[_propName];
            }
          }
          var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
          if (defaultPrevented) {
            this.isDefaultPrevented = functionThatReturnsTrue;
          } else {
            this.isDefaultPrevented = functionThatReturnsFalse;
          }
          this.isPropagationStopped = functionThatReturnsFalse;
          return this;
        }
        assign(SyntheticBaseEvent.prototype, {
          preventDefault: function () {
            this.defaultPrevented = true;
            var event = this.nativeEvent;
            if (!event) {
              return;
            }
            if (event.preventDefault) {
              event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
            } else if (typeof event.returnValue !== 'unknown') {
              event.returnValue = false;
            }
            this.isDefaultPrevented = functionThatReturnsTrue;
          },
          stopPropagation: function () {
            var event = this.nativeEvent;
            if (!event) {
              return;
            }
            if (event.stopPropagation) {
              event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
            } else if (typeof event.cancelBubble !== 'unknown') {
              // The ChangeEventPlugin registers a "propertychange" event for
              // IE. This event does not support bubbling or cancelling, and
              // any references to cancelBubble throw "Member not found".  A
              // typeof check of "unknown" circumvents this issue (and is also
              // IE specific).
              event.cancelBubble = true;
            }
            this.isPropagationStopped = functionThatReturnsTrue;
          },
          /**
           * We release all dispatched `SyntheticEvent`s after each event loop, adding
           * them back into the pool. This allows a way to hold onto a reference that
           * won't be added back into the pool.
           */
          persist: function () {// Modern event system doesn't use pooling.
          },
          /**
           * Checks if this event should be released back into the pool.
           *
           * @return {boolean} True if this should not be released, false otherwise.
           */
          isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
      }
      /**
       * @interface Event
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function (event) {
          return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
      };
      var SyntheticEvent = createSyntheticEvent(EventInterface);
      var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
      });
      createSyntheticEvent(UIEventInterface);
      var lastMovementX;
      var lastMovementY;
      var lastMouseEvent;
      function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
          if (lastMouseEvent && event.type === 'mousemove') {
            lastMovementX = event.screenX - lastMouseEvent.screenX;
            lastMovementY = event.screenY - lastMouseEvent.screenY;
          } else {
            lastMovementX = 0;
            lastMovementY = 0;
          }
          lastMouseEvent = event;
        }
      }
      /**
       * @interface MouseEvent
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function (event) {
          if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
          return event.relatedTarget;
        },
        movementX: function (event) {
          if ('movementX' in event) {
            return event.movementX;
          }
          updateMouseMovementPolyfillState(event);
          return lastMovementX;
        },
        movementY: function (event) {
          if ('movementY' in event) {
            return event.movementY;
          } // Don't need to call updateMouseMovementPolyfillState() here
          // because it's guaranteed to have already run when movementX
          // was copied.

          return lastMovementY;
        }
      });
      createSyntheticEvent(MouseEventInterface);
      /**
       * @interface DragEvent
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
      });
      createSyntheticEvent(DragEventInterface);
      /**
       * @interface FocusEvent
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
      });
      createSyntheticEvent(FocusEventInterface);
      /**
       * @interface Event
       * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
       * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
       */

      var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      });
      createSyntheticEvent(AnimationEventInterface);
      /**
       * @interface Event
       * @see http://www.w3.org/TR/clipboard-apis/
       */

      var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function (event) {
          return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
        }
      });
      createSyntheticEvent(ClipboardEventInterface);
      /**
       * @interface Event
       * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
       */

      var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
      });
      createSyntheticEvent(CompositionEventInterface);
      /**
       * Normalization of deprecated HTML5 `key` values
       * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
       */

      var normalizeKey = {
        Esc: 'Escape',
        Spacebar: ' ',
        Left: 'ArrowLeft',
        Up: 'ArrowUp',
        Right: 'ArrowRight',
        Down: 'ArrowDown',
        Del: 'Delete',
        Win: 'OS',
        Menu: 'ContextMenu',
        Apps: 'ContextMenu',
        Scroll: 'ScrollLock',
        MozPrintableKey: 'Unidentified'
      };
      /**
       * Translation from legacy `keyCode` to HTML5 `key`
       * Only special keys supported, all others depend on keyboard layout or browser
       * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
       */

      var translateToKey = {
        '8': 'Backspace',
        '9': 'Tab',
        '12': 'Clear',
        '13': 'Enter',
        '16': 'Shift',
        '17': 'Control',
        '18': 'Alt',
        '19': 'Pause',
        '20': 'CapsLock',
        '27': 'Escape',
        '32': ' ',
        '33': 'PageUp',
        '34': 'PageDown',
        '35': 'End',
        '36': 'Home',
        '37': 'ArrowLeft',
        '38': 'ArrowUp',
        '39': 'ArrowRight',
        '40': 'ArrowDown',
        '45': 'Insert',
        '46': 'Delete',
        '112': 'F1',
        '113': 'F2',
        '114': 'F3',
        '115': 'F4',
        '116': 'F5',
        '117': 'F6',
        '118': 'F7',
        '119': 'F8',
        '120': 'F9',
        '121': 'F10',
        '122': 'F11',
        '123': 'F12',
        '144': 'NumLock',
        '145': 'ScrollLock',
        '224': 'Meta'
      };
      /**
       * @param {object} nativeEvent Native browser event.
       * @return {string} Normalized `key` property.
       */

      function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
          // Normalize inconsistent values reported by browsers due to
          // implementations of a working draft specification.
          // FireFox implements `key` but returns `MozPrintableKey` for all
          // printable characters (normalized to `Unidentified`), ignore it.
          var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
          if (key !== 'Unidentified') {
            return key;
          }
        } // Browser does not implement `key`, polyfill as much of it as we can.

        if (nativeEvent.type === 'keypress') {
          var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
          // thus be captured by `keypress`, no other non-printable key should.

          return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
          // While user keyboard layout determines the actual meaning of each
          // `keyCode` value, almost all function keys have a universal value.
          return translateToKey[nativeEvent.keyCode] || 'Unidentified';
        }
        return '';
      }
      /**
       * Translation from modifier key to the associated property in the event.
       * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
       */

      var modifierKeyToProp = {
        Alt: 'altKey',
        Control: 'ctrlKey',
        Meta: 'metaKey',
        Shift: 'shiftKey'
      }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
      // getModifierState. If getModifierState is not supported, we map it to a set of
      // modifier keys exposed by the event. In this case, Lock-keys are not supported.

      function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) {
          return nativeEvent.getModifierState(keyArg);
        }
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
      }
      function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
      }
      /**
       * @interface KeyboardEvent
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function (event) {
          // `charCode` is the result of a KeyPress event and represents the value of
          // the actual printable character.
          // KeyPress is deprecated, but its replacement is not yet final and not
          // implemented in any major browser. Only KeyPress has charCode.
          if (event.type === 'keypress') {
            return getEventCharCode(event);
          }
          return 0;
        },
        keyCode: function (event) {
          // `keyCode` is the result of a KeyDown/Up event and represents the value of
          // physical keyboard key.
          // The actual meaning of the value depends on the users' keyboard layout
          // which cannot be detected. Assuming that it is a US keyboard layout
          // provides a surprisingly accurate mapping for US and European users.
          // Due to this, it is left to the user to implement at this time.
          if (event.type === 'keydown' || event.type === 'keyup') {
            return event.keyCode;
          }
          return 0;
        },
        which: function (event) {
          // `which` is an alias for either `keyCode` or `charCode` depending on the
          // type of the event.
          if (event.type === 'keypress') {
            return getEventCharCode(event);
          }
          if (event.type === 'keydown' || event.type === 'keyup') {
            return event.keyCode;
          }
          return 0;
        }
      });
      createSyntheticEvent(KeyboardEventInterface);
      /**
       * @interface PointerEvent
       * @see http://www.w3.org/TR/pointerevents/
       */

      var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
      });
      createSyntheticEvent(PointerEventInterface);
      /**
       * @interface TouchEvent
       * @see http://www.w3.org/TR/touch-events/
       */

      var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
      });
      createSyntheticEvent(TouchEventInterface);
      /**
       * @interface Event
       * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
       * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
       */

      var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      });
      createSyntheticEvent(TransitionEventInterface);
      /**
       * @interface WheelEvent
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function (event) {
          return 'deltaX' in event ? event.deltaX :
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function (event) {
          return 'deltaY' in event ? event.deltaY :
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          'wheelDeltaY' in event ? -event.wheelDeltaY :
          // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
          'wheelDelta' in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
      });
      createSyntheticEvent(WheelEventInterface);

      /**
       * HTML nodeType values that represent the type of the node
       */
      var ELEMENT_NODE = 1;
      function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
          func.apply(context, funcArgs);
        } catch (error) {
          this.onError(error);
        }
      }
      var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
      {
        // In DEV mode, we swap out invokeGuardedCallback for a special version
        // that plays more nicely with the browser's DevTools. The idea is to preserve
        // "Pause on exceptions" behavior. Because React wraps all user-provided
        // functions in invokeGuardedCallback, and the production version of
        // invokeGuardedCallback uses a try-catch, all user exceptions are treated
        // like caught exceptions, and the DevTools won't pause unless the developer
        // takes the extra step of enabling pause on caught exceptions. This is
        // unintuitive, though, because even though React has caught the error, from
        // the developer's perspective, the error is uncaught.
        //
        // To preserve the expected "Pause on exceptions" behavior, we don't use a
        // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
        // DOM node, and call the user-provided callback from inside an event handler
        // for that fake event. If the callback throws, the error is "captured" using
        // a global event handler. But because the error happens in a different
        // event loop context, it does not interrupt the normal program flow.
        // Effectively, this gives us try-catch behavior without actually using
        // try-catch. Neat!
        // Check that the browser supports the APIs we need to implement our special
        // DEV version of invokeGuardedCallback
        if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
          var fakeNode = document.createElement('react');
          invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebook/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (typeof document === 'undefined' || document === null) {
              throw new Error('The `document` global was defined when React was initialized, but is not ' + 'defined anymore. This can happen in a test environment if a component ' + 'schedules an update from an asynchronous callback, but the test has already ' + 'finished running. To solve this, you can either unmount the component at ' + 'the end of your test (and ensure that any asynchronous operations get ' + 'canceled in `componentWillUnmount`), or you can change the test itself ' + 'to be asynchronous.');
            }
            var evt = document.createEvent('Event');
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.

            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.

            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688

            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event');
            function restoreAfterDispatch() {
              // We immediately remove the callback from event listeners so that
              // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
              // nested call would trigger the fake event handlers of any call higher
              // in the stack.
              fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
              // window.event assignment in both IE <= 10 as they throw an error
              // "Member not found" in strict mode, and in Firefox which does not
              // support window.event.

              if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) {
                window.event = windowEvent;
              }
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.

            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
              didCall = true;
              restoreAfterDispatch();
              func.apply(context, funcArgs);
              didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.

            var error; // Use this to track whether the error event is ever called.

            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
              error = event.error;
              didSetError = true;
              if (error === null && event.colno === 0 && event.lineno === 0) {
                isCrossOriginError = true;
              }
              if (event.defaultPrevented) {
                // Some other error handler has prevented default.
                // Browsers silence the error report if this happens.
                // We'll remember this to later decide whether to log it or not.
                if (error != null && typeof error === 'object') {
                  try {
                    error._suppressLogging = true;
                  } catch (inner) {// Ignore.
                  }
                }
              }
            } // Create a fake event type.

            var evtType = "react-" + (name ? name : 'invokeguardedcallback'); // Attach our event handlers

            window.addEventListener('error', handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.

            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) {
              Object.defineProperty(window, 'event', windowEventDescriptor);
            }
            if (didCall && didError) {
              if (!didSetError) {
                // The callback errored, but the error event never fired.
                // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error('An error was thrown inside one of your components, but React ' + "doesn't know what it was. This is likely due to browser " + 'flakiness. React does its best to preserve the "Pause on ' + 'exceptions" behavior of the DevTools, which requires some ' + "DEV-mode only tricks. It's possible that these don't work in " + 'your browser. Try triggering the error in production mode, ' + 'or switching to a modern browser. If you suspect that this is ' + 'actually an issue with React, please file an issue.');
              } else if (isCrossOriginError) {
                // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("A cross-origin error was thrown. React doesn't have access to " + 'the actual error object in development. ' + 'See https://reactjs.org/link/crossorigin-error for more information.');
              }
              this.onError(error);
            } // Remove our event listeners

            window.removeEventListener('error', handleWindowError);
            if (!didCall) {
              // Something went really wrong, and our event was not dispatched.
              // https://github.com/facebook/react/issues/16734
              // https://github.com/facebook/react/issues/16585
              // Fall back to the production implementation.
              restoreAfterDispatch();
              return invokeGuardedCallbackProd.apply(this, arguments);
            }
          };
        }
      }
      var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
      var hasError = false;
      var caughtError = null; // Used by event system to capture/rethrow the first error.

      var hasRethrowError = false;
      var rethrowError = null;
      var reporter = {
        onError: function (error) {
          hasError = true;
          caughtError = error;
        }
      };
      /**
       * Call a function while guarding against errors that happens within it.
       * Returns an error if it throws, otherwise null.
       *
       * In production, this is implemented using a try-catch. The reason we don't
       * use a try-catch directly is so that we can swap out a different
       * implementation in DEV mode.
       *
       * @param {String} name of the guard to use for logging or debugging
       * @param {Function} func The function to invoke
       * @param {*} context The context to use when calling the function
       * @param {...*} args Arguments for function
       */

      function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
      }
      /**
       * Same as invokeGuardedCallback, but instead of returning an error, it stores
       * it in a global so it can be rethrown by `rethrowCaughtError` later.
       * TODO: See if caughtError and rethrowError can be unified.
       *
       * @param {String} name of the guard to use for logging or debugging
       * @param {Function} func The function to invoke
       * @param {*} context The context to use when calling the function
       * @param {...*} args Arguments for function
       */

      function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
          var error = clearCaughtError();
          if (!hasRethrowError) {
            hasRethrowError = true;
            rethrowError = error;
          }
        }
      }
      /**
       * During execution of guarded functions we will capture the first error which
       * we will rethrow to be handled by the top level error handler.
       */

      function rethrowCaughtError() {
        if (hasRethrowError) {
          var error = rethrowError;
          hasRethrowError = false;
          rethrowError = null;
          throw error;
        }
      }
      function clearCaughtError() {
        if (hasError) {
          var error = caughtError;
          hasError = false;
          caughtError = null;
          return error;
        } else {
          throw new Error('clearCaughtError was called but no error was captured. This error ' + 'is likely caused by a bug in React. Please file an issue.');
        }
      }
      var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

      function isArray(a) {
        return isArrayImpl(a);
      }
      var SecretInternals = ReactDOM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      var EventInternals = SecretInternals.Events;
      var getInstanceFromNode = EventInternals[0];
      var getNodeFromInstance = EventInternals[1];
      var getFiberCurrentPropsFromNode = EventInternals[2];
      var enqueueStateRestore = EventInternals[3];
      var restoreStateIfNeeded = EventInternals[4];
      var act = React.unstable_act;
      function Event(suffix) {}
      var hasWarnedAboutDeprecatedMockComponent = false;
      /**
       * @class ReactTestUtils
       */

      function findAllInRenderedFiberTreeInternal(fiber, test) {
        if (!fiber) {
          return [];
        }
        var currentParent = findCurrentFiberUsingSlowPath(fiber);
        if (!currentParent) {
          return [];
        }
        var node = currentParent;
        var ret = [];
        while (true) {
          if (node.tag === HostComponent || node.tag === HostText || node.tag === ClassComponent || node.tag === FunctionComponent) {
            var publicInst = node.stateNode;
            if (test(publicInst)) {
              ret.push(publicInst);
            }
          }
          if (node.child) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === currentParent) {
            return ret;
          }
          while (!node.sibling) {
            if (!node.return || node.return === currentParent) {
              return ret;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
      }
      function validateClassInstance(inst, methodName) {
        if (!inst) {
          // This is probably too relaxed but it's existing behavior.
          return;
        }
        if (get(inst)) {
          // This is a public instance indeed.
          return;
        }
        var received;
        var stringified = String(inst);
        if (isArray(inst)) {
          received = 'an array';
        } else if (inst && inst.nodeType === ELEMENT_NODE && inst.tagName) {
          received = 'a DOM node';
        } else if (stringified === '[object Object]') {
          received = 'object with keys {' + Object.keys(inst).join(', ') + '}';
        } else {
          received = stringified;
        }
        throw new Error(methodName + "(...): the first argument must be a React class instance. " + ("Instead received: " + received + "."));
      }
      /**
       * Utilities for making it easy to test React components.
       *
       * See https://reactjs.org/docs/test-utils.html
       *
       * Todo: Support the entire DOM.scry query syntax. For now, these simple
       * utilities will suffice for testing purposes.
       * @lends ReactTestUtils
       */

      function renderIntoDocument(element) {
        var div = document.createElement('div'); // None of our tests actually require attaching the container to the
        // DOM, and doing so creates a mess that we rely on test isolation to
        // clean up, so we're going to stop honoring the name of this method
        // (and probably rename it eventually) if no problems arise.
        // document.documentElement.appendChild(div);

        return ReactDOM.render(element, div);
      }
      function isElement(element) {
        return React.isValidElement(element);
      }
      function isElementOfType(inst, convenienceConstructor) {
        return React.isValidElement(inst) && inst.type === convenienceConstructor;
      }
      function isDOMComponent(inst) {
        return !!(inst && inst.nodeType === ELEMENT_NODE && inst.tagName);
      }
      function isDOMComponentElement(inst) {
        return !!(inst && React.isValidElement(inst) && !!inst.tagName);
      }
      function isCompositeComponent(inst) {
        if (isDOMComponent(inst)) {
          // Accessing inst.setState warns; just return false as that'll be what
          // this returns when we have DOM nodes as refs directly
          return false;
        }
        return inst != null && typeof inst.render === 'function' && typeof inst.setState === 'function';
      }
      function isCompositeComponentWithType(inst, type) {
        if (!isCompositeComponent(inst)) {
          return false;
        }
        var internalInstance = get(inst);
        var constructor = internalInstance.type;
        return constructor === type;
      }
      function findAllInRenderedTree(inst, test) {
        validateClassInstance(inst, 'findAllInRenderedTree');
        if (!inst) {
          return [];
        }
        var internalInstance = get(inst);
        return findAllInRenderedFiberTreeInternal(internalInstance, test);
      }
      /**
       * Finds all instances of components in the rendered tree that are DOM
       * components with the class name matching `className`.
       * @return {array} an array of all the matches.
       */

      function scryRenderedDOMComponentsWithClass(root, classNames) {
        validateClassInstance(root, 'scryRenderedDOMComponentsWithClass');
        return findAllInRenderedTree(root, function (inst) {
          if (isDOMComponent(inst)) {
            var className = inst.className;
            if (typeof className !== 'string') {
              // SVG, probably.
              className = inst.getAttribute('class') || '';
            }
            var classList = className.split(/\s+/);
            if (!isArray(classNames)) {
              if (classNames === undefined) {
                throw new Error('TestUtils.scryRenderedDOMComponentsWithClass expects a ' + 'className as a second argument.');
              }
              classNames = classNames.split(/\s+/);
            }
            return classNames.every(function (name) {
              return classList.indexOf(name) !== -1;
            });
          }
          return false;
        });
      }
      /**
       * Like scryRenderedDOMComponentsWithClass but expects there to be one result,
       * and returns that one result, or throws exception if there is any other
       * number of matches besides one.
       * @return {!ReactDOMComponent} The one match.
       */

      function findRenderedDOMComponentWithClass(root, className) {
        validateClassInstance(root, 'findRenderedDOMComponentWithClass');
        var all = scryRenderedDOMComponentsWithClass(root, className);
        if (all.length !== 1) {
          throw new Error('Did not find exactly one match (found: ' + all.length + ') ' + 'for class:' + className);
        }
        return all[0];
      }
      /**
       * Finds all instances of components in the rendered tree that are DOM
       * components with the tag name matching `tagName`.
       * @return {array} an array of all the matches.
       */

      function scryRenderedDOMComponentsWithTag(root, tagName) {
        validateClassInstance(root, 'scryRenderedDOMComponentsWithTag');
        return findAllInRenderedTree(root, function (inst) {
          return isDOMComponent(inst) && inst.tagName.toUpperCase() === tagName.toUpperCase();
        });
      }
      /**
       * Like scryRenderedDOMComponentsWithTag but expects there to be one result,
       * and returns that one result, or throws exception if there is any other
       * number of matches besides one.
       * @return {!ReactDOMComponent} The one match.
       */

      function findRenderedDOMComponentWithTag(root, tagName) {
        validateClassInstance(root, 'findRenderedDOMComponentWithTag');
        var all = scryRenderedDOMComponentsWithTag(root, tagName);
        if (all.length !== 1) {
          throw new Error('Did not find exactly one match (found: ' + all.length + ') ' + 'for tag:' + tagName);
        }
        return all[0];
      }
      /**
       * Finds all instances of components with type equal to `componentType`.
       * @return {array} an array of all the matches.
       */

      function scryRenderedComponentsWithType(root, componentType) {
        validateClassInstance(root, 'scryRenderedComponentsWithType');
        return findAllInRenderedTree(root, function (inst) {
          return isCompositeComponentWithType(inst, componentType);
        });
      }
      /**
       * Same as `scryRenderedComponentsWithType` but expects there to be one result
       * and returns that one result, or throws exception if there is any other
       * number of matches besides one.
       * @return {!ReactComponent} The one match.
       */

      function findRenderedComponentWithType(root, componentType) {
        validateClassInstance(root, 'findRenderedComponentWithType');
        var all = scryRenderedComponentsWithType(root, componentType);
        if (all.length !== 1) {
          throw new Error('Did not find exactly one match (found: ' + all.length + ') ' + 'for componentType:' + componentType);
        }
        return all[0];
      }
      /**
       * Pass a mocked component module to this method to augment it with
       * useful methods that allow it to be used as a dummy React component.
       * Instead of rendering as usual, the component will become a simple
       * <div> containing any provided children.
       *
       * @param {object} module the mock function object exported from a
       *                        module that defines the component to be mocked
       * @param {?string} mockTagName optional dummy root tag name to return
       *                              from render method (overrides
       *                              module.mockTagName if provided)
       * @return {object} the ReactTestUtils object (for chaining)
       */

      function mockComponent(module, mockTagName) {
        {
          if (!hasWarnedAboutDeprecatedMockComponent) {
            hasWarnedAboutDeprecatedMockComponent = true;
            warn('ReactTestUtils.mockComponent() is deprecated. ' + 'Use shallow rendering or jest.mock() instead.\n\n' + 'See https://reactjs.org/link/test-utils-mock-component for more information.');
          }
        }
        mockTagName = mockTagName || module.mockTagName || 'div';
        module.prototype.render.mockImplementation(function () {
          return React.createElement(mockTagName, null, this.props.children);
        });
        return this;
      }
      function nativeTouchData(x, y) {
        return {
          touches: [{
            pageX: x,
            pageY: y
          }]
        };
      } // Start of inline: the below functions were inlined from
      // EventPropagator.js, as they deviated from ReactDOM's newer
      // implementations.

      /**
       * Dispatch the event to the listener.
       * @param {SyntheticEvent} event SyntheticEvent to handle
       * @param {function} listener Application-level callback
       * @param {*} inst Internal component instance
       */

      function executeDispatch(event, listener, inst) {
        var type = event.type || 'unknown-event';
        event.currentTarget = getNodeFromInstance(inst);
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
      }
      /**
       * Standard/simple iteration through an event's collected dispatches.
       */

      function executeDispatchesInOrder(event) {
        var dispatchListeners = event._dispatchListeners;
        var dispatchInstances = event._dispatchInstances;
        if (isArray(dispatchListeners)) {
          for (var i = 0; i < dispatchListeners.length; i++) {
            if (event.isPropagationStopped()) {
              break;
            } // Listeners and Instances are two parallel arrays that are always in sync.

            executeDispatch(event, dispatchListeners[i], dispatchInstances[i]);
          }
        } else if (dispatchListeners) {
          executeDispatch(event, dispatchListeners, dispatchInstances);
        }
        event._dispatchListeners = null;
        event._dispatchInstances = null;
      }
      /**
       * Dispatches an event and releases it back into the pool, unless persistent.
       *
       * @param {?object} event Synthetic event to be dispatched.
       * @private
       */

      var executeDispatchesAndRelease = function (event) {
        if (event) {
          executeDispatchesInOrder(event);
          if (!event.isPersistent()) {
            event.constructor.release(event);
          }
        }
      };
      function isInteractive(tag) {
        return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
      }
      function getParent(inst) {
        do {
          inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
          // That is depending on if we want nested subtrees (layers) to bubble
          // events to their parent. We could also go through parentNode on the
          // host node but that wouldn't work for React Native and doesn't let us
          // do the portal feature.
        } while (inst && inst.tag !== HostComponent);
        if (inst) {
          return inst;
        }
        return null;
      }
      /**
       * Simulates the traversal of a two-phase, capture/bubble event dispatch.
       */

      function traverseTwoPhase(inst, fn, arg) {
        var path = [];
        while (inst) {
          path.push(inst);
          inst = getParent(inst);
        }
        var i;
        for (i = path.length; i-- > 0;) {
          fn(path[i], 'captured', arg);
        }
        for (i = 0; i < path.length; i++) {
          fn(path[i], 'bubbled', arg);
        }
      }
      function shouldPreventMouseEvent(name, type, props) {
        switch (name) {
          case 'onClick':
          case 'onClickCapture':
          case 'onDoubleClick':
          case 'onDoubleClickCapture':
          case 'onMouseDown':
          case 'onMouseDownCapture':
          case 'onMouseMove':
          case 'onMouseMoveCapture':
          case 'onMouseUp':
          case 'onMouseUpCapture':
          case 'onMouseEnter':
            return !!(props.disabled && isInteractive(type));
          default:
            return false;
        }
      }
      /**
       * @param {object} inst The instance, which is the source of events.
       * @param {string} registrationName Name of listener (e.g. `onClick`).
       * @return {?function} The stored callback.
       */

      function getListener(inst, registrationName) {
        // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
        // live here; needs to be moved to a better place soon
        var stateNode = inst.stateNode;
        if (!stateNode) {
          // Work in progress (ex: onload events in incremental mode).
          return null;
        }
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (!props) {
          // Work in progress.
          return null;
        }
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) {
          return null;
        }
        if (listener && typeof listener !== 'function') {
          throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        }
        return listener;
      }
      function listenerAtPhase(inst, event, propagationPhase) {
        var registrationName = event._reactName;
        if (propagationPhase === 'captured') {
          registrationName += 'Capture';
        }
        return getListener(inst, registrationName);
      }
      function accumulateDispatches(inst, ignoredDirection, event) {
        if (inst && event && event._reactName) {
          var registrationName = event._reactName;
          var listener = getListener(inst, registrationName);
          if (listener) {
            if (event._dispatchListeners == null) {
              event._dispatchListeners = [];
            }
            if (event._dispatchInstances == null) {
              event._dispatchInstances = [];
            }
            event._dispatchListeners.push(listener);
            event._dispatchInstances.push(inst);
          }
        }
      }
      function accumulateDirectionalDispatches(inst, phase, event) {
        {
          if (!inst) {
            error('Dispatching inst must not be null');
          }
        }
        var listener = listenerAtPhase(inst, event, phase);
        if (listener) {
          if (event._dispatchListeners == null) {
            event._dispatchListeners = [];
          }
          if (event._dispatchInstances == null) {
            event._dispatchInstances = [];
          }
          event._dispatchListeners.push(listener);
          event._dispatchInstances.push(inst);
        }
      }
      function accumulateDirectDispatchesSingle(event) {
        if (event && event._reactName) {
          accumulateDispatches(event._targetInst, null, event);
        }
      }
      function accumulateTwoPhaseDispatchesSingle(event) {
        if (event && event._reactName) {
          traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
        }
      } // End of inline

      var Simulate = {};
      var directDispatchEventTypes = new Set(['mouseEnter', 'mouseLeave', 'pointerEnter', 'pointerLeave']);
      /**
       * Exports:
       *
       * - `Simulate.click(Element)`
       * - `Simulate.mouseMove(Element)`
       * - `Simulate.change(Element)`
       * - ... (All keys from event plugin `eventTypes` objects)
       */

      function makeSimulator(eventType) {
        return function (domNode, eventData) {
          if (React.isValidElement(domNode)) {
            throw new Error('TestUtils.Simulate expected a DOM node as the first argument but received ' + 'a React element. Pass the DOM node you wish to simulate the event on instead. ' + 'Note that TestUtils.Simulate will not work if you are using shallow rendering.');
          }
          if (isCompositeComponent(domNode)) {
            throw new Error('TestUtils.Simulate expected a DOM node as the first argument but received ' + 'a component instance. Pass the DOM node you wish to simulate the event on instead.');
          }
          var reactName = 'on' + eventType[0].toUpperCase() + eventType.slice(1);
          var fakeNativeEvent = new Event();
          fakeNativeEvent.target = domNode;
          fakeNativeEvent.type = eventType.toLowerCase();
          var targetInst = getInstanceFromNode(domNode);
          var event = new SyntheticEvent(reactName, fakeNativeEvent.type, targetInst, fakeNativeEvent, domNode); // Since we aren't using pooling, always persist the event. This will make
          // sure it's marked and won't warn when setting additional properties.

          event.persist();
          assign(event, eventData);
          if (directDispatchEventTypes.has(eventType)) {
            accumulateDirectDispatchesSingle(event);
          } else {
            accumulateTwoPhaseDispatchesSingle(event);
          }
          ReactDOM.unstable_batchedUpdates(function () {
            // Normally extractEvent enqueues a state restore, but we'll just always
            // do that since we're by-passing it here.
            enqueueStateRestore(domNode);
            executeDispatchesAndRelease(event);
            rethrowCaughtError();
          });
          restoreStateIfNeeded();
        };
      } // A one-time snapshot with no plans to update. We'll probably want to deprecate Simulate API.

      var simulatedEventTypes = ['blur', 'cancel', 'click', 'close', 'contextMenu', 'copy', 'cut', 'auxClick', 'doubleClick', 'dragEnd', 'dragStart', 'drop', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'mouseDown', 'mouseUp', 'paste', 'pause', 'play', 'pointerCancel', 'pointerDown', 'pointerUp', 'rateChange', 'reset', 'resize', 'seeked', 'submit', 'touchCancel', 'touchEnd', 'touchStart', 'volumeChange', 'drag', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'mouseMove', 'mouseOut', 'mouseOver', 'pointerMove', 'pointerOut', 'pointerOver', 'scroll', 'toggle', 'touchMove', 'wheel', 'abort', 'animationEnd', 'animationIteration', 'animationStart', 'canPlay', 'canPlayThrough', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'gotPointerCapture', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'lostPointerCapture', 'playing', 'progress', 'seeking', 'stalled', 'suspend', 'timeUpdate', 'transitionEnd', 'waiting', 'mouseEnter', 'mouseLeave', 'pointerEnter', 'pointerLeave', 'change', 'select', 'beforeInput', 'compositionEnd', 'compositionStart', 'compositionUpdate'];
      function buildSimulators() {
        simulatedEventTypes.forEach(function (eventType) {
          Simulate[eventType] = makeSimulator(eventType);
        });
      }
      buildSimulators();
      reactDomTestUtils_development.Simulate = Simulate;
      reactDomTestUtils_development.act = act;
      reactDomTestUtils_development.findAllInRenderedTree = findAllInRenderedTree;
      reactDomTestUtils_development.findRenderedComponentWithType = findRenderedComponentWithType;
      reactDomTestUtils_development.findRenderedDOMComponentWithClass = findRenderedDOMComponentWithClass;
      reactDomTestUtils_development.findRenderedDOMComponentWithTag = findRenderedDOMComponentWithTag;
      reactDomTestUtils_development.isCompositeComponent = isCompositeComponent;
      reactDomTestUtils_development.isCompositeComponentWithType = isCompositeComponentWithType;
      reactDomTestUtils_development.isDOMComponent = isDOMComponent;
      reactDomTestUtils_development.isDOMComponentElement = isDOMComponentElement;
      reactDomTestUtils_development.isElement = isElement;
      reactDomTestUtils_development.isElementOfType = isElementOfType;
      reactDomTestUtils_development.mockComponent = mockComponent;
      reactDomTestUtils_development.nativeTouchData = nativeTouchData;
      reactDomTestUtils_development.renderIntoDocument = renderIntoDocument;
      reactDomTestUtils_development.scryRenderedComponentsWithType = scryRenderedComponentsWithType;
      reactDomTestUtils_development.scryRenderedDOMComponentsWithClass = scryRenderedDOMComponentsWithClass;
      reactDomTestUtils_development.scryRenderedDOMComponentsWithTag = scryRenderedDOMComponentsWithTag;
      reactDomTestUtils_development.traverseTwoPhase = traverseTwoPhase;
    })();
  }
  return reactDomTestUtils_development;
}

var hasRequiredTestUtils;
function requireTestUtils() {
  if (hasRequiredTestUtils) return testUtils.exports;
  hasRequiredTestUtils = 1;
  if (process.env.NODE_ENV === 'production') {
    testUtils.exports = requireReactDomTestUtils_production_min();
  } else {
    testUtils.exports = requireReactDomTestUtils_development();
  }
  return testUtils.exports;
}

var testUtilsExports = requireTestUtils();

var reactAct = testUtilsExports.act;
var actSupported = reactAct !== undefined; // act is supported react-dom@16.8.0
// so for versions that don't have act from test utils
// we do this little polyfill. No warnings, but it's
// better than nothing.

function actPolyfill(cb) {
  ReactDOM__default.unstable_batchedUpdates(cb);
  ReactDOM__default.render( /*#__PURE__*/React.createElement("div", null), document.createElement('div'));
}
var act = reactAct || actPolyfill;
var youHaveBeenWarned = false;
var isAsyncActSupported = null;
function asyncAct(cb) {
  if (actSupported === true) {
    if (isAsyncActSupported === null) {
      return new Promise(function (resolve, reject) {
        // patch console.error here
        var originalConsoleError = console.error;
        console.error = function error() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          /* if console.error fired *with that specific message* */

          /* istanbul ignore next */
          var firstArgIsString = typeof args[0] === 'string';
          if (firstArgIsString && args[0].indexOf('Warning: Do not await the result of calling ReactTestUtils.act') === 0) {
            // v16.8.6
            isAsyncActSupported = false;
          } else if (firstArgIsString && args[0].indexOf('Warning: The callback passed to ReactTestUtils.act(...) function must not return anything') === 0) ;else {
            originalConsoleError.apply(console, args);
          }
        };
        var cbReturn, result;
        try {
          result = reactAct(function () {
            cbReturn = cb();
            return cbReturn;
          });
        } catch (err) {
          console.error = originalConsoleError;
          reject(err);
          return;
        }
        result.then(function () {
          console.error = originalConsoleError; // if it got here, it means async act is supported

          isAsyncActSupported = true;
          resolve();
        }, function (err) {
          console.error = originalConsoleError;
          isAsyncActSupported = true;
          reject(err);
        }); // 16.8.6's act().then() doesn't call a resolve handler, so we need to manually flush here, sigh

        if (isAsyncActSupported === false) {
          console.error = originalConsoleError;
          /* istanbul ignore next */

          if (!youHaveBeenWarned) {
            // if act is supported and async act isn't and they're trying to use async
            // act, then they need to upgrade from 16.8 to 16.9.
            // This is a seamless upgrade, so we'll add a warning
            console.error("It looks like you're using a version of react-dom that supports the \"act\" function, but not an awaitable version of \"act\" which you will need. Please upgrade to at least react-dom@16.9.0 to remove this warning.");
            youHaveBeenWarned = true;
          }
          cbReturn.then(function () {
            // a faux-version.
            // todo - copy https://github.com/facebook/react/blob/master/packages/shared/enqueueTask.js
            Promise.resolve().then(function () {
              // use sync act to flush effects
              act(function () {});
              resolve();
            });
          }, reject);
        }
      });
    } else if (isAsyncActSupported === false) {
      // use the polyfill directly
      var _result;
      act(function () {
        _result = cb();
      });
      return _result.then(function () {
        return Promise.resolve().then(function () {
          // use sync act to flush effects
          act(function () {});
        });
      });
    } // all good! regular act

    return act(cb);
  } // use the polyfill

  var result;
  act(function () {
    result = cb();
  });
  return result.then(function () {
    return Promise.resolve().then(function () {
      // use sync act to flush effects
      act(function () {});
    });
  });
}
/* eslint no-console:0 */

// dom-testing-library's version of fireEvent. The reason
// we make this distinction however is because we have
// a few extra events that work a bit differently

var fireEvent = function fireEvent() {
  return fireEvent$1.apply(void 0, arguments);
};
Object.keys(fireEvent$1).forEach(function (key) {
  fireEvent[key] = function () {
    return fireEvent$1[key].apply(fireEvent$1, arguments);
  };
}); // React event system tracks native mouseOver/mouseOut events for
// running onMouseEnter/onMouseLeave handlers
// @link https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/events/EnterLeaveEventPlugin.js#L24-L31

var mouseEnter = fireEvent.mouseEnter;
var mouseLeave = fireEvent.mouseLeave;
fireEvent.mouseEnter = function () {
  mouseEnter.apply(void 0, arguments);
  return fireEvent.mouseOver.apply(fireEvent, arguments);
};
fireEvent.mouseLeave = function () {
  mouseLeave.apply(void 0, arguments);
  return fireEvent.mouseOut.apply(fireEvent, arguments);
};
var pointerEnter = fireEvent.pointerEnter;
var pointerLeave = fireEvent.pointerLeave;
fireEvent.pointerEnter = function () {
  pointerEnter.apply(void 0, arguments);
  return fireEvent.pointerOver.apply(fireEvent, arguments);
};
fireEvent.pointerLeave = function () {
  pointerLeave.apply(void 0, arguments);
  return fireEvent.pointerOut.apply(fireEvent, arguments);
};
var select = fireEvent.select;
fireEvent.select = function (node, init) {
  select(node, init); // React tracks this event only on focused inputs

  node.focus(); // React creates this event when one of the following native events happens
  // - contextMenu
  // - mouseUp
  // - dragEnd
  // - keyUp
  // - keyDown
  // so we can use any here
  // @link https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/events/SelectEventPlugin.js#L203-L224

  fireEvent.keyUp(node, init);
}; // React event system tracks native focusout/focusin events for
// running blur/focus handlers
// @link https://github.com/facebook/react/pull/19186

var blur = fireEvent.blur;
var focus = fireEvent.focus;
fireEvent.blur = function () {
  fireEvent.focusOut.apply(fireEvent, arguments);
  return blur.apply(void 0, arguments);
};
fireEvent.focus = function () {
  fireEvent.focusIn.apply(fireEvent, arguments);
  return focus.apply(void 0, arguments);
};
configure({
  asyncWrapper: function () {
    var _asyncWrapper = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cb) {
      var result;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return asyncAct( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return cb();
                      case 2:
                        result = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));
            case 2:
              return _context2.abrupt("return", result);
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    function asyncWrapper(_x) {
      return _asyncWrapper.apply(this, arguments);
    }
    return asyncWrapper;
  }(),
  eventWrapper: function eventWrapper(cb) {
    var result;
    act(function () {
      result = cb();
    });
    return result;
  }
});
var mountedContainers = new Set();
function cleanup() {
  mountedContainers.forEach(cleanupAtContainer);
} // maybe one day we'll expose this (perhaps even as a utility returned by render).
// but let's wait until someone asks for it.

function cleanupAtContainer(container) {
  act(function () {
    ReactDOM__default.unmountComponentAtNode(container);
  });
  if (container.parentNode === document.body) {
    document.body.removeChild(container);
  }
  mountedContainers.delete(container);
} // just re-export everything from dom-testing-library
// thing for people using react-dom@16.8.0. Anyone else doesn't need it and
// people should just upgrade anyway.

/* eslint func-name-matching:0 */

var _process$env;
// or teardown then we'll automatically run cleanup afterEach test
// this ensures that tests run in isolation from each other
// if you don't like this then either import the `pure` module
// or set the RTL_SKIP_AUTO_CLEANUP env variable to 'true'.

if (typeof process === 'undefined' || !((_process$env = process.env) != null && _process$env.RTL_SKIP_AUTO_CLEANUP)) {
  // ignore teardown() in code coverage because Jest does not support it

  /* istanbul ignore else */
  if (typeof afterEach === 'function') {
    afterEach(function () {
      cleanup();
    });
  } else if (typeof teardown === 'function') {
    // Block is guarded by `typeof` check.
    // eslint does not support `typeof` guards.
    // eslint-disable-next-line no-undef
    teardown(function () {
      cleanup();
    });
  }
}

const simulateTyping = (inputElement, text) => {
  fireEvent(inputElement, new MouseEvent('click', {
    bubbles: true,
    cancelable: true
  }));
  text.split('').forEach(char => {
    fireEvent.change(inputElement, {
      target: {
        value: inputElement.value + char
      }
    });
  });
};

function Layout$2({
  children
}) {
  return jsxRuntimeExports.jsx("div", {
    children: children
  });
}

function AuthorizationError$1() {
  const location = useLocation();
  const {
    search
  } = location;
  const query = parseQuery(search);
  const applicationPath = query[QUERY_KEY.APPLICATION_PATH];
  const errorDescription = query[QUERY_KEY.ERROR_DESCRIPTION];
  let AuthorizationErrorComponent;
  switch (query[QUERY_KEY.ERROR]) {
    case ERROR_STATUS_NAME.UNAUTHORIZED:
      AuthorizationErrorComponent = UserAuthorizationError;
      break;
    default:
      AuthorizationErrorComponent = AuthorizationServiceError;
  }
  return jsxRuntimeExports.jsx("div", {
    className: "page-container centered-container",
    children: jsxRuntimeExports.jsxs("div", {
      className: "error-page-container",
      children: [jsxRuntimeExports.jsx(ErrorIcon$1, {
        style: {
          fontSize: 100
        },
        color: "disabled"
      }), jsxRuntimeExports.jsx(AuthorizationErrorComponent, {
        applicationPath,
        errorDescription
      })]
    })
  });
}
var AuthorizationError_default = /*#__PURE__*/memo(AuthorizationError$1);
function UserAuthorizationError({
  applicationPath,
  errorDescription
}) {
  const errorMessage = errorDescription?.includes('blocked') ? 'Your account has been disabled. Please contact your administrator if you believe your account should be active.' : 'You are unauthorized. Please contact your administration if you believe this is an error.';
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsx("h4", {
      className: "error-page-title",
      children: "Unauthorized Request"
    }), jsxRuntimeExports.jsx("p", {
      className: "error-page-paragraph",
      children: errorMessage
    }), jsxRuntimeExports.jsx(Button$2, {
      className: "button-warn-outline",
      onClick: () => forceRedirect({
        to: applicationPath
      }),
      children: "Retry Login"
    })]
  });
}
function AuthorizationServiceError({
  errorDescription
}) {
  const history = useHistory();
  // Provide a fallback message if errorDescription is empty or undefined
  const displayError = errorDescription || 'An unexpected authentication error occurred';
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsx("h4", {
      className: "error-page-title",
      children: "Authorization Service Error"
    }), jsxRuntimeExports.jsxs("p", {
      className: "error-page-paragraph",
      children: ["Oops. It appears that the authorization service returned an error:", ' ', displayError, ". If you believe this is an error please contact us."]
    }), jsxRuntimeExports.jsx(Button$2, {
      className: "button-warn-outline",
      onClick: () => history.goBack(),
      children: "Go Back"
    })]
  });
}

function ClientError() {
  const location = useLocation();
  const {
    search
  } = location;
  const query = parseQuery(search);
  const application = query[QUERY_KEY.APPLICATION];
  let ErrorReportingComponent;
  switch (query[QUERY_KEY.STATUS]) {
    case ERROR_STATUS.API_DOWN:
      ErrorReportingComponent = ApiDownError;
      break;
    case ERROR_STATUS.FORBIDDEN:
    case ERROR_STATUS.UNAUTHORIZED:
      ErrorReportingComponent = AuthorizationError;
      break;
    case ERROR_STATUS.NOT_FOUND:
      ErrorReportingComponent = NotFoundError;
      break;
    default:
      throw new Error('Unknown client error');
  }
  return jsxRuntimeExports.jsx("div", {
    className: "page-container centered-container",
    children: jsxRuntimeExports.jsxs("div", {
      className: "error-page-container",
      children: [jsxRuntimeExports.jsx(ErrorIcon$1, {
        style: {
          fontSize: 100
        },
        color: "disabled"
      }), jsxRuntimeExports.jsx(ErrorReportingComponent, {
        app: application
      })]
    })
  });
}
var ClientError_default = /*#__PURE__*/memo(ClientError);
function ApiDownError() {
  const history = useHistory();
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsx("h4", {
      className: "error-page-title",
      children: "Network Unavailable"
    }), jsxRuntimeExports.jsx("p", {
      className: "error-page-paragraph",
      children: "The network is unavailable. Please retry your request again."
    }), jsxRuntimeExports.jsx(Button$2, {
      className: "button-warn-outline",
      onClick: () => history.goBack(),
      children: "Retry Request"
    })]
  });
}
// Authorization errors will be handled only for applications that require
// login...
function AuthorizationError({
  app
}) {
  const history = useHistory();
  const handleRedirect = () => {
    history.push(app === 'credit-portal' ? CREDIT_PORTAL_URL : MERCHANT_PORTAL_URL);
  };
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsx("h4", {
      className: "error-page-title",
      children: "Unauthorized Request"
    }), jsxRuntimeExports.jsx("p", {
      className: "error-page-paragraph",
      children: "You are unauthorized. Please re-login and try your request again."
    }), jsxRuntimeExports.jsx(Button$2, {
      className: "button-warn-outline",
      onClick: handleRedirect,
      children: "Logout and Retry"
    })]
  });
}
function NotFoundError() {
  const history = useHistory();
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsx("h4", {
      className: "error-page-title",
      children: "Unknown Page Error"
    }), jsxRuntimeExports.jsx("p", {
      className: "error-page-paragraph",
      children: "Oops there appears to be a problem. The page you requested doesn\u2019t exist. If you believe this is an error please contact us."
    }), jsxRuntimeExports.jsx(Button$2, {
      className: "button-warn-outline",
      onClick: () => history.goBack(),
      children: "Go Back"
    })]
  });
}

var ErrorOutlineOutlined = {};

var hasRequiredErrorOutlineOutlined;
function requireErrorOutlineOutlined() {
  if (hasRequiredErrorOutlineOutlined) return ErrorOutlineOutlined;
  hasRequiredErrorOutlineOutlined = 1;
  var _interopRequireDefault = requireInteropRequireDefault();
  var _interopRequireWildcard = requireInteropRequireWildcard();
  Object.defineProperty(ErrorOutlineOutlined, "__esModule", {
    value: true
  });
  ErrorOutlineOutlined.default = void 0;
  var React = _interopRequireWildcard(React__default);
  var _createSvgIcon = _interopRequireDefault( /*@__PURE__*/requireCreateSvgIcon());
  var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
    d: "M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), 'ErrorOutlineOutlined');
  ErrorOutlineOutlined.default = _default;
  return ErrorOutlineOutlined;
}

var ErrorOutlineOutlinedExports = /*@__PURE__*/ requireErrorOutlineOutlined();
var ErrorIcon = /*@__PURE__*/getDefaultExportFromCjs(ErrorOutlineOutlinedExports);

function ExpirationTimeError() {
  const {
    logout
  } = useAuth0();
  const params = new URL(document.location.href).searchParams;
  const minDiff = params.get('minDiff');
  const currentDate = new Date();
  return jsxRuntimeExports.jsx("div", {
    className: "page-container expiration-error-container",
    children: jsxRuntimeExports.jsxs("div", {
      className: "error-card-container",
      children: [jsxRuntimeExports.jsxs("div", {
        className: "error-section",
        children: [jsxRuntimeExports.jsx(ErrorIcon, {
          style: {
            fontSize: 100
          },
          color: "error"
        }), jsxRuntimeExports.jsx("h1", {
          children: "Oops! You can't log in because your device time is incorrect."
        })]
      }), jsxRuntimeExports.jsxs("div", {
        className: "error-section date-sync m-t-20 m-b-20 second-header",
        children: ["Your local system time is ", `${currentDate}`, " which is", ' ', minDiff ? `${minDiff} minutes ` : '', " OUT OF SYNC with the server time."]
      }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(Button$1, {
        type: "button",
        onClick: () => logout({
          returnTo: makeApplicationURL(PATH.MERCHANT_PORTAL)
        }),
        className: "button-warn-outline",
        children: "Go Back"
      }), jsxRuntimeExports.jsxs("div", {
        className: "error-section",
        children: [jsxRuntimeExports.jsx("h2", {
          children: "For Windows"
        }), jsxRuntimeExports.jsx("h3", {
          children: "See instructions below on how to fix it."
        }), jsxRuntimeExports.jsx("p", {
          children: "Start > Settings > Time & Language > Date & Time"
        }), jsxRuntimeExports.jsx("p", {
          children: "Under Synchronize your clock, click on Sync now."
        })]
      }), jsxRuntimeExports.jsxs("div", {
        className: "error-section last-section",
        children: [jsxRuntimeExports.jsx("h2", {
          children: "For Mac"
        }), jsxRuntimeExports.jsx("h3", {
          children: "See instructions below on how to fix it."
        }), jsxRuntimeExports.jsx("p", {
          children: "From the Apple menu, select System Preferences."
        }), jsxRuntimeExports.jsx("p", {
          children: "Click Date & Time."
        }), jsxRuntimeExports.jsx("p", {
          children: "Click the Lock Icon."
        }), jsxRuntimeExports.jsx("p", {
          children: "Select the Set data and time automatically checkbox."
        }), jsxRuntimeExports.jsx("h3", {
          className: "second-header",
          children: "Please contact us at 1-920-306-1794 if you experience any problems."
        })]
      })]
    })
  });
}
var ExpirationTimeError_default = /*#__PURE__*/memo(ExpirationTimeError);

function ServerError() {
  const history = useHistory();
  return jsxRuntimeExports.jsx("div", {
    className: "page-container centered-container",
    children: jsxRuntimeExports.jsxs("div", {
      className: "error-page-container",
      children: [jsxRuntimeExports.jsx(ErrorIcon$1, {
        style: {
          fontSize: 100
        },
        color: "disabled"
      }), jsxRuntimeExports.jsx("h4", {
        className: "error-page-title",
        children: "Oops! Something went wrong!"
      }), jsxRuntimeExports.jsxs("p", {
        className: "error-page-paragraph",
        children: ["Please contact our hotline to let us know what you were trying to accomplish at \u00A0", ALPHAEON_CONTACT_PHONE, "."]
      }), jsxRuntimeExports.jsx(Button$2, {
        className: "button-warn-outline",
        onClick: () => history.goBack(),
        children: "Retry Request"
      })]
    })
  });
}
var ServerError_default = /*#__PURE__*/memo(ServerError);

function Routes$2() {
  return jsxRuntimeExports.jsx(Layout$2, {
    children: jsxRuntimeExports.jsxs(Switch, {
      children: [jsxRuntimeExports.jsx(Route, {
        path: PATH.AUTHORIZATION_ERROR,
        children: jsxRuntimeExports.jsx(AuthorizationError_default, {})
      }), jsxRuntimeExports.jsx(Route, {
        path: PATH.CLIENT_ERROR,
        children: jsxRuntimeExports.jsx(ClientError_default, {})
      }), jsxRuntimeExports.jsx(Route, {
        path: PATH.SERVER_ERROR,
        children: jsxRuntimeExports.jsx(ServerError_default, {})
      }), jsxRuntimeExports.jsx(Route, {
        path: PATH.EXPIRATION_TIME_ERROR,
        children: jsxRuntimeExports.jsx(ExpirationTimeError_default, {})
      })]
    })
  });
}

function Layout$1({
  children
}) {
  return jsxRuntimeExports.jsx("div", {
    children: children
  });
}

const formatStates = stateList => {
  if (!stateList || stateList.length === 0) return '';
  if (stateList.length === 1) return stateList[0];
  if (stateList.length === 2) return `${stateList[0]} and ${stateList[1]}`;
  const allButLast = stateList.slice(0, -1).join(', ');
  const last = stateList[stateList.length - 1];
  return `${allButLast}, and ${last}`;
};

function AdvantageDisclosure() {
  const [prequalificationData, setPrequalificationData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    const abortController = new AbortController();
    const fetchPrequalificationData = async () => {
      try {
        const response = await fetch(`${REACT_APP_API_URL}/consumer_applications/v1/prequalifications/new?terms_language=en`, {
          signal: abortController.signal
        });
        if (!response.ok) {
          throw new Error('Failed to fetch Advantage availability');
        }
        const payload = await response.json();
        const camelizedPayload = camelize$1(payload);
        setPrequalificationData(camelizedPayload);
      } catch {
        if (!abortController.signal.aborted) {
          setError('Unable to load Advantage availability at this time.');
        }
      } finally {
        if (!abortController.signal.aborted) {
          setIsLoading(false);
        }
      }
    };
    fetchPrequalificationData();
    return () => abortController.abort();
  }, []);
  const states = formatStates(prequalificationData?.advantageEnabledStates);
  if (isLoading) {
    return jsxRuntimeExports.jsx(Spinner, {
      centerPage: true
    });
  }
  return jsxRuntimeExports.jsxs("div", {
    className: "advantage-disclosure",
    children: [error && jsxRuntimeExports.jsx(P, {
      className: "mar-b-16",
      children: "We could not load Advantage availability right now. Please try again later."
    }), jsxRuntimeExports.jsx(H1, {
      className: "text-center",
      children: "Alphaeon Advantage Disclosure"
    }), jsxRuntimeExports.jsxs(P, {
      className: "mar-t-32",
      children: [jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "Credit Report Authorization Disclosure: "
      }), "You authorize First Bank & Trust and any of its service providers, including Imprint Payments, to obtain information about you in connection with your application, including obtaining credit reports from consumer reporting agencies and other third-party sources. If your credit report is locked or frozen, you agree to update your credit report before applying in order to be considered for credit. There is no impact to your credit file to see if you are approved."]
    }), jsxRuntimeExports.jsxs(P, {
      className: "mar-t-32",
      children: [jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "USA Patriot Act Disclosure: "
      }), "To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies every customer. When applying for a loan, applicants will be asked for their name, address, date of birth, and other information that will allow lenders to identify them. Applicants will also be asked to show their driver's license or other identifying documents."]
    }), jsxRuntimeExports.jsxs(P, {
      className: "mar-t-32",
      children: [jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "Down Payment Disclosure: "
      }), "A down payment may be required. The down payment amount generally equates to a monthly payment amount. A debit card is the only accepted form of payment for a down payment."]
    }), jsxRuntimeExports.jsxs(P, {
      className: "mar-t-32",
      children: [jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "State Availability Disclosure: "
      }), "The Alphaeon Advantage product is only available in the following states: ", states || 'Unavailable', "."]
    }), jsxRuntimeExports.jsxs(P, {
      className: "mar-t-32",
      children: [jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "Product Eligibility Requirements: "
      }), "To be eligible for an Alphaeon Advantage Loan, you must be a U.S. citizen or lawful permanent resident. Applicants using an Individual Taxpayer Identification Number (ITIN) are not eligible. All applicants must provide a valid Social Security Number (SSN) issued by the U.S. Social Security Administration without limitations or restrictions."]
    }), jsxRuntimeExports.jsxs(P, {
      className: "mar-t-32",
      children: [jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "Estimated Cost of Treatment: "
      }), "You understand that by including an estimated cost of treatment in your application, you are not applying for credit in any specific amount."]
    }), jsxRuntimeExports.jsxs(P, {
      className: "mar-t-32",
      children: [jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "Bank Issuer\u2019s Statement: "
      }), "Alphaeon Advantage Installment Loans are provided by First Bank & Trust, Brookings, SD and serviced by Imprint Payment, Inc."]
    })]
  });
}

function CAPrivacyNotice() {
  return jsxRuntimeExports.jsxs("div", {
    className: "page-container",
    children: [jsxRuntimeExports.jsx("h3", {
      className: "font-bold page-title",
      children: "Important Privacy Choices for Consumers"
    }), jsxRuntimeExports.jsx("h4", {
      className: "font-bold",
      children: "You have the right to control whether we share some of your personal information.Please read the following information carefully before you make your choices below."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title text-underline",
      children: "Your Rights"
    }), jsxRuntimeExports.jsx("p", {
      children: "You have the following rights to restrict the sharing of personal and financial information with our affiliates (companies we own or control) and outside companies that we do business with. Nothing in this form prohibits the sharing of information necessary for us to follow the law, as permitted by law, or to give you the best service on your accounts with us. This includes sending you information about some other products or services."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title text-underline",
      children: "Your Choices"
    }), jsxRuntimeExports.jsxs("p", {
      children: [jsxRuntimeExports.jsx("strong", {
        children: "Restrict Information Sharing With Other Companies We Do Business With To Provide Financial Products And Services:"
      }), "Unless you say \u201CNo,\u201D we may share personal and financial information about you with outside companies we contract with to provide financial products and services to you."]
    }), jsxRuntimeExports.jsx("p", {
      children: "(_) NO, please do not share personal and financial information with outside companies you contract with to provide financial products and services."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title text-underline",
      children: "Time Sensitive Reply"
    }), jsxRuntimeExports.jsxs("p", {
      children: ["You may make your privacy choice at any time. Your choice marked here will remain unless you state otherwise. However, if we do not hear from you we may share some of your information with affiliated companies and other companies with whom we have contracts to provide products and services. ", jsxRuntimeExports.jsx("br", {}), "Name: __________________ ", jsxRuntimeExports.jsx("br", {}), "Account Number(s): __________________ ", jsxRuntimeExports.jsx("br", {}), "Signature: ______________________ ", jsxRuntimeExports.jsx("br", {})]
    }), jsxRuntimeExports.jsxs("div", {
      className: "footer-info",
      children: [jsxRuntimeExports.jsx("p", {
        children: "To exercise your choice, do one of the following:"
      }), jsxRuntimeExports.jsxs("ol", {
        children: [jsxRuntimeExports.jsx("li", {
          children: "Call this toll-free number (800) 754 4013; or"
        }), jsxRuntimeExports.jsx("li", {
          children: "Reply electronically by contacting us through the following Internet option: privacy@alphaeoncredit.com."
        })]
      })]
    })]
  });
}
var CAPrivacyNotice_default = /*#__PURE__*/memo(CAPrivacyNotice);

function ComenityCapitalPrequalificationTerms() {
  return jsxRuntimeExports.jsxs("div", {
    className: "page-container",
    children: [jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "You understand and agree that by clicking on the \u201CAgree and Continue Prequalification\u201D button:"
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "We offer, in conjunction with our partner businesses, certain products and services to patients that may make payment for treatment more convenient. Because of our commitment to protecting the privacy of the information you provide as a patient, we would like your authorization to use the information described below to offer you these products and services. Please read the information below carefully before checking off the acknowledgment box at the bottom. A dental office team member is standing by, available to answer any questions regarding this authorization."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "You are being prequalified for credit by each of the lenders offering financing options through this platform (\u201CLenders\u201D), and have read and agree to the disclosures provided with this prequalification."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "You are providing \u201Cwritten authorization\u201D to Lenders under the Fair Credit Reporting Act authorizing each Lender to obtain information from your personal credit report or other information from Experian or other credit bureaus. You authorize each Lender to obtain such information solely to conduct a prequalification for credit."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "You understand that a prequalification is not a guarantee of an approval for credit and a failure to prequalify is not a denial of credit."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "When you review your financing options, a soft inquiry will be performed on your credit report, which won't impact your credit score. When you select a financing offer and submit it for review, a hard inquiry will be performed, which may impact your credit score and be viewed by third parties."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "This prequalification and any information submitted with this prequalification may be shared with and retained by Alphaeon."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "Prequalification Terms and Conditions: I agree to be prequalified for credit by Comenity Bank/Comenity Capital Bank (\u201CBank\u201D) for an Alphaeon Credit Card. I have read and agree to the disclosures provided on or with this prequalification. The information I am submitting is accurate. I understand that a prequalification is not a guaranty of credit and a failure to prequalify is not a denial of credit. Whether or not I am prequalified, I may submit a full application for credit at which time a full credit report will be obtained. This prequalification and any information I submit to the Bank may be shared with and retained by Alphaeon. A copy of these terms and conditions and prequalification disclosures may be obtained from the associate."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "To be prequalified you must: Be at least 18 years of age, have a valid government-issued photo ID, have a U.S. Social Security Number, and be a United States resident with a street, rural route or APO/FPO mailing address."
    })]
  });
}
var ComenityCapitalPrequalificationTerms_default = /*#__PURE__*/memo(ComenityCapitalPrequalificationTerms);

function ConsentAutodialed() {
  return jsxRuntimeExports.jsxs("div", {
    className: "page-container",
    children: [jsxRuntimeExports.jsx(H1, {
      variant: "headline-medium",
      className: "text-center text-underline",
      children: "Consent to Autodialed Calls/Texts"
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-32",
      children: ["If you listed a cell phone number in your application or provide an updated cell phone number, then you expressly consent to Alphaeon and its affiliates, agents, assigns and service providers to call (including sending SMS text messages) using automatic telephone dialing systems, automatic texting systems and artificial or prerecorded messages to your cell phone number to provide information related to, or about, your application or any relationships or transactions you have with us. You agree to notify Alphaeon immediately if you change your number or transfer your phone to another person. You understand text messages may be seen by anyone with access to your phone. Accordingly, you should take steps to safeguard your phone and your text messages if you want them to remain private. Your cellular or mobile phone carrier will charge you according to the type of plan you have. If you do not want to receive calls and/or SMS text messages from Alphaeon, you can unsubscribe by sending an email to", ' ', jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "unsubscribe@alphaeon.com"
      }), " or by calling a customer service representative at (800) 754-4013 specifying your preference. To stop text messages, you can also simply reply \u201CSTOP\u201D to any text message we may send you."]
    })]
  });
}

function ConsentElectronicDisclosures() {
  return jsxRuntimeExports.jsxs("div", {
    className: "page-container",
    children: [jsxRuntimeExports.jsx(H1, {
      variant: "headline-medium",
      className: "text-center text-underline",
      children: "Consent to Electronic Disclosures"
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-32",
      children: ["This Consent to Electronic Disclosures (\u201CConsent\u201D) applies to any and all interactions between you and Alphaeon Credit, Inc. (the \u201CCompany\u201D), and between you and Alphaeon\u2019s", ' ', jsxRuntimeExports.jsx(A, {
        variant: "body-large",
        href: FINANCING_PARTNERS_URL,
        blue: true,
        children: "financing partners"
      }), ' ', "in connection with any prequalifications or applications for credit or any resulting extensions of credit (individually an \u201CAccount\u201D and collectively \u201CAccounts\u201D), as well as your dealings with Company and any third-party creditors in the future in connection with your Accounts."]
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: ["In this Consent, the words \u201Cyou\u201D and \u201Cyour\u201D refer to each person applying for or on an Account; \u201Cwe,\u201D \u201Cus,\u201D and \u201Cour\u201D refer to Company, its", ' ', jsxRuntimeExports.jsx(A, {
        variant: "body-large",
        href: FINANCING_PARTNERS_URL,
        blue: true,
        children: "financing partners"
      }), ", and any of their affiliates, agents, independent contractors, designees, service providers or assignees."]
    }), jsxRuntimeExports.jsx(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: "Please read this document carefully and retain a copy for your reference."
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsxs(Span, {
        bold: true,
        children: ["Your Legal Rights Regarding Electronic Communications:", ' ']
      }), "We must provide you with certain communications and disclosures in writing (i.e., you have a right to receive such communications on paper) pursuant to applicable laws and regulations. This information may be provided to you electronically if you agree to this Consent."]
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "Types of Electronic Communications You May Receive: "
      }), "You agree and consent to receive electronically all communications we may provide, including agreements, documents, notices, statements and disclosures (each a \u201CCommunication\u201D and collectively the \u201CCommunications\u201D) in connection with your applications or Accounts. Categories of communications may include, but are not limited to, the following:"]
    }), jsxRuntimeExports.jsxs("ul", {
      className: "mar-t-8 mar-left-4",
      children: [jsxRuntimeExports.jsx("li", {
        children: jsxRuntimeExports.jsx(P, {
          variant: "body-large",
          children: "agreements and policies you agree and consent to and updates to such agreements and policies;"
        })
      }), jsxRuntimeExports.jsx("li", {
        children: jsxRuntimeExports.jsx(P, {
          variant: "body-large",
          children: "notices, receipts and confirmations related to your Account, including authorizations for consumer reports and receipt of telephonic or text outreach;"
        })
      }), jsxRuntimeExports.jsx("li", {
        children: jsxRuntimeExports.jsx(P, {
          variant: "body-large",
          children: "any notices and disclosures required by state or federal law;"
        })
      }), jsxRuntimeExports.jsx("li", {
        children: jsxRuntimeExports.jsx(P, {
          variant: "body-large",
          children: "marketing information and preferences;"
        })
      }), jsxRuntimeExports.jsx("li", {
        children: jsxRuntimeExports.jsx(P, {
          variant: "body-large",
          children: "any other account and transaction notices and information from us."
        })
      })]
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "Electronic Agreements and Updates: "
      }), "Any Communication that you accept or agree to receive electronically or any Account update you submit to us electronically will be enforceable without your signature on a paper form."]
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "Paper Communications: "
      }), "We will not be obligated to provide any Communication to you in paper form unless you specifically request us to do so. We may send Communications to you in paper form because we are legally required to do so or because we determine in our sole discretion that you should receive the Communication in paper rather than electronic form."]
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "Copies of Electronic Communications: "
      }), "You may retain a copy of any electronic Communication by using your print function or saving an electronic copy for your records. If, after you receive a Communication electronically, you would like a paper copy of a Communication previously provided to you, you may request a copy during the period we retain your Account documentation by contacting us at legal@alphaeon.com. We will send your paper copy to you by U.S. mail. In order for us to send you a paper copy, you must have a current mailing address on file with us. You may be charged a $5 fee for each paper copy of any electronic record."]
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsxs(Span, {
        bold: true,
        children: ["Withdrawal of Consent to Electronic Delivery of Communications:", ' ']
      }), "You can withdraw your consent to electronic Communications by contacting Company and asking that Communications be sent to you in paper or other non-electronic form using one of the following methods:"]
    }), jsxRuntimeExports.jsxs("ul", {
      className: "mar-t-8 mar-left-4",
      children: [jsxRuntimeExports.jsx("li", {
        children: jsxRuntimeExports.jsxs(P, {
          variant: "body-large",
          children: [jsxRuntimeExports.jsx(Span, {
            className: "text-underline",
            children: "Telephone"
          }), ": (800) 754-4013"]
        })
      }), jsxRuntimeExports.jsx("li", {
        children: jsxRuntimeExports.jsxs(P, {
          variant: "body-large",
          children: [jsxRuntimeExports.jsx(Span, {
            className: "text-underline",
            children: "Email"
          }), ": legal@alphaeon.com"]
        })
      }), jsxRuntimeExports.jsx("li", {
        children: jsxRuntimeExports.jsxs(P, {
          variant: "body-large",
          children: [jsxRuntimeExports.jsx(Span, {
            className: "text-underline",
            children: "Postal Mail"
          }), ": 4040 MacArthur Blvd #260, Newport Beach, CA 92660"]
        })
      })]
    }), jsxRuntimeExports.jsx(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: "Your withdrawal of consent to electronic Communications is effective only after we have had a reasonable period of time to act upon your withdrawal."
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "Your Contact Information: "
      }), "If you give us an incorrect email address or fail to update or correct your email address, an electronic Communication will be deemed provided to you if we use the email address in our records for the electronic Communication."]
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "Hardware and Software Requirements: "
      }), "In order to receive access to and retain electronic Communications, you will need the following hardware and software:"]
    }), jsxRuntimeExports.jsxs("ul", {
      className: "mar-t-8 mar-left-4",
      children: [jsxRuntimeExports.jsx("li", {
        children: jsxRuntimeExports.jsx(P, {
          variant: "body-large",
          children: "a recent-generation computer, mobile device, tablet or similar device with an internet connection;"
        })
      }), jsxRuntimeExports.jsx("li", {
        children: jsxRuntimeExports.jsx(P, {
          variant: "body-large",
          children: "a current web browser that includes 128-bit encryption with cookies enabled;"
        })
      }), jsxRuntimeExports.jsx("li", {
        children: jsxRuntimeExports.jsx(P, {
          variant: "body-large",
          children: "a current version of a software program that can open and display PDF files (such as an Adobe Acrobat reader);"
        })
      }), jsxRuntimeExports.jsx("li", {
        children: jsxRuntimeExports.jsx(P, {
          variant: "body-large",
          children: "a valid email address with email software to communicate with us electronically; and"
        })
      }), jsxRuntimeExports.jsx("li", {
        children: jsxRuntimeExports.jsx(P, {
          variant: "body-large",
          children: "an installed printer or sufficient storage space to save, store, print or otherwise retain electronic Communications."
        })
      })]
    }), jsxRuntimeExports.jsx(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: "By giving your consent, you are confirming that you have access to the necessary software and hardware, and can receive, open, print, download a copy or otherwise retain a copy of any electronic Communication for your records. You are advised to retain a copy of all electronic Communications as they may not be accessible online or in paper form at a later date."
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "Federal Electronic Signatures Law. "
      }), "You acknowledge and agree that your consent to electronic Communications is being provided in connection with a transaction affecting interstate commerce that is subject to the federal Electronic Signatures in Global and National Commerce Act and that you and we both intend that the Act apply to the fullest extent possible to validate our ability to conduct business with you by electronic means."]
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "Termination/Changes. "
      }), "We reserve the right, in our sole discretion, to discontinue the provision of your electronic Communications, or to terminate or change the terms and conditions on which we provide electronic Communications. We will provide you with notice of any such termination or change as required by law."]
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsx(Span, {
        bold: true,
        children: "Reservation of Rights. "
      }), "This Consent does not apply to any Communication that we determine, in our sole discretion, that we are required to deliver in paper form under applicable law or that you should receive in paper rather than electronic form."]
    })]
  });
}

function ConsumerFinancialPrivacyPolicy() {
  return jsxRuntimeExports.jsxs("div", {
    className: "page-container",
    children: [jsxRuntimeExports.jsxs("div", {
      className: "fact-table-header",
      children: [jsxRuntimeExports.jsx("div", {
        className: "left-box",
        children: jsxRuntimeExports.jsx("h3", {
          children: "FACTS"
        })
      }), jsxRuntimeExports.jsx("div", {
        className: "right-box",
        children: jsxRuntimeExports.jsxs("h3", {
          children: ["WHAT DOES ALPHAEON ", jsxRuntimeExports.jsx("br", {}), "DO WITH YOUR PERSONAL INFORMATION?"]
        })
      })]
    }), jsxRuntimeExports.jsxs("div", {
      className: "fact-table-1",
      children: [jsxRuntimeExports.jsxs("div", {
        className: "fact-table-row",
        children: [jsxRuntimeExports.jsx("div", {
          className: "left-box",
          children: jsxRuntimeExports.jsx("h3", {
            children: "Why?"
          })
        }), jsxRuntimeExports.jsx("div", {
          className: "right-box",
          children: jsxRuntimeExports.jsx("p", {
            className: "paragraph-basic",
            children: "Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share, and protect your personal information. Please read this notice carefully to understand what we do."
          })
        })]
      }), jsxRuntimeExports.jsxs("div", {
        className: "fact-table-row",
        children: [jsxRuntimeExports.jsx("div", {
          className: "left-box",
          children: jsxRuntimeExports.jsx("h3", {
            children: "What?"
          })
        }), jsxRuntimeExports.jsxs("div", {
          className: "right-box",
          children: [jsxRuntimeExports.jsx("p", {
            className: "paragraph-basic",
            children: "The types of personal information we collect and share depend on the product or service you have with us. This information can include:"
          }), jsxRuntimeExports.jsxs("ul", {
            className: "paragraph-list terms-list",
            children: [jsxRuntimeExports.jsx("li", {
              children: "Social Security number and transaction history"
            }), jsxRuntimeExports.jsx("li", {
              children: "account balances and payment history"
            }), jsxRuntimeExports.jsx("li", {
              children: "account transactions and income"
            })]
          })]
        })]
      }), jsxRuntimeExports.jsxs("div", {
        className: "fact-table-row",
        children: [jsxRuntimeExports.jsx("div", {
          className: "left-box",
          children: jsxRuntimeExports.jsx("h3", {
            children: "How?"
          })
        }), jsxRuntimeExports.jsx("div", {
          className: "right-box",
          children: jsxRuntimeExports.jsx("p", {
            className: "paragraph-basic",
            children: "All financial companies need to share customers' personal information to run their everyday business. In the section below, we list the reasons financial companies can share their customers' personal information; the reasons Alphaeon chooses to share; and whether you can limit this sharing."
          })
        })]
      })]
    }), jsxRuntimeExports.jsx("div", {
      className: "fact-table-2",
      children: jsxRuntimeExports.jsxs("table", {
        children: [jsxRuntimeExports.jsx("thead", {
          children: jsxRuntimeExports.jsxs("tr", {
            children: [jsxRuntimeExports.jsx("th", {
              children: "Reasons we can share your personal information"
            }), jsxRuntimeExports.jsx("th", {
              children: "Does Alphaeon share?"
            }), jsxRuntimeExports.jsx("th", {
              children: "Can you limit this sharing?"
            })]
          })
        }), jsxRuntimeExports.jsxs("tbody", {
          children: [jsxRuntimeExports.jsxs("tr", {
            children: [jsxRuntimeExports.jsxs("td", {
              children: [jsxRuntimeExports.jsx("strong", {
                children: "For our everyday business purposes \u2014"
              }), "such as to process your transactions, maintain your account(s), respond to court orders and legal investigations; or report to credit bureaus"]
            }), jsxRuntimeExports.jsx("td", {
              children: "Yes"
            }), jsxRuntimeExports.jsx("td", {
              children: "No"
            })]
          }), jsxRuntimeExports.jsxs("tr", {
            children: [jsxRuntimeExports.jsxs("td", {
              children: [jsxRuntimeExports.jsx("strong", {
                children: "For our marketing purposes \u2014"
              }), "to offer our products and services to you"]
            }), jsxRuntimeExports.jsx("td", {
              children: "Yes"
            }), jsxRuntimeExports.jsx("td", {
              children: "No"
            })]
          }), jsxRuntimeExports.jsxs("tr", {
            children: [jsxRuntimeExports.jsx("td", {
              children: jsxRuntimeExports.jsx("strong", {
                children: "For joint marketing with other financial companies"
              })
            }), jsxRuntimeExports.jsx("td", {
              children: "Yes"
            }), jsxRuntimeExports.jsx("td", {
              children: "No"
            })]
          }), jsxRuntimeExports.jsxs("tr", {
            children: [jsxRuntimeExports.jsxs("td", {
              children: [jsxRuntimeExports.jsx("strong", {
                children: "For our affiliates' everyday business purposes \u2014"
              }), "information about your transactions and experiences"]
            }), jsxRuntimeExports.jsx("td", {
              children: "No"
            }), jsxRuntimeExports.jsx("td", {
              children: "We don't share"
            })]
          }), jsxRuntimeExports.jsxs("tr", {
            children: [jsxRuntimeExports.jsxs("td", {
              children: [jsxRuntimeExports.jsxs("strong", {
                children: ["For our affiliates' everyday business purposes \u2014", ' ']
              }), "information about your creditworthiness"]
            }), jsxRuntimeExports.jsx("td", {
              children: "No"
            }), jsxRuntimeExports.jsx("td", {
              children: "We don't share"
            })]
          }), jsxRuntimeExports.jsxs("tr", {
            children: [jsxRuntimeExports.jsx("td", {
              children: jsxRuntimeExports.jsx("strong", {
                children: "For our affiliates to market to you"
              })
            }), jsxRuntimeExports.jsx("td", {
              children: "No"
            }), jsxRuntimeExports.jsx("td", {
              children: "We don't share"
            })]
          }), jsxRuntimeExports.jsxs("tr", {
            children: [jsxRuntimeExports.jsx("td", {
              children: jsxRuntimeExports.jsx("strong", {
                children: "For nonaffiliates to market to you"
              })
            }), jsxRuntimeExports.jsx("td", {
              children: "Yes"
            }), jsxRuntimeExports.jsx("td", {
              children: "Yes"
            })]
          })]
        })]
      })
    }), jsxRuntimeExports.jsxs("div", {
      className: "fact-table-4",
      children: [jsxRuntimeExports.jsx("div", {
        className: "left-box",
        children: jsxRuntimeExports.jsx("h3", {
          children: "To Limit Our Sharing"
        })
      }), jsxRuntimeExports.jsxs("div", {
        className: "right-box",
        children: [jsxRuntimeExports.jsx("p", {
          className: "paragraph-basic",
          children: "Call (800) 754-4013 or email us at privacy@alphaeoncredit.com."
        }), jsxRuntimeExports.jsxs("p", {
          className: "paragraph-basic",
          children: [jsxRuntimeExports.jsx("strong", {
            children: "Please note: "
          }), "If you are a new customer, we can begin sharing your information 30 days from the date we sent this notice. When you are no longer our customer, we continue to share your information as described in this notice."]
        }), jsxRuntimeExports.jsx("p", {
          className: "paragraph-basic",
          children: "However, you can contact us at any time to limit our sharing."
        })]
      })]
    }), jsxRuntimeExports.jsxs("div", {
      className: "fact-table-4",
      children: [jsxRuntimeExports.jsx("div", {
        className: "left-box",
        children: jsxRuntimeExports.jsx("h3", {
          children: "Questions?"
        })
      }), jsxRuntimeExports.jsx("div", {
        className: "right-box",
        children: jsxRuntimeExports.jsx("p", {
          className: "paragraph-basic",
          children: "Call (800) 754-4013 or email us at privacy@alphaeoncredit.com."
        })
      })]
    }), jsxRuntimeExports.jsxs("div", {
      className: "fact-table-3",
      children: [jsxRuntimeExports.jsx("div", {
        className: "table-3-header",
        children: jsxRuntimeExports.jsx("h3", {
          children: "Who we are"
        })
      }), jsxRuntimeExports.jsx("div", {
        className: "table-3-body",
        children: jsxRuntimeExports.jsxs("div", {
          className: "table-3-row",
          children: [jsxRuntimeExports.jsx("div", {
            className: "table-3-left",
            children: jsxRuntimeExports.jsx("h4", {
              children: "Who is providing this notice?"
            })
          }), jsxRuntimeExports.jsx("div", {
            className: "table-3-right",
            children: jsxRuntimeExports.jsx("p", {
              children: "Alphaeon Credit, Inc."
            })
          })]
        })
      })]
    }), jsxRuntimeExports.jsxs("div", {
      className: "fact-table-3",
      children: [jsxRuntimeExports.jsx("div", {
        className: "table-3-header",
        children: jsxRuntimeExports.jsx("h3", {
          children: "What we do"
        })
      }), jsxRuntimeExports.jsxs("div", {
        className: "table-3-body",
        children: [jsxRuntimeExports.jsxs("div", {
          className: "table-3-row",
          children: [jsxRuntimeExports.jsx("div", {
            className: "table-3-left",
            children: jsxRuntimeExports.jsx("h4", {
              children: "How does Alphaeon protect my personal information?"
            })
          }), jsxRuntimeExports.jsx("div", {
            className: "table-3-right",
            children: jsxRuntimeExports.jsx("p", {
              className: "paragraph-basic",
              children: "To protect your personal information from unauthorized access and use, we use security measures that comply with federal law. These measures include computer safeguards and secured files and buildings. We also take measures to limit personal information access to only employees, agents and representatives that need to know."
            })
          })]
        }), jsxRuntimeExports.jsxs("div", {
          className: "table-3-row",
          children: [jsxRuntimeExports.jsx("div", {
            className: "table-3-left",
            children: jsxRuntimeExports.jsx("h4", {
              children: "How does Alphaeon collect my personal information?"
            })
          }), jsxRuntimeExports.jsxs("div", {
            className: "table-3-right",
            children: [jsxRuntimeExports.jsx("p", {
              className: "paragraph-basic",
              children: "We collect your personal information, for example, when you:"
            }), jsxRuntimeExports.jsxs("ul", {
              className: "paragraph-list terms-list",
              children: [jsxRuntimeExports.jsx("li", {
                children: "Open an account or provide account information"
              }), jsxRuntimeExports.jsx("li", {
                children: "Apply for a loan or use your credit or debit card"
              }), jsxRuntimeExports.jsx("li", {
                children: "Give us your contact information"
              })]
            }), jsxRuntimeExports.jsx("p", {
              className: "paragraph-basic",
              children: "We also collect your personal information from others, such as creditbureaus, affiliates, or other companies."
            })]
          })]
        }), jsxRuntimeExports.jsxs("div", {
          className: "table-3-row",
          children: [jsxRuntimeExports.jsx("div", {
            className: "table-3-left",
            children: jsxRuntimeExports.jsx("h4", {
              children: "Why can't I limit all sharing?"
            })
          }), jsxRuntimeExports.jsxs("div", {
            className: "table-3-right",
            children: [jsxRuntimeExports.jsx("p", {
              className: "paragraph-basic",
              children: "Federal law gives you the right to limit only:"
            }), jsxRuntimeExports.jsxs("ul", {
              className: "paragraph-list terms-list",
              children: [jsxRuntimeExports.jsx("li", {
                children: "sharing for affiliates' everyday business purposes\u2014information about your creditworthiness"
              }), jsxRuntimeExports.jsx("li", {
                children: "affiliates from using your information to market to you"
              }), jsxRuntimeExports.jsx("li", {
                children: "sharing for nonaffiliates to market to you"
              })]
            }), jsxRuntimeExports.jsx("p", {
              className: "paragraph-basic",
              children: "State laws and individual companies may give you additional rights to limit sharing. See below for more on your rights under state law."
            })]
          })]
        }), jsxRuntimeExports.jsxs("div", {
          className: "table-3-row",
          children: [jsxRuntimeExports.jsx("div", {
            className: "table-3-left",
            children: jsxRuntimeExports.jsx("h4", {
              children: "What happens when I limit sharing for an account I hold jointly with someone else?"
            })
          }), jsxRuntimeExports.jsx("div", {
            className: "table-3-right",
            children: jsxRuntimeExports.jsx("p", {
              className: "paragraph-basic",
              children: "Your choices will apply to everyone on your account."
            })
          })]
        })]
      })]
    }), jsxRuntimeExports.jsxs("div", {
      className: "fact-table-3",
      children: [jsxRuntimeExports.jsx("div", {
        className: "table-3-header",
        children: jsxRuntimeExports.jsx("h3", {
          children: "Definitions"
        })
      }), jsxRuntimeExports.jsxs("div", {
        className: "table-3-body",
        children: [jsxRuntimeExports.jsxs("div", {
          className: "table-3-row",
          children: [jsxRuntimeExports.jsx("div", {
            className: "table-3-left",
            children: jsxRuntimeExports.jsx("h4", {
              children: "Affiliates"
            })
          }), jsxRuntimeExports.jsxs("div", {
            className: "table-3-right",
            children: [jsxRuntimeExports.jsx("p", {
              className: "paragraph-basic",
              children: "Companies related by common ownership or control. They can be financial and nonfinancial companies."
            }), jsxRuntimeExports.jsx("ul", {
              className: "paragraph-list terms-list",
              children: jsxRuntimeExports.jsx("li", {
                children: "Alphaeon has no affiliates."
              })
            })]
          })]
        }), jsxRuntimeExports.jsxs("div", {
          className: "table-3-row",
          children: [jsxRuntimeExports.jsx("div", {
            className: "table-3-left",
            children: jsxRuntimeExports.jsx("h4", {
              children: "Nonaffiliates"
            })
          }), jsxRuntimeExports.jsxs("div", {
            className: "table-3-right",
            children: [jsxRuntimeExports.jsx("p", {
              className: "paragraph-basic",
              children: "Companies not related by common ownership or control. They can be financial and nonfinancial companies."
            }), jsxRuntimeExports.jsx("ul", {
              className: "paragraph-list terms-list",
              children: jsxRuntimeExports.jsx("li", {
                children: "Nonaffiliates we share with can include the medical practices or retailers that referred you to us."
              })
            })]
          })]
        }), jsxRuntimeExports.jsxs("div", {
          className: "table-3-row",
          children: [jsxRuntimeExports.jsx("div", {
            className: "table-3-left",
            children: jsxRuntimeExports.jsx("h4", {
              children: "Joint marketing"
            })
          }), jsxRuntimeExports.jsxs("div", {
            className: "table-3-right",
            children: [jsxRuntimeExports.jsx("p", {
              className: "paragraph-basic",
              children: "A formal agreement between nonaffiliated financial companies that together market financial products or services to you."
            }), jsxRuntimeExports.jsx("ul", {
              className: "paragraph-list terms-list",
              children: jsxRuntimeExports.jsx("li", {
                children: "Our joint marketing partners include companies such as lenders."
              })
            })]
          })]
        })]
      })]
    }), jsxRuntimeExports.jsxs("div", {
      className: "fact-table-3",
      children: [jsxRuntimeExports.jsx("div", {
        className: "table-3-header",
        children: jsxRuntimeExports.jsx("h3", {
          children: "Other Important Information"
        })
      }), jsxRuntimeExports.jsx("div", {
        className: "table-3-body",
        children: jsxRuntimeExports.jsxs("div", {
          className: "table-3-row table-3-info",
          children: [jsxRuntimeExports.jsxs("p", {
            className: "paragraph-basic",
            children: [jsxRuntimeExports.jsx("strong", {
              children: "California Residents:"
            }), " For more information, please refer to our Privacy Policy or the California privacy notice that will be provided separately entitled, \u201CImportant Privacy Choices for Consumers.\u201D"]
          }), jsxRuntimeExports.jsxs("p", {
            className: "paragraph-basic",
            children: [jsxRuntimeExports.jsx("strong", {
              children: "Vermont Customers:"
            }), " We will not disclose information about your creditworthiness to our affiliates and will not disclose your personal information, financial information, credit report, or health information to nonaffiliated third parties to market to you, other than as permitted by Vermont law, unless you authorize us to make those disclosures. Additional information concerning our privacy policies can be found by email at ", jsxRuntimeExports.jsx("span", {
              className: "contact",
              children: "privacy@alphaeoncredit.com"
            }), " or call (800) 754-4013."]
          })]
        })
      })]
    })]
  });
}
var ConsumerFinancialPrivacyPolicy_default = /*#__PURE__*/memo(ConsumerFinancialPrivacyPolicy);

function CreditReportAuthorization() {
  return jsxRuntimeExports.jsxs("div", {
    className: "page-container",
    children: [jsxRuntimeExports.jsx(H1, {
      variant: "headline-medium",
      className: "text-center text-underline",
      children: "Credit Report Authorization"
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-32",
      children: ["You authorize Alphaeon Credit and its", ' ', jsxRuntimeExports.jsx(A, {
        variant: "body-large",
        href: FINANCING_PARTNERS_URL,
        children: "financing partners"
      }), ' ', "to each obtain consumer reports and related information about you from one or more consumer reporting agencies. You also authorize Alphaeon Credit and its", ' ', jsxRuntimeExports.jsx(A, {
        variant: "body-large",
        href: FINANCING_PARTNERS_URL,
        children: "financing partners"
      }), ' ', "to verify information in your application for credit, and you agree that Alphaeon Credit and its", ' ', jsxRuntimeExports.jsx(A, {
        variant: "body-large",
        href: FINANCING_PARTNERS_URL,
        children: "financing partners"
      }), ' ', "may contact third parties to verify any such information. You direct Alphaeon Credit and its", ' ', jsxRuntimeExports.jsx(A, {
        variant: "body-large",
        href: FINANCING_PARTNERS_URL,
        children: "financing partners"
      }), ' ', "to use your consumer reports to authenticate your identity, to make/facilitate prequalification decisions and for other related purposes. [You expressly authorize Alphaeon Credit and its", ' ', jsxRuntimeExports.jsx(A, {
        variant: "body-large",
        href: FINANCING_PARTNERS_URL,
        children: "financing partners"
      }), ' ', "to obtain consumer reports about you, as well as your income information, from consumer reporting agencies when you apply for credit, during the 60 days following your initial application date, and periodically throughout the term of your credit product.] You expressly authorize Alphaeon Credit and its", ' ', jsxRuntimeExports.jsx(A, {
        variant: "body-large",
        href: FINANCING_PARTNERS_URL,
        children: "financing partners"
      }), ' ', "to use and share among themselves the information that we obtain from such reports along with your application information to, among other things, market credit products to you, determine your eligibility for other products that Alphaeon Credit and its", ' ', jsxRuntimeExports.jsx(A, {
        variant: "body-large",
        href: FINANCING_PARTNERS_URL,
        children: "financing partners"
      }), ' ', "may offer or that you may apply for, make decisions related to the servicing and collection of your account, measure how any credit product you obtained impacts your credit, perform other statistical analysis, and share information with you about your credit profile."]
    })]
  });
}

function FinancingPartners() {
  return jsxRuntimeExports.jsxs("div", {
    className: "page-container",
    children: [jsxRuntimeExports.jsx(H1, {
      className: "text-underline text-center",
      children: "Financing Partners"
    }), jsxRuntimeExports.jsx(P, {
      className: "mar-t-8",
      children: "Comenity Capital Bank"
    })]
  });
}

function FlexRicMerchantAgreement() {
  return jsxRuntimeExports.jsxs("div", {
    className: "page-container",
    children: [jsxRuntimeExports.jsx(H1, {
      variant: "headline-medium",
      className: "text-center font-bold",
      children: "ALPHAEON PATIENT FINANCING"
    }), jsxRuntimeExports.jsx(H2, {
      variant: "headline-medium",
      className: "text-center font-bold",
      children: "MERCHANT AGREEMENT"
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: ["This", ' ', jsxRuntimeExports.jsx(Span, {
        variant: "body-large",
        bold: true,
        children: "MERCHANT AGREEMENT"
      }), ' ', "(the \u201C", jsxRuntimeExports.jsx(Span, {
        variant: "body-large",
        className: "text-underline",
        children: "Agreement"
      }), "\u201D) is between Alphaeon Credit, Inc., a Delaware Corporation (\u201C", jsxRuntimeExports.jsx(Span, {
        variant: "body-large",
        className: "text-underline",
        children: "Alphaeon"
      }), "\u201D), and the Merchant acknowledging this Agreement. Alphaeon and Merchant may be referred to in this Agreement individually as a \u201C", jsxRuntimeExports.jsx(Span, {
        variant: "body-large",
        className: "text-underline",
        children: "Party"
      }), "\u201D and collectively as the \u201C", jsxRuntimeExports.jsx(Span, {
        variant: "body-large",
        className: "text-underline",
        children: "Parties"
      }), ".\u201D"]
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsx(Span, {
        variant: "body-large",
        bold: true,
        children: "WHEREAS"
      }), ", Alphaeon Merchant wishes to offer its customers (\u201CCustomers\u201D) Alphaeon\u2019s services, including, but not limited to, participation in the Alphaeon Credit Private Label Credit Card Program (the \u201CServices\u201D);"]
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsx(Span, {
        variant: "body-large",
        bold: true,
        children: "WHEREAS"
      }), ", Alphaeon\u2019s Services also include the administration of its Alphaeon Flex program (\u201CProgram\u201D), through which Consumer Installment Loans (\u201CLoan\u201D or \u201CLoans\u201D) or Retail Installment Contracts (\u201CRICs\u201D) and related financial services may be provided to current or prospective Customers of Merchant and Merchant desires to participate under such Program in connection with such Customers\u2019 purchase of Goods and/or Services (the \u201C", jsxRuntimeExports.jsx(Span, {
        variant: "body-large",
        className: "text-underline",
        children: "Goods and/or Services"
      }), "\u201D) from Merchant;"]
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsx(Span, {
        variant: "body-large",
        bold: true,
        children: "WHEREAS"
      }), ", Customers may obtain credit for personal, family or household purchases of Goods and/or Services through: (1) the Alphaeon Credit Private Label Credit Card Program; (2) Consumer Installment Loans made by or through Alphaeon, with Alphaeon performing various origination, servicing and collection duties on behalf of the lender; and (3) Retail Installment (or credit sale) Contracts originated by the Merchant and purchased by Alphaeon (\u201C", jsxRuntimeExports.jsx(Span, {
        variant: "body-large",
        className: "text-underline",
        children: "Credit Sales"
      }), "\u201D and together with Loans, \u201C", jsxRuntimeExports.jsx(Span, {
        variant: "body-large",
        className: "text-underline",
        children: "Credit Transactions"
      }), "\u201D); and"]
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsx(Span, {
        variant: "body-large",
        bold: true,
        children: "WHEREAS"
      }), ", Merchant wishes to offer the Program to its Customers."]
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsx(Span, {
        variant: "body-large",
        bold: true,
        children: "NOW, THEREFORE"
      }), ", in consideration of the mutual agreements and promises contained herein and other good and valuable consideration, the receipt and sufficiency of which are hereby acknowledged, the Parties agree as follows:"]
    }), jsxRuntimeExports.jsxs("ol", {
      className: "terms-list",
      children: [jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Program."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "terms-list",
          children: [jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Description."
            }), ' ', "Alphaeon is the administrator of the Program and, among other things, provides administrative, technical, and ministerial services to operate the Program. Merchant\u2019s participation in the Program is subject to Alphaeon\u2019s approval\u2014which is at Alphaeon\u2019s sole discretion. If Merchant is approved, Alphaeon grants Merchant access to, and Merchant agrees to participate in, the Program as a Merchant in accordance with this Agreement, with the Program allowing Merchant\u2019s current or prospective Customers to apply for and, if approved, obtain Credit Transactions. A list of all of Merchant\u2019s participating locations, if applicable, is included in Appendix A."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Variation of Financing Method by State."
            }), ' ', "Alphaeon and Funder may vary the Credit Transactions available by state and notify Merchant whether the Program will offer a Credit Sale, Loan or a combination of both. Credit Sales and Loans may not be available in every state."]
          })]
        })]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Merchant\u2019s Agents."
        }), ' ', "Merchant agrees to comply, and to cause Merchant\u2019s Agents to comply, with all of the terms and conditions of this Agreement (including specifically the Operating Procedures) and Applicable Laws. Merchant is responsible and liable for any acts or omissions of Merchant\u2019s Agents, including without limitation (a) Merchant\u2019s Agents who mislead, misrepresent or defraud Applicants, Buyers or Borrowers (as applicable) or Merchant\u2019s Customers or prospective Customers in relation to or arising out of the Program, Credit Transactions or Goods and/or Services or (b) completed Applications without authorization. Alphaeon may, from time to time, offer training to Merchant\u2019s Agents. In which case, Merchant must ensure that (i) all of the Merchant\u2019s Agents involved with the Program are properly trained on all applicable requirements in the training materials, procedures, directions and instructions relating to the Program and the Online Platform (if applicable) offered by Alphaeon and (ii) only Merchant\u2019s Agents who have successfully completed all requisite training may be involved with the Program."]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Credit Transactions."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "terms-list",
          children: [jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Evidence."
            }), ' ', "A Loan will be evidenced by a consumer entering into a Loan Agreement with the Lender as the creditor. A Credit Sale will be evidenced by a consumer entering into a RIC."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Terms and Conditions."
            }), ' ', "The terms and conditions of Credit Transactions offered will be determined solely by, and all Applications will be subject to review and approval by Funder or Alphaeon (acting as service provider for Funder). Merchant will have no discretion with respect to any of the terms and conditions of the Credit Transactions or the approval or rejection of any Application, and Funder and Alphaeon will be under no obligation to approve or accept an Application or request for a Credit Transaction. For the avoidance of doubt, Merchant expressly agrees that the Funder or Alphaeon (acting as service provider for Funder) has sole authority to reject or approve any Application, update or revise credit and underwriting standards, prescribe the terms and conditions of Credit Transactions, including the Application, the Loan Agreement, the RIC, and any other related Credit Transaction documentation, and prospectively modify any terms and conditions with respect to the Credit Transaction in accordance with the terms of the Credit Transaction documentation. By submitting any Application to Alphaeon, Merchant certifies that the applicable Applicant has given consent to: (i) allow any financial institution to which the Application will be submitted (a) to obtain credit reports for the Applicant from various credit reporting agencies, and (b) to share all the information contained in the Application with all applicable financial institutions, partners and affiliates; and (ii) receive, to the extent applicable, certain disclosures and documents electronically from the financial institutions at the email address specified in the Application."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Ownership."
            }), ' ', "To the extent originated, all Credit Transactions will be funded by Funder and serviced by Alphaeon or Funder. Merchant acknowledges that Funder will, at the time of origination (for a Loan) or assignment (for a Credit Sale), own the Credit Transactions contemplated in this Agreement, and Merchant will have no ownership interest whatsoever. Upon payment of the full purchase price of a RIC to Merchant, Merchant assigns all its rights, title and interest in a RIC to Alphaeon subject to the conditions set forth herein. Funder and any subsequent holder of an ownership interest in the Credit Transactions are intended third party beneficiaries of this Agreement. Alphaeon may enforce this Agreement on behalf of said third party beneficiaries and said third party beneficiaries may enforce this Agreement directly at Alphaeon\u2019s option."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Denied Applications."
            }), ' ', "Funder shall take whatever action regarding such declination of the Application as Funder deems necessary to comply with Applicable Law, including, without limitation, responding to any Applicant\u2019s inquiry in connection with such declination, and sending an appropriate notice of adverse action directly to the Applicant. Merchant shall not, without written consent of Alphaeon, communicate to Applicant regarding Funder\u2019s declination of the Application; provided that nothing herein shall limit Merchant from providing its own adverse action notice as required by Applicable Law."]
          })]
        })]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Obligations of Merchant under the Program."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "terms-list",
          children: [jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Operating Procedures."
            }), ' ', "Additional obligations of Merchant under the Program are detailed in the Operating Procedures. The Operating Procedures include without limitation the Terms and Conditions posted by Alphaeon on its website from time to time (currently posted at https://providers.alphaeon.com/legal/alphaeon-credit-inc-terms-and-conditions) or otherwise provided to Merchant in writing (including by email). For clarity, the Operating Procedures, as changed by Alphaeon from time to time, are incorporated into this Agreement by reference."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Compliance Responsibilities."
            }), ' ', "Merchant will facilitate its Customers\u2019 and prospective Customers\u2019 applications for Credit Transactions in compliance with all Applicable Laws and this Agreement. Merchant will fulfill all obligations to its Customers and prospective Customers. Merchant must obtain all business licenses that any jurisdiction in which it will be performing work may require."]
          })]
        })]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Modifications."
        }), ' ', "Alphaeon may, from time to time, modify this Agreement, including the Operating Procedures, by providing written (including electronic) notice to Merchant (including by email) or by posting the modified terms on any online platform or website made available by Alphaeon for Merchant to conduct business with Alphaeon. Merchant\u2019s continued referral in the Program of new Applications after the effective date of any such modification will constitute Merchant\u2019s acceptance of the modified terms and Merchant\u2019s agreement to be bound by them. If Merchant does not want to accept such modifications, it must not refer any Applications subsequent to such effective date and must provide notice to Alphaeon of its decision in accordance with the notice provisions in this Agreement."]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Limitations on Merchant\u2019s Participation in the Program"
        }), ' ', "If Alphaeon determines or believes, in Alphaeon\u2019s sole discretion, that the Merchant\u2019s acts, omissions or participation in the Program poses a risk or there is otherwise a risk to the Program or Alphaeon, then, and in each such case, Alphaeon may limit Merchant\u2019s participation in the Program, or take such other action, as Alphaeon deems appropriate, including withholding of future funds, or termination of this Agreement."]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Online Platform."
        }), ' ', "Merchant agrees that some aspects of the Program or Merchant\u2019s participation in Program may require Merchant\u2019s or Applicant\u2019s enrollment into Alphaeon\u2019s online or mobile portal and account management platform (the \u201C", jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          className: "text-underline",
          children: "Online Platform"
        }), "\u201D), in which case Merchant agrees to enroll in the Online Platform or instruct Applicants to enroll in the Online Platform. The use of the Online Platform may be subject to additional terms and conditions applicable to the Online Platform, including without limitation the terms of use and any applicable privacy policy."]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Customer Complaints; Regulatory Notices"
        }), ". Within two (2) Business Days of receipt of such complaint, Merchant shall notify Alphaeon in writing of any and all complaints relating to the Program, the Consumer Transaction, or any Goods and/or Services under the Program that it receives directly or through any other mechanism. Such notification shall include an identification of the customer, the date of the complaint and a copy or description of the complaint. Merchant shall promptly investigate and make a good faith effort to resolve such complaints, including any complaints brought to Merchant\u2019s attention by Alphaeon. Within ten (10) Business Days from the date it learns of the complaint, Merchant shall notify Alphaeon in writing of the resolution thereof and the action Merchant has taken to resolve the complaint. Merchant shall provide Alphaeon with all such information as Alphaeon may reasonably request in connection therewith. Notwithstanding the foregoing, Alphaeon and not Merchant shall be responsible for addressing any complaints concerning the Consumer Transaction provided hereunder. In the event a federal or state regulatory agency commences an action against or investigates Merchant, Merchant agrees to immediately notify Alphaeon of such action or investigation (but in any event no longer than three (3) Business Days of the commencement of such action or investigation)."]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Term, Suspension and Termination."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "terms-list",
          children: [jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "This Agreement is effective on the Effective Date and will remain effective until either Party gives the other Party written notice of its decision to terminate this Agreement."
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Notwithstanding termination of this Agreement, the termination of this Agreement will not affect the rights of either Party to recover for breaches occurring (or with respect to matters relating to Credit Transactions originated) prior thereto or with respect to provisions of this Agreement that by the nature of their terms continue after termination, and the provisions of this Agreement (including the Operating Procedures) will continue in full force and effect as to all Credit Transaction applications accepted, approved, or being processed for acceptance or approval under the Program and any Credit Transaction extended pursuant to a Loan Agreement prior to or at the time of termination."
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Alphaeon may suspend Merchant\u2019s ability to refer new funding transactions on approved Credit Transactions or new Applications for any reason, including due to a dispute, complaint or investigation relating to Merchant, Credit Transactions or the Program. Such suspension may be for so long as Alphaeon determines is appropriate."
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "In the event of breach of this Agreement by either Party, the non-breaching Party will be entitled to exercise any and all rights and remedies as will be available to it at law or in equity. The non-breaching Party may exercise remedies concurrently or separately, and the exercise of one remedy will not be deemed either an election of such remedy or a preclusion of the right to exercise any other remedy."
          })]
        })]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Representations and Warranties; Covenants."
        }), ' ', "Merchant represents, warrants and covenants for the term of this Agreement that:", jsxRuntimeExports.jsxs("ol", {
          className: "terms-list",
          children: [jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "All information provided to Alphaeon in connection with the Program (including any introductory information submitted before the Effective Date) is and will remain true and correct in all respects, or any material changes will be immediately notified to Alphaeon;"
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Merchant is and will remain duly organized, validly existing and in good standing under the laws of its jurisdiction of organization, has and will maintain all requisite power and authority to carry on its business as presently conducted and as required to perform its obligations hereunder, is and will remain duly qualified or licensed to do business and in good standing (where such concept is recognized under Applicable Law) in each jurisdiction where the nature of its business or the ownership or operation of its properties makes such qualification or licensing necessary, and has and will maintain all required licenses, registrations, authorizations, permits, bonds or other approvals required by Applicable Law to perform its obligations hereunder, and to its Customers and prospective Customers;"
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Merchant has and will maintain all requisite power and authority to execute and deliver, and perform its obligations under, this Agreement and to consummate the transactions contemplated hereby;"
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "The execution, delivery and performance of this Agreement by Merchant and the consummation by Merchant of the transactions contemplated hereby have been duly authorized by all necessary action on the part of Merchant and do not contravene any governmental or contractual restriction applicable to Merchant;"
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "This Agreement has been duly executed and delivered by Merchant (and the Person signing this Agreement has full power and authority to bind Merchant to the terms of this Agreement) and, assuming the due authorization, execution and delivery by Alphaeon, constitutes a legal, valid and binding obligation of Merchant enforceable against Merchant in accordance with its terms;"
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Merchant is in compliance with all Applicable Law, including without limitation Consumer Protection Laws;"
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Merchant has not filed, or consented by answer or otherwise to the filing against it, of a petition for relief, reorganization or arrangement or any other petition in bankruptcy, for liquidation or to take advantage of any bankruptcy or insolvency law of any jurisdiction, made an assignment for the benefit of its creditors, or consented to the appointment of a custodian, receiver, trustee or other officer with similar powers of itself or of any substantial part of its property or be adjudicated insolvent or liquidated;"
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "There is no claim, action, cause of action, demand, lawsuit, arbitration, audit, notice of violation, proceeding, litigation, citation, summons, subpoena or investigation of any nature, civil, criminal, administrative, regulatory or otherwise, whether at law or in equity, in each case pending or, to Merchant\u2019s knowledge, threatened against or by Merchant relating to or affecting the Goods and/or Services subject to the Credit Transaction;"
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Merchant will participate in the Program only to support selling Merchant\u2019s Goods and/or Services to its Customers."
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Merchant documentation related to any Goods and/or Services shall contain all terms, disclosures, and notices required by the Program and any Applicable Law."
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Merchant\u2019s promotion of the Program will at all times be in compliance with this Agreement and use accurate, complete, unbiased information in compliance with Merchant\u2019s obligations under this Agreement."
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["Any marketing, promotional, or advertising materials (\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Marketing Materials"
            }), "\u201D) or documentation relating to the Program must be provided, or approved in writing, by Alphaeon, in advance of the use, and must be used only as expressly permitted by Alphaeon, in Alphaeon\u2019s sole discretion."]
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Merchant agrees that it will not prepare or disseminate any Marketing Materials, other materials or documentation regarding the Program, other than those provided, or approved in advance and in writing, by Alphaeon, and in the manner expressly permitted by Alphaeon."
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Information regarding any Consumer Transaction must only be disclosed to Customers in the manner determined by Alphaeon."
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Alphaeon may from time to time modify the Marketing Materials or documentation related to the Program. Merchant agrees that is will immediately remove and replace any existing Marketing Materials or documentation with new Marketing Materials or documentation as directed by Alphaeon."
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["Merchant will, and will cause Merchant Agents to, ensure that:", jsxRuntimeExports.jsxs("ol", {
              className: "terms-list",
              children: [jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "Each Consumer Transaction will be voluntarily entered into by a Customer and each Customer executing a Consumer Transaction is not a minor and has the capacity to enter into such Consumer Transaction."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "They will not, on behalf of any Customer, enter information into or electronically sign any Application, onscreen form, terms or conditions intended for the Customer, Application or other Program related document."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "They will not engage in false, misleading, deceptive, discriminatory, or abusive acts or practices in connection with any Consumer Transaction, the Program or the marketing, promotion or sale of its Goods and/or Services."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "All documents and agreements related to the Program which are intended for the Customer\u2019s signing shall contain genuine signatures of the Customer."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "Merchant shall maintain an identity theft prevention program for combating identity theft in connection with new and existing Consumer Transaction with Customers."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "Merchant shall not send SMS (text) messages, emails, social media posts, or other electronic communications, or place calls, promoting Alphaeon\u2019s Program, without Alphaeon\u2019s express written consent."
              })]
            })]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["Merchant shall not do any of the following:", jsxRuntimeExports.jsxs("ol", {
              className: "terms-list",
              children: [jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "Require, add, or charge any fees, finance charges, or interest to prices charged to Customers who apply for any Consumer Transaction."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "Charge a different price or provide varying terms and conditions for Merchant\u2019s Goods and/or Services for Customers who utilize a Consumer Transaction, compared to cash paying Customers."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "Discuss with any Person, including a Customer who applies for a Consumer Transaction, the likelihood that the Customer\u2019s Application will be approved."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "Complete an Application or agree to any terms on behalf of an Applicant or provide any erroneous, fake or unauthorized information on such Person (including through the use of fake, unauthorized, or fictitious names or information)."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "Include as part of any Consumer Transaction any add-on products or services, including, but not limited to, insurance or warranty products."
              })]
            })]
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Merchant has verified the identity of each Applicant (as required by Funder\u2019s requirements);"
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "To the best of Merchant's knowledge, Applicant has not used illegally obtained cash for any portion of the purchase, and has no intention to use or permit use of the RIC or Loan for any unlawful purposes; and"
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Throughout the term of the Agreement, the Merchant will procure and maintain adequate levels of insurance, as determined by Alphaeon in its sole discretion or as required by applicable law."
          })]
        }), jsxRuntimeExports.jsx(P, {
          variant: "body-large",
          className: "mar-t-16",
          children: "In addition, Merchant makes the following representations and warranties: (i) as to each RIC at the time of the sale and assignment of the RIC, at all relevant times, each RIC was owned by Merchant free and clear of any and all interests held by third parties, including, but not limited to, assignments, security interests, encumbrances, claims, liens and levies; and (ii) as to each RIC at the time of the purchase of the RIC and as to each Loan at the time of the origination of a Loan, no RIC or Loan Agreement is (a) subject to any claim or complaint relating to the Goods and/or Services or the performance by Merchant of its obligations with respect thereto (including any claims or complaints to a governmental agency or third-party); (b) subject to any liens, mortgages, encumbrances or security interests (nor are any Goods and/or Services subject to any liens, mortgages, encumbrances or security interests); (c) rendered invalid or unenforceable as a result of any action or omission by Merchant, or (d) subject to any claim, dispute, or offset of any kind by the Customer including, but not limited to, any claim, dispute or offset relating to identity theft. Merchant agrees to fully comply with and not breach any provision of this Agreement or the Operating Procedures as of the date of the Application as a condition of disbursal of Loan proceeds or the purchase of a RIC in connection with an Application. Merchant agrees to execute any assignment agreement as required by Alphaeon or Funder. In the event that Alphaeon determines that any Credit Transaction Document has been incorrectly and improperly completed or executed or any document to be delivered or action to be taken by Merchant under this Agreement or under any Credit Transaction Document was incorrect or incomplete, and Alphaeon requests Merchant to take any lawful remedial action with respect thereto (including, in appropriate cases, obtaining a replacement or corrected Credit Transaction Document or other document), Merchant shall, either (i) immediately comply with such request or (ii) if Alphaeon so requests, immediately return to Alphaeon the proceeds of the applicable Credit Transaction, or in the case of a RIC, repurchase the applicable RIC, without recourse to Alphaeon, for an amount equal to the outstanding balance of the Amount Financed (i.e., the dollar amount of the Goods and/or Services that Buyer or Borrower (as applicable) agreed to finance and purchase from Merchant as disclosed in the Credit Transaction\u2019s Truth in Lending Act disclosure). Merchant will give Alphaeon prompt written notice of any representation and warranty made by it in this Agreement that it hereafter learns was inaccurate or incorrect when originally made and any event, change or occurrence arising after the date hereof that would make any representation or warranty of Merchant inaccurate or incorrect as of the time of such event, change or occurrence. The giving of any such notices will not limit or modify any rights of Alphaeon hereunder arising in the case of a breach of a representation or warranty by Merchant."
        })]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          className: "text-underline",
          children: "Ancillary Products"
        }), jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          className: "text-underline",
          children: "."
        }), ' ', jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          className: "text-underline",
          children: "Merchant may provide and, subject to Funder\u2019s approval, Funder may agree to finance various Ancillary Products as requested by Buyer or Borrower. Merchant acknowledges that"
        }), ' ', "Alphaeon", ' ', jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          className: "text-underline",
          children: "or Funder has the obligation under Applicable Law in certain circumstances to provide refunds of unearned Ancillary Product charges directly or ensure that such refunds are provided by the Ancillary Product provider or administrator. If an Ancillary Product is cancelled or terminated prior to the expiration of its stated term, unless otherwise provided for in the Ancillary Product contract or Applicable Law, Merchant shall be responsible for ensuring that the provider or administrator provides a refund equal to the unearned portion of the Buyer\u2019s or Borrower\u2019s cost for such Ancillary Product. The amount shall be calculated using the pro rata method or the method otherwise provided for in the insurance policy or required by Applicable Law. If a balance is owed on the Credit Transaction, then Merchant will ensure that the refund is paid to"
        }), ' ', "Alphaeon", ' ', jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          className: "text-underline",
          children: "or Funder. If the Buyer or Borrower does not owe a balance on the Credit Transaction, then Merchant will ensure that the refund is remitted to the Buyer or Borrower, unless otherwise directed by"
        }), ' ', "Alphaeon", ' ', jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          className: "text-underline",
          children: "or Funder. Notwithstanding the foregoing, if"
        }), ' ', "Alphaeon", ' ', jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          className: "text-underline",
          children: "or Funder advances and pays the Buyer or Borrower any refund amount that is not paid by the provider or administrator, Merchant will be responsible for reimbursing"
        }), ' ', "Alphaeon", ' ', jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          className: "text-underline",
          children: "or Funder upon request. Payment of any refund amount will be made in a timely manner and in accordance with Applicable Law, but in any event not more than 60 days after receiving notice of cancellation of the Ancillary Product. Merchant will furnish a copy of the insurance certificate naming"
        }), ' ', "Alphaeon", ' ', jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          className: "text-underline",
          children: "or Funder as primary beneficiary."
        })]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Merchant Ineligible for Loan or RIC"
        }), ". Merchant acknowledges and agrees that neither it nor any of its owners, directors, officers, members, managers, representatives, employees or any member of their immediate families is eligible for a Loan or RIC."]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Payment Authorization."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "terms-list",
          children: [jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["Merchant authorizes Alphaeon to initiate credit and debit entries (including Automated Clearing House entries or by other electronic transfer of funds \u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Funds Transfer"
            }), "\u201D) for all amounts due from or to be paid to Merchant under this Agreement and to initiate, if necessary, debit or credit entries and adjustments for any debit or credit entries in error, to any of Merchant\u2019s checking and/or savings accounts for which information is provided to Alphaeon. Merchant and Alphaeon agree that the origination of ACH transactions described in this Section 12 must comply with Applicable Law and NACHA rules. If any such account lacks sufficient funds for any debit from Alphaeon, Merchant will pay Alphaeon the entire amount of the debit. Merchant is solely responsible for any overdraft charges or other fees that its bank may assess in connection with transfers initiated pursuant to this Agreement."]
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "The authorizations set forth in this Section are irrevocable and will remain in effect until the date on which no Loans or RICs remain outstanding. Merchant must notify Alphaeon within three (3) Business Days of any change to the bank account for such Funds Transfers. Alphaeon agrees to comply with written notifications from Merchant that alter Merchant\u2019s bank account information (i.e., name and address of the bank or financial institution, transit/routing number or account number), provided that Alphaeon receives such notification in sufficient time and manner to give Merchant and the bank or financial institution reasonable opportunity to act on it. Alphaeon may also permit payment by Merchant delivering to Alphaeon on terms acceptable to Alphaeon a cashier\u2019s check or money order in the full amount owed to an address designated by Alphaeon or by Merchant initiating, on conditions acceptable to Alphaeon, a payment that is a credit entry to an account designate by Alphaeon."
          })]
        })]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Indemnification Rights; Affected Credit Transactions; Merchant Defaults."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "terms-list",
          children: [jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["Merchant (on behalf of itself, Merchant\u2019s Agents and its affiliates, each an \u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Indemnifying Person"
            }), "\u201D) agrees to indemnify, defend (at Merchant\u2019s sole expense and with counsel reasonably acceptable to Alphaeon), and hold harmless Alphaeon and Funder (and their respective officers, directors, shareholders, members, partners, managers, employees, representatives, agents, successors and assigns, each an \u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Indemnified Person"
            }), "\u201D) from and against any and all losses, claims, investigations, litigation, proceedings, liabilities, damages, administrative charges, actions, suits, injunctions, judgments, hearings, settlements, charges, demands, penalties, fines, costs, and expenses (including attorneys\u2019 fees) of any kind whatsoever (collectively a \u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Loss"
            }), "\u201D) directly or indirectly arising out of or related to: (i) failures to pay any Credit Transaction by any Buyer or Borrower (as applicable) due to disputes between Merchant and its Customers over the Goods and/or Services; (ii) Merchant\u2019s breach of any representation, warranty, obligation or covenant contained in this Agreement (including the Operating Procedures), or any such breach caused by an Indemnifying Person; (iii) failure of Indemnifying Person to comply with any Applicable Law; (iv) any Loss sustained by, claimed, or threatened against any Indemnified Person attributable in whole or in part to negligence, recklessness, fraud, error (whether negligent or not), omission or misconduct of Merchant or any Indemnifying Person; (v) any defect, shortcoming, flaw in any Goods and/or Services sold or provided by Merchant or any Indemnifying Person, any breach of any express or implied warranty in connection with such Goods and/or Services or another dispute relating to such Goods and/or Services or any Losses related to Merchant\u2019s business practices; (vi) any voluntary or involuntary bankruptcy or insolvency proceeding by or against Merchant; (vii) any Affected Credit Transaction; and (viii) any Loss incurred based on an Indemnifying Person\u2019s failure to properly describe or deliver Goods and/or Services or comply with Indemnifying Person\u2019s legal or contractual obligations to third parties (including Customers of Merchant); provided that Merchant will have no obligations or liability under this Section 14 to the extent a Loss results solely from the gross negligence or willful misconduct of an Indemnified Person. Merchant further agrees to reimburse each Indemnified Person upon demand for all legal and other expenses (including expenses related to investigation, settlement, compromise, or satisfaction) incurred by any such Indemnified Person in connection with any of the foregoing."]
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Merchant agrees that if it breaches any representation, warranty, covenant or obligation herein, including failure to properly provide the Goods and/or Services, or if a Buyer or Borrower (as applicable) or Applicant asserts any claim or defense arising out of any transaction evidenced by any Loan Agreement or Credit Transaction applications or cancels any transaction evidenced by any Loan Agreement or Credit Transaction applications, Merchant will refund on demand the amount of any Credit Transaction affected, plus any finance or other charges related to such Credit Transaction. Merchant also agrees to indemnify and hold harmless the Indemnified Persons for any and all breaches of warranties or Losses that any Indemnified Person may sustain as a result of any such event, and Alphaeon and Funder are not responsible for any amounts claimed to be owed to Merchant by Merchant\u2019s Customers, including amounts for payment transactions that were authorized but that were subsequently rejected or reversed."
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "In the event and for so long as any Indemnified Person actively is contesting or defending against any Loss in connection with (i) any transaction contemplated under this Agreement or (ii) any fact, situation, circumstance, status, condition, activity, practice, plan, occurrence, event, incident, action, failure to act, or transaction involving Merchant or any Indemnifying Person or any current or prospective customer of Merchant, Merchant and any such Indemnifying Person will cooperate with such Indemnified Person and its counsel with respect thereto, make available any personnel under its control, and provide such testimony and access to its books and records, including allowing copies to be made by such Indemnified Person or its representatives, as will be reasonably necessary in connection therewith, all at the sole cost and expense of Merchant."
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "For the avoidance of doubt, Merchant\u2019s obligations under this Agreement are not affected by: (a) any release, settlement, extension, forbearance, or variation in terms that Alphaeon or Funder may grant in connection with any Credit Transaction; or (b) the release of the obligations of any Buyer or Borrower (as applicable) by a court or by operation of law."
          })]
        })]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Affected Credit Transactions."
        }), ' ', "Merchant shall give Alphaeon immediate notice if it becomes aware that any Credit Transaction is an Affected Credit Transaction. In addition to the indemnification rights provided by Section 14, Alphaeon, on its own behalf or on behalf of Funder or any assignee of a Credit Transaction, may require Merchant to return Loan proceeds associated with the Credit Transaction or purchase any Affected Credit Transaction that is a RIC. The purchase price (the \u201C", jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          className: "text-underline",
          children: "Affected Credit Transaction Purchase Price"
        }), "\u201D) shall equal: (a) the outstanding principal balance of the Affected Credit Transaction as of the purchase date; less (b) the discount applicable to such Affected Credit Transaction times such outstanding principal balance. The rights provided by this paragraph shall be exercised by delivery of a notice from Alphaeon to Merchant of Merchant\u2019s obligation to purchase an Affected Credit Transaction, which notice shall specify in reasonable detail the basis for classifying the Credit Transaction as an Affected Credit Transaction. Upon Merchant\u2019s payment of the Affected Credit Transaction Purchase Price, Merchant shall be deemed to have purchased the Affected Credit Transaction without recourse. Alphaeon may offset against any funds otherwise due from Alphaeon to Merchant any amounts due under Agreement."]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Merchant Defaults."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "terms-list",
          children: [jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Merchant\u2019s breach of any representation, warranty, or covenant set forth in this Agreement will constitute an event of default of Merchant hereunder. Upon the occurrence of any event of default by Merchant, Alphaeon shall have the following rights and remedies, any or all of which may be exercised by Alphaeon, without notice, in its sole discretion: (i) to require Merchant to repurchase any Affected Credit Transaction that is a RIC, each for the Affected Credit Transaction Purchase Price; (ii) to offset against any funds otherwise due from Alphaeon to Merchant all amounts due to Alphaeon under this Agreement; (iii) to require the direct payment of cash from Merchant to Alphaeon of all amounts due to Alphaeon under this Agreement; (iv) to discontinue funding of Credit Transactions hereunder, including any Credit Transaction Document for which Alphaeon has approved an Application but not yet funded; (v) to implement Funder\u2019s decision to discontinue making Credit Transactions, including any approved Credit Transaction where Funder has not yet funded; (vi) to immediately terminate this Agreement; and (vii) to exercise any and all other remedies, legal and equitable, available to Alphaeon under this Agreement and/or Applicable Law. No right or remedy afforded Alphaeon is intended to be exclusive of any other right or remedy, and every right and remedy shall be cumulative and in addition to every other right or remedy."
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Merchant shall be required to pay any reasonable collection and attorneys\u2019 fees and costs incurred by Alphaeon or Funder in enforcing and/or protecting its rights hereunder, including any fees or costs incurred in connection with any bankruptcy or insolvency proceeding affecting Merchant."
          })]
        })]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Confidential Information"
        }), ".", jsxRuntimeExports.jsxs("ol", {
          className: "terms-list",
          children: [jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Merchant agrees to keep all Customer Information private and confidential, and agrees not to release such information to, or allow such information to be accessed by, any third party for any purpose whatsoever, except in compliance with this Agreement."
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["Merchant will keep confidential and not disclose to any Person or entity (except to Merchant\u2019s Agents who are engaged in the implementation and execution of the Program, have a need to know, and are bound by confidentiality obligations substantially similar, but in no event less restrictive, to those contained herein) all information, whether tangible or intangible and whether oral, in writing, or in any other medium and whether or not designated as confidential, including but not limited to product terms and information, compliance standards, processes and procedures, training or operational materials, marketing and sales strategies, trade secrets, know-how, any materials shared during negotiations, business plans, analyses, forecasts, pricing, proposals, terms of this Agreement (including the Operating Procedures), software, systems, any information that Merchant may receive (directly or indirectly) from Alphaeon, any consumer, or from any other source relating to the Program or this Agreement, including consumer names, addresses, Credit Transaction applications and information contained therein, Loan Agreement or RIC information (including the terms thereof), and other nonpublic financial information or Consumer Information, and any other information that, given the nature of the information or the circumstances surrounding its disclosure, reasonably should be considered as confidential (collectively, \u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Program Confidential Information"
            }), "\u201D), except that Merchant (i) will use, or cause its Merchant\u2019s Agents to use, any such Program Confidential Information (a) solely as needed and for the purposes of the performance of Merchant\u2019s obligations under the terms of this Agreement or (b) as expressly permitted in writing by Alphaeon. Merchant will be solely responsible for any breach of this Agreement caused by any of Merchant\u2019s Agents or (ii) may disclose as required by applicable federal, state, or local law or regulation, in which case: (a) before making any such disclosure, the Merchant will, to the extent legally permissible, provide Alphaeon with prompt written notice of such requirement so that Alphaeon may seek a protective order or other remedy and provide reasonable assistance in opposing such disclosure or seeking a protective order or other limitations on disclosure; and (b) if, after providing notice and assistance as required herein, Merchant remains subject to the requirement by said law or regulation, Merchant will disclose no more than that portion of the Program Confidential Information that, on the advice of Merchant\u2019s legal counsel, such law or regulation specifically requires Merchant to disclose and, on Alphaeon\u2019s request, use commercially reasonable efforts to obtain assurances that such information will be afforded confidential treatment. Merchant will maintain the confidentiality of all Program Confidential Information by establishing and utilizing physical, electronic and administrative procedures to protect the security and confidentiality of the information."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["Notwithstanding the foregoing, Merchant certifies that it understands and will comply, and cause Merchant\u2019s Agents to comply, with the following:", jsxRuntimeExports.jsxs("ol", {
              className: "terms-list",
              children: [jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "Merchant will not, and will cause Merchant\u2019s Agents not to, disclose any Program Confidential Information (including Consumer Information) to any other third-party purchase money lender or any other third-party provider of consumer financing without the prior written approval of Alphaeon."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "Merchant will maintain Consumer Information in compliance with Applicable Law. Merchant will not, and will cause Merchant\u2019s Agents to not, (a) collect, retain, use, disclose or otherwise process any Consumer Information for any purpose other than only for the specific purpose of performing Merchant\u2019s obligations under this Agreement in compliance with Applicable Law, and (b) sell any Consumer Information."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "Merchant will not, and will cause Merchant\u2019s Agents to not, store or access Consumer Information outside the United States and will provide access to Consumer Information only to its Merchant\u2019s Agents who are located within the United States."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "Upon written request at any time by Alphaeon or upon termination of the Agreement, Merchant agrees to return to Alphaeon or destroy all information, documentation or materials relating to the Program including Program Confidential Information, in Merchant\u2019s custody, control, or possession without retaining any copies."
              })]
            })]
          }), jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Merchant agrees to immediately notify Alphaeon, and in all events within forty-eight (48) hours unless earlier required by Applicable Law, upon becoming aware of any actual, threatened or alleged breach of the security, confidentiality or integrity of Consumer Information or its confidentiality obligations hereunder. Merchant further agrees to assist and cooperate with Alphaeon in order to respond to any valid consumer requests under Applicable Law."
          })]
        })]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Ownership of Program; Intellectual Property."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "terms-list",
          children: [jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Ownership of Program."
            }), ' ', "Neither Merchant nor any parent, subsidiary or other affiliate of Merchant will by virtue of this Agreement or otherwise secure any title to or other ownership interest in any elements of the Program, including the Credit Transactions, Operating Procedures, written specifications, training materials, programs, systems, screens or any documentation or materials relating thereto, which, as between Alphaeon and Merchant, are the exclusive property of Alphaeon or Alphaeon\u2019s designees. Merchant agrees to use the elements of the Program and information about the Program only for the purpose of enabling Merchant to participate in the Program as provided under this Agreement and for no other purpose. Alphaeon has the right to use and disclose any information received from Merchant in relation to this Program."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Intellectual Property."
            }), ' ', "All intellectual property rights, including copyrights, patents, patent disclosures and inventions (whether patentable or not), trademarks, service marks, trade secrets, know-how and other Program Confidential Information, trade dress, trade names, logos, corporate names and domain names, including any marketing materials or training and operational materials, together with all of the goodwill associated therewith, derivative works and all other rights in and to all documents, work product and other materials that are delivered to or accessed by Merchant for its use under this Agreement or otherwise in connection with the Program are and will continue to be owned by Alphaeon. Merchant hereby grants Alphaeon and Funder and their respective affiliates a nonexclusive and royalty-free license to use Merchant\u2019s name, contact information, trademarks, tradenames logos, other branding, and other marks in connection with the administration and operation of the Program, including for Alphaeon\u2019s and Funder\u2019s purpose of Program promotion and administration."]
          })]
        })]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Information Security; Records; Ownership."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "terms-list",
          children: [jsxRuntimeExports.jsx(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: "Merchant will not disclose, and will take all commercially reasonable measures to protect, Consumer Information. Merchant will not retain in any format, electronic or otherwise, any Consumer Information beyond what is required pursuant to this Agreement. Without by implication limiting the foregoing, if Merchant allows individuals to submit personal identifying information via the Internet, Merchant will adopt and maintain a comprehensive privacy policy with respect to its handling of such personal information, and Merchant\u2019s privacy policy will be available on Merchant\u2019s Internet web sites. Merchant agrees that it has developed, implemented and will maintain at all relevant times contemplated by this Agreement effective information security policies and procedures that include administrative, technical and physical safeguards designed to ensure the security and confidentiality of Consumer Information, protect against anticipated threats or hazards to the security or integrity of Consumer Information, protect against unauthorized access or use of Consumer Information, and ensure the proper disposal of Consumer Information. All personnel handling Consumer Information will be appropriately trained in the implementation of such information security policies and procedures. Merchant will regularly audit and review its information security policies and procedures and systems to ensure their continued effectiveness and determine whether adjustments are necessary in light of circumstances, including changes in technology, customer information systems or threats or hazards to Consumer Information. Merchant will promptly notify Alphaeon of any unauthorized access to Consumer Information and any breach in security measures or systems for the protection of Consumer Information and take appropriate action to prevent further unauthorized access and cure such breach. Merchant will cooperate with Alphaeon with respect to its investigation or inquiry as to any such unauthorized access or breach, provide any notices regarding such unauthorized access or breach to appropriate law enforcement agencies and government regulatory authorities, affected Applicants, Buyers or Borrowers (as applicable) and Customers as Alphaeon, in its sole discretion, deems appropriate, and pay all expenses related thereto. Merchant agrees that Alphaeon may at any time upon notice to Merchant, review and audit Merchant\u2019s information security policies, procedures and systems to verify their adequacy for protection of Consumer Information. Merchant will correct promptly any weakness in such policies, procedures or systems identified by Alphaeon in its reviews thereof. To the extent that applicable privacy, data security or other laws require Alphaeon or a Funder to comply with requests from Applicants or Buyers or Borrowers (as applicable) to access, delete, modify, or restrict the processing of their personal information (as determined by Alphaeon or Funder), Merchant agrees to promptly provide such assistance as Alphaeon or its selected Funder requests to fulfill such requests."
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Records."
            }), ' ', "All data transmitted will be in a medium, form and format designated by Alphaeon under the Program. Any errors in such data or in its transmission by Merchant will be the responsibility of Merchant, and any errors in such data or in its transmission by Alphaeon will be the responsibility of Alphaeon. Merchant will maintain paper copies (when used) or copies of electronic images of the Applicants\u2019 or Buyers\u2019 or Borrowers\u2019 (as applicable) authorization to submit Applications, the Credit Transaction applications and the Invoices and other records pertaining to any Credit Transaction or transaction under the Program for such time and in such manner as Alphaeon or Applicable Law may require, but in no event less than seven years from the date of the Application or Credit Transaction applications."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Ownership."
            }), ' ', "Any information that is received, collected, or otherwise obtained by Alphaeon or Funder in the ordinary course of the Program, such as information received as part of a Credit Transaction application, the underwriting process, a Loan Agreement, RIC, or the servicing and collections processes, will be owned solely by Alphaeon and Funder. Except as otherwise expressly provided herein, the Parties acknowledge and agree that Merchant\u2019s information technology systems and Alphaeon\u2019s information technology systems will be completely separate and will not be integrated."]
          })]
        })]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Reserve Account; Right to Set-Off; Chargebacks; Limited Power of Attorney."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "terms-list",
          children: [jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Reserve Account"
            }), ". If requested by Alphaeon, Merchant will establish and maintain a collateral or reserve account that is satisfactory to Alphaeon (\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Reserve Account"
            }), "\u201D) and Alphaeon will have the right to debit Merchant\u2019s bank account(s) (including any accounts of Merchant disclosed by Merchant to Alphaeon) for amounts that Alphaeon deems necessary to fund the Reserve Account."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Right to Set-Off; Chargebacks"
            }), ". Notwithstanding any other provision of this Agreement to the contrary, Merchant agrees that Alphaeon may, in its sole discretion, set-off any amounts owing to Merchant\u2014whether in association with a Credit Transaction and/or with any other amounts Alphaeon may otherwise owe to Merchant from time to time\u2014against any amounts Merchant owes or will owe to Alphaeon (including any amount Merchant owes Alphaeon pursuant to the indemnification provisions provided in this Agreement). Alphaeon may direct and use funds held on behalf of Merchant to recover chargebacks, fines, and fees associated with the Credit Transactions (including those assessed regarding a Buyer or Borrower (as applicable)) or any amount Merchant owes Alphaeon or Funder or that is otherwise due from Merchant under this Agreement."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Limited Power of Attorney."
            }), ' ', "For each Credit Transaction made, upon Alphaeon\u2019s request, Merchant will deliver to the Buyers or Borrowers (as applicable) or obligors, any notice required by Alphaeon that all payments on Credit Transactions will be made to Alphaeon. However, to the extent that Merchant or Merchant\u2019s Agents receive any payments from Buyers or Borrowers (as applicable) or obligors on Credit Transactions or pursuant to the Credit Transaction Documents (including payments of principal, interest, late fees, or other charges authorized pursuant to the Credit Transaction Documents), Merchant and Merchant\u2019s Agents agree not to accept payment. Merchant agrees to immediately endorse and forward, without offset or deduction, to Alphaeon all such check, bank draft, money order, other negotiable instrument, or other payment instrument received by Merchant that are payments on Credit Transactions or pursuant to the Credit Transaction Documents. Prior to forwarding any such check, bank draft, money order, other negotiable instrument, or other payment instrument, Merchant will hold it in trust for Alphaeon, without commingling it with Merchant\u2019s other funds. Merchant hereby irrevocably nominates, constitutes and appoints Alphaeon as its true and lawful attorney in fact, in Merchant\u2019s name, place and stead, with full right title and authority to sign and deliver any Credit Transaction Documents and to sign, endorse and negotiate any check, bank draft, money order, other negotiable instrument, or other payment instrument payable to Merchant with respect to any Credit Transaction Documents, and Merchant will otherwise cooperate with respect therewith. This power of attorney will be deemed to be coupled with an interest."]
          })]
        })]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "ATTORNEYS\u2019 FEES; LIMITATION OF LIABILITY; DISCLAIMER OF WARRANTIES."
        }), ' ', "TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW: (I) MERCHANT WILL BE LIABLE TO INDEMNIFIED PERSONS FOR ALL DAMAGES UNDER APPLICABLE LAW AND COSTS INCURRED IN ANY COLLECTION ACTION OR OTHER LEGAL PROCEEDING ANY INDEMNIFIED PERSON MAY BRING AGAINST MERCHANT (INCLUDING ATTORNEYS\u2019 FEES, COURT COSTS, INTEREST, FILING FEES AND OTHER EXPENSES OF ANY KIND WHATSOEVER); AND (II) IN NO EVENT WILL ANY INDEMNIFIED PERSON BE LIABLE TO MERCHANT OR ANY OTHER PERSON FOR ANY PUNITIVE, SPECIAL, SPECULATIVE, INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES, INCLUDING LOSS OF PROFIT OR ANY OTHER SIMILAR DAMAGE OR LOSS, WHETHER BASED IN CONTRACT, TORT (INCLUDING NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, STATUTES OR REGULATIONS OR ANY OTHER THEORY) ARISING OUT OF OR RELATING TO THE PROGRAM OR THIS AGREEMENT, EVEN IF ADVISED OF SUCH POTENTIAL DAMAGES OR LOSSES. THE PROGRAM AND ANY SERVICES RELATED THERETO ARE PROVIDED \u201CAS IS\u201D AND \u201CAS AVAILABLE\u201D AND ALPHAEON HEREBY EXPRESSLY DISCLAIMS ALL REPRESENTATIONS AND WARRANTIES, WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT, AND ANY WARRANTIES ARISING FROM COURSE OF DEALING OR COURSE OF PERFORMANCE. ALPHAEON DOES NOT GUARANTEE THAT MERCHANT WILL RECEIVE ANY MINIMUM AMOUNT OF SALES OR REVENUES AS A RESULT OF THE ACTIVITIES CONTEMPLATED BY THIS AGREEMENT AND THAT THE PROGRAM WILL BE CONTINUOUSLY AVAILABLE OR ERROR-FREE."]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Dispute Resolution & Arbitration."
        }), ' ', "Any controversy, dispute, or claim arising out of or relating to this Agreement, or the interpretation, enforceability, or validity of this Agreement, including the scope or applicability of the agreement to arbitrate, that cannot be resolved informally by the Parties (\u201C", jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          className: "text-underline",
          children: "Dispute"
        }), "\u201D) will be solely and finally resolved pursuant to this Section 22. The Parties agree Section 22(b) is governed by the Federal Arbitration Act.", jsxRuntimeExports.jsxs("ol", {
          className: "terms-list",
          children: [jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Direct Business Negotiation"
            }), ". The Parties will use their best efforts to resolve any Dispute by good faith negotiation between officers who have authority to resolve the Dispute. Upon the written request of any Party, the Parties will arrange for their respective senior representatives to meet within thirty (30) days following the request for the purpose of resolving such Dispute on amicable terms. No proceeding may be commenced under Section 22(b) until, at least fourteen (14) days after such meeting, a Party\u2019s senior representative communicates to the other Party his or her good faith conclusion that an amicable resolution of the matter is unlikely. Any discussions undertaken pursuant to this Section 22(a) will be confidential compromise and settlement negotiations without prejudice to any Party\u2019s right to any other remedy in law or equity or under this Agreement."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Arbitration"
            }), ". Any Dispute that remains unresolved following the negotiations undertaken pursuant to Section 22(a) will be solely and finally settled by confidential arbitration in accordance with this Agreement and, where not inconsistent with this Agreement, with the commercial rules of the American Arbitration Association, which rules are hereby incorporated by reference. The location of the arbitration will be in Orange County, California or, if both Parties agree, remotely through video conference. The arbitration will be conducted in English by a panel of three neutral arbitrators, with each Party selecting one arbitrator and the two appointed arbitrators then jointly selecting the third. Except as may be required by law or expressly permitted in this Agreement, the panel is not empowered to award punitive, exemplary, special, speculative, indirect, pre-award interest, incidental or consequential damages, including loss of profit or any other similar damage or loss, whether based in contract, tort (including negligence, strict liability or otherwise, statutes or regulations or any other theory) arising out of or relating to the program or this Agreement, even if advised of such potential damages or losses. All costs and expenses of the arbitrators will be borne by the Parties equally, and each Party will bear its own arbitration costs, including its attorneys\u2019 fees and travel expenses. A reasoned award will be issued in writing by the panel and will be final and binding upon the Parties. If not fully satisfied within thirty (30) days, such award may be enforced in any court of competent jurisdiction and each Party hereby consents to the jurisdiction of such court for the purposes of complying with this Section 22(b) and the award granted in accordance with it. Nothing in this Agreement limits the right of a Party to obtain provisional, injunctive, or ancillary remedies from a court of competent jurisdiction before, after, or during the pendency of any arbitration. Neither Party has the right to arbitrate on a class or representative basis any Dispute including, without limitation, this Section 22(b)."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Exceptions to Arbitration."
            }), ' ', "Notwithstanding the foregoing, the Parties agree that the provisions of Section 22(a) through 22(b) will not apply with respect to any third-party claim in the event such third party: has initiated a lawsuit or other judicial, administrative, or arbitration proceedings against or involving either or both of the Parties in which a Dispute will be resolved; or is a necessary participant in any judicial, administrative, or arbitration proceedings to resolve a Dispute and cannot be joined by either or both of the Parties in a resolution of such Dispute pursuant to the procedures set forth in Section 22(a) through 22(b) and as such the procedure set forth in Section 22(a) through 22(b) is or will be ineffective as to such Dispute; provided, however, that the procedures set forth in this Section 22(a) through 22(b) will apply in the event a Dispute in connection with the foregoing events set forth in this Section 22(c) relates to whether any claims in connection with such third-party claim is indemnifiable by either Party."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Jurisdiction."
            }), ' ', "Should any portion of the provisions of Section 22(a) through Section 22(b) be found to be unenforceable, such portion will be severed from this Agreement, and the remaining portions will continue to be enforceable. However, if for any reason all of the provisions of Section 22(a) through Section 22(b) are found to be unenforceable, then the following will apply instead: any suit, counterclaim, action or proceeding arising out of or relating to this Agreement or the transactions contemplated hereby, any related document or under any other document or agreement delivered or which may in the future be delivered in connection herewith or therewith, or arising from any relationship existing in connection with this Agreement, must be brought by either Party exclusively in the state court situated in Orange County, California or in the United States District Court for the Central District of California, and the Parties hereby irrevocably submit to the exclusive jurisdiction of such courts and any appellate courts thereof for the purpose of any such suit, counterclaim, action or proceeding or judgment thereon (it being understood that such consent to the exclusive jurisdiction of such courts waives any right to submit any disputes hereunder to any courts other than those above)."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Waiver of Jury Trial; No Class Action; No Representative Action"
            }), ". Each Party hereby knowingly, voluntarily and intentionally waive any right to a trial by jury in any action, suit, proceeding or counterclaim arising out of or relating to this Agreement or the transactions contemplated hereby, any related document or under any other document or agreement delivered or which may in the future be delivered in connection herewith or therewith, or arising from any relationship existing in connection with this Agreement, and agree that any such action, suit, proceeding or counterclaim will not be tried before a jury and that this provision is a material inducement for entering into the Agreement. To the fullest extent permitted by applicable law, each Party hereto agrees that any such proceeding will be conducted only on an individual basis and not in a class, consolidated or representative action. Each Party acknowledges that it is entering into this Agreement after having the opportunity to consult counsel."]
          })]
        })]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Miscellaneous"
        }), ".", jsxRuntimeExports.jsxs("ol", {
          className: "terms-list",
          children: [jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Further Assurances."
            }), ' ', "Merchant agrees to execute all such additional documents and instruments and to do all such further things as Alphaeon may reasonably request in order to give effect to and consummate the purposes of the Agreement contemplated hereby. In addition, Merchant authorizes Alphaeon to execute and deliver and file, for itself and on behalf of Merchant, any documents, including forms under the Uniform Commercial Code, necessary or desirable to confirm, protect or renew Alphaeon\u2019s interest in any Credit Transaction."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Publicity."
            }), ' ', "Except as provided herein or with the express prior written consent of Alphaeon in each instance, Merchant will not advertise or promote using the name of Alphaeon or Funder, use the name of Alphaeon or Funder\u2019s company in the Merchant\u2019s website(s) or any of Merchant\u2019s advertising, publicity, or promotional material, nor issue any press release announcing the Agreement with the press or the public, provided that Merchant may disclose the name of Alphaeon when such disclosure is required by Applicable Law."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Subcontracting."
            }), ' ', "Merchant acknowledges that various components of the Program or Alphaeon\u2019s obligations under this Agreement may be subcontracted by Alphaeon to third parties. Alphaeon may share with its subcontractors information and data related to the Program and this Agreement."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Right to Examine and Audit; Requests; Credit Reports & Financial Statements."
            }), jsxRuntimeExports.jsxs("ol", {
              className: "terms-list",
              children: [jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "Merchant agrees that Alphaeon or the Lender may, at any time upon notice to Merchant, review or audit Merchant (including Merchant\u2019s policies, procedures, systems, internal controls, contracts, and other books or records) to verify Merchant\u2019s compliance with this Agreement. Merchant agrees to promptly correct any weakness identified by Alphaeon or the Lender in its reviews or audits thereof. Merchant also agrees that any regulatory body or supervisory agency having jurisdiction over Alphaeon or the Lender will also have access to Merchant\u2019s books and records, systems, controls, processes and procedures relating to the Program when deemed necessary and without prior notice."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "Within seven (7) days of receipt of Alphaeon\u2019s request, or such earlier time as may be required by Alphaeon, Merchant will provide to Alphaeon the Applicant\u2019s or Buyer\u2019s or Borrower\u2019s (as applicable) authorization for an Application, the Credit Transaction applications, the Invoice or other transaction records, including evidence of an Applicant\u2019s or Buyer\u2019s or Borrower\u2019s (as applicable) express consent to submit an Application or transaction, and any other documentary evidence available to Merchant and reasonably requested by Alphaeon (a) to meet its obligations under Applicable Law or otherwise to respond to questions, complaints, lawsuits, counterclaims or claims concerning Credit Transactions or requests from Applicants, Buyers or Borrowers (as applicable), or regulatory authorities, (b) to provide any information in connection with Alphaeon\u2019s pursuit, or its selected Funder\u2019s pursuit, of bad debt tax refunds, deductions, credits, or audit offsets (including providing copies of Merchant\u2019s state sales and use tax returns), (c) to ensure Merchant\u2019s compliance with this Agreement, or (d) to enforce any rights Alphaeon or its selected Funder may have against Merchant, an Applicant, or a Buyer or Borrower (as applicable), including litigation by or against Alphaeon or such Funder, collection efforts and bankruptcy proceedings, or for any other reason."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "Merchant authorizes Alphaeon and/or its selected Funder to obtain credit reports with respect to Merchant and, to the extent permitted by law, to obtain credit reports individually with respect to Merchant or any of Merchant\u2019s Agents, for the purpose of qualifying Merchant\u2019s business for initial participation in the Program and, in the case of when Alphaeon determines or believes, in Alphaeon\u2019s sole discretion, that there is risk, for evaluating Merchant\u2019s business for continued participation in the Program. Merchant agrees that it is authorizing Alphaeon to obtain credit reports and instructing any consumer reporting agency to provide such report now and in the future for the purpose of evaluating Merchant\u2019s business for future retention and participation in the Program. Merchant also agrees that, upon request, Merchant will provide a copy of Merchant\u2019s most recent financial statements in reasonable detail and prepared in accordance with generally accepted accounting principles."
              })]
            })]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Merger and Integration."
            }), ' ', "Except as specifically stated otherwise herein, this Agreement, sets forth the entire understanding of Alphaeon and Merchant relating to the subject matter hereof, and all prior understandings, written or oral, are superseded by this Agreement. This Agreement may not be modified, amended, waived, or supplemented except as provided herein. All exhibits, schedules, and amendments hereto and any documents or instruments delivered pursuant to any provision hereof are expressly made a part of this Agreement as fully as though completely set forth herein. In the event of conflict between this Agreement and the Operating Procedures or any other exhibit or schedule this Agreement shall control."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Independent Contractor."
            }), ' ', "This Agreement does not (and will not be construed to) establish a partnership, joint venture, agency relationship or other form of business association between Merchant and Alphaeon. Alphaeon and Merchant are independent contractors, and neither Party will have the authority to speak for, commit or bind the other Party."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Merchant Communication."
            }), ' ', "Merchant agrees to receive program updates and marketing material from Alphaeon via e-mail, fax, U.S. Mail and telephone. Merchant understands and agrees that for the Parties\u2019 mutual protection, Alphaeon may electronically record any telephone conversations between Alphaeon (and its agents) and Merchant (and Merchant\u2019s Agents), without further notice to the Parties to such conversations. Merchant acknowledges and consents to the retention of and use of such recordings by Alphaeon and its agents for the purpose of settling disputes or managing a quality assurance program."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Governing Law; Severability."
            }), ' ', "Except as provided in Section 22(b) (Arbitration), this Agreement will be governed by and construed in accordance with the laws of the State of California without reference to the conflict of laws provisions thereof. If any provision of this Agreement is found to be illegal or unenforceable, such provision will be deemed ineffective without invalidating the remaining provisions hereof and this Agreement will be reformed giving the effect to the greatest extent possible to the intentions of the Parties as reflected by the ineffective provision."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Notices."
            }), jsxRuntimeExports.jsxs("ol", {
              className: "terms-list",
              children: [jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "All notices, consents, claims, demands and other communications between the Parties will be in writing. All notices, consents, claims, demands and other communications will be and deemed to have been duly given (a) if personally delivered; (b) mailed by certified mail, postage pre-paid, return receipt requested; (c) delivered by a nationally recognized courier that provides proof of delivery, or (d) if notice is to Merchant, by sending the notice in writing (including by e-mail) or by posting on any online platform or website made available by Alphaeon for Merchant to conduct business with Alphaeon, and any such communications will be effective as of the time the same is delivered to Merchant through the foregoing methods."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "Merchant agrees that it has an ongoing obligation to check the emails it receives from Alphaeon and Merchant\u2019s website for any such notices, consents, claims, demands, and other communications, including for updates or changes to the Agreement, the Operating Procedures, or other notices and disclosures."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "All notices, consents, claims, demands and other communications to Merchant or modifications to this Agreement or the Operating Procedures may be provided by Alphaeon by: (i) electronically posting on any online platform or website made available by Alphaeon for Merchant to conduct business with Alphaeon; (ii) sending to Merchant\u2019s postal or street address or e-mail address set forth at the top of this Agreement; or (iii) sending to such other address or e-mail address as Merchant may advise Alphaeon in writing."
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                listStyle: "lower-roman",
                children: "All notices, consents, claims, demands and other communications to Alphaeon hereunder will be sent to the address set forth below or to such other address as Alphaeon may advise Merchant in writing."
              })]
            }), jsxRuntimeExports.jsxs(P, {
              variant: "body-large",
              className: "mar-t-16",
              children: ["If to Alphaeon:", jsxRuntimeExports.jsx("br", {}), "Alphaeon Credit, Inc.", jsxRuntimeExports.jsx("br", {}), "4040 MacArthur Blvd., Ste. 260", jsxRuntimeExports.jsx("br", {}), "Newport Beach, CA 92660", jsxRuntimeExports.jsx("br", {}), "Email: thomas.ervesun@alphaeon.com"]
            }), jsxRuntimeExports.jsxs(P, {
              variant: "body-large",
              className: "mar-t-16",
              children: ["With a copy to:", jsxRuntimeExports.jsx("br", {}), "Alphaeon Credit, Inc.", jsxRuntimeExports.jsx("br", {}), "4040 MacArthur Blvd., Ste. 260", jsxRuntimeExports.jsx("br", {}), "Newport Beach, CA 92660", jsxRuntimeExports.jsx("br", {}), "Attention: Legal Department", jsxRuntimeExports.jsx("br", {}), "Email: legal@alphaeon.com"]
            })]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Electronic Execution; Counterparts."
            }), ' ', "This Agreement may be executed by facsimile, email, DocuSign, or other electronic means (including through the use of electronic signature(s)), which will be deemed an original. Copied signatures will be treated for all purposes as original signatures on this Agreement and any notice. This Agreement may be executed in counterparts, including by electronic signature and electronic transmission, each of which will be deemed an original, but all of which will constitute one and the same document."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Nonwaiver and Extensions."
            }), ' ', "The Parties will not by any act, delay, omission or otherwise be deemed to have waived any rights or remedies hereunder. Each Party agrees that the other Party\u2019s failure to enforce any of its rights under this Agreement will not affect any other right or the same right in any other instance."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Rights of Persons Not a Party."
            }), ' ', "Except as expressly provided herein, this Agreement will not create any rights on the part of any Person not a party hereto, whether as a third-party beneficiary or otherwise."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Assignment."
            }), ' ', "Merchant acknowledges and agrees that Alphaeon may sell, transfer, encumber or assign this Agreement and/or that Alphaeon or Funder may sell, transfer, encumber or assign any Loan Agreement or RIC purchased or originated hereunder, without Merchant\u2019s consent. Merchant further acknowledges and consents to the assignment by Alphaeon to Funder, its successors and assigns, of all of Alphaeon\u2019s rights and remedies hereunder in respect of the applicable Credit Transaction irrespective of any assumption by Lender, its successors and assigns, of any obligation hereunder. This Agreement is binding on Merchant\u2019s successors and assigns. Merchant may not assign this Agreement or any of its rights or obligations hereunder without the prior written consent of Alphaeon (and for purposes of this Section 23(m), a transfer or sale, whether direct or indirect, of a majority interest in Merchant will be deemed an assignment). Any such assignment in violation of this provision will be null and void."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Taxes"
            }), ". Merchant is obligated to pay all taxes, fees and other charges imposed by any governmental authority in relation to the Program, including any value added tax, goods and services tax, provincial sales tax and/or harmonized sales tax on the sale of goods and services Merchant provides to Merchant\u2019s customers in relation to the Program."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Headings."
            }), ' ', "The headings contained in this Agreement are inserted for convenience only and will not affect the meaning or interpretation of this Agreement or any provision hereon."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              bold: true,
              children: "Survival."
            }), ' ', "Notwithstanding anything contained in this Agreement to the contrary, all of Merchant\u2019s and Alphaeon\u2019s respective obligations, representations and warranties under this Agreement that are not, by their express terms, to be fully performed, while this Agreement is in effect, will survive the termination of this Agreement. In addition and without limitation, provisions will survive where necessary to give effect to their meaning, including Sections 4 (Obligations of Merchants Under the Program), 5 (Modifications), 6 (Limitations on Merchant\u2019s Participation in the Program), 8 (Term, Suspension and Termination), 14 (Indemnification Rights; Affected Credit Transactions; Merchant Defaults), 17 (Confidential Information), 18 (Ownership of Program; Intellectual Property), 19 (Information Security; Records; Ownership), 20 (Reserve Account; Right to Set-Off; Chargebacks; Limited Power of Attorney), 21 (Attorneys\u2019 Fees; Limitation of Liability; Disclaimer of Warranties), 22 (Dispute Resolution & Arbitration), and 23 (Miscellaneous)."]
          })]
        })]
      }), jsxRuntimeExports.jsxs(Li, {
        variant: "body-large",
        listStyle: "decimal",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "body-large",
          bold: true,
          children: "Definitions."
        }), ' ', "For purposes of this Agreement, any terms capitalized, but not otherwise defined in the Agreement, are defined as follows:", jsxRuntimeExports.jsxs("ol", {
          className: "terms-list",
          children: [jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Affected Credit Transaction"
            }), "\u201D means (a) any Credit Transaction as to which any breach of a representation, warranty or covenant set forth in this Agreement applies; (b) any Credit Transaction involving a sale of Goods and/or Services that are returned or are not timely delivered to the customer\u2019s satisfaction; or (c) any Credit Transaction involving a customer complaint that is not resolved to Alphaeon\u2019s reasonable satisfaction within ten (10) Business Days from the date Merchant learns of the complaint. Additionally, in the event of any knowing or intentional breach or any breach concerning Merchant generally, as opposed to any specific Credit Transaction, all Credit Transactions shall be deemed to be Affected Credit Transaction. Merchant shall give Alphaeon immediate notice if it becomes aware that any Credit Transaction is an Affected Credit Transaction."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Ancillary Products"
            }), "\u201D means all \u201Cadd on\u201D or voluntary protection products financed or otherwise included in the Credit Transaction."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Applicable Law"
            }), "\u201D means any applicable federal, state, local or other (i) law, statute, regulation, rule, supervisory or administrative guidance, directive or interpretation published by a governmental authority that is applicable to or binding upon a Party, or (ii) any judicial, administrative or other governmental order, judgment, decree, decision, permit or ruling that is binding upon or otherwise applicable to a Party; as any of the foregoing may be amended or modified and in effect from time to time."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Applicant"
            }), "\u201D is a current or prospective customer of Merchant who has applied for, or is in the process of applying for, a Credit Transaction."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Application"
            }), "\u201D is an application for the extension of credit under a Loan or RIC, in either case pursuant to the procedures designated by Alphaeon or Funder from time to time."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Borrower"
            }), "\u201D is a current or prospective customer of Merchant who has applied for and has been approved for a Loan."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Business Day"
            }), "\u201D is any day that is not a Saturday, a Sunday or other day on which banks are required or authorized to be closed in New York, New York."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Buyer"
            }), "\u201D is a current or prospective customer of Merchant who has applied for and has been approved for a Credit Sale."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Consumer Information"
            }), "\u201D is any consumer information received, collected, or otherwise obtained by Merchant or Alphaeon in connection with the Program, including, without limitation, any \u201Cnonpublic personal information\u201D as defined under the Gramm-Leach-Bliley Act or its implementing regulations (including Buyer or Borrower (as applicable) Information) and any \u201Cpersonal information\u201D or \u201Cpersonal data\u201D as such terms are defined under Applicable Law."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Consumer Protection Laws"
            }), "\u201D means, collectively all federal and state licensing laws, state and federal anti-discrimination laws, federal and state laws prohibiting unfair, deceptive or abusive acts or practices (UDAAP), the federal Bank Secrecy Act and Patriot Act (and the implementing regulations of each Act) along with any other laws related to anti-money laundering and customer identification, federal and state consumer credit laws, including the Truth in Lending Act (and its implementing Regulation Z), federal and state fair lending laws (such as the Equal Credit Opportunity Act and the Fair Housing Act), federal and state privacy laws (such as Gramm-Leach-Bliley Act), federal and state telephone communication laws (such as the Telephone Consumer Protection Act) and consumer communication, consumer disclosure and other consumer protection laws and regulations."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Credit Transaction Applications"
            }), "\u201D is a request for a Credit Transaction through the Program to pay for Goods and/or Services pursuant to an Invoice."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Credit Transaction Documents"
            }), "\u201D are the Loan Agreement or RIC and associated disclosures (including Truth-in-Lending Act disclosures) and other documentation and communications from a Funder, Alphaeon or an agent of either."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Merchant\u2019s Agents"
            }), "\u201D or \u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Agents"
            }), "\u201D means Merchant\u2019s owners, directors, officers, advisers, members, managers, representatives, employees, agents, or subcontractors."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Funder"
            }), "\u201D is one or more lender(s) on a Loan or funder(s) on a RIC as selected by Alphaeon from time to time. Said lender or funder may, at Alphaeon\u2019s election, be a third-party lender or funder or Alphaeon acting as a lender or funder."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Goods and/or Services"
            }), "\u201D are any goods or services that Merchant offers, sells, distributes, provides or installs, or that are offered, sold, distributed, provided or installed on behalf of Merchant, other than any goods or services designated by Alphaeon as not eligible for the Program in the Operating Procedures or otherwise in a notice provided to Merchant."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Invoice"
            }), "\u201D is, with respect to Goods and/or Services purchased from Merchant by a Buyer or Borrower (as applicable), evidence of the sale of Goods and/or Services, which evidence will include a description of all Goods and/or Services purchased in detail sufficient to identify the date of such transaction and the entire amount due for such transaction, including any applicable taxes, and otherwise comply with Applicable Law related thereto."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Loan"
            }), "\u201D is the extension of credit to a Borrower from a Funder under a Loan Agreement created pursuant to the Program in accordance with the terms and conditions provided in this Agreement."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Loan Agreement"
            }), "\u201D is a written agreement between a Funder and a Borrower containing the terms and conditions of the Borrower\u2019s Loan."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Operating Procedures"
            }), "\u201D are any procedures, guidelines, documentation, instructions, or other supplemental terms or requirements, including but not limited to the Alphaeon Credit Inc.\u2019s Terms and Conditions, that Alphaeon communicates to Merchant (including by email), and updates to any of the foregoing by Alphaeon from time to time."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Person"
            }), "\u201D is an individual, corporation, partnership, limited liability company, joint venture, association, trust, unincorporated organization, or other entity."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\"", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Refund Credit"
            }), "\" means the pro rata amount associated with any Credit Transaction for which Alphaeon is due compensation from Merchant pursuant to this Agreement, equal to the outstanding balance of the Amount Financed by Lender in connection with any such Loan, plus any unpaid finance charge."]
          }), jsxRuntimeExports.jsxs(Li, {
            variant: "body-large",
            listStyle: "lower-alpha",
            children: ["\u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "Retail Installment Contract"
            }), "\u201D or \u201C", jsxRuntimeExports.jsx(Span, {
              variant: "body-large",
              className: "text-underline",
              children: "RIC"
            }), "\u201D is a written agreement between the Merchant and a Buyer containing the terms and conditions of the Buyer\u2019s Credit Sale which Merchant may assign and sell to Alphaeon in accordance with Alphaeon\u2019s instructions."]
          })]
        })]
      })]
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-16",
      children: [jsxRuntimeExports.jsx(Span, {
        variant: "body-large",
        bold: true,
        children: "IN WITNESS WHEREOF"
      }), ", the Parties have executed this Agreement by their duly authorized representatives."]
    })]
  });
}
var FlexRicMerchantAgreement_default = /*#__PURE__*/memo(FlexRicMerchantAgreement);

function Legals() {
  return jsxRuntimeExports.jsxs("div", {
    className: "page-container",
    children: [jsxRuntimeExports.jsx(ExternalLink$1, {
      styleAsAnchor: true,
      className: "",
      href: "https://c.comenity.net/legaldocs/alphaeoncosmetic/legal-documents/cca",
      children: "ADS Credit Card Act"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(ExternalLink$1, {
      styleAsAnchor: true,
      className: "",
      href: "https://d.comenity.net/legaldocs/alphaeoncosmetic/legal-documents/patriot-act",
      children: "ADS Patriot Act"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(ExternalLink$1, {
      styleAsAnchor: true,
      className: "",
      href: "https://d.comenity.net/ac/privacy/financial",
      children: "ADS Privacy Notice"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(Link, {
      to: makePath(PATH.LEGAL, PATH.CA_PRIVACY_NOTICE),
      children: "CA Privacy Notice"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(Link, {
      to: makePath(PATH.LEGAL, PATH.COMENITY_CAPITAL_PREQUALIFICATION_TERMS),
      children: "Comenity Capital Prequalification Terms"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(Link, {
      to: makePath(PATH.LEGAL, PATH.CONSENT_AUTODIALED),
      children: "Consent Autodialed"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(Link, {
      to: makePath(PATH.LEGAL, PATH.CONSENT_ELECTRONIC_DISCLOSURES),
      children: "Consent Electronic Disclosures"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(Link, {
      to: makePath(PATH.LEGAL, PATH.CONSUMER_FINANCIAL_PRIVACY_POLICY),
      children: "Consumer Financial Privacy Policy"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(Link, {
      to: makePath(PATH.LEGAL, PATH.CREDIT_REPORT_AUTHORIZATION),
      children: "Credit Report Authorization"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(Link, {
      to: makePath(PATH.LEGAL, PATH.FINANCING_PARTNERS),
      children: "Financing Partners"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(Link, {
      to: makePath(PATH.LEGAL, PATH.PARTNERS),
      children: "Partners"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(ExternalLink$1, {
      styleAsAnchor: true,
      href: "https://media-assets.imprint.co/imprint/legal/fbt/privacy-en",
      children: "Imprint Privacy Policy"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(ExternalLink$1, {
      styleAsAnchor: true,
      href: "https://media-assets.imprint.co/imprint/legal/fbt/esign-en",
      children: "Imprint E-Sign"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(Link, {
      to: makePath(PATH.LEGAL, PATH.PREQUALIFICATION_TERMS),
      children: "Prequalification Terms"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(Link, {
      to: makePath(PATH.LEGAL, PATH.PRIVACY_POLICY),
      children: "Privacy Policy"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(Link, {
      to: makePath(PATH.LEGAL, PATH.RIC_MERCHANT_AGREEMENT),
      children: "RIC Merchant Agreement"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(Link, {
      to: makePath(PATH.LEGAL, PATH.WEBSITE_TERMS_OF_USE),
      children: "Website Terms Of Use"
    }), jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(Link, {
      to: makePath(PATH.LEGAL, PATH.WIRELESS_CARRIER_TERMS),
      children: "Wireless Carrier Terms"
    })]
  });
}

function LegalShow() {
  return jsxRuntimeExports.jsx("div", {
    children: " This is the Legal show view! "
  });
}
function mapStateToProps() {
  return {};
}
const mapDispatchToProps = {};
compose(connect(mapStateToProps, mapDispatchToProps))(LegalShow);

function Partners() {
  return jsxRuntimeExports.jsxs("div", {
    className: "page-container",
    children: [jsxRuntimeExports.jsx(H1, {
      className: "text-underline text-center",
      children: "Partners"
    }), jsxRuntimeExports.jsx(P, {
      className: "mar-t-8",
      children: "Comenity Capital Bank - Address: Comenity Capital Bank PO Box 183003 Columbus, OH 43218-3003"
    }), jsxRuntimeExports.jsx(P, {
      className: "mar-t-8",
      children: "American First Finance - Address: American First Finance PO Box 565848 Dallas, TX 75356"
    }), jsxRuntimeExports.jsx(P, {
      className: "mar-t-8",
      children: "FinWise Bank serviced by American First Finance - Address: American First Finance PO Box 565848 Dallas, TX 75356"
    })]
  });
}

function PrequalificationTerms() {
  return jsxRuntimeExports.jsxs("div", {
    className: "page-container",
    children: [jsxRuntimeExports.jsx(H1, {
      variant: "headline-medium",
      className: "text-center text-underline",
      children: "Alphaeon's Prequalification Terms"
    }), jsxRuntimeExports.jsx(P, {
      variant: "body-large",
      className: "mar-t-32",
      children: "Alphaeon\u2019s Prequalification Terms (the \u201CTerms\u201D) outline the relationship between you and Alphaeon Credit, Inc. As used in these Terms, \u201Cwe,\u201D \u201Cour,\u201D \u201Cus\u201D and \u201CCompany\u201D refers to Alphaeon, and \"you\" and \"your\" mean the consumer electronically agreeing to these Terms. For the purpose of the Arbitration Agreement, \u201Cwe,\u201D \u201Cour,\u201D \u201Cus\u201D and \u201CCompany\u201D also refers to Alphaeon\u2019s parents, subsidiaries, affiliates, employees, agents, officers, directors, shareholders, successors, and assigns."
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "mar-t-32",
      children: ["The Terms only apply to the relationship between you and Company, and do not apply to any other relationships you may have with third parties as a result of your relationship with Company.", ' ', jsxRuntimeExports.jsx(Span, {
        bold: true,
        variant: "body-large",
        children: "THESE TERMS INCLUDE AN ARBITRATION AGREEMENT WITH A CLASS ACTION WAIVER AND A JURY TRIAL WAIVER. THIS ARBITRATION AGREEMENT DOES NOT APPLY TO YOU IF YOU ARE A COVERED BORROWER UNDER THE MILITARY LENDING ACT."
      })]
    }), jsxRuntimeExports.jsx(H2, {
      variant: "headline-medium",
      className: "mar-t-32",
      children: "GENERAL TERMS AND CONDITIONS."
    }), jsxRuntimeExports.jsxs("ol", {
      className: "terms-list",
      children: [jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsxs(P, {
          variant: "body-large",
          children: [jsxRuntimeExports.jsxs(Span, {
            variant: "body-large",
            bold: true,
            children: ["Company's Service.", ' ']
          }), "Company is providing you with a platform (the \u201CPlatform\u201D) through which you may submit prequalification inquiries for review by us and our partners. You direct us to use your information or to send your information to", ' ', jsxRuntimeExports.jsx(A, {
            href: `${PATH.LEGAL}${PATH.PARTNERS}`,
            target: "_blank",
            rel: "noopener noreferrer",
            variant: "body-large",
            blue: true,
            bold: true,
            children: "partners"
          }), ", as we may choose, to determine if we or our", ' ', jsxRuntimeExports.jsx(A, {
            href: `${PATH.LEGAL}${PATH.PARTNERS}`,
            target: "_blank",
            rel: "noopener noreferrer",
            variant: "body-large",
            blue: true,
            bold: true,
            children: "partners"
          }), ' ', "want to prequalify you for credit, and you direct each of them to notify us regarding any offer for which you may prequalify. The address of each partner can be found", ' ', jsxRuntimeExports.jsx(A, {
            href: `${PATH.LEGAL}${PATH.PARTNERS}`,
            target: "_blank",
            rel: "noopener noreferrer",
            variant: "body-large",
            blue: true,
            bold: true,
            children: "here"
          }), ". You authorize Alphaeon and", ' ', jsxRuntimeExports.jsx(A, {
            href: `${PATH.LEGAL}${PATH.PARTNERS}`,
            target: "_blank",
            rel: "noopener noreferrer",
            variant: "body-large",
            blue: true,
            bold: true,
            children: "partners"
          }), ' ', "to share application, consumer report and other information about you among themselves in order to determine if you prequalify."]
        }), ' ']
      }), jsxRuntimeExports.jsx("li", {
        className: "decimal",
        children: jsxRuntimeExports.jsxs(P, {
          variant: "body-large",
          children: [jsxRuntimeExports.jsxs(Span, {
            variant: "body-large",
            bold: true,
            children: ["Prequalification Inquiries are Not Credit Applications.", ' ']
          }), "The prequalification inquiries are not credit applications. Instead, they are an opportunity for us and/or our partners to provide information to you so you can decide whether to apply for credit from such creditors."]
        })
      }), jsxRuntimeExports.jsx("li", {
        className: "decimal",
        children: jsxRuntimeExports.jsxs(P, {
          variant: "body-large",
          children: [jsxRuntimeExports.jsxs(Span, {
            variant: "body-large",
            bold: true,
            children: ["Use of the Platform.", ' ']
          }), "The Company makes no representations or guarantees that use of the Platform will result in an offer of credit. The Platform is a tool through which you may submit prequalification inquiries. It is in the sole discretion of us or any third-party creditor to extend credit."]
        })
      }), jsxRuntimeExports.jsx("li", {
        className: "decimal",
        children: jsxRuntimeExports.jsxs(P, {
          variant: "body-large",
          children: [jsxRuntimeExports.jsxs(Span, {
            variant: "body-large",
            bold: true,
            children: ["Your Representations.", ' ']
          }), "By saving your information with and/or submitting a prequalification inquiry through Company, you represent that the information you have provided is accurate, complete, and up-to- date. You agree that only you will use any account set up in your name, and that you will not share any log-in credentials with third parties or otherwise facilitate unauthorized access to your account. You agree that you are responsible for all activities that occur in connection with your account. If you believe that your account has been compromised or is no longer secure, you agree to immediately notify Company."]
        })
      })]
    }), jsxRuntimeExports.jsx(H2, {
      variant: "headline-medium",
      className: "mar-t-32",
      children: "ARBITRATION AGREEMENT."
    }), jsxRuntimeExports.jsx(P, {
      variant: "body-large",
      className: "mar-t-32",
      children: "In consideration for the mutual promises to arbitrate \u201CDisputes,\u201D as defined below, for your access to and use of the Platform provided by Company, and for other valuable consideration, you agree to the specific provisions below (unless you are a covered borrower under the Military Lending Act)."
    }), jsxRuntimeExports.jsx(H3, {
      variant: "headline-medium",
      className: "text-center mar-t-32",
      children: "Background and Scope"
    }), jsxRuntimeExports.jsx("table", {
      className: "prequal-table",
      children: jsxRuntimeExports.jsxs("tbody", {
        children: [jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "What is arbitration?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "An alternative to court."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "In arbitration, a third party (\u201CArbiter\u201D) solves Disputes in a hearing (\u201Chearing\u201D). You, related third parties, and we, waive the right to go to court. Such \u201Cparties\u201D forgo jury trials."
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Is it different from court and jury trials?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Yes."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "The hearing is private and less formal than court. Arbiters may limit pre- hearing fact finding, called \u201Cdiscovery.\u201D The decision is final. Courts rarely overturn Arbiters."
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Who does the Clause cover?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "You, Us, and Others."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "This Clause governs the parties, their heirs, successors, assigns, and third parties related to any Dispute."
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Which Disputes are covered?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "All Disputes."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "In this Clause, the word \u201CDisputes\u201D has the broadest possible meaning. This Clause governs all \u201CDisputes\u201D involving the parties. This includes all claims even indirectly related to your application, relationship or agreement with us. It includes claims related to setting aside this Clause. It includes claims about the Clause\u2019s validity and scope. It even includes threshold claims about whether a particular Dispute is subject to this Clause and whether to arbitrate."
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title thick-border",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Are you waiving rights?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Yes."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsxs("ol", {
              children: [jsxRuntimeExports.jsx(P, {
                variant: "body-large",
                bold: true,
                children: "You waive your rights to:"
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                bold: true,
                className: "mar-left-16",
                children: jsxRuntimeExports.jsx(P, {
                  variant: "body-large",
                  bold: true,
                  children: "Have juries solve Disputes."
                })
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                bold: true,
                className: "mar-left-16",
                children: jsxRuntimeExports.jsx(P, {
                  variant: "body-large",
                  bold: true,
                  children: "Have courts, other than small-claims courts, solve Disputes."
                })
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                bold: true,
                className: "mar-left-16",
                children: jsxRuntimeExports.jsx(P, {
                  variant: "body-large",
                  bold: true,
                  children: "Serve as a private attorney general or in a representative capacity."
                })
              }), jsxRuntimeExports.jsx(Li, {
                variant: "body-large",
                bold: true,
                className: "mar-left-16",
                children: jsxRuntimeExports.jsx(P, {
                  variant: "body-large",
                  bold: true,
                  children: "Be in a class action."
                })
              })]
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title thick-border",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Are you waiving class action rights?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Yes."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsxs(P, {
              variant: "body-large",
              children: [jsxRuntimeExports.jsxs(Span, {
                variant: "body-large",
                bold: true,
                children: ["COURTS AND ARBITERS WON\u2019T ALLOW CLASS ACTIONS.", ' ']
              }), "You waive your rights to be in a class action, as a representative and a member. Only individual arbitration, or small-claims courts, will solve Disputes. You waive your right to have representative claims. Unless reversed on appeal, if a court invalidates this waiver, the Clause will be void."]
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "What law applies?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "The Federal Arbitration Act (\u201CFAA\u201D)."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "This transaction involves interstate commerce. Thus, the FAA governs. If a court finds the FAA doesn\u2019t apply, and the finding can\u2019t be appealed, then the state law where you were when you signed, governs. The Arbiter must apply substantive law consistent with the FAA. The Arbiter must follow statutes of limitation and privilege claims."
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Can the parties try to solve Disputes first?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Yes."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "We can try to solve Disputes if you call us at (800) 754-4013 (Alphaeon Legal Phone number). If this doesn\u2019t solve the Dispute, mail us written notice, within 100 days of the Dispute date. In your notice, tell us the details and how you want to solve it. We will try to solve the Dispute. If we make a written offer (\u201CSettlement Offer\u201D), you can reject it and arbitrate. If we don\u2019t solve the Dispute, either party may start arbitration. To start arbitration, contact an Arbiter or arbitration group listed. No party will disclose settlement proposals to the Arbiter during arbitration."
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "How should you contact us?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "By mail."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsxs(P, {
              variant: "body-large",
              children: ["Send mail to:", jsxRuntimeExports.jsx("br", {}), "4040 MacArthur Blvd #260", jsxRuntimeExports.jsx("br", {}), "Newport Beach, CA 92660", jsxRuntimeExports.jsx("br", {}), "You can call us or use certified mail to confirm receipt."]
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Can small-claims court solve some Disputes?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Yes."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "Each party has the right to arbitrate, or to go to small-claims court if the small-claims court has the power to hear the Dispute. Arbitration will solve all disputes that the small-claims court does not have the power to hear. If there is an appeal from small-claims court, or if a Dispute changes so that the small-claims court loses the power to hear it, then the Dispute will only be heard by an Arbiter."
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Do other options exist?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Yes."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "Both parties may go to court to use lawful self-help remedies. Both parties may seek remedies in court which don\u2019t claim money damages. This includes pre-judgment seizure, injunctions, or equitable relief."
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Will this Clause continue to govern?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Yes, unless otherwise agreed."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "The Clause stays effective, unless the parties sign an agreement stating it doesn\u2019t. The Clause governs if you rescind the transaction. It governs if you default, renew, prepay, or pay. It governs if you terminate the transaction. It governs if your transaction is impacted by bankruptcy. The Clause remains effective, despite a transaction\u2019s termination, amendment, expiration, or performance."
            })
          })]
        })]
      })
    }), jsxRuntimeExports.jsx(H3, {
      variant: "headline-medium",
      className: "text-center mar-t-32",
      children: "Process"
    }), jsxRuntimeExports.jsx("table", {
      className: "prequal-table",
      children: jsxRuntimeExports.jsxs("tbody", {
        children: [jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "How does arbitration start?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Mailing a notice."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "Either party may mail the other a request to arbitrate, even if a lawsuit has been filed. The notice should describe the Dispute and relief sought. The receiving party must mail a response within 20 days. If you mail the demand, you may choose the arbitration group. Or, your demand may state that you want the parties to choose a local Arbiter. If related third parties or we mail the demand, you must respond in 20 days. Your response must choose an arbitration group or propose a local Arbiter. If it doesn\u2019t, we may choose the group."
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Who arbitrates?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "AAA, JAMS, or an agreed Arbiter."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "You may select the American Arbitration Association (\u201CAAA\u201D) (1-800-778- 7879) http://www.adr.org or JAMS (1-800-352-5267) http://www.jamsadr.com. The parties may also agree in writing to a local attorney, retired judge, or Arbiter in good standing with an arbitration group. The Arbiter must arbitrate under AAA or JAMS consumer rules. You may get a copy of these rules from such group. Any rules that conflict with any of our agreements with you, don\u2019t apply. If these options aren\u2019t available, and the parties can\u2019t agree on another, a court may choose the group. The parties will then obtain an Arbiter under such group\u2019s rules. Such Arbiter must enforce your agreements with us, as they are written."
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Will the hearing be held nearby?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Yes."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "The Arbiter will order the hearing within 30 miles of your home or where the transaction occurred."
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "What about appeals?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Appeals are limited."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "The Arbiter\u2019s decision will be final. A party may file the Arbiter\u2019s award with the proper court. Arbitration will solve appeals of a small-claims court judgment. A party may appeal under the FAA. If the amount in controversy exceeds $1,500, a party may appeal the Arbiter\u2019s finding. Such appeal will be to a 3-Arbiter panel from the same arbitration group. The appeal will be de novo, and solved by majority vote."
            })
          })]
        })]
      })
    }), jsxRuntimeExports.jsx(H3, {
      variant: "headline-medium",
      className: "text-center mar-t-32",
      children: "Arbitration Fees and Awards"
    }), jsxRuntimeExports.jsx("table", {
      className: "prequal-table",
      children: jsxRuntimeExports.jsxs("tbody", {
        children: [jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Will we advance Arbitration Fees?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Yes, but you may pay costs."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "We advance your \u201CArbitration Fees\u201D if you ask us to. This includes filing, administrative, hearing, and Arbiter\u2019s fees. You pay your attorney fees and other expenses."
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Are damages and attorney fees possible?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Yes, if allowed."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "The Arbiter may award the same damages as a court. Arbiters may award reasonable attorney fees, and expenses, if allowed by law."
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Will you pay Arbitration Fees if you win?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "No."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "If the Arbiter awards you funds, you don\u2019t reimburse us the Arbitration Fees."
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Will you ever pay Arbitration Fees?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Yes/No."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "If the Arbiter doesn\u2019t award you funds, then you may repay the Arbitration Fees. The Arbiter will decide whether you\u2019ll pay. If you must pay Arbitration Fees, the amount won\u2019t exceed state court costs."
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "What happens if you win?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "You could get more than the Arbiter awarded."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "If an Arbiter\u2019s award to you exceeds our last Settlement Offer, we will pay 3 amounts. We will pay the greater of the award amount or $500.00 (\u201Cbonus payment\u201D). We will pay your attorney twice the attorney fees conferred (\u201Cattorney premium\u201D). If the Arbiter orders, we will pay reasonable expert witness costs and other costs you incurred (\u201Ccost premium\u201D). If we never made a Settlement Offer, we will pay the bonus payment, attorney premium, and any cost premium. The Arbiter may order the process for payment. If a law allows you more, this Clause won\u2019t prevent such award. We won\u2019t seek attorney fees and expenses."
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Can an award be explained?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Yes."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "A party may request details from the Arbiter, within 14 days of the ruling. Upon such request, the Arbiter will explain the ruling in writing."
            })
          })]
        })]
      })
    }), jsxRuntimeExports.jsx(H3, {
      variant: "headline-medium",
      className: "text-center mar-t-32",
      children: "Other Options"
    }), jsxRuntimeExports.jsx("table", {
      className: "prequal-table",
      children: jsxRuntimeExports.jsxs("tbody", {
        children: [jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "If you don\u2019t want to arbitrate, can you still get a transaction?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Yes. You can get our services and decide not to arbitrate."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsxs("ol", {
              children: [jsxRuntimeExports.jsx(P, {
                variant: "body-large",
                children: "Consider these choices:"
              }), jsxRuntimeExports.jsxs(Li, {
                variant: "body-large",
                className: "mar-left-16",
                children: [jsxRuntimeExports.jsxs(Span, {
                  variant: "body-large",
                  bold: true,
                  children: ["Informal Dispute Resolution.", ' ']
                }), jsxRuntimeExports.jsx(P, {
                  variant: "body-large",
                  children: "Contact us, and attempt to settle any Disputes."
                })]
              }), jsxRuntimeExports.jsxs(Li, {
                variant: "body-large",
                className: "mar-left-16",
                children: [jsxRuntimeExports.jsxs(Span, {
                  variant: "body-large",
                  bold: true,
                  children: ["Small-claims Court.", ' ']
                }), jsxRuntimeExports.jsx(P, {
                  variant: "body-large",
                  children: "Seek to solve Disputes in small-claims court, within state law limits."
                })]
              }), jsxRuntimeExports.jsxs(Li, {
                variant: "body-large",
                className: "mar-left-16",
                children: [jsxRuntimeExports.jsxs(Span, {
                  variant: "body-large",
                  bold: true,
                  children: ["Get an Agreement Without the Clause.", ' ']
                }), jsxRuntimeExports.jsx(P, {
                  variant: "body-large",
                  children: "Write to us for an Agreement without the Clause."
                })]
              }), jsxRuntimeExports.jsxs(Li, {
                variant: "body-large",
                className: "mar-left-16",
                children: [jsxRuntimeExports.jsxs(Span, {
                  variant: "body-large",
                  bold: true,
                  children: ["Opt-Out of Arbitration.", ' ']
                }), jsxRuntimeExports.jsx(P, {
                  variant: "body-large",
                  children: "Sign and then timely opt-out."
                })]
              })]
            })
          })]
        }), jsxRuntimeExports.jsxs("tr", {
          children: [jsxRuntimeExports.jsx("td", {
            className: "row-title",
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Can you opt-out of the Clause?"
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              bold: true,
              children: "Yes. Within 60 days."
            })
          }), jsxRuntimeExports.jsx("td", {
            children: jsxRuntimeExports.jsx(P, {
              variant: "body-large",
              children: "Write us at the address above within 60 calendar days of signing your agreement to opt-out of the Clause for that agreement. Provide your name, address, account number and date. State that you \u201Copt out.\u201D If you opt out, it will only apply to that agreement."
            })
          })]
        })]
      })
    })]
  });
}

function PrivateLabelTerms() {
  return jsxRuntimeExports.jsxs("div", {
    className: "page-container",
    children: [jsxRuntimeExports.jsx("h4", {
      className: "page-title font-bold text-underline",
      children: "ALPHAEON CREDIT PRIVATE LABEL CREDIT CARD PROGRAM TERMS AND CONDITIONS"
    }), jsxRuntimeExports.jsxs("ol", {
      className: "paragraph-list terms-list",
      children: [jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "The Agreement. "
        }), " The ALPHAEON CREDIT PRIVATE LABEL CREDIT CARD PROGRAM (the \u201CProgram\u201D) made available hereunder is offered by Comenity Capital Bank (\u201CBank\u201D) for the purchase of Goods and/or Services (a \u201CPurchase\u201D) from a Merchant (\u201CMerchant\u201D). The undersigned Merchant and Merchant\u2019s owner/officer listed on the Private Label Credit Card Program Registration Form (\u201Cthe Registration Form\u201D) are collectively referred to as \u201CMerchant.\u201D Bank and Merchant are referred to herein as a \u201Cparty\u201D and collectively as the \u201Cparties\u201D. These Private Label Credit Card Program Terms and Conditions (\u201CTerms and Conditions\u201D) are attached to, and incorporated by reference in, the Registration Form completed and executed by or on behalf of Merchant. The Registration Form and these Terms and Conditions, including the Schedules attached hereto, are collectively referred to as the \u201CAgreement\u201D. Certain capitalized terms not otherwise defined herein shall have the meanings set forth in Schedule 1 attached hereto.", ' ', jsxRuntimeExports.jsx("strong", {
          children: "Bank shall have no obligation to Merchant hereunder unless and until Bank provides written approval to Merchant of Merchant\u2019s participation in the Program."
        })]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "Credit Transaction"
        }), jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Details regarding the various Promotional Programs available to those individuals who open accounts under this Agreement (\u201CAccountholders\u201D) and the pricing related thereto will be provided separately to Merchant by Alphaeon Credit, Inc., the corporate entity acting as an aggregator and/or sponsor for the Program (\u201CAlphaeon\u201D). Such Promotional Program details and related pricing may be amended and re-distributed to Merchant from time to time. Merchant may not add or assess any portion of the Merchant fees associated with the Promotional Programs, administrative fees, or any other form of additional fees, surcharge, consideration or security to an Accountholder who chooses to use the Program as tender for the Goods and/or Services provided. Merchant will not accept any payments from an Accountholder for charges billed on an Account, and will instead refer the Accountholder to Bank's payment address."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Notwithstanding anything herein to the contrary, Merchant may charge an Accountholder\u2019s credit Account for Goods and/or Services that are initiated or received within thirty (30) days of the date on which the Account is charged (\u201CPre-Funding\u201D). In the event that Merchant does not comply with the foregoing timing requirement, Bank shall exercise its chargeback rights pursuant to the Agreement and the Operating Procedures. Additionally, until such time as the Goods and/or Services are provided, the Accountholder will have the ability to request a refund of the full amount charged to the Account for Goods and/or Services that have not been received, unless otherwise agreed to by Bank and in compliance with Bank\u2019s and Alphaeon\u2019s policies and procedures. In such instances, the amount to be refunded will be returned to Bank as a credit to the Accountholder\u2019s Account. If at any time Bank determines in its sole discretion that Merchant\u2019s practice of Pre-Funding is not in compliance with the requirements set forth herein, or that such practice is a concern to Bank based on Bank\u2019s adherence to applicable law, including, but not limited to, safety and soundness, regulatory feedback or reputational considerations, Bank may prohibit Merchant from continuing the practice of Pre-Funding."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Merchant understands that, for some period of time following the execution of this Agreement, Merchant may receive payment from Bank of the net of funds owed for each Purchase under the Program (\u201CNet Proceeds\u201D). During this time, and any subsequent periods during which Bank may resume payment of the Net Proceeds directly to Merchant, the terms set forth in Schedule 2 attached hereto shall be effective and replace all terms set forth in this Section 2 of the Agreement. Upon the date that Alphaeon assumes responsibility for transmitting payment of the Net Proceeds to Merchant, and informs Merchant of the same, the terms set forth in Schedule 2 shall no longer apply to this Agreement and the terms in this Section 2 shall control. Once Merchant is informed that Alphaeon will be the party transmitting the Net Proceeds to Merchant, Merchant agrees and acknowledges that, in accordance with Merchant\u2019s agreement with Alphaeon, Alphaeon is solely responsible and liable to Merchant for payment of the Net Proceeds due to Merchant for each Purchase under the Program. Accordingly, Merchant has no claim or recourse against Bank for such funds, and Bank has no obligation or liability to Merchant for payment of any such funds under the Program. For the avoidance of doubt, Merchant remains liable to Bank for any chargebacks or other amounts due to Bank in connection with a Purchase that occurred prior to the date that Alphaeon begins transmitting net funds to Merchant, but Alphaeon may process such amounts on Bank\u2019s behalf."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Merchant shall not disclose or transmit to Bank any medical, health (including auditory or dental), or insurance information or data about Customers, including but not limited to information that would meet the definition of \u201CProtected Health Information\u201D under the Health Insurance Portability and Accountability Act of 1996, found at\u00A0 45 CFR, Sec. 160.103, as in force from time to time (collectively, \u201CHealth Information\u201D), including information describing the products and/or services which are the subject of any transaction."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Merchant acknowledges and agrees that (i) the terms of the purchase of Goods and/or Services financed using the Program shall only be offered in the English language, and (ii) the Program shall only be offered in the English language, including the solicitation of applications, and (iii) the Program may be made available solely to Customers who are United States residents, to finance the purchase of Goods and/or Services for personal, family, or household use, the purchase price of which is listed in U.S. dollars."
          })]
        })]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "Ownership of Accounts; Terms and Conditions"
        }), jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Bank shall own all the Accounts under the Program from the time of establishment, and except as otherwise provided herein, Merchant shall not have any right to any indebtedness on an Account or to any Account payment from an Accountholder arising out of or in connection with any Purchases under the Program."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Bank together with any of its successors or assigns shall have sole control over the Program, including the financing products made available, fees, product terms and conditions, Program privacy policies and other disclosures and notices pertaining to the Program, and any invoices, billing statements and other communications pertaining to servicing and collecting on the Program."
          })]
        })]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "Applications; Granting of Credit."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              className: "text-underline",
              children: "Application Procedures."
            }), "Customers who wish to apply for an Account (an \u201CApplicant\u201D) under the Program must submit a completed application in a format approved by Bank (\u201CBank Application\u201D). Bank shall establish and administer the underwriting and credit decisions for the Program, and Bank shall grant or deny the request for credit based solely upon such credit criteria. When facilitating Bank Applications, Merchant shall follow all applicable Operating Procedures. The Bank Application shall be submitted to Bank by the Applicant or submitted by Merchant on behalf of the Applicant, as required in the Operating Procedures."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              className: "text-underline",
              children: "Application Confidentiality."
            }), "Regarding Bank Applications and other Accountholder information submitted in whole or in part to Merchant or its service providers, agents, representatives, or contractors (which must be approved in writing by Bank), Merchant will (i) protect and keep confidential any and all such information (which shall be Bank Confidential Information as defined below) acquired as a result of participating in the Program, and (ii) not disclose, or permit any third party to access, such information to anyone other than authorized representatives of Bank, and (iii) follow all Operating Procedures applicable to such Bank Confidential Information."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              className: "text-underline",
              children: "Granting of Credit."
            }), ' ', "The decision to extend credit to any Applicant under the Program shall be solely Bank\u2019s decision. Qualified Applicants desiring to use Program shall be granted an Account by Bank with a credit limit in an amount to be determined by Bank in its discretion for each individual Applicant. Subject to Applicable Law, Bank shall determine the terms and conditions of the Account in its sole discretion."]
          })]
        })]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "Ownership of the Parties\u2019 Marks; Rights to Other Intellectual Property."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Merchant represents, warrants and agrees that it has the legal right to use and to permit Bank, its affiliates and their respective successors and assigns to use Merchant\u2019s trade names, trademarks and service marks utilized by Merchant in the conduct of its business (the \u201CMerchant Marks\u201D). Merchant hereby authorizes Bank and/or its affiliates to use the Merchant Marks during and after the term of this Agreement as necessary in the servicing of the Accounts, such as in the collection process where it is necessary to identify the location of the Purchase that is the subject of the amount(s) being collected. Bank agrees it will not use the Merchant Marks on or in connection with any products or services or for any other purpose other than (i) as explicitly described in the Agreement, (ii) for Bank\u2019s business purposes, including, but not limited to, its securitization activities, and/or (iii) as required by Applicable Law."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Merchant recognizes that Bank is the sole owner of all trademarks, service marks, or names owned by Bank or licensed (and capable of being sublicensed) to Bank used in connection with the Program (the \u201CBank Marks\u201D and, together with the Merchant Marks, collectively, the \u201CMarks\u201D), that Merchant has no rights of ownership or license therein, and that Merchant is not entitled to (and shall not) use the Bank Marks other than as explicitly and specifically provided in this Agreement, and with the prior review and approval of Bank. Merchant shall cease use of the Bank Marks upon the termination of this Agreement for any reason, or upon request from Bank. Anything in the Agreement to the contrary notwithstanding, each party shall retain all rights in and to the Merchant Marks or the Bank Marks, as applicable, and all goodwill associated with the use of a party\u2019s Marks (whether under this Agreement or otherwise) shall insure to the benefit of such party."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Subject to the terms and conditions of the Agreement, Bank hereby grants Merchant a limited, revocable, non-exclusive, non-transferable license to access, integrate and use Bank Technology in order to provide the Program to Customers during the term of the Agreement. Merchant hereby grants Bank a limited revocable, non-transferable license to use Merchant Technology solely in connection with, and for the purpose of, operating, marketing, and administering the Program. Such Bank Technology and Merchant Technology shall be referred to collectively as \u201CProgram Technology\u201D. Merchant shall implement and maintain such Program Technology in accordance with Bank\u2019s practices and procedures and Bank\u2019s Implementation Guidelines for the applicable Program Technology, including any upgrades, updates, changes to functionality, or fixes (collectively, \u201CProgram Technology Updates\u201D) promptly upon its receipt of notice from Bank that such Program Technology Update is required and in the time frame designate therein. In the event Bank determines that a Critical Issue has caused or may cause harm or loss to Accountholders, customers, Bank, the Program, or Bank Technology, Bank may temporarily suspend, or Merchant shall suspend as directed by Bank, Merchant\u2019s use of and access to the affected Bank Technology and/or suspend Program operations pending resolution of such Critical Issue. If Merchant fails to comply with Bank\u2019s practices, procedures, and Bank\u2019s Implementation Guidelines, or fails to implement and maintain Program Technology Updates as provided above, Bank may, in addition to any other remedies available under law or equity, suspend or revoke Merchant\u2019s license to, use of, and access to any and all Bank Technology. Notwithstanding the foregoing, Bank may in its sole discretion discontinue its provision of non-core Bank Technology for any reason upon ninety (90) days\u2019 prior written notice to Merchant. Upon the expiration or termination of this Agreement, Merchant will remove, return, or destroy any Bank Technology as directed by Bank."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Any software or other technology developed by or for a party or its affiliates, to facilitate the Program, including but not limited to, software and software modifications developed in response to the other party\u2019s request or to accommodate such requesting party\u2019s special requirements and all derivative works, regardless of the developer thereof, will remain the exclusive property of the developing party and/or its affiliates. Nothing in this Agreement shall be deemed to convey a proprietary interest to the other party or any third party in any of the software, hardware, technology, or any of the derivative works thereof which are owned or licensed by a party and/or its affiliates, and each party shall return to the other party all materials containing such intellectual property upon termination of the Agreement."
          })]
        })]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "Customer Service Inquiries."
        }), ' ', "Neither party will attempt to answer inquiries concerning the other party's products and services. Each party will refer inquiries concerning the other party's products and services to the customer service telephone numbers provided by such other party. Such other party will use reasonable efforts to address such inquiries in a timely and effective manner. Merchant will cooperate with all reasonable investigations of Bank in response to an Accountholder\u2019s refusal to pay amounts owed on his or her Account in whole or in part due to complaints regarding the Goods and/or Services that are the basis for the amount(s) owed."]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "Integration; Operating Procedures; Marketing; Compliance Training."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Merchant shall comply with Bank instructions, guidelines and/or procedures regarding integration of the Program, as applicable. Merchant shall provide access and log-in credentials to Bank Portals only to its employees who need access in connection with Merchant\u2019s rights and obligations hereunder. Merchant is responsible for any actions taken in Bank Portals through Merchant\u2019s log-in."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Merchant shall comply with all instructions, procedures, policies, and guidelines regarding the Program disseminated or made available by Bank (itself or through a third party), as amended or modified by Bank from time to time (referred to collectively as the \u201COperating Procedures\u201D). The Operating Procedures constitute a part of this Agreement and are incorporated herein by reference. Merchant shall also adhere to written instructions from Bank not specifically codified in its Operating Procedures."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Merchant shall continuously: (i) prominently position the Program on the Merchant Platform, in-store; and through such other Sales Channels as Merchant and Bank may mutually agree upon; (ii) actively, and on a consistent basis, market, advertise and promote the Program through all Sales Channels; and (iii) otherwise participate in and support the Program. The presentment of the Program as a financing option for the purchase of Goods and/or Services shall be in a manner approved by Bank. Merchant\u2019s marketing, advertising and promotion activities in support of the Program shall comply with this Agreement and Applicable Law."
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: ["Merchant will obtain the approval of Bank prior to sending any marketing or using any collateral that mentions the Program, references or otherwise uses Bank\u2019s name or Bank Marks (or any derivative related marketing), or references any terms or conditions of the Program. Merchant may not implement or modify any Customer or employee incentive relating specifically (in whole or in part) to the Program absent Bank\u2019s prior written approval (which approval may be conditioned upon Merchant\u2019s agreement to Bank\u2019s compliance, performance and monitoring requirements).", ' ']
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Merchant will complete all training provided by Bank on or before the date that the Program is first made available by Merchant in the applicable payment acceptance channel, and promptly complete any ongoing training provided by Bank. Merchant shall cause all representatives, including any employees and approved third parties who will interact either with the Program or Customers (such individuals to be identified by Merchant) to attend such training or, alternatively, to provide training to such individuals that is comparable to the training provided by Bank, prior to interacting with the Program, as applicable, or Customers. Merchant shall submit any Program-related training materials prepared by it to Bank for its review and approval prior to use. Merchant acknowledges and agrees that training provided by Bank is a Bank policy requirement that will help facilitate Merchant\u2019s compliance with this Agreement, and is not legal advice. Merchant is solely responsible for acts or omissions by its employees, service providers, agents, contractors, or other representatives that result in a violation of this Agreement or any laws or regulations."
          })]
        })]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "Confidential Information and Security Controls."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Merchant agrees and acknowledges that all of the following information is owned by Bank and constitutes Confidential Information (as defined below) of Bank (collectively, \u201CBank Confidential Information\u201D): (i) all data related to the operation of the Program; (ii) Applicant and Bank Application data (which includes any non-public personal information regarding Applicants); (iii) Account and Accountholder information (which includes any non-public personal information regarding Accountholders) related specifically to the relationship between Bank and the Accountholders and (iv) any reports, analysis, statistics, and the like provided to and/or generated by Bank with regard to the Program."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Merchant hereby agrees that it shall not disclose any Confidential Information (defined below) Merchant obtains in connection with its participation in, and/or exposure to, the Program. \u201CConfidential Information\u201D is information not of a public nature including, without limitation, the terms and conditions of any agreement Merchant is a party to or has knowledge of in connection with the Program, Bank Confidential Information, Program reports, trade secrets, business and financial information, source codes, business methods, procedures, know-how and other information of every kind that relates to the Program. Notwithstanding the foregoing, Merchant may disclose such information to the extent disclosure is required by Applicable Law, provided that: (i) prior to disclosing any confidential information to any third party, Merchant shall give notice to Bank of the nature of such disclosure and of the fact that such disclosure will be made; and (ii) prior to filing any documentation in connection with the Program with any governmental authority or agency, Merchant will consult with Bank with respect to such filing and shall redact such portions which Bank requests be redacted. Bank\u2019s prior written approval is required for any other disclosure of Confidential Information."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Except as to non-public personal information of an Accountholder (to which the confidentiality obligations of this Section always apply), these confidentiality obligations shall not apply to any information:(i) which is generally known to the trade or to the public at the time of such disclosure; or (ii) which becomes generally known to the trade or the public subsequent to the time of such disclosure; provided, however, that such general knowledge is not the result of a disclosure in violation of this Agreement; or (iii) which is independently conceived and developed by Merchant and proven by Merchant through tangible evidence not to have been developed as a result of a disclosure of information to Merchant, or any other person or organization which has entered into a confidential arrangement with Bank."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Merchant acknowledges that any breach of these confidentiality provisions by it will result in irreparable damage to Bank and therefore in addition to any other remedy that may be afforded by law any breach or threatened breach of these confidentiality provisions may be prohibited by restraining order, injunction or other equitable remedies of any court."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Merchant shall establish and ensure that effective controls and commercially reasonable procedures are in place (i) for the handling, storage, and destruction of Applicant and Accountholder information under the Program and other Confidential Information; (ii) to ensure the confidentiality of Applicant and Accountholder information under the Program and other Confidential Information; and (iii) to ensure that Applicant and Accountholder information and other Confidential Information is not disclosed contrary to these provisions, or any applicable privacy, security or other laws, rules and regulations. Without limiting the foregoing, Merchant shall implement such physical, technical, and other security measures as are necessary to (w) ensure the security and confidentiality of Applicant and Accountholder information and other Confidential Information, (x) protect against any threats or hazards to the security and integrity of Applicant and Accountholder and other Confidential Information, (y) protect against any unauthorized access to or use of Applicant and Accountholder information and other Confidential Information, and (z) properly dispose of Applicant and Accountholder information and other Confidential Information."
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: ["In the event either party believes, or has reason to believe, that a Security Incident has occurred, the party subject to the Security Incident (the \u201CImpacted Party\u201D) shall promptly notify the non-Impacted Party. As used herein, \u201CSecurity Incident\u201D means any unauthorized or accidental access to or use, disclosure, transfer, acquisition, sale, alteration or modification, loss, unavailability, destruction, corruption, or other unauthorized or accidental processing or misuse, of Consumer Personal Information; (ii) any other compromise to the security, confidentiality, or integrity of Consumer Personal Information or systems; or (iii) is a \u201Csecurity breach\u201D or \u201Cdata incident\u201D under Applicable Law. The Impacted Party shall include in such notice an estimate of the intrusion\u2019s effect on the non-Impacted Party and shall specify the corrective action taken and to be taken by the Impacted Party. Without limiting the indemnification obligations set forth in Section 14(a)(viii) of this Agreement, in the event of a Security Incident, the Impacted Party shall pay the costs and expenses relating to the Security Incident, including costs and expenses that are customary and reasonable for mitigating the effects of such Security Incident, and which may include costs and expenses for providing consumer notifications, credit monitoring services, plastics reissuances, and incremental customer support.", ' ']
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Upon termination of Merchant's participation in the Program, Merchant shall take appropriate measures to properly dispose of, destroy and remove from its systems Bank Confidential Information, including Consumer Personal Information of Applicants and Accountholders, and any and all records regarding Applicants and Accountholders whether in paper, electronic, or other form, that are possessed by or on behalf of Merchant, including any compilation(s) of such records."
          })]
        })]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "Merchant Obligations."
        }), ' ', "Merchant agrees to: (i) make information available to its Customers regarding the Program as provided or approved by Bank for such purpose; (ii) accept and process Bank Applications from all Applicants; (iii) promote the Program, but only as authorized by Bank, and use all (and only) those promotional materials and forms approved by Bank; (iv) accept the Accounts for all (and only) bona fide charges and credits for Goods and/or Services; (v) except as expressly permitted herein, deliver all Goods and/or Services covered by any charge to an Account prior to the time the charge is submitted to Bank; (vi) confirm an authorization number or other indicator required by Bank has been issued for a transaction; (vii) only submit such transactions to Bank in the required format as set forth in the Operating Procedures; and (viii) ensure that the transaction information (whether a charge or a credit) is accurately captured in the Bank Portal or otherwise in accordance with Bank\u2019s instructions."]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "Records, Audits and Access."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Pursuant to Applicable Law, not limited to financial privacy regulations, Merchant will keep and maintain at its principal place of business appropriate books and records relating to its activities under this Agreement for a minimum of seven (7) years after their creation. Merchant will permit, once a year, unless Bank has reasonable cause to do so more than once, authorized representatives designated by Bank, at Bank\u2019s expense, to visit its facilities and inspect its books and records pertaining to Applicants, Accounts, transaction records and any category of payments owed, and to make copies and take extracts there from, and to discuss the same with Bank\u2019s representatives, all at reasonable times during normal business hours. Additionally, Merchant shall permit regulatory bodies having jurisdiction over Bank to visit its facilities and inspect records related to the Program and will reasonably cooperate in responding to inquiries by any such regulatory bodies relating to the Program."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Upon request, Merchant shall promptly furnish to Bank the following information pertaining to Merchant (on a consolidated basis if applicable): (i) a balance sheet as of the close of each fiscal quarter; (ii) a statement of income, retained earnings, and paid-in capital as of the close of each fiscal quarter; (iii) a statement of cash flow to the close of each such period; and (iv) a copy of the opinion submitted by Merchant\u2019s independent certified public accountants in connection with such of the financial statements as have been audited. If such financial statements are not available, Merchant shall provide to Bank Merchant\u2019s most recent annual tax filing. Merchant shall provide additional financial information as reasonably requested by Bank."
          })]
        })]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "Term and Termination."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Bank may terminate this Agreement upon thirty (30) days\u2019 written notice."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Any bankruptcy (whether voluntary or involuntary) or insolvency by either party shall be considered an immediate termination event and shall result in the termination of this Agreement. This Agreement shall automatically terminate (i) upon termination or expiration of the Program, of Bank\u2019s agreement with the corporate entity acting as an aggregator and/or sponsor for the Program, or of Merchant\u2019s agreement with such entity, or (ii) if Merchant is no longer authorized to provide Goods and/or Services. Termination of this Agreement will not terminate, affect, or impair any rights, obligations, or liabilities of either party, which may accrue prior to termination, or which under the Agreement\u2019s terms continue after termination. Merchant acknowledges that Bank may terminate this Agreement in its sole discretion."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "For the avoidance of doubt, Merchant\u2019s participation in the Program shall be coterminous with this Agreement."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Notwithstanding anything herein to the contrary, Bank may immediately suspend or terminate Merchant\u2019s participation in the Program as Bank deems necessary to comply with Applicable Law or for other considerations deemed relevant by Bank. Following are examples of basis for Bank taking such action: (i) actions or inactions of Merchant conflict with a material term of this Agreement, including but not limited to Section 5(c) of this Agreement; (ii) actions or inactions by Merchant in regard to the Program involve matters which, taken individually, might not be considered material, but which occurring repeatedly constitute cause for suspension/termination; (iii) Bank determines that suspension or termination is necessary for antifraud concerns, Bank\u2019s safety and soundness considerations, reputational concerns, and/or efforts to comply with Applicable Law; (iv) Bank determines that Merchant may not (or may not be able to) comply with the Agreement or the Program in any material respect including due to the Bank Systems being incompatible with Merchant\u2019s systems; or (v) Merchant has breached or is no longer in good standing under its agreement with Alphaeon."
          })]
        })]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "Representations, Warranties and Covenants; Merchant Data Sharing."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsxs("strong", {
              className: "text-underline",
              children: ["Representations and Warranties of the Parties.", ' ']
            }), ' ', "Each of Bank and Merchant represents and warrants to the other party that: (i) such party has the right, power, and authority to enter into this Agreement and perform the acts required of it hereunder; (ii) the execution of this Agreement by such party, and the performance by such party of its obligations and duties hereunder, do not and will not violate any agreement to which such party is a party or by which it is otherwise bound; and (iii) when executed and delivered by such party, this Agreement will constitute the legal, valid and binding obligation of such party, enforceable against such party in accordance with its terms (except as such enforcement may be limited by bankruptcy, insolvency, reorganization, moratorium and other laws relating to or affecting creditors' rights generally and by general principles of equity)."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsxs("strong", {
              className: "text-underline",
              children: ["Additional Representations, Warranties and Covenants of Merchant.", ' ']
            }), "Merchant represents, warrants and covenants to Bank as of the date hereof and at all times during the term of this Agreement that (i) all information furnished by Merchant to Bank in connection with the Program has been, and will be, to Merchant\u2019s best knowledge and belief, true and accurate in every respect material to the transactions contemplated hereby; (ii) any action taken by Merchant or inaction in connection with the Program, Bank, and/or the sales of Goods and/or Services shall be in compliance with all Applicable Law; (iii) Merchant has the legal right to use and to permit Bank and its successors and assigns to use the Merchant Marks utilized by Merchant in the conduct of its business; (iv) Merchant shall abide by the Operating Procedures of the Program, which includes honoring any Account properly issued under the Program; (v) each transaction represents the obligation of a Customer in the respective amount set forth therein for Goods and/or Services sold or rendered (as the case may be), together with applicable taxes and shipping fees, if any, and shall not involve any element of credit for any other purpose, and Merchant has no knowledge or notice of any fact or matter which would immediately or ultimately impair the validity of any Customer Check-Out, or the transaction evidenced thereby, or its collectability; (vi) Merchant is responsible and liable for the acts and omissions (and compliance by the following with the covenants and restrictions set forth herein) of its employees, service providers, contractors, representatives, or agents acting on its behalf; (vii) Merchant has and will maintain a plan designed to mitigate damages resulting from force majeure or other causes that would threaten operation of its business and/or loss or exposure of information requiring protection; (viii) Merchant is and shall remain fully authorized, certified, and/or licensed to perform as required under the terms of this Agreement, which in the case of Merchant includes but is not limited to (A) being and remaining in good standing with any governmental or professional body having jurisdiction over Merchant, (B) becoming and having its personnel become trained with respect to participation in the Program as well as in compliance with the Operating Procedures and (C) having authority to perform and/or provide the Goods and/or Services for which Accountholders use the Program as a form of payment; and (ix) Merchant has not and shall not provide to Bank any Customer Health Information. Notwithstanding the foregoing, Bank may require Merchant to provide written certification on an annual basis that the foregoing representations and warranties are true and accurate representations of Merchant and have continued to be true and accurate throughout the term of this Agreement."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsxs("strong", {
              className: "text-underline",
              children: ["Intellectual Property.", ' ']
            }), jsxRuntimeExports.jsxs("ol", {
              className: "paragraph-list terms-list",
              children: [jsxRuntimeExports.jsxs("li", {
                className: "lower-roman",
                children: ["Merchant represents and warrants, during the term of the Agreement, that in the event Merchant provides any software or hardware to Bank, including, without limitation, the Merchant Platform and all software, code, system, technology, content, procedures used in connection with or embedded in the Merchant Platform, Merchant has the legal right to such software or hardware and the right to permit Bank and its affiliates to use such software or hardware, and such use shall not violate any intellectual property rights of any third party.", ' ']
              }), jsxRuntimeExports.jsx("li", {
                className: "lower-roman",
                children: "With respect to one party\u2019s intellectual property provided to the other, the receiving party may not, nor allow any third party to: (i) modify, translate, reverse engineer, decompile, disassemble, otherwise attempt to derive source code from, or create derivative works based on, the other party\u2019s intellectual property; (ii) make unauthorized copies of the other party\u2019s intellectual property; (iii) in the case of Merchant, distribute or market the Program and any intellectual property provided by Bank and/or its affiliates, as applicable, except to Customers and then only as permitted under this Agreement, without Bank\u2019s prior written authorization; (iv) in the case of Bank, distribute or market Merchant\u2019s intellectual property, except to Customers, without Merchant\u2019s prior written authorization; (v) remove any proprietary notices, labels or marks on or in any copy of the Program, in the case of Merchant, or the other party\u2019s intellectual property; (vi) alter or remove any warranties, disclaimers or license agreements shipped or provided with the Program, in the case of Merchant, or the other party\u2019s intellectual property; or (vii) use the Program, in the case of Merchant, or the other party\u2019s intellectual property in any manner or for any purpose other than as contemplated in this Agreement."
              })]
            })]
          })]
        })]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "Merchant Data Sharing."
        }), ' ', "Merchant acknowledges that Bank may share information related to Merchant and Merchant\u2019s participation in the Program, including but not limited to relevant financial data, transaction information, personal information, and information submitted by Merchant through the Registration Form (\u201CMerchant Data\u201D) with Alphaeon as part of the initial and ongoing administration of the Program. Accordingly and notwithstanding anything to the contrary contained in this Agreement, Merchant authorizes Bank to disclose and transmit to Alphaeon any Merchant Data, and any and all information concerning Merchant that it obtains in the course of doing business with Merchant, which may include confidential information of Merchant and other information relevant to Merchant\u2019s participation in the Program."]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "Merchant Notices of Changes."
        }), "Merchant shall as soon as possible notify Bank of any: (a) change in its name, tax identification number, or form of business organization, change in the location of its chief executive office or the location of the office where its records concerning the Program are kept; (b) merger or consolidation of Merchant, the sale of a significant portion of its stock (or other form of ownership) or the sale of a substantial amount of its assets not in the ordinary course of business, or any change in the control of Merchant; (c) material adverse change in its financial condition or operations; (d) the planned opening or closing of any Sales Channels (including individual locations); (e) any change in business practices of Merchant that would have a material adverse effect on this Agreement or the Program; or (f) any occurrence that would trigger Bank\u2019s termination rights under this Agreement."]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "Indemnification and Limitation of Liability."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Merchant shall indemnify, hold harmless and, at Bank\u2019s request, defend Bank, Bank\u2019s affiliates, and its and their respective officers, directors, employees, service providers, subcontractors and their successors and assigns (collectively \u201CIndemnified Parties\u201D) from and against any and all liabilities, obligations, losses, claims, damages, actions, suits, proceedings, investigations, demands, assessments, adjustments, settlement payments, costs and expenses (including, without limitation, reasonable attorneys' fees and expenses), and deficiencies suffered, sustained, incurred or paid by them (collectively, \u201CLosses\u201D) in connection with, resulting from, relating to, or arising out of any of the following: (i) an actual or alleged breach by Merchant of any representation or warranty set forth in this Agreement; (ii) an actual or alleged nonfulfillment or breach by Merchant of any covenant, obligation or agreement set forth in this Agreement; (iii) any chargeback against Merchant; (iv) the actual or alleged negligence, willful misconduct, or non-compliance with Applicable Law by Merchant; (v) any actual or alleged action or failure to act (where there was a duty to act) by Merchant related to the Program and/or as otherwise provided for in this Agreement; (vi) any Losses caused by or related to Goods and/or Services charged to an Account or relating to an actual or alleged infringement of a third party\u2019s rights by the Merchant Marks or other intellectual property; (vii) the actual or alleged acts and omissions of Merchant\u2019s affiliates, agents, representatives, service providers and/or subcontractors that perform services on behalf of Merchant or relating to the Program, including Merchant or any of the foregoing allegedly causing Losses to third parties; (viii) a Security Incident within the Merchant\u2019s, or its affiliates, agents, representatives, service providers and/or subcontractors, system, environment, or control, or caused by such person\u2019s actions or inactions; (ix) the transmittal and any storage of Consumer Personal Information, and the acts and omissions of Merchant or any third party in connection therewith; or (x) any failure by Merchant to comply with this Agreement or the guidelines, instructions, policies, and procedures of Bank."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "IN NO EVENT SHALL BANK BE LIABLE TO MERCHANT FOR ANY INCIDENTAL, INDIRECT, PUNITIVE, SPECIAL OR CONSEQUENTIAL DAMAGES MERCHANT INCURS OR CLAIMS TO HAVE INCURRED ARISING OUT OF THIS AGREEMENT (INCLUDING LOST REVENUES OR LOST PROFITS, HOWSOEVER OR WHENEVER THE SAME MAY ARISE AND IRRESPECTIVE OF WHETHER MERCHANT HAD PRIOR NOTICE OF THE POSSIBILITY OF SUCH DAMAGES)."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "BANK\u2019S TOTAL CUMULATIVE LIABILITY TO MERCHANT FOR ALL LOSSES INCURRED BY IT, FOR ANY CAUSE WHATSOEVER, SHALL NOT EXCEED THE AMOUNT PAID BY MERCHANT TO BANK UNDER THE AGREEMENT IN THE PAST SIX MONTHS; PROVIDED, THAT THE EXISTENCE OF MORE THAN ONE CLAIM OR EVENT FROM WHICH LIABILITY ARISES WILL NOT ENLARGE THIS LIMITATION."
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              className: "text-underline",
              children: "NO WARRANTIES. "
            }), "EXCEPT AS PROVIDED IN THE AGREEMENT, THERE ARE NO EXPRESS OR IMPLIED WARRANTIES, INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE, RESPECTING THE SERVICES AND/OR PRODUCTS SOLD OR PROVIDED BY BANK PURSUANT TO THIS AGREEMENT."]
          })]
        })]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "General Provisions. "
        }), jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsxs("strong", {
              className: "text-underline",
              children: ["Relationship of Parties.", ' ']
            }), "The parties agree that in performing their responsibilities pursuant to this Agreement, they are in the position of independent contractors. This Agreement is not intended to create, nor does it create, a partnership, joint venture or any association for profit between Bank and Merchant."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              className: "text-underline",
              children: "Assignment. "
            }), "This Agreement may be assigned by Bank. This Agreement may not be assigned, in whole or in part, by Merchant, without Banks\u2019 prior written consent. This Agreement will be binding upon and will inure to the benefit of the parties and their representatives and respective successors and permitted assigns. Bank may, in its sole discretion, assign, sell, or transfer any Account, or righter therein to any third party."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              className: "text-underline",
              children: "Waivers. "
            }), "No party will be deemed to have waived any of its rights, powers or remedies hereunder unless that party approves such waiver in writing. Any delay, waiver, or omission by a party to exercise any right or power arising from any breach or default in any of the terms of this Agreement will not be construed to be a waiver by that party of any subsequent breach or default of the same or other terms, provisions or covenants."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsxs("strong", {
              className: "text-underline",
              children: ["Entire Agreement; Amendments.", ' ']
            }), "This Agreement, including all attachments hereto, constitutes the entire agreement between the parties relating to the subject matter hereof, and all prior negotiations and understandings, whether oral or written, are superseded hereby. Without limiting the generality of the foregoing, the parties agree that any Alphaeon Credit Registration Form and Private Label Credit Card Program Terms and Conditions in effect between Merchant and Bank is hereby terminated and replaced in its entirety with the terms of this Agreement. For the avoidance of doubt, this Alphaeon Credit Registration Form and Private Label Credit Card Program Terms and Conditions are separate and apart from any other agreement unrelated to Alphaeon Credit private label credit card that may be currently in effect between Merchant and Bank or a Bank affiliate, including any installment loan agreement or other non-Alphaeon credit card program agreement, and the terms of such other agreement(s) (including, without limitation, the termination thereof) will not impact the terms of this Agreement, and vice versa. Except as expressly stated otherwise herein, no modification or amendment of this Agreement will be effective unless set forth in writing and signed by the parties."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              className: "text-underline",
              children: "Insurance. "
            }), "Merchant shall maintain insurance policies with insurers, and in such amounts and against such types of loss and damage, as are customarily maintained by other companies engaged in similar businesses within Merchant\u2019s industry, and in any event sufficient insurance coverage to reasonably protect Bank from any and all liabilities for which Merchant has agreed to indemnify and hold harmless Bank."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              className: "text-underline",
              children: "Governing Law. "
            }), "This Agreement will be governed by and construed in accordance with the internal, substantiative laws of the State of Utah, regardless of the dictates of the conflicts of law provisions of Utah or any other jurisdiction. THE PARTIES HEREBY SUBMIT TO THE EXCLUSIVE JURISDICTION AND VENUE IN THE UNITED STATES FEDERAL DISTRICT COURT OF UTAH OR ANY OF THE STATE COURTS LOCATED IN SALT LAKE COUNTY, UTAH."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsxs("strong", {
              className: "text-underline",
              children: ["JURY TRIAL WAIVER AND CLASS ACTION WAIVER.", ' ']
            }), "The parties waive any right to a trial by jury. The parties waive the right to participate in a class action or other representative action in court or in arbitration, whether as a class representative, class member, private attorney general or otherwise. Further, unless the parties otherwise mutually agree in writing, the arbitrator or court shall not join or consolidate a party\u2019s claims with claims involving any other person or entity."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              className: "text-underline",
              children: "Compliance with Law. "
            }), "Each party shall comply with all Applicable Law in performing its obligations under this Agreement. Merchant\u2019s compliance with Applicable Law includes, but is not limited to, not engaging in: (i) the sale of any illegal goods and/or services, (ii) the illegal sale of otherwise legal goods and/or services, and (iii) sales in violation of federal and/or state laws designed to prevent unlawful gambling. Notwithstanding the foregoing, Merchant will notify Bank immediately if it, or any third party handling any portion of Merchant Technology, (i) fails to comply with Applicable Law related to the Merchant Technology or the Program, or (ii) is subject to any enforcement action, regulatory proceeding, or any other event that may pose a risk that any Merchant Technology or the Program would not comply with Applicable Law or pose a significant risk to Bank or Bank\u2019s existing or prospective Accountholders. Bank shall have the right to monitor Merchant\u2019s operation of Merchant Technology to ensure compliance with Applicable Law."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              className: "text-underline",
              children: "Severability. "
            }), "If any provision of this Agreement or portion thereof is held invalid, illegal, void or unenforceable by reason of any rule of law, administrative or judicial provision or public policy, all other provisions of this Agreement will nevertheless remain in full force and effect to the extent such remaining provisions accurately reflect the intent of the parties."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsxs("strong", {
              className: "text-underline",
              children: ["Product Offers by Bank.", ' ']
            }), "Bank will have the exclusive right but not the obligation to make available to Accountholders various types of debt cancellation and credit related protection programs, and various other types of products and services, the fees for which are charged to the Accountholder\u2019s Account, in Bank\u2019s sole discretion."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              className: "text-underline",
              children: "Taxes. "
            }), "Merchant will be responsible for, and agrees to pay, all sales, use, excise, and value-added taxes, or taxes of a similar nature (excluding personal property taxes and taxes based on Bank\u2019s income which shall be borne by Bank), imposed by the United States, any state or local government, or other taxing authority, on all services provided by Bank under this Agreement. The parties agree to cooperate with each other to minimize any applicable sales, use, or similar tax and, in connection therewith, the parties shall provide each other with any relevant tax information as reasonably requested (including without limitation, resale or exemption certificates, multi-state exemption certificates, information concerning the use of assets, materials and notices of assessments). All amounts set forth in this Agreement are expressed and shall be paid in lawful U.S. dollars."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              className: "text-underline",
              children: "Public Statements. "
            }), "Merchant shall not (i) make any public announcement regarding Bank or the Program, or provide any information concerning Bank or the Program to any representative of any news, trade or other media without the prior approval of Bank, or (ii) respond to any inquiry from any public or governmental authority concerning the Program or Bank without prior consultation and coordination with Bank. Upon Bank\u2019s reasonable request from time to time, Merchant shall provide references or participate in marketing campaigns or testimonial initiatives for Bank regarding the services provided by Bank in connection with the Program."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsxs("strong", {
              className: "text-underline",
              children: ["Notices and Communications.", ' ']
            }), jsxRuntimeExports.jsxs("ol", {
              className: "paragraph-list terms-list",
              children: [jsxRuntimeExports.jsx("li", {
                className: "lower-roman",
                children: "Notices under this Agreement to Bank shall be in writing and addressed or delivered to it at the following (or such other address or contact as may be designated by Bank): Comenity Capital Bank, 12921 South Vista Station Blvd., Suite #100, Draper, UT 84020, Attn: President; with copies to: (i) Comenity Capital Bank, c/o Bread Financial Payments, Inc., P.O. Box 182936, Columbus, OH 43218, Attn: Legal Department and (ii) Legal@BreadFinancial.com"
              }), jsxRuntimeExports.jsxs("li", {
                className: "lower-roman",
                children: ["Notices and communications to Merchant may be sent by email to the email address or delivered to the physical address provided in the Enrollment Form, or through the Bank Portal. Merchant shall notify Bank of any changes to its primary email address or physical address listed on the Enrollment Form.", ' ']
              }), jsxRuntimeExports.jsx("li", {
                className: "lower-roman",
                children: "Electronic communications are considered received by Merchant twenty-four (24) hours from the time they are emailed or posted to the Bank Portal. Notices sent to either party\u2019s physical address are deemed given (A) two (2) business days after being mailed (with postage prepaid) or (B) when delivered by receipted courier service."
              })]
            })]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              className: "text-underline",
              children: "Servicers. "
            }), "Notwithstanding anything in the Agreement to the contrary, Merchant acknowledges and agrees that Bank may, without limitation or condition, subcontract, assign and/or delegate any of its rights or obligations under this Agreement to any Bank affiliate or servicer, and that actions, instructions, policies, and/or notices from such entities shall constitute actions, instructions, policies, and/or notices of Bank. Merchant may not subcontract, assign and/or delegate any rights or obligations hereunder absent Bank\u2019s prior written consent."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              className: "text-underline",
              children: "Survival. "
            }), "No termination or expiration of this Agreement shall in any way affect or impair the powers, obligations, duties, rights, indemnities, liabilities, covenants or warranties and/or representations of the parties with respect to times and/or events occurring prior to such termination or expiration. No powers, obligations, duties, rights, indemnities, liabilities, covenants or warranties and/or representations of the parties with respect to times and/or events occurring after termination or expiration shall survive termination or expiration except for the following Sections and the schedules referenced therein: Sections 2(c) through (e), Section 3, Section 5, Section 6, Section 8, Section 10, Section 14, Sections 15(a) and (c) through (o), and Schedule 2.", ' ']
          })]
        })]
      })]
    }), jsxRuntimeExports.jsx("h4", {
      className: "page-title",
      children: "Schedule 1"
    }), jsxRuntimeExports.jsx("h4", {
      className: "page-title",
      children: "Definitions"
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CAccount\u201D shall mean an individual open-end revolving line of credit which is established by Bank for a Customer pursuant to the terms of a credit agreement."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CAccountholders\u201D shall have the meaning ascribed to such term in Section 2(a)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CAgreement\u201D shall have the meaning ascribed to such term in Section 1."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CApplicable Law\u201D shall mean any applicable federal, state or local law, rule, or regulation, irrespective of whether such law, rule, or regulation has become effective, including, but not limited to, considerations relating to bank regulatory or legal requirements regarding safety and soundness and formal or informal direction from Bank\u2019s primary banking regulator(s)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CApplicant\u201D shall have the meaning ascribed to such term in Section 4(a)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CBank\u201D shall have the meaning ascribed to such term in Section 1."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CBank API\u201D shall mean Bank\u2019s application programming interface."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CBank Application\u201D shall have the meaning ascribed to such term in Section 4(a)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CBank Confidential Information\u201D shall have the meaning ascribed to such term in Section 8(a)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CBank Marks\u201D shall have the meaning ascribed to such term in Section 5(b)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CBank Portal\u201D shall mean the Internet-based platform or platforms, if designated by Bank, which are available to Merchant for (i) linking the processing of Account applications and authorization of Account payments and credits, (ii) reporting the Account payments and credits in the settlement of funds, and/or (iii) facilitating related processing functions with respect to Accounts; or other Internet-based platform having substantially the same functions."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CBank Systems\u201D shall mean, collectively, Bank API, Bank Portals, and Bank systems."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CBank Technology\u201D shall mean products, software, hardware, telecommunication protocol, and/or technologies, that are owned or licensed by Bank, including any Bank Portal and Bank API."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CConfidential Information\u201D shall have the meaning ascribed to such term in Section 8(b)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CConsumer Personal Information\u201D shall mean that non-public personal information regarding Applicants, Customers, and Accountholders, including but not limited to Account information, consumer reports, and information derived from consumer reports, that is subject to protection from publication under Applicable Law."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CCustomer\u201D shall mean any individual consumer who is a customer or potential customer of Merchant."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CCustomer Check-Out\u201D shall mean, for any purchase of Goods and/or Services using the Program on the Merchant Platform, the Customer check-out process on Bank Systems or through another process as directed by Bank."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CCritical Issues\u201D shall mean those critical, priority, or emergency issues (including without limitation security, fraud, or authentication issues)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CGoods and/or Services\u201D shall mean those goods and/or services that are sold or offered by Merchant to the general public for individual, personal, family or household use."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CHealth Information\u201D shall have the meaning ascribed to such term in Section 2(c)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CImpacted Party\u201D shall have the meaning ascribed to such term in Section 8(f)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CImplementation Guidelines\u201D shall mean Bank\u2019s established procedures by which third parties integrate with Bank Systems and Bank Technology."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CLosses\u201D shall have the meaning ascribed to such term in Section 14."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CMarks\u201D shall have the meaning ascribed to such term in Section 5(b)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CMerchant\u201D shall have the meaning ascribed to such term in Section 1."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CMerchant Marks\u201D shall have the meaning ascribed to such term in Section 5(a)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CMerchant Platform\u201D shall mean, collectively, Merchant\u2019s payment acceptance channels as approved by Bank for participation in the Program (e.g., Merchant\u2019s websites, mobile platforms, applications and point of sale systems, whether online or in-store)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CMerchant Technology\u201D shall mean products, software, hardware, telecommunication protocol, and/or technologies, that are owned or licensed by Merchant."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201COperating Procedures\u201D shall have the meaning ascribed to such term in Section 7(b)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CProgram\u201D shall have the meaning ascribed to such term in Section 1."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CProgram Technology\u201D shall have the meaning ascribed to such term in Section 5(c)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CProgram Technology Updates\u201D shall have the meaning ascribed to such term in Section 5(c)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CPromotional Program\u201D shall mean any special Accountholder payment terms approved by Bank for certain Purchases under the Program, including without limitation any Purchases not made pursuant to regular revolving credit terms."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CPurchase\u201D shall have the meaning ascribed to such term in Section 1."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CRegistration Form\u201D shall have the meaning ascribed to such term in Section 1."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CSales Channels\u201D shall mean those certain sales channels through which Merchant sells its Goods and/or Services, regardless of what name Merchant uses for such sales channels, including (as applicable) but not limited to the following which may be owned and operated by Merchant: (i) retail locations, (ii) websites; and (iii) catalogs. Sales Channels does not include any third-party digital platform or a sales channel for which Merchant do not control."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CSchedules\u201D shall mean Schedules 1-2, attached hereto, and any other separate schedule of terms attached hereto, and incorporated herein, from time to time."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CSecurity Incident\u201D shall have the meaning ascribed to such term in Section 8(f)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "\u201CTerms and Conditions\u201D shall have the meaning ascribed to such term in Section 1."
    }), jsxRuntimeExports.jsxs("p", {
      className: "paragraph-basic",
      children: [jsxRuntimeExports.jsx("strong", {
        className: "text-underline",
        children: "Other Definitions. "
      }), "As used in this Agreement, defined terms stated in the singular shall include reference to the plural and vice versa. The terms \u201Cshall\u201D and \u201Cwill\u201D have the identical meaning (i.e., that something is compulsory and certain), and the use of one versus the other is not to be interpreted as implying less certainty or a sense of possibility or choice."]
    }), jsxRuntimeExports.jsx("h4", {
      className: "page-title",
      children: "Schedule 2"
    }), jsxRuntimeExports.jsx("h4", {
      className: "page-title",
      children: "Terms that Apply During Bank Settlement"
    }), jsxRuntimeExports.jsxs("p", {
      className: "paragraph-basic",
      children: ["As further described in Section 2(c) of this Agreement, the terms set forth in this Schedule 2 shall apply, and replace those set forth in Section 2, any time Bank transmits Net Proceeds directly to Merchant, including, without limitation, up until the date on which Alphaeon takes responsibility for settlement transmission to Merchant or if Bank needs to re-commence transmitting settlement directly to Merchant.", ' ']
    }), jsxRuntimeExports.jsxs("p", {
      className: "paragraph-basic",
      children: ["Section 2.", ' ', jsxRuntimeExports.jsx("strong", {
        className: "text-underline",
        children: "Credit Transaction. "
      })]
    }), jsxRuntimeExports.jsxs("ol", {
      className: "paragraph-list terms-list",
      children: [jsxRuntimeExports.jsx("li", {
        className: "lower-alpha",
        children: "Details regarding the various Promotional Programs available to those individuals who open accounts under this Agreement (\u201CAccountholders\u201D) and the pricing related thereto are set forth in a schedule provided separately to Merchant by Bank. Bank may amend and re-distribute the Promotional Program schedule from time to time in Bank\u2019s sole discretion. Merchant may not add or assess any portion of the Discount Fee, administrative fees, or any other form of additional fees, surcharge, consideration or security to an Accountholder who chooses to use the Program as tender for the Goods and/or Services provided. The Program is a non-recourse program for Merchant, meaning that, subject to Bank\u2019s chargeback and other rights as provided herein, Bank will not seek repayment from Merchant if the Accountholder fails to repay the credit transaction. However, if the Goods and/or Services are not performed in full or in part after the amount of such Purchase has been disbursed to Merchant, then upon the request of Bank or the Accountholder, Merchant will return the amount of such transaction to Bank within ten (10) business days. In such instances, the amount to be refunded will be returned to Bank as a credit to the Accountholder\u2019s credit account (\u201CAccount\u201D). Merchant will not accept any payments from an Accountholder for charges billed on an Account, and will instead refer the Accountholder to Bank's payment address. If for any reason, Merchant inadvertently accepts an Accountholder payment, Merchant will hold such payment in trust for Bank and will immediately notify Bank and forward such payment to Bank for processing."
      }), jsxRuntimeExports.jsxs("li", {
        className: "lower-alpha",
        children: ["Notwithstanding anything herein to the contrary, Merchant may charge an Accountholder\u2019s credit Account for Goods and/or Services that are initiated or received within thirty (30) days of the date on which the Account is charged (\u201CPre-Funding\u201D). In the event that Merchant does not comply with the foregoing timing requirement, Bank shall exercise its chargeback rights pursuant to the Agreement and the Operating Procedures. Additionally, until such time as the Goods and/or Services are provided, the Accountholder will have the ability to request a refund of the full amount charged to the Account for Goods and/or Services that have not been received, unless otherwise agreed to by Bank and in compliance with Bank\u2019s and Alphaeon\u2019s policies and procedures. In such instances, the amount to be refunded will be returned to Bank as a credit to the Accountholder\u2019s Account. If at any time Bank determines in its sole discretion that Merchant\u2019s practice of Pre-Funding is not in compliance with the requirements set forth herein, or that such practice is a concern to Bank based on Bank\u2019s adherence to applicable law, including, but not limited to, safety and soundness, regulatory feedback or reputational considerations, Bank may prohibit Merchant from continuing the practice of Pre-Funding.", ' ']
      }), jsxRuntimeExports.jsxs("li", {
        className: "lower-alpha",
        children: ["Merchant will receive the net of funds owed for each Purchase (\u201CNet Proceeds\u201D). Merchant will be responsible for transmitting Transaction Records each day, within a reasonable time period and in a format acceptable to Bank, in accordance with the Agreement and Operating Procedures. Bank shall promptly create electronic settlement files from Transaction Records processed by Merchant and transmit such files to Merchant via the Bank in a format acceptable to Bank. Merchant shall be responsible for properly designating, on the Transaction Records, the Merchant location from which individual transactions originate. Upon receipt Bank shall verify and process such Transaction Records, and Bank will remit to Merchant an amount equal to the Net Proceeds indicated by such Transaction Records for which such remittance is made. Bank will transfer funds via Automated Clearing House (\u201CACH\u201D) to the Merchant bank deposit account indicated in the Registration Form (\u201CDeposit Account\u201D). For Transaction Records received by Bank\u2019s processing center before 9 AM Eastern time on a business day, such ACH transfer will have an effective date of that business day, plus two (2) business days thereafter. For Transaction Records received by Bank\u2019s processing center either (i) after 9 AM Eastern time on a business day, or (ii) on a non-business day, such ACH transfer will have an effective date of that date of receipt, plus three (3) business days thereafter. Effective upon the delivery of Transaction Records by Merchant to Bank and payment to Merchant by Bank, Merchant shall be deemed to have transferred, conveyed, assigned and surrendered to Bank all right, title or interest in all such Transaction Records and in all other rights and writings evidencing such Purchases, if any. All Transaction Records are subject to review and acceptance by Bank. In the event of a computational or similar error of an accounting or record keeping nature with respect to such Transaction Records, Bank may debit or credit to the Deposit Account or net against the Net Proceeds (as the case may be) the proper amount as corrected. For purposes of this Schedule 2, \u201CTransaction Records\u201D shall mean the following, with respect to each Purchase or with respect to a credit or return related to a Purchase (as applicable): (i) the charge slip or credit slip corresponding to the Purchase, credit or return; (ii) the following information submitted to Bank, through the Bank Portal or as otherwise directed by Bank: the Account number of the Accountholder, identification of the Merchant location where the Purchase, credit or return was made (if applicable), the total of (x) the purchase price of Goods and/or Services purchased or amount of the credit, as applicable, plus (y) the date of the transaction and a description of the Goods and/or Services purchased, credited or returned; or (iii) electronic record whereby Merchant otherwise electronically submits the information described in subsection (ii) as directed by Bank.", ' ']
      }), jsxRuntimeExports.jsx("li", {
        className: "lower-alpha",
        children: "Merchant shall not disclose or transmit to Bank any medical, health (including auditory or dental), or insurance information or data about Customers, including but not limited to information that would meet the definition of \u201CProtected Health Information\u201D under the Health Insurance Portability and Accountability Act of 1996, found at\u00A0 45 CFR, Sec. 160.103, as in force from time to time (collectively, \u201CHealth Information\u201D), including information describing the products and/or services which are the subject of any transaction. Merchant shall only indicate that there were Goods and/or Services purchased using the Program (and/or the subject of a credit, refund, or return), but not indicate which Goods and/or Services are the subject of such transaction."
      }), jsxRuntimeExports.jsx("li", {
        className: "lower-alpha",
        children: "Notwithstanding anything herein to the contrary, Bank is not obligated to remit funds to Merchant (i) if Merchant otherwise failed to comply with any of the terms or conditions of this Agreement or (iii) if Merchant is in breach of any of its representations or warranties under this Agreement."
      }), jsxRuntimeExports.jsx("li", {
        className: "lower-alpha",
        children: "Merchant acknowledges and agrees that (i) the terms of the purchase of Goods and/or Services financed using the Program shall only be offered in the English language, and (ii) the Program shall only be offered in the English language, including the solicitation of applications, and (iii) the Program may be made available solely to Customers who are United States residents, to finance the purchase of Goods and/or Services for personal, family, or household use, the purchase price of which is listed in U.S. dollars."
      }), jsxRuntimeExports.jsxs("li", {
        className: "lower-alpha",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "Chargebacks. "
        }), "Bank shall have the right to charge back Merchant the amount of any Purchase, including the unpaid principal balance, applicable sales tax, accrued and billed finance charges, fees, charges and any of such amounts written off by Bank relating to any such Purchase:", jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsx("li", {
            className: "lower-roman",
            children: "If any applicant or Accountholder claim, defense, dispute, or basis for non-payment is based on an alleged action or inaction by Merchant and/or otherwise involves the Goods and/or Services, including but not limited to an alleged: (i) breach of warranty or representation; (ii) unauthorized use of the Account; (iii) charge for something other than an actual Purchase; (iv) the charge slip related to the Purchase is a duplicate of one already paid and/or the price on it differs from the price on the Accountholder\u2019s copy of same; and/or (v) Bank\u2019s determination, upon reasonable investigation, that the signature on any charge slip has been forged or is counterfeit; or"
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-roman",
            children: "If Bank determines that, with respect to such Purchase or the Account: (i) there is a breach of any warranty or representation made by or with respect to Merchant under this Agreement; (ii) there is a failure by Merchant to comply with any term or condition of this Agreement; (iii) Merchant did not obtain an authorization/approval code as required by this Agreement; (iv) the Goods and/or Services purchased have not been delivered, provided or shipped; (v) the transaction was submitted to Bank more than thirty (30) days after it occurred or after Merchant is no longer an authorized participant in the Program; or (vi) fraudulent activity ; or"
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-roman",
            children: "For any chargeback reason as set forth in the Operating Procedures."
          })]
        })]
      }), jsxRuntimeExports.jsx("p", {
        className: "paragraph-basic",
        children: "Bank will offset amounts to be charged back from Net Proceeds to be paid to Merchant, or may debit Merchant\u2019s Deposit Account or demand payment from Merchant in immediately available funds for the full or any partial amount of such chargeback. Merchant will not resubmit or re-transmit any charged back Purchase to Bank without Bank\u2019s prior written consent."
      }), jsxRuntimeExports.jsx("li", {
        className: "lower-alpha",
        children: "Merchant shall be liable for, and Bank shall have the right to offset against other amounts due by Bank to Merchant hereunder, the amount of any Losses incurred by Bank resulting from or attributable to any fraudulent activity, including, but not limited to, the unpaid principal balance, applicable sales tax, accrued and billed finance charges, fees, charges and any such amounts written off by Bank from fraudulent Purchases, if the fraudulent activity is the result of a failure by Merchant to (x) comply with this Agreement, Bank\u2019s practices, procedures, or Bank\u2019s Implementation Guidelines, or (y) implement and maintain any Program Technology Updates and/or Critical Program Technology Updates in accordance with Section 5(c)."
      }), jsxRuntimeExports.jsxs("li", {
        className: "lower-alpha",
        children: ["Bank reserves the right to hold back from Merchant amounts otherwise owing under this Agreement in anticipation of chargebacks or other liabilities, including those that may occur upon termination of this Agreement or at any time after Merchant has received written notice from Bank stating that (i) Merchant has failed to comply with the terms of this Agreement; (ii) Merchant has experienced a higher level of chargebacks, fraud, disputes, cancelled orders, or refund requests than historical levels with Merchant or at levels higher than expected as determined in the sole reasonable discretion of Bank; (iii) Bank has determined that Merchant may not be able to fulfill its obligations to Customers because Merchant\u2019s financial condition has deteriorated or because of an escalation of Customer complaints; (iv) Bank has determined that any one or more transactions will be unenforceable against the Accountholder directly because of an act or omission by Merchant; (v) Bank has determined that any transaction is not a bona fide Customer transaction or is otherwise the result of Merchant fraud; or (vi) Merchant has failed to provide documentation, financial statements, and other information and records to demonstrate compliance with the Agreement as required herein.", ' ']
      }), jsxRuntimeExports.jsx("li", {
        className: "lower-alpha",
        children: "If Bank withholds amounts from Merchant pursuant to Section 2(i) above, Bank will notify Merchant (which may be by email) of the amounts withheld and the reason for such withholding. Bank and Merchant will work together in good faith for a period of thirty (30) calendar days to resolve the reason for such withholding to Bank\u2019s satisfaction. Upon the expiration of the thirty (30) calendar day period or such longer period as it may take to reach a resolution, Bank will either release the withheld funds to Merchant or set off the withheld amount against any amounts determined to be owed from Merchant to Bank, as determined by Bank in its sole discretion. Merchant agrees to provide Bank access to its records and other such information as may be needed to resolve such matter in an expeditious manner. Merchant agrees that, notwithstanding anything to the contrary in this Agreement, any funds withheld are not contractually owed or payable to Merchant unless and until such time as the parties reach a resolution to release such funds to the Merchant pursuant to the resolution procedures described above. If and to the extent such funds are set off against amounts owed from Merchant to Bank, such set off amount shall be deemed to be irrevocably paid to Bank."
      }), jsxRuntimeExports.jsx("li", {
        className: "lower-alpha",
        children: "Bank will debit or credit Merchant\u2019s Deposit Account for the amount due based on the net total of the daily credit transactions including all calculated fees. If Bank is owed any amounts pursuant to this Agreement other than the daily credit transactions for more than fifteen (15) days after the due date, it shall, at its discretion, offset such amounts from any funds due to Merchant and/or against Merchant\u2019s Deposit Account. At its option, Bank may invoice Merchant such amounts, which shall be paid within fifteen (15) days of receipt of invoice."
      })]
    }), "REVISED 7/26/2024 ", jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx("br", {})]
  });
}

function TermsAndConditions() {
  return jsxRuntimeExports.jsxs("div", {
    className: "page-container",
    children: [jsxRuntimeExports.jsx("h4", {
      className: "page-title font-bold text-underline",
      children: "ALPHAEON CREDIT, INC. TERMS AND CONDITIONS"
    }), jsxRuntimeExports.jsx("h4", {
      className: "page-title",
      children: "Please read these entire Terms and Conditions before using the Services. By using the Services, You are acknowledging that these entire Terms and Conditions create a contract (the \u201CAgreement\u201D) between You and Alphaeon Credit, Inc. (\u201CACI\u201D). To confirm Your understanding and acceptance of the Agreement, click \u201CAgree.\u201D"
    }), jsxRuntimeExports.jsxs("ol", {
      className: "paragraph-list terms-list",
      children: [jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "Definitions"
        }), " The following definitions shall apply to this Agreement and any Exhibits:", jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "\u201CAccountholder\u201D means any consumer who is approved for and opens an account with ACI and its Partner(s)."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "\u201CACI\u201D means Alphaeon Credit, Inc., a Delaware corporation, and includes its designated affiliates, successors, and assigns;"
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "\u201CDashboard\u201D means the internet-based platform designated by ACI which is available to You for (i) linking the processing of account applications, (ii) reporting account payments and credits in the settlement of funds, and (iii) facilitating related processing functions with respect to accounts; or other internet-based platform having substantially the same functions."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "\u201CRegistration Form\u201D means the enrollment application for Services You filled out;"
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "\u201CServices\u201D mean the private label credit card program offered by Comenity Capital Bank (\u201CBank\u201D) and any other patient financing program offered by ACI itself or by other third-party financial institutions (\u201CFinancial Institutions\u201D) (Together Bank and Financial Institutions are ACI\u2019s \u201CPartners\u201D) through ACI;"
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "\u201CTransaction Record\u201D means the following, with respect to each purchase or with respect to a credit or return relating to a purchase (as applicable): (i) the charge slip or credit slip corresponding to the purchase, credit or return; or (ii) an electronic identification of Your location where the purchase, credit, or return was made (if applicable), the total of (x) the purchase price of goods and/or services purchased or amount of the credit, as applicable, plus (y) the date of the transaction and a description of the goods and/or services purchased, credited, or returned; or (iii) electronic record whereby You electronically transmit the information described in subsection (ii) hereof to a network provider (selected by You at Your expense), which in turn transmits such information to ACI by a computer tape/cartridge or electric tape or transmission; and"
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "\u201CYou\u201D and \u201CYour\u201D refers to the person, firm, or entity entering into the Agreement with ACI."
          })]
        })]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "THE SERVICES."
        }), " This Agreement governs Your use of ACI\u2019s Services, through which You can access patient financing programs offered by ACI and its Partners. Our Services are available for use in the United States only.", jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              children: " ELIGIBILITY. "
            }), "To use the Services, You will need to agree to these Terms and Conditions and meet certain requirements defined by ACI and its Partners."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              children: "USE."
            }), " Upon enrollment and approval by ACI and its Partner(s), You will be able to offer the Services to new and existing patients. Under this Agreement, You agree:", jsxRuntimeExports.jsxs("ol", {
              className: "paragraph-list terms-list",
              children: [jsxRuntimeExports.jsxs("li", {
                className: "lower-roman",
                children: [jsxRuntimeExports.jsx("strong", {
                  children: "Application Submission."
                }), jsxRuntimeExports.jsxs("ol", {
                  className: "paragraph-list terms-list",
                  children: [jsxRuntimeExports.jsx("li", {
                    className: "decimal",
                    children: "You will follow all application procedures prescribed by ACI and its Partners, including, without limitation, You will verify the identity of any individual applying for financing with ACI\u2019s Partners in Your office by reviewing the name and photo on the consumer\u2019s government issued identification to verify the name on the application and that the photo resembles the customer that is completing the application."
                  }), jsxRuntimeExports.jsxs("li", {
                    className: "decimal",
                    children: ["You will not submit transactions more than 30 days in advance of a surgery, procedure, or treatment and refunds will be made if other factors, in or outside of Your control, prevent You from proceeding with the surgery, procedure, or treatment.", jsxRuntimeExports.jsx("ol", {
                      className: "paragraph-list terms-list",
                      children: jsxRuntimeExports.jsx("li", {
                        className: "lower-alpha",
                        children: "If you submit transactions more than 30 days in advance of a surgery, procedure, or treatment, you may be liable for any fees or interests accrued by the Accountholder."
                      })
                    })]
                  })]
                })]
              }), jsxRuntimeExports.jsxs("li", {
                className: "lower-roman",
                children: [jsxRuntimeExports.jsx("strong", {
                  children: "Your Representations and Warranties."
                }), jsxRuntimeExports.jsxs("ol", {
                  className: "paragraph-list terms-list",
                  children: [jsxRuntimeExports.jsx("li", {
                    className: "decimal",
                    children: "You shall not make any representation or warranty to the consumer in connection with the Services which is inconsistent with or in addition to the terms and conditions of the financing agreement, and You shall not discuss with the consumer the likelihood of: (1) credit approval under the Services; (2) being charged any particular finance charge rate in connection with the Services; or (3) being subject to any particular payment schedule or payment amount(s) in connection with the Services."
                  }), jsxRuntimeExports.jsx("li", {
                    className: "decimal",
                    children: "Each financing agreement will be voluntarily entered into by the consumer. Each consumer executing a financing agreement is not a minor and shall have the capacity to enter into the agreement."
                  }), jsxRuntimeExports.jsx("li", {
                    className: "decimal",
                    children: "No action or inaction on Your part shall cause any financing agreement to be originated in violation of federal, state, or local laws, regulations, ordinances, or governmental agency guidance relating to any aspect of the Services, including, but not limited to, those relating to disclosures, anti-money laundering, privacy and fair lending."
                  }), jsxRuntimeExports.jsx("li", {
                    className: "decimal",
                    children: "You shall have full responsibility for ensuring the quality of goods and/or services provided under the Services and neither ACI nor its Partners will have any responsibility therefor."
                  }), jsxRuntimeExports.jsx("li", {
                    className: "decimal",
                    children: "You shall not disclose or transmit to ACI any medical, health (including auditory or dental), or insurance information or data about Accountholders or patients, including but not limited to information that would meet the definition of \u201CProtected Health Information\u201D under the Health Insurance Portability and Accountability Act of 1996, found at 45 CFR, Sec. 160.103, as in force from time to time (collectively, \u201CHealth Information\u201D), including information describing the products and/or services which are the subject of any transaction. You shall only indicate that there were goods and/or services purchased using the Services (and/or the subject of a credit, refund, or return), but not indicate with goods and/or services are the subject of the transaction."
                  })]
                })]
              }), jsxRuntimeExports.jsxs("li", {
                className: "lower-roman",
                children: [jsxRuntimeExports.jsx("strong", {
                  children: "Return of Services."
                }), jsxRuntimeExports.jsxs("ol", {
                  className: "paragraph-list terms-list",
                  children: [jsxRuntimeExports.jsx("li", {
                    className: "decimal",
                    children: "You understand that ACI and its Partners will not honor \u201Cno refund policies\u201D. In the event services are not rendered for any reason, You must refund the Accountholder immediately upon cancelation, subject to our refund policy."
                  }), jsxRuntimeExports.jsx("li", {
                    className: "decimal",
                    children: "In the event of a charge dispute by an Accountholder, You will provide signed receipts, ID documentation, a copy of the informed consent disclosure, a copy of refund/cancellation policies, and any other reasonably requested documentation to ACI and/or the third-party providing patient financing."
                  }), jsxRuntimeExports.jsx("li", {
                    className: "decimal",
                    children: "The Services are only available for use in the United States."
                  })]
                })]
              }), jsxRuntimeExports.jsxs("li", {
                className: "lower-roman",
                children: [jsxRuntimeExports.jsx("strong", {
                  children: "No Minimums. "
                }), "Neither ACI nor its Partners warrant nor guarantee that (i) You will receive any minimum amount of sales or revenues as a result of using the Services; or (ii) that the Services will be continuously available or error-free."]
              }), jsxRuntimeExports.jsxs("li", {
                className: "lower-roman",
                children: [jsxRuntimeExports.jsx("strong", {
                  children: "No Exclusivity. "
                }), "You shall not represent that you are the exclusive provider of the Services nor shall You have an exclusive relationship with ACI and/or its Partners. You agree that ACI may offer the Services to other merchants."]
              })]
            })]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              children: "ADDITIONAL SERVICES. "
            }), "ACI shall provide You, at no additional cost, training, marketing materials, and operational support materials, live support, and reporting. You will provide ACI with a list of Your locations that will offer the Services."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              children: "MARKETING. "
            }), "You may promote the Services in a commercially reasonable manner, which may include, but is not limited to, signage and leaflets. You agree to use only marketing and promotional materials provided by ACI or its Partner(s) or previously approved in writing by ACI or its Partner(s)."]
          })]
        })]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "CREDIT TRANSACTION AND CORRECTIONS."
        }), ' ', "You authorize and/or confirm the following:", jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: ["ACI is authorized to automatically deposit any funds owed to You through the use of the Services to Your Bank Account(s) (as provided in the Registration Form, any supplement to the Registration Form, and/or subsequently updated or changed) (\u201CBank Account(s)\u201D);", jsxRuntimeExports.jsx("ol", {
              className: "paragraph-list terms-list",
              children: jsxRuntimeExports.jsx("li", {
                className: "lower-roman",
                children: "You will receive the net amount owed for each credit transaction from ACI by ACH direct deposit."
              })
            })]
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "You will promptly notify ACI of any changes or updates to Your Bank Account(s)."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "The various promotional plans available to Accountholders and the pricing related thereto may be found in Your dashboard. ACI and/or its Partners may amend and re- distribute the promotional plan schedules from time to time in their sole discretion."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "You may not add or assess any portion of administrative fees, or any form of additional fees, consideration or security to an Accountholder who chooses to use the Services."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "If the goods and/or services are not performed in full or in part after the transaction amount has been disbursed to You, then upon request of ACI or the Accountholder, You will return the amount of such transaction to ACI within ten (10) business days. In such instances, the amount to be refunded will be returned as a credit to the Accountholder\u2019s credit account."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "You will not accept any payments from an Accountholder for charges billed on an Accountholder\u2019s credit account, and will instead refer the Accountholder to the appropriate Partner. If for any reason, You inadvertently accept an Accountholder payment, You will hold such payment in trust for ACI and will immediately notify ACI."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "You may charge an Accountholder\u2019s credit account for goods and/or services that are initiated or received within thirty (30) days of the date on which the Account is charged (\u201CPre-Funding\u201D). In the event You do not comply with the foregoing timing requirement, ACI shall exercise its chargeback rights pursuant to the Agreement. Further, You may be liable for any fees and interest accrued by the Accountholder. Additionally, until such time as the goods and/or services are provided, the Accountholder will have the ability to request a refund of the amount charged to the Account for goods and/or services that have not been received. In such instances, the amount to be refunded will be returned to the applicable Partner as a credit to the Accountholder\u2019s account."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "You will receive the net of funds owed for each purchase. Each calendar day, You shall electronically transmit all Transaction Records to ACI via the Dashboard on the same day and in a format acceptable to ACI. You shall be responsible for properly designating, on the Transaction Records, Your location from which individual transactions originate. Upon receipt, ACI shall use commercially reasonable efforts to promptly verify and process such Transaction Records within two (2) business days, and ACI will remit to You an amount equal to the net amount indicated by such Transaction Records for which such remittance is made. ACI will transfer funds via Automated Clearing House (\u201CACH\u201D) to Your Bank Account. Effective upon the delivery of Transaction Records by You to ACI and payment to You by ACI, You shall be deemed to have transferred, conveyed, assigned and surrendered to ACI all right, title or interest in all such Transaction Records and in all other rights and writings evidencing such purchases, if any."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "In the event of a computation or similar accounting or recordkeeping error, ACI may debit or credit Your account the proper amount as corrected."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "ACI is authorized (and You consent) to use and store the information on the Registration Form to verify the information contained therein, as well as to request and obtain a consumer report from one or more consumer reporting agencies about You and to furnish information to a consumer reporting agency about You. For purposes of this authorization, \u201CYou\u201D refers to Doctor, Doctor\u2019s Practice, and any of its owners, principals, partners, officers and/or directors who, for purposes of this authorization are deemed to have executed this agreement jointly and severally;"
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "ACI is expressly authorized to adhere to any reasonable instructions, which it may receive from Your employees;"
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "You have read this Agreement and You acknowledge and agree that, upon enrollment with ACI, both You and Your practice shall be bound by and comply with all Terms and Conditions, as well as any other policies and procedures issued by ACI\u2019s Partners; and"
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Notwithstanding anything herein to the contrary, ACI is not obligated to remit funds to You: (i) if You otherwise fail to comply with any of the terms or conditions of this Agreement or (iii) if You are in breach of any of Your representations or warranties under this Agreement."
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("span", {
              className: "text-underline",
              children: "Chargebacks. "
            }), "ACI shall have the right to charge You back the amount of any purchase, including the unpaid principal balance, applicable sales tax, accrued and billed finance charges, fees, charges and any of such amount written off by ACI or its Partner(s) relating to any such purchase:", jsxRuntimeExports.jsxs("ol", {
              className: "paragraph-list terms-list",
              children: [jsxRuntimeExports.jsx("li", {
                className: "lower-roman",
                children: "If any applicant or Accountholder claim, defense, dispute, or basis for non- payment is based on Your alleged action or inaction and/or otherwise involves the goods and/or services, including by not limited to an alleged: (i) breach of warranty or representation; (ii) unauthorized use of the Services; (iii) charge for something other than an actual purchase; (iv) the charge slip related to the purchase is a duplicate of one already paid and/or the price on it differs from the price on the Accountholder\u2019s copy of the same; and/or (v) ACI or its Partners\u2019 determination, upon reasonable investigation, that the signature on any charge slip has been forged or is counterfeit; or"
              }), jsxRuntimeExports.jsx("li", {
                className: "lower-roman",
                children: "If ACI or its Partners determine that, with respect to such purchase or the Account: (i) there is a breach of any warranty or representation made by or with respect to You under this Agreement; (ii) You fail to comply with any term or condition of this Agreement; (iii) You did not obtain the authorization/approval code as required by this Agreement; (iv) the goods and/or services purchased have not been delivered, provided, or shipped; (v) the transaction was submitted to ACI or its Partner more than thirty (30) days after it occurred or after You are no longer an authorized participant in the Services; or (vi) fraudulent activity; or"
              }), jsxRuntimeExports.jsx("li", {
                className: "lower-roman",
                children: "For any chargeback reason set forth in Bank\u2019s Operating Procedures or any other policies and procedures provided by Partners."
              })]
            }), "ACI will offset amounts to be charged back from the net proceeds to be paid to You, or may debit any of Your Bank Account(s), or demand payment from You in immediately available funds for the full or any partial amount of such chargeback. You will not resubmit or re-transmit any charged back purchase to ACI or its Partner without ACI or its Partner\u2019s prior written consent."]
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "You shall be liable for, and ACI shall have the right to offset against other amounts due by ACI or its Partner to You hereunder, the amount of any losses incurred by ACI or its Partner resulting from or attributable to any fraudulent activity including, but not limited to, the unpaid principal balance, applicable sales tax, accrued and billed finance charges, fees, charges and any such amounts written off by ACI or its Partner from fraudulent purchases, if the fraudulent activity is the result of Your failure to (x) comply with this Agreement, or applicable practices, procedures, or guidelines, or (y) implement and maintain any program technology updates and/or critical program technology updates."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "ACI reserves the right to hold back from You amounts otherwise owing under this Agreement in anticipation of chargebacks or other liabilities, including those that may occur upon termination of this Agreement or at any time after You have received written notice from ACI or its Partner stating that (i) You have failed to comply with the terms of this Agreement; (ii) You have experienced a higher level of chargebacks, fraud, disputes, cancelled orders, or refund requests than Your historical levels or at levels higher than expected as determined in the sole reasonable discretion of ACI or its Partner; (iii) ACI or its Partner has determined that You may not be able to fulfill Your obligations to Accountholders or patients because Your financial condition has deteriorated or because of an escalation of customer complaints; (iv) ACI or its Partner has determined that any one or more transactions will be unenforceable against the Accountholder directly because of an act or omission by You; (v) ACI or its Partner has determined that any transaction is not a bona fide customer transaction or is otherwise the result of Your fraud; or (vi) You have failed to provide documentation, financial statements, and other information and records to demonstrate compliance with the Agreement as required herein."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "If ACI or its Partner withholds amounts from You pursuant to Section 3(p) above, ACI will notify You (which may be by email) of the amounts withheld and the reason for such withholding. ACI and You will work together in good faith for a period of thirty (30) calendar days to resolve the reason for such withholding to ACI or its Partner\u2019s satisfaction. Upon the expiration of the thirty (30) calendar day period or such longer period as it may take to reach a resolution, ACI will either release the withheld funds to You or set off the withheld amount against any amounts determined to be owed from You to ACI or its Partner, as determined by ACI or its Partner in its sole discretion. You agree to provide ACI or its Partner access to its records and other such information as may be needed to resolve such matter in an expeditious manner. You agree that, notwithstanding anything to the contrary in this Agreement, any funds withheld are not contractually owed or payable to You unless and until such time as the parties reach a resolution to release such funds to the You pursuant to the resolution procedures described above. If and to the extent such funds are set off against amounts owed from You to ACI or its Partner, such set off amount shall be deemed to be irrevocably paid to ACI."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "ACI will debit or credit Your Bank Account(s) for the amount due based on the net total of the daily credit transactions including all calculated fees. If ACI is owed any amounts pursuant to this Agreement other than the daily credit transactions for more than fifteen (15) days after the due date, it shall, at its discretion, offset such amounts from any funds due to You and/or against Your Bank Account(s). At its option, ACI may invoice You such amounts, which shall be paid within fifteen (15) days of receipt of invoice."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Executing the Registration Form, this Agreement, and using the Services has been duly authorized by all necessary corporate proceedings. This Bank Account Authorization has been duly executed and delivered by You and is a valid and legally binding agreement. The execution and delivery of the Registration Form and compliance by You with all provisions of this Agreement will not conflict with or violate any applicable law, nor will such execution, delivery, or compliance violate or result in the violation of the Articles of Incorporation or By-Laws (or analogous rules of governance) of You and/or Your practice."
          })]
        })]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "TERM AND TERMINATION. "
        }), "ACI may immediately terminate this Agreement at any time by providing notice to You. You may terminate this Agreement at any time after providing 30 days written notice to ACI. Any bankruptcy (whether voluntary or involuntary) or insolvency by either party shall be considered an immediate termination event and shall result in the termination of this Agreement. Termination of this Agreement will not terminate, affect, or impair any rights, obligations, or liabilities of either party, which may accrue prior to such termination, or which under the terms of this Agreement, continue after termination."]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsxs("strong", {
          className: "text-underline",
          children: ["REPRESENTATIONS AND WARRANTIES.", ' ']
        }), "Each party represents and warrants to the other party that : (i) they have the right, power, and authority to enter into this Agreement and perform the acts required of them hereunder; (ii) the execution of this Agreement by such party, and the performance by that party of its obligations and duties hereunder, do not and will not violate any other agreements to which such party is bound; (iii) when executed and delivered by such party, this Agreement will constitute the legal, valid, and binding obligation of such party, enforceable against such party in accordance with its terms (except as such enforcement may be limited by bankruptcy, insolvency, reorganization, moratorium and other laws relating to or affecting creditors\u2019 rights generally and by general principles of equity); (iv) such party is, and shall remain, fully authorized, certified, and/or licensed to perform as required under the terms of this Agreement, which in the case of You includes, but is not limited to, (a) being and remaining in good standing with any governmental or professional body having jurisdiction over Your practice, (b) becoming and having Your personnel become trained with respect to participation in the patient financing program, and (c) having authority to perform and/or provide the goods and services for which your patients use the patient financing as a form of payment."]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "CONFIDENTIALITY. "
        }), "\u201CConfidential Information\u201D means the terms of this Agreement and any and all information disclosed by or on behalf of one party or its affiliates to the other party or its affiliates, whether orally, in writing, or in any other form, which is either (a) marked or identified as \u201Cconfidential\u201D at the time of disclosure or (b) of a nature that a reasonable business person would expect to be confidential or proprietary, provided that the Disclosing Party generally treats it as confidential, including all technical, product, service, business, marketing, sales, order forms, financial and pricing information and data, techniques, methodologies, processes, algorithms, know-how, ideas, concepts, inventions, discoveries and trade secrets including product roadmaps, product designs, architecture, technology and technical information, however, disclosed. Receiving Party shall protect the Confidential Information of Disclosing Party with the same degree of care, but no less than a reasonable degree of care, to prevent unauthorized disclosure or use of Confidential Information, as Receiving Party exercise in protecting Receiving Party\u2019s own proprietary information."]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsxs("strong", {
          className: "text-underline",
          children: ["CONDITIONS OF PARTICIPATION.", ' ']
        }), "As a condition, and in consideration, of Your use of the Services, You agree to indemnify and hold harmless ACI and its affiliates, officers, directors, employees, subcontractors and their respective successors and assigns from any and all losses incurred by ACI that shall have been caused by or are related to (x) goods and/or services charged by You to any patient and/or (y) the damages, acts or omissions of You, Your affiliates, officers, directors, employees, subcontractors, and their respective successors, and/or (z) any breach by You (or any of Your affiliates, officers, directors, employees, subcontractors and their respective successors) of the operating procedures of any third-party providing patient financing."]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "GOVERNING LAW. "
        }), "This Agreement shall be governed by the laws of the State of California and any dispute between You and ACI shall be settled by binding arbitration in Orange County, California under the Rules of Comprehensive Arbitration before the Judicial Arbitration and Mediation Service (\u201CJAMS\u201D). The prevailing party shall be entitled to recover reasonable attorney\u2019s fees and costs."]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "GENERAL PROVISIONS. "
        }), jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              children: "RELATIONSHIP OF PARTIES."
            }), " You and ACI agree that in performing the responsibilities pursuant to this Agreement, you are independent parties. This Agreement is not intended to create, nor does it create, a partnership, joint venture, or any association for profit between You and ACI."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              children: "ASSIGNMENT."
            }), " This Agreement may not be assigned, in whole or in part, by either You or ACI without the prior written consent of the other party. This Agreement will be binding upon and will inure to the benefit of the parties and their representatives, respective successors, and permitted assigns."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              children: "WAIVERS."
            }), " Neither You nor ACI will be deemed to have waived any rights, powers, or remedies hereunder unless that party approves such waiver in writing. Any delay, waiver, or omission by a party to exercise any right or power arising from any breach or default in any of the terms, provisions, or covenants of this Agreement will not be construed to be a waiver by that party of any subsequent breach or default of the same or other terms, provisions, or covenants."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              children: "ENTIRE AGREEMENT; AMENDMENTS."
            }), " This Agreement, including any and all attachments hereto, constitutes the entire agreement between You and ACI relating to the Services, and all prior negotiations and understandings, either oral or written, are superseded hereby No modification or amendment of this Agreement will be effective unless and until set forth in writing and signed by You and ACI."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              children: "INSURANCE."
            }), " You shall maintain sufficient insurance coverage to reasonably protect ACI from any and all liabilities for which You have agreed to indemnify and hold harmless ACI. You shall choose the amount of coverage necessary to meet its obligations hereunder; however, the parties agree that such coverage would be sufficient to meet Your obligations under this Section 10(e) if it includes the following amounts: (i) General Liability: $1,000,000 for each occurrence; (ii) Professional Liability: $1,000,000 for each occurrence; and (iii) Fidelity Bond or Crime Insurance: $1,000,000."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              children: "COMPLIANCE WITH LAWS. "
            }), " Both You and ACI shall comply with all applicable laws and regulations in performing your obligations under this Agreement. Your compliance with applicable law includes, but is not limited to, not engaging in: (i) the sale of any illegal goods and/or services, (ii) the illegal sale of otherwise legal goods and/or services, and (iii) the unlicensed practice of any professional service."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              children: "SEVERABILITY."
            }), " If any provision of this Agreement or portion thereof is held invalid, illegal, void, or unenforceable by reason of any rule of law, administrative or judicial provision, or public policy, all other provisions of this Agreement will nevertheless remain in full force and effect to the extent such remaining provisions accurately reflect the intent of You and ACI."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              children: "ACI\u2019S RIGHT TO OFFSET."
            }), " If ACI is owed any amounts pursuant to this Agreement for more than fifteen (15) days after the due date, it shall, at its discretion, either (i) invoice You for the amount, which shall be paid within fifteen (15) days of receipt of invoice; or (ii) offset such amounts from any funds due to You from ACI, and/or against Your Bank Account(s)."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              children: "TAXES."
            }), " You will be responsible for, and agree to pay, all sales, use, excise, and value- added taxes, or taxes of a similar nature (excluding personal property taxes and taxes based on ACI\u2019s income which shall be borne by ACI), imposed by the United States, any state or local government, or other taxing authority, on all services provided by ACI or its Partners under this Agreement. The parties agree to cooperate with each other to minimize any applicable sales, use, or similar tax and, in connection therewith, the parties shall provide each other with any relevant tax information as reasonably requested (including without limitation, resale or exemption certificates, multi-state exemption certificates, information concerning the use of assets, materials and notices of assessments). All amounts set forth in this Agreement are expressed and shall be paid in lawful U.S. dollars."]
          }), jsxRuntimeExports.jsxs("li", {
            className: "lower-alpha",
            children: [jsxRuntimeExports.jsx("strong", {
              children: "YOUR NOTICES OF CHANGES. "
            }), " You shall, as soon as possible, notify ACI of any: (a) change in Your name, tax identification number, or form of business organization, change in the location of Your chief executive office or the location of the office where Your records concerning the Services are kept; (b) Your merger or consolidation, the sale of a significant portion of Your stock (or other form of ownership) or the sale of a substantial amount of Your assets not in the ordinary course of business, or any change in the control of You; (c) material adverse change in Your financial condition or operations; (d) the planned opening or closing of any Sales Channels (including individual locations); (e) any change in Your business practices that would have a material adverse effect on this Agreement or the Services; or (f) any occurrence that would trigger ACI\u2019s termination rights under this Agreement."]
          })]
        })]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "RECORDS, AUDITS AND ACCESS."
        }), jsxRuntimeExports.jsxs("ol", {
          className: "paragraph-list terms-list",
          children: [jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Pursuant to Applicable Law, including but not limited to financial privacy regulations, You will keep and maintain at its principal place of business appropriate books and records relating to its activities under this Agreement for a minimum of seven (7) years after their creation. You will permit, once a year, unless ACI has reasonable cause to do so more than once, authorized representatives designated by ACI, at ACI\u2019s expense, to visit its facilities and inspect its books and records pertaining to applicants, accounts, transaction records and any category of payments owed, and to make copies and take extracts there from, and to discuss the same with ACI\u2019s representatives, all at reasonable times during normal business hours. Additionally, You shall permit regulatory bodies having jurisdiction over ACI or its Partners to visit its facilities and inspect records related to the Services and will reasonably cooperate in responding to inquiries by any such regulatory bodies relating to the Services."
          }), jsxRuntimeExports.jsx("li", {
            className: "lower-alpha",
            children: "Upon request, You shall furnish to ACI the following information pertaining to You (on a consolidated basis if applicable): (i) a balance sheet as of the close of each fiscal quarter; (ii) a statement of income, retained earnings, and paid-in capital as of the close of each fiscal quarter; (iii) a statement of cash flow to the close of each such period; and (iv) a copy of the opinion submitted by Your independent certified public accountants in connection with such of the financial statements as have been audited. If such financial statements are not available, You shall provide to ACI Your most recent annual tax filing. You shall provide additional financial information as reasonably requested by ACI."
          })]
        })]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "CALL RECORDING. "
        }), "ACI may as permitted by applicable law, but shall not be obligated to, tape or otherwise record telephone conversations and electronic communications between ACI and You, Your users and administrators, or any authorized representative, without notice by ACI to any of the foregoing. You assume responsibility for obtaining any necessary consents of, and giving notice to, any of your personnel, users, administrators, or any authorize representative thereof."]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "CHANGES. "
        }), "ACI may modify these Terms and Conditions from time to time, in which case ACI will update the \u201CLast Revised\u201D date at the top of these Terms and Conditions. If ACI makes changes that are material, we will notify You by email. However, it is Your sole responsibility to review these Terms and Conditions from time to time to view any such changes at www.myalphaeoncredit.com/enroll. The updated Terms and Conditions will be effective not less than 30 days after we provide notice to You; Your continued use of the Program will be Your consent to the revised Terms and Conditions."]
      }), jsxRuntimeExports.jsxs("li", {
        className: "decimal",
        children: [jsxRuntimeExports.jsx("strong", {
          className: "text-underline",
          children: "ENTIRE AGREEMENT. "
        }), "The Agreement constitutes the complete understanding between ACI and You with respect to the Services and supersedes all other prior agreements, whether written or oral, between You and ACI with respect thereto. The Agreement cannot be amended unless in writing signed by authorized representatives of both ACI and You. ACI and You hereby agree if any provision, or any portion of a provision, of this Agreement is held to be invalid or unenforceable, all other provisions shall nevertheless continue in full force and effect. Any provision of this Agreement held invalid or unenforceable only in part or degree, shall remain in full force and effect to the extent not held invalid or unenforceable."]
      })]
    }), jsxRuntimeExports.jsx("p", {
      children: "REVISED 2/16/2026"
    })]
  });
}
var TermsAndConditions_default = /*#__PURE__*/memo(TermsAndConditions);

function TermsOfUse() {
  return jsxRuntimeExports.jsxs("div", {
    className: "page-container",
    children: [jsxRuntimeExports.jsx(H1, {
      className: "page-title font-bold text-underline",
      children: "TERMS OF USE"
    }), jsxRuntimeExports.jsx(H4, {
      className: "section-title",
      children: "Effective Date: June 11, 2025"
    }), jsxRuntimeExports.jsxs(P, {
      className: "paragraph-basic",
      children: ["Alphaeon Credit, Inc. (\"Alphaeon\", \"our\", \"us\", or \"we\") grants you access to our website located at", ' ', jsxRuntimeExports.jsx("a", {
        href: "https://goalphaeon.com/",
        target: "_blank",
        rel: "noopener noreferrer",
        className: "terms-link",
        children: "https://goalphaeon.com/"
      }), ' ', "(the \"Website\") conditioned on your acceptance of these Terms of Use (these \"Terms of Use\")."]
    }), jsxRuntimeExports.jsxs(P, {
      className: "paragraph-basic",
      children: [jsxRuntimeExports.jsx("strong", {
        children: "PLEASE READ THESE TERMS OF USE CAREFULLY."
      }), " THESE TERMS OF USE CONSTITUTE A LEGALLY BINDING AGREEMENT BETWEEN YOU AND US, AND BY USING THE WEBSITE, YOU AGREE TO BE BOUND AND ABIDE BY THESE TERMS OF USE. IF YOU DO NOT AGREE TO THESE TERMS OF USE, YOU MUST CEASE USING THE WEBSITE IMMEDIATELY."]
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Binding Arbitration"
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "These Terms of Use provide that all disputes between you and us will be resolved by BINDING ARBITRATION. ACCORDINGLY, YOU AGREE TO GIVE UP YOUR RIGHT TO GO TO COURT (INCLUDING IN A CLASS ACTION PROCEEDING) to assert or defend your rights under these Terms of Use (except for matters that may be taken to small claims court). Your rights will be determined by a NEUTRAL ARBITRATOR and NOT a judge or jury and your claims cannot be brought as a class action. Please review the section of these Terms of Use titled \"Dispute Resolution; Arbitration Agreement\" for the details regarding your agreement to arbitrate any disputes with us."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Accessing the Website"
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "Subject to these Terms of Use, Alphaeon grants you a limited, nonexclusive, nontransferable, non-sublicensable license to access our Website for your personal, non-commercial use."
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "You will need a working connection to the Internet via a web browser on your computer for which you are responsible for all costs, expenses, and fees. From time to time, due to the performance of maintenance, malfunctions or failures of software, equipment, or telecommunications devices, unusual transaction volume, or similar reasons the Website may not be available for your use. We minimize the periods of time during which Website is unavailable, but we are not responsible for your inability to access the Website caused directly or indirectly, in whole or in part, by your computer or mobile device, your inability to establish a connection to the Internet, your Internet Service Provider (\"ISP\"), or capacity or other limitations or constraints of the Internet."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Access Restrictions"
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "The Website is not intended for use by persons in any jurisdiction or country where such use would be contrary to applicable laws or regulations. We reserve the right to restrict your access to the Website during times you are in a country outside of the United States. You are responsible for compliance with all local and state laws."
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "The Website is intended only for persons who have reached the age of majority in their state of residence. The Website is not intended to be accessed by children."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Modifications to These Terms of Use and Website"
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "We reserve the right, in our sole discretion, to modify these Terms of Use at any time without notice to you. We will post all modifications to these Terms of Use on the Website and they will become effective immediately upon being posted to the Website. Your continued use of the Website following the posting of such modifications constitutes your acceptance of them. Therefore, you should check the Effective Date of these Terms of Use each time that you visit the Website and review any modifications made since the last time that you visited it."
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "We also reserve the right to terminate, change, suspend or discontinue any aspect of the Website at any time without notice to you."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Privacy Policy"
    }), jsxRuntimeExports.jsxs(P, {
      className: "paragraph-basic",
      children: ["We will treat all personal information that you choose to provide to us through the Website in accordance with our", ' ', jsxRuntimeExports.jsx("a", {
        href: makePath(PATH.LEGAL, PATH.CONSUMER_FINANCIAL_PRIVACY_POLICY),
        target: "_blank",
        rel: "noopener noreferrer",
        className: "terms-link",
        children: "privacy policy"
      }), ' ', "(the \"Privacy Policy\"), which is incorporated by reference into these Terms of Use. By using the Website, you consent to the privacy practices set forth in the Privacy Policy."]
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "If you use the Website to apply for a financial product or service, any \"nonpublic personal information\" (as such term is defined under the Gramm-Leach-Bliley Act) collected from or provided by you in connection with such financial product or service will be used and disclosed in accordance with the Privacy Notice of the financial institution providing the product or service. Please see the Privacy Notice of the applicable financial institution to learn how the financial institution uses your nonpublic personal information."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Proprietary Materials"
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "The Website contains forms, content, information, trademarks and other proprietary materials that belong to us and our licensors and that are protected by copyright, trademark, and other intellectual property laws (collectively, \"Proprietary Materials\")."
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "You should assume that everything on the Website is Proprietary Materials, and, except as otherwise explicitly provided on certain Proprietary Materials that you may access through the Website, you shall not reproduce, distribute, publicly display, publicly perform, prepare derivative works of, or otherwise use or exploit Proprietary Materials in any way without our prior written consent. Commercial use of Proprietary Materials is strictly prohibited. All rights not expressly granted herein are reserved to us and our licensors."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Restrictions"
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "You agree that you will not yourself or through any third party: (i) use the Website in a manner that violates applicable laws or the rights of third parties, including intellectual property laws and third-party rights with respect thereto; (ii) engage in any conduct that restricts or inhibits anyone's use or enjoyment of the Website or which may harm us or other users of the Website; (iii) violate the security of the Website, including by using any device, software, or routine that interferes with the proper functioning of the Website, accessing or attempting to access any systems or servers on which the Website is hosted, modifying or altering the Website in any way or forging headers, misrepresenting your identity, or otherwise manipulating identifiers to deceive others; (iv) use automated data extraction tools or manual processes to extract Proprietary Materials from the Website; (v) except as otherwise explicitly provided on certain Proprietary Materials that you may access through the Website, remove, conceal, or alter any identification, copyright, or other proprietary rights notices or labels on the Website or Proprietary Materials; or (vi) otherwise engage in any objectionable conduct, which shall be determined in our sole discretion."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Security"
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "We take commercially reasonable measure to protect the Website, but no online services can guarantee 100% security. If you submit any personal information to us through this Website, you understand that there are risks associated with communicating online, including the possibility of unauthorized access, such as when electronic communications are misdirected or intercepted. For security reasons, we may require you to authenticate your identity (i.e., prove that you are who you say you are) to conduct certain transactions on our Website. If you believe that information that you have submitted through the Website has been used without your permission, you must notify us immediately."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Third-Party Websites"
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "We may include links on the Website to third-party websites that we do not control or operate (each, a \"Third-Party Website\"). We are not responsible for any information, content, advertising, products, services, or other materials on any Third-Party Website, and the presence of such links does not constitute our endorsement, approval, or sponsorship of any Third-Party Website. If you choose to visit any Third-Party Website, you are doing so at your own risk, and you will be subject to the Terms of Use of that website. Therefore, before interacting with any Third-Party Website, you should consult the legal terms governing the use of such Third-Party Website. We expressly disclaim any and all liability resulting from your use of any Third-Party Website."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Disclaimer"
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "THE WEBSITE AND PROPRIETARY MATERIALS ARE PROVIDED \"AS-IS\", \"WHERE-IS\" AND \"AS-AVAILABLE,\" WITH ALL FAULTS AND WITHOUT WARRANTIES OF ANY KIND. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, ALPHAEON HEREBY EXPRESSLY DISCLAIMS ON BEHALF OF OURSELVES AND OUR OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SERVICE PROVIDERS, AND FINANCING PARTNERS (COLLECTIVELY, THE \"ALPHAEON PARTIES\") ANY AND ALL WARRANTIES OF ANY KIND, EXPRESS, IMPLIED, OR STATUTORY, INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. NEITHER ALPHAEON NOR ANY OF THE ALPHAEON PARTIES REPRESENTS OR WARRANTS THAT THE WEBSITE WILL BE ERROR-FREE, THAT DEFECTS, IF ANY, WILL BE CORRECTED, OR THAT THE WEBSITE IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS; NOR DOES ALPHAEON OR ANY OF THE ALPHAEON PARTIES MAKE ANY REPRESENTATIONS OR WARRANTIES ABOUT THE ACCURACY, COMPLETENESS, RELIABILITY, TIMELINESS, QUALITY, PERFORMANCE, OR SUITABILITY OF THE WEBSITE OR PROPRIETARY MATERIALS."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Limitation of Liability"
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL ALPHAEON OR ANY OF THE ALPHAEON PARTIES BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY (I) CONSEQUENTIAL, INCIDENTAL, EXEMPLARY, PUNITIVE, INDIRECT, OR SPECIAL DAMAGES OF ANY NATURE ARISING FROM BREACH OF WARRANTY, BREACH OF CONTRACT, NEGLIGENCE, OR ANY OTHER LEGAL THEORY, WHETHER IN TORT OR CONTRACT, EVEN IF SUCH PARTY HAS BEEN APPRISED OF THE LIKELIHOOD OF SUCH DAMAGES OCCURRING OR (II) DIRECT DAMAGES IN EXCESS OF ONE ($1) U.S. DOLLAR."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Indemnification"
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "You shall indemnify, defend, and hold harmless Alphaeon and the Alphaeon Parties from and against any and all claims, actions, damages, obligations, losses, liabilities, costs, and expenses (including reasonable attorneys' fees, costs of collection, and other costs of defense) arising out of or relating to your use of the Website or Proprietary Materials or your violation of these Terms of Use."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Termination / Suspension"
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "We may, without notice to you, immediately terminate or suspend your license to access the Website, including in the event that you breach these Terms of Use or engage in conduct that we, in our sole discretion, believe is in violation of applicable law or our rights or the rights of other users of the Website. Upon termination of your license, your right to use the Website and Proprietary Materials will immediately terminate."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Complete Agreement"
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "These Terms of Use and the Privacy Policy constitute the entire agreement between you and us with respect to the subject matter hereof and thereof and supersede all prior and contemporaneous agreements, whether oral or written, between us and you with respect to the same."
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "No failure, omission, or delay on our part to exercise any right under these Terms of Use will preclude any other further exercise of that right or other right under these Terms of Use."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Dispute Resolution; Arbitration Agreement"
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "We and you agree that all disputes arising from or relating to the Website or any relationship or dispute between you and us or you and any company or person employed by us, these Terms of Use, and any policies or practices of any of the above-mentioned companies or persons (a \"Dispute\") will only be resolved subject to FINAL AND BINDING ARBITRATION as set forth in this section, and may only be resolved through an individual arbitration governed by the Federal Arbitration Act to the maximum extent permitted by applicable law. You further agree that we shall not have a legal obligation to mitigate any of your potential or actual losses sustained hereunder."
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "WE AND YOU GIVE UP OUR RESPECTIVE RIGHTS TO GO TO COURT IN CONNECTION WITH ANY DISPUTE AND SUCH RIGHTS WILL BE DETERMINED BY A NEUTRAL ARBITRATOR, NOT A JUDGE OR JURY. NEITHER WE NOR YOU SHALL BRING OR PARTICIPATE IN ANY CLASS ACTION OR OTHER CLASS PROCEEDING IN CONNECTION WITH ANY DISPUTE. NEITHER WE NOR YOU AGREE TO CLASS ARBITRATION OR ANY OTHER ARBITRATION PROCEEDINGS WHERE A PERSON BRINGS A DISPUTE AS A REPRESENTATIVE OF OTHER PERSONS."
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "If we and you are unable to resolve a Dispute by informal means, the arbitration of that Dispute will be administered by the American Arbitration Association (AAA) in California in accordance with the Commercial Arbitration Rules. Any proceeding to enforce this arbitration agreement must be brought in the U.S. District Court, Central District of California or in any California state court of competent jurisdiction with venue lying in Orange County to the exclusion of all other forums."
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "Notwithstanding the foregoing, for disputes related to a financial product or service you apply for through the Website, please see the agreement that governs such financial product or service to obtain information regarding your dispute resolution rights and obligations."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Governing Law"
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "All Disputes will be governed by and construed in accordance with the laws of California without reference to the choice of law provisions of any jurisdiction."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Severability"
    }), jsxRuntimeExports.jsx(P, {
      className: "paragraph-basic",
      children: "If any provision of these Terms of Use is found to be invalid or unenforceable by a court of competent jurisdiction, the invalid or unenforceable provision will be deemed superseded by a valid and enforceable provision that most closely matches the intent of the original provision, and the remainder of these Terms of Use will remain in full force and effect."
    }), jsxRuntimeExports.jsx(H2, {
      className: "section-title",
      children: "Contact Us"
    }), jsxRuntimeExports.jsxs(P, {
      className: "paragraph-basic",
      children: ["If you have any questions about these Terms of Use, please contact us at", ' ', jsxRuntimeExports.jsx("a", {
        href: "mailto:privacy@alphaeoncredit.com",
        className: "terms-link",
        children: "privacy@alphaeoncredit.com"
      }), "."]
    })]
  });
}
var TermsOfUse_default = /*#__PURE__*/memo(TermsOfUse);

function WebsiteTermsOfUse() {
  return jsxRuntimeExports.jsxs("div", {
    className: "page-container",
    children: [jsxRuntimeExports.jsx("h4", {
      className: "page-title font-bold text-underline",
      children: "TERMS OF USE"
    }), jsxRuntimeExports.jsxs("h4", {
      className: "section-title",
      children: [jsxRuntimeExports.jsx("strong", {
        children: "Effective Date:"
      }), " June 1, 2022"]
    }), jsxRuntimeExports.jsxs("p", {
      className: "paragrahp-basic",
      children: ["Alphaeon Credit, Inc. (\u201CAlphaeon\u201D, \u201Cour\u201D, \u201Cus\u201D, or \u201Cwe\u201D) grants you access to our website located at", ' ', jsxRuntimeExports.jsx("a", {
        href: "https://goalphaeon.com/",
        target: "_blank",
        rel: "noreferrer",
        className: "terms-link",
        children: "https://goalphaeon.com/"
      }), ' ', "(the \u201CWebsite\u201D) conditioned on your acceptance of these Terms of Use (these \u201CTerms of Use\u201D)."]
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "PLEASE READ THESE TERMS OF USE CAREFULLY. THESE TERMS OF USE CONSTITUTE A LEGALLY BINDING AGREEMENT BETWEEN YOU AND US, AND BY USING THE WEBSITE, YOU AGREE TO BE BOUND AND ABIDE BY THESE TERMS OF USE. IF YOU DO NOT AGREE TO THESE TERMS OF USE, YOU MUST CEASE USING THE WEBSITE IMMEDIATELY."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Binding Arbitration"
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "These Terms of Use provide that all disputes between you and us will be resolved by BINDING ARBITRATION. ACCORDINGLY, YOU AGREE TO GIVE UP YOUR RIGHT TO GO TO COURT (INCLUDING IN A CLASS ACTION PROCEEDING) to assert or defend your rights under these Terms of Use (except for matters that may be taken to small claims court). Your rights will be determined by a NEUTRAL ARBITRATOR and NOT a judge or jury and your claims cannot be brought as a class action. Please review the section of these Terms of Use titled \u201CDispute Resolution; Arbitration Agreement\u201D for the details regarding your agreement to arbitrate any disputes with us."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Accessing the Website"
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "Subject to these Terms of Use, Alphaeon grants you a limited, nonexclusive, nontransferable, non-sublicensable license to access our Website for your personal, non-commercial use."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "You will need a working connection to the Internet via a web browser on your computer for which you are responsible for all costs, expenses, and fees. From time to time, due to the performance of maintenance, malfunctions or failures of software, equipment, or telecommunications devices, unusual transaction volume, or similar reasons the Website may not be available for your use. We minimize the periods of time during which Website is unavailable, but we are not responsible for your inability to access the Website caused directly or indirectly, in whole or in part, by your computer or mobile device, your inability to establish a connection to the Internet, your Internet Service Provider (\u201CISP\u201D), or capacity or other limitations or constraints of the Internet."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Access Restrictions"
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "The Website is not intended for use by persons in any jurisdiction or country where such use would be contrary to applicable laws or regulations. We reserve the right to restrict your access to the Website during times you are in a country outside of the United States. You are responsible for compliance with all local laws."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "The Website is intended only for persons who have reached the age of majority in their state of residence. The Website is not intended to be accessed by children."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Modifications to These Terms of Use and Website"
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "We reserve the right, in our sole discretion, to modify these Terms of Use at any time without notice to you. We will post all modifications to these Terms of Use on the Website and they will become effective immediately upon being posted to the Website. Your continued use of the Website following the posting of such modifications constitutes your acceptance of them. Therefore, you should check the Effective Date of these Terms of Use each time that you visit the Website and review any modifications made since the last time that you visited it."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "We also reserve the right to terminate, change, suspend or discontinue any aspect of the Website at any time without notice to you."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Privacy Policy"
      })
    }), jsxRuntimeExports.jsxs("p", {
      className: "paragraph-basic",
      children: ["We will treat all personal information that you choose to provide to us through the Website in accordance with our privacy policy located at", jsxRuntimeExports.jsx("a", {
        href: PATH.PRIVACY_POLICY,
        children: "(the \u201CPrivacy Policy\u201D)"
      }), ", which is incorporated by reference into these Terms of Use. By using the Website, you consent to the privacy practices set forth in the Privacy Policy."]
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Proprietary Materials"
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "The Website contains forms, content, information, trademarks and other proprietary materials that belong to us and our licensors and that are protected by copyright, trademark, and other intellectual property laws (collectively, \u201CProprietary Materials\u201D)."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "You should assume that everything on the Website is Proprietary Materials, and, except as otherwise explicitly provided on certain Proprietary Materials that you may access through the Website, you shall not reproduce, distribute, publicly display, publicly perform, prepare derivative works of, or otherwise use or exploit Proprietary Materials in any way without our prior written consent. Commercial use of Proprietary Materials is strictly prohibited. All rights not expressly granted herein are reserved to us and our licensors."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Restrictions"
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "You agree that you will not yourself or through any third party: (i) use the Website in a manner that violates applicable laws or the rights of third parties, including intellectual property laws and third-party rights with respect thereto; (ii) engage in any conduct that restricts or inhibits anyone\u2019s use or enjoyment of the Website or which may harm us or other users of the Website; (iii) violate the security of the Website, including by using any device, software, or routine that interferes with the proper functioning of the Website, accessing or attempting to access any systems or servers on which the Website is hosted, modifying or altering the Website in any way or forging headers, misrepresenting your identity, or otherwise manipulating identifiers to deceive others; (iv) use automated data extraction tools or manual processes to extract Proprietary Materials from the Website; (v) except as otherwise explicitly provided on certain Proprietary Materials that you may access through the Website, remove, conceal, or alter any identification, copyright, or other proprietary rights notices or labels on the Website or Proprietary Materials; or (vi) otherwise engage in any objectionable conduct, which shall be determined in our sole discretion."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Security"
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "We take commercially reasonable measure to protect the Website, but not online services can guarantee 100% security. If you submit any personal information to us through this Website, you understand that there are risks associated with communicating online, including the possibility of unauthorized access, such as when electronic communications being misdirected or intercepted. For security reasons, we may require you to authenticate your identity (i.e., prove that you are who you say you are) to conduct certain transactions on our Website. If you believe that information that you have submitted through the Website has been used without your permission, you must notify us immediately."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Third-Party Websites"
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "We may include links on the Website to third-party websites that we do not control or operate (each, a \u201CThird-Party Website\u201D). We are not responsible for any information, content, advertising, products, services, or other materials on any Third-Party Website, and the presence of such links does not constitute our endorsement, approval, or sponsorship of any Third-Party Website. If you choose to visit any Third-Party Website, you are doing so at your own risk, and you will be subject to the Terms of Use of that website. Therefore, before interacting with any Third-Party Website, you should consult the legal terms governing the use of such Third-Party Website. We expressly disclaim any and all liability resulting from your use of any Third-Party Website."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Disclaimer"
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "THE WEBSITE AND PROPRIETARY MATERIALS ARE PROVIDED \u201CAS-IS\u201D, \u201CWHERE-IS\u201D AND \u201CAS-AVAILABLE,\u201D WITH ALL FAULTS AND WITHOUT WARRANTIES OF ANY KIND. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, ALPHAEON HEREBY EXPRESSLY DISCLAIMS ON BEHALF OF OURSELVES AND OUR OFFICERS, DIRECTORS, EMPLOYEES, AND AGENTS (COLLECTIVELY, THE \u201CALPHAEON PARTIES\u201D) ANY AND ALL WARRANTIES OF ANY KIND, EXPRESS, IMPLIED, OR STATUTORY, INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. NEITHER ALPHAEON NOR ANY OF THE ALPHAEON PARTIES REPRESENTS OR WARRANTS THAT THE WEBSITE WILL BE ERROR-FREE, THAT DEFECTS, IF ANY, WILL BE CORRECTED, OR THAT THE WEBSITE IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS; NOR DOES ALPHAEON OR ANY OF THE ALPHAEONPARTIES MAKE ANY REPRESENTATIONS OR WARRANTIES ABOUT THE ACCURACY, COMPLETENESS, RELIABILITY, TIMELINESS, QUALITY, PERFORMANCE, OR SUITABILITY OF THE WEBSITE OR PROPRIETARY MATERIALS."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Limitation of Liability"
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL ALPHAEON OR ANY OF THE ALPHAEON PARTIES BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY (I) CONSEQUENTIAL, INCIDENTAL, EXEMPLARY, PUNITIVE, INDIRECT, OR SPECIAL DAMAGES OF ANY NATURE ARISING FROM BREACH OF WARRANTY, BREACH OF CONTRACT, NEGLIGENCE, OR ANY OTHER LEGAL THEORY, WHETHER IN TORT OR CONTRACT, EVEN IF SUCH PARTY HAS BEEN APPRISED OF THE LIKELIHOOD OF SUCH DAMAGES OCCURRING OR (II) DIRECT DAMAGES IN EXCESS OF ONE ($1) U.S. DOLLAR."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Indemnification"
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "You shall indemnify, defend, and hold harmless Alphaeon and the Alphaeon Parties from and against any and all claims, actions, damages, obligations, losses, liabilities, costs, and expenses (including reasonable attorneys\u2019 fees, costs of collection, and other costs of defense) arising out of or relating to your use of the Website or Proprietary Materials or your violation of these Terms of Use."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Termination / Suspension"
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "We may, without notice to you, immediately terminate or suspend your license to access the Website, including in the event that you breach these Terms of Use or engage in conduct that we, in our sole discretion, believe is in violation of applicable law or our rights or the rights of other users of the Website. Upon termination of your license, your right to use the Website and Proprietary Materials will immediately terminate."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Complete Agreement"
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "These Terms of Use and the Privacy Policy constitute the entire agreement between you and us with respect to the subject matter hereof and thereof and supersede all prior and contemporaneous agreements, whether oral or written, between us and you with respect to the same."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "No failure, omission, or delay on our part to exercise any right under these Terms of Use will preclude any other further exercise of that right or other right under these Terms of Use."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Dispute Resolution; Arbitration Agreement "
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "We and you agree that all disputes arising from or relating to the Website or any relationship or dispute between you and us or you and any company or person employed by us, these Terms of Use, and any policies or practices of any of the above-mentioned companies or persons (a \u201CDispute\u201D) will only be resolved subject to FINAL AND BINDING ARBITRATION as set forth in this section, and may only be resolved through an individual arbitration governed by the Federal Arbitration Act to the maximum extent permitted by applicable law. You further agree that we shall not have a legal obligation to mitigate any of your potential or actual losses sustained hereunder."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "WE AND YOU GIVE UP OUR RESPECTIVE RIGHTS TO GO TO COURT in connection with any Dispute and such rights will be determined by a NEUTRAL ARBITRATOR, NOT A JUDGE OR JURY. NEITHER WE NOR YOU SHALL BRING OR PARTICIPATE IN ANY CLASS ACTION OR OTHER CLASS PROCEEDING IN CONNECTION WITH ANY DISPUTE. Neither we nor you agree to class arbitration or any other arbitration proceedings where a person brings a dispute as a representative of other persons."
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "If we and you are unable to resolve a Dispute by informal means, the arbitration of that Dispute will be administered by the American Arbitration Association (AAA) in California in accordance with the Commercial Arbitration Rules. Any proceeding to enforce this arbitration agreement must be brought in the U.S. District Court, Central District of California or in any California state court of competent jurisdiction with venue lying in Orange County to the exclusion of all other forums."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Governing Law"
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "All Disputes will be governed by and construed in accordance with the laws of California without reference to the choice of law provisions of any jurisdiction."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Severability"
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "If any provision of these Terms of Use is found to be invalid or unenforceable by a court of competent jurisdiction, the invalid or unenforceable provision will be deemed superseded by a valid and enforceable provision that most closely matches the intent of the original provision, and the remainder of these Terms of Use will remain in full force and effect."
    }), jsxRuntimeExports.jsx("h4", {
      className: "section-title",
      children: jsxRuntimeExports.jsx("strong", {
        children: "Contact Us"
      })
    }), jsxRuntimeExports.jsx("p", {
      className: "paragraph-basic",
      children: "If you have any questions about these Terms of Use, please contact us at privacy@alphaeoncredit.com."
    })]
  });
}
var WebsiteTermsOfUse_default = /*#__PURE__*/memo(WebsiteTermsOfUse);

function WirelessCarrier() {
  return jsxRuntimeExports.jsxs("div", {
    className: "page-container",
    children: [jsxRuntimeExports.jsx("h4", {
      className: "page-title",
      children: "Wirelesss Carrier Disclosure"
    }), jsxRuntimeExports.jsxs("p", {
      className: "paragraph-basic",
      children: ["You authorize your wireless carrier to use or disclose information about your account and your wireless device, if available, to Alphaeon Credit or its service provider for the duration of your business relationship, solely to help them identify you or your wireless device and to prevent fraud. See our", ' ', jsxRuntimeExports.jsx(Link, {
        to: "/legal/privacy-policy",
        className: "terms-link font-weight-400",
        children: "Privacy Policy"
      }), ' ', "for how we treat your data."]
    })]
  });
}
var WirelessCarrier_default = /*#__PURE__*/memo(WirelessCarrier);

function Routes$1() {
  const {
    path
  } = useRouteMatch();
  return jsxRuntimeExports.jsx(Layout$1, {
    children: jsxRuntimeExports.jsxs(Switch, {
      children: [jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.ROOT),
        children: jsxRuntimeExports.jsx(Legals, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.ADVANTAGE_DISCLOSURE),
        children: jsxRuntimeExports.jsx(AdvantageDisclosure, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.CA_PRIVACY_NOTICE),
        children: jsxRuntimeExports.jsx(CAPrivacyNotice_default, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.COMENITY_CAPITAL_PREQUALIFICATION_TERMS),
        children: jsxRuntimeExports.jsx(ComenityCapitalPrequalificationTerms_default, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.CONSENT_AUTODIALED),
        children: jsxRuntimeExports.jsx(ConsentAutodialed, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.CONSENT_ELECTRONIC_DISCLOSURES),
        children: jsxRuntimeExports.jsx(ConsentElectronicDisclosures, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.CONSUMER_FINANCIAL_PRIVACY_POLICY),
        children: jsxRuntimeExports.jsx(ConsumerFinancialPrivacyPolicy_default, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.CREDIT_REPORT_AUTHORIZATION),
        children: jsxRuntimeExports.jsx(CreditReportAuthorization, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.PREQUALIFICATION_TERMS),
        children: jsxRuntimeExports.jsx(PrequalificationTerms, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.PRIVACY_POLICY),
        children: jsxRuntimeExports.jsx(TermsOfUse_default, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.TERMS_OF_USE),
        children: jsxRuntimeExports.jsx(TermsOfUse_default, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.WEBSITE_TERMS_OF_USE),
        children: jsxRuntimeExports.jsx(WebsiteTermsOfUse_default, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.TERMS_AND_CONDITIONS),
        children: jsxRuntimeExports.jsx(TermsAndConditions_default, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.PRIVATE_LABEL_TERMS),
        children: jsxRuntimeExports.jsx(PrivateLabelTerms, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.WIRELESS_CARRIER_TERMS),
        children: jsxRuntimeExports.jsx(WirelessCarrier_default, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.PARTNERS),
        children: jsxRuntimeExports.jsx(Partners, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.FINANCING_PARTNERS),
        children: jsxRuntimeExports.jsx(FinancingPartners, {})
      }), jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.RIC_MERCHANT_AGREEMENT),
        children: jsxRuntimeExports.jsx(FlexRicMerchantAgreement_default, {})
      })]
    })
  });
}

function LongLinkFetcher() {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const id = location.pathname.split('/')[2];
  const createOtlToken = async (storeLinkCampaign, storeId, locationId) => {
    return fetch(`${REACT_APP_API_URL}/consumer_applications/v1/link/otl/generate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        store_link_campaign: storeLinkCampaign,
        store_id: storeId,
        location_id: locationId
      })
    }).then(res => {
      return res.json();
    }).then(data => {
      return data.token;
    });
  };
  const handleSpecialResponses = async response => {
    if (response.long_link.includes('store_link_campaign')) {
      try {
        const url = new URL(response.long_link);
        const campaign = url.searchParams.get('store_link_campaign');
        const storeIdMatch = response.long_link.match(/store\/([^?]+)/);
        const storeId = storeIdMatch ? storeIdMatch[1] : '';
        const locationIdMatch = response.long_link.match(/location\/([^?]+)/);
        const locationId = locationIdMatch ? locationIdMatch[1] : '';
        if (campaign) {
          const otlToken = await createOtlToken(campaign, storeId, locationId);
          return appendOtlToLongLink(response.long_link, otlToken);
        } else {
          return response.long_link;
        }
      } catch (e) {
        setError('Error extracting campaign data from URL:');
        return response.long_link;
      }
    } else {
      return response.long_link;
    }
  };
  const appendOtlToLongLink = (longLink, otl) => {
    try {
      const url = new URL(longLink);
      url.searchParams.append('otl', otl);
      return url.toString();
    } catch (e) {
      // If URL parsing fails, return the original URL with a simple parameter append
      if (longLink.includes('?')) {
        return `${longLink}&otl=${otl}`;
      } else {
        return `${longLink}?otl=${otl}`;
      }
    }
  };
  useEffect(() => {
    if (response && new Date(response.expires_at).getTime() > Date.now()) {
      handleSpecialResponses(response).then(longLink => {
        window.location.assign(longLink);
      }).catch(err => {
        setError('Error handling special response:' + err);
        window.location.assign(response.long_link); // Fallback to original link
      });
    } else if (response) {
      setError('The link you tried to access is either invalid or expired.');
    }
  }, [response]);
  useEffect(() => {
    fetch(`${REACT_APP_API_URL}/consumer_applications/v1/link/fetch`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        short_link: id
      })
    }).then(res => {
      return res.json();
    }).then(data => {
      setResponse(data);
    }).catch(() => {
      setError('The link you tried to access is either invalid or expired.');
    }).finally(() => {
      setLoading(false);
    });
  }, []);
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [loading && jsxRuntimeExports.jsx(Spinner, {}), error && jsxRuntimeExports.jsx(CustomErrorPage, {
      title: "Invalid Link Error",
      description: `Oops there appears to be a problem. ${error}`
    })]
  });
}

function Layout({
  children
}) {
  return jsxRuntimeExports.jsx("div", {
    children: children
  });
}

var img$4 = "data:image/svg+xml,%3csvg width='165' height='44' viewBox='0 0 165 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M16.896 29.9289C16.896 31.3809 15.9236 32.1993 14.1592 32.1993H9.98362V34.8437H8.58002V27.6497H14.3924C15.9236 27.6497 16.896 28.5517 16.896 29.9289ZM15.4572 29.9509C15.4572 29.2381 15.026 28.9213 14.102 28.9213H9.98362V30.9189H14.1812C15.0216 30.9189 15.4572 30.5801 15.4572 29.9465V29.9509Z' fill='%23919191'/%3e%3cpath d='M24.9172 34.8393L24.0856 33.2949H19.2544L18.4228 34.8393H16.8784L20.7944 27.6453H22.5368L26.4528 34.8393H24.9084H24.9172ZM21.6788 28.8377L19.9584 32.0189H23.386L21.6788 28.8377Z' fill='%23919191'/%3e%3cpath d='M30.58 28.9213V34.8393H29.1764V28.9213H25.74V27.6453H34.0208V28.9213H30.58Z' fill='%23919191'/%3e%3cpath d='M35.8864 34.8393V27.6453H37.29V34.8393H35.8864Z' fill='%23919191'/%3e%3cpath d='M40.216 34.8393V27.6453H47.6916V28.9213H41.6196V30.4657H45.8436V31.7417H41.6196V33.5677H47.96V34.8437H40.216V34.8393Z' fill='%23919191'/%3e%3cpath d='M56.5312 34.8393L51.6428 28.8377V34.8393H50.2392V27.6453H52.3336L57.222 33.6469V27.6453H58.6256V34.8393H56.5312Z' fill='%23919191'/%3e%3cpath d='M65.3356 28.9213V34.8393H63.932V28.9213H60.4956V27.6453H68.7764V28.9213H65.3356Z' fill='%23919191'/%3e%3cpath d='M76.142 28.9213V30.4657H80.366V31.7417H76.142V34.8393H74.7384V27.6453H82.2096V28.9213H76.1376H76.142Z' fill='%23919191'/%3e%3cpath d='M84.084 34.8393V27.6453H85.4876V34.8393H84.084Z' fill='%23919191'/%3e%3cpath d='M94.7056 34.8393L89.8172 28.8377V34.8393H88.4136V27.6453H90.508L95.3964 33.6469V27.6453H96.8V34.8393H94.7056Z' fill='%23919191'/%3e%3cpath d='M106.586 34.8393L105.754 33.2949H100.923L100.091 34.8393H98.5468L102.463 27.6453H104.205L108.121 34.8393H106.577H106.586ZM103.347 28.8377L101.627 32.0189H105.054L103.347 28.8377Z' fill='%23919191'/%3e%3cpath d='M116.178 34.8393L111.289 28.8377V34.8393H109.886V27.6453H111.98L116.868 33.6469V27.6453H118.272V34.8393H116.178Z' fill='%23919191'/%3e%3cpath d='M128.515 29.8232C127.789 29.0884 126.83 28.6748 125.58 28.6748C123.521 28.6748 122.223 29.7264 122.223 31.2136C122.223 32.7008 123.499 33.7744 125.602 33.7744C126.83 33.7744 127.754 33.4136 128.537 32.5952L129.743 33.2376C128.621 34.5004 127.345 35.0284 125.567 35.0284C122.668 35.0284 120.762 33.4268 120.762 31.2136C120.762 30.0564 121.264 29.1104 122.272 28.3712C123.077 27.786 124.238 27.412 125.488 27.412C127.288 27.412 128.691 28.0456 129.804 29.3788L128.52 29.8232H128.515Z' fill='%23919191'/%3e%3cpath d='M132.233 34.8393V27.6453H133.637V34.8393H132.233Z' fill='%23919191'/%3e%3cpath d='M142.855 34.8393L137.966 28.8377V34.8393H136.563V27.6453H138.657L143.546 33.6469V27.6453H144.949V34.8393H142.855Z' fill='%23919191'/%3e%3cpath d='M156.851 31.1212C156.851 33.4488 155.016 35.0504 152.161 35.0504C150.885 35.0504 149.75 34.6896 148.944 34.1044C147.937 33.3696 147.435 32.4104 147.435 31.2268C147.435 30.0432 147.937 29.1104 148.944 28.3712C149.776 27.764 150.933 27.3988 152.244 27.3988C153.846 27.3988 155.135 27.9356 156.196 29.0708L154.876 29.7264C154.128 29.0136 153.239 28.6748 152.161 28.6748C150.242 28.6748 148.887 29.7748 148.887 31.2224C148.887 32.67 150.185 33.7832 152.161 33.7832C153.613 33.7832 154.629 33.2112 155.096 32.1684H151.857V30.8924H156.851V31.1212Z' fill='%23919191'/%3e%3cpath d='M15.8224 8.40833H17.1776L24.2616 22.2155H21.9428L20.1564 18.7087H12.87L11.0836 22.2155H8.79999L15.8224 8.40833ZM19.2016 16.8827L16.5176 11.5851L13.8028 16.8827H19.2016Z' fill='%23231F23'/%3e%3cpath d='M28.9696 8.40833H31.1212V20.2311H41.3864V22.2155H28.9696V8.40833Z' fill='%23231F23'/%3e%3cpath d='M48.6728 22.2155H46.5212V8.40833H56.5532C59.4 8.40833 61.0588 9.83393 61.0588 12.2495C61.0588 14.4363 59.4704 16.1919 56.7864 16.1919H48.6728V22.2199V22.2155ZM56.5532 14.1679C58.0448 14.1679 58.8368 13.4727 58.8368 12.2803C58.8368 11.0879 58.0756 10.4235 56.65 10.4235H48.6728V14.1679H56.5532Z' fill='%23231F23'/%3e%3cpath d='M68.244 22.2155H66.0924V8.40833H68.244V13.7719H77.946V8.40833H80.0976V22.2155H77.946V15.7915H68.244V22.2155Z' fill='%23231F23'/%3e%3cpath d='M91.8236 8.40833H93.1788L100.267 22.2155H97.9484L96.162 18.7087H88.8756L87.0892 22.2155H84.8056L91.828 8.40833H91.8236ZM95.1984 16.8827L92.5144 11.5851L89.7996 16.8827H95.1984Z' fill='%23231F23'/%3e%3cpath d='M104.971 8.40833H117.916V10.4279H107.122V13.8687H114.206V15.8575H107.122V20.2311H118.514V22.2155H104.971V8.40833Z' fill='%23231F23'/%3e%3cpath d='M144.179 8.40833H145.301L154.079 18.1103V8.40833H156.196V22.2155H155.069L146.296 12.5443V22.2155H144.179V8.40833Z' fill='%23231F23'/%3e%3cpath d='M130.882 24.398C135.854 24.398 139.88 20.3676 139.88 15.4C139.88 15.0964 139.867 14.7928 139.836 14.498C139.44 18.1544 136.343 21.0056 132.581 21.0056C128.55 21.0056 125.277 17.7364 125.277 13.706C125.277 9.94397 128.124 6.84637 131.784 6.45037C131.485 6.42397 131.186 6.40637 130.882 6.40637C125.91 6.40637 121.884 10.4368 121.884 15.4044C121.884 20.372 125.915 24.4024 130.882 24.4024' fill='%23D03027'/%3e%3cpath d='M131.657 18.6076C133.857 18.6076 135.639 16.8256 135.639 14.6256C135.639 14.4892 135.63 14.3572 135.617 14.2252C135.441 15.8444 134.072 17.1028 132.405 17.1028C130.618 17.1028 129.175 15.6552 129.175 13.8732C129.175 12.2056 130.434 10.8372 132.053 10.6612C131.921 10.648 131.789 10.6436 131.652 10.6436C129.452 10.6436 127.67 12.4256 127.67 14.6256C127.67 16.8256 129.452 18.6076 131.652 18.6076' fill='%23793694'/%3e%3cpath d='M132.832 7.29517C129.43 7.29517 126.672 10.054 126.672 13.4552C126.672 13.662 126.685 13.8688 126.702 14.0712C126.975 11.5676 129.092 9.61837 131.67 9.61837C134.429 9.61837 136.668 11.8536 136.668 14.6168C136.668 17.1908 134.719 19.3116 132.216 19.58C132.418 19.602 132.625 19.6108 132.836 19.6108C136.237 19.6108 138.992 16.852 138.992 13.4508C138.992 10.0496 136.233 7.29077 132.836 7.29077' fill='%23F17C21'/%3e%3cpath d='M132.629 11.2463C131.3 11.2463 130.222 12.3243 130.222 13.6531C130.222 13.7323 130.227 13.8159 130.236 13.8951C130.341 12.9183 131.168 12.1527 132.176 12.1527C133.254 12.1527 134.13 13.0283 134.13 14.1063C134.13 15.1139 133.368 15.9411 132.387 16.0467C132.466 16.0555 132.546 16.0599 132.629 16.0599C133.958 16.0599 135.036 14.9819 135.036 13.6531C135.036 12.3243 133.958 11.2463 132.629 11.2463Z' fill='%2399AE3B'/%3e%3cpath d='M160.222 5.6936V7.2512H159.742V5.6936H159.144V5.3064H160.816V5.6936H160.217H160.222ZM162.967 7.2468V5.786L162.43 7.2468H162.219L161.669 5.786V7.2468H161.203V5.3064H161.88L162.338 6.4768L162.76 5.3064H163.425V7.2468H162.967Z' fill='%23231F23'/%3e%3c/svg%3e";

var img$3 = "data:image/svg+xml,%3csvg width='756' height='7' viewBox='0 0 756 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0_4088_7318)'%3e%3cpath d='M756 0H0V7H756V0Z' fill='url(%23paint0_linear_4088_7318)'/%3e%3c/g%3e%3cdefs%3e%3clinearGradient id='paint0_linear_4088_7318' x1='0' y1='3.5' x2='756' y2='3.5' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23D13128'/%3e%3cstop offset='0.04' stop-color='%23D63E29'/%3e%3cstop offset='0.18' stop-color='%23E86A2D'/%3e%3cstop offset='0.25' stop-color='%23F07C2F'/%3e%3cstop offset='0.38' stop-color='%23AF5765'/%3e%3cstop offset='0.5' stop-color='%23783795'/%3e%3cstop offset='0.75' stop-color='%2332479A'/%3e%3cstop offset='0.86' stop-color='%2363796C'/%3e%3cstop offset='0.95' stop-color='%238BA048'/%3e%3cstop offset='1' stop-color='%239AB03B'/%3e%3c/linearGradient%3e%3cclipPath id='clip0_4088_7318'%3e%3crect width='756' height='7' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 15 15'%3e %3cg id='Group_9282' data-name='Group 9282' transform='translate(-913.517 -640.414)'%3e %3ccircle id='Ellipse_29' data-name='Ellipse 29' cx='7.5' cy='7.5' r='7.5' transform='translate(913.517 640.414)' fill='%23d60000'/%3e %3cpath id='Path_363' data-name='Path 363' d='M1.11-7.22l.37%2c5.07H2.92l.35-5.07ZM1.33%2c0H3.09V-1.49H1.33Z' transform='translate(919.017 651.728)' fill='white'/%3e %3c/g%3e%3c/svg%3e";

function CareStackLanding() {
  const {
    queryObject
  } = useQuery();
  const [linkComplete, setLinkComplete] = useState(false);
  // Get query params
  const csId = queryObject.get('cs_id');
  const address = queryObject.get('address');
  const name = queryObject.get('name');
  // Check if all required query params are present
  const hasAllParams = csId && address && name;
  // Open the merchant portal in a popup for Auth0 login (Auth0 cannot be reliably loaded in an iframe due to framing / third-party cookie restrictions)
  const handleLinkAlphaeon = useCallback(() => {
    const params = new URLSearchParams({
      carestack_cs_id: csId ?? '',
      carestack_address: address ?? '',
      carestack_name: name ?? ''
    });
    const popupUrl = makePath(APPLICATION_ROOT_URL, `${PATH.MERCHANT_PORTAL}?${params.toString()}`);
    const width = 720;
    const height = 800;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;
    const popup = window.open(popupUrl, 'alphaeon-link', `width=${width},height=${height},left=${left},top=${top}`);
    if (!popup) {
      alert('Pop-ups are blocked by your browser. Please allow pop-ups for this site and try again.');
    }
  }, [csId, address, name]);
  // Listen for success message from the popup
  useEffect(() => {
    const handleMessage = event => {
      if (event.origin === window.location.origin && event.data?.type === 'CARESTACK_LINK_SUCCESS') {
        setLinkComplete(true);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);
  return jsxRuntimeExports.jsxs("div", {
    className: "carestack-integration",
    children: [jsxRuntimeExports.jsx("img", {
      src: img$3,
      alt: "",
      className: "carestack-integration__colorbar"
    }), jsxRuntimeExports.jsx("div", {
      className: "carestack-integration__logo-container",
      children: jsxRuntimeExports.jsx("img", {
        src: img$4,
        alt: "Alphaeon Patient Financing",
        className: "carestack-integration__logo"
      })
    }), jsxRuntimeExports.jsx("div", {
      className: "carestack-integration__content",
      children: !hasAllParams ? jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
        children: [jsxRuntimeExports.jsx("img", {
          src: img$2,
          alt: "Warning",
          className: "carestack-integration__error-icon mar-b-24"
        }), jsxRuntimeExports.jsx(H1, {
          variant: "headline-large",
          className: "carestack-integration__heading text-center mar-b-16",
          children: "Unable to Process Request"
        }), jsxRuntimeExports.jsx(P, {
          variant: "title-medium",
          className: "carestack-integration__instructions text-center",
          children: "Required information is missing from the URL."
        })]
      }) : linkComplete ? jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
        children: [jsxRuntimeExports.jsx(H1, {
          variant: "headline-large",
          className: "carestack-integration__heading text-center mar-b-16",
          children: "Account Linked Successfully"
        }), jsxRuntimeExports.jsx(P, {
          variant: "title-medium",
          className: "carestack-integration__instructions text-center",
          children: "Your Alphaeon account has been linked to CareStack. You may close this window."
        })]
      }) : jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
        children: [jsxRuntimeExports.jsx(H1, {
          variant: "headline-large",
          className: "carestack-integration__heading text-center mar-b-16",
          children: "Connect Your Alphaeon Account"
        }), jsxRuntimeExports.jsx(P, {
          variant: "title-medium",
          className: "carestack-integration__instructions text-center",
          children: "Log in with Alphaeon to securely link your CareStack account and unlock a seamless financing experience for your patients."
        }), jsxRuntimeExports.jsx(ButtonV2, {
          variant: "filled",
          color: "red",
          size: "medium",
          fullWidth: true,
          className: "mar-t-32",
          onClick: handleLinkAlphaeon,
          children: "Link Alphaeon"
        }), jsxRuntimeExports.jsx("div", {
          className: "carestack-integration__divider",
          children: jsxRuntimeExports.jsx(Span, {
            variant: "title-medium",
            children: "OR"
          })
        }), jsxRuntimeExports.jsx(P, {
          variant: "title-medium",
          className: "carestack-integration__enroll-text text-center",
          children: "Don't have an Alphaeon account yet? Enroll in minutes."
        }), jsxRuntimeExports.jsx(ButtonV2, {
          variant: "outline",
          color: "red",
          size: "medium",
          fullWidth: true,
          className: "mar-b-32",
          onClick: () => window.open(buildCareStackEnrollUrl(csId ?? undefined), '_blank', 'noopener,noreferrer'),
          children: "Enroll with Alphaeon"
        })]
      })
    })]
  });
}

function Routes() {
  const {
    path
  } = useRouteMatch();
  return jsxRuntimeExports.jsx(Layout, {
    children: jsxRuntimeExports.jsx(Switch, {
      children: jsxRuntimeExports.jsx(Route, {
        exact: true,
        path: makePath(path, PATH.CARESTACK),
        children: jsxRuntimeExports.jsx(CareStackLanding, {})
      })
    })
  });
}

function PrintPage() {
  const [loading, setLoading] = useState(true);
  const {
    terms
  } = useParams();
  const printPage = () => {
    setTimeout(() => {
      setLoading(false);
      window.print();
    }, 3000);
  };
  const SRC = terms === 'CCA' ? URL$1.CCA : URL$1.PATRIOT_ACT;
  return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
    children: jsxRuntimeExports.jsxs("div", {
      className: "print-page",
      children: [loading && jsxRuntimeExports.jsx(Spinner, {}), jsxRuntimeExports.jsx("iframe", {
        className: "proxy-iframe",
        id: "iframe",
        src: SRC,
        title: "Proxy"
      }), jsxRuntimeExports.jsx("iframe", {
        className: `iframe ${terms === 'CCA' ? 'financial-terms' : 'patriot-terms'}`,
        id: "iframe",
        onLoad: printPage,
        src: SRC,
        height: "46427px",
        title: "Terms"
      })]
    })
  });
}

var img$1 = "data:image/svg+xml,%3csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M9.1665 16.25H17.4998' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M9.1665 10.417H17.4998' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M9.1665 4.58301H17.4998' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M2.5 4.58366L3.33333 5.41699L5.83333 2.91699' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M2.5 10.4167L3.33333 11.25L5.83333 8.75' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M2.5 16.2497L3.33333 17.083L5.83333 14.583' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

function PlanCard({
  plan,
  isSelected,
  onSelect,
  processDisabled,
  radio
}) {
  const {
    pwaMainMarketing,
    pwaDisclosure,
    pwaFootnoteMarker
  } = plan ?? {};
  const mainMarketingText = pwaMainMarketing?.[0]?.text ?? '';
  const pwaDisclosureText = pwaDisclosure?.[0]?.text ?? '';
  const isRevolving = plan.name === 'REVOLVING';
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsxs("div", {
      className: classNames('select-plan__plan-card', {
        'select-plan__plan-card--selected': isSelected
      }),
      role: "button",
      tabIndex: 0,
      onClick: onSelect,
      onKeyDown: e => {
        if (e.key === 'Enter') onSelect();
        if (e.key === ' ') {
          e.preventDefault();
          onSelect();
        }
      },
      children: [jsxRuntimeExports.jsx("div", {
        className: "select-plan__plan-card-radio",
        children: radio
      }), jsxRuntimeExports.jsx("div", {
        className: "select-plan__plan-card-body",
        children: !isRevolving ? jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
          children: [jsxRuntimeExports.jsx(P, {
            bold: true,
            variant: "body-large",
            className: "select-plan__plan-name color-gray",
            children: plan.name.toUpperCase()
          }), jsxRuntimeExports.jsx(Span, {
            variant: "body-small",
            className: "select-plan__plan-label",
            children: "ESTIMATED PAYMENT"
          }), jsxRuntimeExports.jsxs("div", {
            className: "select-plan__plan-payment",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-small",
              children: "$"
            }), jsxRuntimeExports.jsx(Span, {
              variant: "headline-large",
              bold: true,
              children: plan.estimatedMonthlyPayment
            }), jsxRuntimeExports.jsx(Span, {
              variant: "body-small",
              children: "/mo"
            })]
          }), jsxRuntimeExports.jsxs("div", {
            className: "select-plan__plan-total",
            children: [jsxRuntimeExports.jsx(Span, {
              variant: "body-small",
              className: "select-plan__plan-total-label",
              children: "TOTAL ESTIMATED COST:"
            }), jsxRuntimeExports.jsxs(Span, {
              variant: "body-small",
              bold: true,
              className: "select-plan__plan-total-label",
              children: [formatCurrency(plan.estimatedTotalCost, 2), jsxRuntimeExports.jsx(Span, {
                variant: "body-small",
                className: "select-plan__plan-total-label",
                dangerouslySetInnerHTML: {
                  __html: pwaFootnoteMarker
                }
              })]
            })]
          }), mainMarketingText && jsxRuntimeExports.jsx(P, {
            dangerouslySetInnerHTML: {
              __html: mainMarketingText
            },
            variant: "body-small"
          })]
        }) : jsxRuntimeExports.jsx(P, {
          bold: true,
          variant: "body-large",
          className: "select-plan__plan-name color-gray",
          children: "NO PROMOTIONAL PLAN"
        })
      })]
    }), isSelected && jsxRuntimeExports.jsxs("div", {
      className: "select-plan__plan-card-expansion",
      children: [jsxRuntimeExports.jsx(ButtonV2, {
        type: "submit",
        variant: "filled",
        color: "red",
        size: "small",
        fullWidth: true,
        disabled: processDisabled,
        children: "Process Sale"
      }), jsxRuntimeExports.jsxs(P, {
        variant: "body-medium",
        children: [jsxRuntimeExports.jsx("sup", {
          children: pwaFootnoteMarker
        }), jsxRuntimeExports.jsx(Span, {
          variant: "body-medium",
          dangerouslySetInnerHTML: {
            __html: pwaDisclosureText
          }
        })]
      })]
    })]
  });
}

function Row({
  label,
  value,
  highlight = false
}) {
  return jsxRuntimeExports.jsxs("div", {
    className: "send-receipt__receipt-row",
    children: [jsxRuntimeExports.jsx(P, {
      variant: "body-medium",
      className: "send-receipt__receipt-label",
      children: label
    }), jsxRuntimeExports.jsx(P, {
      variant: "body-medium",
      className: classNames('send-receipt__receipt-value', {
        'send-receipt__receipt-value--highlight': highlight
      }),
      children: value
    })]
  });
}

const FILTER_TO_PAYMENT_PLAN_TYPE = {
  all: null,
  deferred: 'DI',
  'waived-interest': 'WI',
  'low-apr': 'EPP',
  revolving: 'REVOLVING'
};
const filters = [{
  label: 'All',
  value: 'all'
}, {
  label: 'Deferred Interest',
  value: 'deferred'
}, {
  label: 'Low APR',
  value: 'low-apr'
}, {
  label: 'Waived Interest',
  value: 'waived-interest'
}];
// Order plan groups are displayed in (by payment plan type) when viewing "All".
const PLAN_GROUP_ORDER = ['DI', 'EPP', 'WI', 'REVOLVING'];
// Display label per payment plan type for the "All" view. Revolving is blank — icon only.
const PLAN_TYPE_LABELS = {
  DI: 'Deferred Interest',
  EPP: 'Low APR',
  WI: 'Waived Interest',
  REVOLVING: ''
};
function PlansForm({
  initialAmount,
  amountLocked,
  plans,
  isLoading,
  onAmountChange,
  onSubmitForm
}) {
  const [activeFilter, setActiveFilter] = useState('deferred');
  const {
    register,
    handleSubmit,
    setValue,
    control,
    watch,
    formState: {
      errors
    }
  } = useForm({
    defaultValues: {
      amount: initialAmount ? String(initialAmount) : '',
      selectedPlanId: ''
    }
  });
  const selectedPlanId = watch('selectedPlanId');
  const amount = watch('amount');
  const plansOfType = planType => planType ? plans.filter(plan => plan.paymentPlanType === planType) : plans;
  const availableFilters = filters.filter(f => f.value === 'all' || plansOfType(FILTER_TO_PAYMENT_PLAN_TYPE[f.value]).length > 0);
  // If the active filter's plan type has no plans, its button is hidden, so
  // fall back to "All" to avoid showing an empty section with no button active.
  useEffect(() => {
    const planType = FILTER_TO_PAYMENT_PLAN_TYPE[activeFilter];
    if (planType && plans.length > 0 && !plans.some(plan => plan.paymentPlanType === planType)) {
      setActiveFilter('all');
    }
  }, [plans, activeFilter]);
  const planGroups = activeFilter === 'all' ? PLAN_GROUP_ORDER.map(planType => ({
    label: PLAN_TYPE_LABELS[planType] ?? '',
    planType,
    plans: plansOfType(planType)
  })).filter(group => group.plans.length > 0) : [{
    label: filters.find(f => f.value === activeFilter)?.label ?? '',
    planType: FILTER_TO_PAYMENT_PLAN_TYPE[activeFilter] ?? '',
    plans: plansOfType(FILTER_TO_PAYMENT_PLAN_TYPE[activeFilter])
  }];
  const selectedPlan = plans.find(p => p.id === Number(selectedPlanId));
  const {
    pwaDisclosure,
    pwaFootnoteMarker
  } = selectedPlan ?? {};
  const disclosureText = pwaDisclosure?.[0]?.text ?? '';
  const processDisabled = !amount || !selectedPlanId;
  const handleFilterChange = value => {
    setActiveFilter(value);
    setValue('selectedPlanId', '');
  };
  return jsxRuntimeExports.jsxs("form", {
    className: "select-plan__plans-form",
    onSubmit: handleSubmit(data => onSubmitForm(data)),
    children: [jsxRuntimeExports.jsxs("div", {
      className: "select-plan__plans-header",
      children: [jsxRuntimeExports.jsxs("div", {
        className: "select-plan__amount-column",
        children: [jsxRuntimeExports.jsx(Span, {
          variant: "headline-medium",
          bold: true,
          children: "Amount To Pay"
        }), jsxRuntimeExports.jsx(Controller, {
          name: "amount",
          control: control,
          rules: {
            required: 'Required'
          },
          render: ({
            field: {
              onChange,
              value,
              ref,
              name
            }
          }) => jsxRuntimeExports.jsx("div", {
            className: "select-plan__amount-input-wrapper",
            children: jsxRuntimeExports.jsx(InputAmountV2, {
              name: name,
              value: value,
              ref: ref,
              readOnly: amountLocked,
              disabled: amountLocked,
              error: errors.amount?.message ?? null,
              onValueChange: values => {
                if (amountLocked) return;
                onChange(values.value);
                if (values.floatValue !== undefined) {
                  onAmountChange(values.floatValue);
                }
              }
            })
          })
        })]
      }), jsxRuntimeExports.jsx("div", {
        className: "select-plan__divider"
      }), amount && jsxRuntimeExports.jsx("div", {
        className: "select-plan__filters",
        children: jsxRuntimeExports.jsx("div", {
          className: "select-plan__filter-buttons",
          children: availableFilters.map(f => jsxRuntimeExports.jsx(ButtonV2, {
            type: "button",
            variant: activeFilter === f.value ? 'filled' : 'outline',
            color: activeFilter === f.value ? 'red' : 'black',
            size: "extra-small",
            hugText: true,
            onClick: () => handleFilterChange(f.value),
            children: f.label
          }, f.value))
        })
      })]
    }), isLoading && jsxRuntimeExports.jsx(Spinner, {}), !isLoading && plans.length > 0 && jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
      children: planGroups.map(group => {
        const isSelectedPlanInGroup = group.plans.some(plan => String(plan.id) === selectedPlanId);
        return jsxRuntimeExports.jsxs(Fragment, {
          children: [jsxRuntimeExports.jsxs("div", {
            className: "select-plan__plan-info",
            children: [jsxRuntimeExports.jsx("span", {
              "aria-hidden": "true",
              className: "select-plan__plan-badge",
              children: jsxRuntimeExports.jsx("img", {
                src: img$1,
                alt: "plan",
                width: 20,
                height: 20
              })
            }), group.label && jsxRuntimeExports.jsxs(Span, {
              variant: "body-large",
              children: [group.label, " Plans"]
            })]
          }), jsxRuntimeExports.jsx("div", {
            className: "select-plan__plan-grid",
            children: group.plans.map(plan => jsxRuntimeExports.jsx(PlanCard, {
              plan: plan,
              isSelected: selectedPlanId === String(plan.id),
              onSelect: () => {
                setValue('selectedPlanId', String(plan.id), {
                  shouldValidate: true
                });
              },
              processDisabled: processDisabled,
              radio: jsxRuntimeExports.jsx(Radio, {
                ...register('selectedPlanId', {
                  required: 'Please select a plan'
                }),
                value: String(plan.id),
                checked: selectedPlanId === String(plan.id),
                onChange: () => setValue('selectedPlanId', String(plan.id), {
                  shouldValidate: true
                })
              })
            }, plan.id))
          }), isSelectedPlanInGroup && jsxRuntimeExports.jsxs("div", {
            className: classNames('select-plan__plans-footer', 'select-plan__desktop-only'),
            children: [jsxRuntimeExports.jsx(ButtonV2, {
              type: "submit",
              variant: "filled",
              color: "red",
              size: "small",
              disabled: processDisabled,
              children: "Process Sale"
            }), jsxRuntimeExports.jsxs(P, {
              variant: "body-medium",
              children: [jsxRuntimeExports.jsx("sup", {
                children: pwaFootnoteMarker
              }), jsxRuntimeExports.jsx(Span, {
                variant: "body-medium",
                dangerouslySetInnerHTML: {
                  __html: disclosureText
                }
              })]
            })]
          })]
        }, group.planType);
      })
    })]
  });
}

/**
 * The terms-and-signature step of the sales receipt flow: promotional plan
 * terms, the last-4-of-SSN input, the agreement checkbox, and the Sign Receipt
 * action. Modeled on the embed checkout `ReceiptForm`, it owns its field state
 * via react-hook-form and hands the collected SSN back to the host through
 * `onSign`, keeping the actual signing/API call host-specific. Submitting state
 * is derived from the awaited `onSign`, so the host doesn't pass it in.
 */
function SendReceiptForm({
  pwaMainMarketingText,
  pwaDisclosureText,
  onSign,
  signButtonRef,
  planName
}) {
  const {
    handleSubmit,
    control,
    watch,
    formState: {
      errors,
      isSubmitting
    }
  } = useForm({
    defaultValues: {
      ssnLast4: '',
      agreed: false
    }
  });
  const ssnLast4 = watch('ssnLast4');
  const agreed = watch('agreed');
  const submitDisabled = !ssnLast4 || ssnLast4.length < 4 || !agreed;
  const isRevolving = planName === 'REVOLVING';
  async function onSubmit(data) {
    await onSign(data.ssnLast4);
  }
  return jsxRuntimeExports.jsxs("form", {
    className: "send-receipt__terms",
    onSubmit: handleSubmit(onSubmit),
    children: [!isRevolving ? jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
      children: [jsxRuntimeExports.jsxs(P, {
        children: [jsxRuntimeExports.jsx("sup", {
          children: "\u2021"
        }), jsxRuntimeExports.jsx(Span, {
          variant: "body-medium",
          dangerouslySetInnerHTML: {
            __html: pwaMainMarketingText
          }
        })]
      }), jsxRuntimeExports.jsxs(P, {
        children: [jsxRuntimeExports.jsx("sup", {
          children: "\u2020"
        }), jsxRuntimeExports.jsx(Span, {
          variant: "body-medium",
          dangerouslySetInnerHTML: {
            __html: pwaDisclosureText
          }
        })]
      })]
    }) : jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
      children: [jsxRuntimeExports.jsx(P, {
        variant: "body-medium",
        children: "Credit card offers are subject to credit approval."
      }), jsxRuntimeExports.jsx(P, {
        variant: "body-medium",
        children: "Alphaeon Credit Card Accounts are issued by Comenity Capital Bank."
      })]
    }), jsxRuntimeExports.jsx("div", {
      className: "send-receipt__divider"
    }), jsxRuntimeExports.jsx("div", {
      className: "send-receipt__ssn",
      children: jsxRuntimeExports.jsx(Controller, {
        control: control,
        name: "ssnLast4",
        rules: {
          required: true,
          minLength: 4,
          maxLength: 4
        },
        render: ({
          field: {
            name,
            value,
            onChange,
            ref
          }
        }) => jsxRuntimeExports.jsx(InputNumberV2, {
          name: name,
          value: value,
          ref: ref,
          labelElement: jsxRuntimeExports.jsx(Span, {
            variant: "body-medium",
            bold: true,
            children: "Last 4 of SSN/ITIN #"
          }),
          placeholder: "Enter last four of SSN/ITIN #",
          decimalScale: 0,
          allowLeadingZeros: true,
          isAllowed: values => values.value.length <= 4,
          onValueChange: values => onChange(values.value),
          error: errors.ssnLast4?.message ?? null
        })
      })
    }), jsxRuntimeExports.jsxs("div", {
      className: "send-receipt__agreement",
      children: [jsxRuntimeExports.jsx(Controller, {
        control: control,
        name: "agreed",
        render: ({
          field: {
            value,
            onChange,
            ...rest
          }
        }) => jsxRuntimeExports.jsx(Checkbox, {
          checked: value,
          onChange: e => onChange(e.target.checked),
          ...rest
        })
      }), jsxRuntimeExports.jsx(P, {
        variant: "body-large",
        children: "I agree to pay for these goods or services according to the terms of my ALPHAEON Credit Card Agreement and if applicable, any Promotional Credit Plan, which may apply to this transaction. If any purchase is not satisfactory, it will be subject to provider\u2019s refund policy."
      })]
    }), jsxRuntimeExports.jsx("div", {
      ref: signButtonRef,
      className: "send-receipt__sign-button",
      children: jsxRuntimeExports.jsx(ButtonV2, {
        type: "submit",
        variant: "filled",
        color: "red",
        size: "small",
        fullWidth: true,
        disabled: submitDisabled,
        submitting: isSubmitting,
        children: "Sign Receipt & Submit"
      })
    })]
  });
}

function SelectPlan({
  initialAmount,
  amountLocked,
  plans,
  plansLoading,
  onAmountChange,
  onSubmitForm
}) {
  return jsxRuntimeExports.jsx("div", {
    className: "select-plan__step",
    children: jsxRuntimeExports.jsx(PlansForm, {
      initialAmount: initialAmount,
      amountLocked: amountLocked,
      plans: plans,
      isLoading: plansLoading,
      onAmountChange: onAmountChange,
      onSubmitForm: onSubmitForm
    })
  });
}

const ChevronsDown = () => jsxRuntimeExports.jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true",
  children: [jsxRuntimeExports.jsx("polyline", {
    points: "7 6 12 11 17 6"
  }), jsxRuntimeExports.jsx("polyline", {
    points: "7 13 12 18 17 13"
  })]
});
function SendReceipt({
  customerName,
  locationName,
  planName,
  amount,
  estimatedMonthlyPayment,
  pwaMainMarketingText,
  pwaDisclosureText,
  onEdit,
  onSign,
  last4Account = ''
}) {
  const signButtonRef = useRef(null);
  const isMobile = useIsMobile();
  const isSignButtonVisible = useIsInViewport(signButtonRef);
  const showScrollToSign = isMobile && !isSignButtonVisible;
  const scrollToSign = () => signButtonRef.current?.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  });
  return jsxRuntimeExports.jsxs("div", {
    className: "send-receipt__step",
    children: [jsxRuntimeExports.jsx(H1, {
      variant: "headline-large",
      className: "send-receipt__title",
      children: "Sales Receipt"
    }), jsxRuntimeExports.jsxs("div", {
      className: "send-receipt__receipt-box",
      children: [jsxRuntimeExports.jsx(Row, {
        label: "Customer Name",
        value: customerName
      }), last4Account && jsxRuntimeExports.jsx(Row, {
        label: "Account Number",
        value: `**************${last4Account}`
      }), jsxRuntimeExports.jsx(Row, {
        label: "Location Name",
        value: locationName
      }), jsxRuntimeExports.jsx(Row, {
        label: "Plan Name",
        value: estimatedMonthlyPayment != null ? jsxRuntimeExports.jsxs(Span, {
          variant: "body-medium",
          children: [planName === 'REVOLVING' ? 'Revolving Plan' : planName.replace(' SEE PLAN DISCL', ''), planName !== 'REVOLVING' && jsxRuntimeExports.jsx("sup", {
            children: "\u2021"
          })]
        }) : '',
        highlight: true
      }), jsxRuntimeExports.jsx(Row, {
        label: "Sale Amount",
        value: amount != null ? formatCurrency(amount, 2) : ''
      }), planName !== 'REVOLVING' && jsxRuntimeExports.jsx(Row, {
        label: "Estimated Monthly Payment",
        value: estimatedMonthlyPayment != null ? jsxRuntimeExports.jsxs(Span, {
          variant: "body-medium",
          children: [formatCurrency(estimatedMonthlyPayment, 2), jsxRuntimeExports.jsx("sup", {
            children: "\u2020"
          })]
        }) : ''
      })]
    }), jsxRuntimeExports.jsx(ButtonV2, {
      variant: "outline",
      color: "red",
      size: "small",
      fullWidth: true,
      onClick: onEdit,
      children: "Edit"
    }), jsxRuntimeExports.jsx("div", {
      className: "send-receipt__divider"
    }), jsxRuntimeExports.jsx(SendReceiptForm, {
      pwaMainMarketingText: pwaMainMarketingText,
      pwaDisclosureText: pwaDisclosureText,
      onSign: onSign,
      signButtonRef: signButtonRef,
      planName: planName
    }), showScrollToSign && jsxRuntimeExports.jsx("div", {
      className: "send-receipt__scroll-to-sign",
      children: jsxRuntimeExports.jsx(ButtonV2, {
        variant: "filled",
        color: "blue",
        size: "small",
        hugText: true,
        SvgIcon: ChevronsDown,
        onClick: scrollToSign,
        children: "Scroll to Sign"
      })
    })]
  });
}

var img = "data:image/svg+xml,%3csvg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M32.0002 5.35882e-10C14.3271 -0.000101177 0.000121414 14.3267 5.35928e-10 31.9998C-0.000101177 49.6731 14.3269 64.0001 32.0002 64C49.6733 63.9999 64.0001 49.6729 64 31.9998C63.9999 14.3269 49.6731 0.000121414 32.0002 5.35882e-10ZM44.7747 20.4484C45.5895 20.4484 46.4043 20.7605 47.0286 21.3849C48.2774 22.6336 48.2774 24.6442 47.0286 25.8929L30.3097 42.6118C29.7634 43.1581 29.0712 43.4655 28.3609 43.5338C27.4475 43.6216 26.5041 43.3142 25.8017 42.6118L16.9718 33.7822C15.723 32.5334 15.723 30.5228 16.9718 29.2741C18.2205 28.0254 20.2313 28.0254 21.4801 29.2741L28.0558 35.8497L42.5206 21.3849C43.145 20.7605 43.9598 20.4484 44.7747 20.4484Z' fill='%2343A03C'/%3e%3c/svg%3e";

function Success({
  locationName,
  handleComplete,
  sourceFlow
}) {
  return jsxRuntimeExports.jsxs("div", {
    className: "success__step success__step",
    children: [jsxRuntimeExports.jsx("span", {
      "aria-hidden": "true",
      className: "success__success-check",
      children: jsxRuntimeExports.jsx("img", {
        src: img,
        alt: ""
      })
    }), jsxRuntimeExports.jsx(H1, {
      variant: "headline-large",
      className: "success__title success__title",
      children: "Your receipt has been signed!"
    }), jsxRuntimeExports.jsxs(P, {
      variant: "body-large",
      className: "success__success-message",
      children: ["Thank you for successfully signing your receipt. We have sent a copy of the completed receipt to your account email address and ", locationName, ' ', "will receive the funds from this transaction."]
    }), sourceFlow === 'sdk' && handleComplete ? jsxRuntimeExports.jsx(ButtonV2, {
      variant: "filled",
      color: "red",
      size: "small",
      fullWidth: true,
      onClick: handleComplete,
      children: "Close"
    }) : null]
  });
}

export { A, ACCESS_LOAN_DEFAULT_LIST, ACCESS_LOAN_DISALLOWED_STATES, ACCESS_LOAN_URL, ACCOUNT_CREATED_FLEX_URL, ACCOUNT_CREATED_URL, ACCOUNT_DETAIL_URL, ACCOUNT_EXISTS_URL, ACCOUNT_FULL_APPLICATION_CONFIRM_URL, ACCOUNT_FULL_APPLICATION_URL, ACCOUNT_LOOKUP, ACCOUNT_LOOKUP_URL, ACCOUNT_LOOK_RESULT_URL, ACCOUNT_LOOK_UP_RESULT_URL, ACCOUNT_VERIFICATION_URL, ACTION, ADMIN_PERMISSION_KEYS, ADMIN_PERMISSION_OPTIONS, AFF_NUMBER, ALL_LOCATIONS, ALL_PERMISSIONS, ALPHAEON_CONTACT_EMAIL, ALPHAEON_CONTACT_PHONE, ALPHAEON_FLEX_CONTACT_PHONE, API_ERROR_MAP, APPLICANTS_URL, APPLICATION, APPLICATION_FINDER_URL, APPLICATION_FOUND_URL, APPLICATION_PATHS, APPLICATION_REPORT_DETAIL_HEADER, APPLICATION_REPORT_SUMMARY_HEADERS, APPLICATION_ROOT_URL, APPLICATION_SEARCH_CRITERION, APPLICATION_STATUS_OPTIONS, APPLICATION_TRACKING, APPLY_URL, AUTHORIZATION_SENT_URL, AccountNumber$1 as AccountNumber, AnalyticsContext, AnalyticsProvider, AnimationFail, AnimationPhoneWait, AnimationSuccess, AppsOutlined as AppsOutlinedIcon, ArrowBackIos as ArrowBackIosIcon, AssignmentTurnedInOutlined as AssignmentTurnedInOutlinedIcon, AuthBuyerSaleCard, AuthorizationTooltip$1 as AuthorizationTooltip, BANK_RECONCILIATION, BANK_RECONCILIATION_V2, BANK_VERIFICATION_URL, BRAND_COLOR, BREAD_LENDER_STATUS, Button$1 as Button, ButtonLink$1 as ButtonLink, ButtonV2, CALCULATOR_URL, CARESTACK_ENROLL_URL, CARESTACK_LINK_LOCATION, CARESTACK_LINK_LOCATION_CONFIRM_URL, CARESTACK_LINK_LOCATION_SUCCESS_URL, CARESTACK_NO_MATCHES_URL, CARESTACK_SESSION_STORAGE_KEY, COMPARISON_SHEETS_URL, COMPARISON_SHEET_NEW_URL, CONSUMER_APP_URL, CONTACT_NUMBER, CONTACT_US_URL, CONTINUE_APPLICATION_URL, CREDIT_AVAILABLE, CREDIT_AVAILABLE_DETAIL_HEADERS, CREDIT_AVAILABLE_SUMMARY_HEADERS, CREDIT_DECLINED_URL, CREDIT_PORTAL_URL, Cake as CakeIcon, CardRow, Checkbox as CheckboxV2, Close$1 as CloseIcon, CodeInput, CodeInput5Digit, CustomErrorPage, CustomFields, DASHBOARD_ACTIONS, DATE_FILTER_TYPE, DATE_SELECTION, DATE_STRING_LENGTH, DECLINED_URL, DEFAULT_MAX_VALUE_FOR_PLANS, DEFAULT_PERMISSIONS, DEFAULT_PERMISSIONS_KEYS, DOCTOR_SPECIALTIES, DOCUMENT_MANAGEMENT_URL, DOWN_PAYMENT_METHODS, Done as DoneIcon, EMPTY_APPLICATION_REPORT_SUMMARY, EMPTY_CREDIT_AVAILABLE_REPORT_SUMMARY, EMPTY_RECONCILIATION_REPORT_SUMMARY_DETAIL, EMPTY_SALES_REPORT_SUMMARY, ENROLLMENTS_APP_HOSTS, ERROR_EXPIRATION_ERROR_URL, ERROR_STATUS, ERROR_STATUS_NAME, EST_TIMEZONE, EXPIRED_TIME, Edit as EditIcon, Email as EmailIcon, Error$2 as ErrorIcon, ErrorOutlined as ErrorOutlinedIcon, Routes$2 as ErrorRoutes, ExternalLink$1 as ExternalLink, ExternalLinkButton_default as ExternalLinkButton, FILTER_OPTIONS, FINANCING_PARTNERS_URL, FIND_MY_ACCOUNT_URL, FLEX_FINALIZE_PARENT_PATH, FLEX_PORTAL_URL, FLEX_QUICK_START_GUIDE_URL, FULL_ACCOUNT_ACCESS_KEYS, FULL_ACCOUNT_ACCESS_OPTIONS, FULL_ACCOUNT_ACCESS_TOOLTIP, Facebook as FacebookIcon, FallbackErrorScreen, FilterList$1 as FilterListIcon, FlexEstimateFootnotes, FlexOptionCard, FormSpy, GradientStepper, H1, H2, H3, H4, H5, H6, INITIALIZATION_CONTACT_US_URL, INLINE_COLORS, INSTALLMENT, INVOICE_BUILDER_PATHS, INVOICE_BUILDER_STEPS, INVOICE_BUILDER_URL, ImportExport$1 as ImportExportIcon, Info as InfoIcon, InputAmountV2, InputCheckbox, InputDOB as InputDOBV2, InputDate, InputDateMask, InputMask, InputMask2, InputNumber, InputNumberV2, InputPattern, InputPhone as InputPhoneV2, InputRadio, InputSSN, InputSSNV2, InputSelectNative, InputTaxId as InputTaxIdV2, InputText, InputTextV2, InputTip, InputWithToolTip, InputZipV2, Instagram as InstagramIcon, KeyboardArrowDown as KeyboardArrowDownIcon, KeyboardArrowUp as KeyboardArrowUpIcon, LENDER_NAME_TO_PRODUCT_TYPE_MAP, LOAN_ADJUSTMENT_URL, LOCATION_MANAGEMENT_URL, LOCATION_URL, LOC_NEXT_DAY_PENDING_STATES, Label, Language as LanguageIcon, Routes$1 as LegalRoutes, Li, LinkButton_default as LinkButton, LinkedIn as LinkedInIcon, LocalPhone as LocalPhoneIcon, LockOutlined$1 as LockOutlinedIcon, LongLinkFetcher, MARKETING_CUSTOM_LINK_URL, MARKETING_MATERIALS, MAX_DISPLAYED_SELECT_ITEMS, MENU_HEIGHT, MERCHANT_ACCOUNT_EXISTS_URL, MERCHANT_DECLINED_ACCESS_LOAN_AVAILABLE, MERCHANT_DECLINED_URL, MERCHANT_INVOICE_BUILDER, MERCHANT_PENDING_URL, MERCHANT_PORTAL_PATHS, MERCHANT_PORTAL_URL, MERCHANT_SALES_PORTAL, MERCHANT_STEP_UP_URL, MERCHANT_USER_PORTAL, MIN_ANNUAL_INCOME, MaskedInputWithToolTip, Modal, MonetizationOnOutlined as MonetizationOnOutlinedIcon, NEW_ACCESS_LOAN_URL, NOTIFICATIONS_INTERVAL_ACTIVE, NO_APPLICATIONS_URL, NO_MANAGER_ACCESS_URL, NavigateBefore$1 as NavigateBeforeIcon, NavigateNext$1 as NavigateNextIcon, OPTIONS_HOUSING, OPTIONS_INCOME_SOURCE, OPTIONS_PAY_FREQUENCY, P, PAGINATION_PAGE_SIZE, PATH, PAY_WITH_ALPHAEON_URL, PENDING_STATES, PERMISSION, PERMISSION_OPTIONS, PLAN_SELECTION_URL, POBOX_VARIATIONS, PRE_QUALIFICATION_ACCEPT_DECLINED_URL, PRE_QUALIFICATION_ACCOUNT_EXISTS_URL, PRE_QUALIFICATION_DECLINED_ADS_ONLY_URL, PRE_QUALIFICATION_DECLINED_IMPRINT_ONLY_URL, PRE_QUALIFICATION_DECLINED_URL, PRE_QUALIFICATION_INFORMATION_REQUIRED_URL, PRIME_LENDERS, PRINT_URL, PRIVACY_URL, PRIVATE_LABEL_TERMS_URL, PRODUCT_TYPE, PRODUCT_TYPE_BUTTON_CLASS_MAP, PRODUCT_TYPE_BUTTON_OUTLINE_CLASS_MAP, PRODUCT_TYPE_MAP, PROGRAM_MANAGEMENT_URL, PROGRAM_PRODUCT_TYPE_ADVANTAGE, PROGRAM_PRODUCT_TYPE_FLEX, PROGRAM_PRODUCT_TYPE_FLEX_NEAR_PRIME, PROGRAM_PRODUCT_TYPE_FLEX_RECOURSE, PROGRAM_PRODUCT_TYPE_MAP, PROGRAM_PRODUCT_TYPE_TO_LENDER_NAME_MAP, PROVE_CHANNEL_PREQUALIFY, PROVE_CHANNEL_SELECT, PST_TIMEZONE, PUSH_APPLICATION_SMS_TEMPLATE_NAME, PUSH_APPLICATION_URL, PWA_SESSION_KEY, Routes as PartnersRoutes, Pencil as PencilIcon, Plan as PlanIcon, PrintPage, QR_CODE_URL, QUERY_KEY, REACT_APP_ALPHAEON_CONSUMER_AUTH0_CLIENTID, REACT_APP_ALPHAEON_MERCHANT_AUTH0_CLIENTID, REACT_APP_ALPHAEON_MERCHANT_MUX_API, REACT_APP_ALPHAEON_RETOOL_EMBED_URL, REACT_APP_ANALYTICS_CFE_GA_ID, REACT_APP_ANALYTICS_CFE_GTM_ID, REACT_APP_ANALYTICS_MFE_GA_ID, REACT_APP_ANALYTICS_MFE_GTM_ID, REACT_APP_API_URL, REACT_APP_AUTH0_ADMIN_CLIENTID, REACT_APP_AUTH0_DOMAIN, REACT_APP_AUTH0_DOMAIN_CONSUMER, REACT_APP_BUILDID_FETCH_INTERVAL, REACT_APP_CONSUMER_TOKEN_SECRET, REACT_APP_COVERED_CARE_DOMAIN, REACT_APP_HYPERDX, REACT_APP_INTERNAL_PORTAL_GOOGLE_CLIENT_ID, REACT_APP_RECAPTCHA_SITE_KEY, RECEIPT_TYPE_OPTIONS, RECONCILIATION_REPORT_DATA_HEADERS, RECONCILIATION_REPORT_SUMMARY_HEADERS, RECONCILIATION_REPORT_V2_DATA_HEADERS, REFUNDABLE_STATES, REFUND_REQUEST_URL, RELATIONSHIPS, REPORTS_START_OFFSET_DAYS, REPORT_EMAIL, REPORT_TYPES, REPORT_URL, RESEND_APPLICATION_SMS_TEMPLATE_NAME, RETURN_TRANSACTION_TYPES, RIC_MERCHANT_AGREEMENT_URL, RISK_MESSAGE, RISK_NUMBER, ROUTING_NUMBER_LOOKUP_REQUIRED, Radio as RadioV2, ReceiptAccountInfo, ReceiptDisplay, Replay$1 as ReplayIcon, Room as RoomIcon, RoutingNumberError, SALES, SALES_PORTAL_PATHS, SALES_REPORT_DETAIL_HEADER, SALES_REPORT_SUMMARY_HEADERS, SALES_URL, SHARE_WITH_FAMILY_OPTIONS, SIGN_RECEIPT_URL, SSNInput, START_APPLICATION_URL, STATES, STEP_UP_REQUIRED_URL, STORE_LINK_CAMPAIGN_COOKIE_OPTIONS, STORE_URL, Select, SelectPlan, Select$1 as SelectV2, SendReceipt, ServerStatusOverlay_default as ServerStatusOverlay, SingleSelect, Span, Spinner, Success, TDD_TTY_NUMBER, TERMS_AND_CONDITIONS_URL, TRANSACTION_FILTERS, TRANSACTION_STATUS, TRANSACTION_STATUS_MAP, TRANSACTION_TYPE, TRANSACTION_TYPE_TO_PRODUCT_TYPE_MAP, TREATMENT_ESTIMATE_URL, Table, TestEnvironmentBanner, TextArea as TextAreaV2, ToastDismissButton, TooZoom, URL$1 as URL, USER_ACTIVE_STATUS, USER_ADD_URL, USER_PORTAL_PATHS, USER_PORTAL_URL, USER_STATUS, USER_UPDATE_URL, USER_URL, VERIFICATION_METHODS, VOIDABLE_STATES, VOID_SALE, VOID_SALE_URL, Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon, WIZARD_STEP, WIZARD_URL, addHyphen, apiErrorToErrorMessage, apiMiddlewareLegacy, approveTerms, assertRoutingNumber, browserHistory, buildCareStackEnrollUrl, calcTransaction, camelizeResponse, capitalizeFirstLetterInEachWord, checkForNull, checkIfESTTimeisPast10Pm, transformer as codegenMod, comparisonSheetEditUrl, composeValidators, contactFormInitialValues, createDynamicColumns, createMockData, dateRawSplit, daysAgoInMilliseconds, determinePrequalificationError, didServerTimeSyncFail, dpiDetector, errorMessageFromFormErrors, extractAuth0Error, fetchApplicationBuildId, forceRedirect, formatAccountNumber, formatCurrency, formatDateForAPI, formatDateFromDB, formatDateFromISOtoUSdateString, formatDateFromInputString, formatEIN, formatEmailAddress, formatErrorMessage, formatFixedNumber, formatISODate, formatISODateString, formatISODateStringAsUSMonthDayYear, formatLocation, formatNumber, formatPhoneNumber, formatProductType, formatProgramProductType, formatSSN, formatTitleCase, formatUpperCase, getFullAddress as getAddress, getApplicationBuildID, getApplicationPath, getButtonClassnameForProduct, getButtonColorForLender, getCookie, getFullName, getIdentityTypeName, getMonthFromDate, getRTKQueryErrorMessage, getReportDates, getServerNow, getTestEnv, handleClientError, handleServerError, isCookieValidMiddleware, isInIframe, isNodeEnvProduction, isNumberString, isPresent, isProduction, isRevolving, isSafeUrl, localStorage$1 as localStorageService, locationOptions, locationOptionsWithLabels, makeApplicationURL, makeCreditPortalPath, makeInvoiceBuilderPath, makeLocationUrl, makeMerchantPortalPath, makePath, makeQueryPath, makeStoreUrl, manageAuth0AccessToken, mapTransactionTypeToProductType, mapTransactionTypeandInstrumentTypeToProductType, maskNumber, matchingDetailCriteria, mockWindow, operationNotPermitted, operationPermitted, optionsFromLocations, ordinalSuffix, parseAccountNumber, parseAmount, parseAndCompareAsc as parseAndCompareDatesAsc, parseDateOfBirth, parsePhoneNumber, parseQuery, parseUSDayMonthYearDate, patchDomForBrowserExtensions, removeNonDigits, reportAction, reportError, safeStringToJson, scrollToTop, sendToParent, simulateTyping, syncServerTimeOffset, titleCase, toAmount, toNumber, useAnalyticsIdentify, useButtonClickTracker, useErrorListener, useInterval, useIovation, useIsInViewport, useIsMobile, useIsOnline, useNavigationTracker, useNetworkErrorReporter, useNewTab, useOnClickOutside, useParentMessaging, usePendo, useQuery, useRouteTracker, useVisibilityChange, usingTestApi, validDateOfBirth, validateAddress, validateCurrency, validateDateOfBirth, validateDateOfBirthFormat, validateEIN, validateEmail, validateIdExpirationDate, validateLength, validateName, validatePhoneNumber, validateRequired as validateRequiredField, validateRoutingNumber, validateSSN, windowOpenAndPrint, withApiAuth, withGoogleAuth };
//# sourceMappingURL=index.esm.js.map
